var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value2) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value: value2 }) : obj[key] = value2;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __publicField = (obj, key, value2) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value2);
  return value2;
};
import { defineComponent, useSlots, computed, openBlock, createBlock, unref, withCtx, createVNode, createCommentVNode, createElementVNode, normalizeClass, createElementBlock, renderSlot, Fragment, createTextVNode, toDisplayString, onMounted, onBeforeUnmount, ref, provide, mergeProps, inject, watch, onBeforeMount, resolveComponent, normalizeStyle, normalizeProps, guardReactiveProps, renderList, createSlots, resolveDynamicComponent, onUpdated, useAttrs, Transition, Teleport, toHandlers, isRef, reactive, withModifiers, withMemo, isMemoSame, toRaw, toRefs, onBeforeUpdate, TransitionGroup, toRef, setBlockTracking, withKeys, withDirectives, vModelText } from "vue";
function hasSlot(slot) {
  if (!slot) {
    return false;
  }
  if (slot && slot()[0].children) {
    if (typeof slot()[0].children === "string") {
      return slot()[0].children !== "v-if";
    }
    if (Array.isArray(slot()[0].children)) {
      return slot()[0].children.length > 0;
    }
  }
  return true;
}
const TermsOfService = "Polaris-AccountConnection__TermsOfService";
const Content$g = "Polaris-AccountConnection__Content";
var styles$22 = {
  TermsOfService,
  Content: Content$g
};
var AccountConnection_vue_vue_type_style_index_0_lang = "";
const _hoisted_1$1K = { key: 0 };
const _hoisted_2$$ = { key: 1 };
const _hoisted_3$I = { key: 2 };
const _sfc_main$3q = /* @__PURE__ */ defineComponent({
  props: {
    title: null,
    details: null,
    termsOfService: null,
    accountName: { default: "" },
    avatarUrl: null,
    connected: { type: Boolean, default: false },
    action: null
  },
  setup(__props) {
    const props = __props;
    const slots = useSlots();
    const initials = computed(() => {
      return props.accountName ? props.accountName.split(/\s+/).map((name) => name[0]).join("") : void 0;
    });
    return (_ctx, _cache) => {
      return openBlock(), createBlock(unref(_sfc_main$2w), { sectioned: "" }, {
        default: withCtx(() => [
          createVNode(unref(_sfc_main$x), null, {
            action: withCtx(() => [
              __props.action ? (openBlock(), createBlock(unref(_sfc_main$2E), {
                key: 0,
                action: __props.action,
                overrides: { primary: !__props.connected }
              }, null, 8, ["action", "overrides"])) : createCommentVNode("", true)
            ]),
            setting: withCtx(() => [
              createVNode(unref(_sfc_main$12), null, {
                default: withCtx(() => [
                  __props.connected ? (openBlock(), createBlock(unref(_sfc_main$2$), {
                    key: 0,
                    accessibilityLabel: "",
                    name: __props.accountName,
                    initials: unref(initials),
                    source: __props.avatarUrl
                  }, null, 8, ["name", "initials", "source"])) : createCommentVNode("", true),
                  createVNode(unref(_sfc_main$13), { fill: "" }, {
                    default: withCtx(() => [
                      createElementVNode("div", {
                        class: normalizeClass(unref(styles$22).Content)
                      }, [
                        __props.title || unref(hasSlot)(unref(slots).title) ? (openBlock(), createElementBlock("div", _hoisted_1$1K, [
                          unref(hasSlot)(unref(slots).title) ? renderSlot(_ctx.$slots, "title", { key: 0 }) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
                            createTextVNode(toDisplayString(__props.title), 1)
                          ], 64))
                        ])) : __props.accountName ? (openBlock(), createElementBlock("div", _hoisted_2$$, toDisplayString(__props.accountName), 1)) : createCommentVNode("", true),
                        __props.details || unref(hasSlot)(unref(slots).details) ? (openBlock(), createElementBlock("div", _hoisted_3$I, [
                          createVNode(unref(Text), {
                            variant: "bodyMd",
                            color: "subdued",
                            as: "span"
                          }, {
                            default: withCtx(() => [
                              unref(hasSlot)(unref(slots).details) ? renderSlot(_ctx.$slots, "details", { key: 0 }) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
                                createTextVNode(toDisplayString(__props.details), 1)
                              ], 64))
                            ]),
                            _: 3
                          })
                        ])) : createCommentVNode("", true)
                      ], 2)
                    ]),
                    _: 3
                  })
                ]),
                _: 3
              })
            ]),
            _: 3
          }),
          __props.termsOfService || unref(hasSlot)(unref(slots).termsOfService) ? (openBlock(), createElementBlock("div", {
            key: 0,
            class: normalizeClass(unref(styles$22).TermsOfService)
          }, [
            unref(hasSlot)(unref(slots).termsOfService) ? renderSlot(_ctx.$slots, "termsOfService", { key: 0 }) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
              createTextVNode(toDisplayString(__props.termsOfService), 1)
            ], 64))
          ], 2)) : createCommentVNode("", true)
        ]),
        _: 3
      });
    };
  }
});
function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}
function variationName(name, value2) {
  return `${name}${value2.charAt(0).toUpperCase()}${value2.slice(1)}`;
}
function getResponsiveProps(componentName, componentProp, tokenSubgroup, responsiveProp) {
  if (typeof responsiveProp === "string") {
    return {
      [`--pc-${componentName}-${componentProp}-xs`]: `var(--p-${tokenSubgroup}-${responsiveProp})`
    };
  }
  return Object.fromEntries(Object.entries(responsiveProp).map(([breakpointAlias, aliasOrScale]) => [
    `--pc-${componentName}-${componentProp}-${breakpointAlias}`,
    `var(--p-${tokenSubgroup}-${aliasOrScale})`
  ]));
}
function isElementInViewport(element) {
  const { top, left, bottom, right: right2 } = element.getBoundingClientRect();
  return top >= 0 && right2 <= window.innerWidth && bottom <= window.innerHeight && left >= 0;
}
const KEYBOARD_FOCUSABLE_SELECTORS = 'a,frame,iframe,input:not([type=hidden]):not(:disabled),select:not(:disabled),textarea:not(:disabled),button:not(:disabled),*[tabindex]:not([tabindex="-1"])';
const FOCUSABLE_SELECTOR = "a,frame,iframe,input:not([type=hidden]):not(:disabled),select:not(:disabled),textarea:not(:disabled),button:not(:disabled),*[tabindex]";
const MENUITEM_FOCUSABLE_SELECTORS = 'a[role="menuitem"],frame[role="menuitem"],iframe[role="menuitem"],input[role="menuitem"]:not([type=hidden]):not(:disabled),select[role="menuitem"]:not(:disabled),textarea[role="menuitem"]:not(:disabled),button[role="menuitem"]:not(:disabled),*[tabindex]:not([tabindex="-1"])';
function matches(node, selector) {
  if (node.matches) {
    return node.matches(selector);
  }
  const theMatches = (node.ownerDocument || document).querySelectorAll(selector);
  let i = theMatches.length;
  while (i >= 0 && theMatches.item(i) !== node) {
    i -= 1;
    return i > -1;
  }
}
function findFirstFocusableNodeIncludingDisabled(element) {
  const focusableSelector = "a,button,frame,iframe,input:not([type=hidden]),select,textarea,*[tabindex]";
  if (matches(element, focusableSelector)) {
    return element;
  }
  return element.querySelector(focusableSelector);
}
function nextFocusableNode(node, filter) {
  const allFocusableElements = [...document.querySelectorAll(FOCUSABLE_SELECTOR)];
  const sliceLocation = allFocusableElements.indexOf(node) + 1;
  const focusableElementsAfterNode = allFocusableElements.slice(sliceLocation);
  for (const focusableElement of focusableElementsAfterNode) {
    if (isElementInViewport(focusableElement) && (!filter || filter && filter(focusableElement))) {
      return focusableElement;
    }
  }
  return null;
}
function focusNextFocusableNode(node, filter) {
  const nextFocusable = nextFocusableNode(node, filter);
  if (nextFocusable && nextFocusable instanceof HTMLElement) {
    nextFocusable.focus();
    return true;
  }
  return false;
}
function findFirstFocusableNode(element, onlyDescendants = true) {
  if (!onlyDescendants && matches(element, FOCUSABLE_SELECTOR)) {
    return element;
  }
  return element.querySelector(FOCUSABLE_SELECTOR);
}
function getMenuFocusableDescendants(element) {
  return element.querySelectorAll(MENUITEM_FOCUSABLE_SELECTORS);
}
function getCurrentFocusedElementIndex(allFocusableChildren, currentFocusedElement) {
  let currentItemIdx = 0;
  for (const focusableChild of allFocusableChildren) {
    if (focusableChild === currentFocusedElement) {
      break;
    }
    currentItemIdx += 1;
  }
  return currentItemIdx === allFocusableChildren.length ? -1 : currentItemIdx;
}
function wrapFocusPreviousFocusableMenuItem(parentElement, currentFocusedElement) {
  const allFocusableChildren = getMenuFocusableDescendants(parentElement);
  const currentItemIdx = getCurrentFocusedElementIndex(allFocusableChildren, currentFocusedElement);
  if (currentItemIdx === -1) {
    allFocusableChildren[0].focus();
  } else {
    allFocusableChildren[(currentItemIdx - 1 + allFocusableChildren.length) % allFocusableChildren.length].focus();
  }
}
function wrapFocusNextFocusableMenuItem(parentElement, currentFocusedElement) {
  const allFocusableChildren = getMenuFocusableDescendants(parentElement);
  const currentItemIdx = getCurrentFocusedElementIndex(allFocusableChildren, currentFocusedElement);
  if (currentItemIdx === -1) {
    allFocusableChildren[0].focus();
  } else {
    allFocusableChildren[(currentItemIdx + 1) % allFocusableChildren.length].focus();
  }
}
const handleMouseUpByBlurring = (event) => {
  const currentTarget = event.currentTarget;
  currentTarget.blur();
};
function focusFirstFocusableNode(element, onlyDescendants = true) {
  var _a;
  (_a = findFirstFocusableNode(element, onlyDescendants)) == null ? void 0 : _a.focus();
}
function findFirstKeyboardFocusableNode(element, onlyDescendants = true) {
  if (!onlyDescendants && matches(element, KEYBOARD_FOCUSABLE_SELECTORS)) {
    return element;
  }
  return element.querySelector(KEYBOARD_FOCUSABLE_SELECTORS);
}
function findLastKeyboardFocusableNode(element, onlyDescendants = true) {
  if (!onlyDescendants && matches(element, KEYBOARD_FOCUSABLE_SELECTORS)) {
    return element;
  }
  const allFocusable = element.querySelectorAll(KEYBOARD_FOCUSABLE_SELECTORS);
  return allFocusable[allFocusable.length - 1];
}
function focusFirstKeyboardFocusableNode(element, onlyDescendants = true) {
  const firstFocusable = findFirstKeyboardFocusableNode(element, onlyDescendants);
  if (firstFocusable) {
    firstFocusable.focus();
    return true;
  }
  return false;
}
function focusLastKeyboardFocusableNode(element, onlyDescendants = true) {
  const lastFocusable = findLastKeyboardFocusableNode(element, onlyDescendants);
  if (lastFocusable) {
    lastFocusable.focus();
    return true;
  }
  return false;
}
const __default__$n = {
  inheritAttrs: false,
  render() {
    return null;
  }
};
const _sfc_main$3p = /* @__PURE__ */ defineComponent(__spreadProps(__spreadValues({}, __default__$n), {
  props: {
    keyCode: { type: String, required: true },
    keyEvent: { type: String, default: "keyup" },
    handler: { type: Function, required: true },
    useCapture: { type: Boolean },
    options: { type: Object }
  },
  setup(__props) {
    const props = __props;
    function handleKeyEvent(event) {
      if (event.key === props.keyCode) {
        props.handler(event);
      }
    }
    onMounted(() => document.addEventListener(props.keyEvent, handleKeyEvent, props.useCapture || props.options));
    onBeforeUnmount(() => document.removeEventListener(props.keyEvent, handleKeyEvent, props.useCapture || props.options));
    return () => {
    };
  }
}));
var Key = /* @__PURE__ */ ((Key10) => {
  Key10["Backspace"] = "Backspace";
  Key10["Tab"] = "Tab";
  Key10["Enter"] = "Enter";
  Key10["Shift"] = "Shift";
  Key10["Ctrl"] = "Ctrl";
  Key10["Alt"] = "Alt";
  Key10["Pause"] = "Pause";
  Key10["CapsLock"] = "CapsLock";
  Key10["Escape"] = "Escape";
  Key10["Space"] = "Space";
  Key10["PageUp"] = "PageUp";
  Key10["PageDown"] = "PageDown";
  Key10["End"] = "End";
  Key10["Home"] = "Home";
  Key10["ArrowRight"] = "ArrowRight";
  Key10["ArrowLeft"] = "ArrowLeft";
  Key10["ArrowUp"] = "ArrowUp";
  Key10["ArrowDown"] = "ArrowDown";
  Key10["Insert"] = "Insert";
  Key10["Delete"] = "Delete";
  Key10["Key0"] = "Key0";
  Key10["Key1"] = "Key1";
  Key10["Key2"] = "Key2";
  Key10["Key3"] = "Key3";
  Key10["Key4"] = "Key4";
  Key10["Key5"] = "Key5";
  Key10["Key6"] = "Key6";
  Key10["Key7"] = "Key7";
  Key10["Key8"] = "Key8";
  Key10["Key9"] = "Key9";
  Key10["KeyA"] = "KeyA";
  Key10["KeyB"] = "KeyB";
  Key10["KeyC"] = "KeyC";
  Key10["KeyD"] = "KeyD";
  Key10["KeyE"] = "KeyE";
  Key10["KeyF"] = "KeyF";
  Key10["KeyG"] = "KeyG";
  Key10["KeyH"] = "KeyH";
  Key10["KeyI"] = "KeyI";
  Key10["KeyJ"] = "KeyJ";
  Key10["KeyK"] = "KeyK";
  Key10["KeyL"] = "KeyL";
  Key10["KeyM"] = "KeyM";
  Key10["KeyN"] = "KeyN";
  Key10["KeyO"] = "KeyO";
  Key10["KeyP"] = "KeyP";
  Key10["KeyQ"] = "KeyQ";
  Key10["KeyR"] = "KeyR";
  Key10["KeyS"] = "KeyS";
  Key10["KeyT"] = "KeyT";
  Key10["KeyU"] = "KeyU";
  Key10["KeyV"] = "KeyV";
  Key10["KeyW"] = "KeyW";
  Key10["KeyX"] = "KeyX";
  Key10["KeyY"] = "KeyY";
  Key10["KeyZ"] = "KeyZ";
  Key10["LeftMeta"] = "LeftMeta";
  Key10["RightMeta"] = "RightMeta";
  Key10["Select"] = "Select";
  Key10["Numpad0"] = "Numpad0";
  Key10["Numpad1"] = "Numpad1";
  Key10["Numpad2"] = "Numpad2";
  Key10["Numpad3"] = "Numpad3";
  Key10["Numpad4"] = "Numpad4";
  Key10["Numpad5"] = "Numpad5";
  Key10["Numpad6"] = "Numpad6";
  Key10["Numpad7"] = "Numpad7";
  Key10["Numpad8"] = "Numpad8";
  Key10["Numpad9"] = "Numpad9";
  Key10["Multiply"] = "Multiply";
  Key10["Add"] = "Add";
  Key10["Subtract"] = "Subtract";
  Key10["Decimal"] = "Decimal";
  Key10["Divide"] = "Divide";
  Key10["F1"] = "F1";
  Key10["F2"] = "F2";
  Key10["F3"] = "F3";
  Key10["F4"] = "F4";
  Key10["F5"] = "F5";
  Key10["F6"] = "F6";
  Key10["F7"] = "F7";
  Key10["F8"] = "F8";
  Key10["F9"] = "F9";
  Key10["F10"] = "F10";
  Key10["F11"] = "F11";
  Key10["F12"] = "F12";
  Key10["NumLock"] = "NumLock";
  Key10["ScrollLock"] = "ScrollLock";
  Key10["Semicolon"] = "Semicolon";
  Key10["Equals"] = "Equals";
  Key10["Comma"] = "Comma";
  Key10["Dash"] = "Dash";
  Key10["Period"] = "Period";
  Key10["ForwardSlash"] = "ForwardSlash";
  Key10["GraveAccent"] = "GraveAccent";
  Key10["OpenBracket"] = "OpenBracket";
  Key10["BackSlash"] = "BackSlash";
  Key10["CloseBracket"] = "CloseBracket";
  Key10["SingleQuote"] = "SingleQuote";
  return Key10;
})(Key || {});
const ActionList = "Polaris-ActionList";
const Actions$5 = "Polaris-ActionList__Actions";
const Section$8 = "Polaris-ActionList__Section";
const Item$9 = "Polaris-ActionList__Item";
const active$2 = "Polaris-ActionList--active";
const destructive$3 = "Polaris-ActionList--destructive";
const disabled$c = "Polaris-ActionList--disabled";
const Prefix$5 = "Polaris-ActionList__Prefix";
const Suffix$4 = "Polaris-ActionList__Suffix";
const Content$f = "Polaris-ActionList__Content";
const ContentBlock$1 = "Polaris-ActionList__ContentBlock";
const ContentBlockInner = "Polaris-ActionList__ContentBlockInner";
const Text$8 = "Polaris-ActionList__Text";
var styles$21 = {
  ActionList,
  "Section-withoutTitle": "Polaris-ActionList__Section--withoutTitle",
  Actions: Actions$5,
  Section: Section$8,
  Item: Item$9,
  active: active$2,
  destructive: destructive$3,
  disabled: disabled$c,
  Prefix: Prefix$5,
  Suffix: Suffix$4,
  Content: Content$f,
  ContentBlock: ContentBlock$1,
  ContentBlockInner,
  Text: Text$8
};
function debounce(func, waitArg, options) {
  let lastArgs;
  let lastThis;
  let maxWait;
  let result;
  let timerId;
  let lastCallTime;
  let lastInvokeTime = 0;
  let leading = false;
  let maxing = false;
  let trailing = true;
  const useRAF = !waitArg && waitArg !== 0;
  if (typeof func !== "function") {
    throw new TypeError("Expected a function");
  }
  const wait = waitArg || 0;
  if (typeof options === "object") {
    leading = Boolean(options.leading);
    maxing = "maxWait" in options;
    maxWait = maxing ? Math.max(Number(options.maxWait) || 0, wait) : void 0;
    trailing = "trailing" in options ? Boolean(options.trailing) : trailing;
  }
  function invokeFunc(time) {
    const args = lastArgs;
    const thisArg = lastThis;
    lastArgs = void 0;
    lastThis = void 0;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }
  function startTimer(pendingFunc, wait2) {
    if (useRAF) {
      cancelAnimationFrame(timerId);
      return requestAnimationFrame(pendingFunc);
    }
    return setTimeout(pendingFunc, wait2);
  }
  function cancelTimer(id) {
    if (useRAF) {
      return cancelAnimationFrame(id);
    }
    clearTimeout(id);
  }
  function leadingEdge(time) {
    lastInvokeTime = time;
    timerId = startTimer(timerExpired, wait);
    return leading ? invokeFunc(time) : result;
  }
  function remainingWait(time) {
    const timeSinceLastCall = time - lastCallTime;
    const timeSinceLastInvoke = time - lastInvokeTime;
    const timeWaiting = wait - timeSinceLastCall;
    return maxing && maxWait ? Math.min(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
  }
  function shouldInvoke(time) {
    const timeSinceLastCall = time - lastCallTime;
    const timeSinceLastInvoke = time - lastInvokeTime;
    return lastCallTime === void 0 || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && maxWait && timeSinceLastInvoke >= maxWait;
  }
  function timerExpired() {
    const time = Date.now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    timerId = startTimer(timerExpired, remainingWait(time));
  }
  function trailingEdge(time) {
    timerId = void 0;
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = void 0;
    return result;
  }
  function cancel() {
    if (timerId !== void 0) {
      cancelTimer(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = void 0;
  }
  function flush2() {
    return timerId === void 0 ? result : trailingEdge(Date.now());
  }
  function pending() {
    return timerId !== void 0;
  }
  function debounced(...args) {
    const time = Date.now();
    const isInvoking = shouldInvoke(time);
    lastArgs = args;
    lastThis = this;
    lastCallTime = time;
    if (isInvoking) {
      if (timerId === void 0) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        timerId = startTimer(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === void 0) {
      timerId = startTimer(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush2;
  debounced.pending = pending;
  return debounced;
}
const scrollable = {
  props: { "data-polaris-scrollable": true },
  selector: "[data-polaris-scrollable]"
};
const overlay = {
  props: { "data-polaris-overlay": true },
  selector: "[data-polaris-overlay]"
};
const layer = {
  props: { "data-polaris-layer": true },
  selector: "[data-polaris-layer]"
};
const dataPolarisTopBar = {
  props: { "data-polaris-top-bar": true },
  selector: "[data-polaris-top-bar]"
};
const headerCell = {
  props: { "data-polaris-header-cell": true },
  selector: "[data-polaris-header-cell]"
};
const portal = {
  props: ["data-portal-id"],
  selector: "[data-portal-id]"
};
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function(sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), true).forEach(function(key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _defineProperty(obj, key, value2) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value2,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value2;
  }
  return obj;
}
function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr))
    return arr;
}
function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
  if (_i == null)
    return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _s, _e;
  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i && _arr.length === i)
        break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null)
        _i["return"]();
    } finally {
      if (_d)
        throw _e;
    }
  }
  return _arr;
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o)
    return;
  if (typeof o === "string")
    return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor)
    n = o.constructor.name;
  if (n === "Map" || n === "Set")
    return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length)
    len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++)
    arr2[i] = arr[i];
  return arr2;
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
var _templateObject;
var BASE_FONT_SIZE = 16;
var UNIT_PX = "px";
var UNIT_EM = "em";
var UNIT_REM = "rem";
var DIGIT_REGEX = new RegExp(String.raw(_templateObject || (_templateObject = _taggedTemplateLiteral(["-?d+(?:.d+|d*)"], ["-?\\d+(?:\\.\\d+|\\d*)"]))));
var UNIT_REGEX = new RegExp("".concat(UNIT_PX, "|").concat(UNIT_EM, "|").concat(UNIT_REM));
function getUnit() {
  var value2 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
  var unit = value2.match(new RegExp("".concat(DIGIT_REGEX.source, "(").concat(UNIT_REGEX.source, ")")));
  return unit && unit[1];
}
function toPx() {
  var value2 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
  var unit = getUnit(value2);
  if (!unit)
    return value2;
  if (unit === UNIT_PX) {
    return value2;
  }
  if (unit === UNIT_EM || unit === UNIT_REM) {
    return "".concat(parseFloat(value2) * BASE_FONT_SIZE).concat(UNIT_PX);
  }
}
function toEm() {
  var value2 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
  var fontSize = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : BASE_FONT_SIZE;
  var unit = getUnit(value2);
  if (!unit)
    return value2;
  if (unit === UNIT_EM) {
    return value2;
  }
  if (unit === UNIT_PX) {
    return "".concat(parseFloat(value2) / fontSize).concat(UNIT_EM);
  }
  if (unit === UNIT_REM) {
    return "".concat(parseFloat(value2) * BASE_FONT_SIZE / fontSize).concat(UNIT_EM);
  }
}
function toRem() {
  var value2 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
  var unit = getUnit(value2);
  if (!unit)
    return value2;
  if (unit === UNIT_REM) {
    return value2;
  }
  if (unit === UNIT_EM) {
    return "".concat(parseFloat(value2)).concat(UNIT_REM);
  }
  if (unit === UNIT_PX) {
    return "".concat(parseFloat(value2) / BASE_FONT_SIZE).concat(UNIT_REM);
  }
}
function rem(value2) {
  return value2.replace(new RegExp("".concat(DIGIT_REGEX.source, "(").concat(UNIT_PX, ")"), "g"), function(px) {
    var _toRem;
    return (_toRem = toRem(px)) !== null && _toRem !== void 0 ? _toRem : px;
  });
}
function tokensToRems(tokenGroup) {
  return Object.fromEntries(Object.entries(tokenGroup).map(function(_ref) {
    var _ref2 = _slicedToArray(_ref, 2), token = _ref2[0], properties = _ref2[1];
    return [token, _objectSpread2(_objectSpread2({}, properties), {}, {
      value: rem(properties.value)
    })];
  }));
}
function getMediaConditions(breakpoints2) {
  var breakpointEntries = Object.entries(breakpoints2);
  var lastBreakpointIndex = breakpointEntries.length - 1;
  return Object.fromEntries(breakpointEntries.map(function(entry, index) {
    var _ref7 = entry, _ref8 = _slicedToArray(_ref7, 2), breakpointsTokenName = _ref8[0], breakpoint = _ref8[1];
    var upMediaCondition = getUpMediaCondition(breakpoint);
    var downMediaCondition = getDownMediaCondition(breakpoint);
    var onlyMediaCondition = index === lastBreakpointIndex ? upMediaCondition : "".concat(upMediaCondition, " and ").concat(getDownMediaCondition(breakpointEntries[index + 1][1]));
    return [breakpointsTokenName, {
      up: upMediaCondition,
      down: downMediaCondition,
      only: onlyMediaCondition
    }];
  }));
}
function getUpMediaCondition(breakpoint) {
  return "(min-width: ".concat(toEm(breakpoint), ")");
}
function getDownMediaCondition(breakpoint) {
  var _toPx;
  var offsetBreakpoint = parseFloat((_toPx = toPx(breakpoint)) !== null && _toPx !== void 0 ? _toPx : "") - 0.04;
  return "(max-width: ".concat(toEm("".concat(offsetBreakpoint, "px")), ")");
}
var breakpoints$1 = {
  "breakpoints-xs": {
    value: "0px",
    description: "Commonly used for sizing containers (e.g. max-width). See below for media query usage."
  },
  "breakpoints-sm": {
    value: "490px",
    description: "Commonly used for sizing containers (e.g. max-width). See below for media query usage."
  },
  "breakpoints-md": {
    value: "768px",
    description: "Commonly used for sizing containers (e.g. max-width). See below for media query usage."
  },
  "breakpoints-lg": {
    value: "1040px",
    description: "Commonly used for sizing containers (e.g. max-width). See below for media query usage."
  },
  "breakpoints-xl": {
    value: "1440px",
    description: "Commonly used for sizing containers (e.g. max-width). See below for media query usage."
  }
};
var depth = {
  "shadow-transparent": {
    value: "0 0 0 0 transparent"
  },
  "shadow-faint": {
    value: "0 1px 0 0 rgba(22, 29, 37, 0.05)"
  },
  "shadow-base": {
    value: "0 0 0 1px rgba(63, 63, 68, 0.05), 0 1px 3px 0 rgba(63, 63, 68, 0.15)"
  },
  "shadow-deep": {
    value: "0 0 0 1px rgba(6, 44, 82, 0.1), 0 2px 16px rgba(33, 43, 54, 0.08)"
  },
  "shadow-button": {
    value: "0 1px 0 rgba(0, 0, 0, 0.05)"
  },
  "shadow-top-bar": {
    value: "0 2px 2px -1px rgba(0, 0, 0, 0.15)"
  },
  "shadow-card": {
    value: "0 0 5px rgba(23, 24, 24, 0.05), 0 1px 2px rgba(0, 0, 0, 0.15)"
  },
  "shadow-popover": {
    value: "0 3px 6px -3px rgba(23, 24, 24, 0.08), 0 8px 20px -4px rgba(23, 24, 24, 0.12)"
  },
  "shadow-layer": {
    value: "0 31px 41px 0 rgba(32, 42, 53, 0.2), 0 2px 16px 0 rgba(32, 42, 54, 0.08)"
  },
  "shadow-modal": {
    value: "0 26px 80px rgba(0, 0, 0, 0.2), 0 0px 1px rgba(0, 0, 0, 0.2)"
  },
  "shadows-inset-button": {
    value: "inset 0 -1px 0 rgba(0, 0, 0, 0.2)"
  },
  "shadows-inset-button-pressed": {
    value: "inset 0 1px 0 rgba(0, 0, 0, 0.15)"
  }
};
var font = {
  "font-family-sans": {
    value: "-apple-system, BlinkMacSystemFont, 'San Francisco', 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif"
  },
  "font-family-mono": {
    value: "ui-monospace, SFMono-Regular, 'SF Mono', Consolas, 'Liberation Mono', Menlo, monospace"
  },
  "font-size-75": {
    value: "12px"
  },
  "font-size-100": {
    value: "14px"
  },
  "font-size-200": {
    value: "16px"
  },
  "font-size-300": {
    value: "20px"
  },
  "font-size-400": {
    value: "24px"
  },
  "font-size-500": {
    value: "28px"
  },
  "font-size-600": {
    value: "32px"
  },
  "font-size-700": {
    value: "40px"
  },
  "font-weight-regular": {
    value: "400"
  },
  "font-weight-medium": {
    value: "500"
  },
  "font-weight-semibold": {
    value: "600"
  },
  "font-weight-bold": {
    value: "700"
  },
  "font-line-height-1": {
    value: "16px"
  },
  "font-line-height-2": {
    value: "20px"
  },
  "font-line-height-3": {
    value: "24px"
  },
  "font-line-height-4": {
    value: "28px"
  },
  "font-line-height-5": {
    value: "32px"
  },
  "font-line-height-6": {
    value: "40px"
  },
  "font-line-height-7": {
    value: "48px"
  }
};
var legacy = {
  "override-loading-z-index": {
    value: "514"
  },
  "choice-size": {
    value: "20px"
  },
  "icon-size-small": {
    value: "8px"
  },
  "icon-size-medium": {
    value: "20px"
  },
  "choice-margin": {
    value: "1px"
  },
  "control-border-width": {
    value: "2px"
  },
  "banner-border-default": {
    value: "inset 0 1px 0 0 var(--p-border-neutral-subdued), inset 0 0 0 1px var(--p-border-neutral-subdued)"
  },
  "banner-border-success": {
    value: "inset 0 1px 0 0 var(--p-border-success-subdued), inset 0 0 0 1px var(--p-border-success-subdued)"
  },
  "banner-border-highlight": {
    value: "inset 0 1px 0 0 var(--p-border-highlight-subdued), inset 0 0 0 1px var(--p-border-highlight-subdued)"
  },
  "banner-border-warning": {
    value: "inset 0 1px 0 0 var(--p-border-warning-subdued), inset 0 0 0 1px var(--p-border-warning-subdued)"
  },
  "banner-border-critical": {
    value: "inset 0 1px 0 0 var(--p-border-critical-subdued), inset 0 0 0 1px var(--p-border-critical-subdued)"
  },
  "thin-border-subdued": {
    value: "1px solid var(--p-border-subdued)"
  },
  "text-field-spinner-offset": {
    value: "2px"
  },
  "text-field-focus-ring-offset": {
    value: "-4px"
  },
  "button-group-item-spacing": {
    value: "-1px"
  },
  "range-slider-thumb-size-base": {
    value: "16px"
  },
  "range-slider-thumb-size-active": {
    value: "24px"
  },
  "frame-offset": {
    value: "0px"
  }
};
var colors = {
  background: {
    value: "rgba(246, 246, 247, 1)",
    description: "For use as a background color, in components such as Page and Frame backgrounds."
  },
  "background-hovered": {
    value: "rgba(241, 242, 243, 1)",
    description: "For use when an action or navigation is used on a background."
  },
  "background-pressed": {
    value: "rgba(237, 238, 239, 1)",
    description: "For use when an action or navigation is used on a background."
  },
  "background-selected": {
    value: "rgba(237, 238, 239, 1)",
    description: "For use in the selected item in navigation"
  },
  surface: {
    value: "rgba(255, 255, 255, 1)",
    description: "For use as a background color, in components such as Card, Modal, and Popover."
  },
  "surface-dark": {
    value: "rgba(32, 33, 35, 1)",
    description: "For use as a dark background color, in components such as Card, Modal, and Popover."
  },
  "surface-neutral": {
    value: "rgba(228, 229, 231, 1)",
    description: "For use as a background color in neutral badges."
  },
  "surface-neutral-hovered": {
    value: "rgba(219, 221, 223, 1)",
    description: "For use as a hovered background color in neutral badges."
  },
  "surface-neutral-pressed": {
    value: "rgba(201, 204, 208, 1)",
    description: "For use as a pressed background color in neutral badges."
  },
  "surface-neutral-disabled": {
    value: "rgba(241, 242, 243, 1)",
    description: "For use as a disabled background color in neutral badges."
  },
  "surface-neutral-subdued": {
    value: "rgba(246, 246, 247, 1)",
    description: "For use as a background color in neutral banners."
  },
  "surface-neutral-subdued-dark": {
    value: "rgba(68, 71, 74, 1)",
    description: "For use as a dark background color in neutral banners."
  },
  "surface-subdued": {
    value: "rgba(250, 251, 251, 1)",
    description: "For use as a subdued background color, in components such as Card, Modal, and Popover."
  },
  "surface-disabled": {
    value: "rgba(250, 251, 251, 1)",
    description: "For use as a surface color on disabled interactive elements such as option list items and action list items when in a disabled state."
  },
  "surface-hovered": {
    value: "rgba(246, 246, 247, 1)",
    description: "For use as a surface color on interactive elements such as resource list items and action list items when in a hovered state."
  },
  "surface-hovered-dark": {
    value: "rgba(47, 49, 51, 1)",
    description: "For use as a dark surface color on interactive elements such as resource list items and action list items when in a hovered state."
  },
  "surface-pressed": {
    value: "rgba(241, 242, 243, 1)",
    description: "For use as a surface color on interactive elements such as resource list items and action list items when in a pressed state."
  },
  "surface-pressed-dark": {
    value: "rgba(62, 64, 67, 1)",
    description: "For use as a dark surface color on interactive elements such as resource list items and action list items when in a pressed state."
  },
  "surface-depressed": {
    value: "rgba(237, 238, 239, 1)",
    description: "For use as a surface color on interactive elements such as resource list items and action list items when in a depressed state."
  },
  "surface-search-field": {
    value: "rgba(241, 242, 243, 1)",
    description: "For use as a background color, in components on surface elements such as SearchField"
  },
  "surface-search-field-dark": {
    value: "rgba(47, 49, 51, 1)",
    description: "For use as a dark background color, in components on surface elements such as SearchField"
  },
  backdrop: {
    value: "rgba(0, 0, 0, 0.5)",
    description: "For use as the background color of the backdrop component for navigation and modal. This color has an alpha of `0.5`."
  },
  overlay: {
    value: "rgba(255, 255, 255, 0.5)",
    description: "For use as the background color of elements which lay on top of surfaces to obscure their contents. This color has an alpha of `0.5`."
  },
  "shadow-color-picker": {
    value: "rgba(0, 0, 0, 0.5)"
  },
  "shadow-color-picker-dragger": {
    value: "rgba(33, 43, 54, 0.32)"
  },
  "hint-from-direct-light": {
    value: "rgba(0, 0, 0, 0.15)",
    description: "For use in building shadows scrollables."
  },
  border: {
    value: "rgba(140, 145, 150, 1)",
    description: "For use as the default border on elements."
  },
  "border-on-dark": {
    value: "rgba(80, 83, 86, 1)",
    description: "For use as the default border on dark elements."
  },
  "border-neutral-subdued": {
    value: "rgba(186, 191, 195, 1)",
    description: "For use as the border on banners."
  },
  "border-hovered": {
    value: "rgba(153, 158, 164, 1)",
    description: "Used for borders on hovered interactive elements"
  },
  "border-disabled": {
    value: "rgba(210, 213, 216, 1)",
    description: "Used for disabled borders on interactive elements"
  },
  "border-subdued": {
    value: "rgba(201, 204, 207, 1)",
    description: "For use as a subdued border on elements."
  },
  "border-depressed": {
    value: "rgba(87, 89, 89, 1)",
    description: "For use as a border on depressed elements."
  },
  "border-shadow": {
    value: "rgba(174, 180, 185, 1)",
    description: "For use as an additional bottom border on elements."
  },
  "border-shadow-subdued": {
    value: "rgba(186, 191, 196, 1)",
    description: "For use as an additional, subdued bottom border on elements."
  },
  divider: {
    value: "rgba(225, 227, 229, 1)",
    description: "For use as a divider between elements."
  },
  "divider-dark": {
    value: "rgba(69, 71, 73, 1)",
    description: "For use as a dark divider between elements."
  },
  icon: {
    value: "rgba(92, 95, 98, 1)",
    description: "For use as the fill color of icons."
  },
  "icon-on-dark": {
    value: "rgba(166, 172, 178, 1)",
    description: "For use as the fill color of dark icons."
  },
  "icon-hovered": {
    value: "rgba(26, 28, 29, 1)",
    description: "For use as the fill color of hovered icons."
  },
  "icon-pressed": {
    value: "rgba(68, 71, 74, 1)",
    description: "For use as the fill color of pressed icons."
  },
  "icon-disabled": {
    value: "rgba(186, 190, 195, 1)",
    description: "For use as the fill color of disabled icons."
  },
  "icon-subdued": {
    value: "rgba(140, 145, 150, 1)",
    description: "For use as the fill color of subdued icons."
  },
  text: {
    value: "rgba(32, 34, 35, 1)",
    description: "For use as a text color."
  },
  "text-on-dark": {
    value: "rgba(227, 229, 231, 1)",
    description: "For use as a text color on dark elements."
  },
  "text-disabled": {
    value: "rgba(140, 145, 150, 1)",
    description: "For use as a disabled text color and as a placeholder text color."
  },
  "text-subdued": {
    value: "rgba(109, 113, 117, 1)",
    description: "For use as a subdued text color."
  },
  "text-subdued-on-dark": {
    value: "rgba(153, 159, 164, 1)",
    description: "For use as a subdued text color on dark elements."
  },
  interactive: {
    value: "rgba(44, 110, 203, 1)",
    description: "Used for links, plain buttons, and as the fill color for selected checkboxes and radio buttons."
  },
  "interactive-on-dark": {
    value: "rgba(54, 163, 255, 1)",
    description: "Used for links, plain buttons, and as the fill color for selected checkboxes and radio buttons when on a dark element."
  },
  "interactive-disabled": {
    value: "rgba(189, 193, 204, 1)",
    description: "Used for disabled links and plain buttons."
  },
  "interactive-hovered": {
    value: "rgba(31, 81, 153, 1)",
    description: "Used for hovered links and plain buttons."
  },
  "interactive-pressed": {
    value: "rgba(16, 50, 98, 1)",
    description: "Used for pressed links and plain buttons."
  },
  "interactive-pressed-on-dark": {
    value: "rgba(136, 188, 255, 1)",
    description: "Used for pressed links and plain buttons on dark elements."
  },
  focused: {
    value: "rgba(69, 143, 255, 1)",
    description: "For use in the focus ring on interactive elements."
  },
  "surface-selected": {
    value: "rgba(242, 247, 254, 1)",
    description: "For use as a surface color in selected interactive elements, in components such as action list and resource list."
  },
  "surface-selected-hovered": {
    value: "rgba(237, 244, 254, 1)",
    description: "For use as a surface color in selected interactive elements that are hovered, in components such as action list and resource list."
  },
  "surface-selected-pressed": {
    value: "rgba(229, 239, 253, 1)",
    description: "For use as a surface color in selected interactive elements that are pressed, in components such as action list and resource list."
  },
  "icon-on-interactive": {
    value: "rgba(255, 255, 255, 1)",
    description: "For use as a fill color for icons on interactive elements."
  },
  "text-on-interactive": {
    value: "rgba(255, 255, 255, 1)",
    description: "For use as a text color on interactive elements."
  },
  "action-secondary": {
    value: "rgba(255, 255, 255, 1)",
    description: "Used for secondary buttons and tertiary buttons, as well as in form elements as a background color and pontentially other secondary surfaces."
  },
  "action-secondary-disabled": {
    value: "rgba(255, 255, 255, 1)",
    description: "Used as a disabled state for secondary buttons"
  },
  "action-secondary-hovered": {
    value: "rgba(246, 246, 247, 1)",
    description: "Used as a hovered state for secondary buttons"
  },
  "action-secondary-hovered-dark": {
    value: "rgba(84, 87, 91, 1)",
    description: "Used as a dark hovered state for secondary buttons"
  },
  "action-secondary-pressed": {
    value: "rgba(241, 242, 243, 1)",
    description: "Used as a pressed state for secondary buttons"
  },
  "action-secondary-pressed-dark": {
    value: "rgba(96, 100, 103, 1)",
    description: "Used as a dark pressed state for secondary buttons"
  },
  "action-secondary-depressed": {
    value: "rgba(109, 113, 117, 1)",
    description: "Used as a depressed state for secondary buttons"
  },
  "action-primary": {
    value: "rgba(0, 128, 96, 1)",
    description: "Used as the background color for primary actions, and as the fill color for icons and the text color in navigation and tabs to communicate interaction states."
  },
  "action-primary-disabled": {
    value: "rgba(241, 241, 241, 1)",
    description: "Used as the background color for disabled primary actions, and as the fill color for icons and the text color in navigation and tabs to communicate interaction states."
  },
  "action-primary-hovered": {
    value: "rgba(0, 110, 82, 1)",
    description: "Used as the background color for hovered primary actions, and as the fill color for icons and the text color in navigation and tabs to communicate interaction states."
  },
  "action-primary-pressed": {
    value: "rgba(0, 94, 70, 1)",
    description: "Used as the background color for pressed primary actions, and as the fill color for icons and the text color in navigation and tabs to communicate interaction states."
  },
  "action-primary-depressed": {
    value: "rgba(0, 61, 44, 1)",
    description: "Used as the background color for pressed primary actions, and as the fill color for icons and the text color in navigation and tabs to communicate interaction states."
  },
  "icon-on-primary": {
    value: "rgba(255, 255, 255, 1)",
    description: "For use as a fill color for icons on primary actions. Not for use in icons on navigation and tabs."
  },
  "text-on-primary": {
    value: "rgba(255, 255, 255, 1)",
    description: "For use as a text color on primary actions. Not for use in text on navigation and tabs."
  },
  "text-primary": {
    value: "rgba(0, 123, 92, 1)",
    description: "For use as primary text color on background. For use in text in components such as Navigation."
  },
  "text-primary-hovered": {
    value: "rgba(0, 108, 80, 1)",
    description: "For use as primary hovered text color on background. For use in text in components such as Navigation."
  },
  "text-primary-pressed": {
    value: "rgba(0, 92, 68, 1)",
    description: "For use as primary pressed text color on background. For use in text in components such as Navigation."
  },
  "surface-primary-selected": {
    value: "rgba(241, 248, 245, 1)",
    description: "Used as a surface color to indicate selected interactive states in navigation and tabs."
  },
  "surface-primary-selected-hovered": {
    value: "rgba(179, 208, 195, 1)",
    description: "Used as a surface color to indicate selected interactive states that are hovered in navigation and tabs."
  },
  "surface-primary-selected-pressed": {
    value: "rgba(162, 188, 176, 1)",
    description: "Used as a surface color to indicate selected interactive states that are pressed in navigation and tabs."
  },
  "border-critical": {
    value: "rgba(253, 87, 73, 1)",
    description: "For use as a border on critical components such as an outline on interactive elements in an error state."
  },
  "border-critical-subdued": {
    value: "rgba(224, 179, 178, 1)",
    description: "For use as a border on critical components such as banners."
  },
  "border-critical-disabled": {
    value: "rgba(255, 167, 163, 1)",
    description: "For use as a disabled border on critical components such as banners, and as an outline on interactive elements in an error state."
  },
  "icon-critical": {
    value: "rgba(215, 44, 13, 1)",
    description: "For use as an icon fill color on top of critical elements."
  },
  "surface-critical": {
    value: "rgba(254, 211, 209, 1)",
    description: "For use as a surface color on critical elements including badges."
  },
  "surface-critical-subdued": {
    value: "rgba(255, 244, 244, 1)",
    description: "For use as a subdued surface color on critical elements including banners."
  },
  "surface-critical-subdued-hovered": {
    value: "rgba(255, 240, 240, 1)",
    description: "For use as a surface color on critical interactive elements including action list items in a hovered state."
  },
  "surface-critical-subdued-pressed": {
    value: "rgba(255, 233, 232, 1)",
    description: "For use as a surface color on critical interactive elements including action list items in a pressed state."
  },
  "surface-critical-subdued-depressed": {
    value: "rgba(254, 188, 185, 1)",
    description: "For use as a surface color on critical interactive elements including action list items in a depressed state."
  },
  "text-critical": {
    value: "rgba(215, 44, 13, 1)",
    description: "For use as a text color in inert critical elements such as exception list. Not for use as a text color on banners and badges."
  },
  "action-critical": {
    value: "rgba(216, 44, 13, 1)",
    description: "For use as the background color for destructive buttons, and as the background color for error toast messages."
  },
  "action-critical-disabled": {
    value: "rgba(241, 241, 241, 1)",
    description: "For use as the background color for disabled destructive buttons, and as the background color for error toast messages."
  },
  "action-critical-hovered": {
    value: "rgba(188, 34, 0, 1)",
    description: "For use as the background color for hovered destructive buttons, and as the background color for error toast messages."
  },
  "action-critical-pressed": {
    value: "rgba(162, 27, 0, 1)",
    description: "For use as the background color for pressed destructive buttons, and as the background color for error toast messages."
  },
  "action-critical-depressed": {
    value: "rgba(108, 15, 0, 1)",
    description: "For use as the background color for depressed destructive buttons, and as the background color for error toast messages."
  },
  "icon-on-critical": {
    value: "rgba(255, 255, 255, 1)",
    description: "For use as a fill color for icons on critical actions."
  },
  "text-on-critical": {
    value: "rgba(255, 255, 255, 1)",
    description: "For use as a text color on critical actions."
  },
  "interactive-critical": {
    value: "rgba(216, 44, 13, 1)",
    description: "For use as the text color for destructive interactive elements: links, plain buttons, error state of selected checkboxes and radio buttons, as well as a text color on destructive action list items. Not for use on critical banners and badges."
  },
  "interactive-critical-disabled": {
    value: "rgba(253, 147, 141, 1)",
    description: "For use as a text color in disabled destructive plain buttons, as well as a text color on destructive action list items. Not for use on critical banners and badges."
  },
  "interactive-critical-hovered": {
    value: "rgba(205, 41, 12, 1)",
    description: "For use as a text color in hovered destructive plain buttons, as well as a text color on destructive action list items. Not for use on critical banners and badges."
  },
  "interactive-critical-pressed": {
    value: "rgba(103, 15, 3, 1)",
    description: "For use as a text color in pressed destructive plain buttons, as well as a text color on destructive action list items. Not for use on critical banners and badges."
  },
  "border-warning": {
    value: "rgba(185, 137, 0, 1)",
    description: "For use as a border on warning components such as..."
  },
  "border-warning-subdued": {
    value: "rgba(225, 184, 120, 1)",
    description: "For use as a border on warning components such as banners."
  },
  "icon-warning": {
    value: "rgba(185, 137, 0, 1)",
    description: "For use as an icon fill color on top of warning elements."
  },
  "surface-warning": {
    value: "rgba(255, 215, 157, 1)",
    description: "For use as a surface color on warning elements including badges."
  },
  "surface-warning-subdued": {
    value: "rgba(255, 245, 234, 1)",
    description: "For use as a subdued surface color on warning elements including banners."
  },
  "surface-warning-subdued-hovered": {
    value: "rgba(255, 242, 226, 1)",
    description: "For use as a subdued surface color on warning elements including banners."
  },
  "surface-warning-subdued-pressed": {
    value: "rgba(255, 235, 211, 1)",
    description: "For use as a subdued surface color on warning elements including banners."
  },
  "text-warning": {
    value: "rgba(145, 106, 0, 1)",
    description: "For use as a text color in inert critical elements such as exception list. Not for use as a text color on banners and badges."
  },
  "border-highlight": {
    value: "rgba(68, 157, 167, 1)",
    description: "For use as a border on informational components such as..."
  },
  "border-highlight-subdued": {
    value: "rgba(152, 198, 205, 1)",
    description: "For use as a border on informational components such as banners."
  },
  "icon-highlight": {
    value: "rgba(0, 160, 172, 1)",
    description: "For use as an icon fill color on top of informational elements."
  },
  "surface-highlight": {
    value: "rgba(164, 232, 242, 1)",
    description: "For use as a surface color on information elements including badges."
  },
  "surface-highlight-subdued": {
    value: "rgba(235, 249, 252, 1)",
    description: "For use as a surface color on information elements including banners."
  },
  "surface-highlight-subdued-hovered": {
    value: "rgba(228, 247, 250, 1)",
    description: "For use as a surface color on information elements including banners."
  },
  "surface-highlight-subdued-pressed": {
    value: "rgba(213, 243, 248, 1)",
    description: "For use as a surface color on information elements including banners."
  },
  "text-highlight": {
    value: "rgba(52, 124, 132, 1)",
    description: "For use as a text color in inert informational elements. Not for use as a text color on banners and badges."
  },
  "border-success": {
    value: "rgba(0, 164, 124, 1)",
    description: "For use as a border on success components such as text inputs."
  },
  "border-success-subdued": {
    value: "rgba(149, 201, 180, 1)",
    description: "For use as a border on success components such as banners."
  },
  "icon-success": {
    value: "rgba(0, 127, 95, 1)",
    description: "For use as an icon fill color on top of success elements."
  },
  "surface-success": {
    value: "rgba(174, 233, 209, 1)",
    description: "For use as a surface color on success elements including badges."
  },
  "surface-success-subdued": {
    value: "rgba(241, 248, 245, 1)",
    description: "For use as a surface color on information elements including banners."
  },
  "surface-success-subdued-hovered": {
    value: "rgba(236, 246, 241, 1)",
    description: "For use as a surface color on information elements including banners."
  },
  "surface-success-subdued-pressed": {
    value: "rgba(226, 241, 234, 1)",
    description: "For use as a surface color on information elements including banners."
  },
  "text-success": {
    value: "rgba(0, 128, 96, 1)",
    description: "For use as a text color in inert success elements. Not for use as a text color on banners and badges."
  },
  "icon-attention": {
    value: "rgba(138, 97, 22, 1)"
  },
  "surface-attention": {
    value: "rgba(255, 234, 138, 1)"
  },
  "decorative-one-icon": {
    value: "rgba(126, 87, 0, 1)",
    description: "For use as a decorative icon color that is applied on a decorative surface."
  },
  "decorative-one-surface": {
    value: "rgba(255, 201, 107, 1)",
    description: "For use as a decorative surface color."
  },
  "decorative-one-text": {
    value: "rgba(61, 40, 0, 1)",
    description: "For use as a decorative text color that is applied on a decorative surface."
  },
  "decorative-two-icon": {
    value: "rgba(175, 41, 78, 1)",
    description: "For use as a decorative icon color that is applied on a decorative surface."
  },
  "decorative-two-surface": {
    value: "rgba(255, 196, 176, 1)",
    description: "For use as a decorative surface color."
  },
  "decorative-two-text": {
    value: "rgba(73, 11, 28, 1)",
    description: "For use as a decorative text color that is applied on a decorative surface."
  },
  "decorative-three-icon": {
    value: "rgba(0, 109, 65, 1)",
    description: "For use as a decorative icon color that is applied on a decorative surface."
  },
  "decorative-three-surface": {
    value: "rgba(146, 230, 181, 1)",
    description: "For use as a decorative surface color."
  },
  "decorative-three-text": {
    value: "rgba(0, 47, 25, 1)",
    description: "For use as a decorative text color that is applied on a decorative surface."
  },
  "decorative-four-icon": {
    value: "rgba(0, 106, 104, 1)",
    description: "For use as a decorative icon color that is applied on a decorative surface."
  },
  "decorative-four-surface": {
    value: "rgba(145, 224, 214, 1)",
    description: "For use as a decorative surface color."
  },
  "decorative-four-text": {
    value: "rgba(0, 45, 45, 1)",
    description: "For use as a decorative text color that is applied on a decorative surface."
  },
  "decorative-five-icon": {
    value: "rgba(174, 43, 76, 1)",
    description: "For use as a decorative icon color that is applied on a decorative surface."
  },
  "decorative-five-surface": {
    value: "rgba(253, 201, 208, 1)",
    description: "For use as a decorative surface color."
  },
  "decorative-five-text": {
    value: "rgba(79, 14, 31, 1)",
    description: "For use as a decorative text color that is applied on a decorative surface."
  }
};
var motion$1 = {
  "duration-0": {
    value: "0ms"
  },
  "duration-50": {
    value: "50ms"
  },
  "duration-100": {
    value: "100ms"
  },
  "duration-150": {
    value: "150ms"
  },
  "duration-200": {
    value: "200ms"
  },
  "duration-250": {
    value: "250ms"
  },
  "duration-300": {
    value: "300ms"
  },
  "duration-350": {
    value: "350ms"
  },
  "duration-400": {
    value: "400ms"
  },
  "duration-450": {
    value: "450ms"
  },
  "duration-500": {
    value: "500ms"
  },
  "duration-5000": {
    value: "5000ms"
  },
  ease: {
    value: "cubic-bezier(0.25, 0.1, 0.25, 1)"
  },
  "ease-in": {
    value: "cubic-bezier(0.42, 0, 1, 1)"
  },
  "ease-out": {
    value: "cubic-bezier(0, 0, 0.58, 1)"
  },
  "ease-in-out": {
    value: "cubic-bezier(0.42, 0, 0.58, 1)"
  },
  linear: {
    value: "cubic-bezier(0, 0, 1, 1)"
  },
  "keyframes-bounce": {
    value: "{ from, 65%, 85% { transform: scale(1) } 75% { transform: scale(0.85) } 82.5% { transform: scale(1.05) } }"
  },
  "keyframes-fade-in": {
    value: "{ to { opacity: 1 } }"
  },
  "keyframes-pulse": {
    value: "{ from, 75% { transform: scale(0.85); opacity: 1; } to { transform: scale(2.5); opacity: 0; } }"
  },
  "keyframes-spin": {
    value: "{ to { transform: rotate(1turn) } }"
  }
};
var shape = {
  "border-radius-05": {
    value: "2px"
  },
  "border-radius-1": {
    value: "4px"
  },
  "border-radius-2": {
    value: "8px"
  },
  "border-radius-3": {
    value: "12px"
  },
  "border-radius-4": {
    value: "16px"
  },
  "border-radius-5": {
    value: "20px"
  },
  "border-radius-6": {
    value: "30px"
  },
  "border-radius-base": {
    value: "3px"
  },
  "border-radius-large": {
    value: "6px"
  },
  "border-radius-half": {
    value: "50%"
  },
  "border-width-1": {
    value: "1px"
  },
  "border-width-2": {
    value: "2px"
  },
  "border-width-3": {
    value: "3px"
  },
  "border-width-4": {
    value: "4px"
  },
  "border-width-5": {
    value: "5px"
  },
  "border-base": {
    value: "var(--p-border-width-1) solid var(--p-border-subdued)"
  },
  "border-dark": {
    value: "var(--p-border-width-1) solid var(--p-border)"
  },
  "border-transparent": {
    value: "var(--p-border-width-1) solid transparent"
  },
  "border-divider": {
    value: "var(--p-border-width-1) solid var(--p-divider)"
  },
  "border-divider-on-dark": {
    value: "var(--p-border-width-1) solid var(--p-divider-dark)"
  }
};
var spacing$1 = {
  "space-0": {
    value: "0"
  },
  "space-025": {
    value: "1px"
  },
  "space-05": {
    value: "2px"
  },
  "space-1": {
    value: "4px"
  },
  "space-2": {
    value: "8px"
  },
  "space-3": {
    value: "12px"
  },
  "space-4": {
    value: "16px"
  },
  "space-5": {
    value: "20px"
  },
  "space-6": {
    value: "24px"
  },
  "space-8": {
    value: "32px"
  },
  "space-10": {
    value: "40px"
  },
  "space-12": {
    value: "48px"
  },
  "space-16": {
    value: "64px"
  },
  "space-20": {
    value: "80px"
  },
  "space-24": {
    value: "96px"
  },
  "space-28": {
    value: "112px"
  },
  "space-32": {
    value: "128px"
  }
};
var zIndex = {
  "z-1": {
    value: "100"
  },
  "z-2": {
    value: "400"
  },
  "z-3": {
    value: "510"
  },
  "z-4": {
    value: "512"
  },
  "z-5": {
    value: "513"
  },
  "z-6": {
    value: "514"
  },
  "z-7": {
    value: "515"
  },
  "z-8": {
    value: "516"
  },
  "z-9": {
    value: "517"
  },
  "z-10": {
    value: "518"
  },
  "z-11": {
    value: "519"
  },
  "z-12": {
    value: "520"
  }
};
createMetadata({
  breakpoints: tokensToRems(breakpoints$1),
  colors,
  depth,
  font: tokensToRems(font),
  legacy: tokensToRems(legacy),
  motion: motion$1,
  shape: tokensToRems(shape),
  spacing: tokensToRems(spacing$1),
  zIndex
});
function createMetadata(metadata) {
  return metadata;
}
var breakpoints = {
  "breakpoints-xs": "0rem",
  "breakpoints-sm": "30.625rem",
  "breakpoints-md": "48rem",
  "breakpoints-lg": "65rem",
  "breakpoints-xl": "90rem"
};
var motion = {
  "duration-0": "0ms",
  "duration-50": "50ms",
  "duration-100": "100ms",
  "duration-150": "150ms",
  "duration-200": "200ms",
  "duration-250": "250ms",
  "duration-300": "300ms",
  "duration-350": "350ms",
  "duration-400": "400ms",
  "duration-450": "450ms",
  "duration-500": "500ms",
  "duration-5000": "5000ms",
  "ease": "cubic-bezier(0.25, 0.1, 0.25, 1)",
  "ease-in": "cubic-bezier(0.42, 0, 1, 1)",
  "ease-out": "cubic-bezier(0, 0, 0.58, 1)",
  "ease-in-out": "cubic-bezier(0.42, 0, 0.58, 1)",
  "linear": "cubic-bezier(0, 0, 1, 1)",
  "keyframes-bounce": "{ from, 65%, 85% { transform: scale(1) } 75% { transform: scale(0.85) } 82.5% { transform: scale(1.05) } }",
  "keyframes-fade-in": "{ to { opacity: 1 } }",
  "keyframes-pulse": "{ from, 75% { transform: scale(0.85); opacity: 1; } to { transform: scale(2.5); opacity: 0; } }",
  "keyframes-spin": "{ to { transform: rotate(1turn) } }"
};
var spacing = {
  "space-0": "0",
  "space-025": "0.0625rem",
  "space-05": "0.125rem",
  "space-1": "0.25rem",
  "space-2": "0.5rem",
  "space-3": "0.75rem",
  "space-4": "1rem",
  "space-5": "1.25rem",
  "space-6": "1.5rem",
  "space-8": "2rem",
  "space-10": "2.5rem",
  "space-12": "3rem",
  "space-16": "4rem",
  "space-20": "5rem",
  "space-24": "6rem",
  "space-28": "7rem",
  "space-32": "8rem"
};
var tokens = {
  "breakpoints": {
    "breakpoints-xs": "0rem",
    "breakpoints-sm": "30.625rem",
    "breakpoints-md": "48rem",
    "breakpoints-lg": "65rem",
    "breakpoints-xl": "90rem"
  },
  "colors": {
    "background": "rgba(246, 246, 247, 1)",
    "background-hovered": "rgba(241, 242, 243, 1)",
    "background-pressed": "rgba(237, 238, 239, 1)",
    "background-selected": "rgba(237, 238, 239, 1)",
    "surface": "rgba(255, 255, 255, 1)",
    "surface-dark": "rgba(32, 33, 35, 1)",
    "surface-neutral": "rgba(228, 229, 231, 1)",
    "surface-neutral-hovered": "rgba(219, 221, 223, 1)",
    "surface-neutral-pressed": "rgba(201, 204, 208, 1)",
    "surface-neutral-disabled": "rgba(241, 242, 243, 1)",
    "surface-neutral-subdued": "rgba(246, 246, 247, 1)",
    "surface-neutral-subdued-dark": "rgba(68, 71, 74, 1)",
    "surface-subdued": "rgba(250, 251, 251, 1)",
    "surface-disabled": "rgba(250, 251, 251, 1)",
    "surface-hovered": "rgba(246, 246, 247, 1)",
    "surface-hovered-dark": "rgba(47, 49, 51, 1)",
    "surface-pressed": "rgba(241, 242, 243, 1)",
    "surface-pressed-dark": "rgba(62, 64, 67, 1)",
    "surface-depressed": "rgba(237, 238, 239, 1)",
    "surface-search-field": "rgba(241, 242, 243, 1)",
    "surface-search-field-dark": "rgba(47, 49, 51, 1)",
    "backdrop": "rgba(0, 0, 0, 0.5)",
    "overlay": "rgba(255, 255, 255, 0.5)",
    "shadow-color-picker": "rgba(0, 0, 0, 0.5)",
    "shadow-color-picker-dragger": "rgba(33, 43, 54, 0.32)",
    "hint-from-direct-light": "rgba(0, 0, 0, 0.15)",
    "border": "rgba(140, 145, 150, 1)",
    "border-on-dark": "rgba(80, 83, 86, 1)",
    "border-neutral-subdued": "rgba(186, 191, 195, 1)",
    "border-hovered": "rgba(153, 158, 164, 1)",
    "border-disabled": "rgba(210, 213, 216, 1)",
    "border-subdued": "rgba(201, 204, 207, 1)",
    "border-depressed": "rgba(87, 89, 89, 1)",
    "border-shadow": "rgba(174, 180, 185, 1)",
    "border-shadow-subdued": "rgba(186, 191, 196, 1)",
    "divider": "rgba(225, 227, 229, 1)",
    "divider-dark": "rgba(69, 71, 73, 1)",
    "icon": "rgba(92, 95, 98, 1)",
    "icon-on-dark": "rgba(166, 172, 178, 1)",
    "icon-hovered": "rgba(26, 28, 29, 1)",
    "icon-pressed": "rgba(68, 71, 74, 1)",
    "icon-disabled": "rgba(186, 190, 195, 1)",
    "icon-subdued": "rgba(140, 145, 150, 1)",
    "text": "rgba(32, 34, 35, 1)",
    "text-on-dark": "rgba(227, 229, 231, 1)",
    "text-disabled": "rgba(140, 145, 150, 1)",
    "text-subdued": "rgba(109, 113, 117, 1)",
    "text-subdued-on-dark": "rgba(153, 159, 164, 1)",
    "interactive": "rgba(44, 110, 203, 1)",
    "interactive-on-dark": "rgba(54, 163, 255, 1)",
    "interactive-disabled": "rgba(189, 193, 204, 1)",
    "interactive-hovered": "rgba(31, 81, 153, 1)",
    "interactive-pressed": "rgba(16, 50, 98, 1)",
    "interactive-pressed-on-dark": "rgba(136, 188, 255, 1)",
    "focused": "rgba(69, 143, 255, 1)",
    "surface-selected": "rgba(242, 247, 254, 1)",
    "surface-selected-hovered": "rgba(237, 244, 254, 1)",
    "surface-selected-pressed": "rgba(229, 239, 253, 1)",
    "icon-on-interactive": "rgba(255, 255, 255, 1)",
    "text-on-interactive": "rgba(255, 255, 255, 1)",
    "action-secondary": "rgba(255, 255, 255, 1)",
    "action-secondary-disabled": "rgba(255, 255, 255, 1)",
    "action-secondary-hovered": "rgba(246, 246, 247, 1)",
    "action-secondary-hovered-dark": "rgba(84, 87, 91, 1)",
    "action-secondary-pressed": "rgba(241, 242, 243, 1)",
    "action-secondary-pressed-dark": "rgba(96, 100, 103, 1)",
    "action-secondary-depressed": "rgba(109, 113, 117, 1)",
    "action-primary": "rgba(0, 128, 96, 1)",
    "action-primary-disabled": "rgba(241, 241, 241, 1)",
    "action-primary-hovered": "rgba(0, 110, 82, 1)",
    "action-primary-pressed": "rgba(0, 94, 70, 1)",
    "action-primary-depressed": "rgba(0, 61, 44, 1)",
    "icon-on-primary": "rgba(255, 255, 255, 1)",
    "text-on-primary": "rgba(255, 255, 255, 1)",
    "text-primary": "rgba(0, 123, 92, 1)",
    "text-primary-hovered": "rgba(0, 108, 80, 1)",
    "text-primary-pressed": "rgba(0, 92, 68, 1)",
    "surface-primary-selected": "rgba(241, 248, 245, 1)",
    "surface-primary-selected-hovered": "rgba(179, 208, 195, 1)",
    "surface-primary-selected-pressed": "rgba(162, 188, 176, 1)",
    "border-critical": "rgba(253, 87, 73, 1)",
    "border-critical-subdued": "rgba(224, 179, 178, 1)",
    "border-critical-disabled": "rgba(255, 167, 163, 1)",
    "icon-critical": "rgba(215, 44, 13, 1)",
    "surface-critical": "rgba(254, 211, 209, 1)",
    "surface-critical-subdued": "rgba(255, 244, 244, 1)",
    "surface-critical-subdued-hovered": "rgba(255, 240, 240, 1)",
    "surface-critical-subdued-pressed": "rgba(255, 233, 232, 1)",
    "surface-critical-subdued-depressed": "rgba(254, 188, 185, 1)",
    "text-critical": "rgba(215, 44, 13, 1)",
    "action-critical": "rgba(216, 44, 13, 1)",
    "action-critical-disabled": "rgba(241, 241, 241, 1)",
    "action-critical-hovered": "rgba(188, 34, 0, 1)",
    "action-critical-pressed": "rgba(162, 27, 0, 1)",
    "action-critical-depressed": "rgba(108, 15, 0, 1)",
    "icon-on-critical": "rgba(255, 255, 255, 1)",
    "text-on-critical": "rgba(255, 255, 255, 1)",
    "interactive-critical": "rgba(216, 44, 13, 1)",
    "interactive-critical-disabled": "rgba(253, 147, 141, 1)",
    "interactive-critical-hovered": "rgba(205, 41, 12, 1)",
    "interactive-critical-pressed": "rgba(103, 15, 3, 1)",
    "border-warning": "rgba(185, 137, 0, 1)",
    "border-warning-subdued": "rgba(225, 184, 120, 1)",
    "icon-warning": "rgba(185, 137, 0, 1)",
    "surface-warning": "rgba(255, 215, 157, 1)",
    "surface-warning-subdued": "rgba(255, 245, 234, 1)",
    "surface-warning-subdued-hovered": "rgba(255, 242, 226, 1)",
    "surface-warning-subdued-pressed": "rgba(255, 235, 211, 1)",
    "text-warning": "rgba(145, 106, 0, 1)",
    "border-highlight": "rgba(68, 157, 167, 1)",
    "border-highlight-subdued": "rgba(152, 198, 205, 1)",
    "icon-highlight": "rgba(0, 160, 172, 1)",
    "surface-highlight": "rgba(164, 232, 242, 1)",
    "surface-highlight-subdued": "rgba(235, 249, 252, 1)",
    "surface-highlight-subdued-hovered": "rgba(228, 247, 250, 1)",
    "surface-highlight-subdued-pressed": "rgba(213, 243, 248, 1)",
    "text-highlight": "rgba(52, 124, 132, 1)",
    "border-success": "rgba(0, 164, 124, 1)",
    "border-success-subdued": "rgba(149, 201, 180, 1)",
    "icon-success": "rgba(0, 127, 95, 1)",
    "surface-success": "rgba(174, 233, 209, 1)",
    "surface-success-subdued": "rgba(241, 248, 245, 1)",
    "surface-success-subdued-hovered": "rgba(236, 246, 241, 1)",
    "surface-success-subdued-pressed": "rgba(226, 241, 234, 1)",
    "text-success": "rgba(0, 128, 96, 1)",
    "icon-attention": "rgba(138, 97, 22, 1)",
    "surface-attention": "rgba(255, 234, 138, 1)",
    "decorative-one-icon": "rgba(126, 87, 0, 1)",
    "decorative-one-surface": "rgba(255, 201, 107, 1)",
    "decorative-one-text": "rgba(61, 40, 0, 1)",
    "decorative-two-icon": "rgba(175, 41, 78, 1)",
    "decorative-two-surface": "rgba(255, 196, 176, 1)",
    "decorative-two-text": "rgba(73, 11, 28, 1)",
    "decorative-three-icon": "rgba(0, 109, 65, 1)",
    "decorative-three-surface": "rgba(146, 230, 181, 1)",
    "decorative-three-text": "rgba(0, 47, 25, 1)",
    "decorative-four-icon": "rgba(0, 106, 104, 1)",
    "decorative-four-surface": "rgba(145, 224, 214, 1)",
    "decorative-four-text": "rgba(0, 45, 45, 1)",
    "decorative-five-icon": "rgba(174, 43, 76, 1)",
    "decorative-five-surface": "rgba(253, 201, 208, 1)",
    "decorative-five-text": "rgba(79, 14, 31, 1)"
  },
  "depth": {
    "shadow-transparent": "0 0 0 0 transparent",
    "shadow-faint": "0 1px 0 0 rgba(22, 29, 37, 0.05)",
    "shadow-base": "0 0 0 1px rgba(63, 63, 68, 0.05), 0 1px 3px 0 rgba(63, 63, 68, 0.15)",
    "shadow-deep": "0 0 0 1px rgba(6, 44, 82, 0.1), 0 2px 16px rgba(33, 43, 54, 0.08)",
    "shadow-button": "0 1px 0 rgba(0, 0, 0, 0.05)",
    "shadow-top-bar": "0 2px 2px -1px rgba(0, 0, 0, 0.15)",
    "shadow-card": "0 0 5px rgba(23, 24, 24, 0.05), 0 1px 2px rgba(0, 0, 0, 0.15)",
    "shadow-popover": "0 3px 6px -3px rgba(23, 24, 24, 0.08), 0 8px 20px -4px rgba(23, 24, 24, 0.12)",
    "shadow-layer": "0 31px 41px 0 rgba(32, 42, 53, 0.2), 0 2px 16px 0 rgba(32, 42, 54, 0.08)",
    "shadow-modal": "0 26px 80px rgba(0, 0, 0, 0.2), 0 0px 1px rgba(0, 0, 0, 0.2)",
    "shadows-inset-button": "inset 0 -1px 0 rgba(0, 0, 0, 0.2)",
    "shadows-inset-button-pressed": "inset 0 1px 0 rgba(0, 0, 0, 0.15)"
  },
  "font": {
    "font-family-sans": "-apple-system, BlinkMacSystemFont, 'San Francisco', 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif",
    "font-family-mono": "ui-monospace, SFMono-Regular, 'SF Mono', Consolas, 'Liberation Mono', Menlo, monospace",
    "font-size-75": "0.75rem",
    "font-size-100": "0.875rem",
    "font-size-200": "1rem",
    "font-size-300": "1.25rem",
    "font-size-400": "1.5rem",
    "font-size-500": "1.75rem",
    "font-size-600": "2rem",
    "font-size-700": "2.5rem",
    "font-weight-regular": "400",
    "font-weight-medium": "500",
    "font-weight-semibold": "600",
    "font-weight-bold": "700",
    "font-line-height-1": "1rem",
    "font-line-height-2": "1.25rem",
    "font-line-height-3": "1.5rem",
    "font-line-height-4": "1.75rem",
    "font-line-height-5": "2rem",
    "font-line-height-6": "2.5rem",
    "font-line-height-7": "3rem"
  },
  "legacy": {
    "override-loading-z-index": "514",
    "choice-size": "1.25rem",
    "icon-size-small": "0.5rem",
    "icon-size-medium": "1.25rem",
    "choice-margin": "0.0625rem",
    "control-border-width": "0.125rem",
    "banner-border-default": "inset 0 0.0625rem 0 0 var(--p-border-neutral-subdued), inset 0 0 0 0.0625rem var(--p-border-neutral-subdued)",
    "banner-border-success": "inset 0 0.0625rem 0 0 var(--p-border-success-subdued), inset 0 0 0 0.0625rem var(--p-border-success-subdued)",
    "banner-border-highlight": "inset 0 0.0625rem 0 0 var(--p-border-highlight-subdued), inset 0 0 0 0.0625rem var(--p-border-highlight-subdued)",
    "banner-border-warning": "inset 0 0.0625rem 0 0 var(--p-border-warning-subdued), inset 0 0 0 0.0625rem var(--p-border-warning-subdued)",
    "banner-border-critical": "inset 0 0.0625rem 0 0 var(--p-border-critical-subdued), inset 0 0 0 0.0625rem var(--p-border-critical-subdued)",
    "thin-border-subdued": "0.0625rem solid var(--p-border-subdued)",
    "text-field-spinner-offset": "0.125rem",
    "text-field-focus-ring-offset": "-0.25rem",
    "button-group-item-spacing": "-0.0625rem",
    "range-slider-thumb-size-base": "1rem",
    "range-slider-thumb-size-active": "1.5rem",
    "frame-offset": "0rem"
  },
  "motion": {
    "duration-0": "0ms",
    "duration-50": "50ms",
    "duration-100": "100ms",
    "duration-150": "150ms",
    "duration-200": "200ms",
    "duration-250": "250ms",
    "duration-300": "300ms",
    "duration-350": "350ms",
    "duration-400": "400ms",
    "duration-450": "450ms",
    "duration-500": "500ms",
    "duration-5000": "5000ms",
    "ease": "cubic-bezier(0.25, 0.1, 0.25, 1)",
    "ease-in": "cubic-bezier(0.42, 0, 1, 1)",
    "ease-out": "cubic-bezier(0, 0, 0.58, 1)",
    "ease-in-out": "cubic-bezier(0.42, 0, 0.58, 1)",
    "linear": "cubic-bezier(0, 0, 1, 1)",
    "keyframes-bounce": "{ from, 65%, 85% { transform: scale(1) } 75% { transform: scale(0.85) } 82.5% { transform: scale(1.05) } }",
    "keyframes-fade-in": "{ to { opacity: 1 } }",
    "keyframes-pulse": "{ from, 75% { transform: scale(0.85); opacity: 1; } to { transform: scale(2.5); opacity: 0; } }",
    "keyframes-spin": "{ to { transform: rotate(1turn) } }"
  },
  "shape": {
    "border-radius-05": "0.125rem",
    "border-radius-1": "0.25rem",
    "border-radius-2": "0.5rem",
    "border-radius-3": "0.75rem",
    "border-radius-4": "1rem",
    "border-radius-5": "1.25rem",
    "border-radius-6": "1.875rem",
    "border-radius-base": "0.1875rem",
    "border-radius-large": "0.375rem",
    "border-radius-half": "50%",
    "border-width-1": "0.0625rem",
    "border-width-2": "0.125rem",
    "border-width-3": "0.1875rem",
    "border-width-4": "0.25rem",
    "border-width-5": "0.3125rem",
    "border-base": "var(--p-border-width-1) solid var(--p-border-subdued)",
    "border-dark": "var(--p-border-width-1) solid var(--p-border)",
    "border-transparent": "var(--p-border-width-1) solid transparent",
    "border-divider": "var(--p-border-width-1) solid var(--p-divider)",
    "border-divider-on-dark": "var(--p-border-width-1) solid var(--p-divider-dark)"
  },
  "spacing": {
    "space-0": "0",
    "space-025": "0.0625rem",
    "space-05": "0.125rem",
    "space-1": "0.25rem",
    "space-2": "0.5rem",
    "space-3": "0.75rem",
    "space-4": "1rem",
    "space-5": "1.25rem",
    "space-6": "1.5rem",
    "space-8": "2rem",
    "space-10": "2.5rem",
    "space-12": "3rem",
    "space-16": "4rem",
    "space-20": "5rem",
    "space-24": "6rem",
    "space-28": "7rem",
    "space-32": "8rem"
  },
  "zIndex": {
    "z-1": "100",
    "z-2": "400",
    "z-3": "510",
    "z-4": "512",
    "z-5": "513",
    "z-6": "514",
    "z-7": "515",
    "z-8": "516",
    "z-9": "517",
    "z-10": "518",
    "z-11": "519",
    "z-12": "520"
  }
};
const isServer = typeof window === "undefined" || typeof document === "undefined";
const Breakpoints = {
  navigationBarCollapsed: "767.95px",
  stackedContent: "1039.95px"
};
const noWindowMatches = {
  media: "",
  addListener: noop,
  removeListener: noop,
  matches: false,
  onchange: noop,
  addEventListener: noop,
  removeEventListener: noop,
  dispatchEvent: (_) => true
};
function noop() {
  return;
}
function navigationBarCollapsed() {
  return typeof window === "undefined" ? noWindowMatches : window.matchMedia(`(max-width: ${Breakpoints.navigationBarCollapsed})`);
}
function stackedContent() {
  return typeof window === "undefined" ? noWindowMatches : window.matchMedia(`(max-width: ${Breakpoints.stackedContent})`);
}
getBreakpointsQueryEntries(breakpoints);
function getBreakpointsQueryEntries(breakpointsValue) {
  const mediaConditionEntries = Object.entries(getMediaConditions(breakpointsValue));
  return mediaConditionEntries.map(([breakpointsToken, mediaConditions]) => Object.entries(mediaConditions).map(([direction, mediaCondition]) => {
    const breakpointsAlias = breakpointsToken.split("-")[1];
    const directionAlias = `${breakpointsAlias}${capitalize$2(direction)}`;
    return [directionAlias, mediaCondition];
  })).flat();
}
function capitalize$2(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}
class Rect {
  constructor({ top = 0, left = 0, width = 0, height = 0 } = {}) {
    __publicField(this, "top");
    __publicField(this, "left");
    __publicField(this, "width");
    __publicField(this, "height");
    this.top = top;
    this.left = left;
    this.width = width;
    this.height = height;
  }
  static get zero() {
    return new Rect();
  }
  get center() {
    return {
      x: this.left + this.width / 2,
      y: this.top + this.height / 2
    };
  }
}
function getRectForNode(node) {
  if (!(node instanceof Element)) {
    return new Rect({
      width: window.innerWidth,
      height: window.innerHeight
    });
  }
  const rect = node.getBoundingClientRect();
  return new Rect({
    top: rect.top,
    left: rect.left,
    width: rect.width,
    height: rect.height
  });
}
const SIXTY_FPS = 1e3 / 60;
function isDocument$1(node) {
  return node === document;
}
function scrollTopFor(container) {
  return isDocument$1(container) ? document.body.scrollTop || document.documentElement.scrollTop : container.scrollTop;
}
function horizontallyOverlaps(rect1, rect2) {
  const rect1Left = rect1.left;
  const rect1Right = rect1.left + rect1.width;
  const rect2Left = rect2.left;
  const rect2Right = rect2.left + rect2.width;
  return rect2Right < rect1Left || rect1Right < rect2Left;
}
class StickyManager {
  constructor(container) {
    __publicField(this, "stickyItems", []);
    __publicField(this, "stuckItems", []);
    __publicField(this, "container", null);
    __publicField(this, "topBarOffset", 0);
    __publicField(this, "handleResize", debounce(() => {
      this.manageStickyItems();
    }, SIXTY_FPS, { leading: true, trailing: true, maxWait: SIXTY_FPS }));
    __publicField(this, "handleScroll", debounce(() => {
      this.manageStickyItems();
    }, SIXTY_FPS, { leading: true, trailing: true, maxWait: SIXTY_FPS }));
    if (container) {
      this.setContainer(container);
    }
  }
  registerStickyItem(stickyItem) {
    this.stickyItems.push(stickyItem);
  }
  unregisterStickyItem(nodeToRemove) {
    const nodeIndex = this.stickyItems.findIndex(({ stickyNode }) => nodeToRemove === stickyNode);
    this.stickyItems.splice(nodeIndex, 1);
  }
  setContainer(el) {
    this.container = el;
    if (isDocument$1(el)) {
      this.setTopBarOffset(el);
    }
    this.container.addEventListener("scroll", this.handleScroll);
    window.addEventListener("resize", this.handleResize);
    this.manageStickyItems();
  }
  removeScrollListener() {
    if (this.container) {
      this.container.removeEventListener("scroll", this.handleScroll);
      window.removeEventListener("resize", this.handleResize);
    }
  }
  manageStickyItems() {
    if (this.stickyItems.length <= 0) {
      return;
    }
    const scrollTop = this.container ? scrollTopFor(this.container) : 0;
    const containerTop = getRectForNode(this.container).top + this.topBarOffset;
    this.stickyItems.forEach((stickyItem) => {
      const { handlePositioning } = stickyItem;
      const { sticky, top, left, width } = this.evaluateStickyItem(stickyItem, scrollTop, containerTop);
      this.updateStuckItems(stickyItem, sticky);
      handlePositioning(sticky, top, left, width);
    });
  }
  evaluateStickyItem(stickyItem, scrollTop, containerTop) {
    var _a;
    const { stickyNode, placeHolderNode, boundingElement, offset, disableWhenStacked } = stickyItem;
    if (disableWhenStacked && stackedContent().matches) {
      return {
        sticky: false,
        top: 0,
        left: 0,
        width: "auto"
      };
    }
    const stickyOffset = offset ? this.getOffset(stickyNode) + parseInt(spacing["space-5"], 10) : this.getOffset(stickyNode);
    const scrollPosition2 = scrollTop + stickyOffset;
    const placeHolderNodeCurrentTop = placeHolderNode.getBoundingClientRect().top - containerTop + scrollTop;
    const top = containerTop + stickyOffset;
    const { left, width } = placeHolderNode.getBoundingClientRect();
    let sticky;
    if (boundingElement == null) {
      sticky = scrollPosition2 >= placeHolderNodeCurrentTop;
    } else {
      const stickyItemHeight = stickyNode.getBoundingClientRect().height || ((_a = stickyNode.firstElementChild) == null ? void 0 : _a.getBoundingClientRect().height) || 0;
      const stickyItemBottomPosition = boundingElement.getBoundingClientRect().bottom - stickyItemHeight + scrollTop - containerTop;
      sticky = scrollPosition2 >= placeHolderNodeCurrentTop && scrollPosition2 < stickyItemBottomPosition;
    }
    return {
      sticky,
      top,
      left,
      width
    };
  }
  updateStuckItems(item, sticky) {
    const { stickyNode } = item;
    if (sticky && !this.isNodeStuck(stickyNode)) {
      this.addStuckItem(item);
    } else if (!sticky && this.isNodeStuck(stickyNode)) {
      this.removeStuckItem(item);
    }
  }
  addStuckItem(stickyItem) {
    this.stuckItems.push(stickyItem);
  }
  removeStuckItem(stickyItem) {
    const { stickyNode: nodeToRemove } = stickyItem;
    const nodeIndex = this.stuckItems.findIndex(({ stickyNode }) => nodeToRemove === stickyNode);
    this.stuckItems.splice(nodeIndex, 1);
  }
  getOffset(node) {
    if (this.stuckItems.length === 0) {
      return 0;
    }
    let offset = 0;
    let count = 0;
    const stuckNodesLength = this.stuckItems.length;
    const nodeRect = getRectForNode(node);
    while (count < stuckNodesLength) {
      const stuckNode = this.stuckItems[count].stickyNode;
      if (stuckNode !== node) {
        const stuckNodeRect = getRectForNode(stuckNode);
        if (!horizontallyOverlaps(nodeRect, stuckNodeRect)) {
          offset += getRectForNode(stuckNode).height;
        }
      } else {
        break;
      }
      count += 1;
    }
    return offset;
  }
  isNodeStuck(node) {
    const nodeFound = this.stuckItems.findIndex(({ stickyNode }) => node === stickyNode);
    return nodeFound >= 0;
  }
  setTopBarOffset(container) {
    const topbarElement = container.querySelector(`:not(${scrollable.selector}) ${dataPolarisTopBar.selector}`);
    this.topBarOffset = topbarElement ? topbarElement.clientHeight : 0;
  }
}
const Scrollable = "Polaris-Scrollable";
const horizontal = "Polaris-Scrollable--horizontal";
const vertical$1 = "Polaris-Scrollable--vertical";
const hasTopShadow = "Polaris-Scrollable--hasTopShadow";
const hasBottomShadow = "Polaris-Scrollable--hasBottomShadow";
var styles$20 = {
  Scrollable,
  horizontal,
  vertical: vertical$1,
  hasTopShadow,
  hasBottomShadow
};
var Scrollable_vue_vue_type_style_index_0_lang = "";
const _hoisted_1$1J = ["tabindex"];
const _sfc_main$3o = /* @__PURE__ */ defineComponent({
  props: {
    vertical: { type: Boolean, default: true },
    horizontal: { type: Boolean, default: true },
    shadow: { type: Boolean },
    hint: { type: Boolean },
    focusable: { type: Boolean }
  },
  emits: ["scrolled-to-bottom"],
  setup(__props, { emit: emits }) {
    const props = __props;
    const MAX_SCROLL_HINT_DISTANCE = 100;
    const LOW_RES_BUFFER = 2;
    const scrollArea = ref(null);
    const topShadow = ref(false);
    const bottomShadow = ref(false);
    const stickyManager = new StickyManager();
    const finalClassName = computed(() => classNames(styles$20.Scrollable, props.vertical && styles$20.vertical, props.horizontal && styles$20.horizontal, props.shadow && topShadow.value && styles$20.hasTopShadow, props.shadow && bottomShadow.value && styles$20.hasBottomShadow));
    const scrollTo = (scrollY) => {
      var _a;
      const behavior = prefersReducedMotion() ? "auto" : "smooth";
      (_a = scrollArea.value) == null ? void 0 : _a.scrollTo({ top: scrollY, behavior });
    };
    provide("stickyManagerContext", stickyManager);
    provide("scrollableContext", scrollTo);
    const handleScroll = () => {
      const currentScrollArea = scrollArea.value;
      if (!currentScrollArea) {
        return;
      }
      requestAnimationFrame(() => {
        const { scrollTop, clientHeight, scrollHeight } = currentScrollArea;
        const canScroll = Boolean(scrollHeight > clientHeight);
        const isBelowTopOfScroll = Boolean(scrollTop > 0);
        const isAtBottomOfScroll = Boolean(scrollTop + clientHeight >= scrollHeight - LOW_RES_BUFFER);
        topShadow.value = isBelowTopOfScroll;
        bottomShadow.value = !isAtBottomOfScroll;
        if (canScroll && isAtBottomOfScroll) {
          emits("scrolled-to-bottom");
        }
      });
    };
    const handleResize = debounce(handleScroll, 50, { trailing: true });
    onMounted(() => {
      handleScroll();
      if (props.hint) {
        window.requestAnimationFrame(() => performScrollHint(scrollArea.value));
      }
      const currentScrollArea = scrollArea.value;
      if (!currentScrollArea) {
        return;
      }
      stickyManager.setContainer(currentScrollArea);
      currentScrollArea.addEventListener("scroll", handleScroll);
      document.addEventListener("resize", handleResize);
    });
    onBeforeUnmount(() => {
      if (!scrollArea.value) {
        return;
      }
      scrollArea.value.removeEventListener("scroll", handleScroll);
      document.removeEventListener("resize", handleResize);
      stickyManager.removeScrollListener();
    });
    function prefersReducedMotion() {
      try {
        return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      } catch (err) {
        return false;
      }
    }
    function performScrollHint(elem) {
      if (!elem || prefersReducedMotion()) {
        return;
      }
      const scrollableDistance = elem.scrollHeight - elem.clientHeight;
      const distanceToPeek = Math.min(MAX_SCROLL_HINT_DISTANCE, scrollableDistance) - LOW_RES_BUFFER;
      const goBackToTop = () => {
        requestAnimationFrame(() => {
          if (elem.scrollTop >= distanceToPeek) {
            elem.removeEventListener("scroll", goBackToTop);
            elem.scrollTo({ top: 0, behavior: "smooth" });
          }
        });
      };
      elem.addEventListener("scroll", goBackToTop);
      elem.scrollTo({ top: MAX_SCROLL_HINT_DISTANCE, behavior: "smooth" });
    }
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", mergeProps({
        ref_key: "scrollArea",
        ref: scrollArea
      }, unref(scrollable).props, {
        class: [_ctx.$attrs.class, unref(finalClassName)],
        tabindex: __props.focusable ? 0 : void 0
      }), [
        renderSlot(_ctx.$slots, "default")
      ], 16, _hoisted_1$1J);
    };
  }
});
class MissingAppProviderError extends Error {
  constructor(message = "") {
    super(`${message ? `${message} ` : message}Your application must be wrapped in an <AppProvider> component. See https://ownego.github.io/polaris-vue/?path=/docs/components-app-provider for implementation instructions.`);
    this.name = "MissingAppProviderError";
  }
}
class MissingFrameError extends Error {
  constructor(message = "") {
    super(`${message ? `${message} ` : message}Your component must be wrapped in a <Frame> component. See https://ownego.github.io/polaris-vue/?path=/docs/components-frame--page for implementation instructions.`);
    this.name = "MissingFrameError";
  }
}
function UseUniqueId() {
  const idFactory = inject("uniqueIdFactory");
  const uniqueIdRef = ref("");
  function useUniqueId(prefix = "", overrideId = "") {
    if (!idFactory) {
      throw new MissingAppProviderError("No UniqueIdFactory was provided.");
    }
    if (overrideId) {
      return overrideId;
    }
    if (!uniqueIdRef.value) {
      uniqueIdRef.value = idFactory.nextId(prefix);
    }
    return uniqueIdRef.value;
  }
  return { uniqueIdRef, useUniqueId };
}
function UseFocusManager(props) {
  const focusManager = inject("focusManager");
  const { useUniqueId, uniqueIdRef } = UseUniqueId();
  watch([() => props.trapping], () => {
    if (props.trapping && uniqueIdRef) {
      focusManager.add(uniqueIdRef.value);
    }
  });
  const canSafelyFocus = computed(() => {
    return focusManager.trapFocusList[0] === uniqueIdRef.value;
  });
  onBeforeMount(() => {
    if (!focusManager) {
      throw new MissingAppProviderError("No FocusManager was provided.");
    }
  });
  onMounted(() => {
    const id = useUniqueId();
    if (props.trapping) {
      focusManager.add(id);
    }
  });
  onBeforeUnmount(() => {
    if (uniqueIdRef.value) {
      focusManager.remove(uniqueIdRef.value);
    }
  });
  return { canSafelyFocus };
}
function UseI18n() {
  const lang2 = inject("lang");
  const i18n = inject("i18n");
  const translate = (id, replacements) => {
    if (!lang2) {
      throw new MissingAppProviderError("I18n");
    }
    return i18n.translate(id, replacements);
  };
  return { translate };
}
const _hoisted_1$1I = ["id"];
const _sfc_main$3n = /* @__PURE__ */ defineComponent({
  setup(__props) {
    const scrollToPosition = inject("scrollableContext", () => false);
    const anchorNode = ref(null);
    const { useUniqueId } = UseUniqueId();
    const id = useUniqueId("ScrollTo");
    onMounted(() => {
      if (!scrollToPosition || !anchorNode.value) {
        return;
      }
      scrollToPosition(anchorNode.value.offsetTop);
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("a", {
        id: unref(id),
        ref_key: "anchorNode",
        ref: anchorNode
      }, null, 8, _hoisted_1$1I);
    };
  }
});
const _hoisted_1$1H = ["href", "target", "rel"];
const _sfc_main$3m = /* @__PURE__ */ defineComponent({
  props: {
    to: null,
    url: null,
    external: { type: Boolean }
  },
  setup(__props) {
    return (_ctx, _cache) => {
      const _component_router_link = resolveComponent("router-link");
      return __props.to ? (openBlock(), createBlock(_component_router_link, {
        key: 0,
        to: __props.to
      }, {
        default: withCtx(() => [
          renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }, 8, ["to"])) : (openBlock(), createElementBlock("a", {
        key: 1,
        href: __props.url,
        target: __props.to ? "_blank" : void 0,
        rel: __props.external ? "noopener noreferrer" : void 0
      }, [
        renderSlot(_ctx.$slots, "default")
      ], 8, _hoisted_1$1H));
    };
  }
});
const __default__$m = {
  inheritAttrs: false
};
const _sfc_main$3l = /* @__PURE__ */ defineComponent(__spreadProps(__spreadValues({}, __default__$m), {
  props: {
    id: null,
    content: null,
    url: null,
    external: { type: Boolean },
    badge: null,
    destructive: { type: Boolean },
    disabled: { type: Boolean },
    icon: null,
    accessibilityLabel: null,
    helpText: null,
    image: null,
    prefixId: null,
    suffixId: null,
    ellipsis: { type: Boolean },
    active: { type: Boolean },
    role: null,
    onAction: null,
    onMouseEnter: null,
    onTouchStart: null
  },
  setup(__props) {
    const props = __props;
    const contentText = computed(() => props.ellipsis && props.content ? `${props.content}\u2026` : props.content);
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("span", {
        class: normalizeClass(unref(styles$21).Content)
      }, [
        __props.prefixId ? (openBlock(), createElementBlock("span", {
          key: 0,
          class: normalizeClass(unref(styles$21).Prefix)
        }, [
          renderSlot(_ctx.$slots, "prefix")
        ], 2)) : __props.icon ? (openBlock(), createElementBlock("span", {
          key: 1,
          class: normalizeClass(unref(styles$21).Prefix)
        }, [
          createVNode(unref(_sfc_main$2K), { source: __props.icon }, null, 8, ["source"])
        ], 2)) : __props.image ? (openBlock(), createElementBlock("span", {
          key: 2,
          class: normalizeClass(unref(styles$21).Prefix),
          role: "presentation",
          style: normalizeStyle({ backgroundImage: `url(${__props.image}` })
        }, null, 6)) : createCommentVNode("", true),
        createElementVNode("span", {
          class: normalizeClass(unref(styles$21).Text)
        }, [
          __props.helpText ? (openBlock(), createElementBlock("span", {
            key: 0,
            class: normalizeClass(unref(styles$21).ContentBlock)
          }, [
            createElementVNode("span", {
              class: normalizeClass(unref(styles$21).ContentBlockInner)
            }, toDisplayString(unref(contentText)), 3),
            createVNode(unref(Text), {
              variant: "bodyMd",
              color: "subdued",
              as: "span"
            }, {
              default: withCtx(() => [
                createTextVNode(toDisplayString(__props.helpText), 1)
              ]),
              _: 1
            })
          ], 2)) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
            createTextVNode(toDisplayString(unref(contentText)), 1)
          ], 64))
        ], 2),
        __props.badge ? (openBlock(), createElementBlock("span", {
          key: 3,
          class: normalizeClass(unref(styles$21).Suffix)
        }, [
          createVNode(unref(_sfc_main$2Y), {
            status: __props.badge.status
          }, {
            default: withCtx(() => [
              createTextVNode(toDisplayString(__props.badge.content), 1)
            ]),
            _: 1
          }, 8, ["status"])
        ], 2)) : createCommentVNode("", true),
        __props.suffixId ? (openBlock(), createElementBlock("span", {
          key: 4,
          class: normalizeClass(unref(styles$21).Suffix)
        }, [
          renderSlot(_ctx.$slots, "suffix")
        ], 2)) : createCommentVNode("", true)
      ], 2);
    };
  }
}));
const _hoisted_1$1G = ["id", "disabled", "aria-label", "role"];
const __default__$l = {
  inheritAttrs: false
};
const _sfc_main$3k = /* @__PURE__ */ defineComponent(__spreadProps(__spreadValues({}, __default__$l), {
  props: {
    id: null,
    content: null,
    url: null,
    external: { type: Boolean },
    badge: null,
    destructive: { type: Boolean },
    disabled: { type: Boolean },
    icon: null,
    accessibilityLabel: null,
    helpText: null,
    image: null,
    prefixId: null,
    suffixId: null,
    ellipsis: { type: Boolean },
    active: { type: Boolean },
    role: null,
    onAction: null,
    onMouseEnter: null,
    onTouchStart: null
  },
  emits: ["action"],
  setup(__props, { emit }) {
    const props = __props;
    const className = computed(() => classNames(styles$21.Item, props.disabled && styles$21.disabled, props.destructive && styles$21.destructive, props.active && styles$21.active));
    const contentElementProps = computed(() => ({
      badge: props.badge,
      content: props.content,
      helpText: props.helpText,
      icon: props.icon,
      prefixId: props.prefixId,
      suffixId: props.suffixId,
      image: props.image,
      disabled: props.disabled,
      ellipsis: props.ellipsis,
      role: props.role
    }));
    computed(() => props.role === "menuitem" ? "presentation" : void 0);
    const onClick = () => {
      if (!props.disabled) {
        emit("action");
      }
    };
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock(Fragment, null, [
        __props.active ? (openBlock(), createBlock(unref(_sfc_main$3n), { key: 0 })) : createCommentVNode("", true),
        __props.url ? (openBlock(), createBlock(unref(_sfc_main$3m), {
          key: 1,
          id: __props.id,
          url: __props.disabled ? void 0 : __props.url,
          class: normalizeClass(unref(className)),
          external: __props.external,
          "aria-label": __props.accessibilityLabel,
          role: __props.role,
          onClick
        }, {
          default: withCtx(() => [
            createVNode(_sfc_main$3l, normalizeProps(guardReactiveProps(unref(contentElementProps))), {
              suffix: withCtx(() => [
                renderSlot(_ctx.$slots, "suffix")
              ]),
              prefix: withCtx(() => [
                renderSlot(_ctx.$slots, "prefix")
              ]),
              _: 3
            }, 16)
          ]),
          _: 3
        }, 8, ["id", "url", "class", "external", "aria-label", "role"])) : (openBlock(), createElementBlock("button", {
          key: 2,
          id: __props.id,
          type: "button",
          class: normalizeClass(unref(className)),
          disabled: __props.disabled,
          "aria-label": __props.accessibilityLabel,
          role: __props.role,
          onClick,
          onMouseup: _cache[0] || (_cache[0] = (...args) => unref(handleMouseUpByBlurring) && unref(handleMouseUpByBlurring)(...args))
        }, [
          createVNode(_sfc_main$3l, normalizeProps(guardReactiveProps(unref(contentElementProps))), {
            suffix: withCtx(() => [
              renderSlot(_ctx.$slots, "suffix")
            ]),
            prefix: withCtx(() => [
              renderSlot(_ctx.$slots, "prefix")
            ]),
            _: 3
          }, 16)
        ], 42, _hoisted_1$1G))
      ], 64);
    };
  }
}));
const _hoisted_1$1F = ["role", "tabIndex"];
const _hoisted_2$_ = ["role"];
const __default__$k = {
  inheritAttrs: false
};
const _sfc_main$3j = /* @__PURE__ */ defineComponent(__spreadProps(__spreadValues({}, __default__$k), {
  props: {
    section: null,
    hasMultipleSections: { type: Boolean },
    actionRole: null
  },
  emits: ["action-any-item"],
  setup(__props, { emit }) {
    const props = __props;
    const className = computed(() => props.section.title ? void 0 : styles$21["Section-withoutTitle"]);
    const sectionRole = computed(() => {
      let sectionRoleValue;
      switch (props.actionRole) {
        case "option":
          sectionRoleValue = "presentation";
          break;
        case "menuitem":
          sectionRoleValue = !props.hasMultipleSections ? "menu" : "presentation";
          break;
        default:
          sectionRoleValue = void 0;
          break;
      }
      return sectionRoleValue;
    });
    const handleAction = (onAction) => {
      if (onAction) {
        onAction();
      }
      emit("action-any-item");
    };
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(unref(className))
      }, [
        __props.section.title ? (openBlock(), createBlock(unref(_sfc_main$2V), {
          key: 0,
          "padding-block-start": "4",
          "padding-inline-start": "4",
          "padding-block-end": "2",
          "padding-inline-end": "4"
        }, {
          default: withCtx(() => [
            createVNode(unref(Text), {
              as: "p",
              variant: "headingXs"
            }, {
              default: withCtx(() => [
                createTextVNode(toDisplayString(__props.section.title), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        })) : createCommentVNode("", true),
        createElementVNode("ul", {
          class: normalizeClass(unref(styles$21).Actions),
          role: unref(sectionRole),
          tabIndex: !__props.hasMultipleSections ? -1 : void 0
        }, [
          (openBlock(true), createElementBlock(Fragment, null, renderList(__props.section.items, (_a, index) => {
            var _b = _a, { content, helpText, onAction } = _b, item = __objRest(_b, ["content", "helpText", "onAction"]);
            return openBlock(), createElementBlock("li", {
              key: `${content}-${index}`,
              role: __props.actionRole === "menuitem" ? "presentation" : void 0
            }, [
              createVNode(unref(_sfc_main$3k), mergeProps({
                content,
                helpText,
                role: __props.actionRole
              }, __spreadValues({}, item), {
                onAction: ($event) => handleAction(onAction)
              }), createSlots({ _: 2 }, [
                item.prefixId ? {
                  name: "prefix",
                  fn: withCtx(() => [
                    renderSlot(_ctx.$slots, `prefix-${item.prefixId}`)
                  ])
                } : void 0,
                item.suffixId ? {
                  name: "suffix",
                  fn: withCtx(() => [
                    renderSlot(_ctx.$slots, `suffix-${item.suffixId}`)
                  ])
                } : void 0
              ]), 1040, ["content", "helpText", "role", "onAction"])
            ], 8, _hoisted_2$_);
          }), 128))
        ], 10, _hoisted_1$1F)
      ], 2);
    };
  }
}));
const __default__$j = {
  inheritAttrs: false
};
const _sfc_main$3i = /* @__PURE__ */ defineComponent(__spreadProps(__spreadValues({}, __default__$j), {
  props: {
    section: null,
    hasMultipleSections: { type: Boolean },
    actionRole: null
  },
  emits: ["action-any-item"],
  setup(__props, { emit }) {
    const props = __props;
    const sectionMarkupProps = computed(() => {
      const { section, hasMultipleSections, actionRole } = props;
      return {
        section,
        hasMultipleSections,
        actionRole
      };
    });
    return (_ctx, _cache) => {
      return __props.hasMultipleSections ? (openBlock(), createElementBlock("li", {
        key: 0,
        class: normalizeClass(unref(styles$21).Section),
        role: "presentation"
      }, [
        createVNode(_sfc_main$3j, mergeProps(unref(sectionMarkupProps), {
          onActionAnyItem: _cache[0] || (_cache[0] = ($event) => emit("action-any-item"))
        }), createSlots({ _: 2 }, [
          renderList(__props.section.items, ({ prefixId }) => {
            return {
              name: `prefix-${prefixId}`,
              fn: withCtx(() => [
                renderSlot(_ctx.$slots, `prefix-${prefixId}`)
              ])
            };
          }),
          renderList(__props.section.items, ({ suffixId }) => {
            return {
              name: `suffix-${suffixId}`,
              fn: withCtx(() => [
                renderSlot(_ctx.$slots, `suffix-${suffixId}`)
              ])
            };
          })
        ]), 1040)
      ], 2)) : (openBlock(), createBlock(_sfc_main$3j, mergeProps({ key: 1 }, unref(sectionMarkupProps), {
        onActionAnyItem: _cache[1] || (_cache[1] = ($event) => emit("action-any-item"))
      }), createSlots({ _: 2 }, [
        renderList(__props.section.items, ({ prefixId }) => {
          return {
            name: `prefix-${prefixId}`,
            fn: withCtx(() => [
              renderSlot(_ctx.$slots, `prefix-${prefixId}`)
            ])
          };
        }),
        renderList(__props.section.items, ({ suffixId }) => {
          return {
            name: `suffix-${suffixId}`,
            fn: withCtx(() => [
              renderSlot(_ctx.$slots, `suffix-${suffixId}`)
            ])
          };
        })
      ]), 1040));
    };
  }
}));
var ActionList_vue_vue_type_style_index_0_lang = "";
const __default__$i = {
  inheritAttrs: false
};
const _sfc_main$3h = /* @__PURE__ */ defineComponent(__spreadProps(__spreadValues({}, __default__$i), {
  props: {
    items: { default: void 0 },
    sections: { default: () => [] },
    actionRole: { default: void 0 }
  },
  emits: ["action-any-item"],
  setup(__props, { emit }) {
    const props = __props;
    const actionListRef = ref(null);
    const finalSections = computed(() => {
      if (props.items) {
        return [{ items: props.items }, ...props.sections];
      }
      if (props.sections) {
        return props.sections;
      }
      return [];
    });
    const hasMultipleSections = computed(() => finalSections.value.length > 1);
    const element = computed(() => hasMultipleSections.value ? "ul" : "div");
    const elementRole = computed(() => hasMultipleSections.value && props.actionRole === "menuitem" ? "menu" : void 0);
    const elementTabIndex = computed(() => hasMultipleSections.value && props.actionRole === "menuitem" ? -1 : void 0);
    const handleFocusPreviousItem = (evt) => {
      evt.preventDefault();
      const target = evt.target;
      if (actionListRef.value && target) {
        if (actionListRef.value.contains(target)) {
          wrapFocusPreviousFocusableMenuItem(actionListRef.value, target);
        }
      }
    };
    const handleFocusNextItem = (evt) => {
      evt.preventDefault();
      const target = evt.target;
      if (actionListRef.value && target) {
        if (actionListRef.value.contains(target)) {
          wrapFocusNextFocusableMenuItem(actionListRef.value, target);
        }
      }
    };
    return (_ctx, _cache) => {
      return openBlock(), createBlock(resolveDynamicComponent(unref(element)), {
        ref_key: "actionListRef",
        ref: actionListRef,
        role: unref(elementRole),
        class: normalizeClass(unref(classNames)(unref(styles$21).ActionList)),
        tabIndex: unref(elementTabIndex)
      }, {
        default: withCtx(() => [
          (openBlock(true), createElementBlock(Fragment, null, renderList(unref(finalSections), (section, index) => {
            return openBlock(), createElementBlock(Fragment, null, [
              section.items && section.items.length > 0 ? (openBlock(), createBlock(unref(_sfc_main$3i), {
                key: section.title || index,
                section,
                hasMultipleSections: unref(hasMultipleSections),
                actionRole: __props.actionRole,
                onActionAnyItem: _cache[0] || (_cache[0] = ($event) => emit("action-any-item"))
              }, createSlots({ _: 2 }, [
                renderList(section.items, ({ prefixId }) => {
                  return {
                    name: `prefix-${prefixId}`,
                    fn: withCtx(() => [
                      renderSlot(_ctx.$slots, `prefix-${prefixId}`)
                    ])
                  };
                }),
                renderList(section.items, ({ suffixId }) => {
                  return {
                    name: `suffix-${suffixId}`,
                    fn: withCtx(() => [
                      renderSlot(_ctx.$slots, `suffix-${suffixId}`)
                    ])
                  };
                })
              ]), 1032, ["section", "hasMultipleSections", "actionRole"])) : createCommentVNode("", true)
            ], 64);
          }), 256)),
          __props.actionRole === "menuitem" ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
            createVNode(unref(_sfc_main$3p), {
              keyEvent: "keydown",
              keyCode: unref(Key).ArrowDown,
              handler: handleFocusNextItem
            }, null, 8, ["keyCode"]),
            createVNode(unref(_sfc_main$3p), {
              keyEvent: "keydown",
              keyCode: unref(Key).ArrowUp,
              handler: handleFocusPreviousItem
            }, null, 8, ["keyCode"])
          ], 64)) : createCommentVNode("", true)
        ]),
        _: 3
      }, 8, ["role", "class", "tabIndex"]);
    };
  }
}));
const ActionMenu = "Polaris-ActionMenu";
var styles$1$ = {
  ActionMenu
};
const ActionsLayout = "Polaris-ActionMenu-Actions__ActionsLayout";
var styles$1_ = {
  ActionsLayout
};
const Details$2 = "Polaris-ActionMenu-MenuGroup__Details";
var styles$1Z = {
  Details: Details$2
};
const SecondaryAction$3 = "Polaris-ActionMenu-SecondaryAction";
const destructive$2 = "Polaris-ActionMenu-SecondaryAction--destructive";
var styles$1Y = {
  SecondaryAction: SecondaryAction$3,
  destructive: destructive$2
};
var SecondaryAction_vue_vue_type_style_index_0_lang = "";
const _sfc_main$3g = /* @__PURE__ */ defineComponent({
  props: {
    id: null,
    url: null,
    external: { type: Boolean },
    download: { type: [String, Boolean] },
    submit: { type: Boolean },
    disabled: { type: Boolean },
    loading: { type: Boolean },
    pressed: { type: Boolean },
    accessibilityLabel: null,
    role: null,
    ariaControls: null,
    ariaExpanded: { type: Boolean },
    ariaDescribedBy: null,
    primary: { type: Boolean },
    destructive: { type: Boolean },
    helpText: null,
    size: null,
    textAlign: null,
    outline: { type: Boolean },
    fullWidth: { type: Boolean },
    disclosure: { type: [String, Boolean] },
    plain: { type: Boolean },
    monochrome: { type: Boolean },
    removeUnderline: { type: Boolean },
    icon: null,
    connectedDisclosure: null
  },
  emits: ["click", "get-offset-width"],
  setup(__props, { emit: emits }) {
    const props = __props;
    const secondaryActionsRef = ref(null);
    const slots = useSlots();
    const className = computed(() => {
      return classNames(styles$1Y.SecondaryAction, props.destructive && styles$1Y.destructive);
    });
    onMounted(() => {
      var _a;
      onGetOffsetWidth(((_a = secondaryActionsRef.value) == null ? void 0 : _a.offsetWidth) || 0);
    });
    const onGetOffsetWidth = (width) => {
      if (secondaryActionsRef.value) {
        emits("get-offset-width", width);
      }
    };
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("span", {
        class: normalizeClass(unref(className)),
        ref_key: "secondaryActionsRef",
        ref: secondaryActionsRef
      }, [
        __props.helpText || unref(hasSlot)(unref(slots).helpText) ? (openBlock(), createBlock(unref(_sfc_main$f), {
          key: 0,
          content: __props.helpText || ""
        }, createSlots({
          default: withCtx(() => [
            createVNode(unref(_sfc_main$2F), mergeProps(props, {
              onClick: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("click"))
            }), {
              default: withCtx(() => [
                renderSlot(_ctx.$slots, "default")
              ]),
              _: 3
            }, 16)
          ]),
          _: 2
        }, [
          unref(hasSlot)(unref(slots).helpText) ? {
            name: "content",
            fn: withCtx(() => [
              renderSlot(_ctx.$slots, "helpText")
            ])
          } : void 0
        ]), 1032, ["content"])) : (openBlock(), createBlock(unref(_sfc_main$2F), mergeProps({ key: 1 }, props, {
          onClick: _cache[1] || (_cache[1] = ($event) => _ctx.$emit("click"))
        }), {
          default: withCtx(() => [
            renderSlot(_ctx.$slots, "default")
          ]),
          _: 3
        }, 16))
      ], 2);
    };
  }
});
var MenuGroup_vue_vue_type_style_index_0_lang = "";
const __default__$h = {
  inheritAttrs: false
};
const _sfc_main$3f = /* @__PURE__ */ defineComponent(__spreadProps(__spreadValues({}, __default__$h), {
  props: {
    badge: null,
    title: null,
    actions: null,
    icon: null,
    index: null,
    accessibilityLabel: null,
    active: { type: Boolean },
    sections: null
  },
  emits: ["click", "open", "close", "get-offset-width"],
  setup(__props, { emit: emits }) {
    const props = __props;
    const slots = useSlots();
    const handleClose = () => {
      emits("close", props.title);
    };
    const handleClick = () => {
      emits("click");
      emits("open", props.title);
    };
    const handleOffsetWidth = (width) => {
      emits("get-offset-width", width);
    };
    return (_ctx, _cache) => {
      return __props.actions.length ? (openBlock(), createBlock(unref(_sfc_main$2L), {
        key: 0,
        active: Boolean(__props.active),
        "preferred-alignment": "left",
        hideOnPrint: "",
        onClose: handleClose
      }, {
        activator: withCtx(() => [
          createVNode(unref(_sfc_main$3g), {
            disclosure: true,
            icon: __props.icon,
            accessibilityLabel: __props.accessibilityLabel,
            onClick: handleClick,
            onGetOffsetWidth: handleOffsetWidth
          }, {
            default: withCtx(() => [
              createTextVNode(toDisplayString(__props.title), 1)
            ]),
            _: 1
          }, 8, ["icon", "accessibilityLabel"])
        ]),
        content: withCtx(() => [
          createVNode(unref(_sfc_main$3h), {
            items: __props.actions,
            sections: __props.sections,
            onActionAnyItem: handleClose
          }, null, 8, ["items", "sections"]),
          unref(slots).default ? (openBlock(), createElementBlock("div", {
            key: 0,
            class: normalizeClass(unref(styles$1Z).Details)
          }, [
            renderSlot(_ctx.$slots, "default")
          ], 2)) : createCommentVNode("", true)
        ]),
        _: 3
      }, 8, ["active"])) : createCommentVNode("", true);
    };
  }
}));
var Actions_vue_vue_type_style_index_0_lang = "";
const _sfc_main$3e = /* @__PURE__ */ defineComponent({
  props: {
    actions: null,
    groups: null
  },
  emits: ["action-rollup"],
  setup(__props, { emit: emits }) {
    const props = __props;
    const ACTION_SPACING = 8;
    const i18n = UseI18n();
    const actionsLayoutRef = ref(null);
    const menuGroupWidth = ref(0);
    const availableWidth = ref(0);
    const actionsAndGroupsLength = ref(0);
    const timesMeasured = ref(0);
    const actionWidths = ref([]);
    const rollupActiveRef = ref(null);
    const activeMenuGroup = ref(null);
    const measuredActions = ref({
      showable: [],
      rolledUp: []
    });
    const defaultRollupGroup = ref({
      title: i18n.translate("Polaris.ActionMenu.Actions.moreActions"),
      actions: []
    });
    const lastMenuGroup = computed(() => {
      if (props.groups && props.groups.length) {
        return [...props.groups].pop();
      }
      return [];
    });
    const lastMenuGroupWidth = computed(() => [...actionWidths.value].pop() || 0);
    const handleActionsOffsetWidth = (width) => {
      actionWidths.value = [...actionWidths.value, width];
    };
    const handleMenuGroupToggle = (group) => {
      if (activeMenuGroup.value) {
        activeMenuGroup.value = null;
      } else {
        activeMenuGroup.value = group;
      }
    };
    const handleMenuGroupClose = () => {
      activeMenuGroup.value = null;
    };
    const combinedGroups = computed(() => {
      if (props.groups) {
        return [...props.groups, defaultRollupGroup.value];
      }
      return [defaultRollupGroup.value];
    });
    const filteredGroups = computed(() => {
      return combinedGroups.value.filter((group) => {
        return props.groups && props.groups.length === 0 ? group : group === lastMenuGroup.value || !measuredActions.value.rolledUp.some((rolledUpGroup) => isMenuGroup(rolledUpGroup) && rolledUpGroup.title === group.title);
      });
    });
    const isDefaultGroup = (group) => group === defaultRollupGroup.value;
    const isLastMenuGroup = (group) => group === lastMenuGroup.value;
    const finalRolledUp = computed(() => {
      return measuredActions.value.rolledUp.reduce(([actions, sections], action) => {
        if (isMenuGroup(action)) {
          sections.push({
            title: action.title,
            items: action.actions.map((sectionAction) => __spreadProps(__spreadValues({}, sectionAction), {
              disabled: action.disabled || sectionAction.disabled
            }))
          });
        } else {
          actions.push(action);
        }
        return [actions, sections];
      }, [[], []]);
    });
    const finalRolledUpActions = computed(() => finalRolledUp.value[0]);
    const finalRolledUpSectionGroups = computed(() => finalRolledUp.value[1]);
    const menuGroupProps = (group) => {
      const _a = group, { actions } = _a, rest = __objRest(_a, ["actions"]);
      return __spreadProps(__spreadValues({}, rest), {
        active: activeMenuGroup.value === group.title,
        sections: finalRolledUpSectionGroups.value
      });
    };
    const getMenuGroupActions = (group) => {
      if (!isDefaultGroup(group) && !isLastMenuGroup(group)) {
        return group.actions;
      }
      if (!isDefaultGroup(group) && isLastMenuGroup(group)) {
        return [...finalRolledUpActions.value, ...group.actions];
      }
      if (isDefaultGroup(group) && (!props.groups || props.groups.length === 0) && finalRolledUpActions.value.length) {
        return finalRolledUpActions.value;
      }
      return [];
    };
    const updateActions = () => {
      let actionsAndGroups = [...props.actions || [], ...props.groups || []];
      if (props.groups && props.groups.length > 0) {
        actionsAndGroups = [...actionsAndGroups].slice(0, actionsAndGroups.length - 1);
      }
      const showable = actionsAndGroups.slice(0, measuredActions.value.showable.length);
      const rolledUp = actionsAndGroups.slice(measuredActions.value.showable.length, actionsAndGroups.length);
      measuredActions.value = {
        showable,
        rolledUp
      };
    };
    onUpdated(() => {
      updateActions();
      if (!actionsLayoutRef.value) {
        return;
      }
      availableWidth.value = actionsLayoutRef.value.offsetWidth;
      if (timesMeasured.value >= 2 && [...props.actions || [], ...props.groups || []].length === actionsAndGroupsLength.value) {
        updateActions();
        return;
      }
      measureActions();
    });
    const measureActions = () => {
      if (actionWidths.value.length === 0 || availableWidth.value === 0) {
        return;
      }
      const actionsAndGroups = [...props.actions || [], ...props.groups || []];
      if (actionsAndGroups.length === 1) {
        measuredActions.value = {
          showable: actionsAndGroups,
          rolledUp: []
        };
        return;
      }
      let currentAvailableWidth = availableWidth.value;
      let newShowableActions = [];
      let newRolledUpActions = [];
      actionsAndGroups.forEach((action, index) => {
        const canFitAction = actionWidths.value[index] + menuGroupWidth.value + ACTION_SPACING + lastMenuGroupWidth.value <= currentAvailableWidth;
        if (canFitAction) {
          currentAvailableWidth -= actionWidths.value[index] + ACTION_SPACING * 2;
          newShowableActions = [...newShowableActions, action];
        } else {
          currentAvailableWidth = 0;
          if (action === lastMenuGroup.value) {
            return;
          }
          newRolledUpActions = [...newRolledUpActions, action];
        }
      });
      const isRollupActive = newShowableActions.length < actionsAndGroups.length - 1;
      if (rollupActiveRef.value !== isRollupActive) {
        emits("action-rollup", isRollupActive);
        rollupActiveRef.value = isRollupActive;
      }
      measuredActions.value = {
        showable: newShowableActions,
        rolledUp: newRolledUpActions
      };
      timesMeasured.value += 1;
      actionsAndGroupsLength.value = actionsAndGroups.length;
    };
    const handleResize = () => {
      debounce(() => {
        if (!actionsLayoutRef.value) {
          return;
        }
        availableWidth.value = actionsLayoutRef.value.offsetWidth;
        timesMeasured.value = 0;
        measureActions();
      }, 50, { leading: false, trailing: true });
    };
    function isMenuGroup(actionOrMenuGroup) {
      return "title" in actionOrMenuGroup;
    }
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        ref_key: "actionsLayoutRef",
        ref: actionsLayoutRef,
        class: normalizeClass(unref(styles$1_).ActionsLayout)
      }, [
        createVNode(unref(_sfc_main$2C), { spacing: "extraTight" }, {
          default: withCtx(() => [
            measuredActions.value.showable.length > 0 ? (openBlock(true), createElementBlock(Fragment, { key: 0 }, renderList(measuredActions.value.showable, (action) => {
              return openBlock(), createElementBlock(Fragment, {
                key: action.content
              }, [
                action.content ? (openBlock(), createBlock(unref(_sfc_main$3g), mergeProps({ key: 0 }, action, { onGetOffsetWidth: handleActionsOffsetWidth }), {
                  default: withCtx(() => [
                    createTextVNode(toDisplayString(action.content), 1)
                  ]),
                  _: 2
                }, 1040)) : createCommentVNode("", true)
              ], 64);
            }), 128)) : createCommentVNode("", true),
            (openBlock(true), createElementBlock(Fragment, null, renderList(__props.actions, (action) => {
              return openBlock(), createElementBlock(Fragment, {
                key: action.content
              }, [
                !measuredActions.value.showable.length && !measuredActions.value.rolledUp.includes(action) ? (openBlock(), createBlock(unref(_sfc_main$3g), mergeProps({ key: 0 }, action, {
                  onClick: ($event) => action.onAction ? action.onAction() : void 0,
                  onGetOffsetWidth: handleActionsOffsetWidth
                }), {
                  default: withCtx(() => [
                    createTextVNode(toDisplayString(action.content), 1)
                  ]),
                  _: 2
                }, 1040, ["onClick"])) : createCommentVNode("", true)
              ], 64);
            }), 128)),
            (openBlock(true), createElementBlock(Fragment, null, renderList(unref(filteredGroups), (group) => {
              return openBlock(), createBlock(unref(_sfc_main$3f), mergeProps({
                key: group.title
              }, menuGroupProps(group), {
                actions: getMenuGroupActions(group),
                onOpen: handleMenuGroupToggle,
                onClose: handleMenuGroupClose,
                onGetOffsetWidth: handleActionsOffsetWidth
              }), null, 16, ["actions"]);
            }), 128))
          ]),
          _: 1
        }),
        createVNode(unref(_sfc_main$33), {
          event: "resize",
          handler: handleResize
        })
      ], 2);
    };
  }
});
const _hoisted_1$1E = {
  viewBox: "0 0 20 20",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$Z = /* @__PURE__ */ createElementVNode("path", { d: "M6 10a2 2 0 1 1-4.001-.001A2 2 0 0 1 6 10zm6 0a2 2 0 1 1-4.001-.001A2 2 0 0 1 12 10zm6 0a2 2 0 1 1-4.001-.001A2 2 0 0 1 18 10z" }, null, -1);
const _hoisted_3$H = [
  _hoisted_2$Z
];
function render$v(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1$1E, _hoisted_3$H);
}
var HorizontalDotsMinor = { render: render$v };
const RollupActivator = "Polaris-ActionMenu-RollupActions__RollupActivator";
var styles$1X = {
  RollupActivator
};
var RollupActions_vue_vue_type_style_index_0_lang = "";
const _sfc_main$3d = /* @__PURE__ */ defineComponent({
  props: {
    accessibilityLabel: null,
    items: null,
    sections: null
  },
  setup(__props) {
    const i18n = UseI18n();
    const rollupOpen = ref(false);
    const toggleRollupOpen = () => {
      rollupOpen.value = !rollupOpen.value;
    };
    return (_ctx, _cache) => {
      var _a, _b;
      return ((_a = __props.items) == null ? void 0 : _a.length) || ((_b = __props.sections) == null ? void 0 : _b.length) ? (openBlock(), createBlock(unref(_sfc_main$2L), {
        key: 0,
        active: rollupOpen.value,
        preferredAlignment: "right",
        onClose: toggleRollupOpen,
        hideOnPrint: ""
      }, {
        activator: withCtx(() => [
          createElementVNode("div", {
            class: normalizeClass(unref(styles$1X).RollupActivator)
          }, [
            createVNode(unref(_sfc_main$2F), {
              outline: "",
              icon: unref(HorizontalDotsMinor),
              accessibilityLabel: __props.accessibilityLabel || unref(i18n).translate("Polaris.ActionMenu.RollupActions.rollupButton"),
              onClick: toggleRollupOpen
            }, null, 8, ["icon", "accessibilityLabel"])
          ], 2)
        ]),
        content: withCtx(() => [
          createVNode(unref(_sfc_main$3h), {
            items: __props.items,
            sections: __props.sections,
            onActionAnyItem: toggleRollupOpen
          }, null, 8, ["items", "sections"])
        ]),
        _: 1
      }, 8, ["active"])) : createCommentVNode("", true);
    };
  }
});
var ActionMenu_vue_vue_type_style_index_0_lang = "";
const __default__$g = {
  inheritAttrs: false
};
const _sfc_main$3c = /* @__PURE__ */ defineComponent(__spreadProps(__spreadValues({}, __default__$g), {
  props: {
    actions: null,
    groups: null,
    rollup: { type: Boolean },
    rollupActionsLabel: null
  },
  emits: ["action-rollup"],
  setup(__props, { emit: emits }) {
    const props = __props;
    const actionMenuClassNames = computed(() => {
      return classNames(styles$1$.ActionMenu);
    });
    const rollupSections = computed(() => {
      return (props.groups || []).map((group) => convertGroupToSection(group));
    });
    const onActionRollUp = (hasRolledUp) => {
      emits("action-rollup", hasRolledUp);
    };
    function convertGroupToSection({
      title,
      actions,
      disabled: disabled2
    }) {
      return {
        title,
        items: actions.map((action) => __spreadProps(__spreadValues({}, action), {
          disabled: disabled2 || action.disabled
        }))
      };
    }
    return (_ctx, _cache) => {
      return __props.actions && __props.actions.length || __props.groups && __props.groups.length ? (openBlock(), createElementBlock("div", {
        key: 0,
        class: normalizeClass(unref(actionMenuClassNames))
      }, [
        __props.rollup ? (openBlock(), createBlock(unref(_sfc_main$3d), {
          key: 0,
          accessibilityLabel: __props.rollupActionsLabel,
          items: __props.actions,
          sections: unref(rollupSections)
        }, null, 8, ["accessibilityLabel", "items", "sections"])) : (openBlock(), createBlock(unref(_sfc_main$3e), {
          key: 1,
          actions: __props.actions,
          groups: __props.groups,
          onActionRollup: onActionRollUp
        }, null, 8, ["actions", "groups"]))
      ], 2)) : createCommentVNode("", true);
    };
  }
}));
const _sfc_main$3b = /* @__PURE__ */ defineComponent({
  props: {
    background: { default: "surface" },
    padding: { default: "5" },
    roundedAbove: null
  },
  setup(__props) {
    const props = __props;
    const hasBorderRadius = computed(() => {
      if (props.roundedAbove && breakpoints[`${props.roundedAbove}Up`]) {
        return true;
      }
      return !props.roundedAbove;
    });
    return (_ctx, _cache) => {
      return openBlock(), createBlock(unref(_sfc_main$2V), {
        background: __props.background,
        padding: __props.padding,
        shadow: "card",
        "border-radius": unref(hasBorderRadius) ? "2" : void 0
      }, {
        default: withCtx(() => [
          renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }, 8, ["background", "padding", "border-radius"]);
    };
  }
});
const AlphaStack = "Polaris-AlphaStack";
const listReset = "Polaris-AlphaStack--listReset";
const fullWidth$8 = "Polaris-AlphaStack--fullWidth";
var styles$1W = {
  AlphaStack,
  listReset,
  fullWidth: fullWidth$8
};
var AlphaStack_vue_vue_type_style_index_0_lang = "";
const _sfc_main$3a = /* @__PURE__ */ defineComponent({
  props: {
    as: { default: "div" },
    align: { default: "start" },
    fullWidth: { type: Boolean },
    spacing: { default: "4" }
  },
  setup(__props) {
    const props = __props;
    const className = computed(() => classNames(styles$1W.AlphaStack, props.fullWidth && styles$1W.fullWidth, props.as === "ul" && styles$1W.listReset));
    const style2 = computed(() => {
      return __spreadValues({
        "--pc-stack-align": props.align ? `${props.align}` : ""
      }, getResponsiveProps("stack", "spacing", "space", props.spacing));
    });
    return (_ctx, _cache) => {
      return openBlock(), createBlock(resolveDynamicComponent(__props.as), {
        class: normalizeClass(unref(className)),
        style: normalizeStyle(unref(style2))
      }, {
        default: withCtx(() => [
          renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }, 8, ["class", "style"]);
    };
  }
});
const SCROLL_LOCKING_ATTRIBUTE = "data-lock-scrolling";
const SCROLL_LOCKING_HIDDEN_ATTRIBUTE = "data-lock-scrolling-hidden";
const SCROLL_LOCKING_WRAPPER_ATTRIBUTE = "data-lock-scrolling-wrapper";
let scrollPosition = 0;
function isScrollBarVisible() {
  const { body } = document;
  return body.scrollHeight > body.clientHeight;
}
class ScrollLockManager {
  constructor() {
    this.scrollLocks = 0;
    this.locked = false;
  }
  registerScrollLock() {
    this.scrollLocks += 1;
    this.handleScrollLocking();
  }
  unregisterScrollLock() {
    this.scrollLocks -= 1;
    this.handleScrollLocking();
  }
  handleScrollLocking() {
    if (isServer)
      return;
    const { scrollLocks } = this;
    const { body } = document;
    const wrapper = body.firstElementChild;
    if (scrollLocks === 0) {
      body.removeAttribute(SCROLL_LOCKING_ATTRIBUTE);
      body.removeAttribute(SCROLL_LOCKING_HIDDEN_ATTRIBUTE);
      if (wrapper) {
        wrapper.removeAttribute(SCROLL_LOCKING_WRAPPER_ATTRIBUTE);
      }
      window.scroll(0, scrollPosition);
      this.locked = false;
    } else if (scrollLocks > 0 && !this.locked) {
      scrollPosition = window.pageYOffset;
      body.setAttribute(SCROLL_LOCKING_ATTRIBUTE, "");
      if (!isScrollBarVisible()) {
        body.setAttribute(SCROLL_LOCKING_HIDDEN_ATTRIBUTE, "");
      }
      if (wrapper) {
        wrapper.setAttribute(SCROLL_LOCKING_WRAPPER_ATTRIBUTE, "");
        wrapper.scrollTop = scrollPosition;
      }
      this.locked = true;
    }
  }
  resetScrollPosition() {
    scrollPosition = 0;
  }
}
class UniqueIdFactory {
  constructor(idGeneratorFactory) {
    this.idGenerators = {};
    this.idGeneratorFactory = idGeneratorFactory;
  }
  nextId(prefix) {
    if (!this.idGenerators[prefix]) {
      this.idGenerators[prefix] = this.idGeneratorFactory(prefix);
    }
    return this.idGenerators[prefix]();
  }
}
function globalIdGeneratorFactory(prefix = "") {
  let index = 1;
  return () => `Polaris${prefix}${index++}`;
}
function merge(...objs) {
  let final = {};
  for (const obj of objs) {
    final = mergeRecursively(final, obj);
  }
  return final;
}
function mergeRecursively(inputObjA, objB) {
  const objA = Array.isArray(inputObjA) ? [...inputObjA] : __spreadValues({}, inputObjA);
  for (const key in objB) {
    if (!Object.prototype.hasOwnProperty.call(objB, key)) {
      continue;
    } else if (isMergeableValue(objB[key]) && isMergeableValue(objA[key])) {
      objA[key] = mergeRecursively(objA[key], objB[key]);
    } else {
      objA[key] = objB[key];
    }
  }
  return objA;
}
function isMergeableValue(value2) {
  return value2 !== null && typeof value2 === "object";
}
const OBJECT_NOTATION_MATCHER = /\[(.*?)\]|(\w+)/g;
function get(obj, keypath, defaultValue) {
  if (obj == null) {
    return void 0;
  }
  const keys = Array.isArray(keypath) ? keypath : getKeypath(keypath);
  let acc = obj;
  for (let i = 0; i < keys.length; i++) {
    const val = acc[keys[i]];
    if (val === void 0) {
      return defaultValue;
    }
    acc = val;
  }
  return acc;
}
function getKeypath(str) {
  const path = [];
  let result;
  while (result = OBJECT_NOTATION_MATCHER.exec(str)) {
    const [, first2, second] = result;
    path.push(first2 || second);
  }
  return path;
}
const REPLACE_REGEX = /{([^}]*)}/g;
class I18n {
  constructor(translation) {
    __publicField(this, "translation", {});
    this.translation = Array.isArray(translation) ? merge(...translation.slice().reverse()) : translation;
  }
  translate(id, replacements) {
    const text = get(this.translation, id, "");
    if (!text) {
      return "";
    }
    if (replacements) {
      return text.replace(REPLACE_REGEX, (match) => {
        const replacement = match.substring(1, match.length - 1);
        if (replacements[replacement] === void 0) {
          const replacementData = JSON.stringify(replacements);
          throw new Error(`Error in translation for key '${id}'. No replacement found for key '${replacement}'. The following replacements were passed: '${replacementData}'`);
        }
        return replacements[replacement];
      });
    }
    return text;
  }
  translationKeyExists(path) {
    return Boolean(get(this.translation, path));
  }
}
const Polaris = {
  ActionMenu: {
    Actions: {
      moreActions: "More actions"
    },
    RollupActions: {
      rollupButton: "View actions"
    }
  },
  Avatar: {
    label: "Avatar",
    labelWithInitials: "Avatar with initials {initials}"
  },
  Autocomplete: {
    spinnerAccessibilityLabel: "Loading",
    ellipsis: "{content}\u2026"
  },
  Badge: {
    PROGRESS_LABELS: {
      incomplete: "Incomplete",
      partiallyComplete: "Partially complete",
      complete: "Complete"
    },
    STATUS_LABELS: {
      info: "Info",
      success: "Success",
      warning: "Warning",
      critical: "Critical",
      attention: "Attention",
      "new": "New"
    },
    progressAndStatus: "{statusLabel} {progressLabel}"
  },
  Button: {
    spinnerAccessibilityLabel: "Loading",
    connectedDisclosureAccessibilityLabel: "Related actions"
  },
  Common: {
    checkbox: "checkbox",
    undo: "Undo",
    cancel: "Cancel",
    clear: "Clear",
    close: "Close",
    submit: "Submit",
    more: "More"
  },
  ContextualSaveBar: {
    save: "Save",
    discard: "Discard"
  },
  DataTable: {
    sortAccessibilityLabel: "sort {direction} by",
    navAccessibilityLabel: "Scroll table {direction} one column",
    totalsRowHeading: "Totals",
    totalRowHeading: "Total"
  },
  DatePicker: {
    previousMonth: "Show previous month, {previousMonthName} {showPreviousYear}",
    nextMonth: "Show next month, {nextMonth} {nextYear}",
    today: "Today ",
    start: "Start of range",
    end: "End of range",
    months: {
      january: "January",
      february: "February",
      march: "March",
      april: "April",
      may: "May",
      june: "June",
      july: "July",
      august: "August",
      september: "September",
      october: "October",
      november: "November",
      december: "December"
    },
    days: {
      monday: "Monday",
      tuesday: "Tuesday",
      wednesday: "Wednesday",
      thursday: "Thursday",
      friday: "Friday",
      saturday: "Saturday",
      sunday: "Sunday"
    },
    daysAbbreviated: {
      monday: "Mo",
      tuesday: "Tu",
      wednesday: "We",
      thursday: "Th",
      friday: "Fr",
      saturday: "Sa",
      sunday: "Su"
    }
  },
  DiscardConfirmationModal: {
    title: "Discard all unsaved changes",
    message: "If you discard changes, you\u2019ll delete any edits you made since you last saved.",
    primaryAction: "Discard changes",
    secondaryAction: "Continue editing"
  },
  DropZone: {
    single: {
      overlayTextFile: "Drop file to upload",
      overlayTextImage: "Drop image to upload",
      overlayTextVideo: "Drop video to upload",
      actionTitleFile: "Add file",
      actionTitleImage: "Add image",
      actionTitleVideo: "Add video",
      actionHintFile: "or drop file to upload",
      actionHintImage: "or drop image to upload",
      actionHintVideo: "or drop video to upload",
      labelFile: "Upload file",
      labelImage: "Upload image",
      labelVideo: "Upload video"
    },
    allowMultiple: {
      overlayTextFile: "Drop files to upload",
      overlayTextImage: "Drop images to upload",
      overlayTextVideo: "Drop videos to upload",
      actionTitleFile: "Add files",
      actionTitleImage: "Add images",
      actionTitleVideo: "Add videos",
      actionHintFile: "or drop files to upload",
      actionHintImage: "or drop images to upload",
      actionHintVideo: "or drop videos to upload",
      labelFile: "Upload files",
      labelImage: "Upload images",
      labelVideo: "Upload videos"
    },
    errorOverlayTextFile: "File type is not valid",
    errorOverlayTextImage: "Image type is not valid",
    errorOverlayTextVideo: "Video type is not valid"
  },
  EmptySearchResult: {
    altText: "Empty search results"
  },
  Frame: {
    skipToContent: "Skip to content",
    navigationLabel: "Navigation",
    Navigation: {
      closeMobileNavigationLabel: "Close navigation"
    }
  },
  FullscreenBar: {
    back: "Back",
    accessibilityLabel: "Exit fullscreen mode"
  },
  Filters: {
    moreFilters: "More filters",
    moreFiltersWithCount: "More filters ({count})",
    filter: "Filter {resourceName}",
    noFiltersApplied: "No filters applied",
    cancel: "Cancel",
    done: "Done",
    clearAllFilters: "Clear all filters",
    clear: "Clear",
    clearLabel: "Clear {filterName}"
  },
  IndexProvider: {
    defaultItemSingular: "Item",
    defaultItemPlural: "Items",
    allItemsSelected: "All {itemsLength}+ {resourceNamePlural} are selected.",
    selected: "{selectedItemsCount} selected",
    a11yCheckboxDeselectAllSingle: "Deselect {resourceNameSingular}",
    a11yCheckboxSelectAllSingle: "Select {resourceNameSingular}",
    a11yCheckboxDeselectAllMultiple: "Deselect all {itemsLength} {resourceNamePlural}",
    a11yCheckboxSelectAllMultiple: "Select all {itemsLength} {resourceNamePlural}"
  },
  IndexTable: {
    emptySearchTitle: "No {resourceNamePlural} found",
    emptySearchDescription: "Try changing the filters or search term",
    onboardingBadgeText: "New",
    resourceLoadingAccessibilityLabel: "Loading {resourceNamePlural}\u2026",
    selectAllLabel: "Select all {resourceNamePlural}",
    selected: "{selectedItemsCount} selected",
    undo: "Undo",
    selectAllItems: "Select all {itemsLength}+ {resourceNamePlural}",
    selectItem: "Select {resourceName}",
    selectButtonText: "Select",
    sortAccessibilityLabel: "sort {direction} by"
  },
  Loading: {
    label: "Page loading bar"
  },
  Modal: {
    iFrameTitle: "body markup",
    modalWarning: "These required properties are missing from Modal: {missingProps}"
  },
  Page: {
    Header: {
      rollupActionsLabel: "View actions for {title}"
    }
  },
  Pagination: {
    previous: "Previous",
    next: "Next",
    pagination: "Pagination"
  },
  ProgressBar: {
    negativeWarningMessage: "Values passed to the progress prop shouldn\u2019t be negative. Resetting {progress} to 0.",
    exceedWarningMessage: "Values passed to the progress prop shouldn\u2019t exceed 100. Setting {progress} to 100."
  },
  ResourceList: {
    sortingLabel: "Sort by",
    defaultItemSingular: "item",
    defaultItemPlural: "items",
    showing: "Showing {itemsCount} {resource}",
    showingTotalCount: "Showing {itemsCount} of {totalItemsCount} {resource}",
    loading: "Loading {resource}",
    selected: "{selectedItemsCount} selected",
    allItemsSelected: "All {itemsLength}+ {resourceNamePlural} in your store are selected.",
    allFilteredItemsSelected: "All {itemsLength}+ {resourceNamePlural} in this filter are selected.",
    selectAllItems: "Select all {itemsLength}+ {resourceNamePlural} in your store",
    selectAllFilteredItems: "Select all {itemsLength}+ {resourceNamePlural} in this filter",
    emptySearchResultTitle: "No {resourceNamePlural} found",
    emptySearchResultDescription: "Try changing the filters or search term",
    selectButtonText: "Select",
    a11yCheckboxDeselectAllSingle: "Deselect {resourceNameSingular}",
    a11yCheckboxSelectAllSingle: "Select {resourceNameSingular}",
    a11yCheckboxDeselectAllMultiple: "Deselect all {itemsLength} {resourceNamePlural}",
    a11yCheckboxSelectAllMultiple: "Select all {itemsLength} {resourceNamePlural}",
    ariaLiveSingular: "{itemsLength} item",
    ariaLivePlural: "{itemsLength} items",
    Item: {
      actionsDropdownLabel: "Actions for {accessibilityLabel}",
      actionsDropdown: "Actions dropdown",
      viewItem: "View details for {itemName}"
    },
    BulkActions: {
      actionsActivatorLabel: "Actions",
      moreActionsActivatorLabel: "More actions",
      warningMessage: "To provide a better user experience. There should only be a maximum of {maxPromotedActions} promoted actions."
    }
  },
  SkeletonPage: {
    loadingLabel: "Page loading"
  },
  Tabs: {
    toggleTabsLabel: "More tabs"
  },
  Tag: {
    ariaLabel: "Remove {children}"
  },
  TextField: {
    characterCount: "{count} characters",
    characterCountWithMaxLength: "{count} of {limit} characters used"
  },
  TooltipOverlay: {
    accessibilityLabel: "Tooltip: {label}"
  },
  TopBar: {
    toggleMenuLabel: "Toggle menu",
    SearchField: {
      clearButtonLabel: "Clear",
      search: "Search"
    }
  },
  MediaCard: {
    popoverButton: "Actions"
  },
  VideoThumbnail: {
    playButtonA11yLabel: {
      "default": "Play video",
      defaultWithDuration: "Play video of length {duration}",
      duration: {
        hours: {
          other: {
            only: "{hourCount} hours",
            andMinutes: "{hourCount} hours and {minuteCount} minutes",
            andMinute: "{hourCount} hours and {minuteCount} minute",
            minutesAndSeconds: "{hourCount} hours, {minuteCount} minutes, and {secondCount} seconds",
            minutesAndSecond: "{hourCount} hours, {minuteCount} minutes, and {secondCount} second",
            minuteAndSeconds: "{hourCount} hours, {minuteCount} minute, and {secondCount} seconds",
            minuteAndSecond: "{hourCount} hours, {minuteCount} minute, and {secondCount} second",
            andSeconds: "{hourCount} hours and {secondCount} seconds",
            andSecond: "{hourCount} hours and {secondCount} second"
          },
          one: {
            only: "{hourCount} hour",
            andMinutes: "{hourCount} hour and {minuteCount} minutes",
            andMinute: "{hourCount} hour and {minuteCount} minute",
            minutesAndSeconds: "{hourCount} hour, {minuteCount} minutes, and {secondCount} seconds",
            minutesAndSecond: "{hourCount} hour, {minuteCount} minutes, and {secondCount} second",
            minuteAndSeconds: "{hourCount} hour, {minuteCount} minute, and {secondCount} seconds",
            minuteAndSecond: "{hourCount} hour, {minuteCount} minute, and {secondCount} second",
            andSeconds: "{hourCount} hour and {secondCount} seconds",
            andSecond: "{hourCount} hour and {secondCount} second"
          }
        },
        minutes: {
          other: {
            only: "{minuteCount} minutes",
            andSeconds: "{minuteCount} minutes and {secondCount} seconds",
            andSecond: "{minuteCount} minutes and {secondCount} second"
          },
          one: {
            only: "{minuteCount} minute",
            andSeconds: "{minuteCount} minute and {secondCount} seconds",
            andSecond: "{minuteCount} minute and {secondCount} second"
          }
        },
        seconds: {
          other: "{secondCount} seconds",
          one: "{secondCount} second"
        }
      }
    }
  }
};
var lang = {
  Polaris
};
class PortalManager {
  constructor() {
    __publicField(this, "portalIds", []);
  }
  register(id) {
    if (!this.portalIds.includes(id)) {
      this.portalIds.push(id);
    }
  }
  hasContainer() {
    return this.portalIds.length;
  }
}
class FocusManager {
  constructor() {
    __publicField(this, "trapFocusList", []);
  }
  add(id) {
    this.trapFocusList = [...this.trapFocusList, id];
  }
  remove(id) {
    const index = this.trapFocusList.indexOf(id);
    if (index > -1) {
      this.trapFocusList = this.trapFocusList.splice(index, 1);
    }
    return index > -1;
  }
}
var style = "";
var AppProvider_vue_vue_type_style_index_0_lang = "";
const _hoisted_1$1D = { class: "polaris-app-provider" };
const _hoisted_2$Y = /* @__PURE__ */ createElementVNode("div", { id: "PolarisPortalsContainer" }, null, -1);
const _sfc_main$39 = /* @__PURE__ */ defineComponent({
  setup(__props) {
    const stickyManager = new StickyManager();
    const scrollLockManager = new ScrollLockManager();
    const portalManager = new PortalManager();
    const uniqueIdFactory = ref(new UniqueIdFactory(globalIdGeneratorFactory));
    const focusManager = new FocusManager();
    const isNavigationCollapsed = ref(navigationBarCollapsed().matches);
    const setBodyStyles = () => {
      document.body.style.backgroundColor = "var(--p-background)";
      document.body.style.color = "var(--p-text)";
    };
    const handleResize = debounce(() => {
      if (isNavigationCollapsed.value !== navigationBarCollapsed().matches) {
        isNavigationCollapsed.value = !isNavigationCollapsed.value;
      }
    }, 40, { trailing: true, leading: true, maxWait: 40 });
    onMounted(() => {
      if (document !== null) {
        setBodyStyles();
        stickyManager.setContainer(document);
      }
    });
    const i18n = new I18n(lang);
    provide("mediaQueryContext", { isNavigationCollapsed: isNavigationCollapsed.value });
    provide("stickyManagerContext", stickyManager);
    provide("scrollLockManager", scrollLockManager);
    provide("portalManager", portalManager);
    provide("uniqueIdFactory", uniqueIdFactory.value);
    provide("focusManager", focusManager);
    provide("lang", lang);
    provide("i18n", i18n);
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1$1D, [
        createVNode(unref(_sfc_main$33), {
          event: "resize",
          handler: unref(handleResize)
        }, null, 8, ["handler"]),
        renderSlot(_ctx.$slots, "default"),
        _hoisted_2$Y,
        (openBlock(), createBlock(resolveDynamicComponent("style"), null, {
          default: withCtx(() => [
            createTextVNode(toDisplayString(unref(style)), 1)
          ]),
          _: 1
        }))
      ]);
    };
  }
});
var AutoSelection = /* @__PURE__ */ ((AutoSelection2) => {
  AutoSelection2["FirstSelected"] = "FIRST_SELECTED";
  AutoSelection2["First"] = "FIRST";
  AutoSelection2["None"] = "NONE";
  return AutoSelection2;
})(AutoSelection || {});
const ActionContainer$2 = "Polaris-Autocomplete-MappedAction__ActionContainer";
const Action$8 = "Polaris-Autocomplete-MappedAction__Action";
const destructive$1 = "Polaris-Autocomplete-MappedAction--destructive";
const selected$3 = "Polaris-Autocomplete-MappedAction--selected";
const disabled$b = "Polaris-Autocomplete-MappedAction--disabled";
const Prefix$4 = "Polaris-Autocomplete-MappedAction__Prefix";
const Suffix$3 = "Polaris-Autocomplete-MappedAction__Suffix";
const Content$e = "Polaris-Autocomplete-MappedAction__Content";
const Text$7 = "Polaris-Autocomplete-MappedAction__Text";
const ContentWrap = "Polaris-Autocomplete-MappedAction__ContentWrap";
var styles$1V = {
  ActionContainer: ActionContainer$2,
  Action: Action$8,
  destructive: destructive$1,
  selected: selected$3,
  disabled: disabled$b,
  Prefix: Prefix$4,
  Suffix: Suffix$3,
  Content: Content$e,
  Text: Text$7,
  ContentWrap
};
var MappedAction_vue_vue_type_style_index_0_lang = "";
const _sfc_main$38 = /* @__PURE__ */ defineComponent({
  props: {
    active: { type: Boolean },
    content: null,
    disabled: { type: Boolean },
    icon: null,
    image: null,
    ellipsis: { type: Boolean },
    role: null,
    url: null,
    external: { type: Boolean },
    destructive: { type: Boolean },
    badge: null,
    wrapOverflow: { type: Boolean, default: false },
    onAction: null
  },
  setup(__props) {
    const props = __props;
    const slots = useSlots();
    const i18n = UseI18n();
    const actionClassNames = computed(() => classNames(styles$1V.Action, props.disabled && styles$1V.disabled, props.destructive && styles$1V.destructive, props.active && styles$1V.selected));
    const contentOverflowStyle = computed(() => props.wrapOverflow ? styles$1V.ContentWrap : void 0);
    provide("MappedActionContext", {
      role: props.role,
      url: props.url,
      external: props.external,
      destructive: props.destructive,
      onAction: props.onAction
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(unref(styles$1V).ActionContainer)
      }, [
        createVNode(unref(_sfc_main$1e), {
          selected: __props.active,
          disabled: __props.disabled,
          value: __props.content || ""
        }, {
          default: withCtx(() => [
            createElementVNode("div", {
              class: normalizeClass(unref(actionClassNames))
            }, [
              createElementVNode("div", {
                class: normalizeClass(unref(styles$1V).Content)
              }, [
                unref(hasSlot)(unref(slots).prefix) ? (openBlock(), createElementBlock("div", {
                  key: 0,
                  class: normalizeClass(unref(styles$1V).Prefix)
                }, [
                  renderSlot(_ctx.$slots, "prefix")
                ], 2)) : __props.icon ? (openBlock(), createElementBlock("div", {
                  key: 1,
                  class: normalizeClass(unref(styles$1V).Prefix)
                }, [
                  createVNode(unref(_sfc_main$2K), { source: __props.icon }, null, 8, ["source"])
                ], 2)) : __props.image ? (openBlock(), createElementBlock("div", {
                  key: 2,
                  role: "presentation",
                  class: normalizeClass(unref(styles$1V).Prefix),
                  style: normalizeStyle({ backgroundImage: `url(${__props.image})` })
                }, null, 6)) : createCommentVNode("", true),
                createElementVNode("div", {
                  class: normalizeClass(unref(styles$1V).Text)
                }, [
                  createElementVNode("div", {
                    class: normalizeClass(unref(contentOverflowStyle))
                  }, [
                    __props.ellipsis && __props.content ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
                      createTextVNode(toDisplayString(unref(i18n).translate("Polaris.Autocomplete.ellipsis", { content: __props.content })), 1)
                    ], 64)) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
                      createTextVNode(toDisplayString(__props.content), 1)
                    ], 64))
                  ], 2),
                  unref(hasSlot)(unref(slots).helpText) ? (openBlock(), createBlock(unref(Text), {
                    key: 0,
                    variant: "bodyMd",
                    color: "subdued",
                    as: "span"
                  }, {
                    default: withCtx(() => [
                      renderSlot(_ctx.$slots, "helpText")
                    ]),
                    _: 3
                  })) : createCommentVNode("", true)
                ], 2),
                __props.badge ? (openBlock(), createElementBlock("span", {
                  key: 3,
                  class: normalizeClass(unref(styles$1V).Suffix)
                }, [
                  createVNode(unref(_sfc_main$2Y), {
                    status: __props.badge.status
                  }, {
                    default: withCtx(() => [
                      createTextVNode(toDisplayString(__props.badge.content), 1)
                    ]),
                    _: 1
                  }, 8, ["status"])
                ], 2)) : createCommentVNode("", true),
                unref(hasSlot)(unref(slots).suffix) ? (openBlock(), createElementBlock("span", {
                  key: 4,
                  class: normalizeClass(unref(styles$1V).Suffix)
                }, [
                  renderSlot(_ctx.$slots, "suffix")
                ], 2)) : createCommentVNode("", true)
              ], 2)
            ], 2)
          ]),
          _: 3
        }, 8, ["selected", "disabled", "value"])
      ], 2);
    };
  }
});
const Content$d = "Polaris-Autocomplete-MappedOption__Content";
const Media$2 = "Polaris-Autocomplete-MappedOption__Media";
const singleSelectionMedia = "Polaris-Autocomplete-MappedOption--singleSelectionMedia";
const disabledMedia = "Polaris-Autocomplete-MappedOption--disabledMedia";
var styles$1U = {
  Content: Content$d,
  Media: Media$2,
  singleSelectionMedia,
  disabledMedia
};
var MappedOption_vue_vue_type_style_index_0_lang = "";
const _sfc_main$37 = /* @__PURE__ */ defineComponent({
  props: {
    label: null,
    value: null,
    disabled: { type: Boolean },
    selected: { type: Boolean },
    singleSelection: { type: Boolean }
  },
  setup(__props) {
    const props = __props;
    const slots = useSlots();
    const mediaClassNames = computed(() => classNames(styles$1U.Media, props.disabled && styles$1U.disabledMedia, props.singleSelection && styles$1U.singleSelectionMedia));
    const accessibilityLabel = computed(() => typeof props.label === "string" ? props.label : void 0);
    return (_ctx, _cache) => {
      return openBlock(), createBlock(unref(_sfc_main$1f), {
        accessibilityLabel: unref(accessibilityLabel),
        key: __props.value,
        selected: __props.selected,
        value: __props.value,
        disabled: __props.disabled
      }, {
        default: withCtx(() => [
          createVNode(unref(_sfc_main$1g), {
            selected: __props.selected,
            disabled: __props.disabled
          }, {
            default: withCtx(() => [
              createElementVNode("div", {
                class: normalizeClass(unref(styles$1U).Content)
              }, [
                unref(hasSlot)(unref(slots).media) ? (openBlock(), createElementBlock("div", {
                  key: 0,
                  class: normalizeClass(unref(mediaClassNames))
                }, [
                  renderSlot(_ctx.$slots, "media")
                ], 2)) : createCommentVNode("", true),
                createTextVNode(toDisplayString(__props.label), 1)
              ], 2)
            ]),
            _: 3
          }, 8, ["selected", "disabled"])
        ]),
        _: 3
      }, 8, ["accessibilityLabel", "selected", "value", "disabled"]);
    };
  }
});
const Loading$2 = "Polaris-Autocomplete__Loading";
const SectionWrapper = "Polaris-Autocomplete__SectionWrapper";
var styles$1T = {
  Loading: Loading$2,
  SectionWrapper
};
var Autocomplete_vue_vue_type_style_index_0_lang = "";
const _hoisted_1$1C = {
  key: 3,
  role: "status"
};
const _sfc_main$36 = /* @__PURE__ */ defineComponent({
  props: {
    id: null,
    options: null,
    modelValue: null,
    preferredPosition: null,
    listTitle: null,
    allowMultiple: { type: Boolean },
    actionBefore: null,
    loading: { type: Boolean },
    willLoadMoreResults: { type: Boolean }
  },
  emits: ["select", "update:modelValue", "load-more-results"],
  setup(__props, { emit: emits }) {
    const props = __props;
    const slots = useSlots();
    const i18n = UseI18n();
    const autoSelection = computed(() => props.actionBefore ? AutoSelection.First : void 0);
    const conditionalOptions = computed(() => props.loading && !props.willLoadMoreResults ? [] : props.options);
    const sectionOptions = computed(() => {
      return conditionalOptions.value;
    });
    const optionDescriptorOptions = computed(() => {
      return conditionalOptions.value;
    });
    const noOptionsAvailable = computed(() => {
      const tmpConditional = conditionalOptions.value.some((opt) => opt && opt.options.length !== 0);
      return !tmpConditional;
    });
    const isShowAction = computed(() => !!props.actionBefore);
    const isShowOptions = computed(() => {
      if (isSection(conditionalOptions.value)) {
        if (noOptionsAvailable.value) {
          return false;
        } else {
          return true;
        }
      }
      if (props.listTitle) {
        return true;
      }
      if (conditionalOptions.value.length > 0) {
        return true;
      }
      return false;
    });
    const isShowEmptyState = computed(() => {
      return hasSlot(slots.emptyState) && props.options.length < 1 && !props.loading;
    });
    const updateSelection = (newSelection) => {
      if (props.actionBefore && newSelection === props.actionBefore.content) {
        props.actionBefore.onAction && props.actionBefore.onAction();
        return;
      }
      if (props.allowMultiple) {
        if (props.modelValue.includes(newSelection)) {
          emits("select", props.modelValue.filter((option) => option !== newSelection));
          emits("update:modelValue", props.modelValue.filter((option) => option !== newSelection));
        } else {
          emits("select", [...props.modelValue, newSelection]);
          emits("update:modelValue", [...props.modelValue, newSelection]);
        }
      } else {
        emits("select", [newSelection]);
        emits("update:modelValue", [newSelection]);
      }
    };
    const isSection = (options) => {
      const tmpOptions = options;
      return tmpOptions[0] && typeof tmpOptions[0] === "object" && tmpOptions[0].options !== void 0;
    };
    return (_ctx, _cache) => {
      return openBlock(), createBlock(unref(_sfc_main$35), {
        allowMultiple: __props.allowMultiple,
        preferredPosition: __props.preferredPosition,
        willLoadMoreOptions: __props.willLoadMoreResults,
        onScrolledToBottom: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("load-more-results"))
      }, {
        activator: withCtx(() => [
          renderSlot(_ctx.$slots, "textField")
        ]),
        default: withCtx(() => [
          unref(isShowAction) || unref(isShowOptions) || __props.loading || unref(isShowEmptyState) ? (openBlock(), createBlock(unref(_sfc_main$1h), {
            key: 0,
            "auto-selection": unref(autoSelection),
            onSelect: updateSelection
          }, {
            default: withCtx(() => [
              unref(isShowAction) ? (openBlock(), createBlock(unref(_sfc_main$38), normalizeProps(mergeProps({ key: 0 }, __props.actionBefore)), createSlots({ _: 2 }, [
                unref(hasSlot)(unref(slots)["action-prefix"]) ? {
                  name: "prefix",
                  fn: withCtx(() => [
                    renderSlot(_ctx.$slots, "action-prefix")
                  ])
                } : void 0,
                unref(hasSlot)(unref(slots)["action-suffix"]) ? {
                  name: "suffix",
                  fn: withCtx(() => [
                    renderSlot(_ctx.$slots, "action-suffix")
                  ])
                } : void 0,
                unref(hasSlot)(unref(slots)["action-helpText"]) ? {
                  name: "helpText",
                  fn: withCtx(() => [
                    renderSlot(_ctx.$slots, "action-helpText")
                  ])
                } : void 0
              ]), 1040)) : createCommentVNode("", true),
              unref(isShowOptions) && (!__props.loading || __props.willLoadMoreResults) ? (openBlock(), createElementBlock(Fragment, { key: 1 }, [
                isSection(unref(conditionalOptions)) && !unref(noOptionsAvailable) ? (openBlock(), createElementBlock("div", {
                  key: 0,
                  class: normalizeClass(unref(styles$1T).SectionWrapper)
                }, [
                  (openBlock(true), createElementBlock(Fragment, null, renderList(unref(sectionOptions), (opt) => {
                    return openBlock(), createElementBlock(Fragment, {
                      key: opt.title
                    }, [
                      opt.options.length > 0 ? (openBlock(), createBlock(unref(_sfc_main$1b), {
                        key: 0,
                        divider: false
                      }, {
                        title: withCtx(() => [
                          createVNode(unref(_sfc_main$1d), null, {
                            default: withCtx(() => [
                              createTextVNode(toDisplayString(opt.title), 1)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        default: withCtx(() => [
                          (openBlock(true), createElementBlock(Fragment, null, renderList(opt.options, (option) => {
                            return openBlock(), createBlock(unref(_sfc_main$37), mergeProps({
                              key: option.id || option.value
                            }, option, {
                              selected: __props.modelValue.includes(option.value),
                              singleSelection: !__props.allowMultiple
                            }), createSlots({ _: 2 }, [
                              unref(hasSlot)(unref(slots)[`option-media-${option.id}`]) ? {
                                name: "media",
                                fn: withCtx(() => [
                                  renderSlot(_ctx.$slots, `option-media-${option.id}`)
                                ])
                              } : void 0
                            ]), 1040, ["selected", "singleSelection"]);
                          }), 128))
                        ]),
                        _: 2
                      }, 1024)) : createCommentVNode("", true)
                    ], 64);
                  }), 128))
                ], 2)) : __props.listTitle ? (openBlock(), createBlock(unref(_sfc_main$1b), {
                  key: 1,
                  divider: false
                }, {
                  title: withCtx(() => [
                    createVNode(unref(_sfc_main$1d), null, {
                      default: withCtx(() => [
                        createTextVNode(toDisplayString(__props.listTitle), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  default: withCtx(() => [
                    unref(conditionalOptions).length > 0 ? (openBlock(true), createElementBlock(Fragment, { key: 0 }, renderList(unref(optionDescriptorOptions), (option) => {
                      return openBlock(), createBlock(unref(_sfc_main$37), mergeProps({
                        key: option.id || option.value
                      }, option, {
                        selected: __props.modelValue.includes(option.value),
                        singleSelection: !__props.allowMultiple
                      }), createSlots({ _: 2 }, [
                        unref(hasSlot)(unref(slots)[`option-media-${option.id}`]) ? {
                          name: "media",
                          fn: withCtx(() => [
                            renderSlot(_ctx.$slots, `option-media-${option.id}`)
                          ])
                        } : void 0
                      ]), 1040, ["selected", "singleSelection"]);
                    }), 128)) : createCommentVNode("", true)
                  ]),
                  _: 3
                })) : unref(conditionalOptions).length > 0 ? (openBlock(true), createElementBlock(Fragment, { key: 2 }, renderList(unref(optionDescriptorOptions), (option) => {
                  return openBlock(), createBlock(unref(_sfc_main$37), mergeProps({
                    key: option.id || option.value
                  }, option, {
                    selected: __props.modelValue.includes(option.value),
                    singleSelection: !__props.allowMultiple
                  }), createSlots({ _: 2 }, [
                    unref(hasSlot)(unref(slots)[`option-media-${option.id}`]) ? {
                      name: "media",
                      fn: withCtx(() => [
                        renderSlot(_ctx.$slots, `option-media-${option.id}`)
                      ])
                    } : void 0
                  ]), 1040, ["selected", "singleSelection"]);
                }), 128)) : createCommentVNode("", true)
              ], 64)) : createCommentVNode("", true),
              __props.loading ? (openBlock(), createBlock(unref(_sfc_main$1c), {
                key: 2,
                accessibilityLabel: unref(i18n).translate("Polaris.Autocomplete.spinnerAccessibilityLabel")
              }, null, 8, ["accessibilityLabel"])) : createCommentVNode("", true),
              unref(isShowEmptyState) ? (openBlock(), createElementBlock("div", _hoisted_1$1C, [
                renderSlot(_ctx.$slots, "emptyState")
              ])) : createCommentVNode("", true)
            ]),
            _: 3
          }, 8, ["auto-selection"])) : createCommentVNode("", true)
        ]),
        _: 3
      }, 8, ["allowMultiple", "preferredPosition", "willLoadMoreOptions"]);
    };
  }
});
const Listbox$1 = "Polaris-Combobox__Listbox";
var styles$1S = {
  Listbox: Listbox$1
};
var Combobox_vue_vue_type_style_index_0_lang = "";
const _sfc_main$35 = /* @__PURE__ */ defineComponent({
  props: {
    allowMultiple: { type: Boolean },
    preferredPosition: { default: "below" },
    willLoadMoreOptions: { type: Boolean },
    height: null
  },
  emits: ["close", "scrolled-to-bottom"],
  setup(__props, { emit: emits }) {
    const props = __props;
    provide("comboboxListboxOptionContext", { allowMultiple: props.allowMultiple });
    const popoverActive = ref(false);
    const activeOptionId = ref("");
    const textFieldLabelId = ref("");
    const listboxId = ref("");
    const textFieldFocused = ref(false);
    const popoverRef = ref(null);
    const slots = useSlots();
    const defaultSlot = computed(() => {
      var _a;
      return (_a = slots.default) == null ? void 0 : _a.call(slots);
    });
    const shouldOpen = computed(() => !popoverActive.value && defaultSlot);
    const willLoadMoreOptions = computed(() => props.willLoadMoreOptions);
    const handleClose = () => {
      popoverActive.value = false;
      emits("close");
      activeOptionId.value = "";
    };
    const handleOpen = () => {
      popoverActive.value = true;
      activeOptionId.value = "";
    };
    const onOptionSelected = () => {
      if (!props.allowMultiple) {
        handleClose();
        activeOptionId.value = "";
        return;
      }
    };
    const handleFocus = () => {
      if (shouldOpen.value) {
        handleOpen();
      }
    };
    const handleChange = () => {
      if (shouldOpen.value) {
        handleOpen();
      }
    };
    const handleBlur = () => {
      if (popoverActive.value) {
        handleClose();
      }
    };
    const setTextFieldFocused = (value2) => {
      textFieldFocused.value = value2;
    };
    const setTextFieldLabelId = (id) => {
      textFieldLabelId.value = id;
    };
    const setActiveOptionId = (id) => {
      activeOptionId.value = id;
    };
    const setListboxId = (id) => {
      listboxId.value = id;
    };
    const comboboxTextFieldContext = {
      activeOptionId,
      expanded: popoverActive,
      listboxId,
      setTextFieldFocused,
      setTextFieldLabelId,
      onTextFieldFocus: handleFocus,
      onTextFieldChange: handleChange,
      onTextFieldBlur: handleBlur
    };
    provide("comboboxTextFieldContext", comboboxTextFieldContext);
    const comboboxListboxContext = {
      listboxId,
      textFieldLabelId,
      textFieldFocused,
      willLoadMoreOptions,
      onOptionSelected,
      setActiveOptionId,
      setListboxId,
      onKeyToBottom: () => {
        emits("scrolled-to-bottom");
      }
    };
    provide("comboboxListboxContext", comboboxListboxContext);
    return (_ctx, _cache) => {
      return openBlock(), createBlock(unref(_sfc_main$2L), {
        ref_key: "popoverRef",
        ref: popoverRef,
        active: popoverActive.value,
        onClose: handleClose,
        autofocusTarget: "none",
        preventFocusOnClose: "",
        fullWidth: "",
        preferInputActivator: false,
        preferredPosition: __props.preferredPosition
      }, createSlots({ _: 2 }, [
        unref(slots).activator ? {
          name: "activator",
          fn: withCtx(() => [
            renderSlot(_ctx.$slots, "activator")
          ])
        } : void 0,
        unref(slots).default ? {
          name: "content",
          fn: withCtx(() => [
            createVNode(unref(_sfc_main$2O), {
              onScrolledToBottom: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("scrolled-to-bottom")),
              height: __props.height
            }, {
              default: withCtx(() => [
                createElementVNode("div", {
                  class: normalizeClass(unref(styles$1S).Listbox)
                }, [
                  renderSlot(_ctx.$slots, "default")
                ], 2)
              ]),
              _: 3
            }, 8, ["height"])
          ])
        } : void 0
      ]), 1032, ["active", "preferredPosition"]);
    };
  }
});
function labelID(id) {
  return `${id}Label`;
}
const TextField = "Polaris-TextField";
const multiline = "Polaris-TextField--multiline";
const Input$6 = "Polaris-TextField__Input";
const hasValue = "Polaris-TextField--hasValue";
const focus = "Polaris-TextField--focus";
const VerticalContent = "Polaris-TextField__VerticalContent";
const Backdrop$7 = "Polaris-TextField__Backdrop";
const error$5 = "Polaris-TextField--error";
const readOnly = "Polaris-TextField--readOnly";
const disabled$a = "Polaris-TextField--disabled";
const Prefix$3 = "Polaris-TextField__Prefix";
const suggestion = "Polaris-TextField--suggestion";
const Suffix$2 = "Polaris-TextField__Suffix";
const CharacterCount = "Polaris-TextField__CharacterCount";
const AlignFieldBottom = "Polaris-TextField__AlignFieldBottom";
const ClearButton = "Polaris-TextField__ClearButton";
const Spinner$4 = "Polaris-TextField__Spinner";
const SpinnerIcon = "Polaris-TextField__SpinnerIcon";
const Resizer = "Polaris-TextField__Resizer";
const DummyInput = "Polaris-TextField__DummyInput";
const Segment = "Polaris-TextField__Segment";
const monospaced = "Polaris-TextField--monospaced";
var styles$1R = {
  TextField,
  multiline,
  Input: Input$6,
  hasValue,
  focus,
  VerticalContent,
  Backdrop: Backdrop$7,
  error: error$5,
  readOnly,
  disabled: disabled$a,
  Prefix: Prefix$3,
  suggestion,
  "Input-hasClearButton": "Polaris-TextField__Input--hasClearButton",
  "Input-suffixed": "Polaris-TextField__Input--suffixed",
  "Input-alignRight": "Polaris-TextField__Input--alignRight",
  "Input-alignLeft": "Polaris-TextField__Input--alignLeft",
  "Input-alignCenter": "Polaris-TextField__Input--alignCenter",
  Suffix: Suffix$2,
  CharacterCount,
  AlignFieldBottom,
  ClearButton,
  Spinner: Spinner$4,
  SpinnerIcon,
  Resizer,
  DummyInput,
  Segment,
  monospaced
};
const _hoisted_1$1B = {
  viewBox: "0 0 20 20",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$X = /* @__PURE__ */ createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M10 2a8 8 0 1 0 0 16 8 8 0 0 0 0-16zM7.707 6.293a1 1 0 0 0-1.414 1.414L8.586 10l-2.293 2.293a1 1 0 1 0 1.414 1.414L10 11.414l2.293 2.293a1 1 0 1 0 1.414-1.414L11.414 10l2.293-2.293a1 1 0 0 0-1.414-1.414L10 8.586 7.707 6.293z"
}, null, -1);
const _hoisted_3$G = [
  _hoisted_2$X
];
function render$u(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1$1B, _hoisted_3$G);
}
var CircleCancelMinor = { render: render$u };
function errorID(id) {
  return `${id}Error`;
}
function helpTextID$1(id) {
  return `${id}HelpText`;
}
const _hoisted_1$1A = {
  viewBox: "0 0 20 20",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$W = /* @__PURE__ */ createElementVNode("path", { d: "M13.098 8H6.902c-.751 0-1.172.754-.708 1.268L9.292 12.7c.36.399 1.055.399 1.416 0l3.098-3.433C14.27 8.754 13.849 8 13.098 8Z" }, null, -1);
const _hoisted_3$F = [
  _hoisted_2$W
];
function render$t(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1$1A, _hoisted_3$F);
}
var CaretDownMinor = { render: render$t };
const _hoisted_1$1z = {
  viewBox: "0 0 20 20",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$V = /* @__PURE__ */ createElementVNode("path", { d: "M6.902 12h6.196c.751 0 1.172-.754.708-1.268L10.708 7.3c-.36-.399-1.055-.399-1.416 0l-3.098 3.433C5.73 11.246 6.151 12 6.902 12Z" }, null, -1);
const _hoisted_3$E = [
  _hoisted_2$V
];
function render$s(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1$1z, _hoisted_3$E);
}
var CaretUpMinor = { render: render$s };
const _sfc_main$34 = /* @__PURE__ */ defineComponent({
  emits: ["click", "change", "mouseup", "mousedown"],
  setup(__props, { expose, emit: emits }) {
    const elRef = ref(null);
    const handleClick = (e) => {
      emits("click", e);
    };
    const handleStep = (event, step) => {
      emits("change", step);
    };
    expose({ el: elRef });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        ref_key: "elRef",
        ref: elRef,
        "aria-hidden": true,
        class: normalizeClass(unref(styles$1R).Spinner),
        onClick: handleClick
      }, [
        createElementVNode("div", {
          role: "button",
          tabindex: "-1",
          class: normalizeClass(unref(styles$1R).Segment),
          onClick: _cache[0] || (_cache[0] = ($event) => handleStep($event, 1)),
          onMousedown: _cache[1] || (_cache[1] = ($event) => _ctx.$emit("mousedown")),
          onMouseup: _cache[2] || (_cache[2] = ($event) => _ctx.$emit("mouseup"))
        }, [
          createElementVNode("div", {
            class: normalizeClass(unref(styles$1R).SpinnerIcon)
          }, [
            createVNode(unref(_sfc_main$2K), { source: unref(CaretUpMinor) }, null, 8, ["source"])
          ], 2)
        ], 34),
        createElementVNode("div", {
          role: "button",
          tabindex: "-1",
          class: normalizeClass(unref(styles$1R).Segment),
          onClick: _cache[3] || (_cache[3] = ($event) => handleStep($event, -1)),
          onMousedown: _cache[4] || (_cache[4] = ($event) => _ctx.$emit("mousedown")),
          onMouseup: _cache[5] || (_cache[5] = ($event) => _ctx.$emit("mouseup"))
        }, [
          createElementVNode("div", {
            class: normalizeClass(unref(styles$1R).SpinnerIcon)
          }, [
            createVNode(unref(_sfc_main$2K), { source: unref(CaretDownMinor) }, null, 8, ["source"])
          ], 2)
        ], 34)
      ], 2);
    };
  }
});
const __default__$f = {
  inheritAttrs: false,
  render() {
    return null;
  }
};
const _sfc_main$33 = /* @__PURE__ */ defineComponent(__spreadProps(__spreadValues({}, __default__$f), {
  props: {
    event: { type: String, required: true },
    capture: { type: Boolean },
    passive: { type: Boolean },
    handler: { type: Function, required: true }
  },
  setup(__props) {
    const props = __props;
    function attachListener() {
      const { event, capture, passive, handler } = props;
      window.addEventListener(event, handler, { capture, passive });
    }
    function detachListener(prevProps) {
      const { event, handler, capture } = prevProps || props;
      window.removeEventListener(event, handler, capture);
    }
    watch(() => __spreadValues({}, props), (newProps, oldProps) => {
      if (newProps !== oldProps) {
        detachListener(oldProps);
        attachListener();
      }
    });
    onMounted(() => attachListener());
    onBeforeUnmount(() => detachListener());
    return () => {
    };
  }
}));
const _hoisted_1$1y = ["innerHTML"];
const _hoisted_2$U = ["innerHTML"];
const _sfc_main$32 = /* @__PURE__ */ defineComponent({
  props: {
    contents: null,
    currentHeight: null,
    minimumLines: null
  },
  emits: ["height-change"],
  setup(__props, { emit: emits }) {
    const props = __props;
    const ENTITIES_TO_REPLACE = {
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      "\n": "<br>",
      "\r": ""
    };
    const REPLACE_REGEX2 = new RegExp(`[${Object.keys(ENTITIES_TO_REPLACE).join()}]`, "g");
    const contentNode = ref(null);
    const minimumLinesNode = ref(null);
    const animationFrame = ref();
    const currentHeight = ref(props.currentHeight);
    const replaceEntity = (entity) => {
      return ENTITIES_TO_REPLACE[entity];
    };
    const getFinalContents = (contents) => {
      return contents ? `${contents.replace(REPLACE_REGEX2, replaceEntity)}<br>` : "<br>";
    };
    const getContentsForMinimumLines = (minimumLines) => {
      let content = "";
      for (let line = 0; line < minimumLines; line++) {
        content += "<br>";
      }
      return content;
    };
    const handleHeightCheck = () => {
      if (animationFrame.value) {
        cancelAnimationFrame(animationFrame.value);
      }
      animationFrame.value = requestAnimationFrame(() => {
        if (!contentNode.value || !minimumLinesNode.value) {
          return;
        }
        const newHeight = Math.max(contentNode.value.offsetHeight, minimumLinesNode.value.offsetHeight);
        if (newHeight !== currentHeight.value) {
          emits("height-change", newHeight);
        }
      });
    };
    onMounted(() => {
      if (animationFrame.value) {
        cancelAnimationFrame(animationFrame.value);
      }
    });
    onUpdated(() => {
      handleHeightCheck();
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        "aria-hidden": "true",
        class: normalizeClass(unref(styles$1R).Resizer)
      }, [
        createVNode(unref(_sfc_main$33), {
          event: "resize",
          handler: handleHeightCheck
        }),
        createElementVNode("div", {
          ref_key: "contentNode",
          ref: contentNode,
          class: normalizeClass(unref(styles$1R).DummyInput),
          innerHTML: getFinalContents(__props.contents)
        }, null, 10, _hoisted_1$1y),
        __props.minimumLines ? (openBlock(), createElementBlock("div", {
          key: 0,
          ref_key: "minimumLinesNode",
          ref: minimumLinesNode,
          class: normalizeClass(unref(styles$1R).DummyInput),
          innerHTML: getContentsForMinimumLines(__props.minimumLines)
        }, null, 10, _hoisted_2$U)) : createCommentVNode("", true)
      ], 2);
    };
  }
});
var TextField_vue_vue_type_style_index_0_lang = "";
const _hoisted_1$1x = ["id"];
const _hoisted_2$T = ["id"];
const _hoisted_3$D = ["id"];
const _hoisted_4$b = ["aria-live"];
const _hoisted_5$4 = ["disabled"];
const _sfc_main$31 = /* @__PURE__ */ defineComponent({
  props: {
    verticalContent: null,
    prefix: null,
    suffix: null,
    placeholder: null,
    modelValue: null,
    helpText: null,
    label: null,
    labelAction: null,
    labelHidden: { type: Boolean },
    disabled: { type: Boolean },
    clearButton: { type: Boolean },
    suggestion: null,
    readOnly: { type: Boolean },
    autoFocus: { type: Boolean },
    focused: { type: Boolean },
    multiline: { type: [Boolean, Number] },
    error: null,
    type: { default: "text" },
    name: null,
    id: null,
    role: null,
    step: null,
    autoComplete: { default: "off" },
    max: null,
    maxLength: null,
    maxHeight: null,
    min: null,
    minLength: null,
    pattern: null,
    inputMode: null,
    spellCheck: { type: Boolean },
    ariaOwns: null,
    ariaExpanded: { type: Boolean },
    ariaControls: null,
    ariaActiveDescendant: null,
    ariaAutocomplete: null,
    showCharacterCount: { type: Boolean },
    align: null,
    requiredIndicator: { type: Boolean },
    monospaced: { type: Boolean },
    selectTextOnFocus: { type: Boolean }
  },
  emits: ["focus", "blur", "change", "update:modelValue", "clear-button-click"],
  setup(__props, { emit: emits }) {
    const props = __props;
    const i18n = UseI18n();
    const inputRef = ref(null);
    const textAreaRef = ref(null);
    const prefixRef = ref(null);
    const suffixRef = ref(null);
    const verticalContentRef = ref(null);
    const slots = useSlots();
    const connectedLeftSlot = computed(() => {
      var _a;
      return (_a = slots["connected-left"]) == null ? void 0 : _a.call(slots);
    });
    const connectedRightSlot = computed(() => {
      var _a;
      return (_a = slots["connected-right"]) == null ? void 0 : _a.call(slots);
    });
    const helpTextSlot = computed(() => {
      var _a;
      return (_a = slots["help-text"]) == null ? void 0 : _a.call(slots);
    });
    const prefixSlot = computed(() => {
      var _a;
      return (_a = slots.prefix) == null ? void 0 : _a.call(slots);
    });
    const suffixSlot = computed(() => {
      var _a;
      return (_a = slots.suffix) == null ? void 0 : _a.call(slots);
    });
    const verticalContentSlot = computed(() => {
      var _a;
      return (_a = slots.verticalContent) == null ? void 0 : _a.call(slots);
    });
    const height = ref();
    const focus2 = ref();
    const buttonPressTimer = ref();
    const spinnerRef = ref(null);
    watch(() => props.focused, () => {
      const input = props.multiline ? textAreaRef.value : inputRef.value;
      if (!input || props.focused === void 0) {
        return;
      }
      props.focused ? input.focus() : input.blur();
    });
    watch([
      () => focus2.value,
      () => props.modelValue,
      () => props.type,
      () => props.suggestion
    ], () => {
      const isSupportedInputType = props.type === "text" || props.type === "tel" || props.type === "search" || props.type === "url" || props.type === "password";
      if (!inputRef.value || !isSupportedInputType || !props.suggestion) {
        return;
      }
      inputRef.value.setSelectionRange(props.modelValue.length, props.suggestion.length);
    });
    const { useUniqueId } = UseUniqueId();
    const id = computed(() => useUniqueId("TextField", props.id));
    const inputType = computed(() => props.type === "currency" ? "text" : props.type);
    const rows = computed(() => {
      if (!props.multiline) {
        return void 0;
      }
      return typeof props.multiline === "number" ? props.multiline : 1;
    });
    const clearButtonVisible = computed(() => normalizedValue.value !== "");
    const style2 = computed(() => props.multiline && height.value ? { height: `${height.value}px` } : {});
    const className = computed(() => classNames(styles$1R.TextField, Boolean(normalizedValue.value) && styles$1R.hasValue, props.disabled && styles$1R.disabled, props.readOnly && styles$1R.readOnly, props.error && styles$1R.error, props.multiline && styles$1R.multiline, focus2.value && styles$1R.focus));
    const inputClassName = computed(() => {
      const inputAlignmentStyle = props.align && styles$1R[variationName("Input-align", props.align)];
      return classNames(styles$1R.Input, inputAlignmentStyle, suffixSlot.value && styles$1R["Input-suffixed"], props.clearButton && styles$1R["Input-hasClearButton"], props.monospaced && styles$1R.monospaced);
    });
    const characterCountClassName = computed(() => classNames(styles$1R.CharacterCount, props.multiline && styles$1R.AlignFieldBottom));
    const backdropClassName = computed(() => classNames(styles$1R.Backdrop, connectedLeftSlot.value && styles$1R["Backdrop-connectedLeft"], connectedRightSlot.value && styles$1R["Backdrop-connectedRight"]));
    const normalizedValue = computed(() => props.suggestion ? props.suggestion : props.modelValue);
    const normalizedStep = computed(() => props.step ? props.step : 1);
    const normalizedMax = computed(() => props.max ? props.max : Infinity);
    const normalizedMin = computed(() => props.min ? props.min : -Infinity);
    const normalizeAriaMultiline = computed(() => {
      if (!props.multiline) {
        return void 0;
      }
      return Boolean(props.multiline) || props.multiline > 0 ? { "aria-multiline": true } : void 0;
    });
    const characterCount = computed(() => normalizedValue.value.length);
    computed(() => {
      return props.maxLength ? i18n.translate("Polaris.TextField.characterCountWithMaxLength", {
        count: characterCount.value,
        limit: props.maxLength
      }) : i18n.translate("Polaris.TextField.characterCount", {
        count: characterCount.value
      });
    });
    const characterCountText = computed(() => !props.maxLength ? characterCount.value : `${characterCount.value}/${props.maxLength}`);
    const formattedDescribedBy = computed(() => {
      const describedBy = [];
      if (props.error) {
        describedBy.push(`${id.value}Error`);
      }
      if (helpTextSlot.value) {
        describedBy.push(helpTextID$1(id.value));
      }
      if (props.showCharacterCount) {
        describedBy.push(`${id.value}-CharacterCounter`);
      }
      return describedBy.length ? describedBy.join(" ") : "";
    });
    const formattedLabelledBy = computed(() => {
      const labelledBy = [];
      if (prefixSlot.value) {
        labelledBy.push(`${id.value}-Prefix`);
      }
      if (suffixSlot.value) {
        labelledBy.push(`${id.value}-Suffix`);
      }
      if (verticalContentSlot.value) {
        labelledBy.push(`${id.value}-VerticalContent`);
      }
      labelledBy.unshift(labelID(id.value));
      return labelledBy.join(" ");
    });
    const handleExpandingResize = (value2) => {
      height.value = value2;
    };
    const isPrefixOrSuffix = (target) => {
      return target instanceof HTMLElement && (prefixRef.value && prefixRef.value.contains(target) || suffixRef.value && suffixRef.value.contains(target));
    };
    const handleClick = (event) => {
      var _a, _b, _c;
      const target = event.target;
      const inputRefRole = (_a = inputRef.value) == null ? void 0 : _a.getAttribute("role");
      if (target === inputRef.value && inputRefRole === "combobox") {
        (_b = inputRef.value) == null ? void 0 : _b.focus();
        handleOnFocus(event);
        return;
      }
      if (isPrefixOrSuffix(target) || isVerticalContent(target) || isInput(target) || isSpinner(target) || focus2.value) {
        return;
      }
      (_c = inputRef.value) == null ? void 0 : _c.focus();
    };
    const handleChange = (event) => {
      const target = event.target;
      emits("update:modelValue", target.value);
      emits("change", event);
    };
    const handleClickChild = (event) => {
      if (event.target && !isSpinner(event.target) && !isInput(event.target)) {
        event.stopPropagation();
      }
      const target = event.target;
      if (isPrefixOrSuffix(target) || isVerticalContent(target) || isInput(target) || focus2.value) {
        return;
      }
      focus2.value = true;
    };
    const handleNumberChange = (step) => {
      const dpl = (num) => (num.toString().split(".")[1] || []).length;
      const numericValue = props.modelValue ? parseFloat(props.modelValue) : 0;
      if (typeof numericValue !== "number") {
        return;
      }
      const decimalPlaces = Math.max(dpl(numericValue), dpl(normalizedStep.value));
      const newValue = Math.min(Number(normalizedMax.value), Math.max(numericValue + step * normalizedStep.value, Number(normalizedMin.value)));
      emits("change", String(newValue.toFixed(decimalPlaces)));
      emits("update:modelValue", String(newValue.toFixed(decimalPlaces)));
    };
    const handleButtonRelease = () => {
      clearTimeout(buttonPressTimer.value);
    };
    const handleButtonPress = () => {
      const minInterval = 50;
      const decrementBy = 10;
      let interval = 200;
      const onChangeInterval = () => {
        if (interval > minInterval) {
          interval -= decrementBy;
        }
        handleNumberChange(0);
        buttonPressTimer.value = window.setTimeout(onChangeInterval, interval);
      };
      buttonPressTimer.value = window.setTimeout(onChangeInterval, interval);
      document.addEventListener("mouseup", handleButtonRelease, {
        once: true
      });
    };
    const handleClearButtonPress = (targetId) => {
      emits("update:modelValue", "");
      emits("clear-button-click", targetId);
    };
    const handleKeyPress = (event) => {
      const { key, which } = __spreadValues({}, event);
      const numbersSpec = /[\d.eE+-]$/;
      if (props.type !== "number" || which !== 13 || numbersSpec.test(key)) {
        return;
      }
      event.preventDefault();
    };
    const handleOnFocus = (event) => {
      var _a;
      focus2.value = true;
      if (props.selectTextOnFocus && !props.suggestion) {
        const input = props.multiline ? textAreaRef : inputRef;
        (_a = input.value) == null ? void 0 : _a.select();
      }
      emits("focus", event);
    };
    const handleOnBlur = (event) => {
      focus2.value = false;
      emits("blur", event);
    };
    function isVerticalContent(target) {
      return target instanceof HTMLElement && verticalContentRef.value && (verticalContentRef.value.contains(target) || verticalContentRef.value.contains(document.activeElement));
    }
    function isInput(target) {
      return target instanceof HTMLElement && inputRef.value && (inputRef.value.contains(target) || inputRef.value.contains(document.activeElement));
    }
    function isSpinner(target) {
      var _a;
      return target instanceof Element && spinnerRef.value && ((_a = spinnerRef.value.el) == null ? void 0 : _a.contains(target));
    }
    return (_ctx, _cache) => {
      const _component_Text = resolveComponent("Text");
      return openBlock(), createBlock(unref(_sfc_main$1o), {
        id: unref(id),
        error: __props.error,
        action: __props.labelAction,
        labelHidden: __props.labelHidden,
        requiredIndicator: __props.requiredIndicator,
        label: __props.label,
        helpText: __props.helpText
      }, createSlots({
        default: withCtx(() => [
          createVNode(unref(_sfc_main$2j), null, createSlots({
            default: withCtx(() => [
              createElementVNode("div", {
                class: normalizeClass(unref(className)),
                onClick: handleClick
              }, [
                unref(slots).prefix || __props.prefix ? (openBlock(), createElementBlock("div", {
                  key: 0,
                  id: `${unref(id)}Prefix`,
                  class: normalizeClass(unref(styles$1R).Prefix),
                  ref_key: "prefixRef",
                  ref: prefixRef
                }, [
                  unref(hasSlot)(unref(slots).prefix) ? renderSlot(_ctx.$slots, "prefix", { key: 0 }) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
                    createTextVNode(toDisplayString(__props.prefix), 1)
                  ], 64))
                ], 10, _hoisted_1$1x)) : createCommentVNode("", true),
                unref(hasSlot)(unref(slots)["vertical-content"]) || __props.verticalContent ? (openBlock(), createElementBlock("div", {
                  key: 1,
                  class: normalizeClass(unref(styles$1R).VerticalContent),
                  id: `${unref(id)}-VerticalContent`,
                  ref_key: "verticalContentRef",
                  ref: verticalContentRef,
                  onClick: handleClickChild
                }, [
                  unref(hasSlot)(unref(slots)["vertical-content"]) ? renderSlot(_ctx.$slots, "vertical-content", { key: 0 }) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
                    createTextVNode(toDisplayString(__props.verticalContent), 1)
                  ], 64)),
                  (openBlock(), createBlock(resolveDynamicComponent(__props.multiline ? "textarea" : "input"), mergeProps({
                    id: unref(id),
                    name: __props.name,
                    disabled: __props.disabled,
                    readonly: __props.readOnly,
                    role: __props.role,
                    autofocus: __props.autoFocus,
                    value: __props.modelValue,
                    placeholder: __props.placeholder,
                    style: unref(style2),
                    autocomplete: __props.autoComplete,
                    class: unref(inputClassName),
                    ref: __props.multiline ? "textareaRef" : "inputRef",
                    min: __props.min,
                    max: __props.max,
                    step: __props.step,
                    minlength: __props.minLength,
                    maxlength: __props.maxLength,
                    spellcheck: __props.spellCheck,
                    pattern: __props.pattern,
                    inputMode: __props.inputMode,
                    rows: unref(rows),
                    type: unref(inputType),
                    "aria-describedby": unref(formattedDescribedBy),
                    "aria-labelledby": unref(formattedLabelledBy),
                    "aria-invalid": Boolean(__props.error),
                    "aria-owns": __props.ariaOwns,
                    "aria-activedescendant": __props.ariaActiveDescendant,
                    "aria-autocomplete": __props.ariaAutocomplete,
                    "aria-controls": __props.ariaControls,
                    "aria-expanded": __props.ariaExpanded,
                    "aria-required": __props.requiredIndicator
                  }, unref(normalizeAriaMultiline), {
                    onInput: handleChange,
                    onKeydown: handleKeyPress,
                    onFocus: handleOnFocus,
                    onBlur: handleOnBlur
                  }), {
                    default: withCtx(() => [
                      __props.multiline ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
                        createTextVNode(toDisplayString(__props.modelValue), 1)
                      ], 64)) : createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 16, ["id", "name", "disabled", "readonly", "role", "autofocus", "value", "placeholder", "style", "autocomplete", "class", "min", "max", "step", "minlength", "maxlength", "spellcheck", "pattern", "inputMode", "rows", "type", "aria-describedby", "aria-labelledby", "aria-invalid", "aria-owns", "aria-activedescendant", "aria-autocomplete", "aria-controls", "aria-expanded", "aria-required"]))
                ], 10, _hoisted_2$T)) : (openBlock(), createBlock(resolveDynamicComponent(__props.multiline ? "textarea" : "input"), mergeProps({
                  key: 2,
                  id: unref(id),
                  name: __props.name,
                  disabled: __props.disabled,
                  readonly: __props.readOnly,
                  role: __props.role,
                  autofocus: __props.autoFocus,
                  value: __props.modelValue,
                  placeholder: __props.placeholder,
                  style: unref(style2),
                  autocomplete: __props.autoComplete,
                  class: unref(inputClassName),
                  ref: __props.multiline ? "textareaRef" : "inputRef",
                  min: __props.min,
                  max: __props.max,
                  step: __props.step,
                  minlength: __props.minLength,
                  maxlength: __props.maxLength,
                  spellcheck: __props.spellCheck,
                  pattern: __props.pattern,
                  inputMode: __props.inputMode,
                  rows: unref(rows),
                  type: unref(inputType),
                  "aria-describedby": unref(formattedDescribedBy),
                  "aria-labelledby": unref(formattedLabelledBy),
                  "aria-invalid": Boolean(__props.error),
                  "aria-owns": __props.ariaOwns,
                  "aria-activedescendant": __props.ariaActiveDescendant,
                  "aria-autocomplete": __props.ariaAutocomplete,
                  "aria-controls": __props.ariaControls,
                  "aria-expanded": __props.ariaExpanded,
                  "aria-required": __props.requiredIndicator
                }, unref(normalizeAriaMultiline), {
                  onInput: handleChange,
                  onKeydown: handleKeyPress,
                  onFocus: handleOnFocus,
                  onBlur: handleOnBlur
                }), {
                  default: withCtx(() => [
                    __props.multiline ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
                      createTextVNode(toDisplayString(__props.modelValue), 1)
                    ], 64)) : createCommentVNode("", true)
                  ]),
                  _: 1
                }, 16, ["id", "name", "disabled", "readonly", "role", "autofocus", "value", "placeholder", "style", "autocomplete", "class", "min", "max", "step", "minlength", "maxlength", "spellcheck", "pattern", "inputMode", "rows", "type", "aria-describedby", "aria-labelledby", "aria-invalid", "aria-owns", "aria-activedescendant", "aria-autocomplete", "aria-controls", "aria-expanded", "aria-required"])),
                unref(hasSlot)(unref(slots).suffix) || __props.suffix ? (openBlock(), createElementBlock("div", {
                  key: 3,
                  id: `${unref(id)}Suffix`,
                  class: normalizeClass(unref(styles$1R).Suffix),
                  ref_key: "suffixRef",
                  ref: suffixRef
                }, [
                  unref(hasSlot)(unref(slots).suffix) ? renderSlot(_ctx.$slots, "suffix", { key: 0 }) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
                    createTextVNode(toDisplayString(__props.suffix), 1)
                  ], 64))
                ], 10, _hoisted_3$D)) : createCommentVNode("", true),
                __props.showCharacterCount ? (openBlock(), createElementBlock("div", {
                  key: 4,
                  class: normalizeClass(unref(characterCountClassName)),
                  "aria-live": focus2.value ? "polite" : "off",
                  "aria-atomic": "true",
                  onClick: handleClickChild
                }, [
                  createElementVNode("p", null, toDisplayString(unref(characterCountText)), 1)
                ], 10, _hoisted_4$b)) : createCommentVNode("", true),
                unref(clearButtonVisible) && __props.clearButton ? (openBlock(), createElementBlock("button", {
                  key: 5,
                  type: "button",
                  class: normalizeClass(unref(styles$1R).ClearButton),
                  disabled: __props.disabled,
                  onClick: _cache[0] || (_cache[0] = ($event) => handleClearButtonPress(unref(id)))
                }, [
                  createVNode(_component_Text, {
                    as: "span",
                    variant: "bodySm",
                    "visually-hidden": ""
                  }, {
                    default: withCtx(() => [
                      createTextVNode(toDisplayString(unref(i18n).translate("Polaris.Common.clear")), 1)
                    ]),
                    _: 1
                  }),
                  createVNode(unref(_sfc_main$2K), {
                    source: unref(CircleCancelMinor),
                    color: "base"
                  }, null, 8, ["source"])
                ], 10, _hoisted_5$4)) : createCommentVNode("", true),
                __props.type === "number" && __props.step !== 0 && !__props.disabled && !__props.readOnly ? (openBlock(), createBlock(unref(_sfc_main$34), {
                  key: 6,
                  ref_key: "spinnerRef",
                  ref: spinnerRef,
                  onChange: handleNumberChange,
                  onMousedown: handleButtonPress,
                  onMouseup: handleButtonRelease,
                  onClick: handleClickChild
                }, null, 512)) : createCommentVNode("", true),
                createElementVNode("div", {
                  class: normalizeClass(unref(backdropClassName))
                }, null, 2),
                __props.multiline ? (openBlock(), createBlock(unref(_sfc_main$32), {
                  key: 7,
                  contents: unref(normalizedValue) || __props.placeholder,
                  currentHeight: height.value,
                  minimumLines: typeof __props.multiline === "number" ? __props.multiline : 1,
                  onHeightChange: handleExpandingResize
                }, null, 8, ["contents", "currentHeight", "minimumLines"])) : createCommentVNode("", true)
              ], 2)
            ]),
            _: 2
          }, [
            unref(slots)["connected-left"] ? {
              name: "left",
              fn: withCtx(() => [
                renderSlot(_ctx.$slots, "connected-left")
              ])
            } : void 0,
            unref(slots)["connected-right"] ? {
              name: "right",
              fn: withCtx(() => [
                renderSlot(_ctx.$slots, "connected-right")
              ])
            } : void 0
          ]), 1024)
        ]),
        _: 2
      }, [
        unref(hasSlot)(unref(slots).label) ? {
          name: "label",
          fn: withCtx(() => [
            renderSlot(_ctx.$slots, "label")
          ])
        } : void 0,
        unref(hasSlot)(unref(slots)["help-text"]) ? {
          name: "help-text",
          fn: withCtx(() => [
            renderSlot(_ctx.$slots, "help-text")
          ])
        } : void 0
      ]), 1032, ["id", "error", "action", "labelHidden", "requiredIndicator", "label", "helpText"]);
    };
  }
});
const _sfc_main$30 = /* @__PURE__ */ defineComponent({
  props: {
    placeholder: null,
    modelValue: null,
    prefix: null,
    suffix: null,
    helpText: null,
    label: null,
    labelAction: null,
    labelHidden: { type: Boolean },
    disabled: { type: Boolean },
    clearButton: { type: Boolean },
    suggestion: null,
    readOnly: { type: Boolean },
    autoFocus: { type: Boolean },
    focused: { type: Boolean },
    multiline: { type: [Boolean, Number] },
    error: null,
    type: { default: "text" },
    name: null,
    id: null,
    role: null,
    step: null,
    autoComplete: null,
    max: null,
    maxLength: null,
    maxHeight: null,
    min: null,
    minLength: null,
    pattern: null,
    inputMode: null,
    spellCheck: { type: Boolean },
    ariaOwns: null,
    ariaExpanded: { type: Boolean },
    ariaControls: null,
    ariaActiveDescendant: null,
    ariaAutocomplete: { default: "list" },
    showCharacterCount: { type: Boolean },
    align: null,
    requiredIndicator: { type: Boolean },
    monospaced: { type: Boolean },
    selectTextOnFocus: { type: Boolean }
  },
  emits: ["focus", "blur", "change", "update:modelValue"],
  setup(__props, { emit: emits }) {
    const props = __props;
    const {
      activeOptionId,
      listboxId,
      expanded: expanded2,
      setTextFieldFocused,
      setTextFieldLabelId,
      onTextFieldFocus,
      onTextFieldChange,
      onTextFieldBlur
    } = inject("comboboxTextFieldContext", {});
    const { useUniqueId } = UseUniqueId();
    const uniqueId = useUniqueId("ComboboxTextField");
    const textFieldId = computed(() => props.id || uniqueId);
    const labelId = computed(() => labelID(props.id || uniqueId));
    watch(() => labelId.value, () => {
      if (setTextFieldLabelId) {
        setTextFieldLabelId(labelId.value);
      }
    });
    const handleFocus = () => {
      emits("focus");
      if (onTextFieldFocus) {
        onTextFieldFocus();
      }
      if (setTextFieldFocused) {
        setTextFieldFocused(true);
      }
    };
    const handleBlur = () => {
      emits("blur");
      if (onTextFieldBlur) {
        onTextFieldBlur();
      }
      if (setTextFieldFocused) {
        setTextFieldFocused(false);
      }
    };
    const handleChange = (payload) => {
      if (payload instanceof Event) {
        const target = payload.target;
        emits("update:modelValue", target.value);
        emits("change", payload);
      } else {
        emits("update:modelValue", payload);
        emits("change", payload);
      }
      if (onTextFieldChange) {
        onTextFieldChange();
      }
    };
    return (_ctx, _cache) => {
      return openBlock(), createBlock(unref(_sfc_main$31), mergeProps(props, {
        modelValue: __props.modelValue,
        id: unref(textFieldId),
        type: __props.type,
        ariaAutoComplete: __props.ariaAutocomplete,
        "aria-haspopup": "listbox",
        ariaActiveDescendant: unref(activeOptionId),
        ariaControls: unref(listboxId),
        ariaExpanded: unref(expanded2),
        label: __props.label,
        helpText: __props.helpText,
        suffix: __props.suffix,
        prefix: __props.prefix,
        onFocus: handleFocus,
        onBlur: handleBlur,
        onChange: handleChange
      }), createSlots({ _: 2 }, [
        _ctx.$slots.label ? {
          name: "label",
          fn: withCtx(() => [
            renderSlot(_ctx.$slots, "label")
          ])
        } : void 0,
        _ctx.$slots["help-text"] ? {
          name: "help-text",
          fn: withCtx(() => [
            renderSlot(_ctx.$slots, "help-text")
          ])
        } : void 0,
        _ctx.$slots.prefix ? {
          name: "prefix",
          fn: withCtx(() => [
            renderSlot(_ctx.$slots, "prefix")
          ])
        } : void 0,
        _ctx.$slots.suffix ? {
          name: "suffix",
          fn: withCtx(() => [
            renderSlot(_ctx.$slots, "suffix")
          ])
        } : void 0,
        _ctx.$slots["connected-left"] ? {
          name: "connected-left",
          fn: withCtx(() => [
            renderSlot(_ctx.$slots, "connected-left")
          ])
        } : void 0,
        _ctx.$slots["connected-right"] ? {
          name: "connected-right",
          fn: withCtx(() => [
            renderSlot(_ctx.$slots, "connected-right")
          ])
        } : void 0,
        _ctx.$slots["vertical-content"] ? {
          name: "vertical-content",
          fn: withCtx(() => [
            renderSlot(_ctx.$slots, "vertical-content")
          ])
        } : void 0
      ]), 1040, ["modelValue", "id", "type", "ariaAutoComplete", "ariaActiveDescendant", "ariaControls", "ariaExpanded", "label", "helpText", "suffix", "prefix"]);
    };
  }
});
const Avatar = "Polaris-Avatar";
const Text$6 = "Polaris-Avatar__Text";
const long = "Polaris-Avatar--long";
const shapeRound = "Polaris-Avatar--shapeRound";
const shapeSquare = "Polaris-Avatar--shapeSquare";
const hidden$3 = "Polaris-Avatar--hidden";
const sizeExtraSmall$2 = "Polaris-Avatar--sizeExtraSmall";
const sizeSmall$9 = "Polaris-Avatar--sizeSmall";
const sizeMedium$6 = "Polaris-Avatar--sizeMedium";
const sizeLarge$9 = "Polaris-Avatar--sizeLarge";
const styleOne = "Polaris-Avatar--styleOne";
const styleTwo = "Polaris-Avatar--styleTwo";
const styleThree = "Polaris-Avatar--styleThree";
const styleFour = "Polaris-Avatar--styleFour";
const styleFive = "Polaris-Avatar--styleFive";
const imageHasLoaded = "Polaris-Avatar--imageHasLoaded";
const Image$2 = "Polaris-Avatar__Image";
const Initials = "Polaris-Avatar__Initials";
const Svg$1 = "Polaris-Avatar__Svg";
var styles$1Q = {
  Avatar,
  Text: Text$6,
  long,
  shapeRound,
  shapeSquare,
  hidden: hidden$3,
  sizeExtraSmall: sizeExtraSmall$2,
  sizeSmall: sizeSmall$9,
  sizeMedium: sizeMedium$6,
  sizeLarge: sizeLarge$9,
  styleOne,
  styleTwo,
  styleThree,
  styleFour,
  styleFive,
  imageHasLoaded,
  Image: Image$2,
  Initials,
  Svg: Svg$1
};
const STYLE_CLASSES = ["one", "two", "three", "four", "five"];
function xorHash(str) {
  let hash = 0;
  for (const char of str) {
    hash ^= char.charCodeAt(0);
  }
  return hash;
}
function styleClass(name) {
  return name ? STYLE_CLASSES[xorHash(name) % STYLE_CLASSES.length] : STYLE_CLASSES[0];
}
var Avatar_vue_vue_type_style_index_0_lang = "";
const _hoisted_1$1w = ["aria-label"];
const _sfc_main$2$ = /* @__PURE__ */ defineComponent({
  props: {
    size: { default: "medium" },
    shape: { default: "round" },
    name: null,
    initials: null,
    customer: { type: Boolean },
    source: null,
    accessibilityLabel: null
  },
  emits: ["error"],
  setup(__props, { emit }) {
    const props = __props;
    const status = ref("PENDING");
    const svgPath = "M8.28 27.5A14.95 14.95 0 0120 21.8c4.76 0 8.97 2.24 11.72 5.7a14.02 14.02 0 01-8.25 5.91 14.82 14.82 0 01-6.94 0 14.02 14.02 0 01-8.25-5.9zM13.99 12.78a6.02 6.02 0 1112.03 0 6.02 6.02 0 01-12.03 0z";
    const verticalOffset = "0.35em";
    const hasImage = computed(() => {
      return props.source && status.value !== "ERRORED";
    });
    const className = computed(() => {
      const size = variationName("size", props.size);
      const style2 = variationName("style", styleClass(props.name || props.initials));
      return classNames(styles$1Q.Avatar, size && styles$1Q[size], !props.customer && styles$1Q[style2], hasImage.value && status.value === "LOADED" && styles$1Q.imageHasLoaded, props.shape && styles$1Q[variationName("shape", props.shape)], !props.customer && !props.source && styles$1Q[variationName("style", styleClass(props.name || props.initials))]);
    });
    const textClassName = computed(() => {
      var _a;
      return classNames(styles$1Q.Text, (((_a = props.initials) == null ? void 0 : _a.length) || 0) > 2 && styles$1Q.long);
    });
    const imageClassName = computed(() => {
      return classNames(styles$1Q.Image, status.value !== "LOADED" && styles$1Q.hidden);
    });
    const label = computed(() => {
      if (props.accessibilityLabel) {
        return props.accessibilityLabel;
      }
      if (props.name) {
        return props.name;
      }
      if (props.initials) {
        const splitInitials = props.initials.split("").join(" ");
        return `Avatar with initials ${splitInitials}`;
      }
      return "Avatar";
    });
    const handleLoad = () => {
      status.value = "LOADED";
    };
    const handleError = () => {
      status.value = "ERRORED";
      emit("error");
    };
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("span", {
        "aria-label": unref(label),
        role: "img",
        class: normalizeClass(unref(className))
      }, [
        !unref(hasImage) ? (openBlock(), createElementBlock("span", {
          key: 0,
          class: normalizeClass(unref(styles$1Q).Initials)
        }, [
          (openBlock(), createElementBlock("svg", {
            class: normalizeClass(unref(styles$1Q).Svg),
            viewBox: "0 0 40 40"
          }, [
            __props.customer || !__props.initials ? (openBlock(), createElementBlock("path", {
              key: 0,
              fill: "currentColor",
              d: svgPath
            })) : (openBlock(), createElementBlock("text", {
              key: 1,
              x: "50%",
              y: "50%",
              dy: verticalOffset,
              fill: "currentColor",
              class: normalizeClass(unref(textClassName)),
              "text-anchor": "middle"
            }, toDisplayString(__props.initials), 3))
          ], 2))
        ], 2)) : createCommentVNode("", true),
        __props.source && status.value !== "ERRORED" ? (openBlock(), createBlock(unref(_sfc_main$1D), {
          key: 1,
          class: normalizeClass(unref(imageClassName)),
          source: __props.source,
          alt: "",
          role: "presentation",
          onLoad: handleLoad,
          onError: handleError
        }, null, 8, ["class", "source"])) : createCommentVNode("", true)
      ], 10, _hoisted_1$1w);
    };
  }
});
const Backdrop$6 = "Polaris-Backdrop";
const transparent$1 = "Polaris-Backdrop--transparent";
const belowNavigation = "Polaris-Backdrop--belowNavigation";
var styles$1P = {
  Backdrop: Backdrop$6,
  transparent: transparent$1,
  belowNavigation
};
var Backdrop_vue_vue_type_style_index_0_lang = "";
const _sfc_main$2_ = /* @__PURE__ */ defineComponent({
  props: {
    belowNavigation: { type: Boolean },
    transparent: { type: Boolean }
  },
  emits: ["click", "touchstart", "closing", "closed"],
  setup(__props, { emit: emits }) {
    const props = __props;
    const isClosing = ref(false);
    const className = computed(() => {
      return classNames(styles$1P.Backdrop, props.belowNavigation && styles$1P.belowNavigation, props.transparent && styles$1P.transparent);
    });
    const handleMouseDown = () => {
      isClosing.value = true;
      emits("closing", true);
    };
    const handleMouseUp = () => {
      isClosing.value = false;
      emits("closing", false);
      emits("click");
    };
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock(Fragment, null, [
        createVNode(unref(_sfc_main$z)),
        createElementVNode("div", {
          class: normalizeClass(unref(className)),
          onClick: _cache[0] || (_cache[0] = ($event) => emits("click")),
          onTouchstart: _cache[1] || (_cache[1] = ($event) => emits("touchstart")),
          onMousedown: handleMouseDown,
          onMouseup: handleMouseUp
        }, null, 34)
      ], 64);
    };
  }
});
const Badge$1 = "Polaris-Badge";
const statusSuccess$3 = "Polaris-Badge--statusSuccess";
const statusInfo$2 = "Polaris-Badge--statusInfo";
const statusAttention$1 = "Polaris-Badge--statusAttention";
const statusWarning$3 = "Polaris-Badge--statusWarning";
const statusCritical$3 = "Polaris-Badge--statusCritical";
const statusNew$1 = "Polaris-Badge--statusNew";
const withinFilter = "Polaris-Badge--withinFilter";
const Icon$c = "Polaris-Badge__Icon";
const PipContainer = "Polaris-Badge__PipContainer";
var styles$1O = {
  Badge: Badge$1,
  statusSuccess: statusSuccess$3,
  statusInfo: statusInfo$2,
  statusAttention: statusAttention$1,
  statusWarning: statusWarning$3,
  statusCritical: statusCritical$3,
  statusNew: statusNew$1,
  withinFilter,
  Icon: Icon$c,
  PipContainer
};
function getDefaultAccessibilityLabel(progress, status) {
  let progressLabel = "";
  let statusLabel = "";
  if (!progress && !status) {
    return "";
  }
  switch (progress) {
    case "incomplete":
      progressLabel = "Incomplete";
      break;
    case "partiallyComplete":
      progressLabel = "Partially complete";
      break;
    case "complete":
      progressLabel = "Complete";
      break;
  }
  switch (status) {
    case "info":
      statusLabel = "Info";
      break;
    case "success":
      statusLabel = "Success";
      break;
    case "warning":
      statusLabel = "Warning";
      break;
    case "critical":
      statusLabel = "Critical";
      break;
    case "attention":
      statusLabel = "Attention";
      break;
    case "new":
      statusLabel = "New";
      break;
  }
  return `${statusLabel} ${progressLabel}`;
}
const Pip$1 = "Polaris-Badge-Pip";
const statusInfo$1 = "Polaris-Badge-Pip--statusInfo";
const statusSuccess$2 = "Polaris-Badge-Pip--statusSuccess";
const statusNew = "Polaris-Badge-Pip--statusNew";
const statusAttention = "Polaris-Badge-Pip--statusAttention";
const statusWarning$2 = "Polaris-Badge-Pip--statusWarning";
const statusCritical$2 = "Polaris-Badge-Pip--statusCritical";
const progressIncomplete = "Polaris-Badge-Pip--progressIncomplete";
const progressPartiallyComplete = "Polaris-Badge-Pip--progressPartiallyComplete";
const progressComplete = "Polaris-Badge-Pip--progressComplete";
var styles$1N = {
  Pip: Pip$1,
  statusInfo: statusInfo$1,
  statusSuccess: statusSuccess$2,
  statusNew,
  statusAttention,
  statusWarning: statusWarning$2,
  statusCritical: statusCritical$2,
  progressIncomplete,
  progressPartiallyComplete,
  progressComplete
};
var Pip_vue_vue_type_style_index_0_lang = "";
const _sfc_main$2Z = /* @__PURE__ */ defineComponent({
  props: {
    status: null,
    progress: { default: "complete" },
    accessibilityLabelOverride: null
  },
  setup(__props) {
    const props = __props;
    const className = computed(() => {
      return classNames(styles$1N.Pip, props.status && styles$1N[variationName("status", props.status)], props.progress && styles$1N[variationName("progress", props.progress)]);
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("span", {
        class: normalizeClass(unref(className))
      }, [
        createVNode(unref(Text), {
          variant: "bodySm",
          as: "span",
          "visually-hidden": ""
        }, {
          default: withCtx(() => [
            __props.accessibilityLabelOverride ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
              createTextVNode(toDisplayString(__props.accessibilityLabelOverride), 1)
            ], 64)) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
              createTextVNode(toDisplayString(unref(getDefaultAccessibilityLabel)(__props.progress, __props.status)), 1)
            ], 64))
          ]),
          _: 1
        })
      ], 2);
    };
  }
});
var Badge_vue_vue_type_style_index_0_lang = "";
const _sfc_main$2Y = /* @__PURE__ */ defineComponent({
  props: {
    status: null,
    progress: null,
    size: { default: "medium" },
    statusAndProgressLabelOverride: null,
    icon: null
  },
  setup(__props) {
    const props = __props;
    const withinFilter2 = inject("withinFilterContext", false);
    const DEFAULT_SIZE = "medium";
    const progressLabel = ref("");
    const statusLabel = ref("");
    const className = computed(() => classNames(styles$1O.Badge, props.status && styles$1O[variationName("status", props.status)], props.size && props.size !== DEFAULT_SIZE && styles$1O[variationName("size", props.size)], withinFilter2 && styles$1O.withinFilter));
    const hasAccessibilityLabel = computed(() => props.statusAndProgressLabelOverride || statusLabel.value || progressLabel.value);
    const accessibilityLabel = computed(() => props.statusAndProgressLabelOverride ? props.statusAndProgressLabelOverride : getDefaultAccessibilityLabel(props.progress, props.status));
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("span", {
        class: normalizeClass(unref(className))
      }, [
        __props.progress && !__props.icon ? (openBlock(), createElementBlock("span", {
          key: 0,
          class: normalizeClass(unref(styles$1O).PipContainer)
        }, [
          createVNode(unref(_sfc_main$2Z), {
            progress: __props.progress,
            status: __props.status,
            accessibilityLabelOverride: unref(accessibilityLabel)
          }, null, 8, ["progress", "status", "accessibilityLabelOverride"])
        ], 2)) : createCommentVNode("", true),
        unref(hasAccessibilityLabel) ? (openBlock(), createBlock(unref(Text), {
          key: 1,
          variant: "bodySm",
          as: "span",
          "visually-hidden": ""
        }, {
          default: withCtx(() => [
            createTextVNode(toDisplayString(unref(accessibilityLabel)), 1)
          ]),
          _: 1
        })) : createCommentVNode("", true),
        __props.icon ? (openBlock(), createElementBlock("span", {
          key: 2,
          class: normalizeClass(unref(styles$1O).Icon)
        }, [
          createVNode(unref(_sfc_main$2K), { source: __props.icon }, null, 8, ["source"])
        ], 2)) : createCommentVNode("", true),
        _ctx.$slots.default ? (openBlock(), createBlock(unref(Text), {
          key: 3,
          as: "span",
          variant: "bodySm"
        }, {
          default: withCtx(() => [
            renderSlot(_ctx.$slots, "default")
          ]),
          _: 3
        })) : createCommentVNode("", true)
      ], 2);
    };
  }
});
const _hoisted_1$1v = {
  viewBox: "0 0 20 20",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$S = /* @__PURE__ */ createElementVNode("path", { d: "M6.707 5.293a1 1 0 0 0-1.414 1.414L8.586 10l-3.293 3.293a1 1 0 1 0 1.414 1.414L10 11.414l3.293 3.293a1 1 0 0 0 1.414-1.414L11.414 10l3.293-3.293a1 1 0 0 0-1.414-1.414L10 8.586 6.707 5.293Z" }, null, -1);
const _hoisted_3$C = [
  _hoisted_2$S
];
function render$r(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1$1v, _hoisted_3$C);
}
var CancelSmallMinor = { render: render$r };
const _hoisted_1$1u = {
  viewBox: "0 0 20 20",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$R = /* @__PURE__ */ createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M0 10a10 10 0 1 0 20 0 10 10 0 0 0-20 0zm15.2-1.8a1 1 0 0 0-1.4-1.4L9 11.6 6.7 9.3a1 1 0 0 0-1.4 1.4l3 3c.4.4 1 .4 1.4 0l5.5-5.5z"
}, null, -1);
const _hoisted_3$B = [
  _hoisted_2$R
];
function render$q(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1$1u, _hoisted_3$B);
}
var CircleTickMajor = { render: render$q };
const _hoisted_1$1t = {
  viewBox: "0 0 20 20",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$Q = /* @__PURE__ */ createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M10 20c5.514 0 10-4.486 10-10S15.514 0 10 0 0 4.486 0 10s4.486 10 10 10zm1-6a1 1 0 1 1-2 0v-4a1 1 0 1 1 2 0v4zm-1-9a1 1 0 1 0 0 2 1 1 0 0 0 0-2z"
}, null, -1);
const _hoisted_3$A = [
  _hoisted_2$Q
];
function render$p(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1$1t, _hoisted_3$A);
}
var CircleInformationMajor = { render: render$p };
const _hoisted_1$1s = {
  viewBox: "0 0 20 20",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$P = /* @__PURE__ */ createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M10 0C4.486 0 0 4.486 0 10s4.486 10 10 10 10-4.486 10-10S15.514 0 10 0zM9 6a1 1 0 1 1 2 0v4a1 1 0 1 1-2 0V6zm1 9a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"
}, null, -1);
const _hoisted_3$z = [
  _hoisted_2$P
];
function render$o(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1$1s, _hoisted_3$z);
}
var CircleAlertMajor = { render: render$o };
const _hoisted_1$1r = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20"
};
const _hoisted_2$O = /* @__PURE__ */ createElementVNode("path", { d: "M11.768.768a2.5 2.5 0 0 0-3.536 0L.768 8.232a2.5 2.5 0 0 0 0 3.536l7.464 7.464a2.5 2.5 0 0 0 3.536 0l7.464-7.464a2.5 2.5 0 0 0 0-3.536L11.768.768zM9 6a1 1 0 1 1 2 0v4a1 1 0 1 1-2 0V6zm2 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0z" }, null, -1);
const _hoisted_3$y = [
  _hoisted_2$O
];
function render$n(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1$1r, _hoisted_3$y);
}
var DiamondAlertMajor = { render: render$n };
const Banner = "Polaris-Banner";
const statusCritical$1 = "Polaris-Banner--statusCritical";
const PrimaryAction$2 = "Polaris-Banner__PrimaryAction";
const Button$3 = "Polaris-Banner__Button";
const statusWarning$1 = "Polaris-Banner--statusWarning";
const statusInfo = "Polaris-Banner--statusInfo";
const statusSuccess$1 = "Polaris-Banner--statusSuccess";
const ContentWrapper = "Polaris-Banner__ContentWrapper";
const withinContentContainer$1 = "Polaris-Banner--withinContentContainer";
const Dismiss$1 = "Polaris-Banner__Dismiss";
const Ribbon = "Polaris-Banner__Ribbon";
const keyFocused$4 = "Polaris-Banner--keyFocused";
const Actions$4 = "Polaris-Banner__Actions";
const withinPage = "Polaris-Banner--withinPage";
const hasDismiss$1 = "Polaris-Banner--hasDismiss";
const Heading$3 = "Polaris-Banner__Heading";
const Content$c = "Polaris-Banner__Content";
const SecondaryAction$2 = "Polaris-Banner__SecondaryAction";
const Text$5 = "Polaris-Banner__Text";
const pressed$2 = "Polaris-Banner--pressed";
const loading$1 = "Polaris-Banner--loading";
const Spinner$3 = "Polaris-Banner__Spinner";
var styles$1M = {
  Banner,
  statusCritical: statusCritical$1,
  PrimaryAction: PrimaryAction$2,
  Button: Button$3,
  statusWarning: statusWarning$1,
  statusInfo,
  statusSuccess: statusSuccess$1,
  ContentWrapper,
  withinContentContainer: withinContentContainer$1,
  Dismiss: Dismiss$1,
  Ribbon,
  keyFocused: keyFocused$4,
  Actions: Actions$4,
  withinPage,
  hasDismiss: hasDismiss$1,
  Heading: Heading$3,
  Content: Content$c,
  SecondaryAction: SecondaryAction$2,
  Text: Text$5,
  pressed: pressed$2,
  loading: loading$1,
  Spinner: Spinner$3
};
var Banner_vue_vue_type_style_index_0_lang = "";
const _hoisted_1$1q = ["role", "aria-live", "aria-labelledby", "aria-describedby"];
const _hoisted_2$N = ["id"];
const _hoisted_3$x = ["id"];
const _sfc_main$2X = /* @__PURE__ */ defineComponent({
  props: {
    title: null,
    icon: null,
    status: null,
    action: null,
    secondaryAction: null,
    stopAnnouncements: { type: Boolean }
  },
  setup(__props) {
    const props = __props;
    const i18n = UseI18n();
    const withinContentContainer2 = inject("WithinContentContext", false);
    provide("BannerContext", false);
    const { useUniqueId } = UseUniqueId();
    const id = useUniqueId("Banner");
    const headingID = computed(() => `${id}Heading`);
    const contentID = computed(() => `${id}Content`);
    const attrs = useAttrs();
    const slots = useSlots();
    const wrapperRef = ref(null);
    const shouldShowFocus = ref(false);
    const { defaultIcon, iconColor, ariaRoleType } = useBannerAttributes(props.status);
    const iconName = computed(() => {
      return props.icon || defaultIcon;
    });
    const triggerSecondaryAction = () => {
      if (props.secondaryAction && props.secondaryAction.onAction) {
        props.secondaryAction.onAction();
      }
    };
    const className = computed(() => {
      const onDismiss = !!attrs.onDismiss;
      return classNames(styles$1M.Banner, props.status && styles$1M[variationName("status", props.status)], onDismiss && styles$1M.hasDismiss, shouldShowFocus.value && styles$1M.keyFocused, withinContentContainer2 ? styles$1M.withinContentContainer : styles$1M.withinPage);
    });
    const spinnerClassName = computed(() => {
      return classNames(styles$1M.Button, styles$1M.loading);
    });
    const handleKeyUp = (event) => {
      if (event.target === wrapperRef.value) {
        shouldShowFocus.value = true;
      }
    };
    const handleBlur = () => {
      shouldShowFocus.value = false;
    };
    const handleMouseUp = (event) => {
      const target = event.currentTarget;
      target.blur();
      shouldShowFocus.value = false;
    };
    function useBannerAttributes(status) {
      switch (status) {
        case "success":
          return {
            defaultIcon: CircleTickMajor,
            iconColor: "success",
            ariaRoleType: "status"
          };
        case "info":
          return {
            defaultIcon: CircleInformationMajor,
            iconColor: "highlight",
            ariaRoleType: "status"
          };
        case "warning":
          return {
            defaultIcon: CircleAlertMajor,
            iconColor: "warning",
            ariaRoleType: "alert"
          };
        case "critical":
          return {
            defaultIcon: DiamondAlertMajor,
            iconColor: "critical",
            ariaRoleType: "alert"
          };
        default:
          return {
            defaultIcon: CircleInformationMajor,
            iconColor: "base",
            ariaRoleType: "status"
          };
      }
    }
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(unref(className)),
        tabIndex: "0",
        ref_key: "wrapperRef",
        ref: wrapperRef,
        role: unref(ariaRoleType),
        "aria-live": __props.stopAnnouncements ? "off" : "polite",
        onMouseup: handleMouseUp,
        onKeyup: handleKeyUp,
        onBlur: handleBlur,
        "aria-labelledby": unref(headingID),
        "aria-describedby": unref(contentID)
      }, [
        unref(attrs).onDismiss ? (openBlock(), createElementBlock("div", {
          key: 0,
          class: normalizeClass(unref(styles$1M).Dismiss)
        }, [
          createVNode(unref(_sfc_main$2F), {
            plain: "",
            icon: unref(CancelSmallMinor),
            onClick: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("dismiss")),
            accessibilityLabel: "Dismiss notification"
          }, null, 8, ["icon"])
        ], 2)) : createCommentVNode("", true),
        createElementVNode("div", {
          class: normalizeClass(unref(styles$1M).Ribbon)
        }, [
          createVNode(unref(_sfc_main$2K), {
            source: unref(iconName),
            color: unref(iconColor)
          }, null, 8, ["source", "color"])
        ], 2),
        createElementVNode("div", {
          class: normalizeClass(unref(styles$1M).ContentWrapper)
        }, [
          createElementVNode("div", {
            class: normalizeClass(unref(styles$1M).Heading),
            id: unref(headingID)
          }, [
            createVNode(unref(Text), {
              as: "p",
              variant: "headingMd"
            }, {
              default: withCtx(() => [
                createTextVNode(toDisplayString(__props.title), 1)
              ]),
              _: 1
            })
          ], 10, _hoisted_2$N),
          unref(hasSlot)(unref(slots).default) || __props.action || __props.secondaryAction ? (openBlock(), createElementBlock("div", {
            key: 0,
            class: normalizeClass(unref(styles$1M).Content),
            id: unref(contentID)
          }, [
            renderSlot(_ctx.$slots, "default"),
            __props.action || __props.secondaryAction ? (openBlock(), createElementBlock("div", {
              key: 0,
              class: normalizeClass(unref(styles$1M).Actions)
            }, [
              createVNode(unref(_sfc_main$2C), null, {
                default: withCtx(() => [
                  __props.action ? (openBlock(), createElementBlock("div", {
                    key: 0,
                    class: normalizeClass(unref(styles$1M).PrimaryAction)
                  }, [
                    __props.action.loading ? (openBlock(), createElementBlock("button", {
                      key: 0,
                      disabled: "",
                      "aria-busy": "",
                      class: normalizeClass(unref(spinnerClassName))
                    }, [
                      createElementVNode("span", {
                        class: normalizeClass(unref(styles$1M).Spinner)
                      }, [
                        createVNode(unref(_sfc_main$2H), {
                          size: "small",
                          accessibilityLabel: unref(i18n).translate("Polaris.Button.spinnerAccessibilityLabel")
                        }, null, 8, ["accessibilityLabel"])
                      ], 2),
                      createTextVNode(toDisplayString(__props.action.content), 1)
                    ], 2)) : (openBlock(), createBlock(unref(_sfc_main$2I), {
                      key: 1,
                      action: __props.action,
                      class: normalizeClass(unref(styles$1M).Button)
                    }, null, 8, ["action", "class"]))
                  ], 2)) : createCommentVNode("", true),
                  __props.secondaryAction ? (openBlock(), createElementBlock(Fragment, { key: 1 }, [
                    __props.secondaryAction.url ? (openBlock(), createBlock(unref(_sfc_main$3m), {
                      key: 0,
                      class: normalizeClass(unref(styles$1M).SecondaryAction),
                      url: __props.secondaryAction.url,
                      external: __props.secondaryAction.external
                    }, {
                      default: withCtx(() => [
                        createElementVNode("span", {
                          class: normalizeClass(unref(styles$1M).Text)
                        }, toDisplayString(__props.secondaryAction.content), 3)
                      ]),
                      _: 1
                    }, 8, ["class", "url", "external"])) : (openBlock(), createBlock(unref(_sfc_main$2J), {
                      key: 1,
                      class: normalizeClass(unref(styles$1M).SecondaryAction),
                      onClick: triggerSecondaryAction
                    }, {
                      default: withCtx(() => [
                        createElementVNode("span", {
                          class: normalizeClass(unref(styles$1M).Text)
                        }, toDisplayString(__props.secondaryAction.content), 3)
                      ]),
                      _: 1
                    }, 8, ["class"]))
                  ], 64)) : createCommentVNode("", true)
                ]),
                _: 1
              })
            ], 2)) : createCommentVNode("", true)
          ], 10, _hoisted_3$x)) : createCommentVNode("", true)
        ], 2)
      ], 42, _hoisted_1$1q);
    };
  }
});
const Bleed = "Polaris-Bleed";
var styles$1L = {
  Bleed
};
var Bleed_vue_vue_type_style_index_0_lang = "";
const _sfc_main$2W = /* @__PURE__ */ defineComponent({
  props: {
    spacing: null,
    horizontal: null,
    vertical: null,
    top: null,
    bottom: null,
    left: null,
    right: null
  },
  setup(__props) {
    const props = __props;
    const getNegativeMargins = (direction) => {
      const xAxis = ["left", "right"];
      const yAxis = ["top", "bottom"];
      const directionValues = {
        top: props.top,
        bottom: props.bottom,
        left: props.left,
        right: props.right,
        horizontal: props.horizontal,
        vertical: props.vertical
      };
      if (directionValues[direction]) {
        return directionValues[direction];
      } else if (!yAxis.includes(direction) && props.horizontal) {
        return directionValues.horizontal;
      } else if (!xAxis.includes(direction) && props.vertical) {
        return directionValues.vertical;
      } else {
        return props.spacing;
      }
    };
    const negativeMargins = computed(() => {
      return {
        top: getNegativeMargins("top"),
        left: getNegativeMargins("left"),
        right: getNegativeMargins("right"),
        bottom: getNegativeMargins("bottom")
      };
    });
    const style2 = computed(() => {
      const fullStyles = __spreadValues(__spreadValues(__spreadValues(__spreadValues({}, negativeMargins.value.bottom ? { "--pc-bleed-margin-bottom": `var(--p-space-${negativeMargins.value.bottom})` } : void 0), negativeMargins.value.left ? { "--pc-bleed-margin-left": `var(--p-space-${negativeMargins.value.left})` } : void 0), negativeMargins.value.right ? { "--pc-bleed-margin-right": `var(--p-space-${negativeMargins.value.right})` } : void 0), negativeMargins.value.top ? { "--pc-bleed-margin-top": `var(--p-space-${negativeMargins.value.top})` } : void 0);
      return Object.keys(fullStyles).reduce((acc, key) => {
        if (fullStyles[key] !== void 0) {
          acc[key] = fullStyles[key];
        }
        return acc;
      }, {});
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(unref(styles$1L).Bleed),
        style: normalizeStyle(unref(style2))
      }, [
        renderSlot(_ctx.$slots, "default")
      ], 6);
    };
  }
});
const Box = "Polaris-Box";
var styles$1K = {
  Box
};
var Box_vue_vue_type_style_index_0_lang = "";
const _sfc_main$2V = /* @__PURE__ */ defineComponent({
  props: {
    as: { default: "div" },
    background: null,
    border: null,
    borderBlockEnd: null,
    borderInlineStart: null,
    borderInlineEnd: null,
    borderBlockStart: null,
    borderRadius: null,
    borderRadiusEndStart: null,
    borderRadiusEndEnd: null,
    borderRadiusStartStart: null,
    borderRadiusStartEnd: null,
    borderWidth: null,
    borderBlockStartWidth: null,
    borderBlockEndWidth: null,
    borderInlineStartWidth: null,
    borderInlineEndWidth: null,
    color: null,
    id: null,
    minHeight: null,
    minWidth: null,
    maxWidth: null,
    overflowX: null,
    overflowY: null,
    padding: null,
    paddingBlockStart: null,
    paddingBlockEnd: null,
    paddingInlineStart: null,
    paddingInlineEnd: null,
    shadow: null,
    width: null
  },
  setup(__props) {
    const props = __props;
    const borders = computed(() => ({
      blockEnd: props.borderBlockEnd,
      inlineStart: props.borderInlineStart,
      inlineEnd: props.borderInlineEnd,
      blockStart: props.borderBlockStart
    }));
    const borderRadiuses = computed(() => ({
      endStart: props.borderRadiusEndStart,
      endEnd: props.borderRadiusEndEnd,
      startStart: props.borderRadiusStartStart,
      startEnd: props.borderRadiusStartEnd
    }));
    const borderWidths = computed(() => ({
      blockStart: props.borderBlockStartWidth,
      blockEnd: props.borderBlockEndWidth,
      inlineStart: props.borderInlineStartWidth,
      inlineEnd: props.borderInlineEndWidth
    }));
    const paddings = computed(() => ({
      blockEnd: props.paddingBlockEnd,
      inlineStart: props.paddingInlineStart,
      inlineEnd: props.paddingInlineEnd,
      blockStart: props.paddingBlockStart
    }));
    const style2 = computed(() => {
      const fullStyle = {
        "--pc-box-color": props.color ? `var(--p-${props.color})` : void 0,
        "--pc-box-background": props.background ? `var(--p-${props.background})` : void 0,
        "--pc-box-border": props.border ? `var(--p-border-${props.border})` : void 0,
        "--pc-box-border-block-end": borders.value.blockEnd ? `var(--p-border-${borders.value.blockEnd})` : void 0,
        "--pc-box-border-inline-start": borders.value.inlineStart ? `var(--p-border-${borders.value.inlineStart})` : void 0,
        "--pc-box-border-inline-end": borders.value.inlineEnd ? `var(--p-border-${borders.value.inlineEnd})` : void 0,
        "--pc-box-border-block-start": borders.value.blockStart ? `var(--p-border-${borders.value.blockStart})` : void 0,
        "--pc-box-border-radius": props.borderRadius ? `var(--p-border-radius-${props.borderRadius})` : void 0,
        "--pc-box-border-radius-end-start": borderRadiuses.value.endStart ? `var(--p-border-radius-${borderRadiuses.value.endStart})` : void 0,
        "--pc-box-border-radius-end-end": borderRadiuses.value.endEnd ? `var(--p-border-radius-${borderRadiuses.value.endEnd})` : void 0,
        "--pc-box-border-radius-start-start": borderRadiuses.value.startStart ? `var(--p-border-radius-${borderRadiuses.value.startStart})` : void 0,
        "--pc-box-border-radius-start-end": borderRadiuses.value.startEnd ? `var(--p-border-radius-${borderRadiuses.value.startEnd})` : void 0,
        "--pc-box-border-width": props.borderWidth ? `var(--p-border-width-${props.borderWidth})` : void 0,
        "--pc-box-border-block-start-width": borderWidths.value.blockStart ? `var(--p-border-width-${borderWidths.value.blockStart})` : void 0,
        "--pc-box-border-block-end-width": borderWidths.value.blockEnd ? `var(--p-border-width-${borderWidths.value.blockEnd})` : void 0,
        "--pc-box-border-inline-start-width": borderWidths.value.inlineStart ? `var(--p-border-width-${borderWidths.value.inlineStart})` : void 0,
        "--pc-box-border-inline-end-width": borderWidths.value.inlineEnd ? `var(--p-border-width-${borderWidths.value.inlineEnd})` : void 0,
        "--pc-box-min-height": props.minHeight,
        "--pc-box-min-width": props.minWidth,
        "--pc-box-max-width": props.maxWidth,
        "--pc-box-overflow-x": props.overflowX,
        "--pc-box-overflow-y": props.overflowY,
        "--pc-box-padding": props.padding ? `var(--p-space-${props.padding})` : void 0,
        "--pc-box-padding-block-end": paddings.value.blockEnd ? `var(--p-space-${paddings.value.blockEnd})` : void 0,
        "--pc-box-padding-inline-start": paddings.value.inlineStart ? `var(--p-space-${paddings.value.inlineStart})` : void 0,
        "--pc-box-padding-inline-end": paddings.value.inlineEnd ? `var(--p-space-${paddings.value.inlineEnd})` : void 0,
        "--pc-box-padding-block-start": paddings.value.blockStart ? `var(--p-space-${paddings.value.blockStart})` : void 0,
        "--pc-box-shadow": props.shadow ? `var(--p-shadow-${props.shadow})` : void 0,
        "--pc-box-width": props.width
      };
      return Object.keys(fullStyle).reduce((acc, key) => {
        if (fullStyle[key] !== void 0) {
          acc[key] = fullStyle[key];
        }
        return acc;
      }, {});
    });
    const className = classNames(styles$1K.Box);
    return (_ctx, _cache) => {
      return openBlock(), createBlock(resolveDynamicComponent(__props.as), {
        class: normalizeClass(unref(className)),
        id: __props.id,
        ref,
        style: normalizeStyle(unref(style2))
      }, {
        default: withCtx(() => [
          renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }, 8, ["class", "id", "style"]);
    };
  }
});
const Breadcrumb = "Polaris-Breadcrumbs__Breadcrumb";
const Icon$b = "Polaris-Breadcrumbs__Icon";
const Content$b = "Polaris-Breadcrumbs__Content";
var styles$1J = {
  Breadcrumb,
  Icon: Icon$b,
  Content: Content$b
};
const _hoisted_1$1p = {
  viewBox: "0 0 20 20",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$M = /* @__PURE__ */ createElementVNode("path", { d: "M17 9H5.414l3.293-3.293a.999.999 0 1 0-1.414-1.414l-5 5a.999.999 0 0 0 0 1.414l5 5a.997.997 0 0 0 1.414 0 .999.999 0 0 0 0-1.414L5.414 11H17a1 1 0 1 0 0-2z" }, null, -1);
const _hoisted_3$w = [
  _hoisted_2$M
];
function render$m(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1$1p, _hoisted_3$w);
}
var ArrowLeftMinor = { render: render$m };
var Breadcrumbs_vue_vue_type_style_index_0_lang = "";
const _hoisted_1$1o = {
  key: 0,
  role: "navigation"
};
const _hoisted_2$L = ["aria-label"];
const _sfc_main$2U = /* @__PURE__ */ defineComponent({
  props: {
    breadcrumbs: null
  },
  setup(__props) {
    const props = __props;
    const breadcrumb = ref(props.breadcrumbs[props.breadcrumbs.length - 1]);
    const linkUrl = computed(() => {
      const { url } = breadcrumb.value;
      return url;
    });
    const callbackOnAction = computed(() => {
      const { onAction } = breadcrumb.value;
      return onAction;
    });
    return (_ctx, _cache) => {
      return breadcrumb.value ? (openBlock(), createElementBlock("nav", _hoisted_1$1o, [
        unref(linkUrl) ? (openBlock(), createBlock(unref(_sfc_main$3m), {
          key: 0,
          url: unref(linkUrl),
          class: normalizeClass(unref(styles$1J).Breadcrumb),
          "aria-label": breadcrumb.value.accessibilityLabel,
          onMouseup: unref(handleMouseUpByBlurring)
        }, {
          default: withCtx(() => [
            createElementVNode("span", {
              class: normalizeClass(unref(styles$1J).Icon)
            }, [
              createVNode(unref(_sfc_main$2K), { source: unref(ArrowLeftMinor) }, null, 8, ["source"])
            ], 2),
            createVNode(unref(Text), {
              variant: "bodySm",
              as: "span",
              "visually-hidden": "",
              color: "subdued"
            }, {
              default: withCtx(() => [
                createTextVNode(toDisplayString(breadcrumb.value.content), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["url", "class", "aria-label", "onMouseup"])) : (openBlock(), createElementBlock("button", {
          key: 1,
          type: "button",
          class: normalizeClass(unref(styles$1J).Breadcrumb),
          "aria-label": breadcrumb.value.accessibilityLabel,
          onMouseup: _cache[0] || (_cache[0] = (...args) => unref(handleMouseUpByBlurring) && unref(handleMouseUpByBlurring)(...args)),
          onClick: _cache[1] || (_cache[1] = (...args) => unref(callbackOnAction) && unref(callbackOnAction)(...args))
        }, [
          createElementVNode("span", {
            class: normalizeClass(unref(styles$1J).Icon)
          }, [
            createVNode(unref(_sfc_main$2K), { source: unref(ArrowLeftMinor) }, null, 8, ["source"])
          ], 2),
          createVNode(unref(Text), {
            variant: "bodySm",
            as: "span",
            "visually-hidden": "",
            color: "subdued"
          }, {
            default: withCtx(() => [
              createTextVNode(toDisplayString(breadcrumb.value.content), 1)
            ]),
            _: 1
          })
        ], 42, _hoisted_2$L))
      ])) : createCommentVNode("", true);
    };
  }
});
function clamp(number, min, max) {
  if (number < min)
    return min;
  if (number > max)
    return max;
  return number;
}
const Group = "Polaris-BulkActions__Group";
const ButtonGroupWrapper = "Polaris-BulkActions__ButtonGroupWrapper";
const BulkActionButton = "Polaris-BulkActions__BulkActionButton";
const CheckableContainer = "Polaris-BulkActions__CheckableContainer";
const disabled$9 = "Polaris-BulkActions--disabled";
const PaginatedSelectAll = "Polaris-BulkActions__PaginatedSelectAll";
const Slide = "Polaris-BulkActions__Slide";
var styles$1I = {
  Group,
  "Group-measuring": "Polaris-BulkActions__Group--measuring",
  "Group-entering": "Polaris-BulkActions__Group--entering",
  "Group-exiting": "Polaris-BulkActions__Group--exiting",
  "Group-entered": "Polaris-BulkActions__Group--entered",
  "Group-exited": "Polaris-BulkActions__Group--exited",
  "Group-smallScreen": "Polaris-BulkActions__Group--smallScreen",
  "Group-largeScreen": "Polaris-BulkActions__Group--largeScreen",
  ButtonGroupWrapper,
  BulkActionButton,
  CheckableContainer,
  disabled: disabled$9,
  PaginatedSelectAll,
  Slide,
  "Slide-appear": "Polaris-BulkActions__Slide--appear",
  "Slide-enter": "Polaris-BulkActions__Slide--enter",
  "Slide-exit": "Polaris-BulkActions__Slide--exit",
  "Slide-appearing": "Polaris-BulkActions__Slide--appearing",
  "Slide-entering": "Polaris-BulkActions__Slide--entering"
};
const _sfc_main$2T = /* @__PURE__ */ defineComponent({
  props: {
    disclosure: { type: Boolean },
    indicator: { type: Boolean },
    url: null,
    external: { type: Boolean },
    content: null,
    accessibilityLabel: null,
    disabled: { type: Boolean }
  },
  emits: ["handle-measurement", "action"],
  setup(__props, { emit: emits }) {
    const bulkActionButton = ref(null);
    onMounted(() => {
      if (bulkActionButton.value) {
        const width = bulkActionButton.value.getBoundingClientRect().width;
        emits("handle-measurement", width);
      }
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(unref(styles$1I).BulkActionButton),
        ref_key: "bulkActionButton",
        ref: bulkActionButton
      }, [
        createVNode(unref(_sfc_main$2F), {
          external: __props.external,
          url: __props.url,
          "aria-label": __props.accessibilityLabel,
          disabled: __props.disabled,
          disclosure: __props.disclosure,
          onClick: _cache[0] || (_cache[0] = ($event) => emits("action"))
        }, {
          default: withCtx(() => [
            createTextVNode(toDisplayString(__props.content), 1)
          ]),
          _: 1
        }, 8, ["external", "url", "aria-label", "disabled", "disclosure"]),
        __props.indicator ? (openBlock(), createBlock(unref(_sfc_main$1s), { key: 0 })) : createCommentVNode("", true)
      ], 2);
    };
  }
});
const _sfc_main$2S = /* @__PURE__ */ defineComponent({
  props: {
    actions: null,
    title: null,
    isNewBadgeInBadgeActions: { type: Boolean }
  },
  setup(__props) {
    const isVisible = ref(false);
    const toggleMenuVisibility = () => {
      isVisible.value = !isVisible.value;
    };
    return (_ctx, _cache) => {
      return openBlock(), createBlock(unref(_sfc_main$2L), {
        active: isVisible.value,
        preferInputActivator: "",
        onClose: toggleMenuVisibility
      }, {
        activator: withCtx(() => [
          createVNode(unref(_sfc_main$2T), {
            disclosure: true,
            content: __props.title,
            indicator: __props.isNewBadgeInBadgeActions,
            onAction: toggleMenuVisibility
          }, null, 8, ["content", "indicator"])
        ]),
        content: withCtx(() => [
          createVNode(unref(_sfc_main$3h), {
            items: __props.actions,
            onActionAnyItem: toggleMenuVisibility
          }, null, 8, ["items"])
        ]),
        _: 1
      }, 8, ["active"]);
    };
  }
});
var BulkActions_vue_vue_type_style_index_0_lang = "";
const _hoisted_1$1n = {
  key: 0,
  "aria-live": "polite"
};
const _hoisted_2$K = {
  key: 0,
  "aria-live": "polite"
};
const _sfc_main$2R = /* @__PURE__ */ defineComponent({
  props: {
    accessibilityLabel: null,
    smallScreen: { type: Boolean },
    label: null,
    selected: { type: [Boolean, String] },
    selectMode: { type: Boolean },
    promotedActions: null,
    actions: null,
    paginatedSelectAllText: null,
    paginatedSelectAllAction: null,
    disabled: { type: Boolean }
  },
  emits: ["toggle-all", "select-mode-toggle", "more-action-popover-toggle"],
  setup(__props, { emit: emits }) {
    const props = __props;
    const i18n = UseI18n();
    const smallScreenPopoverVisible = ref(false);
    const largeScreenPopoverVisible = ref(false);
    const containerWidth = ref(0);
    const measuring2 = ref(true);
    const containerNode = ref(null);
    const largeScreenButtonsNode = ref(null);
    const moreActionsNode = ref(null);
    const checkableWrapperNode = ref(null);
    const largeScreenGroupNode = ref(null);
    const smallScreenGroupNode = ref(null);
    const promotedActionsWidths = ref([]);
    const bulkActionsWidth = ref(0);
    const addedMoreActionsWidthForMeasuring = ref(0);
    const handleResize = debounce(() => {
      if (containerNode.value) {
        const tmpContainerWidth = containerNode.value.getBoundingClientRect().width;
        if (tmpContainerWidth > 0) {
          containerWidth.value = tmpContainerWidth;
        }
      }
      if (smallScreenPopoverVisible.value || largeScreenPopoverVisible.value) {
        smallScreenPopoverVisible.value = false;
        largeScreenPopoverVisible.value = false;
      }
    }, 50, { trailing: true });
    const numberOfPromotedActionsToRender = computed(() => {
      if (!props.promotedActions) {
        return 0;
      }
      if (containerWidth.value >= bulkActionsWidth.value || measuring2.value) {
        return props.promotedActions.length;
      }
      let sufficientSpace = false;
      let counter = props.promotedActions.length - 1;
      let totalWidth = 0;
      while (!sufficientSpace && counter >= 0) {
        totalWidth += promotedActionsWidths.value[counter];
        const widthWithRemovedAction = bulkActionsWidth.value - totalWidth + addedMoreActionsWidthForMeasuring.value;
        if (containerWidth.value >= widthWithRemovedAction) {
          sufficientSpace = true;
        } else {
          counter--;
        }
      }
      return clamp(counter, 0, props.promotedActions.length);
    });
    const actionSectionsHandler = () => {
      if (!props.actions || props.actions.length === 0) {
        return;
      }
      if (instanceOfBulkActionListSectionArray(props.actions)) {
        return props.actions;
      }
      if (instanceOfBulkActionArray(props.actions)) {
        return [{ items: props.actions }];
      }
      return void 0;
    };
    const actionSections = computed(actionSectionsHandler);
    const checkableButtonProps = computed(() => {
      return {
        accessibilityLabel: props.accessibilityLabel,
        label: props.label,
        selected: props.selected,
        selectMode: props.selectMode,
        measuring: measuring2.value,
        disabled: props.disabled
      };
    });
    const rolledInPromotedActions = computed(() => {
      const number = numberOfPromotedActionsToRender.value;
      if (!props.promotedActions || props.promotedActions.length === 0 || number >= props.promotedActions.length) {
        return [];
      }
      const rolled = props.promotedActions.map((action) => {
        if (instanceOfMenuGroupDescriptor(action)) {
          const group = action;
          return { items: [...group.actions] };
        }
        return { items: [action] };
      });
      return rolled.slice(number);
    });
    const isNewBadgeInBadgeActions = computed(() => {
      var _a;
      const actions = actionSectionsHandler();
      if (!actions) {
        return false;
      }
      for (const action of actions) {
        for (const item of action.items) {
          if (((_a = item.badge) == null ? void 0 : _a.status) === "new") {
            return true;
          }
        }
      }
      return false;
    });
    const combinedActions = computed(() => {
      if (actionSections.value && rolledInPromotedActions.value.length > 0) {
        return [...rolledInPromotedActions.value, ...actionSections.value];
      }
      if (actionSections.value) {
        return actionSections.value;
      }
      if (rolledInPromotedActions.value.length > 0) {
        return rolledInPromotedActions.value;
      }
      return [];
    });
    const smallScreenGroupClassName = computed(() => classNames(styles$1I.Group, styles$1I["Group-smallScreen"], styles$1I["Group-entered"]));
    const largeScreenGroupClassName = computed(() => classNames(styles$1I.Group, styles$1I["Group-largeScreen"], !measuring2.value && styles$1I["Group-entered"], measuring2.value && styles$1I["Group-measuring"]));
    const activatorLabel = computed(() => {
      return !props.promotedActions || props.promotedActions && numberOfPromotedActionsToRender.value === 0 && !measuring2.value ? i18n.translate("Polaris.ResourceList.BulkActions.actionsActivatorLabel") : i18n.translate("Polaris.ResourceList.BulkActions.moreActionsActivatorLabel");
    });
    const hasActionsPopover = computed(() => actionSections.value || rolledInPromotedActions.value.length > 0 || measuring2.value);
    const initialRenderer = () => {
      setTimeout(() => {
        if (props.promotedActions && !props.actions && moreActionsNode.value) {
          addedMoreActionsWidthForMeasuring.value = moreActionsNode.value.getBoundingClientRect().width;
        }
        bulkActionsWidth.value = largeScreenButtonsNode.value ? largeScreenButtonsNode.value.getBoundingClientRect().width - addedMoreActionsWidthForMeasuring.value : 0;
        if (containerNode.value) {
          containerWidth.value = containerNode.value.getBoundingClientRect().width;
          measuring2.value = false;
        }
      }, 1);
    };
    onMounted(() => {
      initialRenderer();
    });
    watch(() => props.selectMode, initialRenderer);
    const onTransitionBeforeEnter = (el) => {
      el.classList.add(styles$1I["Slide-enter"]);
    };
    const onTransitionEnter = (el, done) => {
      setTimeout(() => {
        el.classList.add(styles$1I["Slide-entering"]);
        done();
      }, 1);
    };
    const onTransitionAfterEnter = (el) => {
      el.classList.remove(styles$1I["Slide-enter"], styles$1I["Slide-entering"]);
    };
    const toggleSmallScreenPopover = () => {
      emits("more-action-popover-toggle", smallScreenPopoverVisible.value);
      smallScreenPopoverVisible.value = !smallScreenPopoverVisible.value;
    };
    const toggleLargeScreenPopover = () => {
      emits("more-action-popover-toggle", largeScreenPopoverVisible.value);
      largeScreenPopoverVisible.value = !largeScreenPopoverVisible.value;
    };
    const handleMeasurement = (width) => {
      if (measuring2.value) {
        promotedActionsWidths.value.push(width);
      }
    };
    const setSelectMode = (val) => {
      emits("select-mode-toggle", val);
    };
    const bulkActionPropsGenerate = (action) => {
      return action;
    };
    function instanceOfBulkActionListSectionArray(actions) {
      const validList = actions.filter((action) => {
        return action.items;
      });
      return actions.length === validList.length;
    }
    function instanceOfBulkActionArray(actions) {
      const validList = actions.filter((action) => {
        return !action.items;
      });
      return actions.length === validList.length;
    }
    function instanceOfMenuGroupDescriptor(action) {
      return !!action["title"];
    }
    return (_ctx, _cache) => {
      var _a, _b;
      return __props.selectMode ? (openBlock(), createElementBlock("div", {
        key: 0,
        ref_key: "containerNode",
        ref: containerNode
      }, [
        __props.smallScreen ? (openBlock(), createElementBlock("div", {
          key: 0,
          class: normalizeClass(unref(smallScreenGroupClassName)),
          ref_key: "smallScreenGroupNode",
          ref: smallScreenGroupNode
        }, [
          createElementVNode("div", {
            class: normalizeClass(unref(styles$1I).ButtonGroupWrapper)
          }, [
            createVNode(unref(_sfc_main$2C), {
              segmented: "",
              "no-item-wrap": ""
            }, {
              default: withCtx(() => [
                createVNode(unref(_sfc_main$2D), null, {
                  default: withCtx(() => [
                    createVNode(Transition, {
                      name: "custom-bulkactions-transition",
                      appear: "",
                      class: normalizeClass(unref(styles$1I).Slide),
                      onBeforeEnter: onTransitionBeforeEnter,
                      onEnter: onTransitionEnter,
                      onAfterEnter: onTransitionAfterEnter
                    }, {
                      default: withCtx(() => [
                        createElementVNode("div", {
                          class: normalizeClass(unref(styles$1I).CheckableContainer),
                          ref_key: "checkableWrapperNode",
                          ref: checkableWrapperNode
                        }, [
                          createVNode(unref(_sfc_main$2v), mergeProps(unref(checkableButtonProps), {
                            onToggleAll: _cache[0] || (_cache[0] = ($event) => emits("toggle-all")),
                            smallScreen: ""
                          }), null, 16)
                        ], 2)
                      ]),
                      _: 1
                    }, 8, ["class"])
                  ]),
                  _: 1
                }),
                unref(actionSections) || unref(rolledInPromotedActions).length > 0 || measuring2.value ? (openBlock(), createBlock(unref(_sfc_main$2D), {
                  key: 0,
                  ref_key: "moreActionsNode",
                  ref: moreActionsNode
                }, {
                  default: withCtx(() => [
                    createVNode(unref(_sfc_main$2L), {
                      active: smallScreenPopoverVisible.value && __props.selectMode,
                      onClose: toggleSmallScreenPopover
                    }, {
                      activator: withCtx(() => [
                        createVNode(unref(_sfc_main$2T), {
                          disclosure: "",
                          content: unref(i18n).translate("Polaris.ResourceList.BulkActions.actionsActivatorLabel"),
                          disabled: __props.disabled,
                          indicator: unref(isNewBadgeInBadgeActions),
                          onAction: toggleSmallScreenPopover
                        }, null, 8, ["content", "disabled", "indicator"])
                      ]),
                      content: withCtx(() => [
                        createVNode(unref(_sfc_main$3h), {
                          items: __props.promotedActions,
                          sections: unref(actionSections),
                          onActionAnyItem: toggleSmallScreenPopover
                        }, null, 8, ["items", "sections"])
                      ]),
                      _: 1
                    }, 8, ["active"])
                  ]),
                  _: 1
                }, 512)) : createCommentVNode("", true),
                createVNode(unref(_sfc_main$2D), null, {
                  default: withCtx(() => [
                    createVNode(unref(_sfc_main$2F), {
                      disabled: __props.disabled,
                      onClick: _cache[1] || (_cache[1] = ($event) => setSelectMode(false))
                    }, {
                      default: withCtx(() => [
                        createTextVNode(toDisplayString(unref(i18n).translate("Polaris.Common.cancel")), 1)
                      ]),
                      _: 1
                    }, 8, ["disabled"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ], 2),
          __props.paginatedSelectAllAction ? (openBlock(), createElementBlock("div", {
            key: 0,
            class: normalizeClass(unref(styles$1I).PaginatedSelectAll)
          }, [
            __props.paginatedSelectAllText && __props.paginatedSelectAllAction ? (openBlock(), createElementBlock("span", _hoisted_1$1n, toDisplayString(__props.paginatedSelectAllText) + "\xA0", 1)) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
              createTextVNode(toDisplayString(__props.paginatedSelectAllText), 1)
            ], 64)),
            __props.paginatedSelectAllAction && __props.paginatedSelectAllAction.onAction ? (openBlock(), createBlock(unref(_sfc_main$2F), {
              key: 2,
              plain: "",
              disabled: __props.disabled,
              onClick: (_a = __props.paginatedSelectAllAction) == null ? void 0 : _a.onAction
            }, {
              default: withCtx(() => [
                createTextVNode(toDisplayString(__props.paginatedSelectAllAction.content), 1)
              ]),
              _: 1
            }, 8, ["disabled", "onClick"])) : createCommentVNode("", true)
          ], 2)) : createCommentVNode("", true)
        ], 2)) : (openBlock(), createElementBlock("div", {
          key: 1,
          class: normalizeClass(unref(largeScreenGroupClassName)),
          ref_key: "largeScreenGroupNode",
          ref: largeScreenGroupNode
        }, [
          createVNode(unref(_sfc_main$33), {
            event: "resize",
            handler: unref(handleResize)
          }, null, 8, ["handler"]),
          createElementVNode("div", {
            class: normalizeClass(unref(styles$1I).ButtonGroupWrapper),
            ref_key: "largeScreenButtonsNode",
            ref: largeScreenButtonsNode
          }, [
            __props.promotedActions && unref(numberOfPromotedActionsToRender) > 0 || unref(hasActionsPopover) ? (openBlock(), createBlock(unref(_sfc_main$2C), {
              key: 0,
              segmented: "",
              "no-item-wrap": ""
            }, {
              default: withCtx(() => [
                createVNode(unref(_sfc_main$2D), null, {
                  default: withCtx(() => [
                    createVNode(unref(_sfc_main$2v), mergeProps(unref(checkableButtonProps), {
                      onToggleAll: _cache[2] || (_cache[2] = ($event) => emits("toggle-all"))
                    }), null, 16)
                  ]),
                  _: 1
                }),
                __props.promotedActions && unref(numberOfPromotedActionsToRender) > 0 ? (openBlock(true), createElementBlock(Fragment, { key: 0 }, renderList(__props.promotedActions.slice(0, unref(numberOfPromotedActionsToRender)), (action, index) => {
                  return openBlock(), createBlock(unref(_sfc_main$2D), { key: index }, {
                    default: withCtx(() => [
                      instanceOfMenuGroupDescriptor(action) ? (openBlock(), createBlock(unref(_sfc_main$2S), mergeProps({ key: 0 }, bulkActionPropsGenerate(action), { isNewBadgeInBadgeActions: unref(isNewBadgeInBadgeActions) }), null, 16, ["isNewBadgeInBadgeActions"])) : (openBlock(), createBlock(unref(_sfc_main$2T), mergeProps({
                        key: 1,
                        disabled: __props.disabled
                      }, action, { handleMeasurement }), null, 16, ["disabled"]))
                    ]),
                    _: 2
                  }, 1024);
                }), 128)) : createCommentVNode("", true),
                unref(hasActionsPopover) ? (openBlock(), createBlock(unref(_sfc_main$2D), { key: 1 }, {
                  default: withCtx(() => [
                    createElementVNode("div", {
                      ref_key: "moreActionsNode",
                      ref: moreActionsNode
                    }, [
                      createVNode(unref(_sfc_main$2L), {
                        active: largeScreenPopoverVisible.value && __props.selectMode,
                        onClose: toggleLargeScreenPopover
                      }, {
                        activator: withCtx(() => [
                          createVNode(unref(_sfc_main$2T), {
                            disclosure: "",
                            content: unref(activatorLabel),
                            disabled: __props.disabled,
                            indicator: unref(isNewBadgeInBadgeActions),
                            onAction: toggleLargeScreenPopover
                          }, null, 8, ["content", "disabled", "indicator"])
                        ]),
                        content: withCtx(() => [
                          createVNode(unref(_sfc_main$3h), {
                            sections: unref(combinedActions),
                            onActionAnyItem: toggleLargeScreenPopover
                          }, null, 8, ["sections"])
                        ]),
                        _: 1
                      }, 8, ["active"])
                    ], 512)
                  ]),
                  _: 1
                })) : createCommentVNode("", true)
              ]),
              _: 1
            })) : (openBlock(), createBlock(unref(_sfc_main$2v), mergeProps({ key: 1 }, unref(checkableButtonProps), {
              onToggleAll: _cache[3] || (_cache[3] = ($event) => emits("toggle-all"))
            }), null, 16))
          ], 2),
          __props.paginatedSelectAllAction ? (openBlock(), createElementBlock("div", {
            key: 0,
            class: normalizeClass(unref(styles$1I).PaginatedSelectAll)
          }, [
            __props.paginatedSelectAllText && __props.paginatedSelectAllAction ? (openBlock(), createElementBlock("span", _hoisted_2$K, toDisplayString(__props.paginatedSelectAllText) + "\xA0", 1)) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
              createTextVNode(toDisplayString(__props.paginatedSelectAllText), 1)
            ], 64)),
            __props.paginatedSelectAllAction && __props.paginatedSelectAllAction.onAction ? (openBlock(), createBlock(unref(_sfc_main$2F), {
              key: 2,
              plain: "",
              disabled: __props.disabled,
              onClick: (_b = __props.paginatedSelectAllAction) == null ? void 0 : _b.onAction
            }, {
              default: withCtx(() => [
                createTextVNode(toDisplayString(__props.paginatedSelectAllAction.content), 1)
              ]),
              _: 1
            }, 8, ["disabled", "onClick"])) : createCommentVNode("", true)
          ], 2)) : createCommentVNode("", true)
        ], 2))
      ], 512)) : createCommentVNode("", true);
    };
  }
});
function capitalize$1(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}
function useDisableClick(disabled2, handleClick) {
  const handleClickWrapper = (event) => {
    event.preventDefault();
    event.stopPropagation();
  };
  if (!disabled2) {
    const fallbackEvent = () => {
    };
    return handleClick || fallbackEvent;
  }
  return handleClickWrapper;
}
const Button$2 = "Polaris-Button";
const pressed$1 = "Polaris-Button--pressed";
const disabled$8 = "Polaris-Button--disabled";
const connectedDisclosure = "Polaris-Button--connectedDisclosure";
const Content$a = "Polaris-Button__Content";
const plain = "Polaris-Button--plain";
const textAlignLeft = "Polaris-Button--textAlignLeft";
const textAlignStart = "Polaris-Button--textAlignStart";
const textAlignCenter = "Polaris-Button--textAlignCenter";
const textAlignRight = "Polaris-Button--textAlignRight";
const textAlignEnd = "Polaris-Button--textAlignEnd";
const Icon$a = "Polaris-Button__Icon";
const fullWidth$7 = "Polaris-Button--fullWidth";
const hidden$2 = "Polaris-Button--hidden";
const Spinner$2 = "Polaris-Button__Spinner";
const primary = "Polaris-Button--primary";
const destructive = "Polaris-Button--destructive";
const outline = "Polaris-Button--outline";
const loading = "Polaris-Button--loading";
const removeUnderline$1 = "Polaris-Button--removeUnderline";
const iconOnly = "Polaris-Button--iconOnly";
const sizeSlim = "Polaris-Button--sizeSlim";
const sizeLarge$8 = "Polaris-Button--sizeLarge";
const monochrome$1 = "Polaris-Button--monochrome";
const Text$4 = "Polaris-Button__Text";
const ConnectedDisclosureWrapper = "Polaris-Button__ConnectedDisclosureWrapper";
const ConnectedDisclosure = "Polaris-Button__ConnectedDisclosure";
var styles$1H = {
  Button: Button$2,
  pressed: pressed$1,
  disabled: disabled$8,
  connectedDisclosure,
  Content: Content$a,
  plain,
  textAlignLeft,
  textAlignStart,
  textAlignCenter,
  textAlignRight,
  textAlignEnd,
  Icon: Icon$a,
  fullWidth: fullWidth$7,
  hidden: hidden$2,
  Spinner: Spinner$2,
  primary,
  destructive,
  outline,
  loading,
  removeUnderline: removeUnderline$1,
  iconOnly,
  sizeSlim,
  sizeLarge: sizeLarge$8,
  monochrome: monochrome$1,
  Text: Text$4,
  ConnectedDisclosureWrapper,
  ConnectedDisclosure
};
var PopoverCloseSource = /* @__PURE__ */ ((PopoverCloseSource2) => {
  PopoverCloseSource2[PopoverCloseSource2["Click"] = 0] = "Click";
  PopoverCloseSource2[PopoverCloseSource2["EscapeKeypress"] = 1] = "EscapeKeypress";
  PopoverCloseSource2[PopoverCloseSource2["FocusOut"] = 2] = "FocusOut";
  PopoverCloseSource2[PopoverCloseSource2["ScrollOut"] = 3] = "ScrollOut";
  return PopoverCloseSource2;
})(PopoverCloseSource || {});
var TransitionStatus = /* @__PURE__ */ ((TransitionStatus2) => {
  TransitionStatus2["Entering"] = "entering";
  TransitionStatus2["Entered"] = "entered";
  TransitionStatus2["Exiting"] = "exiting";
  TransitionStatus2["Exited"] = "exited";
  return TransitionStatus2;
})(TransitionStatus || {});
function nodeContainsDescendant(rootNode, descendant) {
  if (rootNode === descendant) {
    return true;
  }
  let parent = descendant.parentNode;
  while (parent != null) {
    if (parent === rootNode) {
      return true;
    }
    parent = parent.parentNode;
  }
  return false;
}
function setActivatorAttributes(activator, {
  id,
  active: active2 = false,
  ariaHaspopup,
  activatorDisabled = false
}) {
  if (!activatorDisabled) {
    activator.tabIndex = activator.tabIndex || 0;
  }
  activator.setAttribute("aria-controls", id);
  activator.setAttribute("aria-owns", id);
  activator.setAttribute("aria-expanded", String(active2));
  if (ariaHaspopup != null) {
    activator.setAttribute("aria-haspopup", String(ariaHaspopup));
  }
}
const PositionedOverlay = "Polaris-PositionedOverlay";
const fixed = "Polaris-PositionedOverlay--fixed";
const calculating = "Polaris-PositionedOverlay--calculating";
const preventInteraction = "Polaris-PositionedOverlay--preventInteraction";
var styles$1G = {
  PositionedOverlay,
  fixed,
  calculating,
  preventInteraction
};
const Popover$1 = "Polaris-Popover";
const PopoverOverlay = "Polaris-Popover__PopoverOverlay";
const measuring$2 = "Polaris-Popover--measuring";
const fullWidth$6 = "Polaris-Popover--fullWidth";
const Content$9 = "Polaris-Popover__Content";
const positionedAbove$1 = "Polaris-Popover--positionedAbove";
const Wrapper$3 = "Polaris-Popover__Wrapper";
const Pane = "Polaris-Popover__Pane";
const Section$7 = "Polaris-Popover__Section";
const FocusTracker = "Polaris-Popover__FocusTracker";
var styles$1F = {
  Popover: Popover$1,
  PopoverOverlay,
  "PopoverOverlay-entering": "Polaris-Popover__PopoverOverlay--entering",
  "PopoverOverlay-open": "Polaris-Popover__PopoverOverlay--open",
  "PopoverOverlay-exiting": "Polaris-Popover__PopoverOverlay--exiting",
  measuring: measuring$2,
  fullWidth: fullWidth$6,
  Content: Content$9,
  positionedAbove: positionedAbove$1,
  Wrapper: Wrapper$3,
  "Content-fullHeight": "Polaris-Popover__Content--fullHeight",
  "Content-fluidContent": "Polaris-Popover__Content--fluidContent",
  Pane,
  "Pane-fixed": "Polaris-Popover__Pane--fixed",
  Section: Section$7,
  FocusTracker,
  "PopoverOverlay-hideOnPrint": "Polaris-Popover__PopoverOverlay--hideOnPrint"
};
const TooltipOverlay = "Polaris-Tooltip-TooltipOverlay";
const measuring$1 = "Polaris-Tooltip-TooltipOverlay--measuring";
const positionedAbove = "Polaris-Tooltip-TooltipOverlay--positionedAbove";
const Content$8 = "Polaris-Tooltip-TooltipOverlay__Content";
var styles$1E = {
  TooltipOverlay,
  measuring: measuring$1,
  positionedAbove,
  Content: Content$8
};
function calculateVerticalPosition(activatorRect, overlayRect, overlayMargins, scrollableContainerRect, containerRect, preferredPosition, fixed2, topBarOffset = 0) {
  const activatorTop = activatorRect.top;
  const activatorBottom = activatorTop + activatorRect.height;
  const spaceAbove = activatorRect.top - topBarOffset;
  const spaceBelow = containerRect.height - activatorRect.top - activatorRect.height;
  const desiredHeight = overlayRect.height;
  const verticalMargins = overlayMargins.activator + overlayMargins.container;
  const minimumSpaceToScroll = overlayMargins.container;
  const distanceToTopScroll = activatorRect.top - Math.max(scrollableContainerRect.top, 0);
  const distanceToBottomScroll = containerRect.top + Math.min(containerRect.height, scrollableContainerRect.top + scrollableContainerRect.height) - (activatorRect.top + activatorRect.height);
  const enoughSpaceFromTopScroll = distanceToTopScroll >= minimumSpaceToScroll;
  const enoughSpaceFromBottomScroll = distanceToBottomScroll >= minimumSpaceToScroll;
  const heightIfBelow = Math.min(spaceBelow, desiredHeight);
  const heightIfAbove = Math.min(spaceAbove, desiredHeight);
  const containerRectTop = fixed2 ? 0 : containerRect.top;
  const positionIfAbove = {
    height: heightIfAbove - verticalMargins,
    top: activatorTop + containerRectTop - heightIfAbove,
    positioning: "above"
  };
  const positionIfBelow = {
    height: heightIfBelow - verticalMargins,
    top: activatorBottom + containerRectTop,
    positioning: "below"
  };
  if (preferredPosition === "above") {
    return (enoughSpaceFromTopScroll || distanceToTopScroll >= distanceToBottomScroll && !enoughSpaceFromBottomScroll) && (spaceAbove > desiredHeight || spaceAbove > spaceBelow) ? positionIfAbove : positionIfBelow;
  }
  if (preferredPosition === "below") {
    return (enoughSpaceFromBottomScroll || distanceToBottomScroll >= distanceToTopScroll && !enoughSpaceFromTopScroll) && (spaceBelow > desiredHeight || spaceBelow > spaceAbove) ? positionIfBelow : positionIfAbove;
  }
  if (enoughSpaceFromTopScroll && enoughSpaceFromBottomScroll) {
    return spaceAbove > spaceBelow ? positionIfAbove : positionIfBelow;
  }
  return distanceToTopScroll > minimumSpaceToScroll ? positionIfAbove : positionIfBelow;
}
function calculateHorizontalPosition(activatorRect, overlayRect, containerRect, overlayMargins, preferredAlignment) {
  const maximum = containerRect.width - overlayRect.width;
  if (preferredAlignment === "left") {
    return Math.min(maximum, Math.max(0, activatorRect.left - overlayMargins.horizontal));
  }
  if (preferredAlignment === "right") {
    const activatorRight = containerRect.width - (activatorRect.left + activatorRect.width);
    return Math.min(maximum, Math.max(0, activatorRight - overlayMargins.horizontal));
  }
  return Math.min(maximum, Math.max(0, activatorRect.center.x - overlayRect.width / 2));
}
function rectIsOutsideOfRect(inner, outer) {
  const { center: center2 } = inner;
  return center2.y < outer.top || center2.y > outer.top + outer.height;
}
function windowRect() {
  return new Rect({
    top: window.scrollY,
    left: window.scrollX,
    height: window.innerHeight,
    width: document.body.clientWidth
  });
}
function intersectionWithViewport(rect, viewport = windowRect()) {
  const top = Math.max(rect.top, 0);
  const left = Math.max(rect.left, 0);
  const bottom = Math.min(rect.top + rect.height, viewport.height);
  const right2 = Math.min(rect.left + rect.width, viewport.width);
  return new Rect({
    top,
    left,
    height: bottom - top,
    width: right2 - left
  });
}
function isDocument(node) {
  return node === document;
}
function getMarginsForNode(node) {
  const nodeStyles = window.getComputedStyle(node);
  return {
    activator: parseFloat(nodeStyles.marginTop || "0"),
    container: parseFloat(nodeStyles.marginBottom || "0"),
    horizontal: parseFloat(nodeStyles.marginLeft || "0")
  };
}
function getZIndexForLayerFromNode(node) {
  const layerNode = node.closest(layer.selector) || document.body;
  const zIndex2 = layerNode === document.body ? "auto" : parseInt(window.getComputedStyle(layerNode).zIndex || "0", 10);
  return zIndex2 === "auto" || Number.isNaN(zIndex2) ? null : zIndex2;
}
function forNode(node) {
  const closestElement = node.closest(scrollable.selector);
  return closestElement instanceof HTMLElement ? closestElement : document;
}
var PositionedOverlay_vue_vue_type_style_index_0_lang = "";
const __default__$e = {
  inheritAttrs: false
};
const _sfc_main$2Q = /* @__PURE__ */ defineComponent(__spreadProps(__spreadValues({}, __default__$e), {
  props: {
    active: { type: Boolean },
    activator: null,
    preferInputActivator: { type: Boolean },
    preferredPosition: null,
    preferredAlignment: null,
    fullWidth: { type: Boolean },
    fixed: { type: Boolean },
    preventInteraction: { type: Boolean },
    classNames: null,
    zIndexOverride: null,
    hideOnPrint: { type: Boolean },
    layout: null
  },
  emits: ["change-content-styles", "scroll-out"],
  setup(__props, { emit }) {
    const props = __props;
    const OBSERVER_CONFIG = {
      childList: true,
      subtree: true,
      characterData: true
    };
    const overlayRef = ref(null);
    const right2 = ref(null);
    const left = ref(null);
    const top = ref(0);
    const height = ref(0);
    const width = ref(null);
    const zIndex2 = ref(null);
    const measuring2 = ref(true);
    const positioning = ref("below");
    const activatorRect = ref(getRectForNode(props.activator));
    const lockPosition = ref(false);
    const outsideScrollableContainer = ref(false);
    const scrollableContainer = ref(null);
    const observer = ref(null);
    const className = computed(() => {
      const propClassNames = props.classNames;
      return classNames(styles$1G.PositionedOverlay, props.fixed && styles$1G.fixed, props.preventInteraction && styles$1G.preventInteraction, propClassNames);
    });
    const popoverClassName = computed(() => classNames(styles$1F.Popover, positioning.value === "above" && styles$1F.positionedAbove, props.fullWidth && styles$1F.fullWidth, measuring2.value && styles$1F.measuring, props.hideOnPrint && styles$1F["PopoverOverlay-hideOnPrint"]));
    const tooltipClassName = computed(() => classNames(styles$1E.TooltipOverlay, measuring2.value && styles$1E.measuring, positioning.value === "above" && styles$1E.positionedAbove));
    const style2 = computed(() => ({
      top: top.value == null || Number.isNaN(top.value) ? void 0 : `${top.value}px`,
      left: left.value == null || Number.isNaN(left.value) ? void 0 : `${left.value}px`,
      right: right2.value == null || Number.isNaN(right2.value) ? void 0 : `${right2.value}px`,
      width: width.value == null || Number.isNaN(width.value) ? void 0 : `${width.value}px`,
      zIndex: props.zIndexOverride || zIndex2.value || void 0
    }));
    const handleMeasurement = () => {
      if (observer.value) {
        observer.value.disconnect();
      }
      height.value = 0;
      positioning.value = "below";
      measuring2.value = true;
      if (overlayRef.value && scrollableContainer.value) {
        const {
          activator,
          preferredPosition = "below",
          preferredAlignment = "center",
          fullWidth: fullWidth2,
          fixed: fixed2,
          preferInputActivator = true
        } = props;
        const preferredActivator = preferInputActivator ? activator.querySelector("input") || activator : activator;
        const activatorRectValue = getRectForNode(preferredActivator);
        const currentOverlayRect = getRectForNode(overlayRef.value);
        const scrollableElement = isDocument(scrollableContainer.value) ? document.body : scrollableContainer.value;
        const scrollableContainerRect = getRectForNode(scrollableElement);
        const overlayRect = fullWidth2 ? new Rect(__spreadProps(__spreadValues({}, currentOverlayRect), { width: activatorRectValue.width })) : currentOverlayRect;
        if (scrollableElement === document.body) {
          scrollableContainerRect.height = document.body.scrollHeight;
        }
        let topBarOffset = 0;
        const topBarElement = scrollableElement.querySelector(`${dataPolarisTopBar.selector}`);
        if (topBarElement) {
          topBarOffset = topBarElement.clientHeight;
        }
        const overlayMargins = overlayRef.value.firstElementChild && overlayRef.value.firstChild ? getMarginsForNode(overlayRef.value.firstElementChild) : { activator: 0, container: 0, horizontal: 0 };
        const containerRect = windowRect();
        const zIndexForLayer = getZIndexForLayerFromNode(activator);
        const zIndexValue = zIndexForLayer == null ? zIndexForLayer : zIndexForLayer + 1;
        const verticalPosition = calculateVerticalPosition(activatorRectValue, overlayRect, overlayMargins, scrollableContainerRect, containerRect, preferredPosition, fixed2, topBarOffset);
        const horizontalPosition = calculateHorizontalPosition(activatorRectValue, overlayRect, containerRect, overlayMargins, preferredAlignment);
        measuring2.value = false;
        activatorRect.value = getRectForNode(activator);
        left.value = preferredAlignment !== "right" ? horizontalPosition : null;
        right2.value = preferredAlignment === "right" ? horizontalPosition : null;
        top.value = lockPosition.value ? top.value : verticalPosition.top;
        lockPosition.value = Boolean(fixed2);
        height.value = verticalPosition.height || 0;
        width.value = fullWidth2 ? overlayRect.width : null;
        positioning.value = verticalPosition.positioning;
        outsideScrollableContainer.value = rectIsOutsideOfRect(activatorRectValue, intersectionWithViewport(scrollableContainerRect));
        zIndex2.value = zIndexValue;
        emit("change-content-styles", { desiredHeight: height.value });
        if (observer.value) {
          observer.value.observe(overlayRef.value, OBSERVER_CONFIG);
          observer.value.observe(activator, OBSERVER_CONFIG);
        }
      }
    };
    onBeforeMount(() => {
      observer.value = new MutationObserver(handleMeasurement);
    });
    onUpdated(() => {
      if (props.active && top.value !== 0 && outsideScrollableContainer.value) {
        emit("scroll-out");
      }
    });
    onMounted(() => {
      scrollableContainer.value = forNode(props.activator);
      if (scrollableContainer.value && !props.fixed) {
        scrollableContainer.value.addEventListener("scroll", handleMeasurement);
      }
      handleMeasurement();
    });
    onBeforeUnmount(() => {
      if (scrollableContainer.value && !props.fixed) {
        scrollableContainer.value.removeEventListener("scroll", handleMeasurement);
      }
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(unref(className)),
        style: normalizeStyle(unref(style2)),
        ref_key: "overlayRef",
        ref: overlayRef
      }, [
        __props.layout === "tooltip" ? (openBlock(), createElementBlock("div", mergeProps({
          key: 0,
          class: unref(tooltipClassName)
        }, __spreadValues({}, unref(layer).props)), [
          renderSlot(_ctx.$slots, "default")
        ], 16)) : (openBlock(), createElementBlock("div", mergeProps({
          key: 1,
          class: unref(popoverClassName)
        }, __spreadValues({}, unref(overlay).props)), [
          renderSlot(_ctx.$slots, "default")
        ], 16)),
        createVNode(unref(_sfc_main$33), {
          event: "resize",
          handler: handleMeasurement
        })
      ], 6);
    };
  }
}));
const _sfc_main$2P = /* @__PURE__ */ defineComponent({
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(unref(styles$1F).Section)
      }, [
        renderSlot(_ctx.$slots, "default")
      ], 2);
    };
  }
});
const _sfc_main$2O = /* @__PURE__ */ defineComponent({
  props: {
    fixed: { type: Boolean },
    sectioned: { type: Boolean },
    height: null,
    captureOverscroll: { type: Boolean, default: false }
  },
  emits: ["scrolled-to-bottom"],
  setup(__props, { emit }) {
    const props = __props;
    const style2 = props.height ? { height: props.height, maxHeight: props.height, minHeight: props.height } : void 0;
    const className = computed(() => classNames(styles$1F.Pane, props.fixed && styles$1F["Pane-fixed"], props.captureOverscroll && styles$1F["Pane-captureOverscroll"]));
    return (_ctx, _cache) => {
      return __props.fixed ? (openBlock(), createElementBlock("div", {
        key: 0,
        style: normalizeStyle(unref(style2)),
        class: normalizeClass(unref(className))
      }, [
        __props.sectioned ? (openBlock(), createBlock(unref(_sfc_main$2P), { key: 0 }, {
          default: withCtx(() => [
            renderSlot(_ctx.$slots, "default")
          ]),
          _: 3
        })) : renderSlot(_ctx.$slots, "default", { key: 1 })
      ], 6)) : (openBlock(), createBlock(unref(_sfc_main$3o), {
        key: 1,
        shadow: "",
        style: normalizeStyle(unref(style2)),
        class: normalizeClass(unref(className)),
        onScrolledToBottom: _cache[0] || (_cache[0] = ($event) => emit("scrolled-to-bottom"))
      }, {
        default: withCtx(() => [
          __props.sectioned ? (openBlock(), createBlock(unref(_sfc_main$2P), { key: 0 }, {
            default: withCtx(() => [
              renderSlot(_ctx.$slots, "default")
            ]),
            _: 3
          })) : renderSlot(_ctx.$slots, "default", { key: 1 })
        ]),
        _: 3
      }, 8, ["style", "class"]));
    };
  }
});
const _hoisted_1$1m = ["id", "tabIndex"];
const __default__$d = {
  inheritAttrs: false
};
const _sfc_main$2N = /* @__PURE__ */ defineComponent(__spreadProps(__spreadValues({}, __default__$d), {
  props: {
    fullWidth: { type: Boolean },
    fullHeight: { type: Boolean },
    fluidContent: { type: Boolean },
    preferredPosition: { default: "below" },
    preferredAlignment: { default: "center" },
    active: { type: Boolean },
    id: null,
    zIndexOverride: { default: void 0 },
    activator: null,
    preferInputActivator: { default: true },
    sectioned: { type: Boolean },
    fixed: { type: Boolean },
    hideOnPrint: { type: Boolean },
    autofocusTarget: { default: "container" },
    preventCloseOnChildOverlayClick: { type: Boolean },
    captureOverscroll: { type: Boolean }
  },
  emits: ["close", "scrolled-to-bottom"],
  setup(__props, { emit }) {
    const props = __props;
    const transitionStatus = ref(TransitionStatus.Exited);
    const contentRef = ref(null);
    const enteringTimer = ref(null);
    const exitingTimer = ref(null);
    const contentStyles = ref({});
    const changeTransitionStatus = (status) => {
      transitionStatus.value = status;
      if (contentRef.value) {
        contentRef.value.getBoundingClientRect();
      }
    };
    const clearTransitionTimeout = () => {
      if (enteringTimer.value) {
        window.clearTimeout(enteringTimer.value);
      }
      if (exitingTimer.value) {
        window.clearTimeout(exitingTimer.value);
      }
    };
    watch(() => props.active, () => {
      const beforeStatus = props.active ? TransitionStatus.Entering : TransitionStatus.Exiting;
      const afterStatus = props.active ? TransitionStatus.Entered : TransitionStatus.Exited;
      changeTransitionStatus(beforeStatus);
      clearTransitionTimeout();
      const timer = window.setTimeout(() => {
        transitionStatus.value = afterStatus;
      }, parseInt(motion["duration-100"], 10));
      if (props.active) {
        enteringTimer.value = timer;
      } else {
        exitingTimer.value = timer;
      }
    });
    const className = computed(() => classNames(styles$1F.PopoverOverlay, transitionStatus.value === TransitionStatus.Entering && styles$1F["PopoverOverlay-entering"], transitionStatus.value === TransitionStatus.Entered && styles$1F["PopoverOverlay-open"], transitionStatus.value === TransitionStatus.Exiting && styles$1F["PopoverOverlay-exiting"]));
    const contentClassNames = computed(() => classNames(styles$1F.Content, props.fullHeight && styles$1F["Content-fullHeight"], props.fluidContent && styles$1F["Content-fluidContent"]));
    const handleScrollOut = () => {
      emit("close", PopoverCloseSource.ScrollOut);
    };
    const handleEscape = (event) => {
      const target = event.target;
      const composedPath = event.composedPath();
      const wasDescendant = wasContentNodeDescendant(composedPath, contentRef.value);
      const isActivatorDescendant = nodeContainsDescendant(props.activator, target);
      if (wasDescendant || isActivatorDescendant) {
        emit("close", PopoverCloseSource.EscapeKeypress);
      }
    };
    const handleClick = (event) => {
      const target = event.target;
      const composedPath = event.composedPath();
      const currentContainer = document.getElementById("PolarisPortalsContainer");
      const wasDescendant = props.preventCloseOnChildOverlayClick ? currentContainer && wasPolarisPortalDescendant(composedPath, currentContainer) : contentRef.value && wasContentNodeDescendant(composedPath, contentRef.value);
      const isActivatorDescendant = nodeContainsDescendant(props.activator, target);
      if (wasDescendant || isActivatorDescendant || transitionStatus.value !== TransitionStatus.Entered) {
        return;
      }
      emit("close", PopoverCloseSource.Click);
    };
    const handleFocusFirstItem = () => {
      emit("close", PopoverCloseSource.FocusOut);
    };
    const handleFocusLastItem = () => {
      emit("close", PopoverCloseSource.FocusOut);
    };
    const changeContentStyles = (value2) => {
      contentStyles.value = { desiredHeight: `${value2.height}px` };
    };
    const focusContent = () => {
      if (props.autofocusTarget === "none" || !contentRef.value) {
        return;
      }
      requestAnimationFrame(() => {
        if (contentRef.value) {
          const focusableChild = findFirstKeyboardFocusableNode(contentRef.value);
          if (focusableChild && props.autofocusTarget === "first-node") {
            focusableChild.focus();
          } else {
            contentRef.value.focus();
          }
        }
      });
    };
    onMounted(() => {
      if (props.active) {
        focusContent();
        changeTransitionStatus(TransitionStatus.Entered);
      }
    });
    onBeforeUnmount(() => {
      clearTransitionTimeout();
    });
    function wasContentNodeDescendant(composedPath, contentNode) {
      return contentNode != null && composedPath.includes(contentNode);
    }
    function wasPolarisPortalDescendant(composedPath, portalsContainerElement) {
      return composedPath.some((eventTarget) => eventTarget instanceof Node && (portalsContainerElement == null ? void 0 : portalsContainerElement.contains(eventTarget)));
    }
    return (_ctx, _cache) => {
      return openBlock(), createBlock(unref(_sfc_main$2Q), {
        id: __props.id,
        fullWidth: __props.fullWidth,
        active: __props.active,
        activator: __props.activator,
        classNames: unref(className),
        preferInputActivator: __props.preferInputActivator,
        fixed: __props.fixed,
        preferredPosition: __props.preferredPosition,
        preferredAlignment: __props.preferredAlignment,
        zIndexOverride: __props.zIndexOverride,
        onScrollOut: handleScrollOut,
        onChangeContentStyles: changeContentStyles
      }, {
        default: withCtx(() => [
          createElementVNode("div", {
            class: normalizeClass(unref(styles$1F).FocusTracker),
            tabIndex: "0",
            onFocus: handleFocusFirstItem
          }, null, 34),
          createElementVNode("div", {
            class: normalizeClass(unref(styles$1F).Wrapper)
          }, [
            createElementVNode("div", {
              id: __props.id,
              tabIndex: __props.autofocusTarget === "none" ? void 0 : -1,
              style: normalizeStyle(contentStyles.value),
              class: normalizeClass(unref(contentClassNames)),
              ref_key: "contentRef",
              ref: contentRef
            }, [
              renderSlot(_ctx.$slots, "extra-content"),
              createVNode(unref(_sfc_main$2O), {
                sectioned: __props.sectioned,
                fixed: __props.fixed,
                "capture-overscroll": __props.captureOverscroll,
                onScrolledToBottom: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("scrolled-to-bottom"))
              }, {
                default: withCtx(() => [
                  renderSlot(_ctx.$slots, "overlay")
                ]),
                _: 3
              }, 8, ["sectioned", "fixed", "capture-overscroll"])
            ], 14, _hoisted_1$1m)
          ], 2),
          createElementVNode("div", {
            class: normalizeClass(unref(styles$1F).FocusTracker),
            tabIndex: "0",
            onFocus: handleFocusLastItem
          }, null, 34),
          createVNode(unref(_sfc_main$33), {
            event: "click",
            handler: handleClick
          }),
          createVNode(unref(_sfc_main$33), {
            event: "touchstart",
            handler: handleClick
          }),
          createVNode(unref(_sfc_main$3p), {
            keyCode: unref(Key).Escape,
            handler: handleEscape
          }, null, 8, ["keyCode"])
        ]),
        _: 3
      }, 8, ["id", "fullWidth", "active", "activator", "classNames", "preferInputActivator", "fixed", "preferredPosition", "preferredAlignment", "zIndexOverride"]);
    };
  }
}));
const _hoisted_1$1l = ["data-portal-id"];
const __default__$c = {
  inheritAttrs: false
};
const _sfc_main$2M = /* @__PURE__ */ defineComponent(__spreadProps(__spreadValues({}, __default__$c), {
  props: {
    idPrefix: {
      type: String,
      default: ""
    }
  },
  setup(__props) {
    const props = __props;
    const portalManager = inject("portalManager", new PortalManager());
    const portalId = ref("");
    const { useUniqueId } = UseUniqueId();
    onMounted(() => {
      const uniqueId = useUniqueId("portal");
      portalId.value = props.idPrefix ? `${props.idPrefix}-${uniqueId}` : uniqueId;
      if (portalManager) {
        portalManager.register(portalId.value);
      }
    });
    return (_ctx, _cache) => {
      return unref(portalManager) ? (openBlock(), createBlock(Teleport, {
        key: 0,
        to: "#PolarisPortalsContainer"
      }, [
        createElementVNode("div", { "data-portal-id": portalId.value }, [
          renderSlot(_ctx.$slots, "default")
        ], 8, _hoisted_1$1l)
      ])) : createCommentVNode("", true);
    };
  }
}));
var Popover_vue_vue_type_style_index_0_lang = "";
const __default__$b = {
  inheritAttrs: false
};
const _sfc_main$2L = /* @__PURE__ */ defineComponent(__spreadProps(__spreadValues({}, __default__$b), {
  props: {
    preferredPosition: { default: void 0 },
    preferredAlignment: { default: void 0 },
    active: { type: Boolean },
    preferInputActivator: { default: true },
    activatorWrapper: { default: "div" },
    zIndexOverride: { default: void 0 },
    preventFocusOnClose: { type: Boolean },
    sectioned: { type: Boolean },
    fullWidth: { type: Boolean },
    fullHeight: { type: Boolean },
    fluidContent: { type: Boolean },
    fixed: { type: Boolean },
    ariaHaspopup: { default: void 0 },
    hideOnPrint: { type: Boolean },
    autofocusTarget: { default: "container" },
    preventCloseOnChildOverlayClick: { type: Boolean },
    captureOverscroll: { type: Boolean }
  },
  emits: ["close", "scrolled-to-bottom"],
  setup(__props, { emit }) {
    const props = __props;
    const container = ref(null);
    const activator = ref(null);
    const { useUniqueId } = UseUniqueId();
    useAttrs();
    const id = ref(useUniqueId("popover"));
    const setAccessibilityAttributes = () => {
      if (container.value) {
        const containerNode = container.value;
        const firstFocusable = findFirstFocusableNodeIncludingDisabled(containerNode);
        const focusableActivator = firstFocusable || containerNode;
        const activatorDisabled = "disabled" in focusableActivator && Boolean(focusableActivator.disabled);
        setActivatorAttributes(focusableActivator, {
          id: id.value,
          active: props.active,
          ariaHaspopup: props.ariaHaspopup,
          activatorDisabled
        });
      }
    };
    watch(() => props.active, () => setAccessibilityAttributes());
    const isInPortal = (element) => {
      let { parentElement } = element;
      while (parentElement) {
        if (parentElement.matches(portal.selector)) {
          return false;
        }
        parentElement = parentElement.parentElement;
      }
      return true;
    };
    const handleClose = (source) => {
      emit("close", source);
      if (!container.value || props.preventFocusOnClose) {
        return;
      }
      if ((source === PopoverCloseSource.FocusOut || source === PopoverCloseSource.EscapeKeypress) && activator.value) {
        const focusableActivator = findFirstFocusableNodeIncludingDisabled(activator.value) || findFirstFocusableNodeIncludingDisabled(container.value) || container.value;
        if (!focusNextFocusableNode(focusableActivator, isInPortal)) {
          focusableActivator.focus();
        }
      }
    };
    onMounted(() => {
      if (container.value) {
        const activatorNode = container.value.firstElementChild;
        if (activatorNode) {
          activator.value = activatorNode;
        }
        setAccessibilityAttributes();
      }
    });
    return (_ctx, _cache) => {
      return openBlock(), createBlock(resolveDynamicComponent(__props.activatorWrapper), {
        ref_key: "container",
        ref: container
      }, {
        default: withCtx(() => [
          renderSlot(_ctx.$slots, "activator"),
          activator.value && __props.active ? (openBlock(), createBlock(unref(_sfc_main$2M), {
            key: 0,
            idPrefix: "popover"
          }, {
            default: withCtx(() => [
              createVNode(unref(_sfc_main$2N), mergeProps({ id: id.value }, props, {
                activator: activator.value,
                onClose: handleClose,
                onScrolledToBottom: _cache[0] || (_cache[0] = ($event) => emit("scrolled-to-bottom"))
              }), {
                overlay: withCtx((attrs2) => [
                  renderSlot(_ctx.$slots, "content")
                ]),
                "extra-content": withCtx(() => [
                  renderSlot(_ctx.$slots, "extra-content")
                ]),
                _: 3
              }, 16, ["id", "activator"])
            ]),
            _: 3
          })) : createCommentVNode("", true)
        ]),
        _: 3
      }, 512);
    };
  }
}));
const Icon$9 = "Polaris-Icon";
const applyColor = "Polaris-Icon--applyColor";
const hasBackdrop = "Polaris-Icon--hasBackdrop";
const colorBase = "Polaris-Icon--colorBase";
const colorSubdued = "Polaris-Icon--colorSubdued";
const colorCritical$1 = "Polaris-Icon--colorCritical";
const colorInteractive = "Polaris-Icon--colorInteractive";
const colorWarning = "Polaris-Icon--colorWarning";
const colorHighlight$1 = "Polaris-Icon--colorHighlight";
const colorSuccess$1 = "Polaris-Icon--colorSuccess";
const colorPrimary$1 = "Polaris-Icon--colorPrimary";
const Svg = "Polaris-Icon__Svg";
const Img = "Polaris-Icon__Img";
const Placeholder = "Polaris-Icon__Placeholder";
var styles$1D = {
  Icon: Icon$9,
  applyColor,
  hasBackdrop,
  colorBase,
  colorSubdued,
  colorCritical: colorCritical$1,
  colorInteractive,
  colorWarning,
  colorHighlight: colorHighlight$1,
  colorSuccess: colorSuccess$1,
  colorPrimary: colorPrimary$1,
  Svg,
  Img,
  Placeholder
};
var config = {
  env: "production"
};
var Icon_vue_vue_type_style_index_0_lang = "";
const _hoisted_1$1k = ["src"];
const _sfc_main$2K = /* @__PURE__ */ defineComponent({
  props: {
    source: null,
    color: null,
    backdrop: { type: Boolean },
    accessibilityLabel: null
  },
  setup(__props) {
    const props = __props;
    const COLORS_WITH_BACKDROPS = ["base", "critical", "highlight", "success", "warning"];
    const colorClassName = computed(() => props.color && styles$1D[variationName("color", props.color)]);
    const className = computed(() => classNames(styles$1D.Icon, colorClassName.value, props.color && styles$1D.applyColor, props.backdrop && styles$1D.hasBackdrop));
    const sourceType = computed(() => {
      if (typeof props.source === "object") {
        return "icon";
      }
      if (props.source === "placeholder") {
        return "placeholder";
      }
      return "external";
    });
    const encodedSvg = computed(() => sourceType.value === "external" ? encodeURIComponent(String(props.source)) : "");
    const checkSupportedSvg = () => {
      if (props.color && sourceType.value === "external" && config.env === "development") {
        console.warn("Recoloring external SVGs is not supported. Set the intended color on your SVG instead.");
      }
    };
    const checkSupportedBackdrop = () => {
      if (props.backdrop && props.color && !COLORS_WITH_BACKDROPS.includes(props.color) && config.env === "development") {
        console.warn(`The ${props.color} variant does not have a supported backdrop color`);
      }
    };
    onMounted(() => {
      checkSupportedSvg();
      checkSupportedBackdrop();
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("span", {
        class: normalizeClass(unref(className))
      }, [
        createVNode(unref(Text), {
          variant: "bodySm",
          as: "span",
          "visually-hidden": ""
        }, {
          default: withCtx(() => [
            createTextVNode(toDisplayString(__props.accessibilityLabel), 1)
          ]),
          _: 1
        }),
        unref(sourceType) === "icon" ? (openBlock(), createBlock(resolveDynamicComponent(__props.source), {
          key: 0,
          class: normalizeClass(unref(styles$1D).Svg)
        }, null, 8, ["class"])) : unref(sourceType) === "placeholder" ? (openBlock(), createElementBlock("div", {
          key: 1,
          class: normalizeClass(unref(styles$1D).Placeholder)
        }, null, 2)) : (openBlock(), createElementBlock("img", {
          key: 2,
          class: normalizeClass(unref(styles$1D).Img),
          src: `data:image/svg+xml;utf8,${unref(encodedSvg)}`,
          alt: "",
          "aria-hidden": "true"
        }, null, 10, _hoisted_1$1k))
      ], 2);
    };
  }
});
const _hoisted_1$1j = {
  viewBox: "0 0 20 20",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$J = /* @__PURE__ */ createElementVNode("path", { d: "M7.676 9h4.648c.563 0 .879-.603.53-1.014L10.531 5.24a.708.708 0 0 0-1.062 0L7.145 7.986C6.798 8.397 7.113 9 7.676 9Zm4.648 2H7.676c-.563 0-.878.603-.53 1.014l2.323 2.746c.27.32.792.32 1.062 0l2.323-2.746c.349-.411.033-1.014-.53-1.014Z" }, null, -1);
const _hoisted_3$v = [
  _hoisted_2$J
];
function render$l(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1$1j, _hoisted_3$v);
}
var SelectMinor = { render: render$l };
const _hoisted_1$1i = ["role", "type", "disabled", "aria-busy", "aria-controls", "aria-expanded", "aria-describedby", "aria-checked", "aria-pressed"];
const __default__$a = {
  inheritAttrs: false
};
const _sfc_main$2J = /* @__PURE__ */ defineComponent(__spreadProps(__spreadValues({}, __default__$a), {
  props: {
    id: null,
    url: null,
    external: { type: Boolean },
    download: { type: [String, Boolean] },
    submit: { type: Boolean },
    disabled: { type: Boolean },
    loading: { type: Boolean },
    pressed: { type: Boolean },
    accessibilityLabel: null,
    role: null,
    ariaControls: null,
    ariaExpanded: { type: Boolean },
    ariaDescribedBy: null,
    ariaChecked: { type: Boolean },
    others: null
  },
  setup(__props) {
    const props = __props;
    const attrs = useAttrs();
    const getEventList = (events) => {
      const eventBindings = { mouseup: handleMouseUpByBlurring };
      for (const event of events) {
        const eventName = `on${capitalize$1(event)}`;
        if (attrs[eventName]) {
          eventBindings[event] = attrs[eventName];
        }
      }
      return eventBindings;
    };
    const buttonListeners = getEventList(["blur", "focus", "keydown", "keypress", "keyup", "mouseover", "touchstart"]);
    const handleClick = computed(() => useDisableClick(props.disabled, attrs.onClick));
    const linkListeners = getEventList(["blur", "click", "focus", "mouseover", "touchstart"]);
    const commonProps = computed(() => ({
      id: props.id,
      class: attrs.class,
      "aria-label": props.accessibilityLabel
    }));
    const interactiveProps = computed(() => __spreadProps(__spreadValues(__spreadValues({}, commonProps.value), props.others), {
      role: props.role
    }));
    return (_ctx, _cache) => {
      return __props.url && __props.disabled ? (openBlock(), createElementBlock("a", normalizeProps(mergeProps({ key: 0 }, unref(commonProps))), [
        renderSlot(_ctx.$slots, "default")
      ], 16)) : __props.url && !__props.disabled ? (openBlock(), createBlock(unref(_sfc_main$3m), mergeProps({ key: 1 }, unref(interactiveProps), {
        url: __props.url,
        external: __props.external,
        download: __props.download
      }, toHandlers(unref(linkListeners))), {
        default: withCtx(() => [
          renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }, 16, ["url", "external", "download"])) : (openBlock(), createElementBlock("button", mergeProps({ key: 2 }, unref(commonProps), {
        role: __props.role,
        type: __props.submit ? "submit" : "button",
        disabled: __props.disabled,
        "aria-busy": __props.loading ? true : void 0,
        "aria-controls": __props.ariaControls,
        "aria-expanded": __props.ariaExpanded,
        "aria-describedby": __props.ariaDescribedBy,
        "aria-checked": __props.ariaChecked,
        "aria-pressed": __props.pressed,
        onClick: _cache[0] || (_cache[0] = (...args) => unref(handleClick) && unref(handleClick)(...args))
      }, toHandlers(unref(buttonListeners))), [
        renderSlot(_ctx.$slots, "default")
      ], 16, _hoisted_1$1i));
    };
  }
}));
const _sfc_main$2I = /* @__PURE__ */ defineComponent({
  props: {
    action: null,
    overrides: null,
    keyProp: null
  },
  setup(__props) {
    const props = __props;
    const bindProps = computed(() => {
      const _a = props.action, { content, onAction } = _a, rest = __objRest(_a, ["content", "onAction"]);
      return __spreadValues(__spreadValues({}, rest), props.overrides);
    });
    return (_ctx, _cache) => {
      return openBlock(), createBlock(_sfc_main$2J, mergeProps({ key: __props.keyProp }, unref(bindProps), {
        onClick: __props.action.onAction
      }), {
        default: withCtx(() => [
          createTextVNode(toDisplayString(__props.action.content), 1)
        ]),
        _: 1
      }, 16, ["onClick"]);
    };
  }
});
const _hoisted_1$1h = {
  viewBox: "0 0 44 44",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$I = /* @__PURE__ */ createElementVNode("path", { d: "M15.542 1.487A21.507 21.507 0 0 0 .5 22c0 11.874 9.626 21.5 21.5 21.5 9.847 0 18.364-6.675 20.809-16.072a1.5 1.5 0 0 0-2.904-.756C37.803 34.755 30.473 40.5 22 40.5 11.783 40.5 3.5 32.217 3.5 22c0-8.137 5.3-15.247 12.942-17.65a1.5 1.5 0 1 0-.9-2.863z" }, null, -1);
const _hoisted_3$u = [
  _hoisted_2$I
];
function render$k(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1$1h, _hoisted_3$u);
}
var SpinnerIconLarge = { render: render$k };
const _hoisted_1$1g = {
  viewBox: "0 0 20 20",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$H = /* @__PURE__ */ createElementVNode("path", { d: "M7.229 1.173a9.25 9.25 0 1 0 11.655 11.412 1.25 1.25 0 1 0-2.4-.698 6.75 6.75 0 1 1-8.506-8.329 1.25 1.25 0 1 0-.75-2.385z" }, null, -1);
const _hoisted_3$t = [
  _hoisted_2$H
];
function render$j(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1$1g, _hoisted_3$t);
}
var SpinnerIconSmall = { render: render$j };
const Spinner$1 = "Polaris-Spinner";
const sizeSmall$8 = "Polaris-Spinner--sizeSmall";
const sizeLarge$7 = "Polaris-Spinner--sizeLarge";
var styles$1C = {
  Spinner: Spinner$1,
  sizeSmall: sizeSmall$8,
  sizeLarge: sizeLarge$7
};
var Spinner_vue_vue_type_style_index_0_lang = "";
const _sfc_main$2H = /* @__PURE__ */ defineComponent({
  props: {
    size: {
      type: String,
      default: "large"
    },
    accessibilityLabel: {
      type: String,
      default: null
    },
    hasFocusableParent: {
      type: Boolean
    }
  },
  setup(__props) {
    const props = __props;
    const spanAttributes = ref(__spreadValues({}, !props.hasFocusableParent && { role: "status" }));
    const className = computed(() => {
      const variation = variationName("size", props.size);
      return classNames(styles$1C.Spinner, props.size && styles$1C[variation]);
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock(Fragment, null, [
        createElementVNode("span", {
          class: normalizeClass(unref(className))
        }, [
          __props.size === "large" ? (openBlock(), createBlock(unref(SpinnerIconLarge), { key: 0 })) : (openBlock(), createBlock(unref(SpinnerIconSmall), { key: 1 }))
        ], 2),
        createElementVNode("span", normalizeProps(guardReactiveProps(spanAttributes.value)), [
          createVNode(unref(Text), {
            as: "span",
            variant: "bodySm",
            "visually-hidden": ""
          }, {
            default: withCtx(() => [
              createTextVNode(toDisplayString(__props.accessibilityLabel), 1)
            ]),
            _: 1
          })
        ], 16)
      ], 64);
    };
  }
});
const __default__$9 = {
  inheritAttrs: false
};
const _sfc_main$2G = /* @__PURE__ */ defineComponent(__spreadProps(__spreadValues({}, __default__$9), {
  props: {
    commonProps: null,
    linkProps: null,
    actionProps: null,
    removeUnderline: null,
    children: { type: Boolean },
    disclosure: null,
    loading: null,
    icon: null
  },
  setup(__props) {
    const props = __props;
    const attrs = useAttrs();
    const listeners = computed(() => {
      const events = ["blur", "click", "focus", "keydown", "keypress", "keyup", "mouseover", "touchstart", "pointerdown"];
      const eventBindings = {};
      for (const event of events) {
        const eventName = `on${capitalize$1(event)}`;
        if (attrs[eventName]) {
          eventBindings[event] = attrs[eventName];
        }
      }
      return eventBindings;
    });
    const iconClass = computed(() => {
      return classNames(styles$1H.Icon, props.loading && styles$1H.hidden);
    });
    const childrenClass = computed(() => {
      return classNames(styles$1H.Text, props.removeUnderline && styles$1H.removeUnderline);
    });
    const getDisclosureIconSource = computed(() => {
      if (props.disclosure === "select") {
        return SelectMinor;
      }
      return props.disclosure === "up" ? CaretUpMinor : CaretDownMinor;
    });
    return (_ctx, _cache) => {
      return openBlock(), createBlock(unref(_sfc_main$2J), mergeProps(__spreadValues(__spreadValues(__spreadValues({}, __props.commonProps), __props.linkProps), __props.actionProps), toHandlers(unref(listeners))), {
        default: withCtx(() => [
          createElementVNode("span", {
            class: normalizeClass(unref(styles$1H).Content)
          }, [
            __props.loading ? (openBlock(), createElementBlock("span", {
              key: 0,
              class: normalizeClass(unref(styles$1H).Spinner)
            }, [
              createVNode(unref(_sfc_main$2H), {
                size: "small",
                accessibilityLabel: "Loading"
              })
            ], 2)) : createCommentVNode("", true),
            __props.icon ? (openBlock(), createElementBlock("span", {
              key: 1,
              class: normalizeClass(unref(iconClass))
            }, [
              createVNode(unref(_sfc_main$2K), {
                source: __props.loading ? "placeholder" : __props.icon
              }, null, 8, ["source"])
            ], 2)) : createCommentVNode("", true),
            __props.children ? (openBlock(), createElementBlock("span", {
              key: __props.actionProps && __props.actionProps.disabled ? "text-disabled" : "text",
              class: normalizeClass(unref(childrenClass))
            }, [
              renderSlot(_ctx.$slots, "default")
            ], 2)) : createCommentVNode("", true),
            __props.disclosure ? (openBlock(), createElementBlock("span", {
              key: 3,
              class: normalizeClass(unref(styles$1H).Icon)
            }, [
              createElementVNode("div", null, [
                createVNode(unref(_sfc_main$2K), {
                  source: __props.loading ? "placeholder" : unref(getDisclosureIconSource)
                }, null, 8, ["source"])
              ])
            ], 2)) : createCommentVNode("", true)
          ], 2)
        ]),
        _: 3
      }, 16);
    };
  }
}));
var Button_vue_vue_type_style_index_0_lang = "";
const _hoisted_1$1f = ["aria-disabled", "tabIndex", "aria-label", "aria-describedby", "aria-checked"];
const __default__$8 = {
  inheritAttrs: false
};
const _sfc_main$2F = /* @__PURE__ */ defineComponent(__spreadProps(__spreadValues({}, __default__$8), {
  props: {
    id: null,
    url: { default: "" },
    external: { type: Boolean },
    download: { type: [String, Boolean] },
    submit: { type: Boolean },
    disabled: { type: Boolean },
    loading: { type: Boolean },
    pressed: { type: Boolean },
    accessibilityLabel: null,
    role: null,
    ariaControls: null,
    ariaExpanded: { type: Boolean },
    ariaDescribedBy: null,
    ariaChecked: { type: Boolean },
    primary: { type: Boolean },
    destructive: { type: Boolean },
    size: { default: "medium" },
    textAlign: { default: void 0 },
    outline: { type: Boolean },
    fullWidth: { type: Boolean },
    disclosure: { type: [String, Boolean], default: void 0 },
    plain: { type: Boolean },
    monochrome: { type: Boolean },
    removeUnderline: { type: Boolean },
    icon: null,
    connectedDisclosure: null,
    dataPrimaryLink: { type: Boolean }
  },
  setup(__props) {
    const props = __props;
    const slots = useSlots();
    const attrs = useAttrs();
    const hasChildren = !!slots.default;
    const disclosureActive = ref(false);
    const listeners = computed(() => {
      const events = ["blur", "click", "focus", "keydown", "keypress", "keyup", "mouseover", "touchstart", "pointerdown"];
      const eventBindings = {};
      for (const event of events) {
        const eventName = `on${capitalize$1(event)}`;
        if (attrs[eventName]) {
          eventBindings[event] = attrs[eventName];
        }
      }
      return eventBindings;
    });
    const isDisabled2 = computed(() => props.disabled || props.loading);
    const className = computed(() => {
      const textAlignVariation = props.textAlign && variationName("textAlign", props.textAlign);
      const sizeVariation = props.size && variationName("size", props.size);
      return classNames(styles$1H.Button, props.primary && styles$1H.primary, props.outline && styles$1H.outline, props.destructive && styles$1H.destructive, isDisabled2.value && styles$1H.disabled, props.loading && styles$1H.loading, props.plain && styles$1H.plain, props.pressed && !props.disabled && !props.url && styles$1H.pressed, props.monochrome && styles$1H.monochrome, props.size !== "medium" && sizeVariation && styles$1H[sizeVariation], textAlignVariation && styles$1H[textAlignVariation], props.fullWidth && styles$1H.fullWidth, props.icon && !hasChildren && styles$1H.iconOnly, props.connectedDisclosure && styles$1H.connectedDisclosure, props.removeUnderline && styles$1H.removeUnderline);
    });
    const connectedDisclosureClassName = computed(() => {
      const textAlignVariation = props.textAlign && variationName("textAlign", props.textAlign);
      const sizeVariation = props.size && variationName("size", props.size);
      return classNames(styles$1H.Button, props.primary && styles$1H.primary, props.outline && styles$1H.outline, props.size !== "medium" && sizeVariation && styles$1H[sizeVariation], textAlignVariation && styles$1H[textAlignVariation], props.destructive && styles$1H.destructive, props.connectedDisclosure && props.connectedDisclosure.disabled && styles$1H.disabled, styles$1H.iconOnly, styles$1H.ConnectedDisclosure, props.monochrome && styles$1H.monochrome);
    });
    const commonProps = computed(() => {
      const { id, accessibilityLabel, role, ariaDescribedBy } = props;
      return {
        id,
        class: className.value,
        accessibilityLabel,
        role,
        ariaDescribedBy,
        "data-primary-link": props.dataPrimaryLink
      };
    });
    const linkProps = computed(() => {
      const { url, external, download } = props;
      return { url, external, download };
    });
    const actionProps = computed(() => {
      const { submit, loading: loading2, pressed: pressed2 } = props;
      return {
        submit,
        loading: loading2,
        pressed: pressed2,
        disabled: isDisabled2.value
      };
    });
    const buttonMarkupProps = computed(() => {
      const { removeUnderline: removeUnderline2, disclosure, loading: loading2, icon } = props;
      return {
        commonProps: commonProps.value,
        linkProps: linkProps.value,
        actionProps: actionProps.value,
        removeUnderline: removeUnderline2,
        children: hasChildren,
        disclosure,
        loading: loading2,
        icon
      };
    });
    const connectedDisclosureData = computed(() => {
      if (props.connectedDisclosure) {
        const {
          disabled: disabled2,
          accessibilityLabel: disclosureLabel = "Related actions"
        } = props.connectedDisclosure;
        return { disabled: disabled2, disclosureLabel };
      }
      return {};
    });
    const toggleDisclosureActive = () => {
      disclosureActive.value = !disclosureActive.value;
    };
    const handleClick = computed(() => useDisableClick(connectedDisclosureData.value.disabled, toggleDisclosureActive));
    return (_ctx, _cache) => {
      return __props.connectedDisclosure ? (openBlock(), createElementBlock("div", {
        key: 0,
        class: normalizeClass(unref(styles$1H).ConnectedDisclosureWrapper)
      }, [
        createVNode(_sfc_main$2G, mergeProps(unref(buttonMarkupProps), toHandlers(unref(listeners))), {
          default: withCtx(() => [
            renderSlot(_ctx.$slots, "default")
          ]),
          _: 3
        }, 16),
        createVNode(unref(_sfc_main$2L), {
          preferredAlignment: "right",
          active: disclosureActive.value,
          onClose: toggleDisclosureActive
        }, {
          activator: withCtx(() => [
            createElementVNode("button", {
              type: "button",
              class: normalizeClass(unref(connectedDisclosureClassName)),
              "aria-disabled": unref(connectedDisclosureData).disabled,
              tabIndex: unref(connectedDisclosureData).disabled ? -1 : void 0,
              "aria-label": unref(connectedDisclosureData).disclosureLabel,
              "aria-describedby": __props.ariaDescribedBy,
              "aria-checked": __props.ariaChecked,
              onClick: _cache[0] || (_cache[0] = (...args) => unref(handleClick) && unref(handleClick)(...args)),
              onMouseup: _cache[1] || (_cache[1] = (...args) => unref(handleMouseUpByBlurring) && unref(handleMouseUpByBlurring)(...args))
            }, [
              createElementVNode("span", null, [
                createVNode(unref(_sfc_main$2K), { source: unref(CaretDownMinor) }, null, 8, ["source"])
              ])
            ], 42, _hoisted_1$1f)
          ]),
          content: withCtx(() => [
            createVNode(unref(_sfc_main$3h), {
              items: __props.connectedDisclosure.actions,
              onActionAnyItem: toggleDisclosureActive
            }, createSlots({ _: 2 }, [
              renderList(__props.connectedDisclosure.actions, ({ prefixId }) => {
                return {
                  name: `prefix-${prefixId}`,
                  fn: withCtx(() => [
                    renderSlot(_ctx.$slots, `prefix-${prefixId}`)
                  ])
                };
              }),
              renderList(__props.connectedDisclosure.actions, ({ suffixId }) => {
                return {
                  name: `suffix-${suffixId}`,
                  fn: withCtx(() => [
                    renderSlot(_ctx.$slots, `suffix-${suffixId}`)
                  ])
                };
              })
            ]), 1032, ["items"])
          ]),
          _: 3
        }, 8, ["active"])
      ], 2)) : (openBlock(), createBlock(_sfc_main$2G, mergeProps({ key: 1 }, unref(buttonMarkupProps), toHandlers(unref(listeners))), {
        default: withCtx(() => [
          renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }, 16));
    };
  }
}));
const __default__$7 = {
  inheritAttrs: false
};
const _sfc_main$2E = /* @__PURE__ */ defineComponent(__spreadProps(__spreadValues({}, __default__$7), {
  props: {
    action: null,
    overrides: { default: () => ({}) }
  },
  setup(__props) {
    const props = __props;
    const bindProps = computed(() => {
      if (!props.action) {
        return {};
      }
      const _a = props.action, { onAction, content } = _a, other = __objRest(_a, ["onAction", "content"]);
      return __spreadValues(__spreadValues({}, other), props.overrides);
    });
    const handleClick = () => {
      if (props.action && props.action.onAction) {
        props.action.onAction();
      }
    };
    return (_ctx, _cache) => {
      return __props.action ? (openBlock(), createBlock(unref(_sfc_main$2F), mergeProps({ key: 0 }, unref(bindProps), { onClick: handleClick }), {
        default: withCtx(() => [
          createTextVNode(toDisplayString(__props.action.content), 1)
        ]),
        _: 1
      }, 16)) : createCommentVNode("", true);
    };
  }
}));
function isFragment(item) {
  return item.type.toString() === "Symbol(Fragment)" || item.type.toString() === "Symbol()";
}
function extractElement(elm) {
  if (!isFragment(elm)) {
    return [elm];
  }
  const children = elm.children;
  const items = [];
  for (const child of children) {
    if (isFragment(child)) {
      items.push(...extractElement(child));
    } else {
      items.push(child);
    }
  }
  return items;
}
const ButtonGroup = "Polaris-ButtonGroup";
const Item$8 = "Polaris-ButtonGroup__Item";
const segmented$1 = "Polaris-ButtonGroup--segmented";
const fullWidth$5 = "Polaris-ButtonGroup--fullWidth";
const extraTight = "Polaris-ButtonGroup--extraTight";
const tight = "Polaris-ButtonGroup--tight";
const loose = "Polaris-ButtonGroup--loose";
var styles$1B = {
  ButtonGroup,
  Item: Item$8,
  "Item-plain": "Polaris-ButtonGroup__Item--plain",
  segmented: segmented$1,
  "Item-focused": "Polaris-ButtonGroup__Item--focused",
  fullWidth: fullWidth$5,
  extraTight,
  tight,
  loose
};
const __default__$6 = {
  inheritAttrs: false
};
const _sfc_main$2D = /* @__PURE__ */ defineComponent(__spreadProps(__spreadValues({}, __default__$6), {
  setup(__props) {
    const focused2 = ref(false);
    const slots = useSlots();
    const slotProps = computed(() => {
      return slots.default && slots.default()[0].props;
    });
    const className = computed(() => {
      const plain2 = slotProps.value && (slotProps.value.plain === "" || slotProps.value.plain);
      return classNames(styles$1B.Item, focused2.value && styles$1B["Item-focused"], plain2 && styles$1B["Item-plain"]);
    });
    const forceTrueFocused = () => {
      focused2.value = true;
    };
    const forceFalseFocused = () => {
      focused2.value = false;
    };
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(unref(className)),
        onFocus: forceTrueFocused,
        onBlur: forceFalseFocused
      }, [
        renderSlot(_ctx.$slots, "default")
      ], 34);
    };
  }
}));
var ButtonGroup_vue_vue_type_style_index_0_lang = "";
const _hoisted_1$1e = ["data-buttongroup-segmented", "data-buttongroup-connected-top", "data-buttongroup-full-width"];
const __default__$5 = {
  inheritAttrs: false
};
const _sfc_main$2C = /* @__PURE__ */ defineComponent(__spreadProps(__spreadValues({}, __default__$5), {
  props: {
    spacing: null,
    segmented: { type: Boolean },
    fullWidth: { type: Boolean },
    connectedTop: { type: Boolean },
    noItemWrap: { type: Boolean }
  },
  setup(__props) {
    const props = __props;
    const slots = useSlots();
    const itemMarkup = computed(() => {
      let elms = [];
      if (slots.default) {
        const groups = slots.default().map((group) => {
          return extractElement(group);
        });
        elms = groups.flat();
      }
      return elms;
    });
    const className = computed(() => {
      return classNames(styles$1B.ButtonGroup, props.spacing && styles$1B[props.spacing], props.segmented && styles$1B.segmented, props.fullWidth && styles$1B.fullWidth);
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(unref(className)),
        "data-buttongroup-segmented": __props.segmented,
        "data-buttongroup-connected-top": __props.connectedTop,
        "data-buttongroup-full-width": __props.fullWidth
      }, [
        !__props.noItemWrap ? (openBlock(true), createElementBlock(Fragment, { key: 0 }, renderList(unref(itemMarkup), (item, index) => {
          return openBlock(), createBlock(unref(_sfc_main$2D), { key: index }, {
            default: withCtx(() => [
              (openBlock(), createBlock(resolveDynamicComponent(item)))
            ]),
            _: 2
          }, 1024);
        }), 128)) : renderSlot(_ctx.$slots, "default", { key: 1 })
      ], 10, _hoisted_1$1e);
    };
  }
}));
const CalloutCard = "Polaris-CalloutCard";
const Image$1 = "Polaris-CalloutCard__Image";
const DismissImage = "Polaris-CalloutCard__DismissImage";
const Content$7 = "Polaris-CalloutCard__Content";
const Title$8 = "Polaris-CalloutCard__Title";
const Buttons = "Polaris-CalloutCard__Buttons";
const Container$4 = "Polaris-CalloutCard__Container";
const Dismiss = "Polaris-CalloutCard__Dismiss";
const hasDismiss = "Polaris-CalloutCard--hasDismiss";
var styles$1A = {
  CalloutCard,
  Image: Image$1,
  DismissImage,
  Content: Content$7,
  Title: Title$8,
  Buttons,
  Container: Container$4,
  Dismiss,
  hasDismiss
};
var CalloutCard_vue_vue_type_style_index_0_lang = "";
const _sfc_main$2B = /* @__PURE__ */ defineComponent({
  props: {
    title: null,
    illustration: null,
    primaryAction: null,
    secondaryAction: null
  },
  setup(__props) {
    const attrs = useAttrs();
    const slots = useSlots();
    const imageClassName = computed(() => {
      return classNames(styles$1A.Image, !!attrs["onDismiss"] && styles$1A.DismissImage);
    });
    const containerClassName = computed(() => {
      return classNames(styles$1A.Container, !!attrs["onDismiss"] && styles$1A.hasDismiss);
    });
    const handleClick = () => {
      const onDismiss = attrs.onDismiss;
      attrs.onDismiss && onDismiss();
    };
    return (_ctx, _cache) => {
      return openBlock(), createBlock(unref(_sfc_main$2w), null, {
        default: withCtx(() => [
          createElementVNode("div", {
            class: normalizeClass(unref(containerClassName))
          }, [
            unref(attrs).onDismiss ? (openBlock(), createElementBlock("div", {
              key: 0,
              class: normalizeClass(unref(styles$1A).Dismiss)
            }, [
              createVNode(unref(_sfc_main$2F), {
                plain: "",
                icon: unref(CancelSmallMinor),
                accessibilityLabel: "Dismiss card",
                onClick: handleClick
              }, null, 8, ["icon"])
            ], 2)) : createCommentVNode("", true),
            createVNode(unref(_sfc_main$2y), null, {
              default: withCtx(() => [
                createElementVNode("div", {
                  class: normalizeClass(unref(styles$1A).CalloutCard)
                }, [
                  createElementVNode("div", {
                    class: normalizeClass(unref(styles$1A).Content)
                  }, [
                    createElementVNode("div", {
                      class: normalizeClass(unref(styles$1A).Title)
                    }, [
                      createVNode(unref(Text), {
                        as: "h2",
                        variant: "headingMd"
                      }, {
                        default: withCtx(() => [
                          unref(slots).title ? renderSlot(_ctx.$slots, "title", { key: 0 }) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
                            createTextVNode(toDisplayString(__props.title), 1)
                          ], 64))
                        ]),
                        _: 3
                      })
                    ], 2),
                    createVNode(unref(_sfc_main$c), null, {
                      default: withCtx(() => [
                        renderSlot(_ctx.$slots, "default")
                      ]),
                      _: 3
                    }),
                    createElementVNode("div", {
                      class: normalizeClass(unref(styles$1A).Buttons)
                    }, [
                      __props.secondaryAction ? (openBlock(), createBlock(unref(_sfc_main$2C), { key: 0 }, {
                        default: withCtx(() => [
                          createVNode(unref(_sfc_main$2E), { action: __props.primaryAction }, null, 8, ["action"]),
                          createVNode(unref(_sfc_main$2E), {
                            action: __props.secondaryAction,
                            overrides: { plain: true }
                          }, null, 8, ["action"])
                        ]),
                        _: 1
                      })) : (openBlock(), createBlock(unref(_sfc_main$2E), {
                        key: 1,
                        action: __props.primaryAction
                      }, null, 8, ["action"]))
                    ], 2)
                  ], 2),
                  createVNode(unref(_sfc_main$1D), {
                    alt: "",
                    class: normalizeClass(unref(imageClassName)),
                    source: __props.illustration
                  }, null, 8, ["class", "source"])
                ], 2)
              ]),
              _: 3
            })
          ], 2)
        ]),
        _: 3
      });
    };
  }
});
const Caption = "Polaris-Caption";
var styles$1z = {
  Caption
};
var Caption_vue_vue_type_style_index_0_lang = "";
const _sfc_main$2A = /* @__PURE__ */ defineComponent({
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("p", {
        class: normalizeClass(unref(styles$1z).Caption)
      }, [
        renderSlot(_ctx.$slots, "default")
      ], 2);
    };
  }
});
const Card = "Polaris-Card";
const subdued$2 = "Polaris-Card--subdued";
const hideOnPrint = "Polaris-Card--hideOnPrint";
const Header$4 = "Polaris-Card__Header";
const Section$6 = "Polaris-Card__Section";
const SectionHeader = "Polaris-Card__SectionHeader";
const Subsection = "Polaris-Card__Subsection";
const Footer$2 = "Polaris-Card__Footer";
const LeftJustified = "Polaris-Card__LeftJustified";
var styles$1y = {
  Card,
  subdued: subdued$2,
  "Section-hideOnPrint": "Polaris-Card__Section--hideOnPrint",
  hideOnPrint,
  Header: Header$4,
  Section: Section$6,
  "Section-fullWidth": "Polaris-Card__Section--fullWidth",
  "Section-flush": "Polaris-Card__Section--flush",
  "Section-subdued": "Polaris-Card__Section--subdued",
  SectionHeader,
  Subsection,
  Footer: Footer$2,
  LeftJustified
};
const _sfc_main$2z = /* @__PURE__ */ defineComponent({
  props: {
    actions: null
  },
  setup(__props) {
    const slots = useSlots();
    const isTextOnlyTitle = computed(() => {
      var _a, _b, _c, _d, _e;
      if (slots.title && slots.title().length === 1) {
        if (((_a = slots.title()[0]) == null ? void 0 : _a.type.toString()) === "Symbol(Text)" || ((_b = slots.title()[0]) == null ? void 0 : _b.type.toString()) === "Symbol()") {
          return true;
        } else {
          return slots.title()[0].children && ((_c = slots.title()[0].children) == null ? void 0 : _c.length) === 1 && (((_d = slots.title()[0].children) == null ? void 0 : _d[0].type.toString()) === "Symbol(Text)" || ((_e = slots.title()[0].children) == null ? void 0 : _e[0].type.toString()) === "Symbol()");
        }
      }
      return false;
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(unref(styles$1y).Header)
      }, [
        unref(slots).default || __props.actions ? (openBlock(), createBlock(unref(_sfc_main$12), {
          key: 0,
          alignment: "baseline",
          noItemWrap: ""
        }, {
          default: withCtx(() => [
            createVNode(unref(_sfc_main$13), { fill: true }, {
              default: withCtx(() => [
                !unref(isTextOnlyTitle) ? renderSlot(_ctx.$slots, "title", { key: 0 }) : (openBlock(), createBlock(unref(Text), {
                  key: 1,
                  as: "h2",
                  variant: "headingMd"
                }, {
                  default: withCtx(() => [
                    renderSlot(_ctx.$slots, "title")
                  ]),
                  _: 3
                }))
              ]),
              _: 3
            }),
            __props.actions ? (openBlock(), createBlock(unref(_sfc_main$13), { key: 0 }, {
              default: withCtx(() => [
                createVNode(unref(_sfc_main$2C), null, {
                  default: withCtx(() => [
                    (openBlock(true), createElementBlock(Fragment, null, renderList(__props.actions, (action, index) => {
                      return openBlock(), createBlock(unref(_sfc_main$2E), {
                        key: index,
                        action,
                        overrides: { plain: true }
                      }, null, 8, ["action"]);
                    }), 128))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })) : createCommentVNode("", true),
            unref(slots).default ? (openBlock(), createBlock(unref(_sfc_main$13), { key: 1 }, {
              default: withCtx(() => [
                renderSlot(_ctx.$slots, "default")
              ]),
              _: 3
            })) : createCommentVNode("", true)
          ]),
          _: 3
        })) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
          !unref(isTextOnlyTitle) ? renderSlot(_ctx.$slots, "title", { key: 0 }) : (openBlock(), createBlock(unref(Text), {
            key: 1,
            as: "h2",
            variant: "headingMd"
          }, {
            default: withCtx(() => [
              renderSlot(_ctx.$slots, "title")
            ]),
            _: 3
          }))
        ], 64))
      ], 2);
    };
  }
});
const _sfc_main$2y = /* @__PURE__ */ defineComponent({
  props: {
    title: null,
    subdued: { type: Boolean },
    flush: { type: Boolean },
    fullWidth: { type: Boolean },
    hideOnPrint: { type: Boolean },
    actions: null
  },
  setup(__props) {
    const props = __props;
    const slots = useSlots();
    const className = computed(() => {
      return classNames(styles$1y.Section, props.flush && styles$1y["Section-flush"], props.subdued && styles$1y["Section-subdued"], props.fullWidth && styles$1y["Section-fullWidth"], props.hideOnPrint && styles$1y["Section-hideOnPrint"]);
    });
    const isTextOnlyTitle = computed(() => {
      var _a, _b, _c, _d, _e;
      if (slots.title && slots.title().length === 1) {
        if (((_a = slots.title()[0]) == null ? void 0 : _a.type.toString()) === "Symbol(Text)" || ((_b = slots.title()[0]) == null ? void 0 : _b.type.toString()) === "Symbol()") {
          return true;
        } else {
          return slots.title()[0].children && ((_c = slots.title()[0].children) == null ? void 0 : _c.length) === 1 && (((_d = slots.title()[0].children) == null ? void 0 : _d[0].type.toString()) === "Symbol(Text)" || ((_e = slots.title()[0].children) == null ? void 0 : _e[0].type.toString()) === "Symbol()");
        }
      }
      return true;
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(unref(className))
      }, [
        __props.title || unref(hasSlot)(unref(slots).title) || __props.actions ? (openBlock(), createElementBlock("div", {
          key: 0,
          class: normalizeClass(unref(styles$1y).SectionHeader)
        }, [
          __props.actions ? (openBlock(), createBlock(unref(_sfc_main$12), {
            key: 0,
            noItemWrap: "",
            alignment: "baseline"
          }, {
            default: withCtx(() => [
              createVNode(unref(_sfc_main$13), { fill: "" }, {
                default: withCtx(() => [
                  !unref(isTextOnlyTitle) ? renderSlot(_ctx.$slots, "title", { key: 0 }) : (openBlock(), createBlock(unref(Text), {
                    key: 1,
                    variant: "headingSm",
                    as: "h3"
                  }, {
                    default: withCtx(() => [
                      unref(hasSlot)(unref(slots).title) ? renderSlot(_ctx.$slots, "title", { key: 0 }) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
                        createTextVNode(toDisplayString(__props.title), 1)
                      ], 64))
                    ]),
                    _: 3
                  }))
                ]),
                _: 3
              }),
              createVNode(unref(_sfc_main$2C), null, {
                default: withCtx(() => [
                  (openBlock(true), createElementBlock(Fragment, null, renderList(__props.actions, (action, index) => {
                    return openBlock(), createBlock(unref(_sfc_main$2E), {
                      key: index,
                      index,
                      action,
                      overrides: { plain: true }
                    }, null, 8, ["index", "action"]);
                  }), 128))
                ]),
                _: 1
              })
            ]),
            _: 3
          })) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
            !unref(isTextOnlyTitle) ? renderSlot(_ctx.$slots, "title", { key: 0 }) : (openBlock(), createBlock(unref(Text), {
              key: 1,
              variant: "headingSm",
              as: "h3"
            }, {
              default: withCtx(() => [
                unref(hasSlot)(unref(slots).title) ? renderSlot(_ctx.$slots, "title", { key: 0 }) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
                  createTextVNode(toDisplayString(__props.title), 1)
                ], 64))
              ]),
              _: 3
            }))
          ], 64))
        ], 2)) : createCommentVNode("", true),
        renderSlot(_ctx.$slots, "default")
      ], 2);
    };
  }
});
const _sfc_main$2x = /* @__PURE__ */ defineComponent({
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(unref(styles$1y).Subsection)
      }, [
        renderSlot(_ctx.$slots, "default")
      ], 2);
    };
  }
});
var Card_vue_vue_type_style_index_0_lang = "";
const _sfc_main$2w = /* @__PURE__ */ defineComponent({
  props: {
    title: null,
    subdued: { type: Boolean },
    sectioned: { type: Boolean },
    actions: null,
    primaryFooterAction: null,
    secondaryFooterActions: null,
    secondaryFooterActionsDisclosureText: null,
    footerActionAlignment: { default: "right" },
    hideOnPrint: { type: Boolean }
  },
  setup(__props) {
    const props = __props;
    const i18n = UseI18n();
    const slots = useSlots();
    const secondaryActionsPopoverOpen = ref(false);
    const toggleSecondaryActionsPopoverOpen = () => {
      secondaryActionsPopoverOpen.value = !secondaryActionsPopoverOpen.value;
    };
    const className = computed(() => {
      return classNames(styles$1y.Card, props.subdued && styles$1y.subdued, props.hideOnPrint && styles$1y.hideOnPrint);
    });
    const footerClassName = computed(() => {
      return classNames(styles$1y.Footer, props.footerActionAlignment === "left" && styles$1y.LeftJustified);
    });
    provide("WithinContentContext", true);
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(unref(className))
      }, [
        __props.title || unref(hasSlot)(unref(slots).title) || __props.actions ? (openBlock(), createBlock(unref(_sfc_main$2z), {
          key: 0,
          actions: __props.actions
        }, {
          title: withCtx(() => [
            unref(hasSlot)(unref(slots).title) ? renderSlot(_ctx.$slots, "title", { key: 0 }) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
              createTextVNode(toDisplayString(__props.title), 1)
            ], 64))
          ]),
          _: 3
        }, 8, ["actions"])) : createCommentVNode("", true),
        __props.sectioned ? (openBlock(), createBlock(unref(_sfc_main$2y), { key: 1 }, {
          default: withCtx(() => [
            renderSlot(_ctx.$slots, "default")
          ]),
          _: 3
        })) : renderSlot(_ctx.$slots, "default", { key: 2 }),
        __props.primaryFooterAction || __props.secondaryFooterActions && __props.secondaryFooterActions.length ? (openBlock(), createElementBlock("div", {
          key: 3,
          class: normalizeClass(unref(footerClassName))
        }, [
          __props.footerActionAlignment === "right" ? (openBlock(), createBlock(unref(_sfc_main$2C), { key: 0 }, {
            default: withCtx(() => [
              __props.secondaryFooterActions && __props.secondaryFooterActions.length === 1 ? (openBlock(), createBlock(unref(_sfc_main$2E), {
                key: 0,
                action: __props.secondaryFooterActions[0]
              }, null, 8, ["action"])) : __props.secondaryFooterActions && __props.secondaryFooterActions.length > 1 ? (openBlock(), createBlock(unref(_sfc_main$2L), {
                key: 1,
                active: secondaryActionsPopoverOpen.value,
                onClose: toggleSecondaryActionsPopoverOpen
              }, {
                activator: withCtx(() => [
                  createVNode(unref(_sfc_main$2F), {
                    disclosure: true,
                    onClick: toggleSecondaryActionsPopoverOpen
                  }, {
                    default: withCtx(() => [
                      createTextVNode(toDisplayString(__props.secondaryFooterActionsDisclosureText || unref(i18n).translate("Polaris.Common.more")), 1)
                    ]),
                    _: 1
                  })
                ]),
                content: withCtx(() => [
                  createVNode(unref(_sfc_main$3h), { items: __props.secondaryFooterActions }, null, 8, ["items"])
                ]),
                _: 1
              }, 8, ["active"])) : createCommentVNode("", true),
              __props.primaryFooterAction ? (openBlock(), createBlock(unref(_sfc_main$2E), {
                key: 2,
                action: __props.primaryFooterAction,
                overrides: { primary: true }
              }, null, 8, ["action"])) : createCommentVNode("", true)
            ]),
            _: 1
          })) : (openBlock(), createBlock(unref(_sfc_main$2C), { key: 1 }, {
            default: withCtx(() => [
              __props.primaryFooterAction ? (openBlock(), createBlock(unref(_sfc_main$2E), {
                key: 0,
                action: __props.primaryFooterAction,
                overrides: { primary: true }
              }, null, 8, ["action"])) : createCommentVNode("", true),
              __props.secondaryFooterActions && __props.secondaryFooterActions.length === 1 ? (openBlock(), createBlock(unref(_sfc_main$2E), {
                key: 1,
                action: __props.secondaryFooterActions[0]
              }, null, 8, ["action"])) : __props.secondaryFooterActions && __props.secondaryFooterActions.length > 1 ? (openBlock(), createBlock(unref(_sfc_main$2L), {
                key: 2,
                active: secondaryActionsPopoverOpen.value,
                onClose: toggleSecondaryActionsPopoverOpen
              }, {
                activator: withCtx(() => [
                  createVNode(unref(_sfc_main$2F), {
                    disclosure: "",
                    onClick: toggleSecondaryActionsPopoverOpen
                  }, {
                    default: withCtx(() => [
                      createTextVNode(toDisplayString(__props.secondaryFooterActionsDisclosureText || unref(i18n).translate("Polaris.Common.more")), 1)
                    ]),
                    _: 1
                  })
                ]),
                content: withCtx(() => [
                  createVNode(unref(_sfc_main$3h), { items: __props.secondaryFooterActions }, null, 8, ["items"])
                ]),
                _: 1
              }, 8, ["active"])) : createCommentVNode("", true)
            ]),
            _: 1
          }))
        ], 2)) : createCommentVNode("", true)
      ], 2);
    };
  }
});
const CheckableButton = "Polaris-CheckableButton";
const Checkbox$4 = "Polaris-CheckableButton__Checkbox";
const Label$5 = "Polaris-CheckableButton__Label";
var styles$1x = {
  CheckableButton,
  "CheckableButton-measuring": "Polaris-CheckableButton__CheckableButton--measuring",
  "CheckableButton-plain": "Polaris-CheckableButton__CheckableButton--plain",
  "CheckableButton-selectMode": "Polaris-CheckableButton__CheckableButton--selectMode",
  "CheckableButton-selected": "Polaris-CheckableButton__CheckableButton--selected",
  Checkbox: Checkbox$4,
  Label: Label$5
};
var CheckableButton_vue_vue_type_style_index_0_lang = "";
const _sfc_main$2v = /* @__PURE__ */ defineComponent({
  props: {
    accessibilityLabel: null,
    label: { default: "" },
    selected: { type: [Boolean, String] },
    selectMode: { type: Boolean },
    smallScreen: { type: Boolean },
    plain: { type: Boolean },
    measuring: { type: Boolean },
    disabled: { type: Boolean }
  },
  setup(__props) {
    const props = __props;
    const { registerCheckableButtons } = inject("ResourceListContext", {});
    const checkBoxRef = ref(null);
    const currentKey = computed(() => {
      if (props.plain) {
        return "plain";
      }
      if (props.smallScreen) {
        return "bulkSm";
      }
      return "bulkLg";
    });
    onUpdated(() => registerButton);
    onMounted(() => registerButton);
    const registerButton = () => {
      if (checkBoxRef.value && registerCheckableButtons) {
        registerCheckableButtons(currentKey.value, checkBoxRef.value);
      }
    };
    const className = computed(() => {
      return props.plain ? classNames(styles$1x.CheckableButton, styles$1x["CheckableButton-plain"]) : classNames(styles$1x.CheckableButton, props.selectMode && styles$1x["CheckableButton-selectMode"], props.selected && styles$1x["CheckableButton-selected"], props.measuring && styles$1x["CheckableButton-measuring"]);
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(unref(className)),
        onClick: _cache[2] || (_cache[2] = ($event) => _ctx.$emit("toggle-all"))
      }, [
        createElementVNode("div", {
          class: normalizeClass(unref(styles$1x).Checkbox)
        }, [
          createVNode(unref(_sfc_main$2s), {
            ref_key: "checkBoxRef",
            ref: checkBoxRef,
            label: __props.accessibilityLabel,
            labelHidden: "",
            modelValue: __props.selected,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => isRef(selected) ? selected.value = $event : null),
            disabled: __props.disabled,
            onChange: _cache[1] || (_cache[1] = ($event) => _ctx.$emit("toggle-all"))
          }, null, 8, ["label", "modelValue", "disabled"])
        ], 2),
        createElementVNode("span", {
          class: normalizeClass(unref(styles$1x).Label)
        }, toDisplayString(__props.label), 3)
      ], 2);
    };
  }
});
const _hoisted_1$1d = {
  viewBox: "0 0 20 20",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$G = /* @__PURE__ */ createElementVNode("path", { d: "M14.167 9H5.833C5.373 9 5 9.448 5 10s.372 1 .833 1h8.334c.46 0 .833-.448.833-1s-.373-1-.833-1" }, null, -1);
const _hoisted_3$s = [
  _hoisted_2$G
];
function render$i(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1$1d, _hoisted_3$s);
}
var MinusMinor = { render: render$i };
const _hoisted_1$1c = {
  viewBox: "0 0 20 20",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$F = /* @__PURE__ */ createElementVNode("path", { d: "M14.723 6.237a.94.94 0 0 1 .053 1.277L9.41 13.707a.834.834 0 0 1-.611.293.83.83 0 0 1-.622-.264L5.25 10.639a.94.94 0 0 1 0-1.278.82.82 0 0 1 1.207 0l2.297 2.43 4.763-5.498a.821.821 0 0 1 1.206-.056Z" }, null, -1);
const _hoisted_3$r = [
  _hoisted_2$F
];
function render$h(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1$1c, _hoisted_3$r);
}
var TickSmallMinor = { render: render$h };
const Checkbox$3 = "Polaris-Checkbox";
const Input$5 = "Polaris-Checkbox__Input";
const keyFocused$3 = "Polaris-Checkbox--keyFocused";
const Backdrop$5 = "Polaris-Checkbox__Backdrop";
const Icon$8 = "Polaris-Checkbox__Icon";
const hover$3 = "Polaris-Checkbox--hover";
const error$4 = "Polaris-Checkbox--error";
var styles$1w = {
  Checkbox: Checkbox$3,
  Input: Input$5,
  keyFocused: keyFocused$3,
  Backdrop: Backdrop$5,
  "Input-indeterminate": "Polaris-Checkbox__Input--indeterminate",
  Icon: Icon$8,
  hover: hover$3,
  error: error$4
};
const errorTextID = (id) => `${id}Error`;
const Choice = "Polaris-Choice";
const labelHidden = "Polaris-Choice--labelHidden";
const Label$4 = "Polaris-Choice__Label";
const Control = "Polaris-Choice__Control";
const disabled$7 = "Polaris-Choice--disabled";
const Descriptions = "Polaris-Choice__Descriptions";
const HelpText$2 = "Polaris-Choice__HelpText";
var styles$1v = {
  Choice,
  labelHidden,
  Label: Label$4,
  Control,
  disabled: disabled$7,
  Descriptions,
  HelpText: HelpText$2
};
const helpTextID = (id) => `${id}HelpText`;
const _hoisted_1$1b = {
  viewBox: "0 0 20 20",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$E = /* @__PURE__ */ createElementVNode("path", { d: "M10 18a8 8 0 1 1 0-16 8 8 0 0 1 0 16zM9 9a1 1 0 0 0 2 0V7a1 1 0 1 0-2 0v2zm0 4a1 1 0 1 0 2 0 1 1 0 0 0-2 0z" }, null, -1);
const _hoisted_3$q = [
  _hoisted_2$E
];
function render$g(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1$1b, _hoisted_3$q);
}
var AlertMinor = { render: render$g };
const InlineError = "Polaris-InlineError";
const Icon$7 = "Polaris-InlineError__Icon";
var styles$1u = {
  InlineError,
  Icon: Icon$7
};
var InlineError_vue_vue_type_style_index_0_lang = "";
const _hoisted_1$1a = ["id"];
const _hoisted_2$D = { key: 1 };
const _sfc_main$2u = /* @__PURE__ */ defineComponent({
  props: {
    message: null,
    fieldID: null
  },
  setup(__props) {
    return (_ctx, _cache) => {
      return __props.message ? (openBlock(), createElementBlock("div", {
        key: 0,
        id: unref(errorTextID)(__props.fieldID),
        class: normalizeClass(unref(styles$1u).InlineError)
      }, [
        createElementVNode("div", {
          class: normalizeClass(unref(styles$1u).Icon)
        }, [
          createVNode(unref(_sfc_main$2K), { source: unref(AlertMinor) }, null, 8, ["source"])
        ], 2),
        typeof __props.message === "object" ? (openBlock(), createBlock(resolveDynamicComponent(__props.message), { key: 0 })) : (openBlock(), createElementBlock("div", _hoisted_2$D, toDisplayString(__props.message), 1))
      ], 10, _hoisted_1$1a)) : createCommentVNode("", true);
    };
  }
});
var Choice_vue_vue_type_style_index_0_lang = "";
const _hoisted_1$19 = { key: 0 };
const _hoisted_2$C = ["id"];
const _sfc_main$2t = /* @__PURE__ */ defineComponent({
  props: {
    id: null,
    label: null,
    disabled: { type: Boolean },
    error: null,
    labelHidden: { type: Boolean },
    helpText: null
  },
  setup(__props) {
    const props = __props;
    const className = computed(() => classNames(styles$1v.Choice, props.labelHidden && styles$1v.labelHidden, props.disabled && styles$1v.disabled));
    return (_ctx, _cache) => {
      return __props.error && typeof __props.error !== "boolean" || _ctx.$slots["help-text"] ? (openBlock(), createElementBlock("div", _hoisted_1$19, [
        createElementVNode("label", {
          class: normalizeClass(unref(className)),
          onClick: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("click")),
          onMouseover: _cache[1] || (_cache[1] = ($event) => _ctx.$emit("mouseover")),
          onMouseout: _cache[2] || (_cache[2] = ($event) => _ctx.$emit("mouseout"))
        }, [
          createElementVNode("span", {
            class: normalizeClass(unref(styles$1v).Control)
          }, [
            renderSlot(_ctx.$slots, "default")
          ], 2),
          createElementVNode("span", {
            class: normalizeClass(unref(styles$1v).Label)
          }, [
            createVNode(unref(Text), {
              as: "span",
              variant: "bodyMd"
            }, {
              default: withCtx(() => [
                _ctx.$slots.label ? renderSlot(_ctx.$slots, "label", { key: 0 }) : __props.label ? (openBlock(), createElementBlock(Fragment, { key: 1 }, [
                  createTextVNode(toDisplayString(__props.label), 1)
                ], 64)) : createCommentVNode("", true)
              ]),
              _: 3
            })
          ], 2)
        ], 34),
        createElementVNode("div", {
          class: normalizeClass(unref(styles$1v).Descriptions)
        }, [
          _ctx.$slots["help-text"] || __props.helpText ? (openBlock(), createElementBlock("div", {
            key: 0,
            id: unref(helpTextID)(__props.id),
            class: normalizeClass(unref(styles$1v).HelpText)
          }, [
            createVNode(unref(Text), {
              as: "span",
              variant: "bodyMd",
              color: "subdued"
            }, {
              default: withCtx(() => [
                _ctx.$slots["help-text"] ? renderSlot(_ctx.$slots, "help-text", { key: 0 }) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
                  createTextVNode(toDisplayString(__props.helpText), 1)
                ], 64))
              ]),
              _: 3
            })
          ], 10, _hoisted_2$C)) : createCommentVNode("", true),
          __props.error && typeof __props.error !== "boolean" ? (openBlock(), createBlock(unref(_sfc_main$2u), {
            key: 1,
            fieldID: __props.id,
            message: __props.error
          }, null, 8, ["fieldID", "message"])) : createCommentVNode("", true)
        ], 2)
      ])) : (openBlock(), createElementBlock("label", {
        key: 1,
        class: normalizeClass(unref(className)),
        onClick: _cache[3] || (_cache[3] = ($event) => _ctx.$emit("click")),
        onMouseover: _cache[4] || (_cache[4] = ($event) => _ctx.$emit("mouseover")),
        onMouseout: _cache[5] || (_cache[5] = ($event) => _ctx.$emit("mouseout"))
      }, [
        createElementVNode("span", {
          class: normalizeClass(unref(styles$1v).Control)
        }, [
          renderSlot(_ctx.$slots, "default")
        ], 2),
        createElementVNode("span", {
          class: normalizeClass(unref(styles$1v).Label)
        }, [
          createVNode(unref(Text), {
            as: "span",
            variant: "bodyMd"
          }, {
            default: withCtx(() => [
              _ctx.$slots.label ? renderSlot(_ctx.$slots, "label", { key: 0 }) : __props.label ? (openBlock(), createElementBlock(Fragment, { key: 1 }, [
                createTextVNode(toDisplayString(__props.label), 1)
              ], 64)) : createCommentVNode("", true)
            ]),
            _: 3
          })
        ], 2)
      ], 34));
    };
  }
});
var Checkbox_vue_vue_type_style_index_0_lang$2 = "";
const _hoisted_1$18 = ["id", "role", "name", "value", "checked", "disabled", "aria-invalid", "aria-controls", "aria-describedby"];
const _sfc_main$2s = /* @__PURE__ */ defineComponent({
  props: {
    ariaControls: null,
    ariaDescribedBy: null,
    label: null,
    labelHidden: { type: Boolean },
    checked: { type: [Boolean, String] },
    helpText: null,
    disabled: { type: Boolean },
    id: null,
    name: null,
    value: { type: [String, Boolean] },
    modelValue: { type: [String, Boolean] },
    error: null
  },
  emits: ["focus", "change", "update:modelValue", "blur"],
  setup(__props, { emit: emits }) {
    const props = __props;
    const isWithinListbox = inject("withinListboxContext", false);
    const mouseOver = ref(false);
    const keyFocused2 = ref(false);
    const slots = useSlots();
    const helpTextSlot = computed(() => {
      var _a;
      return (_a = slots["help-text"]) == null ? void 0 : _a.call(slots);
    });
    const { useUniqueId } = UseUniqueId();
    const uniqueId = computed(() => useUniqueId("Checkbox", props.id));
    const isIndeterminate = computed(() => props.modelValue === "indeterminate" || props.checked === "indeterminate");
    const isChecked = computed(() => !isIndeterminate.value && Boolean(props.checked) || typeof props.modelValue === "boolean" && props.modelValue === true);
    const iconSource = computed(() => isIndeterminate.value ? MinusMinor : TickSmallMinor);
    const wrapperClassName = computed(() => classNames(styles$1w.Checkbox, props.error && styles$1w.error));
    const backdropClassName = computed(() => classNames(styles$1w.Backdrop, mouseOver.value && styles$1w.hover));
    const inputClassName = computed(() => classNames(styles$1w.Input, isIndeterminate.value && styles$1w["Input-indeterminate"], keyFocused2.value && styles$1w.keyFocused));
    const indeterminateAttributes = computed(() => isIndeterminate.value ? { indeterminate: true, "aria-checked": "mixed" } : { "aria-checked": isChecked.value });
    const formattedAriaDescribedBy = computed(() => {
      const describedBy = [];
      if (props.ariaDescribedBy) {
        describedBy.push(props.ariaDescribedBy);
      }
      if (props.error && typeof props.error !== "boolean") {
        describedBy.push(errorTextID(uniqueId.value));
      }
      if (helpTextSlot.value) {
        describedBy.push(helpTextID(uniqueId.value));
      }
      return describedBy.length ? describedBy.join(" ") : void 0;
    });
    const handleFocus = () => {
      keyFocused2.value = true;
      emits("focus");
    };
    const handleChange = (event) => {
      const target = event.target;
      emits("change", event);
      emits("update:modelValue", target.checked);
    };
    const handleBlur = () => {
      keyFocused2.value = false;
      emits("blur");
    };
    const handleKeyup = (event) => {
      const { key } = event;
      if (key === Key.Space || key === Key.Tab) {
        if (!keyFocused2.value) {
          keyFocused2.value = true;
        }
      }
    };
    function stopPropagation(event) {
      event.stopPropagation();
    }
    return (_ctx, _cache) => {
      return openBlock(), createBlock(unref(_sfc_main$2t), {
        id: unref(uniqueId),
        error: __props.error,
        disabled: __props.disabled,
        labelHidden: __props.labelHidden,
        onMouseover: _cache[0] || (_cache[0] = ($event) => mouseOver.value = true),
        onMouseout: _cache[1] || (_cache[1] = ($event) => mouseOver.value = false)
      }, createSlots({
        default: withCtx(() => [
          createElementVNode("span", {
            class: normalizeClass(unref(wrapperClassName))
          }, [
            createElementVNode("input", mergeProps({
              id: unref(uniqueId),
              role: unref(isWithinListbox) ? "presentation" : "checkbox",
              name: __props.name,
              value: __props.value || __props.modelValue,
              type: "checkbox",
              checked: unref(isChecked),
              disabled: __props.disabled,
              class: unref(inputClassName),
              "aria-invalid": __props.error !== null,
              "aria-controls": __props.ariaControls,
              "aria-describedby": unref(formattedAriaDescribedBy),
              onFocus: handleFocus,
              onChange: handleChange,
              onBlur: handleBlur,
              onKeyup: handleKeyup
            }, unref(indeterminateAttributes)), null, 16, _hoisted_1$18),
            createElementVNode("span", {
              class: normalizeClass(unref(backdropClassName)),
              onClick: stopPropagation,
              onMouseup: stopPropagation
            }, null, 34),
            createElementVNode("span", {
              class: normalizeClass(unref(styles$1w).Icon)
            }, [
              createVNode(unref(_sfc_main$2K), { source: unref(iconSource) }, null, 8, ["source"])
            ], 2)
          ], 2)
        ]),
        _: 2
      }, [
        unref(slots).label || __props.label ? {
          name: "label",
          fn: withCtx(() => [
            unref(slots).label ? renderSlot(_ctx.$slots, "label", { key: 0 }) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
              createTextVNode(toDisplayString(__props.label), 1)
            ], 64))
          ])
        } : void 0,
        unref(slots)["help-text"] || __props.helpText ? {
          name: "help-text",
          fn: withCtx(() => [
            unref(slots)["help-text"] ? renderSlot(_ctx.$slots, "help-text", { key: 0 }) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
              createTextVNode(toDisplayString(__props.helpText), 1)
            ], 64))
          ])
        } : void 0
      ]), 1032, ["id", "error", "disabled", "labelHidden"]);
    };
  }
});
const ChoiceList = "Polaris-ChoiceList";
const ChoiceItem = "Polaris-ChoiceList__ChoiceItem";
const titleHidden$4 = "Polaris-ChoiceList--titleHidden";
const Title$7 = "Polaris-ChoiceList__Title";
const Choices = "Polaris-ChoiceList__Choices";
const ChoiceChildren = "Polaris-ChoiceList__ChoiceChildren";
const ChoiceError = "Polaris-ChoiceList__ChoiceError";
var styles$1t = {
  ChoiceList,
  ChoiceItem,
  titleHidden: titleHidden$4,
  Title: Title$7,
  Choices,
  ChoiceChildren,
  ChoiceError
};
var ChoiceList_vue_vue_type_style_index_0_lang = "";
const _hoisted_1$17 = ["id", "aria-invalid"];
const _hoisted_2$B = ["innerHTML"];
const _sfc_main$2r = /* @__PURE__ */ defineComponent({
  props: {
    choices: null,
    modelValue: null,
    name: null,
    allowMultiple: { type: Boolean },
    titleHidden: { type: Boolean },
    error: null,
    id: null,
    disabled: { type: Boolean }
  },
  emits: ["change", "update:modelValue"],
  setup(__props, { emit: emits }) {
    const props = __props;
    const { useUniqueId } = UseUniqueId();
    const uniqueId = computed(() => useUniqueId("ChoiceList", props.name));
    const finalName = computed(() => props.allowMultiple ? `${uniqueId.value}[]` : uniqueId.value);
    const className = computed(() => classNames(styles$1t.ChoiceList, props.titleHidden && styles$1t.titleHidden));
    const isChoiceSelected = (choice) => props.allowMultiple ? props.modelValue.includes(choice.value) : props.modelValue === choice.value;
    const updateSelectedChoices = (event) => {
      const target = event.target;
      if (target.checked) {
        return props.allowMultiple ? [...props.modelValue, target.value] : target.value;
      }
      return Array.isArray(props.modelValue) ? props.modelValue.filter((val) => val !== target.value) : [];
    };
    const handleChange = (event) => {
      emits("update:modelValue", updateSelectedChoices(event));
      emits("change", event);
    };
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("fieldset", {
        id: unref(finalName),
        class: normalizeClass(unref(className)),
        "aria-invalid": __props.error !== null
      }, [
        _ctx.$slots.default ? (openBlock(), createElementBlock("legend", {
          key: 0,
          class: normalizeClass(unref(styles$1t).Title)
        }, [
          createVNode(unref(Text), {
            as: "span",
            variant: "bodyMd"
          }, {
            default: withCtx(() => [
              renderSlot(_ctx.$slots, "default")
            ]),
            _: 3
          })
        ], 2)) : createCommentVNode("", true),
        createElementVNode("ul", {
          class: normalizeClass(unref(styles$1t).Choices)
        }, [
          (openBlock(true), createElementBlock(Fragment, null, renderList(__props.choices, (choice, index) => {
            return openBlock(), createElementBlock("li", {
              key: index,
              class: normalizeClass(unref(styles$1t).ChoiceItem)
            }, [
              (openBlock(), createBlock(resolveDynamicComponent(__props.allowMultiple ? unref(_sfc_main$2s) : unref(_sfc_main$F)), {
                name: unref(finalName),
                id: __props.id,
                value: choice.value,
                checked: isChoiceSelected(choice),
                disabled: choice.disabled || __props.disabled,
                ariaDescribedBy: __props.error && choice.describedByError ? unref(errorTextID)(unref(finalName)) : null,
                onChange: handleChange
              }, createSlots({ _: 2 }, [
                choice.label ? {
                  name: "label",
                  fn: withCtx(() => [
                    createElementVNode("span", null, toDisplayString(choice.label), 1)
                  ])
                } : void 0,
                choice.helpText ? {
                  name: "help-text",
                  fn: withCtx(() => [
                    createElementVNode("span", null, toDisplayString(choice.helpText), 1)
                  ])
                } : void 0
              ]), 1032, ["name", "id", "value", "checked", "disabled", "ariaDescribedBy"])),
              typeof choice.renderChildren === "string" ? (openBlock(), createElementBlock("div", {
                key: 0,
                innerHTML: choice.renderChildren,
                class: normalizeClass(unref(styles$1t).ChoiceChildren)
              }, null, 10, _hoisted_2$B)) : (openBlock(), createBlock(resolveDynamicComponent(choice.renderChildren), {
                key: 1,
                class: normalizeClass(unref(styles$1t).ChoiceChildren)
              }, null, 8, ["class"]))
            ], 2);
          }), 128))
        ], 2),
        __props.error ? (openBlock(), createElementBlock("div", {
          key: 1,
          class: normalizeClass(unref(styles$1t).ChoiceError)
        }, [
          createVNode(unref(_sfc_main$2u), {
            fieldID: unref(finalName),
            message: __props.error
          }, null, 8, ["fieldID", "message"])
        ], 2)) : createCommentVNode("", true)
      ], 10, _hoisted_1$17);
    };
  }
});
const Collapsible = "Polaris-Collapsible";
const isFullyClosed = "Polaris-Collapsible--isFullyClosed";
const expandOnPrint = "Polaris-Collapsible--expandOnPrint";
var styles$1s = {
  Collapsible,
  isFullyClosed,
  expandOnPrint
};
var Collapsible_vue_vue_type_style_index_0_lang = "";
const _hoisted_1$16 = ["id", "aria-hidden"];
const _sfc_main$2q = /* @__PURE__ */ defineComponent({
  props: {
    id: null,
    expandOnPrint: { type: Boolean },
    open: { type: Boolean },
    preventMeasuringOnChildrenUpdate: { type: Boolean },
    transition: { type: [Boolean, Object], default: true }
  },
  setup(__props) {
    const props = __props;
    const height = ref(0);
    const animationState = ref("idle");
    const collapsibleContainerRef = ref(null);
    const isOpen = ref(props.open);
    const isFullyOpen = computed(() => {
      return animationState.value === "idle" && props.open && isOpen.value;
    });
    const isFullyClosed2 = computed(() => {
      return animationState.value === "idle" && !props.open && !isOpen.value;
    });
    const wrapperClassName = computed(() => {
      return classNames(styles$1s.Collapsible, isFullyClosed2.value && styles$1s.isFullyClosed, props.expandOnPrint && styles$1s.expandOnPrint);
    });
    const collapsibleStyles = computed(() => {
      return __spreadValues(__spreadValues({}, transitionStyles.value), {
        maxHeight: isFullyOpen.value ? "none" : `${height.value}px`,
        overflow: isFullyOpen.value ? "visible" : "hidden"
      });
    });
    const transitionDisabled = computed(() => isTransitionDisabled(props.transition));
    const transitionStyles = computed(() => {
      return typeof props.transition === "object" && {
        transitionDuration: props.transition.duration,
        transitionTimingFunction: props.transition.timingFunction
      };
    });
    const startAnimation = () => {
      if (transitionDisabled.value) {
        isOpen.value = props.open;
        animationState.value = "idle";
        if (props.open && collapsibleContainerRef.value) {
          height.value = collapsibleContainerRef.value.scrollHeight;
        } else {
          height.value = 0;
        }
      } else {
        animationState.value = "measuring";
      }
    };
    const handleCompleteAnimation = ({ target }) => {
      if (target === collapsibleContainerRef.value) {
        animationState.value = "idle";
        isOpen.value = props.open;
      }
    };
    watch(() => [props.open, isOpen.value], () => {
      if (props.open !== isOpen.value) {
        startAnimation();
        return;
      }
      if (!isFullyClosed2.value && !props.preventMeasuringOnChildrenUpdate) {
        animationState.value = "measuring";
      }
    });
    onUpdated(() => {
      if (!collapsibleContainerRef.value) {
        return;
      }
      switch (animationState.value) {
        case "idle":
          break;
        case "measuring":
          height.value = collapsibleContainerRef.value.scrollHeight;
          animationState.value = "animating";
          break;
        case "animating":
          height.value = props.open ? collapsibleContainerRef.value.scrollHeight : 0;
      }
    });
    onMounted(() => {
      if (!open || !collapsibleContainerRef.value) {
        return;
      }
      height.value = collapsibleContainerRef.value.scrollHeight;
    });
    const zeroDurationRegex = /^0(ms|s)$/;
    function isTransitionDisabled(transitionProp) {
      if (typeof transitionProp === "boolean") {
        return !transitionProp;
      }
      const { duration } = transitionProp;
      if (duration && zeroDurationRegex.test(duration.trim())) {
        return true;
      }
      return false;
    }
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        id: __props.id,
        style: normalizeStyle(unref(collapsibleStyles)),
        ref_key: "collapsibleContainerRef",
        ref: collapsibleContainerRef,
        class: normalizeClass(unref(wrapperClassName)),
        onTransitionend: handleCompleteAnimation,
        "aria-hidden": !__props.open
      }, [
        __props.expandOnPrint || !unref(isFullyClosed2) ? renderSlot(_ctx.$slots, "default", { key: 0 }) : createCommentVNode("", true)
      ], 46, _hoisted_1$16);
    };
  }
});
function roundNumberToDecimalPlaces(value2, decimals) {
  const exponent = Number(`${value2}e${decimals}`);
  const roundedExponent = Math.round(exponent);
  const numberWithDecimalPlaces = Number(`${roundedExponent}e-${decimals}`);
  return numberWithDecimalPlaces;
}
function componentToHex(component) {
  const hex = component.toString(16);
  return hex.length === 1 ? `0${hex}` : hex;
}
function rgbFromHueAndChroma(hue, chroma) {
  const huePrime = hue / 60;
  const hueDelta = 1 - Math.abs(huePrime % 2 - 1);
  const intermediateValue = chroma * hueDelta;
  let red = 0;
  let green = 0;
  let blue = 0;
  if (huePrime >= 0 && huePrime <= 1) {
    red = chroma;
    green = intermediateValue;
    blue = 0;
  }
  if (huePrime >= 1 && huePrime <= 2) {
    red = intermediateValue;
    green = chroma;
    blue = 0;
  }
  if (huePrime >= 2 && huePrime <= 3) {
    red = 0;
    green = chroma;
    blue = intermediateValue;
  }
  if (huePrime >= 3 && huePrime <= 4) {
    red = 0;
    green = intermediateValue;
    blue = chroma;
  }
  if (huePrime >= 4 && huePrime <= 5) {
    red = intermediateValue;
    green = 0;
    blue = chroma;
  }
  if (huePrime >= 5 && huePrime <= 6) {
    red = chroma;
    green = 0;
    blue = intermediateValue;
  }
  return { red, green, blue };
}
function rgbToHsbl(color, type = "b") {
  const { alpha = 1 } = color;
  const red = color.red / 255;
  const green = color.green / 255;
  const blue = color.blue / 255;
  const largestComponent = Math.max(red, green, blue);
  const smallestComponent = Math.min(red, green, blue);
  const delta = largestComponent - smallestComponent;
  const lightness = (largestComponent + smallestComponent) / 2;
  let saturation = 0;
  if (largestComponent === 0) {
    saturation = 0;
  } else if (type === "b") {
    saturation = delta / largestComponent;
  } else if (type === "l") {
    const baseSaturation = lightness > 0.5 ? delta / (2 - largestComponent - smallestComponent) : delta / (largestComponent + smallestComponent);
    saturation = Number.isNaN(baseSaturation) ? 0 : baseSaturation;
  }
  let huePercentage = 0;
  switch (largestComponent) {
    case red:
      huePercentage = (green - blue) / delta + (green < blue ? 6 : 0);
      break;
    case green:
      huePercentage = (blue - red) / delta + 2;
      break;
    case blue:
      huePercentage = (red - green) / delta + 4;
      break;
  }
  const hue = huePercentage / 6 * 360;
  const clampedHue = clamp(hue, 0, 360);
  return {
    hue: clampedHue ? roundNumberToDecimalPlaces(clampedHue, 2) : 0,
    saturation: roundNumberToDecimalPlaces(clamp(saturation, 0, 1), 4),
    brightness: roundNumberToDecimalPlaces(clamp(largestComponent, 0, 1), 4),
    lightness: roundNumberToDecimalPlaces(lightness, 4),
    alpha: roundNumberToDecimalPlaces(alpha, 4)
  };
}
function hexToRgb(color) {
  if (color.length === 4) {
    const repeatHex = (hex1, hex2) => color.slice(hex1, hex2).repeat(2);
    const red2 = parseInt(repeatHex(1, 2), 16);
    const green2 = parseInt(repeatHex(2, 3), 16);
    const blue2 = parseInt(repeatHex(3, 4), 16);
    return { red: red2, green: green2, blue: blue2 };
  }
  const red = parseInt(color.slice(1, 3), 16);
  const green = parseInt(color.slice(3, 5), 16);
  const blue = parseInt(color.slice(5, 7), 16);
  return { red, green, blue };
}
function rgbToHex({ red, green, blue }) {
  return `#${componentToHex(red)}${componentToHex(green)}${componentToHex(blue)}`;
}
function hsbToRgb(color) {
  const { hue, saturation, brightness } = color;
  const colorAlpha = color;
  const alpha = colorAlpha.alpha || 1;
  const chroma = brightness * saturation;
  let { red, green, blue } = rgbFromHueAndChroma(hue, chroma);
  const chromaBrightnessDelta = brightness - chroma;
  red += chromaBrightnessDelta;
  green += chromaBrightnessDelta;
  blue += chromaBrightnessDelta;
  return {
    red: Math.round(red * 255),
    green: Math.round(green * 255),
    blue: Math.round(blue * 255),
    alpha
  };
}
function hsbToHex(color) {
  return rgbToHex(hsbToRgb(__spreadProps(__spreadValues({}, color), { alpha: 1 })));
}
function rgbToHsb(color) {
  const { hue, saturation, brightness, alpha = 1 } = rgbToHsbl(color, "b");
  return {
    hue,
    saturation,
    brightness,
    alpha
  };
}
const ColorPicker = "Polaris-ColorPicker";
const MainColor = "Polaris-ColorPicker__MainColor";
const fullWidth$4 = "Polaris-ColorPicker--fullWidth";
const Dragger = "Polaris-ColorPicker__Dragger";
const ColorLayer = "Polaris-ColorPicker__ColorLayer";
const HuePicker = "Polaris-ColorPicker__HuePicker";
const AlphaPicker = "Polaris-ColorPicker__AlphaPicker";
const Slidable = "Polaris-ColorPicker__Slidable";
var styles$1r = {
  ColorPicker,
  MainColor,
  fullWidth: fullWidth$4,
  Dragger,
  ColorLayer,
  HuePicker,
  AlphaPicker,
  Slidable
};
const VERTICAL_PADDING$1 = 13;
function calculateDraggerY$1(alpha, sliderHeight, draggerHeight) {
  const offset = offsetForAlpha(alpha, sliderHeight, draggerHeight);
  return clamp(offset, 0, sliderHeight);
}
function alphaForDraggerY(y, sliderHeight) {
  const offsetY = clamp(y, 0, sliderHeight);
  return alphaForOffset(offsetY, sliderHeight);
}
function alphaForOffset(offset, sliderHeight) {
  const selectionHeight = offset - VERTICAL_PADDING$1;
  const slidableArea = sliderHeight - VERTICAL_PADDING$1 * 2;
  return clamp(1 - selectionHeight / slidableArea, 0, 1);
}
function offsetForAlpha(alpha, sliderHeight, draggerHeight) {
  const slidableArea = sliderHeight - (draggerHeight + VERTICAL_PADDING$1);
  return clamp((1 - alpha) * slidableArea + VERTICAL_PADDING$1, 0, sliderHeight - draggerHeight);
}
const _hoisted_1$15 = ["data-dragging"];
const _sfc_main$2p = /* @__PURE__ */ defineComponent({
  props: {
    draggerX: { default: 0 },
    draggerY: { default: 0 }
  },
  emits: ["change", "dragger-height"],
  setup(__props, { emit: emits }) {
    const props = __props;
    const isDragging2 = ref(false);
    const slidableRef = ref(null);
    const draggerRef = ref(null);
    const positionX = ref(0);
    const positionY = ref(0);
    const draggerPositioning = computed(() => {
      return { transform: `translate3d(${positionX.value || props.draggerX}px, ${positionY.value || props.draggerY}px, 0)` };
    });
    if (!isServer) {
      window.addEventListener("touchmove", (e) => {
        if (isDragging2.value) {
          e.preventDefault();
        }
      }, { passive: false });
    }
    onMounted(() => {
      if (draggerRef.value) {
        emits("dragger-height", draggerRef.value.clientWidth);
      }
    });
    const startDrag = (event) => {
      if (isMouseDownEvent(event)) {
        const { clientX, clientY } = event;
        handleDraggerMove(clientX, clientY);
      }
      isDragging2.value = true;
    };
    const handleDragEnd = () => {
      isDragging2.value = false;
    };
    const handleMove = (event) => {
      event.stopImmediatePropagation();
      event.stopPropagation();
      if (event.cancelable) {
        event.preventDefault();
      }
      if (isMouseMoveEvent(event)) {
        const eventMouse = event;
        handleDraggerMove(eventMouse.clientX, eventMouse.clientY);
        return;
      }
      const eventTouch = event;
      handleDraggerMove(eventTouch.touches[0].clientX, eventTouch.touches[0].clientY);
    };
    const handleDraggerMove = (x, y) => {
      if (slidableRef.value) {
        const rect = slidableRef.value.getBoundingClientRect();
        const offsetX = x - rect.left;
        const offsetY = y - rect.top;
        emits("change", { x: offsetX, y: offsetY });
      }
    };
    function isMouseMoveEvent(event) {
      return event.type === "mousemove";
    }
    function isMouseDownEvent(event) {
      return event.type === "mousedown";
    }
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        ref_key: "slidableRef",
        ref: slidableRef,
        class: normalizeClass(unref(styles$1r).Slidable),
        "data-dragging": isDragging2.value,
        onMousedown: startDrag,
        onTouchstart: startDrag
      }, [
        isDragging2.value ? (openBlock(), createBlock(unref(_sfc_main$33), {
          key: 0,
          event: "mouseup",
          handler: handleDragEnd
        })) : createCommentVNode("", true),
        isDragging2.value ? (openBlock(), createBlock(unref(_sfc_main$33), {
          key: 1,
          event: "mousemove",
          handler: handleMove,
          passive: false
        })) : createCommentVNode("", true),
        isDragging2.value ? (openBlock(), createBlock(unref(_sfc_main$33), {
          key: 2,
          event: "touchmove",
          handler: handleMove,
          passive: false
        })) : createCommentVNode("", true),
        isDragging2.value ? (openBlock(), createBlock(unref(_sfc_main$33), {
          key: 3,
          event: "touchend",
          handler: handleDragEnd
        })) : createCommentVNode("", true),
        isDragging2.value ? (openBlock(), createBlock(unref(_sfc_main$33), {
          key: 4,
          event: "touchcancel",
          handler: handleDragEnd
        })) : createCommentVNode("", true),
        createElementVNode("div", {
          style: normalizeStyle(unref(draggerPositioning)),
          class: normalizeClass(unref(styles$1r).Dragger),
          ref_key: "draggerRef",
          ref: draggerRef
        }, null, 6)
      ], 42, _hoisted_1$15);
    };
  }
});
const _sfc_main$2o = /* @__PURE__ */ defineComponent({
  props: {
    color: null,
    alpha: null
  },
  emits: ["change"],
  setup(__props, { emit: emits }) {
    const props = __props;
    const alphaPickerRef = ref(null);
    const sliderHeight = ref(0);
    const draggerHeight = ref(0);
    const draggerY = computed(() => {
      return calculateDraggerY$1(props.alpha, sliderHeight.value, draggerHeight.value);
    });
    const background = computed(() => {
      const { red, green, blue } = hsbToRgb(props.color);
      const rgb = `${red}, ${green}, ${blue}`;
      return `linear-gradient(to top, rgba(${rgb}, 0) 18px, rgba(${rgb}, 1) calc(100% - 18px))`;
    });
    onMounted(() => {
      setSliderHeight();
    });
    const setSliderHeight = () => {
      if (alphaPickerRef.value) {
        sliderHeight.value = alphaPickerRef.value.clientHeight;
      }
    };
    const setDraggerHeight = (height) => {
      draggerHeight.value = height;
    };
    const handleChange = ({ y }) => {
      const alpha = alphaForDraggerY(y, sliderHeight.value);
      emits("change", alpha);
    };
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(unref(styles$1r).AlphaPicker),
        ref_key: "alphaPickerRef",
        ref: alphaPickerRef
      }, [
        createElementVNode("div", {
          class: normalizeClass(unref(styles$1r).ColorLayer),
          style: normalizeStyle({ background: unref(background) })
        }, "\xA0", 6),
        createVNode(unref(_sfc_main$2p), {
          draggerY: unref(draggerY),
          draggerX: 0,
          onChange: handleChange,
          onDraggerHeight: setDraggerHeight
        }, null, 8, ["draggerY"])
      ], 2);
    };
  }
});
const VERTICAL_PADDING = 13;
function calculateDraggerY(hue, sliderHeight, draggerHeight) {
  const offset = offsetForHue(hue, sliderHeight, draggerHeight);
  return clamp(offset, 0, sliderHeight);
}
function hueForDraggerY(y, sliderHeight) {
  const offsetY = clamp(y, 0, sliderHeight);
  return hueForOffset(offsetY, sliderHeight);
}
function hueForOffset(offset, sliderHeight) {
  const selectionHeight = offset - VERTICAL_PADDING;
  const slidableArea = sliderHeight - VERTICAL_PADDING * 2;
  return clamp(selectionHeight / slidableArea * 360, 0, 360);
}
function offsetForHue(hue, sliderHeight, draggerHeight) {
  const slidableArea = sliderHeight - (draggerHeight + VERTICAL_PADDING);
  return clamp(hue / 360 * slidableArea + VERTICAL_PADDING, 0, sliderHeight - draggerHeight);
}
const _sfc_main$2n = /* @__PURE__ */ defineComponent({
  props: {
    hue: null
  },
  emits: ["change"],
  setup(__props, { emit }) {
    const props = __props;
    const huePickerRef = ref(null);
    const sliderHeight = ref(0);
    const draggerHeight = ref(0);
    const draggerY = computed(() => {
      return calculateDraggerY(props.hue, sliderHeight.value, draggerHeight.value);
    });
    onMounted(() => {
      setSliderHeight();
    });
    const setSliderHeight = () => {
      if (huePickerRef.value) {
        sliderHeight.value = huePickerRef.value.clientHeight;
      }
    };
    const setDraggerHeight = (height) => {
      draggerHeight.value = height;
    };
    const handleChange = ({ y }) => {
      const hue = hueForDraggerY(y, sliderHeight.value);
      emit("change", hue);
    };
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(unref(styles$1r).HuePicker),
        ref_key: "huePickerRef",
        ref: huePickerRef
      }, [
        createVNode(unref(_sfc_main$2p), {
          draggerY: unref(draggerY),
          draggerX: 0,
          onChange: handleChange,
          onDraggerHeight: setDraggerHeight
        }, null, 8, ["draggerY"])
      ], 2);
    };
  }
});
var ColorPicker_vue_vue_type_style_index_0_lang = "";
const _hoisted_1$14 = ["id", "onMousedown"];
const _sfc_main$2m = /* @__PURE__ */ defineComponent({
  props: {
    id: null,
    modelValue: null,
    allowAlpha: { type: Boolean },
    fullWidth: { type: Boolean },
    outputType: null
  },
  emits: ["change", "update:modelValue"],
  setup(__props, { emit: emits }) {
    const props = __props;
    const RESIZE_DEBOUNCE_TIME_MS = 200;
    const mainColorRef = ref(null);
    const colorHsb = reactive({
      hue: 0,
      saturation: 0,
      brightness: 0,
      alpha: 1
    });
    const pickerSize = reactive({ width: 0, height: 0 });
    const handlePickerDrag = (event) => {
      event.preventDefault();
    };
    const className = computed(() => {
      return classNames(styles$1r.ColorPicker, props.fullWidth && styles$1r.fullWidth);
    });
    const alpha = computed(() => {
      return colorHsb.alpha !== void 0 && props.allowAlpha ? colorHsb.alpha : 1;
    });
    const colorString = computed(() => {
      const { red, green, blue } = hsbToRgb({
        hue: colorHsb.hue,
        saturation: 1,
        brightness: 1
      });
      return `rgba(${red}, ${green}, ${blue}, ${alpha.value})`;
    });
    const draggerX = computed(() => {
      return clamp(colorHsb.saturation * pickerSize.width, 0, pickerSize.width);
    });
    const draggerY = computed(() => {
      return clamp(pickerSize.height - colorHsb.brightness * pickerSize.height, 0, pickerSize.height);
    });
    const outputColor = computed(() => {
      if (props.outputType === "hex") {
        return hsbToHex(colorHsb);
      }
      if (props.outputType === "rgb") {
        const rgbColor = hsbToRgb(colorHsb);
        return `rgba(${rgbColor.red}, ${rgbColor.green}, ${rgbColor.blue}, ${alpha.value})`;
      }
      return colorHsb;
    });
    const handleResize = debounce(() => {
      if (mainColorRef.value) {
        pickerSize.width = mainColorRef.value.clientWidth;
        pickerSize.height = mainColorRef.value.clientHeight;
      }
    }, RESIZE_DEBOUNCE_TIME_MS, { leading: true, trailing: true, maxWait: RESIZE_DEBOUNCE_TIME_MS });
    if (typeof props.modelValue === "object") {
      Object.assign(colorHsb, props.modelValue);
    }
    if (typeof props.modelValue === "string") {
      let colorRgb;
      if (/#[0-9abcdef]{3,6}/.test(props.modelValue)) {
        colorRgb = __spreadProps(__spreadValues({}, hexToRgb(props.modelValue)), { alpha: 1 });
      } else {
        const colorRgbArr = props.modelValue.replace(/^rgba?\(|\s+|\)$/g, "").split(",");
        colorRgb = {
          red: parseInt(colorRgbArr[0], 10),
          green: parseInt(colorRgbArr[1], 10),
          blue: parseInt(colorRgbArr[2], 10),
          alpha: colorRgbArr[2] ? parseFloat(colorRgbArr[3]) : 1
        };
      }
      Object.assign(colorHsb, __spreadProps(__spreadValues({}, rgbToHsb(colorRgb)), { alpha: colorRgb.alpha }));
    }
    onMounted(() => {
      if (mainColorRef.value) {
        pickerSize.width = mainColorRef.value.clientWidth;
        pickerSize.height = mainColorRef.value.clientHeight;
      }
    });
    const handleHueChange = (hue) => {
      colorHsb.hue = hue;
      emits("change", outputColor.value);
      emits("update:modelValue", outputColor.value);
    };
    const handleAlphaChange = (value2) => {
      colorHsb.alpha = value2;
      emits("change", outputColor.value);
      emits("update:modelValue", outputColor.value);
    };
    const handleDraggerMove = ({ x, y }) => {
      colorHsb.saturation = clamp(x / pickerSize.width, 0, 1);
      colorHsb.brightness = clamp(1 - y / pickerSize.height, 0, 1);
      emits("change", outputColor.value);
      emits("update:modelValue", outputColor.value);
    };
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        id: __props.id,
        class: normalizeClass(unref(className)),
        onMousedown: withModifiers(handlePickerDrag, ["prevent"])
      }, [
        createElementVNode("div", {
          ref_key: "mainColorRef",
          ref: mainColorRef,
          class: normalizeClass(unref(styles$1r).MainColor)
        }, [
          createElementVNode("div", {
            class: normalizeClass(unref(styles$1r).ColorLayer),
            style: normalizeStyle({ backgroundColor: unref(colorString) })
          }, "\xA0", 6),
          createVNode(unref(_sfc_main$2p), {
            draggerX: unref(draggerX),
            draggerY: unref(draggerY),
            onChange: handleDraggerMove
          }, null, 8, ["draggerX", "draggerY"])
        ], 2),
        createVNode(unref(_sfc_main$2n), {
          hue: unref(colorHsb).hue,
          onChange: handleHueChange
        }, null, 8, ["hue"]),
        __props.allowAlpha ? (openBlock(), createBlock(unref(_sfc_main$2o), {
          key: 0,
          alpha: unref(alpha),
          color: unref(colorHsb),
          onChange: handleAlphaChange
        }, null, 8, ["alpha", "color"])) : createCommentVNode("", true),
        createVNode(unref(_sfc_main$33), {
          event: "resize",
          handler: unref(handleResize)
        }, null, 8, ["handler"])
      ], 42, _hoisted_1$14);
    };
  }
});
const Columns = "Polaris-Columns";
var styles$1q = {
  Columns
};
var Columns_vue_vue_type_style_index_0_lang = "";
const _sfc_main$2l = /* @__PURE__ */ defineComponent({
  props: {
    spacing: null,
    columns: null
  },
  setup(__props) {
    const props = __props;
    const style2 = computed(() => {
      var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o;
      const fullStyles = {
        "--pc-columns-xs": formatColumns(((_a = props.columns) == null ? void 0 : _a.xs) || 6),
        "--pc-columns-sm": formatColumns((_b = props.columns) == null ? void 0 : _b.sm),
        "--pc-columns-md": formatColumns((_c = props.columns) == null ? void 0 : _c.md),
        "--pc-columns-lg": formatColumns((_d = props.columns) == null ? void 0 : _d.lg),
        "--pc-columns-xl": formatColumns((_e = props.columns) == null ? void 0 : _e.xl),
        "--pc-columns-space-xs": ((_f = props.spacing) == null ? void 0 : _f.xs) ? `var(--p-space-${(_g = props.spacing) == null ? void 0 : _g.xs})` : void 0,
        "--pc-columns-space-sm": ((_h = props.spacing) == null ? void 0 : _h.sm) ? `var(--p-space-${(_i = props.spacing) == null ? void 0 : _i.sm})` : void 0,
        "--pc-columns-space-md": ((_j = props.spacing) == null ? void 0 : _j.md) ? `var(--p-space-${(_k = props.spacing) == null ? void 0 : _k.md})` : void 0,
        "--pc-columns-space-lg": ((_l = props.spacing) == null ? void 0 : _l.lg) ? `var(--p-space-${(_m = props.spacing) == null ? void 0 : _m.lg})` : void 0,
        "--pc-columns-space-xl": ((_n = props.spacing) == null ? void 0 : _n.xl) ? `var(--p-space-${(_o = props.spacing) == null ? void 0 : _o.xl})` : void 0
      };
      return Object.keys(fullStyles).reduce((acc, key) => {
        if (fullStyles[key] !== void 0) {
          acc[key] = fullStyles[key];
        }
        return acc;
      }, {});
    });
    function formatColumns(columns) {
      if (!columns) {
        return void 0;
      }
      return typeof columns === "number" ? `repeat(${columns}, minmax(0, 1fr))` : columns;
    }
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(unref(styles$1q).Columns),
        style: normalizeStyle(unref(style2))
      }, [
        renderSlot(_ctx.$slots, "default")
      ], 6);
    };
  }
});
const Connected = "Polaris-Connected";
const Item$7 = "Polaris-Connected__Item";
var styles$1p = {
  Connected,
  Item: Item$7,
  "Item-primary": "Polaris-Connected__Item--primary",
  "Item-focused": "Polaris-Connected__Item--focused"
};
const _sfc_main$2k = /* @__PURE__ */ defineComponent({
  props: {
    position: null
  },
  emits: ["focus", "blur"],
  setup(__props, { emit: emits }) {
    const props = __props;
    const focused2 = ref(false);
    const className = computed(() => classNames(styles$1p.Item, focused2.value && styles$1p["Item-focused"], props.position === "primary" && styles$1p["Item-primary"]));
    const handleFocus = () => {
      focused2.value = true;
      emits("focus");
    };
    const handleBlur = () => {
      focused2.value = false;
      emits("blur");
    };
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(unref(className)),
        onFocus: handleFocus,
        onBlur: handleBlur
      }, [
        renderSlot(_ctx.$slots, "default")
      ], 34);
    };
  }
});
var Connected_vue_vue_type_style_index_0_lang = "";
const _sfc_main$2j = /* @__PURE__ */ defineComponent({
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(unref(styles$1p).Connected)
      }, [
        _ctx.$slots.left ? (openBlock(), createBlock(unref(_sfc_main$2k), {
          key: 0,
          position: "left"
        }, {
          default: withCtx(() => [
            renderSlot(_ctx.$slots, "left")
          ]),
          _: 3
        })) : createCommentVNode("", true),
        _ctx.$slots.default ? (openBlock(), createBlock(unref(_sfc_main$2k), {
          key: 1,
          position: "primary"
        }, {
          default: withCtx(() => [
            renderSlot(_ctx.$slots, "default")
          ]),
          _: 3
        })) : createCommentVNode("", true),
        _ctx.$slots.right ? (openBlock(), createBlock(unref(_sfc_main$2k), {
          key: 2,
          position: "right"
        }, {
          default: withCtx(() => [
            renderSlot(_ctx.$slots, "right")
          ]),
          _: 3
        })) : createCommentVNode("", true)
      ], 2);
    };
  }
});
const ContentBlock = "Polaris-ContentBlock";
const md = "Polaris-ContentBlock--md";
const lg = "Polaris-ContentBlock--lg";
var styles$1o = {
  ContentBlock,
  md,
  lg
};
var ContentBlock_vue_vue_type_style_index_0_lang = "";
const _sfc_main$2i = /* @__PURE__ */ defineComponent({
  props: {
    width: null
  },
  setup(__props) {
    const props = __props;
    const className = computed(() => classNames(styles$1o.ContentBlock, styles$1o[props.width]));
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(unref(className))
      }, [
        renderSlot(_ctx.$slots, "default")
      ], 2);
    };
  }
});
function UseFrame() {
  const frame = inject("frameContext", {});
  function useFrame() {
    if (!frame) {
      throw new MissingFrameError("No frame context was provided.");
    }
    return frame;
  }
  return { useFrame };
}
const _sfc_main$2h = /* @__PURE__ */ defineComponent({
  props: {
    alignContentFlush: { type: Boolean },
    message: null,
    saveAction: null,
    discardAction: null,
    fullWidth: { type: Boolean },
    contextControl: null,
    secondaryMenu: null
  },
  setup(__props) {
    const props = __props;
    const { useFrame } = UseFrame();
    const {
      setContextualSaveBar,
      removeContextualSaveBar
    } = useFrame();
    const slots = useSlots();
    onMounted(() => {
      const {
        message,
        saveAction,
        discardAction,
        alignContentFlush,
        fullWidth: fullWidth2
      } = props;
      setContextualSaveBar({
        message,
        saveAction,
        discardAction,
        alignContentFlush,
        fullWidth: fullWidth2,
        contextControl: slots.contextControl && slots.contextControl(),
        secondaryMenu: slots.secondaryMenu && slots.secondaryMenu()
      });
    });
    onBeforeUnmount(() => {
      removeContextualSaveBar();
    });
    return (_ctx, _cache) => {
      return null;
    };
  }
});
const DataTable = "Polaris-DataTable";
const condensed$2 = "Polaris-DataTable--condensed";
const Navigation$3 = "Polaris-DataTable__Navigation";
const IncreasedTableDensity = "Polaris-DataTable__IncreasedTableDensity";
const Pip = "Polaris-DataTable__Pip";
const ScrollContainer$1 = "Polaris-DataTable__ScrollContainer";
const Table$1 = "Polaris-DataTable__Table";
const TableRow$1 = "Polaris-DataTable__TableRow";
const Cell$1 = "Polaris-DataTable__Cell";
const ZebraStripingOnData = "Polaris-DataTable__ZebraStripingOnData";
const RowCountIsEven = "Polaris-DataTable__RowCountIsEven";
const ShowTotalsInFooter = "Polaris-DataTable__ShowTotalsInFooter";
const hoverable = "Polaris-DataTable--hoverable";
const Icon$6 = "Polaris-DataTable__Icon";
const Heading$2 = "Polaris-DataTable__Heading";
const StickyHeaderEnabled = "Polaris-DataTable__StickyHeaderEnabled";
const StickyHeaderWrapper = "Polaris-DataTable__StickyHeaderWrapper";
const ShowTotals = "Polaris-DataTable__ShowTotals";
const Footer$1 = "Polaris-DataTable__Footer";
const StickyHeaderInner = "Polaris-DataTable__StickyHeaderInner";
const StickyHeaderTable = "Polaris-DataTable__StickyHeaderTable";
const FixedFirstColumn = "Polaris-DataTable__FixedFirstColumn";
const StickyTableHeadingsRow = "Polaris-DataTable__StickyTableHeadingsRow";
const TooltipContent = "Polaris-DataTable__TooltipContent";
var styles$1n = {
  DataTable,
  condensed: condensed$2,
  Navigation: Navigation$3,
  IncreasedTableDensity,
  Pip,
  "Pip-visible": "Polaris-DataTable__Pip--visible",
  ScrollContainer: ScrollContainer$1,
  Table: Table$1,
  TableRow: TableRow$1,
  Cell: Cell$1,
  ZebraStripingOnData,
  RowCountIsEven,
  ShowTotalsInFooter,
  "Cell-separate": "Polaris-DataTable__Cell--separate",
  "Cell-firstColumn": "Polaris-DataTable__Cell--firstColumn",
  "Cell-numeric": "Polaris-DataTable__Cell--numeric",
  "Cell-truncated": "Polaris-DataTable__Cell--truncated",
  "Cell-header": "Polaris-DataTable__Cell--header",
  "Cell-sortable": "Polaris-DataTable__Cell--sortable",
  "Heading-left": "Polaris-DataTable__Heading--left",
  "Cell-verticalAlignTop": "Polaris-DataTable__Cell--verticalAlignTop",
  "Cell-verticalAlignBottom": "Polaris-DataTable__Cell--verticalAlignBottom",
  "Cell-verticalAlignMiddle": "Polaris-DataTable__Cell--verticalAlignMiddle",
  "Cell-verticalAlignBaseline": "Polaris-DataTable__Cell--verticalAlignBaseline",
  hoverable,
  "Cell-hovered": "Polaris-DataTable__Cell--hovered",
  Icon: Icon$6,
  Heading: Heading$2,
  StickyHeaderEnabled,
  StickyHeaderWrapper,
  "Cell-sorted": "Polaris-DataTable__Cell--sorted",
  "Cell-total": "Polaris-DataTable__Cell--total",
  ShowTotals,
  "Cell-total-footer": "Polaris-DataTable--cellTotalFooter",
  Footer: Footer$1,
  StickyHeaderInner,
  "StickyHeaderInner-isSticky": "Polaris-DataTable__StickyHeaderInner--isSticky",
  StickyHeaderTable,
  FixedFirstColumn,
  "StickyTableColumnHeader-isScrolling": "Polaris-DataTable__StickyTableColumnHeader--isScrolling",
  StickyTableHeadingsRow,
  TooltipContent
};
const _hoisted_1$13 = {
  viewBox: "0 0 20 20",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$A = /* @__PURE__ */ createElementVNode("path", { d: "M12.324 9H7.676c-.563 0-.878-.603-.53-1.014L9.469 5.24a.708.708 0 0 1 1.062 0l2.323 2.746c.349.411.033 1.014-.53 1.014Z" }, null, -1);
const _hoisted_3$p = /* @__PURE__ */ createElementVNode("path", {
  d: "M7.676 11h4.648c.563 0 .879.603.53 1.014l-2.323 2.746a.708.708 0 0 1-1.062 0l-2.324-2.746C6.798 11.603 7.113 11 7.676 11Z",
  "fill-opacity": "50%"
}, null, -1);
const _hoisted_4$a = [
  _hoisted_2$A,
  _hoisted_3$p
];
function render$f(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1$13, _hoisted_4$a);
}
var SortAscendingMajor = { render: render$f };
const _hoisted_1$12 = {
  viewBox: "0 0 20 20",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$z = /* @__PURE__ */ createElementVNode("path", {
  d: "M12.324 9H7.676c-.563 0-.878-.603-.53-1.014L9.469 5.24a.708.708 0 0 1 1.062 0l2.323 2.746c.349.411.033 1.014-.53 1.014Z",
  "fill-opacity": "50%"
}, null, -1);
const _hoisted_3$o = /* @__PURE__ */ createElementVNode("path", { d: "M7.676 11h4.648c.563 0 .879.603.53 1.014l-2.323 2.746a.708.708 0 0 1-1.062 0l-2.324-2.746C6.798 11.603 7.113 11 7.676 11Z" }, null, -1);
const _hoisted_4$9 = [
  _hoisted_2$z,
  _hoisted_3$o
];
function render$e(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1$12, _hoisted_4$9);
}
var SortDescendingMajor = { render: render$e };
const _hoisted_1$11 = ["aria-sort"];
const _hoisted_2$y = ["tabIndex"];
const _hoisted_3$n = ["aria-sort"];
const _hoisted_4$8 = ["tabIndex"];
const _sfc_main$2g = /* @__PURE__ */ defineComponent({
  props: {
    contentType: null,
    nthColumn: { type: Boolean },
    firstColumn: { type: Boolean },
    truncate: { type: Boolean },
    header: { type: Boolean },
    total: { type: Boolean },
    totalInFooter: { type: Boolean },
    sorted: { type: Boolean },
    sortable: { type: Boolean },
    sortDirection: null,
    defaultSortDirection: { default: "ascending" },
    verticalAlign: { default: "top" },
    colSpan: null,
    stickyHeadingCell: { type: Boolean, default: false },
    stickyCellWidth: null,
    hovered: { type: Boolean, default: false },
    inFixedNthColumn: { type: Boolean },
    hasFixedNthColumn: { type: Boolean, default: false },
    fixedCellVisible: { type: Boolean, default: false },
    firstColumnMinWidth: null,
    style: null,
    lastFixedFirstColumn: { type: Boolean },
    setRef: { type: Function, default: () => {
    } }
  },
  setup(__props) {
    const props = __props;
    const i18n = UseI18n();
    const slots = useSlots();
    const numeric = computed(() => props.contentType === "numeric");
    computed(() => {
      var _a;
      return slots.default && ((_a = slots.default()[0].el) == null ? void 0 : _a.innerText);
    });
    const className = computed(() => classNames(styles$1n.Cell, styles$1n[`Cell-${variationName("verticalAlign", props.verticalAlign)}`], props.firstColumn && styles$1n["Cell-firstColumn"], props.truncate && styles$1n["Cell-truncated"], props.header && styles$1n["Cell-header"], props.total && styles$1n["Cell-total"], props.totalInFooter && styles$1n["Cell-total-footer"], numeric.value && styles$1n["Cell-numeric"], props.sortable && styles$1n["Cell-sortable"], props.sorted && styles$1n["Cell-sorted"], props.hovered && styles$1n["Cell-hovered"], props.lastFixedFirstColumn && props.inFixedNthColumn && props.fixedCellVisible && styles$1n["Cell-separate"], props.nthColumn && props.inFixedNthColumn && props.stickyHeadingCell && styles$1n.FixedFirstColumn));
    const headerClassName = computed(() => classNames(props.header && styles$1n.Heading, props.header && props.contentType === "text" && styles$1n["Heading-left"]));
    const iconClassName = computed(() => classNames(props.sortable && styles$1n.Icon));
    const direction = computed(() => props.sorted && props.sortDirection ? props.sortDirection : props.defaultSortDirection);
    const source = computed(() => direction.value === "descending" ? SortDescendingMajor : SortAscendingMajor);
    const oppositeDirection = computed(() => props.sortDirection === "ascending" ? "descending" : "ascending");
    const sortAccessibilityLabel = computed(() => i18n.translate("Polaris.DataTable.sortAccessibilityLabel", { direction: props.sorted ? oppositeDirection.value : direction.value }));
    const focusable = computed(() => !(props.stickyHeadingCell && props.hasFixedNthColumn && props.nthColumn && !props.inFixedNthColumn));
    const colSpanProp = computed(() => props.colSpan && props.colSpan > 1 ? { colSpan: props.colSpan } : {});
    const minWidthStyles = computed(() => {
      return props.nthColumn && props.firstColumnMinWidth ? { minWidth: `${props.firstColumnMinWidth || 0}px` } : { minWidth: `${props.stickyCellWidth || 0}px` };
    });
    return (_ctx, _cache) => {
      return __props.stickyHeadingCell ? (openBlock(), createElementBlock("th", mergeProps({ key: 0 }, __spreadValues(__spreadValues({}, unref(headerCell).props), unref(colSpanProp)), {
        ref: __props.setRef,
        class: unref(className),
        "aria-sort": __props.sortDirection,
        style: __spreadValues(__spreadValues({}, __props.style), unref(minWidthStyles)),
        "data-index-table-sticky-heading": "true"
      }), [
        __props.sortable ? (openBlock(), createElementBlock("button", {
          key: 0,
          class: normalizeClass(unref(headerClassName)),
          tabIndex: unref(focusable) ? 0 : -1,
          onClick: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("sort")),
          onFocus: _cache[1] || (_cache[1] = ($event) => _ctx.$emit("focus", $event))
        }, [
          createElementVNode("span", {
            class: normalizeClass(unref(iconClassName))
          }, [
            createVNode(unref(_sfc_main$2K), {
              source: unref(source),
              accessibilityLabel: unref(sortAccessibilityLabel)
            }, null, 8, ["source", "accessibilityLabel"])
          ], 2),
          renderSlot(_ctx.$slots, "default")
        ], 42, _hoisted_2$y)) : renderSlot(_ctx.$slots, "default", { key: 1 })
      ], 16, _hoisted_1$11)) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
        __props.header ? (openBlock(), createElementBlock("th", mergeProps({
          key: 0,
          "aria-sort": __props.sortDirection
        }, __spreadValues(__spreadValues({}, unref(headerCell).props), unref(colSpanProp)), {
          ref: __props.setRef,
          class: unref(className),
          scope: "col",
          style: __spreadValues({}, unref(minWidthStyles))
        }), [
          __props.sortable ? (openBlock(), createElementBlock("button", {
            key: 0,
            class: normalizeClass(unref(headerClassName)),
            tabIndex: unref(focusable) ? 0 : -1,
            onClick: _cache[2] || (_cache[2] = ($event) => _ctx.$emit("sort")),
            onFocus: _cache[3] || (_cache[3] = ($event) => _ctx.$emit("focus", $event))
          }, [
            createElementVNode("span", {
              class: normalizeClass(unref(iconClassName))
            }, [
              createVNode(unref(_sfc_main$2K), {
                source: unref(source),
                accessibilityLabel: unref(sortAccessibilityLabel)
              }, null, 8, ["source", "accessibilityLabel"])
            ], 2),
            renderSlot(_ctx.$slots, "default")
          ], 42, _hoisted_4$8)) : renderSlot(_ctx.$slots, "default", { key: 1 })
        ], 16, _hoisted_3$n)) : __props.firstColumn || __props.nthColumn ? (openBlock(), createElementBlock("th", mergeProps({ key: 1 }, unref(colSpanProp), {
          ref: __props.setRef,
          class: unref(className),
          scope: "row",
          style: __spreadValues({}, unref(minWidthStyles))
        }), [
          __props.truncate ? (openBlock(), createBlock(unref(_sfc_main$1), {
            key: 0,
            class: normalizeClass(unref(styles$1n).TooltipContent)
          }, {
            default: withCtx(() => [
              renderSlot(_ctx.$slots, "default")
            ]),
            _: 3
          }, 8, ["class"])) : renderSlot(_ctx.$slots, "default", { key: 1 })
        ], 16)) : (openBlock(), createElementBlock("td", mergeProps({
          key: 2,
          class: unref(className)
        }, unref(colSpanProp)), [
          renderSlot(_ctx.$slots, "default")
        ], 16))
      ], 64));
    };
  }
});
const _hoisted_1$10 = {
  viewBox: "0 0 20 20",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$x = /* @__PURE__ */ createElementVNode("path", { d: "M12 16a.997.997 0 0 1-.707-.293l-5-5a.999.999 0 0 1 0-1.414l5-5a.999.999 0 1 1 1.414 1.414L8.414 10l4.293 4.293A.999.999 0 0 1 12 16z" }, null, -1);
const _hoisted_3$m = [
  _hoisted_2$x
];
function render$d(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1$10, _hoisted_3$m);
}
var ChevronLeftMinor = { render: render$d };
const _hoisted_1$$ = {
  viewBox: "0 0 20 20",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$w = /* @__PURE__ */ createElementVNode("path", { d: "M8 16a.999.999 0 0 1-.707-1.707L11.586 10 7.293 5.707a.999.999 0 1 1 1.414-1.414l5 5a.999.999 0 0 1 0 1.414l-5 5A.997.997 0 0 1 8 16z" }, null, -1);
const _hoisted_3$l = [
  _hoisted_2$w
];
function render$c(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1$$, _hoisted_3$l);
}
var ChevronRightMinor = { render: render$c };
const _sfc_main$2f = /* @__PURE__ */ defineComponent({
  props: {
    columnVisibilityData: null,
    isScrolledFarthestLeft: { type: Boolean },
    isScrolledFarthestRight: { type: Boolean },
    fixedFirstColumns: null,
    setRef: null
  },
  setup(__props, { expose }) {
    const i18n = UseI18n();
    const navigationRef = ref(null);
    const leftA11yLabel = i18n.translate("Polaris.DataTable.navAccessibilityLabel", { direction: "left" });
    const rightA11yLabel = i18n.translate("Polaris.DataTable.navAccessibilityLabel", { direction: "right" });
    expose({ el: navigationRef });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(unref(styles$1n).Navigation),
        ref: __props.setRef
      }, [
        createVNode(unref(_sfc_main$2F), {
          plain: "",
          icon: unref(ChevronLeftMinor),
          disabled: __props.isScrolledFarthestLeft,
          accessibilityLabel: unref(leftA11yLabel),
          onClick: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("navigate-table-left"))
        }, null, 8, ["icon", "disabled", "accessibilityLabel"]),
        (openBlock(true), createElementBlock(Fragment, null, renderList(__props.columnVisibilityData, (column, index) => {
          return openBlock(), createElementBlock(Fragment, {
            key: `pip-${index}`
          }, [
            __props.fixedFirstColumns <= index ? (openBlock(), createElementBlock("div", {
              key: 0,
              class: normalizeClass(unref(classNames)(unref(styles$1n).Pip, column.isVisible && unref(styles$1n)["Pip-visible"]))
            }, null, 2)) : createCommentVNode("", true)
          ], 64);
        }), 128)),
        createVNode(unref(_sfc_main$2F), {
          plain: "",
          icon: unref(ChevronRightMinor),
          disabled: __props.isScrolledFarthestRight,
          accessibilityLabel: unref(rightA11yLabel),
          onClick: _cache[1] || (_cache[1] = ($event) => _ctx.$emit("navigate-table-right"))
        }, null, 8, ["icon", "disabled", "accessibilityLabel"])
      ], 2);
    };
  }
});
const _sfc_main$2e = /* @__PURE__ */ defineComponent({
  props: {
    headingIndex: null,
    inFixedNthColumn: { type: Boolean },
    inStickyHeader: { type: Boolean },
    sortable: null,
    truncate: { type: Boolean, default: false },
    columnContentTypes: null,
    verticalAlign: null,
    firstColumnMinWidth: null,
    sortDirection: null,
    defaultSortDirection: null,
    sortedColumnIndex: null,
    isScrolledFarthestLeft: { type: Boolean },
    hasFixedFirstColumn: { type: Boolean },
    stickyCellWidth: null,
    fixedFirstColumns: null,
    columnVisibilityData: null,
    setRef: null
  },
  emits: ["focus", "sort"],
  setup(__props, { emit: emits }) {
    const props = __props;
    useSlots();
    const isSortable = computed(() => props.sortable && props.sortable[props.headingIndex]);
    const isSorted = computed(() => isSortable.value && props.sortedColumnIndex === props.headingIndex);
    const direction = computed(() => isSorted.value ? props.sortDirection : "none");
    const sortableHeadingProps = computed(() => {
      if (props.sortable) {
        return {
          defaultSortDirection: props.defaultSortDirection,
          sorted: isSorted.value,
          sortable: isSortable.value,
          sortDirection: direction.value,
          inFixedNthColumn: props.fixedFirstColumns
        };
      }
      return {};
    });
    const cellProps = computed(() => {
      var _a;
      return __spreadProps(__spreadValues({
        header: true,
        stickyHeadingCell: props.inStickyHeader,
        contentType: (_a = props.columnContentTypes) == null ? void 0 : _a[props.headingIndex],
        nthColumn: props.headingIndex < props.fixedFirstColumns,
        truncate: props.truncate
      }, sortableHeadingProps.value), {
        verticalAlign: props.verticalAlign,
        stickyCellWidth: props.stickyCellWidth,
        fixedCellVisible: props.isScrolledFarthestLeft,
        firstColumnMinWidth: props.firstColumnMinWidth
      });
    });
    const handleFocus = (e) => {
      emits("focus", e);
    };
    return (_ctx, _cache) => {
      var _a;
      return __props.inFixedNthColumn && __props.inStickyHeader ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
        createVNode(unref(_sfc_main$2g), mergeProps({ setRef: __props.setRef }, unref(cellProps), {
          inFixedNthColumn: false,
          onFocus: handleFocus,
          onSort: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("sort"))
        }), {
          default: withCtx(() => [
            renderSlot(_ctx.$slots, "default")
          ]),
          _: 3
        }, 16, ["setRef"]),
        createVNode(unref(_sfc_main$2g), mergeProps({ setRef: __props.setRef }, unref(cellProps), {
          inFixedNthColumn: !!__props.fixedFirstColumns,
          lastFixedFirstColumn: __props.headingIndex === __props.fixedFirstColumns - 1,
          style: { left: __props.columnVisibilityData ? `${(_a = __props.columnVisibilityData[__props.headingIndex]) == null ? void 0 : _a.leftEdge}px` : "0px" },
          onFocus: handleFocus,
          onSort: _cache[1] || (_cache[1] = ($event) => _ctx.$emit("sort"))
        }), {
          default: withCtx(() => [
            renderSlot(_ctx.$slots, "default")
          ]),
          _: 3
        }, 16, ["setRef", "inFixedNthColumn", "lastFixedFirstColumn", "style"])
      ], 64)) : (openBlock(), createBlock(unref(_sfc_main$2g), mergeProps({
        key: 1,
        setRef: __props.setRef
      }, unref(cellProps), {
        inFixedNthColumn: __props.inFixedNthColumn,
        lastFixedFirstColumn: __props.headingIndex === __props.fixedFirstColumns - 1,
        onFocus: handleFocus,
        onSort: _cache[2] || (_cache[2] = ($event) => _ctx.$emit("sort"))
      }), {
        default: withCtx(() => [
          renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }, 16, ["setRef", "inFixedNthColumn", "lastFixedFirstColumn"]));
    };
  }
});
function measureColumn(tableData) {
  return function(elm, index) {
    const {
      firstVisibleColumnIndex,
      tableLeftVisibleEdge: tableStart,
      tableRightVisibleEdge: tableEnd
    } = tableData;
    const column = elm;
    const leftEdge = column.offsetLeft;
    const rightEdge = leftEdge + column.offsetWidth;
    const isVisibleLeft = isEdgeVisible(leftEdge, tableStart, tableEnd, "left");
    const isVisibleRight = isEdgeVisible(rightEdge, tableStart, tableEnd, "right");
    const isVisible = isVisibleLeft || isVisibleRight;
    const width = column.offsetWidth;
    if (isVisible) {
      tableData.firstVisibleColumnIndex = Math.min(firstVisibleColumnIndex, index);
    }
    return { leftEdge, rightEdge, isVisible, width, index };
  };
}
function isEdgeVisible(position, start2, end2, edgeType) {
  const minVisiblePixels = 30;
  return position >= start2 + (edgeType === "left" ? 0 : minVisiblePixels) && position <= end2 - minVisiblePixels;
}
function getPrevAndCurrentColumns(tableData, columnData) {
  const { firstVisibleColumnIndex } = tableData;
  const previousColumnIndex = Math.max(firstVisibleColumnIndex - 1, 0);
  const previousColumn = columnData[previousColumnIndex];
  const currentColumn = columnData[firstVisibleColumnIndex];
  return { previousColumn, currentColumn };
}
var DataTable_vue_vue_type_style_index_0_lang = "";
const _hoisted_1$_ = { key: 0 };
const _hoisted_2$v = { key: 0 };
const _hoisted_3$k = ["onMouseenter"];
const _hoisted_4$7 = { key: 0 };
const _hoisted_5$3 = { key: 0 };
const _sfc_main$2d = /* @__PURE__ */ defineComponent({
  props: {
    columnContentTypes: null,
    headings: null,
    totals: null,
    totalsName: null,
    showTotalsInFooter: { type: Boolean },
    rows: null,
    hideScrollIndicator: { type: Boolean, default: false },
    truncate: { type: Boolean, default: true },
    verticalAlign: { default: "top" },
    footerContent: null,
    hoverable: { type: Boolean, default: true },
    sortable: null,
    defaultSortDirection: { default: "ascending" },
    initialSortColumnIndex: { default: 0 },
    increasedTableDensity: { type: Boolean },
    hasZebraStripingOnData: { type: Boolean },
    stickyHeader: { type: Boolean },
    hasFixedFirstColumn: { type: Boolean },
    fixedFirstColumns: null,
    firstColumnMinWidth: null
  },
  emits: ["sort"],
  setup(__props, { emit: emits }) {
    const props = __props;
    const i18n = UseI18n();
    const slots = useSlots();
    const isMounted = ref(false);
    const dataTable = ref(null);
    const scrollContainer = ref(null);
    const table = ref(null);
    const stickyTable = ref(null);
    const stickyNav = ref(null);
    const headerNav = ref(null);
    const tableHeadings = ref([]);
    const stickyHeadings = ref([]);
    const tableHeadingWidths = ref([]);
    const stickyHeaderActive = ref(false);
    const scrollStopTimer = ref(null);
    const condensed2 = ref(false);
    const columnVisibilityData = ref([]);
    const previousColumn = ref(void 0);
    const currentColumn = ref(void 0);
    const sortedColumnIndex = ref(void 0);
    const sortDirection = ref(void 0);
    const isScrolledFarthestLeft = ref(true);
    const isScrolledFarthestRight = ref(false);
    const rowHovered = ref(void 0);
    const handleResize = debounce(() => {
      let tmpCondensed = false;
      if (table.value && scrollContainer.value) {
        tmpCondensed = table.value.scrollWidth > scrollContainer.value.clientWidth + 1;
      }
      calculateColumnVisibilityData(tmpCondensed);
      condensed2.value = tmpCondensed;
    }, 40, { trailing: true, leading: true, maxWait: 40 });
    const fixedFirstColumns = computed(() => {
      const numberOfFixedFirstColumns = props.hasFixedFirstColumn && !props.fixedFirstColumns ? 1 : props.fixedFirstColumns || 0;
      if (numberOfFixedFirstColumns >= props.headings.length) {
        return 0;
      }
      return numberOfFixedFirstColumns;
    });
    const rowCountIsEven = computed(() => props.rows.length % 2 === 0);
    const className = computed(() => classNames(styles$1n.DataTable, condensed2.value && styles$1n.condensed, props.totals && styles$1n.ShowTotals, props.showTotalsInFooter && styles$1n.ShowTotalsInFooter, props.hasZebraStripingOnData && styles$1n.ZebraStripingOnData, props.hasZebraStripingOnData && rowCountIsEven && styles$1n.RowCountIsEven));
    const wrapperClassName = computed(() => classNames(condensed2.value && styles$1n.condensed, props.increasedTableDensity && styles$1n.IncreasedTableDensity, props.stickyHeader && styles$1n.StickyHeaderEnabled));
    const fixedFirstColumnClassName = computed(() => classNames(styles$1n.FixedFirstColumn, !isScrolledFarthestLeft.value && styles$1n["Cell-separate"]));
    const nthColumns = computed(() => props.rows.map((row) => row.slice(0, fixedFirstColumns.value)));
    const nthHeadings = computed(() => props.headings.slice(0, fixedFirstColumns.value));
    const nthTotals = computed(() => {
      var _a;
      return (_a = props.totals) == null ? void 0 : _a.slice(0, fixedFirstColumns.value);
    });
    const tableHeaderRows = computed(() => {
      var _a;
      return (_a = table.value) == null ? void 0 : _a.children[0].childNodes;
    });
    const tableBodyRows = computed(() => {
      var _a;
      return (_a = table.value) == null ? void 0 : _a.children[1].childNodes;
    });
    const headerRowHeights = computed(() => getRowClientHeights(tableHeaderRows.value));
    const bodyRowHeights = computed(() => getRowClientHeights(tableBodyRows.value));
    const tableRowClassName = computed(() => {
      return classNames(styles$1n.TableRow, props.hoverable && styles$1n.hoverable);
    });
    const tableHeadingProps = computed(() => {
      return {
        sortable: props.sortable,
        truncate: props.truncate,
        fixedFirstColumns: fixedFirstColumns.value,
        columnContentTypes: props.columnContentTypes,
        verticalAlign: props.verticalAlign,
        firstColumnMinWidth: props.firstColumnMinWidth,
        sortDirection: sortDirection.value || props.defaultSortDirection,
        defaultSortDirection: props.defaultSortDirection,
        sortedColumnIndex: sortedColumnIndex.value || props.initialSortColumnIndex,
        isScrolledFarthestLeft: isScrolledFarthestLeft.value,
        hasFixedFirstColumn: props.hasFixedFirstColumn,
        columnVisibilityData: columnVisibilityData.value
      };
    });
    onMounted(() => {
      isMounted.value = true;
      setTimeout(handleResize, 10);
    });
    onBeforeUnmount(() => {
      handleResize.cancel();
    });
    const getRowClientHeights = (rows) => {
      const heights = [];
      if (!rows) {
        return heights;
      }
      rows.forEach((row) => {
        heights.push(row.clientHeight);
      });
      return heights;
    };
    const setCellRef = ({
      cellRef,
      index,
      inStickyHeader
    }) => {
      if (cellRef == null) {
        return;
      }
      if (inStickyHeader) {
        stickyHeadings.value[index] = cellRef;
        const button = cellRef.querySelector("button");
        if (button == null) {
          return;
        }
        button.addEventListener("focus", handleHeaderButtonFocus);
      } else {
        tableHeadings.value[index] = cellRef;
        tableHeadingWidths.value[index] = cellRef.clientWidth;
      }
    };
    const changeHeadingFocus = () => {
      var _a, _b, _c, _d;
      const stickyFocusedItemIndex = stickyHeadings.value.findIndex((item) => {
        var _a2;
        return item === ((_a2 = document.activeElement) == null ? void 0 : _a2.parentElement);
      });
      const tableFocusedItemIndex = tableHeadings.value.findIndex((item) => {
        var _a2;
        return item === ((_a2 = document.activeElement) == null ? void 0 : _a2.parentElement);
      });
      const arrowsInStickyNav = (_b = (_a = stickyNav.value) == null ? void 0 : _a.el) == null ? void 0 : _b.querySelectorAll("button");
      const arrowsInHeaderNav = (_d = (_c = headerNav.value) == null ? void 0 : _c.el) == null ? void 0 : _d.querySelectorAll("button");
      let stickyFocusedNavIndex = -1;
      arrowsInStickyNav == null ? void 0 : arrowsInStickyNav.forEach((item, index) => {
        if (item === document.activeElement) {
          stickyFocusedNavIndex = index;
        }
      });
      let headerFocusedNavIndex = -1;
      arrowsInHeaderNav == null ? void 0 : arrowsInHeaderNav.forEach((item, index) => {
        if (item === document.activeElement) {
          headerFocusedNavIndex = index;
        }
      });
      if (stickyFocusedItemIndex < 0 && tableFocusedItemIndex < 0 && stickyFocusedNavIndex < 0 && headerFocusedNavIndex < 0) {
        return null;
      }
      let button;
      if (stickyFocusedItemIndex >= 0) {
        button = tableHeadings[stickyFocusedItemIndex].querySelector("button");
      } else if (tableFocusedItemIndex >= 0) {
        button = stickyHeadings[tableFocusedItemIndex].querySelector("button");
      }
      if (stickyFocusedNavIndex >= 0) {
        button = arrowsInHeaderNav == null ? void 0 : arrowsInHeaderNav[stickyFocusedNavIndex];
      } else if (headerFocusedNavIndex >= 0) {
        button = arrowsInStickyNav == null ? void 0 : arrowsInStickyNav[headerFocusedNavIndex];
      }
      if (button == null) {
        return null;
      }
      button.style.visibility = "visible";
      button.focus();
      button.style.removeProperty("visibility");
    };
    const calculateColumnVisibilityData = (tmpCondensed) => {
      if ((props.stickyHeader || tmpCondensed) && table.value && scrollContainer.value && dataTable.value) {
        const headerCells = table.value.querySelectorAll(headerCell.selector);
        const rightMostHeader = headerCells[fixedFirstColumns.value - 1];
        const nthColumnWidth = fixedFirstColumns.value ? rightMostHeader.offsetLeft + rightMostHeader.offsetWidth : 0;
        if (headerCells.length > 0) {
          const firstVisibleColumnIndex = headerCells.length - 1;
          const tableLeftVisibleEdge = scrollContainer.value.scrollLeft + nthColumnWidth;
          const tableRightVisibleEdge = scrollContainer.value.scrollLeft + dataTable.value.offsetWidth;
          const tableData = {
            firstVisibleColumnIndex,
            tableLeftVisibleEdge,
            tableRightVisibleEdge
          };
          const tmpColumnVisibilityData = [...headerCells].map(measureColumn(tableData));
          const lastColumn = tmpColumnVisibilityData[tmpColumnVisibilityData.length - 1];
          const tmpIsScrolledFarthestLeft = fixedFirstColumns.value ? tableLeftVisibleEdge === nthColumnWidth : tableLeftVisibleEdge === 0;
          const {
            previousColumn: tmpPreviousColumn,
            currentColumn: tmpCurrentColumn
          } = getPrevAndCurrentColumns(tableData, tmpColumnVisibilityData);
          columnVisibilityData.value = tmpColumnVisibilityData;
          isScrolledFarthestLeft.value = tmpIsScrolledFarthestLeft;
          isScrolledFarthestRight.value = lastColumn.rightEdge <= tableRightVisibleEdge;
          previousColumn.value = tmpPreviousColumn;
          currentColumn.value = tmpCurrentColumn;
          return;
        }
      }
      columnVisibilityData.value = [];
      previousColumn.value = void 0;
      currentColumn.value = void 0;
    };
    const handleHeaderButtonFocus = (event) => {
      var _a;
      if (!scrollContainer.value || event.target == null || columnVisibilityData.value.length === 0) {
        return;
      }
      const target = event.target;
      const currentCell = target.parentNode;
      const tableScrollLeft = scrollContainer.value.scrollLeft;
      const tableViewableWidth = scrollContainer.value.offsetWidth;
      const tableRightEdge = tableScrollLeft + tableViewableWidth;
      const nthColumnWidth = columnVisibilityData.value.length > 0 ? (_a = columnVisibilityData.value[fixedFirstColumns.value]) == null ? void 0 : _a.rightEdge : 0;
      const currentColumnLeftEdge = currentCell.offsetLeft;
      const currentColumnRightEdge = currentCell.offsetLeft + currentCell.offsetWidth;
      if (tableScrollLeft > currentColumnLeftEdge - nthColumnWidth) {
        scrollContainer.value.scrollLeft = currentColumnLeftEdge - nthColumnWidth;
      }
      if (currentColumnRightEdge > tableRightEdge) {
        scrollContainer.value.scrollLeft = currentColumnRightEdge - tableViewableWidth;
      }
    };
    const stickyHeaderScrolling = () => {
      if (!stickyTable.value || !scrollContainer.value) {
        return;
      }
      stickyTable.value.scrollLeft = scrollContainer.value.scrollLeft;
    };
    const scrollListener = () => {
      var _a, _b;
      if (scrollStopTimer.value) {
        clearTimeout(scrollStopTimer.value);
      }
      scrollStopTimer.value = setTimeout(() => {
        calculateColumnVisibilityData(condensed2.value);
      }, 100);
      if (isScrolledFarthestLeft.value !== (((_a = scrollContainer.value) == null ? void 0 : _a.scrollLeft) === 0)) {
        isScrolledFarthestLeft.value = ((_b = scrollContainer.value) == null ? void 0 : _b.scrollLeft) === 0;
      }
      if (props.stickyHeader && stickyHeaderActive.value) {
        stickyHeaderScrolling();
      }
    };
    const handleHover = (row) => {
      rowHovered.value = row;
    };
    const handleFocus = (event) => {
      var _a;
      if (!scrollContainer.value || event.target == null) {
        return;
      }
      const currentCell = event.target.parentNode;
      const hasFixedFirstColumn = columnVisibilityData.value.length > 0;
      const nthColumnWidth = hasFixedFirstColumn ? (_a = columnVisibilityData.value[fixedFirstColumns.value]) == null ? void 0 : _a.rightEdge : 0;
      const currentColumnLeftEdge = currentCell.offsetLeft;
      const desiredScrollLeft = currentColumnLeftEdge - nthColumnWidth;
      if (scrollContainer.value.scrollLeft > desiredScrollLeft) {
        scrollContainer.value.scrollLeft = desiredScrollLeft;
      }
    };
    const navigateTable = (direction) => {
      var _a;
      const nthColumnWidth = (_a = columnVisibilityData.value[fixedFirstColumns.value - 1]) == null ? void 0 : _a.rightEdge;
      if (!currentColumn.value || !previousColumn.value) {
        return;
      }
      let prevWidths = 0;
      for (let index = 0; index < currentColumn.value.index; index++) {
        prevWidths += columnVisibilityData.value[index].width;
      }
      const handleScroll = () => {
        var _a2, _b, _c, _d, _e, _f, _g, _h;
        let newScrollLeft = 0;
        if (fixedFirstColumns.value) {
          newScrollLeft = direction === "right" ? prevWidths - nthColumnWidth + ((_b = (_a2 = currentColumn.value) == null ? void 0 : _a2.width) != null ? _b : 0) : prevWidths - ((_d = (_c = previousColumn.value) == null ? void 0 : _c.width) != null ? _d : 0) - nthColumnWidth;
        } else {
          newScrollLeft = direction === "right" ? (_f = (_e = currentColumn.value) == null ? void 0 : _e.rightEdge) != null ? _f : 0 : (_h = (_g = previousColumn.value) == null ? void 0 : _g.leftEdge) != null ? _h : 0;
        }
        if (scrollContainer.value) {
          scrollContainer.value.scrollLeft = newScrollLeft;
          requestAnimationFrame(() => {
            calculateColumnVisibilityData(condensed2.value);
          });
        }
      };
      return handleScroll();
    };
    const getColSpan = (rowLength, headingsLength, contentTypesLength, cellIndex) => {
      if (fixedFirstColumns.value) {
        return 1;
      }
      const rowLen = rowLength ? rowLength : 1;
      const colLen = headingsLength ? headingsLength : contentTypesLength;
      const colSpan = Math.floor(colLen / rowLen);
      const remainder = colLen % rowLen;
      return cellIndex === 0 ? colSpan + remainder : colSpan;
    };
    const defaultOnSort = (headingIndex) => {
      var _a, _b;
      sortDirection.value = (_a = sortDirection.value) != null ? _a : toRaw(props.defaultSortDirection);
      sortedColumnIndex.value = (_b = sortedColumnIndex.value) != null ? _b : toRaw(props.initialSortColumnIndex);
      let newSortDirection = toRaw(props.defaultSortDirection);
      if (sortedColumnIndex.value === headingIndex) {
        newSortDirection = sortDirection.value === "ascending" ? "descending" : "ascending";
      }
      const handleSort = () => {
        sortDirection.value = newSortDirection;
        sortedColumnIndex.value = headingIndex;
        emits("sort", headingIndex, newSortDirection);
      };
      return handleSort();
    };
    const isTotalsNamePlural = computed(() => {
      return props.totals && props.totals.filter((total) => total !== "").length > 1;
    });
    const hasCustomTotalsNamePlural = computed(() => {
      var _a;
      return hasSlot(slots["totalsName-plural"]) || ((_a = props.totalsName) == null ? void 0 : _a.plural);
    });
    const hasCustomTotalsNameSingular = computed(() => {
      var _a;
      return hasSlot(slots["totalsName-singular"]) || ((_a = props.totalsName) == null ? void 0 : _a.singular);
    });
    const stickyHandler = (isSticky) => {
      setTimeout(changeHeadingFocus, 10);
      stickyHeaderActive.value = isSticky;
    };
    const stickyHeaderInnerClassNames = computed(() => classNames(styles$1n.StickyHeaderInner, stickyHeaderActive.value && styles$1n["StickyHeaderInner-isSticky"]));
    const stickyHeaderTableClassNames = computed(() => classNames(styles$1n.StickyHeaderTable, !isScrolledFarthestLeft.value && styles$1n["Cell-separate"]));
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        ref_key: "dataTable",
        ref: dataTable,
        class: normalizeClass(unref(wrapperClassName))
      }, [
        __props.stickyHeader ? (openBlock(), createElementBlock("div", {
          key: 0,
          class: normalizeClass(unref(styles$1n).StickyHeaderWrapper),
          role: "presentation"
        }, [
          createVNode(unref(_sfc_main$p), {
            boundingElement: dataTable.value,
            onStickyChange: stickyHandler
          }, {
            default: withCtx(() => [
              createElementVNode("div", {
                class: normalizeClass(unref(stickyHeaderInnerClassNames))
              }, [
                createElementVNode("div", null, [
                  !__props.hideScrollIndicator ? (openBlock(), createBlock(unref(_sfc_main$2f), {
                    key: 0,
                    ref_key: "stickyNav",
                    ref: stickyNav,
                    columnVisibilityData: columnVisibilityData.value,
                    isScrolledFarthestLeft: isScrolledFarthestLeft.value,
                    isScrolledFarthestRight: isScrolledFarthestRight.value,
                    fixedFirstColumns: unref(fixedFirstColumns),
                    onNavigateTableLeft: _cache[0] || (_cache[0] = ($event) => navigateTable("left")),
                    onNavigateTableRight: _cache[1] || (_cache[1] = ($event) => navigateTable("right"))
                  }, null, 8, ["columnVisibilityData", "isScrolledFarthestLeft", "isScrolledFarthestRight", "fixedFirstColumns"])) : createCommentVNode("", true)
                ]),
                createElementVNode("table", {
                  ref_key: "stickyTable",
                  ref: stickyTable,
                  class: normalizeClass(unref(stickyHeaderTableClassNames))
                }, [
                  createElementVNode("thead", null, [
                    createElementVNode("tr", {
                      class: normalizeClass(unref(styles$1n).StickyTableHeadingsRow)
                    }, [
                      (openBlock(true), createElementBlock(Fragment, null, renderList(__props.headings, (heading, index) => {
                        return openBlock(), createBlock(unref(_sfc_main$2e), mergeProps({
                          key: `stickyheader-${index}`,
                          headingIndex: index,
                          inFixedNthColumn: Boolean(index <= unref(fixedFirstColumns) - 1 && unref(fixedFirstColumns)),
                          inStickyHeader: true,
                          stickyCellWidth: tableHeadingWidths.value[index],
                          setRef: (ref2) => {
                            setCellRef({ cellRef: ref2, index, inStickyHeader: false });
                          }
                        }, unref(tableHeadingProps), {
                          onFocus: handleFocus,
                          onSort: ($event) => defaultOnSort(index)
                        }), {
                          default: withCtx(() => [
                            unref(hasSlot)(unref(slots)[`heading-${index}`]) ? renderSlot(_ctx.$slots, `heading-${index}`, { key: 0 }) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
                              createTextVNode(toDisplayString(heading), 1)
                            ], 64))
                          ]),
                          _: 2
                        }, 1040, ["headingIndex", "inFixedNthColumn", "stickyCellWidth", "setRef", "onSort"]);
                      }), 128))
                    ], 2)
                  ])
                ], 2)
              ], 2)
            ]),
            _: 3
          }, 8, ["boundingElement"])
        ], 2)) : createCommentVNode("", true),
        !__props.hideScrollIndicator ? (openBlock(), createBlock(unref(_sfc_main$2f), {
          key: 1,
          ref_key: "headerNav",
          ref: headerNav,
          columnVisibilityData: columnVisibilityData.value,
          isScrolledFarthestLeft: isScrolledFarthestLeft.value,
          isScrolledFarthestRight: isScrolledFarthestRight.value,
          fixedFirstColumns: unref(fixedFirstColumns),
          onNavigateTableLeft: _cache[2] || (_cache[2] = ($event) => navigateTable("left")),
          onNavigateTableRight: _cache[3] || (_cache[3] = ($event) => navigateTable("right"))
        }, null, 8, ["columnVisibilityData", "isScrolledFarthestLeft", "isScrolledFarthestRight", "fixedFirstColumns"])) : createCommentVNode("", true),
        createElementVNode("div", {
          class: normalizeClass(unref(className))
        }, [
          createElementVNode("div", {
            class: normalizeClass(unref(styles$1n).ScrollContainer),
            ref_key: "scrollContainer",
            ref: scrollContainer
          }, [
            createVNode(unref(_sfc_main$33), {
              event: "resize",
              handler: unref(handleResize)
            }, null, 8, ["handler"]),
            createVNode(unref(_sfc_main$33), {
              capture: "",
              passive: "",
              event: "scroll",
              handler: scrollListener
            }),
            condensed2.value && unref(fixedFirstColumns) !== 0 ? withMemo([condensed2.value, __props.showTotalsInFooter, columnVisibilityData.value, __props.columnContentTypes, __props.hideScrollIndicator, __props.hasFixedFirstColumn, __props.truncate, __props.verticalAlign], () => {
              var _a;
              return openBlock(), createElementBlock("table", {
                key: 0,
                class: normalizeClass(unref(fixedFirstColumnClassName)),
                style: normalizeStyle({ width: `${(_a = columnVisibilityData.value[unref(fixedFirstColumns) - 1]) == null ? void 0 : _a.rightEdge}px` })
              }, [
                createElementVNode("thead", null, [
                  createElementVNode("tr", {
                    style: normalizeStyle({ height: `${unref(headerRowHeights)[0]}px` })
                  }, [
                    (openBlock(true), createElementBlock(Fragment, null, renderList(unref(nthHeadings), (heading, index) => {
                      return openBlock(), createBlock(unref(_sfc_main$2e), mergeProps({
                        key: `heading-cell-${index}`,
                        headingIndex: index,
                        inFixedNthColumn: true,
                        inStickyHeader: false,
                        setRef: (ref2) => {
                          setCellRef({ cellRef: ref2, index, inStickyHeader: false });
                        }
                      }, unref(tableHeadingProps), {
                        onFocus: handleFocus,
                        onSort: ($event) => defaultOnSort(index)
                      }), {
                        default: withCtx(() => [
                          unref(hasSlot)(unref(slots)[`heading-${index}`]) ? renderSlot(_ctx.$slots, `heading-${index}`, { key: 0 }) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
                            createTextVNode(toDisplayString(heading), 1)
                          ], 64))
                        ]),
                        _: 2
                      }, 1040, ["headingIndex", "setRef", "onSort"]);
                    }), 128))
                  ], 4),
                  __props.totals && !__props.showTotalsInFooter ? (openBlock(), createElementBlock("tr", {
                    key: 0,
                    style: normalizeStyle({ height: `${unref(headerRowHeights)[1]}px` })
                  }, [
                    (openBlock(true), createElementBlock(Fragment, null, renderList(unref(nthTotals), (total, index) => {
                      return openBlock(), createBlock(unref(_sfc_main$2g), {
                        key: `totals-cell-${index}`,
                        total: "",
                        totalInFooter: __props.showTotalsInFooter,
                        nthColumn: index <= unref(fixedFirstColumns) - 1,
                        firstColumn: index === 0,
                        contentType: total !== "" && index > 0 ? __props.columnContentTypes[index] : void 0,
                        truncate: __props.truncate,
                        verticalAlign: __props.verticalAlign
                      }, {
                        default: withCtx(() => [
                          index === 0 ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
                            unref(hasSlot)(unref(slots)["totalsName-plural"]) && unref(isTotalsNamePlural) ? renderSlot(_ctx.$slots, "totalsName-plural", { key: 0 }) : unref(hasSlot)(unref(slots)["totalsName-singular"]) && !unref(isTotalsNamePlural) ? renderSlot(_ctx.$slots, "totalsName-singular", { key: 1 }) : createCommentVNode("", true),
                            !unref(hasSlot)(unref(slots)["totalsName-plural"]) && unref(isTotalsNamePlural) ? (openBlock(), createElementBlock(Fragment, { key: 2 }, [
                              createTextVNode(toDisplayString(unref(i18n).translate("Polaris.DataTable.totalsRowHeading")), 1)
                            ], 64)) : createCommentVNode("", true),
                            !unref(hasSlot)(unref(slots)["totalsName-singular"]) && !unref(isTotalsNamePlural) ? (openBlock(), createElementBlock(Fragment, { key: 3 }, [
                              createTextVNode(toDisplayString(unref(i18n).translate("Polaris.DataTable.totalRowHeading")), 1)
                            ], 64)) : createCommentVNode("", true)
                          ], 64)) : total !== "" && index > 0 ? (openBlock(), createElementBlock(Fragment, { key: 1 }, [
                            createTextVNode(toDisplayString(total), 1)
                          ], 64)) : createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1032, ["totalInFooter", "nthColumn", "firstColumn", "contentType", "truncate", "verticalAlign"]);
                    }), 128))
                  ], 4)) : createCommentVNode("", true)
                ]),
                createElementVNode("tbody", null, [
                  (openBlock(true), createElementBlock(Fragment, null, renderList(unref(nthColumns), (row, index, ___, _cached) => {
                    const _memo = [condensed2.value, __props.showTotalsInFooter, columnVisibilityData.value, __props.columnContentTypes, __props.hideScrollIndicator, __props.hasFixedFirstColumn, __props.truncate, __props.verticalAlign, row];
                    if (_cached && _cached.key === `row-${index}` && isMemoSame(_cached, _memo))
                      return _cached;
                    const _item = (openBlock(), createElementBlock("tr", {
                      key: `row-${index}`,
                      class: normalizeClass(unref(tableRowClassName)),
                      onMouseenter: ($event) => handleHover(index),
                      onMouseleave: _cache[4] || (_cache[4] = ($event) => handleHover())
                    }, [
                      (openBlock(true), createElementBlock(Fragment, null, renderList(row, (content, cellIndex) => {
                        return openBlock(), createBlock(unref(_sfc_main$2g), {
                          key: `cell-${cellIndex}-row-${index}`,
                          contentType: __props.columnContentTypes[cellIndex],
                          nthColumn: cellIndex <= unref(fixedFirstColumns) - 1,
                          firstColumn: cellIndex === 0,
                          truncate: __props.truncate,
                          verticalAlign: __props.verticalAlign,
                          colSpan: getColSpan(row.length, __props.headings.length, __props.columnContentTypes.length, cellIndex),
                          hovered: index === rowHovered.value,
                          style: normalizeStyle(unref(bodyRowHeights) ? { height: `${unref(bodyRowHeights)[index]}px` } : {}),
                          inFixedNthColumn: condensed2.value && true
                        }, {
                          default: withCtx(() => [
                            unref(hasSlot)(unref(slots)[`cell-${cellIndex}-row-${index}`]) ? renderSlot(_ctx.$slots, `cell-${cellIndex}-row-${index}`, { key: 0 }) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
                              createTextVNode(toDisplayString(content), 1)
                            ], 64))
                          ]),
                          _: 2
                        }, 1032, ["contentType", "nthColumn", "firstColumn", "truncate", "verticalAlign", "colSpan", "hovered", "style", "inFixedNthColumn"]);
                      }), 128))
                    ], 42, ["onMouseenter"]));
                    _item.memo = _memo;
                    return _item;
                  }, _cache, 5), 128))
                ]),
                __props.totals && __props.showTotalsInFooter ? (openBlock(), createElementBlock("tfoot", _hoisted_1$_, [
                  createElementVNode("tr", null, [
                    (openBlock(true), createElementBlock(Fragment, null, renderList(unref(nthTotals), (total, index) => {
                      return openBlock(), createBlock(unref(_sfc_main$2g), {
                        key: `totals-cell-${index}`,
                        total: "",
                        totalInFooter: __props.showTotalsInFooter,
                        nthColumn: index <= unref(fixedFirstColumns) - 1,
                        firstColumn: index === 0,
                        contentType: total !== "" && index > 0 ? __props.columnContentTypes[index] : void 0,
                        truncate: __props.truncate,
                        verticalAlign: __props.verticalAlign
                      }, {
                        default: withCtx(() => [
                          index === 0 ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
                            unref(hasSlot)(unref(slots)["totalsName-plural"]) && unref(isTotalsNamePlural) ? renderSlot(_ctx.$slots, "totalsName-plural", { key: 0 }) : unref(hasSlot)(unref(slots)["totalsName-singular"]) && !unref(isTotalsNamePlural) ? renderSlot(_ctx.$slots, "totalsName-singular", { key: 1 }) : createCommentVNode("", true),
                            !unref(hasSlot)(unref(slots)["totalsName-plural"]) && unref(isTotalsNamePlural) ? (openBlock(), createElementBlock(Fragment, { key: 2 }, [
                              createTextVNode(toDisplayString(unref(i18n).translate("Polaris.DataTable.totalsRowHeading")), 1)
                            ], 64)) : createCommentVNode("", true),
                            !unref(hasSlot)(unref(slots)["totalsName-singular"]) && !unref(isTotalsNamePlural) ? (openBlock(), createElementBlock(Fragment, { key: 3 }, [
                              createTextVNode(toDisplayString(unref(i18n).translate("Polaris.DataTable.totalRowHeading")), 1)
                            ], 64)) : createCommentVNode("", true)
                          ], 64)) : total !== "" && index > 0 ? (openBlock(), createElementBlock(Fragment, { key: 1 }, [
                            createTextVNode(toDisplayString(total), 1)
                          ], 64)) : createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1032, ["totalInFooter", "nthColumn", "firstColumn", "contentType", "truncate", "verticalAlign"]);
                    }), 128))
                  ])
                ])) : createCommentVNode("", true)
              ], 6);
            }, _cache, 7) : createCommentVNode("", true),
            createElementVNode("table", {
              class: normalizeClass(unref(styles$1n).Table),
              ref_key: "table",
              ref: table
            }, [
              createElementVNode("thead", null, [
                createElementVNode("tr", null, [
                  (openBlock(true), createElementBlock(Fragment, null, renderList(__props.headings, (heading, index) => {
                    return openBlock(), createBlock(unref(_sfc_main$2e), mergeProps({
                      key: `heading-cell-${index}`,
                      headingIndex: index,
                      inFixedNthColumn: false,
                      inStickyHeader: false,
                      setRef: (ref2) => {
                        setCellRef({ cellRef: ref2, index, inStickyHeader: false });
                      }
                    }, unref(tableHeadingProps), {
                      onFocus: handleFocus,
                      onSort: ($event) => defaultOnSort(index)
                    }), {
                      default: withCtx(() => [
                        unref(hasSlot)(unref(slots)[`heading-${index}`]) ? renderSlot(_ctx.$slots, `heading-${index}`, { key: 0 }) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
                          createTextVNode(toDisplayString(heading), 1)
                        ], 64))
                      ]),
                      _: 2
                    }, 1040, ["headingIndex", "setRef", "onSort"]);
                  }), 128))
                ]),
                !__props.showTotalsInFooter ? (openBlock(), createElementBlock("tr", _hoisted_2$v, [
                  (openBlock(true), createElementBlock(Fragment, null, renderList(__props.totals, (total, index) => {
                    return openBlock(), createBlock(unref(_sfc_main$2g), {
                      key: `totals-cell-${index}`,
                      total: "",
                      totalInFooter: __props.showTotalsInFooter,
                      firstColumn: index === 0,
                      contentType: total !== "" && index > 0 ? __props.columnContentTypes[index] : void 0,
                      truncate: __props.truncate,
                      verticalAlign: __props.verticalAlign
                    }, {
                      default: withCtx(() => [
                        index === 0 ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
                          unref(hasSlot)(unref(slots)["totalsName-plural"]) && unref(isTotalsNamePlural) ? renderSlot(_ctx.$slots, "totalsName-plural", { key: 0 }) : unref(hasSlot)(unref(slots)["totalsName-singular"]) && !unref(isTotalsNamePlural) ? renderSlot(_ctx.$slots, "totalsName-singular", { key: 1 }) : createCommentVNode("", true),
                          !unref(hasSlot)(unref(slots)["totalsName-plural"]) && unref(isTotalsNamePlural) ? (openBlock(), createElementBlock(Fragment, { key: 2 }, [
                            createTextVNode(toDisplayString(unref(i18n).translate("Polaris.DataTable.totalsRowHeading")), 1)
                          ], 64)) : createCommentVNode("", true),
                          !unref(hasSlot)(unref(slots)["totalsName-singular"]) && !unref(isTotalsNamePlural) ? (openBlock(), createElementBlock(Fragment, { key: 3 }, [
                            createTextVNode(toDisplayString(unref(i18n).translate("Polaris.DataTable.totalRowHeading")), 1)
                          ], 64)) : createCommentVNode("", true)
                        ], 64)) : total !== "" && index > 0 ? (openBlock(), createElementBlock(Fragment, { key: 1 }, [
                          createTextVNode(toDisplayString(total), 1)
                        ], 64)) : createCommentVNode("", true)
                      ]),
                      _: 2
                    }, 1032, ["totalInFooter", "firstColumn", "contentType", "truncate", "verticalAlign"]);
                  }), 128))
                ])) : createCommentVNode("", true)
              ]),
              createElementVNode("tbody", null, [
                (openBlock(true), createElementBlock(Fragment, null, renderList(__props.rows, (row, index) => {
                  return openBlock(), createElementBlock("tr", {
                    key: `row-${index}`,
                    class: normalizeClass(unref(tableRowClassName)),
                    onMouseenter: ($event) => handleHover(index),
                    onMouseleave: _cache[10] || (_cache[10] = ($event) => handleHover())
                  }, [
                    (openBlock(true), createElementBlock(Fragment, null, renderList(row, (content, cellIndex, ___, _cached) => {
                      const _memo = [condensed2.value, __props.showTotalsInFooter, columnVisibilityData.value, __props.columnContentTypes, __props.hideScrollIndicator, __props.hasFixedFirstColumn, __props.truncate, __props.verticalAlign];
                      if (_cached && _cached.key === `cell-${cellIndex}-row-${index}` && isMemoSame(_cached, _memo))
                        return _cached;
                      const _item = (openBlock(), createBlock(unref(_sfc_main$2g), {
                        key: `cell-${cellIndex}-row-${index}`,
                        contentType: __props.columnContentTypes[cellIndex],
                        nthColumn: cellIndex <= unref(fixedFirstColumns) - 1,
                        firstColumn: cellIndex === 0,
                        truncate: __props.truncate,
                        verticalAlign: __props.verticalAlign,
                        colSpan: getColSpan(row.length, __props.headings.length, __props.columnContentTypes.length, cellIndex),
                        hovered: index === rowHovered.value,
                        inFixedNthColumn: condensed2.value && false
                      }, {
                        default: withCtx(() => [
                          unref(hasSlot)(unref(slots)[`cell-${cellIndex}-row-${index}`]) ? renderSlot(_ctx.$slots, `cell-${cellIndex}-row-${index}`, { key: 0 }) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
                            createTextVNode(toDisplayString(content), 1)
                          ], 64))
                        ]),
                        _: 2
                      }, 1032, ["contentType", "nthColumn", "firstColumn", "truncate", "verticalAlign", "colSpan", "hovered", "inFixedNthColumn"]));
                      _item.memo = _memo;
                      return _item;
                    }, _cache, 8), 128))
                  ], 42, _hoisted_3$k);
                }), 128))
              ]),
              __props.showTotalsInFooter ? (openBlock(), createElementBlock("tfoot", _hoisted_4$7, [
                __props.totals ? (openBlock(), createElementBlock("tr", _hoisted_5$3, [
                  (openBlock(true), createElementBlock(Fragment, null, renderList(__props.totals, (total, index) => {
                    return openBlock(), createBlock(unref(_sfc_main$2g), {
                      key: `totals-cell-${index}`,
                      total: "",
                      totalInFooter: __props.showTotalsInFooter,
                      firstColumn: index === 0,
                      contentType: total !== "" && index > 0 ? __props.columnContentTypes[index] : void 0,
                      truncate: __props.truncate,
                      verticalAlign: __props.verticalAlign
                    }, {
                      default: withCtx(() => {
                        var _a, _b;
                        return [
                          index === 0 ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
                            unref(hasCustomTotalsNamePlural) && unref(isTotalsNamePlural) ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
                              unref(hasSlot)(unref(slots)["totalsName-plural"]) ? renderSlot(_ctx.$slots, "totalsName-plural", { key: 0 }) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
                                createTextVNode(toDisplayString((_a = __props.totalsName) == null ? void 0 : _a.plural), 1)
                              ], 64))
                            ], 64)) : unref(hasCustomTotalsNameSingular) && !unref(isTotalsNamePlural) ? (openBlock(), createElementBlock(Fragment, { key: 1 }, [
                              unref(hasSlot)(unref(slots)["totalsName-singular"]) ? renderSlot(_ctx.$slots, "totalsName-singular", { key: 0 }) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
                                createTextVNode(toDisplayString((_b = __props.totalsName) == null ? void 0 : _b.singular), 1)
                              ], 64))
                            ], 64)) : createCommentVNode("", true),
                            !unref(hasCustomTotalsNamePlural) && unref(isTotalsNamePlural) ? (openBlock(), createElementBlock(Fragment, { key: 2 }, [
                              createTextVNode(toDisplayString(unref(i18n).translate("Polaris.DataTable.totalsRowHeading")), 1)
                            ], 64)) : createCommentVNode("", true),
                            !unref(hasCustomTotalsNameSingular) && !unref(isTotalsNamePlural) ? (openBlock(), createElementBlock(Fragment, { key: 3 }, [
                              createTextVNode(toDisplayString(unref(i18n).translate("Polaris.DataTable.totalRowHeading")), 1)
                            ], 64)) : createCommentVNode("", true)
                          ], 64)) : total !== "" && index > 0 ? (openBlock(), createElementBlock(Fragment, { key: 1 }, [
                            createTextVNode(toDisplayString(total), 1)
                          ], 64)) : createCommentVNode("", true)
                        ];
                      }),
                      _: 2
                    }, 1032, ["totalInFooter", "firstColumn", "contentType", "truncate", "verticalAlign"]);
                  }), 128))
                ])) : createCommentVNode("", true)
              ])) : createCommentVNode("", true)
            ], 2)
          ], 2),
          unref(hasSlot)(unref(slots).footerContent) || __props.footerContent ? (openBlock(), createElementBlock("div", {
            key: 0,
            class: normalizeClass(unref(styles$1n).Footer)
          }, [
            !unref(hasSlot)(unref(slots).footerContent) ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
              createTextVNode(toDisplayString(__props.footerContent), 1)
            ], 64)) : renderSlot(_ctx.$slots, "footerContent", { key: 1 })
          ], 2)) : createCommentVNode("", true)
        ], 2)
      ], 2);
    };
  }
});
const WEEK_LENGTH = 7;
function getWeeksForMonth(month, year, weekStartsOn = 0) {
  const firstOfMonth = new Date(year, month, 1);
  const firstDayOfWeek = firstOfMonth.getDay();
  const weeks = [[]];
  let currentWeek = weeks[0];
  let currentDate = firstOfMonth;
  const orderedWeekday = getOrderedWeekdays(weekStartsOn);
  for (let i = 0; i < orderedWeekday.indexOf(firstDayOfWeek); i++) {
    currentWeek.push(null);
  }
  while (currentDate.getMonth() === month) {
    if (currentWeek.length === WEEK_LENGTH) {
      currentWeek = [];
      weeks.push(currentWeek);
    }
    currentWeek.push(currentDate);
    currentDate = new Date(year, month, currentDate.getDate() + 1);
  }
  while (currentWeek.length < 7) {
    currentWeek.push(null);
  }
  return weeks;
}
function dateIsInRange(day, range) {
  if (day == null) {
    return false;
  }
  const { start: start2, end: end2 } = range;
  return Boolean(start2 && day > start2 && end2 && day < end2);
}
function dateIsSelected(day, range) {
  if (day == null) {
    return false;
  }
  const { start: start2, end: end2 } = range;
  return Boolean(start2 && isSameDay(start2, day) || end2 && isSameDay(end2, day));
}
function isSameDay(day1, day2) {
  return day1.getDate() === day2.getDate() && day1.getMonth() === day2.getMonth() && day1.getFullYear() === day2.getFullYear();
}
function getNewRange(range, selected2) {
  if (range == null) {
    return { start: selected2, end: selected2 };
  }
  const { start: start2, end: end2 } = range;
  if (end2 && (isDateAfter(start2, end2) || isDateBefore(start2, end2))) {
    return { start: selected2, end: selected2 };
  }
  if (start2) {
    if (isDateBefore(selected2, start2)) {
      return { start: selected2, end: selected2 };
    }
    return { start: start2, end: selected2 };
  }
  if (end2) {
    if (isDateBefore(selected2, end2)) {
      return { start: selected2, end: end2 };
    }
    return { start: start2 || end2, end: selected2 };
  }
  return { start: selected2, end: selected2 };
}
function getNextDisplayMonth(month) {
  if (month === 11) {
    return 0;
  }
  return month + 1;
}
function getNextDisplayYear(month, year) {
  if (month === 11) {
    return year + 1;
  }
  return year;
}
function getPreviousDisplayMonth(month) {
  if (month === 0) {
    return 11;
  }
  return month - 1;
}
function getPreviousDisplayYear(month, year) {
  if (month === 0) {
    return year - 1;
  }
  return year;
}
function isDateAfter(date, dateToCompare) {
  return date.getTime() > dateToCompare.getTime();
}
function isDateBefore(date, dateToCompare) {
  return date.getTime() < dateToCompare.getTime();
}
function isDateDisabled(date, datesToCompare) {
  return datesToCompare.some((dateToCompare) => {
    return date.getTime() === dateToCompare.getTime();
  });
}
const WEEKDAYS = [0, 1, 2, 3, 4, 5, 6];
function getOrderedWeekdays(weekStartsOn) {
  const weekDays = [...WEEKDAYS];
  const restOfDays = weekDays.splice(weekStartsOn);
  return [...restOfDays, ...weekDays];
}
const _hoisted_1$Z = {
  viewBox: "0 0 20 20",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$u = /* @__PURE__ */ createElementVNode("path", { d: "m17.707 9.293-5-5a.999.999 0 1 0-1.414 1.414L14.586 9H3a1 1 0 1 0 0 2h11.586l-3.293 3.293a.999.999 0 1 0 1.414 1.414l5-5a.999.999 0 0 0 0-1.414z" }, null, -1);
const _hoisted_3$j = [
  _hoisted_2$u
];
function render$b(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1$Z, _hoisted_3$j);
}
var ArrowRightMinor = { render: render$b };
const DatePicker = "Polaris-DatePicker";
const MonthLayout = "Polaris-DatePicker__MonthLayout";
const MonthContainer = "Polaris-DatePicker__MonthContainer";
const Month = "Polaris-DatePicker__Month";
const DayCell = "Polaris-DatePicker__DayCell";
const Day = "Polaris-DatePicker__Day";
const EmptyDayCell = "Polaris-DatePicker__EmptyDayCell";
const Weekday = "Polaris-DatePicker__Weekday";
const Header$3 = "Polaris-DatePicker__Header";
const Title$6 = "Polaris-DatePicker__Title";
const Week = "Polaris-DatePicker__Week";
var styles$1m = {
  DatePicker,
  MonthLayout,
  MonthContainer,
  Month,
  "Month-current": "Polaris-DatePicker__Month--current",
  DayCell,
  "DayCell-inRange": "Polaris-DatePicker__DayCell--inRange",
  Day,
  "Day-today": "Polaris-DatePicker__Day--today",
  "Day-inRange": "Polaris-DatePicker__Day--inRange",
  "Day-selected": "Polaris-DatePicker__Day--selected",
  "Day-disabled": "Polaris-DatePicker__Day--disabled",
  EmptyDayCell,
  Weekday,
  "Weekday-current": "Polaris-DatePicker__Weekday--current",
  Header: Header$3,
  Title: Title$6,
  "Day-firstInRange": "Polaris-DatePicker__Day--firstInRange",
  "Day-hasRange": "Polaris-DatePicker__Day--hasRange",
  "Day-hoverRight": "Polaris-DatePicker__Day--hoverRight",
  "Day-lastInRange": "Polaris-DatePicker__Day--lastInRange",
  Week
};
const transformedDate = {
  months: {
    january: "January",
    february: "February",
    march: "March",
    april: "April",
    may: "May",
    june: "June",
    july: "July",
    august: "August",
    september: "September",
    october: "October",
    november: "November",
    december: "December"
  },
  days: {
    monday: "Monday",
    tuesday: "Tuesday",
    wednesday: "Wednesday",
    thursday: "Thursday",
    friday: "Friday",
    saturday: "Saturday",
    sunday: "Sunday"
  },
  daysAbbreviated: {
    monday: "Mo",
    tuesday: "Tu",
    wednesday: "We",
    thursday: "Th",
    friday: "Fr",
    saturday: "Sa",
    sunday: "Su"
  }
};
function monthName(month) {
  switch (month) {
    case 0:
      return "january";
    case 1:
      return "february";
    case 2:
      return "march";
    case 3:
      return "april";
    case 4:
      return "may";
    case 5:
      return "june";
    case 6:
      return "july";
    case 7:
      return "august";
    case 8:
      return "september";
    case 9:
      return "october";
    case 10:
      return "november";
    case 11:
      return "december";
  }
}
function weekdayName(weekday) {
  switch (weekday) {
    case 0:
      return "sunday";
    case 1:
      return "monday";
    case 2:
      return "tuesday";
    case 3:
      return "wednesday";
    case 4:
      return "thursday";
    case 5:
      return "friday";
    case 6:
      return "saturday";
  }
}
const _hoisted_1$Y = ["tabIndex", "aria-label", "aria-disabled", "aria-pressed"];
const _sfc_main$2c = /* @__PURE__ */ defineComponent({
  props: {
    focused: { type: Boolean },
    day: null,
    selected: { type: Boolean },
    inRange: { type: Boolean },
    inHoveringRange: { type: Boolean },
    disabled: { type: Boolean },
    lastDayOfMonth: null,
    isLastSelectedDay: { type: Boolean },
    isFirstSelectedDay: { type: Boolean },
    isHoveringRight: { type: Boolean },
    rangeIsDifferent: { type: Boolean },
    weekday: null,
    selectedAccessibilityLabelPrefix: null
  },
  emits: ["focus", "hover", "click"],
  setup(__props, { emit: emits }) {
    const props = __props;
    const dayRef = ref(null);
    const hoverValue = computed(() => {
      return props.lastDayOfMonth || props.day;
    });
    const today = computed(() => {
      return props.day ? isSameDay(new Date(), props.day) : null;
    });
    const date = computed(() => {
      return props.day ? props.day.getDate() : null;
    });
    const tabIndex = computed(() => {
      if ((props.focused || props.selected || today.value || date.value === 1) && !props.disabled) {
        return 0;
      }
      return -1;
    });
    const dayCellClassName = computed(() => {
      return classNames(styles$1m.DayCell, props.selected && styles$1m["DayCell-selected"], (props.inRange || props.inHoveringRange) && !props.disabled && styles$1m["DayCell-inRange"], props.isLastSelectedDay && styles$1m["DayCell-lastInRange"], props.isFirstSelectedDay && styles$1m["DayCell-firstInRange"], props.isHoveringRight && styles$1m["DayCell-hoverRight"], props.rangeIsDifferent && styles$1m["DayCell-hasRange"]);
    });
    const dayClassName = computed(() => {
      return classNames(styles$1m.Day, props.selected && styles$1m["Day-selected"], props.disabled && styles$1m["Day-disabled"], today.value && styles$1m["Day-today"], (props.inRange || props.inHoveringRange) && !props.disabled && styles$1m["Day-inRange"], props.isLastSelectedDay && styles$1m["Day-lastInRange"], props.isFirstSelectedDay && styles$1m["Day-firstInRange"], props.isHoveringRight && styles$1m["Day-hoverRight"], props.rangeIsDifferent && styles$1m["Day-hasRange"]);
    });
    const monthRealName = computed(() => {
      if (!props.day) {
        return null;
      }
      const name = monthName(props.day.getMonth());
      return name ? transformedDate.months[name] : "";
    });
    const ariaLabel = computed(() => {
      return [
        props.selected && props.selectedAccessibilityLabelPrefix ? `${props.selectedAccessibilityLabelPrefix} ` : "",
        `${today.value ? "Today " : ""}`,
        `${props.weekday ? props.weekday : ""} `,
        `${monthRealName.value} `,
        `${date.value} `,
        `${props.day ? props.day.getFullYear() : new Date().getFullYear()}`
      ].join("");
    });
    onUpdated(() => {
      if (props.focused && dayRef.value) {
        setTimeout(() => {
          dayRef.value.focus();
        }, 10);
      }
    });
    const onFocus = () => {
      emits("focus", props.day);
    };
    const onHover = () => {
      emits("hover", hoverValue.value);
    };
    const handleClick = () => {
      if (!props.disabled && props.day) {
        emits("click", props.day);
      }
    };
    return (_ctx, _cache) => {
      return __props.day ? (openBlock(), createElementBlock("td", {
        key: 0,
        class: normalizeClass(unref(dayCellClassName))
      }, [
        createElementVNode("button", {
          type: "button",
          ref_key: "dayRef",
          ref: dayRef,
          tabIndex: unref(tabIndex),
          class: normalizeClass(unref(dayClassName)),
          "aria-label": unref(ariaLabel),
          "aria-disabled": __props.disabled,
          "aria-pressed": __props.selected,
          onFocus,
          onMouseover: onHover,
          onClick: handleClick
        }, toDisplayString(unref(date)), 43, _hoisted_1$Y)
      ], 2)) : (openBlock(), createElementBlock("td", {
        key: 1,
        class: normalizeClass(unref(styles$1m).EmptyDayCell),
        onMouseover: onHover
      }, null, 34));
    };
  }
});
const _hoisted_1$X = ["aria-label"];
const _sfc_main$2b = /* @__PURE__ */ defineComponent({
  props: {
    label: null,
    title: null,
    current: { type: Boolean }
  },
  setup(__props) {
    const props = __props;
    const className = computed(() => {
      return classNames(styles$1m.Weekday, props.current && styles$1m["Weekday-current"]);
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("th", {
        "aria-label": __props.label,
        scope: "col",
        class: normalizeClass(unref(className))
      }, toDisplayString(__props.title), 11, _hoisted_1$X);
    };
  }
});
const _sfc_main$2a = /* @__PURE__ */ defineComponent({
  props: {
    focusedDate: null,
    selected: null,
    hoverDate: null,
    month: null,
    year: null,
    disableDatesBefore: null,
    disableDatesAfter: null,
    disableSpecificDates: null,
    allowRange: { type: Boolean },
    weekStartsOn: null,
    accessibilityLabelPrefixes: null
  },
  emits: ["focus", "hover", "click", "change"],
  setup(__props, { emit: emits }) {
    const props = __props;
    const now = new Date();
    const current = computed(() => {
      return now.getMonth() === props.month && now.getFullYear() === props.year;
    });
    const className = computed(() => {
      return classNames(styles$1m.Title, current.value && styles$1m["Month-current"]);
    });
    const weekHeadingsClassName = "Polaris-DatePicker__WeekHeadings";
    const weeks = computed(() => {
      return getWeeksForMonth(props.month, props.year, props.weekStartsOn);
    });
    const monthRealName = computed(() => {
      const month = monthName(props.month);
      return month ? transformedDate.months[month] : "";
    });
    const weekdaysOrdered = computed(() => {
      return getOrderedWeekdays(props.weekStartsOn);
    });
    const lastDayOfMonth = computed(() => {
      return new Date(props.year, props.month + 1, 0);
    });
    const rangeIsDifferent = computed(() => {
      return !(props.selected && isSameDay(props.selected.start, props.selected.end));
    });
    const handleDateClick = (selectedDate) => {
      const selectedValue = getNewRange(props.allowRange ? props.selected : void 0, selectedDate);
      emits("change", selectedValue);
    };
    const isDayDisabled = (day) => {
      return props.disableDatesBefore && isDateBefore(day, props.disableDatesBefore) || props.disableDatesAfter && isDateAfter(day, props.disableDatesAfter) || props.disableSpecificDates && isDateDisabled(day, props.disableSpecificDates);
    };
    const isFirstSelectedDay = (day) => {
      return props.allowRange && props.selected && isDateStart(day, props.selected);
    };
    const isLastSelectedDay = (day) => {
      return props.allowRange && props.selected && (!isSameDay(props.selected.start, props.selected.end) && isDateEnd(day, props.selected) || props.hoverDate && isSameDay(props.selected.start, props.selected.end) && isDateAfter(props.hoverDate, props.selected.start) && isSameDay(day, props.hoverDate) && !isFirstSelectedDay(day));
    };
    const isHoveringRight = (day) => {
      return props.hoverDate && isDateBefore(day, props.hoverDate);
    };
    const accessibilityLabelPrefix = (day) => {
      if (!props.accessibilityLabelPrefixes) {
        return "";
      }
      const [
        firstAccessibilityLabelPrefix,
        lastAccessibilityLabelPrefix
      ] = props.accessibilityLabelPrefixes;
      if (props.allowRange && isFirstSelectedDay(day) || !props.allowRange && firstAccessibilityLabelPrefix) {
        return firstAccessibilityLabelPrefix;
      }
      if (props.allowRange && isLastSelectedDay(day)) {
        return lastAccessibilityLabelPrefix;
      }
    };
    const hoveringDateIsInRange = (day, range, hoverEndDate) => {
      if (!props.allowRange || !range || !hoverEndDate || day == null) {
        return false;
      }
      const { start: start2, end: end2 } = range;
      return Boolean(isSameDay(start2, end2) && day > start2 && day <= hoverEndDate);
    };
    function weekdaysName(weekday) {
      const name = weekdayName(weekday);
      return name ? transformedDate.daysAbbreviated[name] : "";
    }
    function weekdayLabel(weekday) {
      const name = weekdayName(weekday);
      return name ? transformedDate.days[name] : "";
    }
    function isDateEnd(day, range) {
      if (day == null) {
        return false;
      }
      const { end: end2 } = range;
      return Boolean(end2 && isSameDay(end2, day));
    }
    function isDateStart(day, range) {
      if (day == null) {
        return false;
      }
      const { start: start2 } = range;
      return Boolean(start2 && isSameDay(start2, day));
    }
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(unref(styles$1m).MonthContainer)
      }, [
        createElementVNode("table", {
          role: "grid",
          class: normalizeClass(unref(styles$1m).Month)
        }, [
          createElementVNode("caption", {
            class: normalizeClass(unref(className))
          }, toDisplayString(unref(monthRealName)) + " " + toDisplayString(__props.year), 3),
          createElementVNode("thead", null, [
            createElementVNode("tr", {
              class: normalizeClass(weekHeadingsClassName)
            }, [
              (openBlock(true), createElementBlock(Fragment, null, renderList(unref(weekdaysOrdered), (weekday) => {
                return openBlock(), createBlock(unref(_sfc_main$2b), {
                  key: weekday,
                  title: weekdaysName(weekday),
                  label: weekdayLabel(weekday),
                  current: unref(current) && new Date().getDay() === weekday
                }, null, 8, ["title", "label", "current"]);
              }), 128))
            ])
          ]),
          createElementVNode("tbody", null, [
            (openBlock(true), createElementBlock(Fragment, null, renderList(unref(weeks), (week, index) => {
              return openBlock(), createElementBlock("tr", {
                key: index,
                class: normalizeClass(unref(styles$1m).Week)
              }, [
                (openBlock(true), createElementBlock(Fragment, null, renderList(week, (day, dayIndex) => {
                  return openBlock(), createElementBlock(Fragment, { key: dayIndex }, [
                    !day ? (openBlock(), createBlock(unref(_sfc_main$2c), {
                      key: 0,
                      lastDayOfMonth: unref(lastDayOfMonth),
                      onHover: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("hover", null))
                    }, null, 8, ["lastDayOfMonth"])) : (openBlock(), createBlock(unref(_sfc_main$2c), {
                      key: 1,
                      selectedAccessibilityLabelPrefix: accessibilityLabelPrefix(day),
                      weekday: weekdayLabel(dayIndex),
                      focused: __props.focusedDate && unref(isSameDay)(day, __props.focusedDate),
                      day,
                      selected: __props.selected && unref(dateIsSelected)(day, __props.selected),
                      inRange: __props.selected && unref(dateIsInRange)(day, __props.selected),
                      disabled: isDayDisabled(day),
                      inHoveringRange: hoveringDateIsInRange(day, __props.selected, __props.hoverDate),
                      isLastSelectedDay: isLastSelectedDay(day),
                      isFirstSelectedDay: isFirstSelectedDay(day),
                      isHoveringRight: isHoveringRight(day),
                      rangeIsDifferent: unref(rangeIsDifferent),
                      onFocus: ($event) => _ctx.$emit("focus", day),
                      onClick: handleDateClick,
                      onHover: ($event) => _ctx.$emit("hover", day)
                    }, null, 8, ["selectedAccessibilityLabelPrefix", "weekday", "focused", "day", "selected", "inRange", "disabled", "inHoveringRange", "isLastSelectedDay", "isFirstSelectedDay", "isHoveringRight", "rangeIsDifferent", "onFocus", "onHover"]))
                  ], 64);
                }), 128))
              ], 2);
            }), 128))
          ])
        ], 2)
      ], 2);
    };
  }
});
var DatePicker_vue_vue_type_style_index_0_lang = "";
const _hoisted_1$W = ["id"];
const _sfc_main$29 = /* @__PURE__ */ defineComponent({
  props: {
    id: null,
    modelValue: null,
    month: null,
    year: null,
    allowRange: { type: Boolean },
    disableDatesBefore: null,
    disableDatesAfter: null,
    disableSpecificDates: null,
    multiMonth: { type: Boolean },
    weekStartsOn: { default: 0 },
    dayAccessibilityLabelPrefix: null
  },
  emits: ["month-change", "change", "update:modelValue"],
  setup(__props, { emit: emits }) {
    const props = __props;
    const focusDate = ref();
    const hoverDate = ref();
    const showNextYear = computed(() => {
      return getNextDisplayYear(props.month, props.year);
    });
    const showNextMonth = computed(() => {
      return getNextDisplayMonth(props.month);
    });
    const showNextToNextYear = computed(() => {
      return getNextDisplayYear(showNextMonth.value, showNextYear.value);
    });
    const showNextToNextMonth = computed(() => {
      return getNextDisplayMonth(showNextMonth.value);
    });
    const showPreviousYear = computed(() => {
      return getPreviousDisplayYear(props.month, props.year);
    });
    const showPreviousMonth = computed(() => {
      return getPreviousDisplayMonth(props.month);
    });
    const previousMonthName = computed(() => {
      const name = monthName(showPreviousMonth.value);
      return name ? transformedDate.months[name] : "";
    });
    const nextMonth = computed(() => {
      if (props.multiMonth) {
        const month = monthName(showNextToNextMonth.value);
        return month ? transformedDate.months[month] : "";
      }
      const name = monthName(showNextMonth.value);
      return name ? transformedDate.months[name] : "";
    });
    const nextYear = computed(() => {
      return props.multiMonth ? showNextToNextYear.value : showNextYear.value;
    });
    const monthIsSelected = computed(() => {
      return deriveRange(props.modelValue);
    });
    const firstDatePickerAccessibilityLabelPrefix = computed(() => {
      return props.allowRange ? "Start of range" : props.dayAccessibilityLabelPrefix;
    });
    const secondDatePickerAccessibilityLabelPrefix = "End of range";
    const accessibilityLabelPrefixes = computed(() => {
      return [
        firstDatePickerAccessibilityLabelPrefix.value,
        secondDatePickerAccessibilityLabelPrefix
      ];
    });
    const previousMonthAccessibilityLabel = computed(() => {
      return `Show previous month, ${previousMonthName.value} ${showPreviousYear.value}`;
    });
    const nextMonthAccessibilityLabel = computed(() => {
      return `Show next month, ${nextMonth.value} ${nextYear.value}`;
    });
    const onMonthChange = (month, year) => {
      emits("month-change", { month, year });
    };
    const handleMonthChangeClick = (month, year) => {
      focusDate.value = void 0;
      onMonthChange(month, year);
    };
    const handleFocus = (date) => {
      focusDate.value = date || void 0;
    };
    const handleHover = (date) => {
      hoverDate.value = date || void 0;
    };
    const setFocusDateAndHandleMonthChange = (date) => {
      onMonthChange(date.getMonth(), date.getFullYear());
      hoverDate.value = date;
      focusDate.value = date;
    };
    const handleDateSelection = (range) => {
      if (range) {
        const { end: end2 } = range;
        hoverDate.value = end2;
        focusDate.value = new Date(end2);
        emits("update:modelValue", range);
      }
      emits("change", range);
    };
    const handleKeyUp = (event) => {
      const { key } = event;
      const range = deriveRange(props.modelValue);
      const focusedDate = focusDate.value || range && range.start;
      if (!focusedDate) {
        return;
      }
      if (key === "ArrowUp") {
        const previousWeek = new Date(focusedDate);
        previousWeek.setDate(focusedDate.getDate() - 7);
        if (!(props.disableDatesBefore && isDateBefore(previousWeek, props.disableDatesBefore) || props.disableSpecificDates && isDateDisabled(previousWeek, props.disableSpecificDates))) {
          setFocusDateAndHandleMonthChange(previousWeek);
        }
      }
      if (key === "ArrowDown") {
        const nextWeek = new Date(focusedDate);
        nextWeek.setDate(focusedDate.getDate() + 7);
        if (!(props.disableDatesAfter && isDateAfter(nextWeek, props.disableDatesAfter) || props.disableSpecificDates && isDateDisabled(nextWeek, props.disableSpecificDates))) {
          setFocusDateAndHandleMonthChange(nextWeek);
        }
      }
      if (key === "ArrowRight") {
        const tomorrow = new Date(focusedDate);
        tomorrow.setDate(focusedDate.getDate() + 1);
        if (!(props.disableDatesAfter && isDateAfter(tomorrow, props.disableDatesAfter) || props.disableSpecificDates && isDateDisabled(tomorrow, props.disableSpecificDates))) {
          setFocusDateAndHandleMonthChange(tomorrow);
        }
      }
      if (key === "ArrowLeft") {
        const yesterday = new Date(focusedDate);
        yesterday.setDate(focusedDate.getDate() - 1);
        if (!(props.disableDatesBefore && isDateBefore(yesterday, props.disableDatesBefore) || props.disableSpecificDates && isDateDisabled(yesterday, props.disableSpecificDates))) {
          setFocusDateAndHandleMonthChange(yesterday);
        }
      }
    };
    const handleKeyDown = (event) => {
      const { key } = event;
      if (key === "ArrowUp" || key === "ArrowDown" || key === "ArrowLeft" || key === "ArrowRight") {
        event.preventDefault();
        event.stopPropagation();
      }
    };
    function deriveRange(selected2) {
      return selected2 instanceof Date ? { start: selected2, end: selected2 } : selected2;
    }
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        id: __props.id,
        class: normalizeClass(unref(styles$1m).DatePicker),
        onKeydown: handleKeyDown,
        onKeyup: handleKeyUp
      }, [
        createElementVNode("div", {
          class: normalizeClass(unref(styles$1m).Header)
        }, [
          createVNode(unref(_sfc_main$2F), {
            plain: "",
            icon: unref(ArrowLeftMinor),
            accessibilityLabel: unref(previousMonthAccessibilityLabel),
            onClick: _cache[0] || (_cache[0] = ($event) => handleMonthChangeClick(unref(showPreviousMonth), unref(showPreviousYear)))
          }, null, 8, ["icon", "accessibilityLabel"]),
          createVNode(unref(_sfc_main$2F), {
            plain: "",
            icon: unref(ArrowRightMinor),
            accessibilityLabel: unref(nextMonthAccessibilityLabel),
            onClick: _cache[1] || (_cache[1] = ($event) => handleMonthChangeClick(unref(showNextMonth), unref(showNextYear)))
          }, null, 8, ["icon", "accessibilityLabel"])
        ], 2),
        createElementVNode("div", {
          class: normalizeClass(unref(styles$1m).MonthLayout)
        }, [
          createVNode(unref(_sfc_main$2a), {
            focusedDate: focusDate.value,
            month: __props.month,
            year: __props.year,
            selected: deriveRange(__props.modelValue),
            hoverDate: hoverDate.value,
            disableDatesBefore: __props.disableDatesBefore,
            disableDatesAfter: __props.disableDatesAfter,
            disableSpecificDates: __props.disableSpecificDates,
            allowRange: __props.allowRange,
            weekStartsOn: __props.weekStartsOn,
            accessibilityLabelPrefixes: unref(accessibilityLabelPrefixes),
            onChange: handleDateSelection,
            onHover: handleHover,
            onFocus: handleFocus
          }, null, 8, ["focusedDate", "month", "year", "selected", "hoverDate", "disableDatesBefore", "disableDatesAfter", "disableSpecificDates", "allowRange", "weekStartsOn", "accessibilityLabelPrefixes"]),
          __props.multiMonth ? (openBlock(), createBlock(unref(_sfc_main$2a), {
            key: 0,
            focusedDate: focusDate.value,
            month: unref(showNextMonth),
            year: unref(showNextYear),
            selected: unref(monthIsSelected),
            hoverDate: hoverDate.value,
            disableDatesBefore: __props.disableDatesBefore,
            disableDatesAfter: __props.disableDatesAfter,
            disableSpecificDates: __props.disableSpecificDates,
            allowRange: __props.allowRange,
            weekStartsOn: __props.weekStartsOn,
            accessibilityLabelPrefixes: unref(accessibilityLabelPrefixes),
            onChange: handleDateSelection,
            onHover: handleHover,
            onFocus: handleFocus
          }, null, 8, ["focusedDate", "month", "year", "selected", "hoverDate", "disableDatesBefore", "disableDatesAfter", "disableSpecificDates", "allowRange", "weekStartsOn", "accessibilityLabelPrefixes"])) : createCommentVNode("", true)
        ], 2)
      ], 42, _hoisted_1$W);
    };
  }
});
const DescriptionList = "Polaris-DescriptionList";
const Term = "Polaris-DescriptionList__Term";
const spacingTight$2 = "Polaris-DescriptionList--spacingTight";
const Description$1 = "Polaris-DescriptionList__Description";
var styles$1l = {
  DescriptionList,
  Term,
  spacingTight: spacingTight$2,
  Description: Description$1
};
var DescriptionList_vue_vue_type_style_index_0_lang = "";
const _sfc_main$28 = /* @__PURE__ */ defineComponent({
  props: {
    spacing: { default: "loose" }
  },
  setup(__props) {
    const props = __props;
    const className = computed(() => {
      return classNames(styles$1l.DescriptionList, props.spacing === "tight" && styles$1l.spacingTight);
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("dl", {
        class: normalizeClass(unref(className))
      }, [
        renderSlot(_ctx.$slots, "default")
      ], 2);
    };
  }
});
const _sfc_main$27 = /* @__PURE__ */ defineComponent({
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("dt", {
        class: normalizeClass(unref(styles$1l).Term)
      }, [
        createVNode(unref(Text), {
          as: "span",
          variant: "headingSm"
        }, {
          default: withCtx(() => [
            renderSlot(_ctx.$slots, "default")
          ]),
          _: 3
        })
      ], 2);
    };
  }
});
const _sfc_main$26 = /* @__PURE__ */ defineComponent({
  setup(__props) {
    const className = classNames(styles$1l.Description);
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("dd", {
        class: normalizeClass(unref(className))
      }, [
        renderSlot(_ctx.$slots, "default")
      ], 2);
    };
  }
});
const DisplayText$1 = "Polaris-DisplayText";
const sizeSmall$7 = "Polaris-DisplayText--sizeSmall";
const sizeMedium$5 = "Polaris-DisplayText--sizeMedium";
const sizeLarge$6 = "Polaris-DisplayText--sizeLarge";
const sizeExtraLarge$1 = "Polaris-DisplayText--sizeExtraLarge";
var styles$1k = {
  DisplayText: DisplayText$1,
  sizeSmall: sizeSmall$7,
  sizeMedium: sizeMedium$5,
  sizeLarge: sizeLarge$6,
  sizeExtraLarge: sizeExtraLarge$1
};
var DisplayText_vue_vue_type_style_index_0_lang = "";
const _sfc_main$25 = /* @__PURE__ */ defineComponent({
  props: {
    element: { default: "p" },
    size: { default: "medium" }
  },
  setup(__props) {
    const props = __props;
    const className = computed(() => classNames(styles$1k.DisplayText, props.size && styles$1k[variationName("size", props.size)]));
    return (_ctx, _cache) => {
      return openBlock(), createBlock(resolveDynamicComponent(__props.element), {
        class: normalizeClass(unref(className))
      }, {
        default: withCtx(() => [
          renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }, 8, ["class"]);
    };
  }
});
const _hoisted_1$V = {
  viewBox: "0 0 20 20",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$t = /* @__PURE__ */ createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M20 10c0 5.523-4.477 10-10 10S0 15.523 0 10 4.477 0 10 0s10 4.477 10 10zM5.293 8.293l4-4a1 1 0 0 1 1.414 0l4 4a1 1 0 0 1-1.414 1.414L11 7.414V15a1 1 0 1 1-2 0V7.414L6.707 9.707a1 1 0 0 1-1.414-1.414z"
}, null, -1);
const _hoisted_3$i = [
  _hoisted_2$t
];
function render$a(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1$V, _hoisted_3$i);
}
var UploadMajor = { render: render$a };
function capitalize(word = "") {
  const wordLower = word.toLowerCase();
  return wordLower.charAt(0).toUpperCase() + wordLower.slice(1);
}
const DropZone = "Polaris-DropZone";
const focused$5 = "Polaris-DropZone--focused";
const hasOutline = "Polaris-DropZone--hasOutline";
const isDisabled = "Polaris-DropZone--isDisabled";
const isDragging = "Polaris-DropZone--isDragging";
const sizeLarge$5 = "Polaris-DropZone--sizeLarge";
const sizeMedium$4 = "Polaris-DropZone--sizeMedium";
const sizeSmall$6 = "Polaris-DropZone--sizeSmall";
const measuring = "Polaris-DropZone--measuring";
const Container$3 = "Polaris-DropZone__Container";
const Overlay = "Polaris-DropZone__Overlay";
const hasError = "Polaris-DropZone--hasError";
var styles$1j = {
  DropZone,
  focused: focused$5,
  hasOutline,
  isDisabled,
  isDragging,
  sizeLarge: sizeLarge$5,
  sizeMedium: sizeMedium$4,
  sizeSmall: sizeSmall$6,
  measuring,
  Container: Container$3,
  Overlay,
  hasError
};
const _sfc_main$24 = /* @__PURE__ */ defineComponent({
  props: {
    id: null,
    accept: null,
    disabled: { type: Boolean },
    type: null,
    multiple: { type: Boolean },
    openFileDialog: { type: Boolean }
  },
  emits: ["focus", "blur", "input", "file-dialog-close"],
  setup(__props, { emit: emits }) {
    const props = __props;
    const fileInputNode = ref();
    onMounted(() => {
      props.openFileDialog && triggerFileDialog();
    });
    onUpdated(() => {
      props.openFileDialog && triggerFileDialog();
    });
    const triggerFileDialog = () => {
      open2();
      emits("file-dialog-close");
    };
    const open2 = () => {
      if (!fileInputNode.value) {
        return;
      }
      fileInputNode.value.click();
    };
    const handleChange = (event) => {
      const files = event.target.files;
      if (!files) {
        return;
      }
      emits("input", event);
    };
    const handleFocus = () => {
      emits("focus");
    };
    const handleBlur = () => {
      emits("blur");
    };
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("input", mergeProps(props, {
        ref_key: "fileInputNode",
        ref: fileInputNode,
        autoComplete: "off",
        onChange: handleChange,
        onFocus: handleFocus,
        onBlur: handleBlur
      }), null, 16);
    };
  }
});
const dragEvents = ["dragover", "dragenter", "drop"];
function fileAccepted(file, accept) {
  return file.type === "application/x-moz-file" || accepts(file, accept);
}
function getDataTransferFiles(event) {
  if (isDragEvent(event) && event.dataTransfer) {
    const dt = event.dataTransfer;
    if (dt.files && dt.files.length) {
      return Array.from(dt.files);
    } else if (dt.items && dt.items.length) {
      return Array.from(dt.items);
    }
  } else if (isChangeEvent(event) && event.target.files) {
    const target = event.target;
    return Array.from(target.files || []);
  }
  return [];
}
function accepts(file, acceptedFiles) {
  if (file && acceptedFiles) {
    const fileName = file.name || "";
    const mimeType = file.type || "";
    const baseMimeType = mimeType.replace(/\/.*$/, "");
    const acceptedFilesArray = Array.isArray(acceptedFiles) ? acceptedFiles : acceptedFiles.split(",");
    return acceptedFilesArray.some((type) => {
      const validType = type.trim();
      if (validType.startsWith(".")) {
        return fileName.toLowerCase().endsWith(validType.toLowerCase());
      } else if (validType.endsWith("/*")) {
        return baseMimeType === validType.replace(/\/.*$/, "");
      }
      return mimeType === validType;
    });
  }
  return true;
}
function isDragEvent(event) {
  return dragEvents.indexOf(event.type) > 0;
}
function isChangeEvent(event) {
  return event.type === "change";
}
const defaultAllowMultiple = true;
function createAllowMultipleKey(allowMultiple2) {
  return allowMultiple2 ? "allowMultiple" : "single";
}
var DropZone_vue_vue_type_style_index_0_lang = "";
const _hoisted_1$U = ["aria-disabled"];
const _sfc_main$23 = /* @__PURE__ */ defineComponent({
  props: {
    label: null,
    labelAction: null,
    labelHidden: { type: Boolean },
    id: null,
    accept: null,
    type: { default: "file" },
    active: { type: Boolean },
    error: { type: Boolean },
    outline: { type: Boolean, default: true },
    overlay: { type: Boolean, default: true },
    overlayText: null,
    errorOverlayText: null,
    allowMultiple: { type: Boolean, default: defaultAllowMultiple },
    disabled: { type: Boolean, default: false },
    dropOnPage: { type: Boolean },
    openFileDialog: { type: Boolean },
    variableHeight: { type: Boolean },
    customValidator: null
  },
  emits: ["drop", "drop-accepted", "drop-rejected", "dragover", "dragenter", "dragleave", "file-dialog-close"],
  setup(__props, { emit: emits }) {
    const props = __props;
    const i18n = UseI18n();
    const slots = useSlots();
    const attrs = useAttrs();
    const { useUniqueId } = UseUniqueId();
    const uniqueId = useUniqueId("DropZone", props.id);
    const typeSuffix = capitalize(props.type);
    const allowMultipleKey = createAllowMultipleKey(props.allowMultiple || false);
    const dropZoneRef = ref(null);
    const dragTargets = ref([]);
    const measuring2 = ref(true);
    const size = ref("large");
    const dragging = ref(false);
    const internalError = ref(false);
    const focused2 = ref(false);
    const overlayTextWithDefault = computed(() => {
      return !props.overlayText ? i18n.translate(`Polaris.DropZone.${allowMultipleKey}.overlayText${typeSuffix}`) : props.overlayText;
    });
    const errorOverlayTextWithDefault = computed(() => {
      return !props.errorOverlayText ? i18n.translate(`Polaris.DropZone.errorOverlayText${typeSuffix}`) : props.errorOverlayText;
    });
    const labelFallback = i18n.translate(`Polaris.DropZone.${allowMultipleKey}.label${typeSuffix}`);
    const labelHiddenValue = computed(() => slots.label || props.label ? props.labelHidden : true);
    const classes = computed(() => {
      return classNames(styles$1j.DropZone, props.outline && styles$1j.hasOutline, focused2.value && styles$1j.focused, (props.active || dragging.value) && styles$1j.isDragging, props.disabled && styles$1j.isDisabled, (internalError.value || props.error) && styles$1j.hasError, !props.variableHeight && styles$1j[variationName("size", size.value)], measuring2.value && styles$1j.measuring);
    });
    const showDragOverlay = computed(() => {
      return (props.active || dragging.value) && !internalError.value && !props.error && props.overlay;
    });
    const showDragErrorOverlay = computed(() => {
      return dragging.value && (internalError.value || props.error);
    });
    onMounted(() => {
      adjustSize();
      const dropNode = props.dropOnPage ? document : dropZoneRef.value;
      if (!dropNode) {
        return;
      }
      dropNode.addEventListener("drop", handleDrop);
      dropNode.addEventListener("dragover", handleDragOver);
      dropNode.addEventListener("dragenter", handleDragEnter);
      dropNode.addEventListener("dragleave", handleDragLeave);
      window.addEventListener("resize", adjustSize);
    });
    onBeforeUnmount(() => {
      const dropNode = props.dropOnPage ? document : dropZoneRef.value;
      if (!dropNode) {
        return;
      }
      dropNode.removeEventListener("drop", handleDrop);
      dropNode.removeEventListener("dragover", handleDragOver);
      dropNode.removeEventListener("dragenter", handleDragEnter);
      dropNode.removeEventListener("dragleave", handleDragLeave);
      window.removeEventListener("resize", adjustSize);
    });
    const adjustSize = debounce(() => {
      if (!dropZoneRef.value) {
        return;
      }
      if (props.variableHeight) {
        measuring2.value = false;
        return;
      }
      const width = dropZoneRef.value.getBoundingClientRect().width;
      size.value = "large";
      if (width < 100) {
        size.value = "small";
      } else if (width < 160) {
        size.value = "medium";
      }
      if (measuring2.value) {
        measuring2.value = false;
      }
    }, 50, { trailing: true });
    const handleFocus = () => {
      focused2.value = true;
    };
    const handleBlur = () => {
      focused2.value = false;
    };
    const onFileDialogClose = () => {
      emits("file-dialog-close");
    };
    const getValidatedFiles = (files) => {
      const acceptedFiles = [];
      const rejectedFiles = [];
      Array.from(files).forEach((file) => {
        !fileAccepted(file, props.accept) || props.customValidator && !props.customValidator(file) ? rejectedFiles.push(file) : acceptedFiles.push(file);
      });
      if (!props.allowMultiple) {
        acceptedFiles.splice(1, acceptedFiles.length);
        rejectedFiles.push(...acceptedFiles.slice(1));
      }
      return { files, acceptedFiles, rejectedFiles };
    };
    const handleDrop = (event) => {
      stopEvent(event);
      if (props.disabled) {
        return;
      }
      const fileList = getDataTransferFiles(event);
      const { files, acceptedFiles, rejectedFiles } = getValidatedFiles(fileList);
      dragTargets.value = [];
      dragging.value = false;
      internalError.value = rejectedFiles.length > 0;
      emits("drop", files, acceptedFiles, rejectedFiles);
      if (acceptedFiles.length > 0) {
        emits("drop-accepted", acceptedFiles);
      }
      if (rejectedFiles.length > 0) {
        emits("drop-rejected", rejectedFiles);
      }
      event.target.value = "";
    };
    const handleDragEnter = (event) => {
      stopEvent(event);
      if (props.disabled) {
        return;
      }
      const fileList = getDataTransferFiles(event);
      if (event.target && !dragTargets.value.includes(event.target)) {
        dragTargets.value.push(event.target);
      }
      if (dragging.value) {
        return;
      }
      const { rejectedFiles } = getValidatedFiles(fileList);
      dragging.value = true;
      internalError.value = rejectedFiles.length > 0;
      emits("dragenter");
    };
    const handleDragOver = (event) => {
      stopEvent(event);
      if (props.disabled) {
        return;
      }
      emits("dragover");
    };
    const handleDragLeave = (event) => {
      event.preventDefault();
      if (props.disabled) {
        return;
      }
      dragTargets.value = dragTargets.value.filter((el) => {
        const compareNode = props.dropOnPage && !isServer ? document.body : el;
        return el !== event.target && compareNode && compareNode.contains(el);
      });
      if (dragTargets.value.length > 0) {
        return;
      }
      dragging.value = false;
      internalError.value = false;
      emits("dragleave");
    };
    const open2 = () => {
      const fileInputNode = dropZoneRef.value && dropZoneRef.value.querySelector(`#${uniqueId}`);
      fileInputNode && fileInputNode instanceof HTMLElement && fileInputNode.click();
    };
    function handleClick(event) {
      if (props.disabled) {
        return;
      }
      return attrs["onClick"] ? attrs["onClick"](event) : open2();
    }
    const stopEvent = (event) => {
      event.preventDefault();
      event.stopPropagation();
    };
    const context = reactive({
      disabled: props.disabled,
      focused: focused2,
      size,
      type: props.type,
      measuring: measuring2,
      allowMultiple: props.allowMultiple
    });
    provide("dropZoneContext", context);
    return (_ctx, _cache) => {
      return openBlock(), createBlock(unref(_sfc_main$1o), {
        id: unref(uniqueId),
        action: __props.labelAction,
        labelHidden: unref(labelHiddenValue)
      }, {
        label: withCtx(() => [
          unref(slots).label ? renderSlot(_ctx.$slots, "label", { key: 0 }) : __props.label ? (openBlock(), createElementBlock(Fragment, { key: 1 }, [
            createTextVNode(toDisplayString(__props.label), 1)
          ], 64)) : (openBlock(), createElementBlock(Fragment, { key: 2 }, [
            createTextVNode(toDisplayString(unref(labelFallback)), 1)
          ], 64))
        ]),
        default: withCtx(() => [
          createElementVNode("div", {
            ref_key: "dropZoneRef",
            ref: dropZoneRef,
            class: normalizeClass(unref(classes)),
            "aria-disabled": __props.disabled,
            onClick: handleClick,
            onDragstart: stopEvent
          }, [
            unref(showDragOverlay) ? (openBlock(), createElementBlock("div", {
              key: 0,
              class: normalizeClass(unref(styles$1j).Overlay)
            }, [
              createVNode(unref(_sfc_main$12), {
                vertical: "",
                spacing: "tight"
              }, {
                default: withCtx(() => [
                  size.value === "small" ? (openBlock(), createBlock(unref(_sfc_main$2K), {
                    key: 0,
                    source: unref(UploadMajor),
                    color: "interactive"
                  }, null, 8, ["source"])) : (openBlock(), createBlock(unref(Text), {
                    key: 1,
                    as: "p",
                    variant: "bodySm",
                    "font-weight": "bold"
                  }, {
                    default: withCtx(() => [
                      createTextVNode(toDisplayString(unref(overlayTextWithDefault)), 1)
                    ]),
                    _: 1
                  }))
                ]),
                _: 1
              })
            ], 2)) : createCommentVNode("", true),
            unref(showDragErrorOverlay) ? (openBlock(), createElementBlock("div", {
              key: 1,
              class: normalizeClass(unref(styles$1j).Overlay)
            }, [
              createVNode(unref(_sfc_main$12), {
                vertical: "",
                spacing: "tight"
              }, {
                default: withCtx(() => [
                  size.value === "small" ? (openBlock(), createBlock(unref(_sfc_main$2K), {
                    key: 0,
                    source: unref(CircleAlertMajor),
                    color: "critical"
                  }, null, 8, ["source"])) : (openBlock(), createBlock(unref(Text), {
                    key: 1,
                    as: "p",
                    variant: "bodySm",
                    "font-weight": "bold"
                  }, {
                    default: withCtx(() => [
                      createTextVNode(toDisplayString(unref(errorOverlayTextWithDefault)), 1)
                    ]),
                    _: 1
                  }))
                ]),
                _: 1
              })
            ], 2)) : createCommentVNode("", true),
            createVNode(unref(Text), {
              variant: "bodySm",
              as: "span",
              "visually-hidden": ""
            }, {
              default: withCtx(() => [
                createVNode(_sfc_main$24, {
                  type: "file",
                  id: unref(uniqueId),
                  accept: __props.accept,
                  disabled: __props.disabled,
                  multiple: __props.allowMultiple || false,
                  openFileDialog: __props.openFileDialog,
                  onInput: handleDrop,
                  onFocus: handleFocus,
                  onBlur: handleBlur,
                  onFileDialogClose
                }, null, 8, ["id", "accept", "disabled", "multiple", "openFileDialog"])
              ]),
              _: 1
            }),
            createElementVNode("div", {
              class: normalizeClass(unref(styles$1j).Container)
            }, [
              renderSlot(_ctx.$slots, "default")
            ], 2)
          ], 42, _hoisted_1$U)
        ]),
        _: 3
      }, 8, ["id", "action", "labelHidden"]);
    };
  }
});
const _hoisted_1$T = {
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20"
};
const _hoisted_2$s = /* @__PURE__ */ createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M20 10a10 10 0 1 1-20 0 10 10 0 0 1 20 0zM5.3 8.3l4-4a1 1 0 0 1 1.4 0l4 4a1 1 0 0 1-1.4 1.4L11 7.4V15a1 1 0 1 1-2 0V7.4L6.7 9.7a1 1 0 0 1-1.4-1.4z",
  fill: "#5C5F62"
}, null, -1);
const _hoisted_3$h = [
  _hoisted_2$s
];
function render$9(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1$T, _hoisted_3$h);
}
var UploadArrow = { render: render$9 };
const FileUpload = "Polaris-DropZone-FileUpload";
const large = "Polaris-DropZone-FileUpload--large";
const small = "Polaris-DropZone-FileUpload--small";
const Action$7 = "Polaris-DropZone-FileUpload__Action";
const disabled$6 = "Polaris-DropZone-FileUpload--disabled";
const ActionTitle = "Polaris-DropZone-FileUpload__ActionTitle";
var styles$1i = {
  FileUpload,
  large,
  small,
  Action: Action$7,
  disabled: disabled$6,
  ActionTitle,
  "ActionTitle-disabled": "Polaris-DropZone-FileUpload__ActionTitle--disabled",
  "ActionTitle-focused": "Polaris-DropZone-FileUpload__ActionTitle--focused"
};
var FileUpload_vue_vue_type_style_index_0_lang = "";
const _sfc_main$22 = /* @__PURE__ */ defineComponent({
  props: {
    actionTitle: null,
    actionHint: null
  },
  setup(__props) {
    const props = __props;
    const i18n = UseI18n();
    const { size, measuring: measuring2, type, disabled: disabled2, allowMultiple: allowMultiple2 } = toRefs(inject("dropZoneContext"));
    const typeSuffix = capitalize(type.value);
    const allowMultipleKey = createAllowMultipleKey(allowMultiple2.value);
    const title = computed(() => {
      return props.actionTitle || i18n.translate(`Polaris.DropZone.${allowMultipleKey}.actionTitle${typeSuffix}`);
    });
    const actionClassNames = classNames(styles$1i.Action, disabled2.value && styles$1i.disabled);
    const fileUploadClassName = computed(() => {
      return classNames(styles$1i.FileUpload, size.value === "large" && styles$1i.large, size.value === "small" && styles$1i.small);
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(unref(fileUploadClassName))
      }, [
        unref(size) === "large" || unref(size) === "medium" ? (openBlock(), createBlock(unref(_sfc_main$12), {
          key: 0,
          vertical: "",
          spacing: "tight"
        }, {
          default: withCtx(() => [
            createElementVNode("div", {
              class: normalizeClass(unref(actionClassNames))
            }, toDisplayString(unref(title)), 3),
            __props.actionHint ? (openBlock(), createBlock(unref(Text), {
              key: 0,
              variant: "bodySm",
              as: "p",
              color: "subdued"
            }, {
              default: withCtx(() => [
                createTextVNode(toDisplayString(__props.actionHint), 1)
              ]),
              _: 1
            })) : createCommentVNode("", true)
          ]),
          _: 1
        })) : (openBlock(), createBlock(unref(UploadArrow), {
          key: 1,
          width: "20"
        }))
      ], 2);
    };
  }
});
const _hoisted_1$S = {
  width: "60",
  height: "60",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$r = /* @__PURE__ */ createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M41.87 24a17.87 17.87 0 1 1-35.74 0 17.87 17.87 0 0 1 35.74 0zm-3.15 18.96a24 24 0 1 1 4.24-4.24L59.04 54.8a3 3 0 1 1-4.24 4.24L38.72 42.96z",
  fill: "#8C9196"
}, null, -1);
const _hoisted_3$g = [
  _hoisted_2$r
];
function render$8(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1$S, _hoisted_3$g);
}
var EmptySearchSvg = { render: render$8 };
const _hoisted_1$R = { key: 0 };
const _sfc_main$21 = /* @__PURE__ */ defineComponent({
  props: {
    title: null,
    description: null,
    withIllustration: { type: Boolean }
  },
  setup(__props) {
    const i18n = UseI18n();
    i18n.translate("Polaris.EmptySearchResult.altText");
    return (_ctx, _cache) => {
      return openBlock(), createBlock(unref(_sfc_main$12), {
        alignment: "center",
        vertical: ""
      }, {
        default: withCtx(() => [
          createVNode(unref(EmptySearchSvg)),
          createVNode(unref(Text), {
            variant: "headingLg",
            as: "p"
          }, {
            default: withCtx(() => [
              createTextVNode(toDisplayString(__props.title), 1)
            ]),
            _: 1
          }),
          createVNode(unref(Text), {
            variant: "bodyMd",
            color: "subdued",
            as: "span"
          }, {
            default: withCtx(() => [
              __props.description ? (openBlock(), createElementBlock("p", _hoisted_1$R, toDisplayString(__props.description), 1)) : createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      });
    };
  }
});
const EmptyState = "Polaris-EmptyState";
const Section$5 = "Polaris-EmptyState__Section";
const Details$1 = "Polaris-EmptyState__Details";
const Image = "Polaris-EmptyState__Image";
const ImageContainer = "Polaris-EmptyState__ImageContainer";
const DetailsContainer = "Polaris-EmptyState__DetailsContainer";
const withinContentContainer = "Polaris-EmptyState--withinContentContainer";
const Content$6 = "Polaris-EmptyState__Content";
const imageContained = "Polaris-EmptyState--imageContained";
const fullWidth$3 = "Polaris-EmptyState--fullWidth";
const Actions$3 = "Polaris-EmptyState__Actions";
var styles$1h = {
  EmptyState,
  Section: Section$5,
  Details: Details$1,
  Image,
  ImageContainer,
  DetailsContainer,
  withinContentContainer,
  Content: Content$6,
  imageContained,
  fullWidth: fullWidth$3,
  Actions: Actions$3
};
var EmptyState_vue_vue_type_style_index_0_lang = "";
const _sfc_main$20 = /* @__PURE__ */ defineComponent({
  props: {
    heading: null,
    image: null,
    largeImage: null,
    imageContained: { type: Boolean },
    fullWidth: { type: Boolean, default: false },
    action: null,
    secondaryAction: null
  },
  setup(__props) {
    const props = __props;
    const withinContentContainer2 = inject("WithinContentContext", false);
    const slots = useSlots();
    const className = computed(() => {
      return classNames(styles$1h.EmptyState, props.fullWidth && styles$1h.fullWidth, props.imageContained && styles$1h.imageContained, withinContentContainer2 && styles$1h.withinContentContainer);
    });
    const headingSize = computed(() => withinContentContainer2 ? "headingLg" : "headingXl");
    const hasDetails = computed(() => {
      return props.heading || hasSlot(slots.default) || (props.action || props.secondaryAction) || hasSlot(slots.footerContent);
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(unref(className))
      }, [
        createElementVNode("div", {
          class: normalizeClass(unref(styles$1h).Section)
        }, [
          unref(hasDetails) ? (openBlock(), createElementBlock("div", {
            key: 0,
            class: normalizeClass(unref(styles$1h).DetailsContainer)
          }, [
            createElementVNode("div", {
              class: normalizeClass(unref(styles$1h).Details)
            }, [
              __props.heading || unref(hasSlot)(unref(slots).default) ? (openBlock(), createBlock(unref(_sfc_main$c), { key: 0 }, {
                default: withCtx(() => [
                  __props.heading ? (openBlock(), createBlock(unref(Text), {
                    key: 0,
                    variant: unref(headingSize),
                    as: "p"
                  }, {
                    default: withCtx(() => [
                      createTextVNode(toDisplayString(__props.heading), 1)
                    ]),
                    _: 1
                  }, 8, ["variant"])) : createCommentVNode("", true),
                  unref(hasSlot)(unref(slots).default) ? (openBlock(), createElementBlock("div", {
                    key: 1,
                    class: normalizeClass(unref(styles$1h).Content)
                  }, [
                    createVNode(unref(Text), {
                      as: "span",
                      variant: "bodyMd",
                      color: "subdued"
                    }, {
                      default: withCtx(() => [
                        renderSlot(_ctx.$slots, "default")
                      ]),
                      _: 3
                    })
                  ], 2)) : createCommentVNode("", true)
                ]),
                _: 3
              })) : createCommentVNode("", true),
              __props.action || __props.secondaryAction ? (openBlock(), createElementBlock("div", {
                key: 1,
                class: normalizeClass(unref(styles$1h).Actions)
              }, [
                createVNode(unref(_sfc_main$12), {
                  alignment: "center",
                  distribution: "center",
                  spacing: "tight"
                }, {
                  default: withCtx(() => [
                    __props.secondaryAction ? (openBlock(), createBlock(unref(_sfc_main$2E), {
                      key: 0,
                      action: __props.secondaryAction
                    }, null, 8, ["action"])) : createCommentVNode("", true),
                    __props.action ? (openBlock(), createBlock(unref(_sfc_main$2E), {
                      key: 1,
                      action: __props.action,
                      overrides: { primary: true, size: "medium" }
                    }, null, 8, ["action"])) : createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ], 2)) : createCommentVNode("", true),
              unref(hasSlot)(unref(slots).footerContent) ? (openBlock(), createBlock(unref(_sfc_main$2V), {
                key: 2,
                paddingBlockStart: "4"
              }, {
                default: withCtx(() => [
                  createVNode(unref(Text), {
                    as: "span",
                    variant: "bodyMd",
                    color: "subdued"
                  }, {
                    default: withCtx(() => [
                      renderSlot(_ctx.$slots, "footerContent")
                    ]),
                    _: 3
                  })
                ]),
                _: 3
              })) : createCommentVNode("", true)
            ], 2)
          ], 2)) : (openBlock(), createElementBlock("div", {
            key: 1,
            class: normalizeClass(unref(styles$1h).DetailsContainer)
          }, null, 2)),
          createElementVNode("div", {
            class: normalizeClass(unref(styles$1h).ImageContainer)
          }, [
            __props.largeImage ? (openBlock(), createBlock(unref(_sfc_main$1D), {
              key: 0,
              alt: "",
              role: "presentation",
              class: normalizeClass(unref(styles$1h).Image),
              source: __props.largeImage,
              sourceSet: [{ source: __props.image, descriptor: "568w" }, { source: __props.largeImage, descriptor: "1136w" }],
              sizes: "(max-width: 568px) 60vw"
            }, null, 8, ["class", "source", "sourceSet"])) : (openBlock(), createBlock(unref(_sfc_main$1D), {
              key: 1,
              role: "presentation",
              alt: "",
              class: normalizeClass(unref(styles$1h).Image),
              source: __props.image
            }, null, 8, ["class", "source"]))
          ], 2)
        ], 2)
      ], 2);
    };
  }
});
const ExceptionList = "Polaris-ExceptionList";
const Item$6 = "Polaris-ExceptionList__Item";
const Icon$5 = "Polaris-ExceptionList__Icon";
const statusWarning = "Polaris-ExceptionList--statusWarning";
const statusCritical = "Polaris-ExceptionList--statusCritical";
const Bullet = "Polaris-ExceptionList__Bullet";
const Title$5 = "Polaris-ExceptionList__Title";
const Description = "Polaris-ExceptionList__Description";
var styles$1g = {
  ExceptionList,
  Item: Item$6,
  Icon: Icon$5,
  statusWarning,
  statusCritical,
  Bullet,
  Title: Title$5,
  Description
};
var ExceptionList_vue_vue_type_style_index_0_lang = "";
const _sfc_main$1$ = /* @__PURE__ */ defineComponent({
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("ul", {
        class: normalizeClass(unref(styles$1g).ExceptionList)
      }, [
        renderSlot(_ctx.$slots, "default")
      ], 2);
    };
  }
});
const Truncate = "Polaris-Truncate";
var styles$1f = {
  Truncate
};
var Truncate_vue_vue_type_style_index_0_lang = "";
const _sfc_main$1_ = /* @__PURE__ */ defineComponent({
  setup(__props) {
    return (_ctx, _cache) => {
      const _component_component = resolveComponent("component");
      return openBlock(), createBlock(_component_component, {
        class: normalizeClass(unref(styles$1f).Truncate)
      }, {
        default: withCtx(() => [
          renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }, 8, ["class"]);
    };
  }
});
var ExceptionListItem_vue_vue_type_style_index_0_lang = "";
const _sfc_main$1Z = /* @__PURE__ */ defineComponent({
  props: {
    status: null,
    icon: null,
    title: null,
    truncate: { type: Boolean }
  },
  setup(__props) {
    const props = __props;
    const slots = useSlots();
    const classItem = computed(() => {
      return classNames(styles$1g.Item, props.status && styles$1g[variationName("status", props.status)]);
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("li", {
        class: normalizeClass(unref(classItem))
      }, [
        createElementVNode("span", {
          class: normalizeClass(unref(styles$1g).Icon)
        }, [
          __props.icon ? (openBlock(), createBlock(unref(_sfc_main$2K), {
            key: 0,
            source: __props.icon
          }, null, 8, ["source"])) : (openBlock(), createElementBlock("span", {
            key: 1,
            class: normalizeClass(unref(styles$1g).Bullet)
          }, null, 2))
        ], 2),
        __props.truncate ? (openBlock(), createBlock(unref(_sfc_main$1_), { key: 0 }, {
          default: withCtx(() => [
            __props.title ? (openBlock(), createElementBlock("span", {
              key: 0,
              class: normalizeClass(unref(styles$1g).Title)
            }, toDisplayString(__props.title), 3)) : createCommentVNode("", true),
            unref(slots).default ? (openBlock(), createElementBlock("span", {
              key: 1,
              class: normalizeClass(unref(styles$1g).Description)
            }, [
              renderSlot(_ctx.$slots, "default")
            ], 2)) : createCommentVNode("", true)
          ]),
          _: 3
        })) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
          __props.title ? (openBlock(), createElementBlock("span", {
            key: 0,
            class: normalizeClass(unref(styles$1g).Title)
          }, toDisplayString(__props.title), 3)) : createCommentVNode("", true),
          unref(slots).default ? (openBlock(), createElementBlock("span", {
            key: 1,
            class: normalizeClass(unref(styles$1g).Description)
          }, [
            renderSlot(_ctx.$slots, "default")
          ], 2)) : createCommentVNode("", true)
        ], 64))
      ], 2);
    };
  }
});
function UseMediaQuery() {
  const mediaQuery = inject("mediaQueryContext", {});
  function useMediaQuery() {
    if (!mediaQuery) {
      throw new MissingAppProviderError("No mediaQuery was provided.");
    }
    return mediaQuery;
  }
  return { useMediaQuery };
}
const _hoisted_1$Q = {
  viewBox: "0 0 20 20",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$q = /* @__PURE__ */ createElementVNode("path", { d: "M8 12a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm9.707 4.293-4.82-4.82A5.968 5.968 0 0 0 14 8 6 6 0 0 0 2 8a6 6 0 0 0 6 6 5.968 5.968 0 0 0 3.473-1.113l4.82 4.82a.997.997 0 0 0 1.414 0 .999.999 0 0 0 0-1.414z" }, null, -1);
const _hoisted_3$f = [
  _hoisted_2$q
];
function render$7(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1$Q, _hoisted_3$f);
}
var SearchMinor = { render: render$7 };
const _hoisted_1$P = {
  viewBox: "0 0 20 20",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$p = /* @__PURE__ */ createElementVNode("path", { d: "M15 13a.997.997 0 0 1-.707-.293L10 8.414l-4.293 4.293a.999.999 0 1 1-1.414-1.414l5-5a.999.999 0 0 1 1.414 0l5 5A.999.999 0 0 1 15 13z" }, null, -1);
const _hoisted_3$e = [
  _hoisted_2$p
];
function render$6(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1$P, _hoisted_3$e);
}
var ChevronUpMinor = { render: render$6 };
const _hoisted_1$O = {
  viewBox: "0 0 20 20",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$o = /* @__PURE__ */ createElementVNode("path", { d: "M10 14a.997.997 0 0 1-.707-.293l-5-5a.999.999 0 1 1 1.414-1.414L10 11.586l4.293-4.293a.999.999 0 1 1 1.414 1.414l-5 5A.997.997 0 0 1 10 14z" }, null, -1);
const _hoisted_3$d = [
  _hoisted_2$o
];
function render$5(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1$O, _hoisted_3$d);
}
var ChevronDownMinor = { render: render$5 };
const Filters = "Polaris-Filters";
const FiltersContainer = "Polaris-Filters__FiltersContainer";
const FiltersContainerHeader = "Polaris-Filters__FiltersContainerHeader";
const FiltersDesktopContainerContent = "Polaris-Filters__FiltersDesktopContainerContent";
const FiltersMobileContainerContent = "Polaris-Filters__FiltersMobileContainerContent";
const FiltersContainerFooter = "Polaris-Filters__FiltersContainerFooter";
const FiltersMobileContainerFooter = "Polaris-Filters__FiltersMobileContainerFooter";
const EmptyFooterState = "Polaris-Filters__EmptyFooterState";
const FilterTriggerContainer = "Polaris-Filters__FilterTriggerContainer";
const FilterTrigger = "Polaris-Filters__FilterTrigger";
const FilterTriggerTitle = "Polaris-Filters__FilterTriggerTitle";
const AppliedFilterBadgeContainer = "Polaris-Filters__AppliedFilterBadgeContainer";
const open$1 = "Polaris-Filters--open";
const FilterTriggerLabelContainer = "Polaris-Filters__FilterTriggerLabelContainer";
const first = "Polaris-Filters--first";
const last = "Polaris-Filters--last";
const FilterNodeContainer = "Polaris-Filters__FilterNodeContainer";
const SearchIcon = "Polaris-Filters__SearchIcon";
const Backdrop$4 = "Polaris-Filters__Backdrop";
const HelpText$1 = "Polaris-Filters__HelpText";
const TagsContainer = "Polaris-Filters__TagsContainer";
var styles$1e = {
  Filters,
  FiltersContainer,
  FiltersContainerHeader,
  FiltersDesktopContainerContent,
  FiltersMobileContainerContent,
  FiltersContainerFooter,
  FiltersMobileContainerFooter,
  EmptyFooterState,
  FilterTriggerContainer,
  FilterTrigger,
  FilterTriggerTitle,
  AppliedFilterBadgeContainer,
  open: open$1,
  FilterTriggerLabelContainer,
  first,
  last,
  FilterNodeContainer,
  SearchIcon,
  Backdrop: Backdrop$4,
  HelpText: HelpText$1,
  TagsContainer
};
const ConnectedFilterControl = "Polaris-Filters-ConnectedFilterControl";
const CenterContainer = "Polaris-Filters-ConnectedFilterControl__CenterContainer";
const right = "Polaris-Filters-ConnectedFilterControl--right";
const Item$5 = "Polaris-Filters-ConnectedFilterControl__Item";
const ProxyButtonContainer = "Polaris-Filters-ConnectedFilterControl__ProxyButtonContainer";
const RightContainer = "Polaris-Filters-ConnectedFilterControl__RightContainer";
const MoreFiltersButtonContainer = "Polaris-Filters-ConnectedFilterControl__MoreFiltersButtonContainer";
const queryFieldHidden = "Polaris-Filters-ConnectedFilterControl--queryFieldHidden";
const RightContainerWithoutMoreFilters = "Polaris-Filters-ConnectedFilterControl__RightContainerWithoutMoreFilters";
const onlyButtonVisible = "Polaris-Filters-ConnectedFilterControl--onlyButtonVisible";
const Wrapper$2 = "Polaris-Filters-ConnectedFilterControl__Wrapper";
const AuxiliaryContainer = "Polaris-Filters-ConnectedFilterControl__AuxiliaryContainer";
var styles$1d = {
  ConnectedFilterControl,
  CenterContainer,
  right,
  Item: Item$5,
  "Item-focused": "Polaris-Filters-ConnectedFilterControl__Item--focused",
  ProxyButtonContainer,
  RightContainer,
  MoreFiltersButtonContainer,
  queryFieldHidden,
  RightContainerWithoutMoreFilters,
  onlyButtonVisible,
  Wrapper: Wrapper$2,
  AuxiliaryContainer
};
const _sfc_main$1Y = /* @__PURE__ */ defineComponent({
  setup(__props) {
    const focused2 = ref(false);
    const className = computed(() => classNames(styles$1d.Item, focused2.value && styles$1d["Item-focused"]));
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        onBlur: _cache[0] || (_cache[0] = () => focused2.value = false),
        onFocus: _cache[1] || (_cache[1] = () => focused2.value = true),
        class: normalizeClass(unref(className))
      }, [
        renderSlot(_ctx.$slots, "default")
      ], 34);
    };
  }
});
var ConnectedFilterControl_vue_vue_type_style_index_0_lang = "";
const _hoisted_1$N = ["data-key"];
const _sfc_main$1X = /* @__PURE__ */ defineComponent({
  props: {
    rightPopoverableActions: null,
    disabled: { type: Boolean },
    forceShowMorefiltersButton: { type: Boolean, default: true },
    queryFieldHidden: { type: Boolean }
  },
  setup(__props) {
    const props = __props;
    const FILTER_FIELD_MIN_WIDTH = 150;
    const slots = useSlots();
    const availableWidth = ref(0);
    const proxyButtonsWidth = ref({});
    const containerRef = ref(null);
    const proxyButtonContainer = ref(null);
    const moreFiltersButtonContainer = ref(null);
    const handleResize = debounce(() => {
      measureProxyButtons();
      measureAvailableWidth();
    }, 40, { leading: true, trailing: true, maxWait: 40 });
    onMounted(() => {
      handleResize();
    });
    const actionsToRender = computed(() => props.rightPopoverableActions != null ? getActionsToRender(props.rightPopoverableActions) : []);
    const className = computed(() => classNames(styles$1d.ConnectedFilterControl, props.rightPopoverableActions && styles$1d.right));
    const shouldRenderMoreFiltersButton = computed(() => props.forceShowMorefiltersButton || props.rightPopoverableActions && props.rightPopoverableActions.length !== actionsToRender.value.length);
    const RightContainerClassName = computed(() => classNames(styles$1d.RightContainer, !shouldRenderMoreFiltersButton.value && styles$1d.RightContainerWithoutMoreFilters, props.queryFieldHidden && styles$1d.queryFieldHidden));
    const moreFiltersButtonContainerClassname = computed(() => classNames(styles$1d.MoreFiltersButtonContainer, actionsToRender.value.length === 0 && styles$1d.onlyButtonVisible));
    const measureProxyButtons = () => {
      if (proxyButtonContainer.value) {
        const tmpProxyButtonsWidth = {};
        const tolerance = 78;
        if (proxyButtonContainer.value) {
          Array.from(proxyButtonContainer.value.children).forEach((element) => {
            const buttonWidth = element.getBoundingClientRect().width + tolerance;
            const buttonKey = element instanceof HTMLElement && element.dataset.key;
            if (buttonKey) {
              tmpProxyButtonsWidth[buttonKey] = buttonWidth;
            }
          });
        }
        proxyButtonsWidth.value = tmpProxyButtonsWidth;
      }
    };
    const measureAvailableWidth = () => {
      if (containerRef.value && moreFiltersButtonContainer.value) {
        const containerWidth = containerRef.value.getBoundingClientRect().width;
        const moreFiltersButtonWidth = moreFiltersButtonContainer.value.getBoundingClientRect().width;
        const filtersActionWidth = 0;
        const filterFieldMinWidth = props.queryFieldHidden ? 0 : FILTER_FIELD_MIN_WIDTH;
        const tmpAvailableWidth = containerWidth - filterFieldMinWidth - moreFiltersButtonWidth - filtersActionWidth;
        availableWidth.value = tmpAvailableWidth;
      }
    };
    const getActionsToRender = (actions) => {
      let remainingWidth = availableWidth.value;
      const actionsToReturn = [];
      for (let i = 0; remainingWidth > 0 && i < actions.length; i++) {
        const action = actions[i];
        const actionWidth = proxyButtonsWidth.value[action.key];
        if (actionWidth <= remainingWidth) {
          actionsToReturn.push(action);
          remainingWidth -= actionWidth;
        } else {
          break;
        }
      }
      return actionsToReturn;
    };
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock(Fragment, null, [
        __props.rightPopoverableActions ? (openBlock(), createElementBlock("div", {
          key: 0,
          class: normalizeClass(unref(styles$1d).ProxyButtonContainer),
          ref_key: "proxyButtonContainer",
          ref: proxyButtonContainer,
          "aria-hidden": ""
        }, [
          (openBlock(true), createElementBlock(Fragment, null, renderList(__props.rightPopoverableActions, (action) => {
            return openBlock(), createElementBlock("div", {
              key: action.key,
              "data-key": action.key
            }, [
              createVNode(unref(_sfc_main$2F), {
                disclosure: "",
                disabled: __props.disabled || action.disabled,
                onClick: action.onAction
              }, {
                default: withCtx(() => [
                  createTextVNode(toDisplayString(action.content), 1)
                ]),
                _: 2
              }, 1032, ["disabled", "onClick"])
            ], 8, _hoisted_1$N);
          }), 128))
        ], 2)) : createCommentVNode("", true),
        createElementVNode("div", {
          class: normalizeClass(unref(styles$1d).Wrapper)
        }, [
          createElementVNode("div", {
            class: normalizeClass(unref(className)),
            ref_key: "containerRef",
            ref: containerRef
          }, [
            unref(hasSlot)(unref(slots).default) ? (openBlock(), createElementBlock("div", {
              key: 0,
              class: normalizeClass(unref(styles$1d).CenterContainer)
            }, [
              createVNode(unref(_sfc_main$1Y), null, {
                default: withCtx(() => [
                  renderSlot(_ctx.$slots, "default")
                ]),
                _: 3
              })
            ], 2)) : createCommentVNode("", true),
            unref(actionsToRender).length > 0 ? (openBlock(), createElementBlock("div", {
              key: 1,
              class: normalizeClass(unref(RightContainerClassName))
            }, [
              (openBlock(true), createElementBlock(Fragment, null, renderList(unref(actionsToRender), (action) => {
                return openBlock(), createBlock(unref(_sfc_main$1Y), {
                  key: action.key
                }, {
                  default: withCtx(() => [
                    createVNode(unref(_sfc_main$2L), {
                      active: action.popoverOpen,
                      preferredAlignment: "left",
                      sectioned: "",
                      onClose: action.onAction
                    }, {
                      activator: withCtx(() => [
                        createVNode(unref(_sfc_main$2F), {
                          disclosure: "",
                          disabled: __props.disabled || action.disabled,
                          id: `Activator-${action.key}`,
                          onClick: action.onAction
                        }, {
                          default: withCtx(() => [
                            createTextVNode(toDisplayString(action.content), 1)
                          ]),
                          _: 2
                        }, 1032, ["disabled", "id", "onClick"])
                      ]),
                      content: withCtx(() => [
                        renderSlot(_ctx.$slots, `popover-${action.key}`)
                      ]),
                      _: 2
                    }, 1032, ["active", "onClose"])
                  ]),
                  _: 2
                }, 1024);
              }), 128))
            ], 2)) : createCommentVNode("", true),
            unref(hasSlot)(unref(slots).rightAction) ? (openBlock(), createElementBlock("div", {
              key: 2,
              ref_key: "moreFiltersButtonContainer",
              ref: moreFiltersButtonContainer,
              class: normalizeClass(unref(moreFiltersButtonContainerClassname))
            }, [
              unref(shouldRenderMoreFiltersButton) ? (openBlock(), createBlock(unref(_sfc_main$1Y), { key: 0 }, {
                default: withCtx(() => [
                  renderSlot(_ctx.$slots, "rightAction")
                ]),
                _: 3
              })) : createCommentVNode("", true)
            ], 2)) : createCommentVNode("", true),
            createVNode(unref(_sfc_main$33), {
              event: "resize",
              handler: unref(handleResize)
            }, null, 8, ["handler"])
          ], 2),
          unref(hasSlot)(unref(slots).auxiliary) ? (openBlock(), createElementBlock("div", {
            key: 0,
            class: normalizeClass(unref(styles$1d).AuxiliaryContainer)
          }, [
            renderSlot(_ctx.$slots, "auxiliary")
          ], 2)) : createCommentVNode("", true)
        ], 2)
      ], 64);
    };
  }
});
const _sfc_main$1W = /* @__PURE__ */ defineComponent({
  props: {
    hidden: { type: Boolean }
  },
  setup(__props) {
    return (_ctx, _cache) => {
      return __props.hidden ? (openBlock(), createBlock(unref(Text), {
        key: 0,
        variant: "bodySm",
        as: "span",
        "visually-hidden": ""
      }, {
        default: withCtx(() => [
          renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      })) : renderSlot(_ctx.$slots, "default", { key: 1 });
    };
  }
});
var Filters_vue_vue_type_style_index_0_lang = "";
const _hoisted_1$M = ["onClick", "id", "aria-controls", "aria-expanded"];
const _hoisted_2$n = ["onClick", "id", "aria-controls", "aria-expanded"];
const _sfc_main$1V = /* @__PURE__ */ defineComponent({
  props: {
    modelValue: null,
    queryPlaceholder: null,
    focused: { type: Boolean },
    filters: null,
    appliedFilters: null,
    disabled: { type: Boolean, default: false },
    helpText: null,
    hideTags: { type: Boolean },
    hideQueryField: { type: Boolean },
    disableQueryField: { type: Boolean, default: false }
  },
  emits: ["update:modelValue", "query-change", "query-clear", "clear-all", "query-blur", "query-focus"],
  setup(__props, { emit: emits }) {
    const props = __props;
    const i18n = UseI18n();
    const { useMediaQuery } = UseMediaQuery();
    const { isNavigationCollapsed } = useMediaQuery();
    const slots = useSlots();
    const open2 = ref(false);
    const readyForFocus = ref(false);
    const stateFilter = reactive({});
    const Suffix2 = {
      Filter: "Filter",
      Shortcut: "Shortcut"
    };
    const resourceListContext = inject("ResourceListContext", {});
    const { resourceName } = resourceListContext;
    const moreFiltersButtonContainer = ref(null);
    const moreFiltersDoneButtonContainer = ref(null);
    const focusNode = ref(null);
    const filtersContainerHeaderClassname = classNames(styles$1e.FiltersContainerHeader);
    const filtersDesktopFooterClassname = classNames(styles$1e.FiltersContainerFooter);
    const filtersMobileContainerContentClassName = classNames(styles$1e.FiltersMobileContainerContent);
    const filtersDesktopContainerContentClassName = classNames(styles$1e.FiltersDesktopContainerContent);
    const shouldHideTagsContainer = computed(() => !props.appliedFilters || props.appliedFilters.length < 1);
    const buttonClassName = classNames(styles$1e.FilterTrigger);
    const transformedFilters = computed(() => transformFilters(props.filters));
    const hasAppliedFilters = computed(() => {
      const filtersApplied = Boolean(props.appliedFilters && props.appliedFilters.length > 0);
      const queryApplied = Boolean(props.modelValue && props.modelValue !== "");
      return filtersApplied || queryApplied;
    });
    const appliedFiltersCount = computed(() => props.appliedFilters ? props.appliedFilters.length : 0);
    const moreFiltersLabel = computed(() => {
      return props.hideTags && appliedFiltersCount.value > 0 ? i18n.translate("Polaris.Filters.moreFiltersWithCount", {
        count: appliedFiltersCount.value
      }) : i18n.translate("Polaris.Filters.moreFilters");
    });
    const filterResourceName = computed(() => resourceName || {
      singular: i18n.translate("Polaris.ResourceList.defaultItemSingular"),
      plural: i18n.translate("Polaris.ResourceList.defaultItemPlural")
    });
    const filterIsOpen = (filter, index) => stateFilter[`${filter.key}${Suffix2.Filter}`] === true;
    const filterClassName = (filter, index) => classNames(styles$1e.FilterTriggerContainer, filterIsOpen(filter) && styles$1e.open, index === 0 && styles$1e.first, props.filters.length !== 1 && index === props.filters.length - 1 && styles$1e.last);
    const getAppliedFilterContent = (key) => {
      const { appliedFilters } = props;
      if (!appliedFilters) {
        return void 0;
      }
      const filter = appliedFilters.find((f) => f.key === key);
      return filter == null ? void 0 : filter.label;
    };
    const getAppliedFilterRemoveHandler = (key) => {
      const { appliedFilters } = props;
      if (!appliedFilters) {
        return void 0;
      }
      const filter = appliedFilters.find((f) => f.key === key);
      return filter == null ? void 0 : filter.onRemove;
    };
    const openFilters = () => {
      open2.value = true;
    };
    const closeFilters = () => {
      open2.value = false;
      if (moreFiltersButtonContainer.value) {
        focusFirstFocusableNode(moreFiltersButtonContainer.value, false);
      }
    };
    const toggleFilters = () => {
      if (open2.value === true) {
        closeFilters();
      } else {
        openFilters();
      }
    };
    const setReadyForFocus = (newState) => () => {
      readyForFocus.value = newState;
    };
    const openFilter = (key) => {
      stateFilter[`${key}${Suffix2.Filter}`] = true;
    };
    const closeFilter = (key) => {
      stateFilter[`${key}${Suffix2.Filter}`] = false;
    };
    const toggleFilter = (key) => {
      if (stateFilter[`${key}${Suffix2.Filter}`] === true) {
        closeFilter(key);
      } else {
        openFilter(key);
      }
    };
    const openFilterShortcut = (key) => {
      stateFilter[`${key}${Suffix2.Shortcut}`] = true;
    };
    const closeFilterShortcut = (key) => {
      stateFilter[`${key}${Suffix2.Shortcut}`] = false;
    };
    const toggleFilterShortcut = (key) => {
      if (stateFilter[`${key}${Suffix2.Shortcut}`] === true) {
        closeFilterShortcut(key);
      } else {
        openFilterShortcut(key);
      }
    };
    const transformFilters = (filters) => {
      const transformedActions = [];
      getShortcutFilters(filters).forEach((filter) => {
        const { key, label, disabled: disabled2 } = filter;
        transformedActions.push({
          popoverContent: filter,
          popoverOpen: Boolean(stateFilter[`${key}${Suffix2.Shortcut}`]),
          key,
          content: label,
          disabled: disabled2,
          onAction: () => toggleFilterShortcut(key)
        });
      });
      return transformedActions;
    };
    const handleClearAll = () => {
      emits("clear-all");
      moreFiltersDoneButtonContainer.value && focusFirstFocusableNode(moreFiltersDoneButtonContainer.value, false);
    };
    const handleClearTextField = (id) => {
      emits("query-clear", id);
    };
    const handleQueryChange = (event) => {
      emits("update:modelValue", event.target.value);
      emits("query-change", event.target.value || "");
    };
    const getShortcutFilters = (filters) => {
      return filters.filter((filter) => filter.shortcut === true);
    };
    const hasRemoveHandler = (key) => {
      const handler = getAppliedFilterRemoveHandler(key);
      if (handler) {
        return true;
      }
      return null;
    };
    const removeHandler = (key) => {
      const handler = getAppliedFilterRemoveHandler(key);
      if (handler) {
        return handler(key);
      }
      return null;
    };
    provide("withinFilterContext", true);
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(unref(styles$1e).Filters)
      }, [
        createVNode(unref(_sfc_main$1X), {
          rightPopoverableActions: unref(transformedFilters),
          disabled: __props.disabled,
          forceShowMorefiltersButton: __props.filters.length > unref(transformedFilters).length,
          queryFieldHidden: __props.hideQueryField
        }, createSlots({
          auxiliary: withCtx(() => [
            renderSlot(_ctx.$slots, "default")
          ]),
          rightAction: withCtx(() => [
            __props.filters.length ? (openBlock(), createElementBlock("div", {
              key: 0,
              ref_key: "moreFiltersButtonContainer",
              ref: moreFiltersButtonContainer
            }, [
              createVNode(unref(_sfc_main$2F), {
                onClick: toggleFilters,
                disabled: __props.disabled
              }, {
                default: withCtx(() => [
                  createTextVNode(toDisplayString(unref(moreFiltersLabel)), 1)
                ]),
                _: 1
              }, 8, ["disabled"])
            ], 512)) : createCommentVNode("", true)
          ]),
          default: withCtx(() => [
            !__props.hideQueryField ? (openBlock(), createBlock(unref(_sfc_main$31), {
              key: 0,
              "model-value": __props.modelValue,
              focused: __props.focused,
              placeholder: __props.queryPlaceholder || unref(i18n).translate("Polaris.Filters.filter", { resourceName: unref(filterResourceName).plural }),
              labelHidden: "",
              clearButton: "",
              disabled: __props.disabled || __props.disableQueryField,
              autoComplete: "off",
              onClearButtonClick: handleClearTextField,
              onChange: handleQueryChange,
              onBlur: _cache[0] || (_cache[0] = ($event) => emits("query-blur")),
              onFocus: _cache[1] || (_cache[1] = ($event) => emits("query-focus"))
            }, {
              label: withCtx(() => [
                createTextVNode(toDisplayString(__props.queryPlaceholder || unref(i18n).translate("Polaris.Filters.filter", { resourceName: unref(filterResourceName).plural })), 1)
              ]),
              prefix: withCtx(() => [
                createElementVNode("span", {
                  class: normalizeClass(unref(styles$1e).SearchIcon)
                }, [
                  createVNode(unref(_sfc_main$2K), { source: unref(SearchMinor) }, null, 8, ["source"])
                ], 2)
              ]),
              _: 1
            }, 8, ["model-value", "focused", "placeholder", "disabled"])) : createCommentVNode("", true)
          ]),
          _: 2
        }, [
          renderList(unref(transformedFilters), (action) => {
            return {
              name: `popover-${action.key}`,
              fn: withCtx(() => [
                createElementVNode("div", {
                  ref_key: "focusNode",
                  ref: focusNode
                }, [
                  createVNode(unref(_sfc_main$12), {
                    vertical: "",
                    spacing: "tight"
                  }, {
                    default: withCtx(() => [
                      unref(hasSlot)(unref(slots)[`filter-${action.key}`]) ? renderSlot(_ctx.$slots, `filter-${action.key}`, { key: 0 }) : createCommentVNode("", true),
                      action.popoverContent.hideClearButton !== false ? (openBlock(), createBlock(unref(_sfc_main$2F), {
                        key: 1,
                        plain: "",
                        disabled: !hasRemoveHandler(action.key),
                        accessibilityLabel: unref(i18n).translate("Polaris.Filters.clearLabel", { filterName: action.popoverContent.label }),
                        onClick: ($event) => removeHandler(action.key)
                      }, {
                        default: withCtx(() => [
                          createTextVNode(toDisplayString(unref(i18n).translate("Polaris.Filters.clear")), 1)
                        ]),
                        _: 2
                      }, 1032, ["disabled", "accessibilityLabel", "onClick"])) : createCommentVNode("", true)
                    ]),
                    _: 2
                  }, 1024)
                ], 512)
              ])
            };
          })
        ]), 1032, ["rightPopoverableActions", "disabled", "forceShowMorefiltersButton", "queryFieldHidden"]),
        unref(isNavigationCollapsed) ? (openBlock(), createBlock(unref(_sfc_main$v), {
          key: 0,
          accessibilityLabel: unref(moreFiltersLabel),
          open: open2.value,
          onClose: closeFilters,
          onEntered: _cache[3] || (_cache[3] = ($event) => setReadyForFocus(true)),
          onExit: _cache[4] || (_cache[4] = ($event) => setReadyForFocus(false))
        }, {
          default: withCtx(() => [
            createElementVNode("div", {
              class: normalizeClass(unref(filtersContainerHeaderClassname))
            }, [
              createVNode(unref(_sfc_main$2F), {
                icon: unref(CancelSmallMinor),
                plain: "",
                accessibilityLabel: unref(i18n).translate("Polaris.Filters.cancel"),
                onClick: closeFilters
              }, null, 8, ["icon", "accessibilityLabel"]),
              createVNode(unref(Text), {
                variant: "headingLg",
                as: "h3"
              }, {
                default: withCtx(() => [
                  createTextVNode(toDisplayString(unref(moreFiltersLabel)), 1)
                ]),
                _: 1
              }),
              createVNode(unref(_sfc_main$2F), {
                onClick: closeFilters,
                primary: ""
              }, {
                default: withCtx(() => [
                  createTextVNode(toDisplayString(unref(i18n).translate("Polaris.Filters.done")), 1)
                ]),
                _: 1
              })
            ], 2),
            createVNode(unref(_sfc_main$3o), {
              class: normalizeClass(unref(filtersMobileContainerContentClassName)),
              shadow: ""
            }, {
              default: withCtx(() => [
                (openBlock(true), createElementBlock(Fragment, null, renderList(__props.filters, (filter, index) => {
                  return openBlock(), createElementBlock("div", {
                    key: filter.key,
                    class: normalizeClass(filterClassName(filter, index))
                  }, [
                    createElementVNode("button", {
                      onClick: () => toggleFilter(filter.key),
                      class: normalizeClass(unref(buttonClassName)),
                      id: `${filter.key}ToggleButton`,
                      type: "button",
                      "aria-controls": `${filter.key}Collapsible`,
                      "aria-expanded": filterIsOpen(filter)
                    }, [
                      createElementVNode("div", {
                        class: normalizeClass(unref(styles$1e).FilterTriggerLabelContainer)
                      }, [
                        createElementVNode("h3", {
                          class: normalizeClass(unref(styles$1e).FilterTriggerTitle)
                        }, [
                          createVNode(unref(Text), {
                            variant: "bodyMd",
                            as: "span",
                            color: __props.disabled || filter.disabled ? "subdued" : void 0
                          }, {
                            default: withCtx(() => [
                              createTextVNode(toDisplayString(filter.label), 1)
                            ]),
                            _: 2
                          }, 1032, ["color"])
                        ], 2),
                        createElementVNode("span", null, [
                          createVNode(unref(_sfc_main$2K), {
                            source: filterIsOpen(filter) ? unref(ChevronUpMinor) : unref(ChevronDownMinor),
                            color: "base"
                          }, null, 8, ["source"])
                        ])
                      ], 2),
                      getAppliedFilterContent(filter.key) ? (openBlock(), createElementBlock("div", {
                        key: 0,
                        class: normalizeClass(unref(styles$1e).AppliedFilterBadgeContainer)
                      }, [
                        createVNode(unref(_sfc_main$2Y), { status: "new" }, {
                          default: withCtx(() => [
                            createTextVNode(toDisplayString(getAppliedFilterContent(filter.key)), 1)
                          ]),
                          _: 2
                        }, 1024)
                      ], 2)) : createCommentVNode("", true)
                    ], 10, _hoisted_1$M),
                    createVNode(unref(_sfc_main$2q), {
                      id: `${filter.key}Collapsible`,
                      open: filterIsOpen(filter)
                    }, {
                      default: withCtx(() => [
                        createElementVNode("div", {
                          class: normalizeClass(unref(styles$1e).FilterNodeContainer)
                        }, [
                          createVNode(unref(_sfc_main$1U), {
                            disabled: !filterIsOpen(filter) || !readyForFocus.value || !open2.value,
                            root: focusNode.value
                          }, {
                            default: withCtx(() => [
                              createElementVNode("div", {
                                ref_for: true,
                                ref_key: "focusNode",
                                ref: focusNode
                              }, [
                                createVNode(unref(_sfc_main$12), {
                                  vertical: "",
                                  spacing: "tight"
                                }, {
                                  default: withCtx(() => [
                                    renderSlot(_ctx.$slots, `filter-${filter.key}`),
                                    filter.hideClearButton !== false ? (openBlock(), createBlock(unref(_sfc_main$2F), {
                                      key: 0,
                                      plain: "",
                                      disabled: !hasRemoveHandler(filter.key),
                                      onClick: ($event) => removeHandler(filter.key),
                                      accessibilityLabel: unref(i18n).translate("Polaris.Filters.clearLabel", { filterName: filter.label })
                                    }, {
                                      default: withCtx(() => [
                                        createTextVNode(toDisplayString(unref(i18n).translate("Polaris.Filters.clear")), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["disabled", "onClick", "accessibilityLabel"])) : createCommentVNode("", true)
                                  ]),
                                  _: 2
                                }, 1024)
                              ], 512)
                            ]),
                            _: 2
                          }, 1032, ["disabled", "root"])
                        ], 2)
                      ]),
                      _: 2
                    }, 1032, ["id", "open"])
                  ], 2);
                }), 128)),
                createElementVNode("div", {
                  class: normalizeClass(unref(styles$1e).FiltersMobileContainerFooter)
                }, [
                  unref(hasAppliedFilters) ? (openBlock(), createBlock(unref(_sfc_main$2F), {
                    key: 0,
                    onClick: _cache[2] || (_cache[2] = ($event) => emits("clear-all")),
                    fullWidth: ""
                  }, {
                    default: withCtx(() => [
                      createTextVNode(toDisplayString(unref(i18n).translate("Polaris.Filters.clearAllFilters")), 1)
                    ]),
                    _: 1
                  })) : (openBlock(), createElementBlock("div", {
                    key: 1,
                    class: normalizeClass(unref(styles$1e).EmptyFooterState)
                  }, [
                    createVNode(unref(Text), {
                      variant: "bodyMd",
                      color: "subdued",
                      as: "span"
                    }, {
                      default: withCtx(() => [
                        createElementVNode("p", null, toDisplayString(unref(i18n).translate("Polaris.Filters.noFiltersApplied")), 1)
                      ]),
                      _: 1
                    })
                  ], 2))
                ], 2)
              ]),
              _: 3
            }, 8, ["class"])
          ]),
          _: 3
        }, 8, ["accessibilityLabel", "open"])) : (openBlock(), createBlock(unref(_sfc_main$v), {
          key: 1,
          accessibilityLabel: unref(moreFiltersLabel),
          open: open2.value,
          onClose: closeFilters,
          onEntered: _cache[5] || (_cache[5] = ($event) => setReadyForFocus(true)),
          onExit: _cache[6] || (_cache[6] = ($event) => setReadyForFocus(false))
        }, {
          default: withCtx(() => [
            createElementVNode("div", {
              class: normalizeClass(unref(styles$1e).FiltersContainer)
            }, [
              createElementVNode("div", {
                class: normalizeClass(unref(filtersContainerHeaderClassname))
              }, [
                createVNode(unref(Text), {
                  variant: "headingLg",
                  as: "h3"
                }, {
                  default: withCtx(() => [
                    createTextVNode(toDisplayString(unref(moreFiltersLabel)), 1)
                  ]),
                  _: 1
                }),
                createVNode(unref(_sfc_main$2F), {
                  icon: unref(CancelSmallMinor),
                  plain: "",
                  accessibilityLabel: unref(i18n).translate("Polaris.Filters.cancel"),
                  onClick: closeFilters
                }, null, 8, ["icon", "accessibilityLabel"])
              ], 2),
              createVNode(unref(_sfc_main$3o), {
                class: normalizeClass(unref(filtersDesktopContainerContentClassName)),
                shadow: ""
              }, {
                default: withCtx(() => [
                  (openBlock(true), createElementBlock(Fragment, null, renderList(__props.filters, (filter, index) => {
                    return openBlock(), createElementBlock("div", {
                      key: filter.key,
                      class: normalizeClass(filterClassName(filter, index))
                    }, [
                      createElementVNode("button", {
                        onClick: () => toggleFilter(filter.key),
                        class: normalizeClass(unref(buttonClassName)),
                        id: `${filter.key}ToggleButton`,
                        type: "button",
                        "aria-controls": `${filter.key}Collapsible`,
                        "aria-expanded": filterIsOpen(filter)
                      }, [
                        createElementVNode("div", {
                          class: normalizeClass(unref(styles$1e).FilterTriggerLabelContainer)
                        }, [
                          createElementVNode("h3", {
                            class: normalizeClass(unref(styles$1e).FilterTriggerTitle)
                          }, [
                            createVNode(unref(Text), {
                              variant: "bodyMd",
                              as: "span",
                              color: __props.disabled || filter.disabled ? "subdued" : void 0
                            }, {
                              default: withCtx(() => [
                                createTextVNode(toDisplayString(filter.label), 1)
                              ]),
                              _: 2
                            }, 1032, ["color"])
                          ], 2),
                          createElementVNode("span", null, [
                            createVNode(unref(_sfc_main$2K), {
                              source: filterIsOpen(filter) ? unref(ChevronUpMinor) : unref(ChevronDownMinor),
                              color: "base"
                            }, null, 8, ["source"])
                          ])
                        ], 2),
                        getAppliedFilterContent(filter.key) ? (openBlock(), createElementBlock("div", {
                          key: 0,
                          class: normalizeClass(unref(styles$1e).AppliedFilterBadgeContainer)
                        }, [
                          createVNode(unref(_sfc_main$2Y), { status: "new" }, {
                            default: withCtx(() => [
                              createTextVNode(toDisplayString(getAppliedFilterContent(filter.key)), 1)
                            ]),
                            _: 2
                          }, 1024)
                        ], 2)) : createCommentVNode("", true)
                      ], 10, _hoisted_2$n),
                      createVNode(unref(_sfc_main$2q), {
                        id: `${filter.key}Collapsible`,
                        open: filterIsOpen(filter)
                      }, {
                        default: withCtx(() => [
                          createElementVNode("div", {
                            class: normalizeClass(unref(styles$1e).FilterNodeContainer)
                          }, [
                            createVNode(unref(_sfc_main$1U), {
                              disabled: !filterIsOpen(filter) || !readyForFocus.value || !open2.value,
                              root: focusNode.value
                            }, {
                              default: withCtx(() => [
                                createElementVNode("div", {
                                  ref_for: true,
                                  ref_key: "focusNode",
                                  ref: focusNode
                                }, [
                                  createVNode(unref(_sfc_main$12), {
                                    vertical: "",
                                    spacing: "tight"
                                  }, {
                                    default: withCtx(() => [
                                      renderSlot(_ctx.$slots, `filter-${filter.key}`),
                                      filter.hideClearButton !== false ? (openBlock(), createBlock(unref(_sfc_main$2F), {
                                        key: 0,
                                        plain: "",
                                        disabled: !hasRemoveHandler(filter.key),
                                        onClick: ($event) => removeHandler(filter.key),
                                        accessibilityLabel: unref(i18n).translate("Polaris.Filters.clearLabel", { filterName: filter.label })
                                      }, {
                                        default: withCtx(() => [
                                          createTextVNode(toDisplayString(unref(i18n).translate("Polaris.Filters.clear")), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["disabled", "onClick", "accessibilityLabel"])) : createCommentVNode("", true)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ], 512)
                              ]),
                              _: 2
                            }, 1032, ["disabled", "root"])
                          ], 2)
                        ]),
                        _: 2
                      }, 1032, ["id", "open"])
                    ], 2);
                  }), 128))
                ]),
                _: 3
              }, 8, ["class"]),
              createElementVNode("div", {
                class: normalizeClass(unref(filtersDesktopFooterClassname))
              }, [
                createVNode(unref(_sfc_main$2F), {
                  onClick: handleClearAll,
                  disabled: unref(hasAppliedFilters)
                }, {
                  default: withCtx(() => [
                    createTextVNode(toDisplayString(unref(i18n).translate("Polaris.Filters.clearAllFilters")), 1)
                  ]),
                  _: 1
                }, 8, ["disabled"]),
                createElementVNode("div", {
                  ref_key: "moreFiltersDoneButtonContainer",
                  ref: moreFiltersDoneButtonContainer
                }, [
                  createVNode(unref(_sfc_main$2F), {
                    onClick: closeFilters,
                    primary: ""
                  }, {
                    default: withCtx(() => [
                      createTextVNode(toDisplayString(unref(i18n).translate("Polaris.Filters.done")), 1)
                    ]),
                    _: 1
                  })
                ], 512)
              ], 2)
            ], 2)
          ]),
          _: 3
        }, 8, ["accessibilityLabel", "open"])),
        !__props.hideTags ? (openBlock(), createBlock(unref(_sfc_main$1W), {
          key: 2,
          hidden: unref(shouldHideTagsContainer)
        }, {
          default: withCtx(() => [
            createElementVNode("div", {
              class: normalizeClass(unref(styles$1e).TagsContainer),
              "aria-live": "polite"
            }, [
              __props.appliedFilters && __props.appliedFilters.length ? (openBlock(true), createElementBlock(Fragment, { key: 0 }, renderList(__props.appliedFilters, (filter) => {
                return openBlock(), createBlock(unref(_sfc_main$e), {
                  key: filter.key,
                  disabled: __props.disabled,
                  onRemove: () => {
                    filter.onRemove(filter.key);
                  }
                }, {
                  default: withCtx(() => [
                    createTextVNode(toDisplayString(filter.label), 1)
                  ]),
                  _: 2
                }, 1032, ["disabled", "onRemove"]);
              }), 128)) : createCommentVNode("", true)
            ], 2)
          ]),
          _: 1
        }, 8, ["hidden"])) : createCommentVNode("", true),
        unref(hasSlot)(unref(slots)["help-text"]) || __props.helpText ? (openBlock(), createElementBlock("div", {
          key: 3,
          id: "FiltersHelpText",
          class: normalizeClass(unref(styles$1e).HelpText)
        }, [
          createVNode(unref(Text), {
            variant: "bodyMd",
            color: "subdued",
            as: "span"
          }, {
            default: withCtx(() => [
              unref(hasSlot)(unref(slots)["help-text"]) ? renderSlot(_ctx.$slots, "help-text", { key: 0 }) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
                createTextVNode(toDisplayString(__props.helpText), 1)
              ], 64))
            ]),
            _: 3
          })
        ], 2)) : createCommentVNode("", true),
        open2.value ? (openBlock(), createElementBlock(Fragment, { key: 4 }, [
          createVNode(unref(_sfc_main$z)),
          createElementVNode("div", {
            class: normalizeClass(unref(styles$1e).Backdrop),
            onClick: closeFilters
          }, null, 2)
        ], 64)) : createCommentVNode("", true),
        createVNode(unref(_sfc_main$3p), {
          keyCode: unref(Key).Escape,
          handler: closeFilters
        }, null, 8, ["keyCode"])
      ], 2);
    };
  }
});
const __default__$4 = {
  inheritAttrs: false
};
const _sfc_main$1U = /* @__PURE__ */ defineComponent(__spreadProps(__spreadValues({}, __default__$4), {
  props: {
    disabled: { type: Boolean },
    root: null
  },
  setup(__props) {
    const props = __props;
    const focusNode = () => {
      if (!props.disabled && props.root && !props.root.querySelector("[autofocus]")) {
        focusFirstFocusableNode(props.root, false);
      }
    };
    watch([
      () => props.disabled,
      () => props.root
    ], () => focusNode());
    onMounted(() => {
      focusNode();
    });
    return (_ctx, _cache) => {
      return renderSlot(_ctx.$slots, "default");
    };
  }
}));
const FooterHelp = "Polaris-FooterHelp";
const Text$3 = "Polaris-FooterHelp__Text";
var styles$1c = {
  FooterHelp,
  Text: Text$3
};
var FooterHelp_vue_vue_type_style_index_0_lang = "";
const _sfc_main$1T = /* @__PURE__ */ defineComponent({
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(unref(styles$1c).FooterHelp)
      }, [
        createElementVNode("div", {
          class: normalizeClass(unref(styles$1c).Text)
        }, [
          renderSlot(_ctx.$slots, "default")
        ], 2)
      ], 2);
    };
  }
});
const _hoisted_1$L = ["acceptCharset", "action", "encType", "method", "name", "noValidate", "target", "autocomplete"];
const _hoisted_2$m = /* @__PURE__ */ createElementVNode("button", {
  type: "submit",
  "aria-hidden": "true",
  tabIndex: "-1"
}, "Submit", -1);
const _sfc_main$1S = /* @__PURE__ */ defineComponent({
  props: {
    acceptCharset: null,
    action: null,
    autoComplete: { type: Boolean },
    encType: null,
    implicitSubmit: { type: Boolean, default: true },
    method: { default: "post" },
    name: null,
    noValidate: { type: Boolean },
    preventDefault: { type: Boolean, default: true },
    target: null
  },
  emits: ["submit"],
  setup(__props, { emit }) {
    const props = __props;
    const autoCompleteInputs = computed(() => {
      if (typeof props.autoComplete === "undefined") {
        return void 0;
      }
      return props.autoComplete ? "on" : "off";
    });
    const submitHandle = (e) => {
      if (props.preventDefault) {
        e.preventDefault();
      }
      emit("submit", e);
    };
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("form", {
        acceptCharset: __props.acceptCharset || void 0,
        action: __props.action,
        encType: __props.encType,
        method: __props.method,
        name: __props.name,
        noValidate: __props.noValidate,
        target: __props.target,
        autocomplete: unref(autoCompleteInputs),
        onSubmit: submitHandle
      }, [
        __props.implicitSubmit ? (openBlock(), createBlock(unref(Text), {
          key: 0,
          variant: "bodySm",
          as: "span",
          "visually-hidden": ""
        }, {
          default: withCtx(() => [
            _hoisted_2$m
          ]),
          _: 1
        })) : createCommentVNode("", true),
        renderSlot(_ctx.$slots, "default")
      ], 40, _hoisted_1$L);
    };
  }
});
const FormLayout = "Polaris-FormLayout";
const Title$4 = "Polaris-FormLayout__Title";
const Items = "Polaris-FormLayout__Items";
const Item$4 = "Polaris-FormLayout__Item";
const grouped = "Polaris-FormLayout--grouped";
const condensed$1 = "Polaris-FormLayout--condensed";
var styles$1b = {
  FormLayout,
  Title: Title$4,
  Items,
  Item: Item$4,
  grouped,
  condensed: condensed$1
};
const _sfc_main$1R = /* @__PURE__ */ defineComponent({
  setup(__props) {
    return (_ctx, _cache) => {
      return _ctx.$slots.default ? (openBlock(), createElementBlock("div", {
        key: 0,
        class: normalizeClass(unref(styles$1b).Item)
      }, [
        renderSlot(_ctx.$slots, "default")
      ], 2)) : createCommentVNode("", true);
    };
  }
});
const _sfc_main$1Q = /* @__PURE__ */ defineComponent({
  props: {
    condensed: { type: Boolean },
    helpText: null,
    title: null
  },
  setup(__props, { expose }) {
    const props = __props;
    const slots = useSlots();
    const { useUniqueId } = UseUniqueId();
    const id = useUniqueId("FormLayoutGroup");
    const helpTextId = `${id}HelpText`;
    const titleId = `${id}Title`;
    expose({ name: "FormGroup" });
    const className = computed(() => {
      return classNames(props.condensed ? styles$1b.condensed : styles$1b.grouped);
    });
    const slotsElms = computed(() => {
      let elms = [];
      if (slots.default) {
        const groups = slots.default().map((group) => {
          return extractElement(group);
        });
        elms = groups.flat();
      }
      return elms;
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        role: "group",
        class: normalizeClass(unref(className)),
        "aria-labelledby": titleId,
        "aria-describedby": helpTextId
      }, [
        unref(slots).title || __props.title ? (openBlock(), createElementBlock("div", {
          key: 0,
          id: titleId,
          class: normalizeClass(unref(styles$1b).Title)
        }, [
          unref(slots).title ? renderSlot(_ctx.$slots, "title", { key: 0 }) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
            createTextVNode(toDisplayString(__props.title), 1)
          ], 64))
        ], 2)) : createCommentVNode("", true),
        createElementVNode("div", {
          class: normalizeClass(unref(styles$1b).Items)
        }, [
          unref(slots).default && unref(hasSlot)(unref(slots).default) ? (openBlock(true), createElementBlock(Fragment, { key: 0 }, renderList(unref(slotsElms), (item, index) => {
            return openBlock(), createBlock(unref(_sfc_main$1R), { key: index }, {
              default: withCtx(() => [
                (openBlock(), createBlock(resolveDynamicComponent(item)))
              ]),
              _: 2
            }, 1024);
          }), 128)) : renderSlot(_ctx.$slots, "default", { key: 1 })
        ], 2),
        unref(slots)["help-text"] || __props.helpText ? (openBlock(), createBlock(unref(_sfc_main$2V), {
          key: 1,
          id: helpTextId,
          color: "text-subdued",
          paddingBlockStart: "2",
          paddingInlineStart: "5",
          paddingBlockEnd: "0",
          paddingInlineEnd: "5"
        }, {
          default: withCtx(() => [
            unref(slots)["help-text"] ? renderSlot(_ctx.$slots, "help-text", { key: 0 }) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
              createTextVNode(toDisplayString(__props.helpText), 1)
            ], 64))
          ]),
          _: 3
        })) : createCommentVNode("", true)
      ], 2);
    };
  }
});
var FormLayout_vue_vue_type_style_index_0_lang = "";
const _sfc_main$1P = /* @__PURE__ */ defineComponent({
  props: {
    noItemWrap: { type: Boolean, default: false }
  },
  setup(__props) {
    const itemRefs = ref([]);
    const itemGroupIndexes = ref([]);
    const slots = useSlots();
    const slotsElms = computed(() => {
      let elms = [];
      if (slots.default) {
        const groups = slots.default().map((group) => {
          return extractElement(group);
        });
        elms = groups.flat();
      }
      return elms;
    });
    onBeforeUpdate(() => {
      itemRefs.value = [];
    });
    onMounted(() => {
      itemRefs.value.forEach((item) => {
        itemGroupIndexes.value.push(item.name === "FormGroup");
      });
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(unref(styles$1b).FormLayout)
      }, [
        !__props.noItemWrap && unref(slotsElms).length ? (openBlock(true), createElementBlock(Fragment, { key: 0 }, renderList(unref(slotsElms), (item, index) => {
          return openBlock(), createElementBlock(Fragment, null, [
            !itemGroupIndexes.value[index] ? (openBlock(), createBlock(unref(_sfc_main$1R), { key: index }, {
              default: withCtx(() => [
                (openBlock(), createBlock(resolveDynamicComponent(item), {
                  ref_for: true,
                  ref: (el) => {
                    itemRefs.value[index] = el;
                  }
                }, null, 512))
              ]),
              _: 2
            }, 1024)) : (openBlock(), createBlock(resolveDynamicComponent(item), {
              key: 1,
              ref_for: true,
              ref: (el) => {
                itemRefs.value[index] = el;
              }
            }, null, 512))
          ], 64);
        }), 256)) : renderSlot(_ctx.$slots, "default", { key: 1 })
      ], 2);
    };
  }
});
function setRootProperty(name, value2, node) {
  if (!document)
    return;
  const element = node || document.documentElement;
  element.style.setProperty(name, value2);
}
const Frame = "Polaris-Frame";
const Navigation$2 = "Polaris-Frame__Navigation";
const hasTopBar = "Polaris-Frame--hasTopBar";
const NavigationDismiss = "Polaris-Frame__NavigationDismiss";
const TopBar$1 = "Polaris-Frame__TopBar";
const ContextualSaveBar$1 = "Polaris-Frame__ContextualSaveBar";
const Main = "Polaris-Frame__Main";
const hasNav = "Polaris-Frame--hasNav";
const Content$5 = "Polaris-Frame__Content";
const GlobalRibbonContainer = "Polaris-Frame__GlobalRibbonContainer";
const LoadingBar = "Polaris-Frame__LoadingBar";
const Skip = "Polaris-Frame__Skip";
const focused$4 = "Polaris-Frame--focused";
const pressed = "Polaris-Frame--pressed";
var styles$1a = {
  Frame,
  Navigation: Navigation$2,
  hasTopBar,
  "Navigation-enter": "Polaris-Frame__Navigation--enter",
  "Navigation-enterActive": "Polaris-Frame__Navigation--enterActive",
  "Navigation-exit": "Polaris-Frame__Navigation--exit",
  "Navigation-exitActive": "Polaris-Frame__Navigation--exitActive",
  NavigationDismiss,
  "Navigation-visible": "Polaris-Frame__Navigation--visible",
  TopBar: TopBar$1,
  ContextualSaveBar: ContextualSaveBar$1,
  Main,
  hasNav,
  Content: Content$5,
  GlobalRibbonContainer,
  LoadingBar,
  Skip,
  focused: focused$4,
  pressed
};
const _hoisted_1$K = {
  viewBox: "0 0 20 20",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$l = /* @__PURE__ */ createElementVNode("path", { d: "m11.414 10 6.293-6.293a1 1 0 1 0-1.414-1.414L10 8.586 3.707 2.293a1 1 0 0 0-1.414 1.414L8.586 10l-6.293 6.293a1 1 0 1 0 1.414 1.414L10 11.414l6.293 6.293A.998.998 0 0 0 18 17a.999.999 0 0 0-.293-.707L11.414 10z" }, null, -1);
const _hoisted_3$c = [
  _hoisted_2$l
];
function render$4(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1$K, _hoisted_3$c);
}
var MobileCancelMajor = { render: render$4 };
const startFade = "Polaris-Frame-CssAnimation--startFade";
const endFade = "Polaris-Frame-CssAnimation--endFade";
var styles$19 = {
  startFade,
  endFade
};
var CssAnimation_vue_vue_type_style_index_0_lang = "";
const _sfc_main$1O = /* @__PURE__ */ defineComponent({
  props: {
    in: { type: Boolean },
    type: null
  },
  setup(__props) {
    const props = __props;
    const TransitionStatus2 = {
      Entering: "entering",
      Entered: "entered",
      Exiting: "exiting",
      Exited: "exited"
    };
    const frameCssAnimationRef = ref(null);
    const transitionStatus = ref(props.in ? TransitionStatus2.Entering : TransitionStatus2.Exited);
    const wrapperClassName = computed(() => classNames(styles$19[variationName("start", props.type)], props.in && styles$19[variationName("end", props.type)]));
    watch(() => transitionStatus.value, () => {
      transitionStatus.value === TransitionStatus2.Entering && changeTransitionStatus(TransitionStatus2.Entered);
    });
    watch(() => props.in, () => {
      props.in && changeTransitionStatus(TransitionStatus2.Entering);
      !props.in && changeTransitionStatus(TransitionStatus2.Exiting);
    });
    const handleTransitionEnd = () => {
      transitionStatus.value === TransitionStatus2.Exiting && changeTransitionStatus(TransitionStatus2.Exited);
    };
    const changeTransitionStatus = (transitionStatusNew) => {
      transitionStatus.value = transitionStatusNew;
      if (transitionStatusNew === TransitionStatus2.Entering) {
        frameCssAnimationRef.value && frameCssAnimationRef.value.getBoundingClientRect();
      }
    };
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(unref(wrapperClassName)),
        ref_key: "frameCssAnimationRef",
        ref: frameCssAnimationRef,
        onTransitionend: handleTransitionEnd
      }, [
        transitionStatus.value !== TransitionStatus2.Exited || props.in ? renderSlot(_ctx.$slots, "default", { key: 0 }) : createCommentVNode("", true)
      ], 34);
    };
  }
});
function isObject(value2) {
  const type = typeof value2;
  return value2 != null && (type === "object" || type === "function");
}
function pluckDeep(obj, key) {
  if (!obj) {
    return null;
  }
  const keys = Object.keys(obj);
  for (const currKey of keys) {
    if (currKey === key) {
      return obj[key];
    }
    if (isObject(obj[currKey])) {
      const plucked = pluckDeep(obj[currKey], key);
      if (plucked) {
        return plucked;
      }
    }
  }
  return null;
}
function getWidth(value2 = {}, defaultWidth = 0, key = "width") {
  const width = typeof value2 === "number" ? value2 : pluckDeep(value2, key);
  return width ? `${width}px` : `${defaultWidth}px`;
}
const ContextualSaveBar = "Polaris-Frame-ContextualSaveBar";
const LogoContainer$2 = "Polaris-Frame-ContextualSaveBar__LogoContainer";
const ContextControl$2 = "Polaris-Frame-ContextualSaveBar__ContextControl";
const Contents$1 = "Polaris-Frame-ContextualSaveBar__Contents";
const fullWidth$2 = "Polaris-Frame-ContextualSaveBar--fullWidth";
const ActionContainer$1 = "Polaris-Frame-ContextualSaveBar__ActionContainer";
const Action$6 = "Polaris-Frame-ContextualSaveBar__Action";
var styles$18 = {
  ContextualSaveBar,
  LogoContainer: LogoContainer$2,
  ContextControl: ContextControl$2,
  Contents: Contents$1,
  fullWidth: fullWidth$2,
  ActionContainer: ActionContainer$1,
  Action: Action$6
};
const _sfc_main$1N = /* @__PURE__ */ defineComponent({
  props: {
    open: { type: Boolean }
  },
  emits: ["discard", "cancel"],
  setup(__props, { emit: emits }) {
    const i18n = UseI18n();
    const message = i18n.translate("Polaris.DiscardConfirmationModal.message");
    const title = i18n.translate("Polaris.DiscardConfirmationModal.title");
    const primaryActionMsg = i18n.translate("Polaris.DiscardConfirmationModal.primaryAction");
    const secondaryActionMsg = i18n.translate("Polaris.DiscardConfirmationModal.secondaryAction");
    const onDiscard = () => {
      emits("discard");
    };
    const onCancel = () => {
      emits("cancel");
    };
    return (_ctx, _cache) => {
      return openBlock(), createBlock(unref(_sfc_main$$), {
        open: __props.open,
        onClose: onCancel,
        primaryAction: { content: unref(primaryActionMsg), destructive: true, onAction: onDiscard },
        secondaryActions: [{ content: unref(secondaryActionMsg), onAction: onCancel }],
        sectioned: ""
      }, {
        title: withCtx(() => [
          createTextVNode(toDisplayString(unref(title)), 1)
        ]),
        content: withCtx(() => [
          createTextVNode(toDisplayString(unref(message)), 1)
        ]),
        _: 1
      }, 8, ["open", "primaryAction", "secondaryActions"]);
    };
  }
});
var ContextualSaveBar_vue_vue_type_style_index_0_lang = "";
const _hoisted_1$J = /* @__PURE__ */ createElementVNode("span", null, "\xA0", -1);
const _sfc_main$1M = /* @__PURE__ */ defineComponent({
  props: {
    alignContentFlush: { type: Boolean },
    message: null,
    saveAction: null,
    discardAction: null,
    fullWidth: { type: Boolean }
  },
  setup(__props) {
    const props = __props;
    const i18n = UseI18n();
    const slots = useSlots();
    const contentsClassName = computed(() => {
      return classNames(styles$18.Contents, props.fullWidth && styles$18.fullWidth);
    });
    const saveLang = i18n.translate("Polaris.ContextualSaveBar.save");
    const discardLang = i18n.translate("Polaris.ContextualSaveBar.discard");
    const { useFrame } = UseFrame();
    const { logo } = useFrame();
    const width = getWidth(logo, 104);
    const discardConfirmationModalVisible = ref(false);
    const handleSaveAction = (e) => {
      var _a;
      ((_a = props.saveAction) == null ? void 0 : _a.onAction) && props.saveAction.onAction();
    };
    const toggleDiscardConfirmationModal = () => {
      discardConfirmationModalVisible.value = !discardConfirmationModalVisible.value;
    };
    const closeDiscardConfirmationModal = () => {
      discardConfirmationModalVisible.value = false;
    };
    const discardActionHandler = () => {
      if (props.discardAction) {
        if (props.discardAction.discardConfirmationModal) {
          toggleDiscardConfirmationModal();
        } else {
          props.discardAction.onAction && props.discardAction.onAction();
        }
      }
    };
    const handleDiscardAction = () => {
      if (props.discardAction && props.discardAction.onAction) {
        props.discardAction.onAction();
      }
      closeDiscardConfirmationModal();
    };
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock(Fragment, null, [
        createElementVNode("div", {
          class: normalizeClass(unref(styles$18).ContextualSaveBar)
        }, [
          unref(slots).contextControl ? (openBlock(), createElementBlock("div", {
            key: 0,
            class: normalizeClass(unref(styles$18).ContextControl)
          }, [
            renderSlot(_ctx.$slots, "contextControl")
          ], 2)) : createCommentVNode("", true),
          !__props.alignContentFlush && !unref(slots).contextControl ? (openBlock(), createElementBlock("div", {
            key: 1,
            class: normalizeClass(unref(styles$18).LogoContainer),
            style: normalizeStyle(unref(width))
          }, [
            unref(logo) ? (openBlock(), createBlock(unref(_sfc_main$1D), {
              key: 0,
              style: normalizeStyle({ width: unref(width) }),
              source: unref(logo).contextualSaveBarSource || "",
              alt: ""
            }, null, 8, ["style", "source"])) : createCommentVNode("", true)
          ], 6)) : createCommentVNode("", true),
          createElementVNode("div", {
            class: normalizeClass(unref(contentsClassName))
          }, [
            createVNode(unref(Text), {
              as: "h2",
              variant: "headingMd",
              color: "text-inverse",
              truncate: ""
            }, {
              default: withCtx(() => [
                createTextVNode(toDisplayString(__props.message), 1)
              ]),
              _: 1
            }),
            createElementVNode("div", {
              class: normalizeClass(unref(styles$18).ActionContainer)
            }, [
              createVNode(unref(_sfc_main$12), {
                spacing: "tight",
                wrap: false
              }, {
                default: withCtx(() => [
                  renderSlot(_ctx.$slots, "secondaryMenu", {}, () => [
                    _hoisted_1$J
                  ]),
                  __props.discardAction ? (openBlock(), createBlock(unref(_sfc_main$2F), {
                    key: 0,
                    url: __props.discardAction.url,
                    loading: __props.discardAction.loading,
                    disabled: __props.discardAction.disabled,
                    accessibilityLabel: __props.discardAction.content,
                    onClick: discardActionHandler
                  }, {
                    default: withCtx(() => [
                      __props.discardAction.content ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
                        createTextVNode(toDisplayString(__props.discardAction.content), 1)
                      ], 64)) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
                        createTextVNode(toDisplayString(unref(discardLang)), 1)
                      ], 64))
                    ]),
                    _: 1
                  }, 8, ["url", "loading", "disabled", "accessibilityLabel"])) : createCommentVNode("", true),
                  __props.saveAction ? (openBlock(), createBlock(unref(_sfc_main$2F), {
                    key: 1,
                    primary: "",
                    url: __props.saveAction.url,
                    loading: __props.saveAction.loading,
                    disabled: __props.saveAction.disabled,
                    accessibilityLabel: __props.saveAction.content,
                    onClick: handleSaveAction
                  }, {
                    default: withCtx(() => [
                      __props.saveAction.content ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
                        createTextVNode(toDisplayString(__props.saveAction.content), 1)
                      ], 64)) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
                        createTextVNode(toDisplayString(unref(saveLang)), 1)
                      ], 64))
                    ]),
                    _: 1
                  }, 8, ["url", "loading", "disabled", "accessibilityLabel"])) : createCommentVNode("", true)
                ]),
                _: 3
              })
            ], 2)
          ], 2)
        ], 2),
        __props.discardAction && __props.discardAction.onAction && __props.discardAction.discardConfirmationModal ? (openBlock(), createBlock(unref(_sfc_main$1N), {
          key: 0,
          open: discardConfirmationModalVisible.value,
          onCancel: toggleDiscardConfirmationModal,
          onDiscard: handleDiscardAction
        }, null, 8, ["open"])) : createCommentVNode("", true)
      ], 64);
    };
  }
});
const Loading$1 = "Polaris-Frame-Loading";
const Level = "Polaris-Frame-Loading__Level";
var styles$17 = {
  Loading: Loading$1,
  Level
};
var Loading_vue_vue_type_style_index_0_lang$1 = "";
const _hoisted_1$I = ["aria-valuenow", "aria-label"];
const _sfc_main$1L = /* @__PURE__ */ defineComponent({
  setup(__props) {
    const STUCK_THRESHOLD = 99;
    const i18n = UseI18n();
    const progress = ref(0);
    const animating = ref(false);
    const customStyles = computed(() => {
      return {
        transform: `scaleX(${Math.floor(progress.value) / 100})`
      };
    });
    onMounted(() => {
      requestAnimation();
    });
    watch(() => [animating.value, progress.value], () => {
      requestAnimation();
    });
    const requestAnimation = () => {
      if (progress.value >= STUCK_THRESHOLD || animating.value) {
        return;
      }
      requestAnimationFrame(() => {
        const step = Math.max((STUCK_THRESHOLD - progress.value) / 10, 1);
        animating.value = true;
        progress.value = progress.value + step;
      });
    };
    const onTransitionEnd = () => {
      animating.value = false;
    };
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(unref(styles$17).Loading),
        "aria-valuenow": progress.value,
        "aria-valuemin": 0,
        "aria-valuemax": 100,
        role: "progressbar",
        "aria-label": unref(i18n).translate("Polaris.Loading.label")
      }, [
        createElementVNode("div", {
          class: normalizeClass(unref(styles$17).Level),
          style: normalizeStyle(unref(customStyles)),
          onTransitionend: onTransitionEnd
        }, null, 38)
      ], 10, _hoisted_1$I);
    };
  }
});
const Toast = "Polaris-Frame-Toast";
const Action$5 = "Polaris-Frame-Toast__Action";
const error$3 = "Polaris-Frame-Toast--error";
const CloseButton$1 = "Polaris-Frame-Toast__CloseButton";
var styles$16 = {
  Toast,
  Action: Action$5,
  error: error$3,
  CloseButton: CloseButton$1
};
var Toast_vue_vue_type_style_index_0_lang = "";
const _sfc_main$1K = /* @__PURE__ */ defineComponent({
  props: {
    content: null,
    duration: null,
    error: { type: Boolean },
    action: null
  },
  emits: ["dismiss"],
  setup(__props, { emit: emits }) {
    const props = __props;
    const DEFAULT_TOAST_DURATION = 5e3;
    const DEFAULT_TOAST_DURATION_WITH_ACTION = 1e4;
    const timer = ref();
    const className = computed(() => classNames(styles$16.Toast, props.error && styles$16.error));
    onMounted(() => {
      let timeoutDuration = props.duration || DEFAULT_TOAST_DURATION;
      if (props.action && !props.duration) {
        timeoutDuration = DEFAULT_TOAST_DURATION_WITH_ACTION;
      } else if (props.action && props.duration && props.duration < DEFAULT_TOAST_DURATION_WITH_ACTION) {
        console.log("Toast with action should persist for at least 10,000 milliseconds to give the merchant enough time to act on it.");
      }
      timer.value = setTimeout(onDismiss, timeoutDuration);
    });
    onBeforeUnmount(() => {
      clearTimeout(timer.value);
    });
    const onDismiss = () => {
      emits("dismiss");
    };
    const handleAction = (e) => {
      var _a;
      ((_a = props.action) == null ? void 0 : _a.onAction) && props.action.onAction();
    };
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(unref(className))
      }, [
        createVNode(unref(_sfc_main$3p), {
          keyCode: unref(Key).Escape,
          handler: onDismiss
        }, null, 8, ["keyCode"]),
        createVNode(unref(_sfc_main$1r), { "block-align": "center" }, {
          default: withCtx(() => [
            createVNode(unref(Text), {
              as: "span",
              variant: "bodyMd",
              fontWeight: "medium"
            }, {
              default: withCtx(() => [
                createTextVNode(toDisplayString(__props.content), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        renderSlot(_ctx.$slots, "default"),
        __props.action ? (openBlock(), createElementBlock("div", {
          key: 0,
          class: normalizeClass(unref(styles$16).Action)
        }, [
          createVNode(unref(_sfc_main$2F), {
            plain: "",
            monochrome: "",
            onClick: handleAction
          }, {
            default: withCtx(() => [
              createTextVNode(toDisplayString(__props.action.content), 1)
            ]),
            _: 1
          })
        ], 2)) : createCommentVNode("", true),
        createElementVNode("button", {
          type: "button",
          class: normalizeClass(unref(styles$16).CloseButton),
          onClick: onDismiss
        }, [
          createVNode(unref(_sfc_main$2K), { source: unref(MobileCancelMajor) }, null, 8, ["source"])
        ], 2)
      ], 2);
    };
  }
});
const ToastManager = "Polaris-Frame-ToastManager";
const ToastWrapper = "Polaris-Frame-ToastManager__ToastWrapper";
var styles$15 = {
  ToastManager,
  ToastWrapper,
  "ToastWrapper-enter": "Polaris-Frame-ToastManager__ToastWrapper--enter",
  "ToastWrapper-exit": "Polaris-Frame-ToastManager__ToastWrapper--exit",
  "ToastWrapper-enter-done": "Polaris-Frame-ToastManager--toastWrapperEnterDone"
};
var ToastManager_vue_vue_type_style_index_0_lang = "";
const _sfc_main$1J = /* @__PURE__ */ defineComponent({
  props: {
    toastMessages: null
  },
  setup(__props) {
    const props = __props;
    const TOAST_ANIMATION_DURATION = 400;
    const toastRefs = ref([]);
    const isMounted = ref(false);
    const updateToasts = () => {
      let targetInPos = 0;
      props.toastMessages.forEach((_, index) => {
        const currentToast = toastRefs.value[index];
        if (!currentToast) {
          return;
        }
        targetInPos += currentToast.clientHeight;
        currentToast.style.setProperty("--pc-toast-manager-translate-y-in", `-${targetInPos}px`);
        currentToast.style.setProperty("--pc-toast-manager-translate-y-out", `${-targetInPos + 150}px`);
      });
    };
    const onAfterEnter = (el) => {
      el.classList.add(toastClasses.enterDone);
    };
    const onBeforeEnter = (el) => {
      el.classList.add(toastClasses.enter);
    };
    const onEnter = (el, done) => {
      el.classList.remove(toastClasses.enter);
      el.classList.add(toastClasses.enterDone);
      setTimeout(done, TOAST_ANIMATION_DURATION);
    };
    const onLeave = (el, done) => {
      el.classList.remove(toastClasses.enterDone);
      el.classList.add(toastClasses.exit);
      setTimeout(done, TOAST_ANIMATION_DURATION);
    };
    watch(() => props.toastMessages, () => {
      setTimeout(updateToasts, 0);
    });
    onMounted(() => {
      isMounted.value = true;
    });
    const toastClasses = {
      enter: classNames(styles$15["ToastWrapper-enter"]),
      enterDone: classNames(styles$15["ToastWrapper-enter-done"]),
      exit: classNames(styles$15["ToastWrapper-exit"])
    };
    return (_ctx, _cache) => {
      return isMounted.value ? (openBlock(), createBlock(unref(_sfc_main$2M), { key: 0 }, {
        default: withCtx(() => [
          createVNode(unref(_sfc_main$33), {
            event: "resize",
            handler: updateToasts
          }),
          createElementVNode("div", {
            class: normalizeClass(unref(styles$15).ToastManager),
            "aria-live": "assertive"
          }, [
            createVNode(TransitionGroup, {
              name: "custom-classes",
              onAfterEnter,
              onBeforeEnter,
              onEnter,
              onLeave
            }, {
              default: withCtx(() => [
                __props.toastMessages.length > 0 ? (openBlock(true), createElementBlock(Fragment, { key: 0 }, renderList(__props.toastMessages, (toast, index) => {
                  return openBlock(), createElementBlock("div", {
                    key: toast.id,
                    ref_for: true,
                    ref: (el) => {
                      toastRefs.value[index] = el;
                    },
                    class: normalizeClass(unref(styles$15).ToastWrapper)
                  }, [
                    createVNode(unref(_sfc_main$1K), normalizeProps(guardReactiveProps(toast)), null, 16)
                  ], 2);
                }), 128)) : createCommentVNode("", true)
              ]),
              _: 1
            })
          ], 2)
        ]),
        _: 1
      })) : createCommentVNode("", true);
    };
  }
});
var Frame_vue_vue_type_style_index_0_lang = "";
const _hoisted_1$H = ["data-has-navigation"];
const _hoisted_2$k = ["href"];
const _hoisted_3$b = ["aria-label", "hidden"];
const _hoisted_4$6 = ["aria-hidden", "aria-label", "tabIndex"];
const _hoisted_5$2 = ["data-has-global-ribbon"];
const _sfc_main$1I = /* @__PURE__ */ defineComponent({
  props: {
    logo: null,
    offset: null,
    showMobileNavigation: { type: Boolean },
    skipToContentTarget: null
  },
  emits: ["navigation-dismiss"],
  setup(__props, { emit: emits }) {
    const props = __props;
    const APP_FRAME_MAIN = "AppFrameMain";
    const APP_FRAME_NAV = "AppFrameNav";
    const APP_FRAME_TOP_BAR = "AppFrameTopBar";
    const APP_FRAME_LOADING_BAR = "AppFrameLoadingBar";
    const CONTEXTUALSAVEBAR_FADE_DURATION = parseInt(motion["duration-400"], 10);
    const NAVIGATION_ANIMATION_DURATION = parseInt(motion["duration-300"], 10);
    const slots = useSlots();
    const i18n = UseI18n();
    const skipFocused = ref(false);
    const globalRibbonHeight = ref(0);
    const loadingStack = ref(0);
    const toastMessages = ref([]);
    const showContextualSaveBar = ref(false);
    const contextualSaveBar = ref(null);
    const contextualSaveBarSlots = ref({});
    const navigationRef = ref(null);
    const { useMediaQuery } = UseMediaQuery();
    const { isNavigationCollapsed } = useMediaQuery();
    const globalRibbonContainerRef = ref(null);
    const setGlobalRibbonHeight = () => {
      if (globalRibbonContainerRef.value) {
        globalRibbonHeight.value = globalRibbonContainerRef.value.offsetHeight;
        setGlobalRibbonRootProperty();
      }
    };
    const navClassName = computed(() => {
      return classNames(styles$1a.Navigation, props.showMobileNavigation && styles$1a["Navigation-visible"]);
    });
    const navTransitionClasses = {
      enter: classNames(styles$1a["Navigation-enter"]),
      enterActive: classNames(styles$1a["Navigation-enterActive"]),
      enterDone: classNames(styles$1a["Navigation-enterActive"]),
      exit: classNames(styles$1a["Navigation-exit"]),
      exitActive: classNames(styles$1a["Navigation-exitActive"])
    };
    const onTransitionAfterEnter = (el) => {
      el.classList.add(navTransitionClasses.enterDone);
    };
    const onTransitionBeforeEnter = (el) => {
      el.classList.add(navTransitionClasses.enter);
    };
    const onTransitionEnter = (el, done) => {
      el.classList.remove(navTransitionClasses.enter);
      el.classList.add(navTransitionClasses.enterDone);
      setTimeout(done, NAVIGATION_ANIMATION_DURATION);
    };
    const onTransitionBeforeLeave = (el) => {
      el.classList.remove(navTransitionClasses.enterActive);
      el.classList.add(navTransitionClasses.exitActive);
    };
    const onTransitionLeave = (el, done) => {
      el.classList.add(navTransitionClasses.exit);
      setTimeout(done, NAVIGATION_ANIMATION_DURATION);
    };
    const mobileNavHidden = computed(() => isNavigationCollapsed && !props.showMobileNavigation);
    const mobileNavShowing = computed(() => isNavigationCollapsed && props.showMobileNavigation);
    const tabIndex = mobileNavShowing.value ? 0 : -1;
    const mobileNavAttributes = __spreadValues({}, mobileNavShowing.value && {
      "aria-modal": true,
      role: "dialog"
    });
    const frameClassName = computed(() => {
      return classNames(styles$1a.Frame, slots.navigation && styles$1a.hasNav, slots.topBar && styles$1a.hasTopBar);
    });
    const skipClassName = computed(() => {
      return classNames(styles$1a.Skip, skipFocused.value && styles$1a.focused);
    });
    const skipTarget = computed(() => {
      return props.skipToContentTarget ? props.skipToContentTarget.id : APP_FRAME_MAIN;
    });
    onMounted(() => {
      handleResize();
      if (slots.globalRibbon) {
        return;
      }
      setGlobalRibbonRootProperty();
      setOffset();
    });
    watch(() => slots.globalRibbon, () => {
      setGlobalRibbonHeight();
      setOffset();
    });
    const setOffset = () => {
      setRootProperty("--pc-frame-offset", props.offset || "0px");
    };
    const setGlobalRibbonRootProperty = () => {
      setRootProperty("--pc-frame-global-ribbon-height", `${globalRibbonHeight.value}px`);
    };
    const showToast = (toast) => {
      const hasToastById = toastMessages.value.find(({ id }) => id === toast.id) != null;
      toastMessages.value = hasToastById ? toastMessages.value : [...toastMessages.value, toast];
    };
    const hideToast = ({ id }) => {
      toastMessages.value = toastMessages.value.filter(({ id: toastId }) => id !== toastId);
    };
    const setContextualSaveBar = (saveBarProps) => {
      const _a = saveBarProps, { contextControl, secondaryMenu } = _a, rest = __objRest(_a, ["contextControl", "secondaryMenu"]);
      contextualSaveBar.value = rest;
      contextualSaveBarSlots.value = { contextControl, secondaryMenu };
      if (!showContextualSaveBar.value) {
        showContextualSaveBar.value = true;
      }
    };
    const removeContextualSaveBar = () => {
      showContextualSaveBar.value = false;
      setTimeout(() => {
        contextualSaveBar.value = null;
      }, CONTEXTUALSAVEBAR_FADE_DURATION);
    };
    const startLoading = () => {
      loadingStack.value = loadingStack.value + 1;
    };
    const stopLoading = () => {
      loadingStack.value = Math.max(0, loadingStack.value - 1);
    };
    const handleResize = () => {
      if (slots.globalRibbon) {
        setGlobalRibbonHeight();
      }
    };
    const handleFocus = () => {
      skipFocused.value = true;
    };
    const handleBlur = () => {
      skipFocused.value = false;
    };
    const handleClick = (event) => {
      if (props.skipToContentTarget) {
        props.skipToContentTarget.focus();
        event.preventDefault();
      }
    };
    const handleNavigationDismiss = () => {
      emits("navigation-dismiss");
    };
    const handleNavKeydown = (event) => {
      const { key } = event;
      const isMobileNavShowing = isNavigationCollapsed && props.showMobileNavigation;
      if (isMobileNavShowing && key === "Escape") {
        handleNavigationDismiss();
      }
    };
    provide("frameContext", {
      logo: props.logo,
      showToast,
      hideToast,
      startLoading,
      stopLoading,
      setContextualSaveBar,
      removeContextualSaveBar
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", mergeProps({ class: unref(frameClassName) }, unref(layer).props, {
        "data-has-navigation": unref(slots).navigation ? true : void 0
      }), [
        createElementVNode("div", {
          class: normalizeClass(unref(skipClassName))
        }, [
          createElementVNode("a", {
            href: `#${unref(skipTarget)}`,
            onFocus: handleFocus,
            onBlur: handleBlur,
            onClick: handleClick
          }, toDisplayString(unref(i18n).translate("Polaris.Frame.skipToContent")), 41, _hoisted_2$k)
        ], 2),
        unref(slots).topBar ? (openBlock(), createElementBlock("div", mergeProps({
          key: 0,
          class: unref(styles$1a).TopBar
        }, __spreadValues(__spreadValues({}, unref(layer).props), unref(dataPolarisTopBar).props), { id: APP_FRAME_TOP_BAR }), [
          renderSlot(_ctx.$slots, "topBar")
        ], 16)) : createCommentVNode("", true),
        unref(slots).navigation ? (openBlock(), createBlock(unref(_sfc_main$17), {
          key: 1,
          trapping: unref(mobileNavShowing)
        }, {
          default: withCtx(() => [
            createVNode(Transition, {
              name: "custom-classes",
              onAfterEnter: onTransitionAfterEnter,
              onBeforeEnter: onTransitionBeforeEnter,
              onEnter: onTransitionEnter,
              onBeforeLeave: onTransitionBeforeLeave,
              onLeave: onTransitionLeave
            }, {
              default: withCtx(() => [
                __props.showMobileNavigation || !unref(isNavigationCollapsed) ? (openBlock(), createElementBlock("div", mergeProps({ key: 0 }, mobileNavAttributes, {
                  key: "NavContent",
                  id: APP_FRAME_NAV,
                  "aria-label": unref(i18n).translate("Polaris.Frame.navigationLabel"),
                  class: unref(navClassName),
                  ref_key: "navigationRef",
                  ref: navigationRef,
                  onKeydown: handleNavKeydown,
                  hidden: unref(mobileNavHidden)
                }), [
                  renderSlot(_ctx.$slots, "navigation"),
                  createElementVNode("button", {
                    type: "button",
                    class: normalizeClass(unref(styles$1a).NavigationDismiss),
                    onClick: handleNavigationDismiss,
                    "aria-hidden": unref(mobileNavHidden) || !unref(isNavigationCollapsed) && !__props.showMobileNavigation,
                    "aria-label": unref(i18n).translate("Polaris.Frame.Navigation.closeMobileNavigationLabel"),
                    tabIndex: unref(tabIndex)
                  }, [
                    createVNode(unref(_sfc_main$2K), { source: unref(MobileCancelMajor) }, null, 8, ["source"])
                  ], 10, _hoisted_4$6)
                ], 16, _hoisted_3$b)) : createCommentVNode("", true)
              ]),
              _: 3
            })
          ]),
          _: 3
        }, 8, ["trapping"])) : createCommentVNode("", true),
        createVNode(unref(_sfc_main$1O), {
          in: showContextualSaveBar.value,
          class: normalizeClass(unref(styles$1a).ContextualSaveBar),
          type: "fade"
        }, {
          default: withCtx(() => [
            contextualSaveBar.value ? (openBlock(), createBlock(unref(_sfc_main$1M), normalizeProps(mergeProps({ key: 0 }, contextualSaveBar.value)), createSlots({ _: 2 }, [
              contextualSaveBarSlots.value.contextControl ? {
                name: "contextControl",
                fn: withCtx(() => [
                  (openBlock(true), createElementBlock(Fragment, null, renderList(contextualSaveBarSlots.value.contextControl, (el, index) => {
                    return openBlock(), createBlock(resolveDynamicComponent(el), { key: index });
                  }), 128))
                ])
              } : void 0,
              contextualSaveBarSlots.value.secondaryMenu ? {
                name: "secondaryMenu",
                fn: withCtx(() => [
                  (openBlock(true), createElementBlock(Fragment, null, renderList(contextualSaveBarSlots.value.secondaryMenu, (el, index) => {
                    return openBlock(), createBlock(resolveDynamicComponent(el), { key: index });
                  }), 128))
                ])
              } : void 0
            ]), 1040)) : createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["in", "class"]),
        loadingStack.value > 0 ? (openBlock(), createElementBlock("div", {
          key: 2,
          class: normalizeClass(unref(styles$1a).LoadingBar),
          id: APP_FRAME_LOADING_BAR
        }, [
          createVNode(unref(_sfc_main$1L))
        ], 2)) : createCommentVNode("", true),
        __props.showMobileNavigation && unref(isNavigationCollapsed) ? (openBlock(), createBlock(unref(_sfc_main$2_), {
          key: 3,
          belowNavigation: "",
          onClick: handleNavigationDismiss,
          onTouchstart: handleNavigationDismiss
        })) : createCommentVNode("", true),
        createElementVNode("main", {
          class: normalizeClass(unref(styles$1a).Main),
          id: APP_FRAME_MAIN,
          "data-has-global-ribbon": !!unref(slots).globalRibbon
        }, [
          createElementVNode("div", {
            class: normalizeClass(unref(styles$1a).Content)
          }, [
            renderSlot(_ctx.$slots, "default")
          ], 2)
        ], 10, _hoisted_5$2),
        createVNode(unref(_sfc_main$1J), { "toast-messages": toastMessages.value }, null, 8, ["toast-messages"]),
        unref(slots).globalRibbon ? (openBlock(), createElementBlock("div", {
          key: 4,
          class: normalizeClass(unref(styles$1a).GlobalRibbonContainer),
          ref_key: "globalRibbonContainerRef",
          ref: globalRibbonContainerRef
        }, [
          renderSlot(_ctx.$slots, "globalRibbon")
        ], 2)) : createCommentVNode("", true),
        createVNode(unref(_sfc_main$33), {
          event: "resize",
          handler: handleResize
        })
      ], 16, _hoisted_1$H);
    };
  }
});
const _hoisted_1$G = {
  viewBox: "0 0 20 20",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$j = /* @__PURE__ */ createElementVNode("path", { d: "M7.703 13.707a.997.997 0 0 0 0-1.414L6.409 11h6.589a1 1 0 1 0 0-2H6.409l1.294-1.293a1 1 0 1 0-1.415-1.414l-3.001 3a.994.994 0 0 0-.198.298c-.013.027-.021.054-.03.082a.944.944 0 0 0-.054.269l-.001.027a.937.937 0 0 0 .062.398l.003.012v.004c.048.112.117.208.197.294l.01.015.01.015 3.002 3a1 1 0 0 0 1.415 0z" }, null, -1);
const _hoisted_3$a = /* @__PURE__ */ createElementVNode("path", { d: "M2 16.5A1.5 1.5 0 0 0 3.5 18h13a1.5 1.5 0 0 0 1.5-1.5v-13A1.5 1.5 0 0 0 16.5 2h-13A1.5 1.5 0 0 0 2 3.5V5a1 1 0 1 0 2 0V4h12v12H4v-1a1 1 0 1 0-2 0v1.5z" }, null, -1);
const _hoisted_4$5 = [
  _hoisted_2$j,
  _hoisted_3$a
];
function render$3(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1$G, _hoisted_4$5);
}
var ExitMajor = { render: render$3 };
const FullscreenBar = "Polaris-FullscreenBar";
const BackAction = "Polaris-FullscreenBar__BackAction";
var styles$14 = {
  FullscreenBar,
  BackAction
};
var FullscreenBar_vue_vue_type_style_index_0_lang = "";
const _hoisted_1$F = ["aria-label"];
const _sfc_main$1H = /* @__PURE__ */ defineComponent({
  setup(__props) {
    const i18n = UseI18n();
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(unref(styles$14).FullscreenBar)
      }, [
        createElementVNode("button", {
          class: normalizeClass(unref(styles$14).BackAction),
          onClick: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("action")),
          "aria-label": unref(i18n).translate("Polaris.FullscreenBar.accessibilityLabel")
        }, [
          createVNode(unref(_sfc_main$2K), { source: unref(ExitMajor) }, null, 8, ["source"]),
          createTextVNode(toDisplayString(unref(i18n).translate("Polaris.FullscreenBar.back")), 1)
        ], 10, _hoisted_1$F),
        renderSlot(_ctx.$slots, "default")
      ], 2);
    };
  }
});
const Grid = "Polaris-Grid";
var styles$13 = {
  Grid
};
var Grid_vue_vue_type_style_index_0_lang = "";
const _sfc_main$1G = /* @__PURE__ */ defineComponent({
  props: {
    areas: null,
    columns: null,
    gap: null
  },
  setup(__props) {
    const props = __props;
    const style2 = computed(() => {
      var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n;
      const gridStyle = {
        "--pc-grid-gap-xs": props.gap && props.gap.xs ? props.gap.xs : void 0,
        "--pc-grid-gap-sm": (_a = props.gap) == null ? void 0 : _a.sm,
        "--pc-grid-gap-md": (_b = props.gap) == null ? void 0 : _b.md,
        "--pc-grid-gap-lg": (_c = props.gap) == null ? void 0 : _c.lg,
        "--pc-grid-gap-xl": (_d = props.gap) == null ? void 0 : _d.xl,
        "--pc-grid-columns-xs": (_e = props.columns) == null ? void 0 : _e.xs,
        "--pc-grid-columns-sm": (_f = props.columns) == null ? void 0 : _f.sm,
        "--pc-grid-columns-md": (_g = props.columns) == null ? void 0 : _g.md,
        "--pc-grid-columns-lg": (_h = props.columns) == null ? void 0 : _h.lg,
        "--pc-grid-columns-xl": (_i = props.columns) == null ? void 0 : _i.xl,
        "--pc-grid-areas-xs": formatAreas((_j = props.areas) == null ? void 0 : _j.xs),
        "--pc-grid-areas-sm": formatAreas((_k = props.areas) == null ? void 0 : _k.sm),
        "--pc-grid-areas-md": formatAreas((_l = props.areas) == null ? void 0 : _l.md),
        "--pc-grid-areas-lg": formatAreas((_m = props.areas) == null ? void 0 : _m.lg),
        "--pc-grid-areas-xl": formatAreas((_n = props.areas) == null ? void 0 : _n.xl)
      };
      Object.keys(gridStyle).forEach((key) => {
        if (!gridStyle[key]) {
          delete gridStyle[key];
        }
      });
      return gridStyle;
    });
    function formatAreas(areas) {
      if (!areas) {
        return;
      }
      return `'${areas == null ? void 0 : areas.join(`' '`)}'`;
    }
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(unref(styles$13).Grid),
        style: normalizeStyle(unref(style2))
      }, [
        renderSlot(_ctx.$slots, "default")
      ], 6);
    };
  }
});
const Cell = "Polaris-Grid-Cell";
var styles$12 = {
  Cell,
  "Cell-1-column-xs": "Polaris-Grid-Cell--cell_1ColumnXs",
  "Cell-2-column-xs": "Polaris-Grid-Cell--cell_2ColumnXs",
  "Cell-3-column-xs": "Polaris-Grid-Cell--cell_3ColumnXs",
  "Cell-4-column-xs": "Polaris-Grid-Cell--cell_4ColumnXs",
  "Cell-5-column-xs": "Polaris-Grid-Cell--cell_5ColumnXs",
  "Cell-6-column-xs": "Polaris-Grid-Cell--cell_6ColumnXs",
  "Cell-1-column-sm": "Polaris-Grid-Cell--cell_1ColumnSm",
  "Cell-2-column-sm": "Polaris-Grid-Cell--cell_2ColumnSm",
  "Cell-3-column-sm": "Polaris-Grid-Cell--cell_3ColumnSm",
  "Cell-4-column-sm": "Polaris-Grid-Cell--cell_4ColumnSm",
  "Cell-5-column-sm": "Polaris-Grid-Cell--cell_5ColumnSm",
  "Cell-6-column-sm": "Polaris-Grid-Cell--cell_6ColumnSm",
  "Cell-1-column-md": "Polaris-Grid-Cell--cell_1ColumnMd",
  "Cell-2-column-md": "Polaris-Grid-Cell--cell_2ColumnMd",
  "Cell-3-column-md": "Polaris-Grid-Cell--cell_3ColumnMd",
  "Cell-4-column-md": "Polaris-Grid-Cell--cell_4ColumnMd",
  "Cell-5-column-md": "Polaris-Grid-Cell--cell_5ColumnMd",
  "Cell-6-column-md": "Polaris-Grid-Cell--cell_6ColumnMd",
  "Cell-1-column-lg": "Polaris-Grid-Cell--cell_1ColumnLg",
  "Cell-2-column-lg": "Polaris-Grid-Cell--cell_2ColumnLg",
  "Cell-3-column-lg": "Polaris-Grid-Cell--cell_3ColumnLg",
  "Cell-4-column-lg": "Polaris-Grid-Cell--cell_4ColumnLg",
  "Cell-5-column-lg": "Polaris-Grid-Cell--cell_5ColumnLg",
  "Cell-6-column-lg": "Polaris-Grid-Cell--cell_6ColumnLg",
  "Cell-7-column-lg": "Polaris-Grid-Cell--cell_7ColumnLg",
  "Cell-8-column-lg": "Polaris-Grid-Cell--cell_8ColumnLg",
  "Cell-9-column-lg": "Polaris-Grid-Cell--cell_9ColumnLg",
  "Cell-10-column-lg": "Polaris-Grid-Cell--cell_10ColumnLg",
  "Cell-11-column-lg": "Polaris-Grid-Cell--cell_11ColumnLg",
  "Cell-12-column-lg": "Polaris-Grid-Cell--cell_12ColumnLg",
  "Cell-1-column-xl": "Polaris-Grid-Cell--cell_1ColumnXl",
  "Cell-2-column-xl": "Polaris-Grid-Cell--cell_2ColumnXl",
  "Cell-3-column-xl": "Polaris-Grid-Cell--cell_3ColumnXl",
  "Cell-4-column-xl": "Polaris-Grid-Cell--cell_4ColumnXl",
  "Cell-5-column-xl": "Polaris-Grid-Cell--cell_5ColumnXl",
  "Cell-6-column-xl": "Polaris-Grid-Cell--cell_6ColumnXl",
  "Cell-7-column-xl": "Polaris-Grid-Cell--cell_7ColumnXl",
  "Cell-8-column-xl": "Polaris-Grid-Cell--cell_8ColumnXl",
  "Cell-9-column-xl": "Polaris-Grid-Cell--cell_9ColumnXl",
  "Cell-10-column-xl": "Polaris-Grid-Cell--cell_10ColumnXl",
  "Cell-11-column-xl": "Polaris-Grid-Cell--cell_11ColumnXl",
  "Cell-12-column-xl": "Polaris-Grid-Cell--cell_12ColumnXl"
};
var Cell_vue_vue_type_style_index_0_lang = "";
const _sfc_main$1F = /* @__PURE__ */ defineComponent({
  props: {
    area: null,
    column: null,
    columnSpan: null,
    row: null
  },
  setup(__props) {
    const props = __props;
    const className = computed(() => {
      var _a, _b, _c, _d, _e;
      return classNames(styles$12.Cell, ((_a = props.columnSpan) == null ? void 0 : _a.xs) && styles$12[`Cell-${props.columnSpan.xs}-column-xs`], ((_b = props.columnSpan) == null ? void 0 : _b.sm) && styles$12[`Cell-${props.columnSpan.sm}-column-sm`], ((_c = props.columnSpan) == null ? void 0 : _c.md) && styles$12[`Cell-${props.columnSpan.md}-column-md`], ((_d = props.columnSpan) == null ? void 0 : _d.lg) && styles$12[`Cell-${props.columnSpan.lg}-column-lg`], ((_e = props.columnSpan) == null ? void 0 : _e.xl) && styles$12[`Cell-${props.columnSpan.xl}-column-xl`]);
    });
    const style2 = computed(() => {
      var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j;
      const columnStyle = {
        gridArea: props.area,
        "--pc-column-xs": (_a = props.column) == null ? void 0 : _a.xs,
        "--pc-column-sm": (_b = props.column) == null ? void 0 : _b.sm,
        "--pc-column-md": (_c = props.column) == null ? void 0 : _c.md,
        "--pc-column-lg": (_d = props.column) == null ? void 0 : _d.lg,
        "--pc-column-xl": (_e = props.column) == null ? void 0 : _e.xl,
        "--pc-row-xs": (_f = props.row) == null ? void 0 : _f.xs,
        "--pc-row-sm": (_g = props.row) == null ? void 0 : _g.sm,
        "--pc-row-md": (_h = props.row) == null ? void 0 : _h.md,
        "--pc-row-lg": (_i = props.row) == null ? void 0 : _i.lg,
        "--pc-row-xl": (_j = props.row) == null ? void 0 : _j.xl
      };
      Object.keys(columnStyle).forEach((key) => {
        if (!columnStyle[key]) {
          delete columnStyle[key];
        }
      });
      return columnStyle;
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(unref(className)),
        style: normalizeStyle(unref(style2))
      }, [
        renderSlot(_ctx.$slots, "default")
      ], 6);
    };
  }
});
const Heading$1 = "Polaris-Heading";
var styles$11 = {
  Heading: Heading$1
};
var Heading_vue_vue_type_style_index_0_lang = "";
const _sfc_main$1E = /* @__PURE__ */ defineComponent({
  props: {
    element: { default: "h2" },
    id: null
  },
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createBlock(resolveDynamicComponent(__props.element), {
        id: __props.id,
        class: normalizeClass(unref(styles$11).Heading)
      }, {
        default: withCtx(() => [
          renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }, 8, ["id", "class"]);
    };
  }
});
const _hoisted_1$E = ["src", "src-set", "crossOrigin"];
const _sfc_main$1D = /* @__PURE__ */ defineComponent({
  props: {
    source: null,
    crossOrigin: null,
    sourceSet: null
  },
  emits: ["load"],
  setup(__props, { emit: emits }) {
    const props = __props;
    const finalSourceSet = computed(() => props.sourceSet ? props.sourceSet.map(({ source: subSource, descriptor }) => `${subSource} ${descriptor}`).join(",") : null);
    const handleLoad = () => {
      emits("load");
    };
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("img", {
        src: __props.source,
        "src-set": unref(finalSourceSet) ? unref(finalSourceSet) : void 0,
        crossOrigin: __props.crossOrigin,
        onLoad: handleLoad
      }, null, 40, _hoisted_1$E);
    };
  }
});
function useIndexSelectionChange() {
  const onSelectionChange = inject("IndexSelectionChangeContext", void 0);
  if (!onSelectionChange) {
    throw new Error(`useIndexSelectionChange: Missing IndexProvider context`);
  }
  return onSelectionChange;
}
function useIndexRow() {
  const indexRow = inject("IndexRowContext", void 0);
  if (!indexRow) {
    throw new Error(`useIndexRow: Missing IndexProvider context`);
  }
  return indexRow;
}
function useIndexValue() {
  const index = inject("IndexContext", void 0);
  if (!index) {
    throw new Error(`useIndexValue: Missing IndexProvider context`);
  }
  return index;
}
function useHandleBulkSelection({
  onSelectionChange = () => {
  }
}) {
  const lastSelected = ref(null);
  const handleSelectionChange = (selectionType, toggleType, selection, sortOrder) => {
    const prevSelected = lastSelected.value;
    if (selectionType === "multi" && typeof sortOrder === "number") {
      lastSelected.value = sortOrder;
    }
    if (selectionType === "single" || selectionType === "multi" && (typeof prevSelected !== "number" || typeof sortOrder !== "number")) {
      onSelectionChange("single", toggleType, selection);
    } else if (selectionType === "multi") {
      const min = Math.min(prevSelected, sortOrder);
      const max = Math.max(prevSelected, sortOrder);
      onSelectionChange(selectionType, toggleType, [min, max]);
    } else if (selectionType === "page" || selectionType === "all") {
      onSelectionChange(selectionType, toggleType);
    }
  };
  return handleSelectionChange;
}
const SELECT_ALL_ITEMS$1 = "All";
const _sfc_main$1C = /* @__PURE__ */ defineComponent({
  props: {
    selectable: { type: Boolean, default: true },
    itemCount: null,
    selectedItemsCount: { default: 0 },
    resourceName: null,
    loading: { type: Boolean },
    hasMoreItems: { type: Boolean },
    condensed: { type: Boolean },
    onSelectionChange: null
  },
  setup(__props) {
    const props = __props;
    const i18n = UseI18n();
    const paginatedSelectAllText = computed(() => {
      if (!props.selectable || !props.hasMoreItems) {
        return;
      }
      if (props.selectedItemsCount === SELECT_ALL_ITEMS$1) {
        return i18n.translate("Polaris.IndexProvider.allItemsSelected", {
          itemsLength: props.itemCount,
          resourceNamePlural: resourceName.value.plural.toLocaleLowerCase()
        });
      }
      return void 0;
    });
    const resourceName = computed(() => {
      const defaultResourceName = {
        singular: i18n.translate("Polaris.IndexProvider.defaultItemSingular"),
        plural: i18n.translate("Polaris.IndexProvider.defaultItemPlural")
      };
      return props.resourceName ? props.resourceName : defaultResourceName;
    });
    const bulkActionsLabel = computed(() => {
      const selectedItemsCountLabel = props.selectedItemsCount === SELECT_ALL_ITEMS$1 ? `${props.itemCount}+` : props.selectedItemsCount;
      return i18n.translate("Polaris.IndexProvider.selected", {
        selectedItemsCount: selectedItemsCountLabel
      });
    });
    const bulkActionsAccessibilityLabel = computed(() => {
      const totalItemsCount = props.itemCount;
      const allSelected = props.selectedItemsCount === totalItemsCount;
      if (totalItemsCount === 1 && allSelected) {
        return i18n.translate("Polaris.IndexProvider.a11yCheckboxDeselectAllSingle", {
          resourceNameSingular: resourceName.value.singular
        });
      } else if (totalItemsCount === 1) {
        return i18n.translate("Polaris.IndexProvider.a11yCheckboxSelectAllSingle", {
          resourceNameSingular: resourceName.value.singular
        });
      } else if (allSelected) {
        return i18n.translate("Polaris.IndexProvider.a11yCheckboxDeselectAllMultiple", {
          itemsLength: props.itemCount,
          resourceNamePlural: resourceName.value.plural
        });
      } else {
        return i18n.translate("Polaris.IndexProvider.a11yCheckboxSelectAllMultiple", {
          itemsLength: props.itemCount,
          resourceNamePlural: resourceName.value.plural
        });
      }
    });
    const selectMode2 = computed(() => props.selectedItemsCount === "All" || props.selectedItemsCount > 0);
    const selectModeRef = computed(() => selectMode2.value && props.selectable);
    const bulkSelectState = computed(() => {
      if (!props.selectedItemsCount || props.selectedItemsCount === 0) {
        return false;
      }
      if (props.selectedItemsCount === SELECT_ALL_ITEMS$1 || props.selectedItemsCount === props.itemCount) {
        return true;
      }
      return "indeterminate";
    });
    const handleSelectionChange = useHandleBulkSelection({
      onSelectionChange: props.onSelectionChange
    });
    provide("IndexContext", {
      loading: toRef(props, "loading"),
      bulkSelectState,
      resourceName: props.resourceName || {
        singular: "",
        plural: ""
      },
      selectedItemsCount: toRef(props, "selectedItemsCount"),
      bulkActionsAccessibilityLabel,
      selectMode: selectModeRef,
      paginatedSelectAllText,
      itemCount: toRef(props, "itemCount"),
      selectable: toRef(props, "selectable"),
      hasMoreItems: toRef(props, "hasMoreItems"),
      condensed: toRef(props, "condensed"),
      bulkActionsLabel
    });
    provide("IndexRowContext", {
      selectable: toRef(props, "selectable"),
      selectMode: selectModeRef,
      condensed: toRef(props, "condensed")
    });
    provide("IndexSelectionChangeContext", handleSelectionChange);
    return (_ctx, _cache) => {
      return renderSlot(_ctx.$slots, "default");
    };
  }
});
const _hoisted_1$D = {
  viewBox: "0 0 20 20",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$i = /* @__PURE__ */ createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M4.5 3A1.5 1.5 0 0 0 3 4.5v11A1.5 1.5 0 0 0 4.5 17h11a1.5 1.5 0 0 0 1.5-1.5v-11A1.5 1.5 0 0 0 15.5 3h-11zm9.207 5.707a1 1 0 0 0-1.414-1.414L9 10.586 7.707 9.293a1 1 0 0 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4z"
}, null, -1);
const _hoisted_3$9 = [
  _hoisted_2$i
];
function render$2(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1$D, _hoisted_3$9);
}
var EnableSelectionMinor = { render: render$2 };
const IndexTable = "Polaris-IndexTable";
const LoadingPanel = "Polaris-IndexTable__LoadingPanel";
const LoadingPanelRow = "Polaris-IndexTable__LoadingPanelRow";
const LoadingPanelText = "Polaris-IndexTable__LoadingPanelText";
const Table = "Polaris-IndexTable__Table";
const TableCell = "Polaris-IndexTable__TableCell";
const TableRow = "Polaris-IndexTable__TableRow";
const statusSuccess = "Polaris-IndexTable--statusSuccess";
const statusSubdued = "Polaris-IndexTable--statusSubdued";
const TableHeading = "Polaris-IndexTable__TableHeading";
const TableHeadingSortButton = "Polaris-IndexTable__TableHeadingSortButton";
const TableHeadingSortIcon = "Polaris-IndexTable__TableHeadingSortIcon";
const TableHeadingSortSvg = "Polaris-IndexTable__TableHeadingSortSvg";
const ColumnHeaderCheckboxWrapper = "Polaris-IndexTable__ColumnHeaderCheckboxWrapper";
const FirstStickyHeaderElement = "Polaris-IndexTable__FirstStickyHeaderElement";
const StickyTable = "Polaris-IndexTable__StickyTable";
const StickyTableHeader = "Polaris-IndexTable__StickyTableHeader";
const StickyTableColumnHeader = "Polaris-IndexTable__StickyTableColumnHeader";
const StickyTableHeadings = "Polaris-IndexTable__StickyTableHeadings";
const unselectable = "Polaris-IndexTable--unselectable";
const ScrollLeft = "Polaris-IndexTable__ScrollLeft";
const ScrollRight = "Polaris-IndexTable__ScrollRight";
const BulkActionsWrapper$1 = "Polaris-IndexTable__BulkActionsWrapper";
const ScrollBarContainer = "Polaris-IndexTable__ScrollBarContainer";
const scrollBarContainerCondensed = "Polaris-IndexTable--scrollBarContainerCondensed";
const scrollBarContainerHidden = "Polaris-IndexTable--scrollBarContainerHidden";
const ScrollBar = "Polaris-IndexTable__ScrollBar";
const disableTextSelection$1 = "Polaris-IndexTable--disableTextSelection";
const selectMode$1 = "Polaris-IndexTable--selectMode";
const EmptySearchResultWrapper$1 = "Polaris-IndexTable__EmptySearchResultWrapper";
const condensedRow = "Polaris-IndexTable--condensedRow";
const CondensedList = "Polaris-IndexTable__CondensedList";
const HeaderWrapper$1 = "Polaris-IndexTable__HeaderWrapper";
const ScrollBarContent = "Polaris-IndexTable__ScrollBarContent";
var styles$10 = {
  IndexTable,
  "LoadingContainer-enter": "Polaris-IndexTable__LoadingContainer--enter",
  "LoadingContainer-enter-active": "Polaris-IndexTable--loadingContainerEnterActive",
  "LoadingContainer-exit": "Polaris-IndexTable__LoadingContainer--exit",
  "LoadingContainer-exit-active": "Polaris-IndexTable--loadingContainerExitActive",
  LoadingPanel,
  LoadingPanelRow,
  LoadingPanelText,
  Table,
  "Table-scrolling": "Polaris-IndexTable__Table--scrolling",
  "TableCell-first": "Polaris-IndexTable__TableCell--first",
  TableCell,
  "TableHeading-first": "Polaris-IndexTable__TableHeading--first",
  "TableHeading-second": "Polaris-IndexTable__TableHeading--second",
  "Table-sticky": "Polaris-IndexTable__Table--sticky",
  "Table-unselectable": "Polaris-IndexTable__Table--unselectable",
  TableRow,
  "TableRow-unclickable": "Polaris-IndexTable__TableRow--unclickable",
  statusSuccess,
  statusSubdued,
  "TableRow-hovered": "Polaris-IndexTable__TableRow--hovered",
  "TableRow-selected": "Polaris-IndexTable__TableRow--selected",
  "TableRow-subdued": "Polaris-IndexTable__TableRow--subdued",
  "TableRow-disabled": "Polaris-IndexTable__TableRow--disabled",
  TableHeading,
  "TableHeading-sortable": "Polaris-IndexTable__TableHeading--sortable",
  "TableHeading-flush": "Polaris-IndexTable__TableHeading--flush",
  TableHeadingSortButton,
  TableHeadingSortIcon,
  "TableHeadingSortIcon-visible": "Polaris-IndexTable__TableHeadingSortIcon--visible",
  TableHeadingSortSvg,
  ColumnHeaderCheckboxWrapper,
  FirstStickyHeaderElement,
  "TableHeading-unselectable": "Polaris-IndexTable__TableHeading--unselectable",
  "TableCell-flush": "Polaris-IndexTable__TableCell--flush",
  "Table-sticky-scrolling": "Polaris-IndexTable--tableStickyScrolling",
  "TableHeading-last": "Polaris-IndexTable__TableHeading--last",
  "Table-sticky-last": "Polaris-IndexTable--tableStickyLast",
  "Table-sortable": "Polaris-IndexTable__Table--sortable",
  StickyTable,
  StickyTableHeader,
  "StickyTableHeader-isSticky": "Polaris-IndexTable__StickyTableHeader--isSticky",
  StickyTableColumnHeader,
  "StickyTableColumnHeader-isScrolling": "Polaris-IndexTable__StickyTableColumnHeader--isScrolling",
  StickyTableHeadings,
  "StickyTableHeading-second": "Polaris-IndexTable__StickyTableHeading--second",
  unselectable,
  "StickyTableHeading-second-scrolling": "Polaris-IndexTable--stickyTableHeadingSecondScrolling",
  ScrollLeft,
  ScrollRight,
  "ScrollRight-onboarding": "Polaris-IndexTable__ScrollRight--onboarding",
  BulkActionsWrapper: BulkActionsWrapper$1,
  ScrollBarContainer,
  scrollBarContainerCondensed,
  scrollBarContainerHidden,
  ScrollBar,
  disableTextSelection: disableTextSelection$1,
  selectMode: selectMode$1,
  EmptySearchResultWrapper: EmptySearchResultWrapper$1,
  condensedRow,
  CondensedList,
  HeaderWrapper: HeaderWrapper$1,
  "StickyTable-condensed": "Polaris-IndexTable__StickyTable--condensed",
  "StickyTableHeader-condensed": "Polaris-IndexTable__StickyTableHeader--condensed",
  ScrollBarContent
};
const _sfc_main$1B = /* @__PURE__ */ defineComponent({
  props: {
    flush: { type: Boolean }
  },
  setup(__props) {
    const props = __props;
    const cellClassName = computed(() => classNames(styles$10.TableCell, props.flush && styles$10["TableCell-flush"]));
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("td", {
        class: normalizeClass(unref(cellClassName))
      }, [
        renderSlot(_ctx.$slots, "default")
      ], 2);
    };
  }
});
function useRowContext() {
  const context = inject("RowContext", {});
  return context;
}
function useContainerScroll() {
  const scrolledContainerRef = inject("ScrollContext", null);
  return scrolledContainerRef;
}
const TableCellContentContainer = "Polaris-IndexTable-Checkbox__TableCellContentContainer";
const Wrapper$1 = "Polaris-IndexTable-Checkbox__Wrapper";
const expanded = "Polaris-IndexTable-Checkbox--expanded";
const condensed = "Polaris-IndexTable-Checkbox--condensed";
var styles$$ = {
  TableCellContentContainer,
  Wrapper: Wrapper$1,
  expanded,
  condensed
};
var Checkbox_vue_vue_type_style_index_0_lang$1 = "";
const _sfc_main$1A = /* @__PURE__ */ defineComponent({
  setup(__props) {
    const i18n = UseI18n();
    const { condensed: condensed2, resourceName } = useIndexValue();
    const rowContext = useRowContext();
    const wrapperClassName = computed(() => classNames(styles$$.Wrapper, (condensed2 == null ? void 0 : condensed2.value) ? styles$$.condensed : styles$$.expanded));
    const checkboxNode = ref(null);
    const handleResize = debounce(() => {
      if (rowContext.value.position !== 0 || !checkboxNode.value) {
        return;
      }
      const { width } = checkboxNode.value.getBoundingClientRect();
      setRootProperty("--pc-checkbox-offset", `${width}px`);
    });
    const checkboxClassName = computed(() => classNames(styles$10.TableCell, styles$10["TableCell-first"]));
    const selectItemLabel = computed(() => {
      return i18n.translate("Polaris.IndexTable.selectItem", {
        resourceName: resourceName.singular
      });
    });
    onMounted(() => {
      handleResize();
      if (!checkboxNode.value) {
        return;
      }
      window.addEventListener("resize", handleResize);
    });
    onBeforeUnmount(() => {
      window.removeEventListener("resize", handleResize);
    });
    return (_ctx, _cache) => {
      return !unref(condensed2) ? (openBlock(), createElementBlock("td", {
        key: 0,
        class: normalizeClass(unref(checkboxClassName)),
        ref_key: "checkboxNode",
        ref: checkboxNode
      }, [
        createElementVNode("div", {
          class: normalizeClass(unref(styles$$).TableCellContentContainer)
        }, [
          createElementVNode("div", {
            class: normalizeClass(unref(wrapperClassName)),
            onClick: _cache[0] || (_cache[0] = (...args) => unref(rowContext).onInteraction && unref(rowContext).onInteraction(...args))
          }, [
            createVNode(unref(_sfc_main$2s), {
              id: unref(rowContext).itemId,
              label: unref(selectItemLabel),
              labelHidden: "",
              checked: unref(rowContext).selected,
              disabled: unref(rowContext).disabled
            }, null, 8, ["id", "label", "checked", "disabled"])
          ], 2)
        ], 2)
      ], 2)) : (openBlock(), createElementBlock("div", {
        key: 1,
        class: normalizeClass(unref(styles$$).TableCellContentContainer)
      }, [
        createElementVNode("div", {
          class: normalizeClass(unref(wrapperClassName)),
          onClick: _cache[1] || (_cache[1] = (...args) => unref(rowContext).onInteraction && unref(rowContext).onInteraction(...args))
        }, [
          createVNode(unref(_sfc_main$2s), {
            id: unref(rowContext).itemId,
            label: unref(selectItemLabel),
            labelHidden: "",
            checked: unref(rowContext).selected,
            disabled: unref(rowContext).disabled
          }, null, 8, ["id", "label", "checked", "disabled"])
        ], 2)
      ], 2));
    };
  }
});
const _sfc_main$1z = /* @__PURE__ */ defineComponent({
  props: {
    id: null,
    selected: { type: Boolean },
    position: null,
    subdued: { type: Boolean },
    status: null,
    disabled: { type: Boolean }
  },
  emits: ["click", "navigation"],
  setup(__props, { emit: emits }) {
    const props = __props;
    const attrs = useAttrs();
    const { selectable: selectable2, selectMode: selectMode2, condensed: condensed2 } = useIndexRow();
    const onSelectionChange = useIndexSelectionChange();
    const primaryLinkElement = ref(null);
    const isNavigating = ref(false);
    const tableRowRef = ref(null);
    const hovered = ref(false);
    const setHoverIn = () => {
      hovered.value = true;
    };
    const setHoverOut = () => {
      hovered.value = false;
    };
    const contextValue = computed(() => {
      return {
        itemId: props.id,
        selected: props.selected,
        disabled: props.disabled,
        position: props.position,
        onInteraction: handleInteraction
      };
    });
    const handleInteraction = (event) => {
      event.stopPropagation();
      if ("key" in event && event.key !== " " || !onSelectionChange) {
        return;
      }
      const selectionType = event.shiftKey ? "multi" : "single";
      onSelectionChange(selectionType, !props.selected, props.id, props.position);
    };
    const rowClassName = computed(() => classNames(styles$10.TableRow, selectable2.value && (condensed2 == null ? void 0 : condensed2.value) && styles$10.condensedRow, props.selected && styles$10["TableRow-selected"], props.subdued && styles$10["TableRow-subdued"], hovered.value && styles$10["TableRow-hovered"], props.disabled && styles$10["TableRow-disabled"], props.status && styles$10[variationName("status", props.status)], !selectable2.value && !primaryLinkElement.value && styles$10["TableRow-unclickable"]));
    const RowWrapper = computed(() => (condensed2 == null ? void 0 : condensed2.value) ? "li" : "tr");
    const handleRowClick = (event) => {
      if ((props.disabled || !selectable2.value) && !primaryLinkElement.value) {
        return;
      }
      if (!tableRowRef.value || isNavigating.value) {
        return;
      }
      event.stopPropagation();
      event.preventDefault();
      if (attrs.onClick) {
        emits("click");
        return;
      }
      if (primaryLinkElement.value && !selectMode2.value) {
        isNavigating.value = true;
        const { ctrlKey, metaKey } = event;
        if (attrs.onNavigation) {
          emits("navigation", props.id);
        }
        if ((ctrlKey || metaKey) && primaryLinkElement.value instanceof HTMLAnchorElement) {
          isNavigating.value = false;
          window.open(primaryLinkElement.value.href, "_blank");
          return;
        }
        primaryLinkElement.value.dispatchEvent(new MouseEvent(event.type, event));
      } else {
        isNavigating.value = false;
        handleInteraction(event);
      }
    };
    onMounted(() => {
      var _a;
      const el = (_a = tableRowRef.value) == null ? void 0 : _a.querySelector("[data-primary-link]");
      if (el) {
        primaryLinkElement.value = el;
      }
    });
    provide("RowContext", contextValue);
    provide("RowHoveredContext", hovered);
    return (_ctx, _cache) => {
      return openBlock(), createBlock(resolveDynamicComponent(unref(RowWrapper)), {
        key: __props.id,
        class: normalizeClass(unref(rowClassName)),
        onMouseenter: setHoverIn,
        onMouseleave: setHoverOut,
        onClick: handleRowClick,
        ref_key: "tableRowRef",
        ref: tableRowRef
      }, {
        default: withCtx(() => [
          unref(selectable2) ? (openBlock(), createBlock(unref(_sfc_main$1A), { key: 0 })) : createCommentVNode("", true),
          renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }, 8, ["class"]);
    };
  }
});
const ScrollContainer = "Polaris-IndexTable-ScrollContainer";
var styles$_ = {
  ScrollContainer
};
var ScrollContainer_vue_vue_type_style_index_0_lang = "";
const _sfc_main$1y = /* @__PURE__ */ defineComponent({
  emits: ["scroll"],
  setup(__props, { expose, emit: emits }) {
    const scrollableContainerRef = ref(null);
    onMounted(() => {
      if (scrollableContainerRef.value) {
        scrollableContainerRef.value.dispatchEvent(new Event("scroll"));
      }
    });
    const containerScroll = ref({
      scrollableContainer: scrollableContainerRef,
      canScrollLeft: false,
      canScrollRight: false
    });
    const handleScroll = debounce(() => {
      if (!scrollableContainerRef.value) {
        return;
      }
      const availableScrollAmount = scrollableContainerRef.value.scrollWidth - scrollableContainerRef.value.offsetWidth;
      const canScrollLeft = scrollableContainerRef.value.scrollLeft > 0;
      const canScrollRight = scrollableContainerRef.value.scrollLeft < availableScrollAmount;
      emits("scroll", canScrollLeft, canScrollRight);
      containerScroll.value = {
        scrollableContainer: scrollableContainerRef,
        canScrollLeft,
        canScrollRight
      };
    }, 40, { trailing: true, leading: true, maxWait: 40 });
    provide("ScrollContext", containerScroll);
    expose({ scrollableContainerRef });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(unref(styles$_).ScrollContainer),
        ref_key: "scrollableContainerRef",
        ref: scrollableContainerRef,
        onScroll: _cache[0] || (_cache[0] = (...args) => unref(handleScroll) && unref(handleScroll)(...args))
      }, [
        renderSlot(_ctx.$slots, "default")
      ], 34);
    };
  }
});
const _sfc_main$1x = /* @__PURE__ */ defineComponent({
  props: {
    heading: null
  },
  setup(__props) {
    const i18n = UseI18n();
    return (_ctx, _cache) => {
      return __props.heading.new ? (openBlock(), createBlock(unref(_sfc_main$12), {
        key: 0,
        wrap: false,
        alignment: "center"
      }, {
        default: withCtx(() => [
          createElementVNode("span", null, toDisplayString(__props.heading.title), 1),
          createVNode(unref(_sfc_main$2Y), { status: "new" }, {
            default: withCtx(() => [
              createTextVNode(toDisplayString(unref(i18n).translate("Polaris.IndexTable.onboardingBadgeText")), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      })) : __props.heading.hidden ? (openBlock(), createBlock(unref(Text), {
        key: 1,
        variant: "bodySm",
        as: "span",
        "visually-hidden": ""
      }, {
        default: withCtx(() => [
          createTextVNode(toDisplayString(__props.heading.title), 1)
        ]),
        _: 1
      })) : (openBlock(), createElementBlock(Fragment, { key: 2 }, [
        createTextVNode(toDisplayString(__props.heading.title), 1)
      ], 64));
    };
  }
});
const _sfc_main$1w = /* @__PURE__ */ defineComponent({
  props: {
    heading: null,
    index: null,
    sortable: null,
    defaultSortDirection: { default: "descending" },
    sortDirection: null,
    sortColumnIndex: null,
    sortToggleLabels: null
  },
  emits: ["sort"],
  setup(__props, { emit: emits }) {
    const props = __props;
    UseI18n();
    const isCurrentlySorted = computed(() => props.index === props.sortColumnIndex);
    const isAscending = computed(() => props.sortDirection === "ascending");
    const newDirection = computed(() => {
      if (isCurrentlySorted.value) {
        return isAscending.value ? "descending" : "ascending";
      }
      return props.defaultSortDirection;
    });
    const SourceComponent = computed(() => {
      if (isCurrentlySorted.value) {
        return props.sortDirection === "ascending" ? SortAscendingMajor : SortDescendingMajor;
      }
      return props.defaultSortDirection === "ascending" ? SortAscendingMajor : SortDescendingMajor;
    });
    const className = computed(() => classNames(styles$10.TableHeadingSortIcon, isCurrentlySorted.value && styles$10["TableHeadingSortIcon-visible"]));
    const tooltipDirection = computed(() => isCurrentlySorted.value ? props.sortDirection : props.defaultSortDirection);
    const tooltipContent = computed(() => {
      var _a;
      return (_a = props.sortToggleLabels) == null ? void 0 : _a[props.index][tooltipDirection.value];
    });
    const handleSortHeadingClick = (index, direction) => {
      emits("sort", index, direction);
    };
    return (_ctx, _cache) => {
      return __props.sortable && __props.sortable[__props.index] && __props.sortToggleLabels ? (openBlock(), createBlock(unref(_sfc_main$f), {
        key: 0,
        content: unref(tooltipContent)
      }, {
        default: withCtx(() => [
          createVNode(unref(_sfc_main$2J), {
            class: normalizeClass(unref(styles$10).TableHeadingSortButton),
            onClick: _cache[0] || (_cache[0] = () => handleSortHeadingClick(__props.index, unref(newDirection)))
          }, {
            default: withCtx(() => [
              createElementVNode("span", {
                class: normalizeClass(unref(className))
              }, [
                createVNode(unref(SourceComponent), {
                  focusable: "false",
                  "aria-hidden": "true",
                  class: normalizeClass(unref(styles$10).TableHeadingSortSvg)
                }, null, 8, ["class"])
              ], 2),
              createVNode(_sfc_main$1x, { heading: __props.heading }, null, 8, ["heading"])
            ]),
            _: 1
          }, 8, ["class"])
        ]),
        _: 1
      }, 8, ["content"])) : __props.sortable && __props.sortable[__props.index] ? (openBlock(), createBlock(unref(_sfc_main$2J), {
        key: 1,
        class: normalizeClass(unref(styles$10).TableHeadingSortButton),
        onClick: _cache[1] || (_cache[1] = () => handleSortHeadingClick(__props.index, unref(newDirection)))
      }, {
        default: withCtx(() => [
          createElementVNode("span", {
            class: normalizeClass(unref(className))
          }, [
            createVNode(unref(SourceComponent), {
              focusable: "false",
              "aria-hidden": "true",
              class: normalizeClass(unref(styles$10).TableHeadingSortSvg)
            }, null, 8, ["class"])
          ], 2),
          createVNode(_sfc_main$1x, { heading: __props.heading }, null, 8, ["heading"])
        ]),
        _: 1
      }, 8, ["class"])) : (openBlock(), createBlock(_sfc_main$1x, {
        key: 2,
        heading: __props.heading
      }, null, 8, ["heading"]));
    };
  }
});
function getTableHeadingsBySelector(wrapperElement, selector) {
  return wrapperElement ? Array.from(wrapperElement.querySelectorAll(selector)) : [];
}
const _hoisted_1$C = ["data-condensed"];
const _hoisted_2$h = ["data-selectmode"];
const _sfc_main$1v = /* @__PURE__ */ defineComponent({
  props: {
    headings: null,
    promotedBulkActions: null,
    bulkActions: null,
    paginatedSelectAllActionText: null,
    lastColumnSticky: { type: Boolean, default: false },
    sortable: null,
    defaultSortDirection: { default: "descending" },
    sortDirection: null,
    sortColumnIndex: null,
    sortToggleLabels: null
  },
  emits: ["sort"],
  setup(__props, { emit: emits }) {
    const props = __props;
    const SCROLL_BAR_PADDING = 4;
    const SCROLL_BAR_DEBOUNCE_PERIOD = 300;
    const slots = useSlots();
    const {
      condensed: condensed2,
      selectMode: selectMode2,
      selectable: selectable2,
      loading: loading2,
      itemCount,
      selectedItemsCount,
      hasMoreItems,
      resourceName,
      bulkActionsAccessibilityLabel,
      bulkSelectState,
      paginatedSelectAllText
    } = useIndexValue();
    const handleSelectionChange = useIndexSelectionChange();
    const i18n = UseI18n();
    const hasMoreLeftColumns = ref(false);
    const toggleHasMoreLeftColumns = () => {
      hasMoreLeftColumns.value = !hasMoreLeftColumns.value;
    };
    const isBreakpointsXS = () => {
      var _a;
      return typeof window === "undefined" ? false : window.innerWidth < parseFloat((_a = toPx(tokens.breakpoints["breakpoints-sm"])) != null ? _a : "");
    };
    const tablePosition = ref({ top: 0, left: 0 });
    const tableHeadingRects = ref([]);
    const scrollableContainerElement = ref(null);
    const tableElement = ref(null);
    const condensedListElement = ref(null);
    const tableInitialized = ref(false);
    const isSmallScreenSelectable = ref(false);
    const stickyWrapper = ref(null);
    const hideScrollContainer = ref(false);
    const smallScreen = ref(isBreakpointsXS());
    const canFitStickyColumn = ref(true);
    const tableHeadings = ref([]);
    const stickyTableHeadings = ref([]);
    const stickyHeaderWrapperElement = ref(null);
    const firstStickyHeaderElement = ref(null);
    const stickyHeaderElement = ref(null);
    const scrollBarElement = ref(null);
    const scrollContainerElement = ref(null);
    const scrollingWithBar = ref(false);
    const scrollingContainer = ref(false);
    const canScrollRight = ref(true);
    const isMounted = ref(false);
    const stickyColumnHeaderStyle = ref({});
    const scrollContainerRef = computed(() => {
      return scrollableContainerElement.value && scrollableContainerElement.value.scrollableContainerRef;
    });
    const handleCanFitStickyColumn = () => {
      if (!scrollableContainerElement.value || !tableHeadings.value.length) {
        return;
      }
      const scrollableRect = scrollableContainerElement.value.getBoundingClientRect();
      const checkboxColumnWidth = selectable2 ? tableHeadings.value[0].getBoundingClientRect().width : 0;
      const firstStickyColumnWidth = tableHeadings.value[selectable2 ? 1 : 0].getBoundingClientRect().width;
      const lastColumnIsNotTheFirst = selectable2 ? tableHeadings.value.length > 2 : 1;
      const lastStickyColumnWidth = props.lastColumnSticky && lastColumnIsNotTheFirst ? tableHeadings.value[tableHeadings.value.length - 1].getBoundingClientRect().width : 0;
      const restOfContentMinWidth = 100;
      canFitStickyColumn.value = scrollableRect.width > firstStickyColumnWidth + checkboxColumnWidth + lastStickyColumnWidth + restOfContentMinWidth;
    };
    const tableBodyRef = (node) => {
      if (node !== null && !tableInitialized.value) {
        tableInitialized.value = true;
      }
    };
    const toggleIsSmallScreenSelectable = () => {
      isSmallScreenSelectable.value = !isSmallScreenSelectable.value;
    };
    const handleSelectAllItemsInStore = () => {
      handleSelectionChange(selectedItemsCount.value === SELECT_ALL_ITEMS$1 ? "page" : "all", true);
    };
    const calculateFirstHeaderOffset = () => {
      if (!(selectable2 == null ? void 0 : selectable2.value)) {
        return tableHeadingRects.value[0].offsetWidth;
      }
      return (condensed2 == null ? void 0 : condensed2.value) ? tableHeadingRects.value[0].offsetWidth : tableHeadingRects.value[0].offsetWidth + tableHeadingRects.value[1].offsetWidth;
    };
    const resizeTableHeadings = debounce(() => {
      if (!tableElement.value || !scrollContainerRef.value) {
        return;
      }
      const boundingRect = scrollContainerRef.value.getBoundingClientRect();
      tablePosition.value = {
        top: boundingRect.top,
        left: boundingRect.left
      };
      tableHeadingRects.value = tableHeadings.value.map((heading) => ({
        offsetWidth: heading.offsetWidth || 0,
        offsetLeft: heading.offsetLeft || 0
      }));
      if (tableHeadings.value.length === 0) {
        return;
      }
      if ((selectable2 == null ? void 0 : selectable2.value) && tableHeadings.value.length > 1) {
        tableHeadings.value[1].style.left = `${tableHeadingRects.value[0].offsetWidth}px`;
      }
      if ((selectable2 == null ? void 0 : selectable2.value) && (firstStickyHeaderElement == null ? void 0 : firstStickyHeaderElement.value)) {
        const elementStyle = getComputedStyle(tableHeadings.value[0]);
        const boxWidth = tableHeadings.value[0].offsetWidth;
        firstStickyHeaderElement.value.style.minWidth = `calc(${boxWidth}px - ${elementStyle.paddingLeft} - ${elementStyle.paddingRight} + 2px)`;
      }
      stickyTableHeadings.value.forEach((heading, index) => {
        var _a, _b;
        let minWidth = 0;
        if (index === 0 && (!isBreakpointsXS() || !(selectable2 == null ? void 0 : selectable2.value))) {
          minWidth = calculateFirstHeaderOffset();
        } else if ((selectable2 == null ? void 0 : selectable2.value) && tableHeadingRects.value.length > index) {
          minWidth = ((_a = tableHeadingRects.value[index]) == null ? void 0 : _a.offsetWidth) || 0;
        } else if (!(selectable2 == null ? void 0 : selectable2.value) && tableHeadingRects.value.length >= index) {
          minWidth = ((_b = tableHeadingRects.value[index - 1]) == null ? void 0 : _b.offsetWidth) || 0;
        }
        heading.style.minWidth = `${minWidth}px`;
      });
    });
    const resizeTableScrollBar = () => {
      var _a, _b;
      if (scrollBarElement.value && tableElement.value && tableInitialized) {
        scrollBarElement.value.style.setProperty("--pc-index-table-scroll-bar-content-width", `${tableElement.value.offsetWidth - SCROLL_BAR_PADDING}px`);
        hideScrollContainer.value = ((_a = scrollContainerElement.value) == null ? void 0 : _a.offsetWidth) === ((_b = tableElement.value) == null ? void 0 : _b.offsetWidth);
      }
    };
    const debounceResizeTableScrollbar = () => debounce(resizeTableScrollBar, SCROLL_BAR_DEBOUNCE_PERIOD, {
      trailing: true
    });
    const handleCanScrollRight = debounce(() => {
      if (!props.lastColumnSticky || !tableElement.value || !scrollContainerRef.value) {
        return;
      }
      const tableRect = tableElement.value.getBoundingClientRect();
      const scrollableRect = scrollContainerRef.value.getBoundingClientRect();
      canScrollRight.value = tableRect.width > scrollableRect.width;
    });
    const handleIsSmallScreen = () => {
      smallScreen.value = isBreakpointsXS();
    };
    const handleResize = () => {
      var _a;
      (_a = scrollBarElement.value) == null ? void 0 : _a.style.setProperty("--pc-index-table-scroll-bar-content-width", `0px`);
      resizeTableHeadings();
      debounceResizeTableScrollbar();
      handleCanScrollRight();
      handleIsSmallScreen();
      handleCanFitStickyColumn();
    };
    const handleScrollContainerScroll = (canScrollLeft, tmpCanScrollRight) => {
      if (!scrollContainerRef.value || !scrollBarElement.value) {
        return;
      }
      if (!scrollingWithBar.value) {
        scrollingContainer.value = true;
        scrollBarElement.value.scrollLeft = scrollContainerRef.value.scrollLeft;
      }
      scrollingWithBar.value = false;
      if (stickyHeaderElement.value) {
        stickyHeaderElement.value.scrollLeft = scrollContainerRef.value.scrollLeft;
      }
      if (canScrollLeft && !hasMoreLeftColumns.value || !canScrollLeft && hasMoreLeftColumns.value) {
        toggleHasMoreLeftColumns();
      }
      canScrollRight.value = tmpCanScrollRight;
    };
    const handleScrollBarScroll = () => {
      if (!scrollContainerRef.value || !scrollBarElement.value) {
        return;
      }
      if (!scrollingContainer.value) {
        scrollingWithBar.value = true;
        scrollContainerRef.value.scrollLeft = scrollBarElement.value.scrollLeft;
      }
      scrollingContainer.value = false;
    };
    const isSticky = ref(false);
    const onStickyChange = (value2) => {
      isSticky.value = value2;
    };
    const triggerResizeTableHeadings = () => {
      tableHeadings.value = getTableHeadingsBySelector(tableElement.value, "[data-index-table-heading]");
      stickyTableHeadings.value = getTableHeadingsBySelector(stickyHeaderWrapperElement.value, "[data-index-table-sticky-heading]");
      resizeTableHeadings();
    };
    const triggerResizeTableScrollBar = () => {
      resizeTableScrollBar();
      stickyWrapper.value = (condensed2 == null ? void 0 : condensed2.value) ? condensedListElement.value : tableElement.value;
    };
    const checkIsSmallScreenSelectable = () => {
      if (!(condensed2 == null ? void 0 : condensed2.value) && isSmallScreenSelectable.value) {
        isSmallScreenSelectable.value = false;
      }
    };
    onMounted(() => {
      isMounted.value = true;
      handleCanScrollRight();
      if (tableHeadingRects.value && tableHeadingRects.value.length > 0) {
        stickyColumnHeaderStyle.value = { minWidth: `${calculateFirstHeaderOffset()}px` };
      }
      triggerResizeTableHeadings();
      triggerResizeTableScrollBar();
      checkIsSmallScreenSelectable();
    });
    watch(() => [props.headings, firstStickyHeaderElement.value, tableInitialized.value], triggerResizeTableHeadings);
    watch(() => [tableInitialized.value, condensed2 == null ? void 0 : condensed2.value], triggerResizeTableScrollBar);
    watch(() => [isSmallScreenSelectable.value, condensed2 == null ? void 0 : condensed2.value], checkIsSmallScreenSelectable);
    watch(() => [tableInitialized.value], handleCanFitStickyColumn);
    const hasBulkActions = computed(() => Boolean(props.promotedBulkActions && props.promotedBulkActions.length > 0 || props.bulkActions && props.bulkActions.length > 0));
    const bulkActionsSelectable = computed(() => Boolean(props.promotedBulkActions && props.promotedBulkActions.length > 0 || props.bulkActions && props.bulkActions.length > 0));
    const selectedItemsCountLabel = computed(() => selectedItemsCount.value === SELECT_ALL_ITEMS$1 ? `${itemCount.value}+` : selectedItemsCount.value);
    const handleTogglePage = () => {
      handleSelectionChange("page", Boolean(!(bulkSelectState == null ? void 0 : bulkSelectState.value) || (bulkSelectState == null ? void 0 : bulkSelectState.value) === "indeterminate"));
    };
    const stickyColumnHeaderClassNames = computed(() => classNames(styles$10.StickyTableColumnHeader, hasMoreLeftColumns.value && styles$10["StickyTableColumnHeader-isScrolling"]));
    const stickyHeaderClassNames = computed(() => classNames(styles$10.StickyTableHeader, isSticky.value && styles$10["StickyTableHeader-isSticky"]));
    const bulkActionClassNames = computed(() => classNames(styles$10.BulkActionsWrapper, condensed2 && styles$10["StickyTableHeader-condensed"], isSticky.value && styles$10["StickyTableHeader-isSticky"]));
    const shouldShowActions = computed(() => !(condensed2 == null ? void 0 : condensed2.value) || selectedItemsCount.value);
    const promotedActions = computed(() => shouldShowActions.value ? props.promotedBulkActions : []);
    const stickyActions = computed(() => shouldShowActions.value ? props.bulkActions : []);
    const checkboxLabel = computed(() => {
      return i18n.translate("Polaris.IndexTable.selectAllLabel", {
        resourceNamePlural: resourceName.plural
      });
    });
    const emptyStateTitle = computed(() => {
      return i18n.translate("Polaris.IndexTable.emptySearchTitle", {
        resourceNamePlural: resourceName.plural
      });
    });
    const loadingPanelTextContent = computed(() => {
      return i18n.translate("Polaris.IndexTable.resourceLoadingAccessibilityLabel", {
        resourceNamePlural: resourceName.plural.toLocaleLowerCase()
      });
    });
    const bulkActionLabel = computed(() => {
      return i18n.translate("Polaris.IndexTable.selected", {
        selectedItemsCount: selectedItemsCountLabel.value
      });
    });
    const paginatedSelectAllAction = computed(() => {
      var _a;
      if (!(selectable2 == null ? void 0 : selectable2.value) || !hasBulkActions.value || !(hasMoreItems == null ? void 0 : hasMoreItems.value)) {
        return;
      }
      const customActionText = (_a = props.paginatedSelectAllActionText) != null ? _a : i18n.translate("Polaris.IndexTable.selectAllItems", {
        itemsLength: itemCount.value,
        resourceNamePlural: resourceName.plural.toLocaleLowerCase()
      });
      const actionText = selectedItemsCount.value === SELECT_ALL_ITEMS$1 ? i18n.translate("Polaris.IndexTable.undo") : customActionText;
      return {
        content: actionText,
        onAction: handleSelectAllItemsInStore
      };
    });
    const stickyTableClassNames = computed(() => classNames(styles$10.StickyTable, (condensed2 == null ? void 0 : condensed2.value) && styles$10["StickyTable-condensed"]));
    const shouldShowBulkActions = computed(() => bulkActionsSelectable.value && selectedItemsCount.value || isSmallScreenSelectable.value);
    const scrollBarWrapperClassNames = computed(() => classNames(styles$10.ScrollBarContainer, (condensed2 == null ? void 0 : condensed2.value) && styles$10.scrollBarContainerCondensed, hideScrollContainer.value && styles$10.scrollBarContainerHidden));
    const scrollBarClassNames = computed(() => classNames(tableElement.value && tableInitialized && styles$10.ScrollBarContent));
    const isSortable = computed(() => {
      var _a;
      return (_a = props.sortable) == null ? void 0 : _a.some((value2) => value2);
    });
    const tableClassNames = computed(() => classNames(styles$10.Table, hasMoreLeftColumns.value && styles$10["Table-scrolling"], selectMode2.value && styles$10.disableTextSelection, selectMode2.value && shouldShowBulkActions.value && styles$10.selectMode, !(selectable2 == null ? void 0 : selectable2.value) && styles$10["Table-unselectable"], canFitStickyColumn.value && props.lastColumnSticky && styles$10["Table-sticky-last"], canFitStickyColumn.value && styles$10["Table-sticky"], isSortable.value && styles$10["Table-sortable"], canFitStickyColumn.value && props.lastColumnSticky && canScrollRight.value && styles$10["Table-sticky-scrolling"]));
    const handleSelectModeToggle = (val) => {
      if (condensed2 == null ? void 0 : condensed2.value) {
        handleSelectionChange("all", false);
        isSmallScreenSelectable.value = val;
      }
    };
    const isSecond = (index) => index === 0;
    const isLast = (index) => index === props.headings.length - 1;
    const headingContentClassName = (heading, index) => {
      var _a;
      return classNames(styles$10.TableHeading, ((_a = props.sortable) == null ? void 0 : _a.some((value2) => value2 === true)) && styles$10["TableHeading-sortable"], isSecond(index) && styles$10["TableHeading-second"], isLast(index) && !heading.hidden && styles$10["TableHeading-last"], !(selectable2 == null ? void 0 : selectable2.value) && styles$10["TableHeading-unselectable"], heading.flush && styles$10["TableHeading-flush"]);
    };
    const getHeadingKey = (heading) => {
      if (heading.id) {
        return heading.id;
      }
      if (typeof heading.title === "string") {
        return heading.title;
      }
      return "";
    };
    const stickyPositioningStyle = (index) => {
      return (selectable2 == null ? void 0 : selectable2.value) !== false && isSecond(index) && tableHeadingRects.value && tableHeadingRects.value.length > 0 ? { left: `${tableHeadingRects.value[0].offsetWidth}px` } : void 0;
    };
    const checkboxClassName = (index) => {
      var _a;
      return classNames(styles$10.TableHeading, ((_a = props.sortable) == null ? void 0 : _a.some((value2) => value2 === true)) && styles$10["TableHeading-sortable"], index === 0 && styles$10["TableHeading-first"]);
    };
    const handleSelectPage = (event) => {
      const target = event.target;
      handleSelectionChange("page", target.checked || false);
    };
    const handleSort = (headingIndex, direction) => {
      emits("sort", headingIndex, direction);
    };
    const renderStickyHeading = (index) => {
      return tableHeadingRects.value && tableHeadingRects.value.length > index + 1 ? { minWidth: `${tableHeadingRects.value[index + 1].offsetWidth}px` } : void 0;
    };
    const stickyHeadingClassName = (index) => {
      return classNames(styles$10.TableHeading, index === 0 && styles$10["StickyTableHeading-second"], index === 0 && !(selectable2 == null ? void 0 : selectable2.value) && styles$10.unselectable);
    };
    const loadingTransitionClassNames = {
      enter: styles$10["LoadingContainer-enter"],
      enterActive: styles$10["LoadingContainer-enter-active"],
      exit: styles$10["LoadingContainer-exit"],
      exitActive: styles$10["LoadingContainer-exit-active"]
    };
    const onTransitionBeforeEnter = (el) => {
      el.classList.add(loadingTransitionClassNames.enter);
    };
    const onTransitionEnter = (el, done) => {
      setTimeout(() => {
        el.classList.add(loadingTransitionClassNames.enterActive);
        done();
      }, 1);
    };
    const onTransitionAfterEnter = (el) => {
      el.classList.remove(loadingTransitionClassNames.enter);
    };
    const onTransitionBeforeLeave = (el) => {
      el.classList.remove(loadingTransitionClassNames.enterActive);
      el.classList.add(loadingTransitionClassNames.exit);
    };
    const onTransitionLeave = (el, done) => {
      el.classList.add(loadingTransitionClassNames.exitActive);
      setTimeout(() => {
        done();
      }, parseInt(motion["duration-100"], 10));
    };
    const onTransitionAfterLeave = (el) => {
      el.classList.remove(loadingTransitionClassNames.exit);
    };
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock(Fragment, null, [
        createElementVNode("div", {
          class: normalizeClass(unref(styles$10).IndexTable)
        }, [
          createVNode(Transition, {
            name: "custom-indextable-loading-transition",
            appear: "",
            onBeforeEnter: onTransitionBeforeEnter,
            onEnter: onTransitionEnter,
            onAfterEnter: onTransitionAfterEnter,
            onBeforeLeave: onTransitionBeforeLeave,
            onLeave: onTransitionLeave,
            onAfterLeave: onTransitionAfterLeave
          }, {
            default: withCtx(() => [
              !unref(shouldShowBulkActions) && !unref(condensed2) && unref(loading2) ? (openBlock(), createElementBlock("div", {
                key: 0,
                class: normalizeClass(unref(styles$10).LoadingPanel)
              }, [
                createElementVNode("div", {
                  class: normalizeClass(unref(styles$10).LoadingPanelRow)
                }, [
                  createVNode(unref(_sfc_main$2H), { size: "small" }),
                  createElementVNode("span", {
                    class: normalizeClass(unref(styles$10).LoadingPanelText)
                  }, toDisplayString(unref(loadingPanelTextContent)), 3)
                ], 2)
              ], 2)) : createCommentVNode("", true)
            ]),
            _: 1
          }),
          unref(itemCount) > 0 ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
            createVNode(unref(_sfc_main$33), {
              event: "resize",
              handler: handleResize
            }),
            isMounted.value ? (openBlock(), createElementBlock("div", {
              key: 0,
              class: normalizeClass(unref(stickyTableClassNames)),
              role: "presentation"
            }, [
              createVNode(unref(_sfc_main$p), {
                boundingElement: stickyWrapper.value,
                onStickyChange
              }, {
                default: withCtx(() => [
                  unref(shouldShowBulkActions) ? (openBlock(), createElementBlock("div", {
                    key: 0,
                    class: normalizeClass(unref(bulkActionClassNames)),
                    "data-condensed": unref(condensed2)
                  }, [
                    createVNode(Transition, {
                      name: "custom-indextable-loading-transition",
                      appear: "",
                      onBeforeEnter: onTransitionBeforeEnter,
                      onEnter: onTransitionEnter,
                      onAfterEnter: onTransitionAfterEnter,
                      onBeforeLeave: onTransitionBeforeLeave,
                      onLeave: onTransitionLeave,
                      onAfterLeave: onTransitionAfterLeave
                    }, {
                      default: withCtx(() => [
                        unref(loading2) ? (openBlock(), createElementBlock("div", {
                          key: 0,
                          class: normalizeClass(unref(styles$10).LoadingPanel)
                        }, [
                          createElementVNode("div", {
                            class: normalizeClass(unref(styles$10).LoadingPanelRow)
                          }, [
                            createVNode(unref(_sfc_main$2H), { size: "small" }),
                            createElementVNode("span", {
                              class: normalizeClass(unref(styles$10).LoadingPanelText)
                            }, toDisplayString(unref(loadingPanelTextContent)), 3)
                          ], 2)
                        ], 2)) : createCommentVNode("", true)
                      ]),
                      _: 1
                    }),
                    createVNode(unref(_sfc_main$2R), {
                      smallScreen: smallScreen.value,
                      label: unref(bulkActionLabel),
                      accessibilityLabel: unref(bulkActionsAccessibilityLabel),
                      selected: unref(bulkSelectState),
                      selectMode: unref(selectMode2) || isSmallScreenSelectable.value,
                      promotedActions: unref(promotedActions),
                      actions: unref(stickyActions),
                      paginatedSelectAllText: unref(paginatedSelectAllText),
                      paginatedSelectAllAction: unref(paginatedSelectAllAction),
                      onToggleAll: handleTogglePage,
                      onSelectModeToggle: handleSelectModeToggle
                    }, null, 8, ["smallScreen", "label", "accessibilityLabel", "selected", "selectMode", "promotedActions", "actions", "paginatedSelectAllText", "paginatedSelectAllAction"])
                  ], 10, _hoisted_1$C)) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
                    unref(condensed2) ? (openBlock(), createElementBlock("div", {
                      key: 0,
                      class: normalizeClass(unref(classNames)(unref(styles$10).HeaderWrapper, !unref(selectable2) && unref(styles$10).unselectable))
                    }, [
                      createVNode(Transition, {
                        name: "custom-indextable-loading-transition",
                        appear: "",
                        onBeforeEnter: onTransitionBeforeEnter,
                        onEnter: onTransitionEnter,
                        onAfterEnter: onTransitionAfterEnter,
                        onBeforeLeave: onTransitionBeforeLeave,
                        onLeave: onTransitionLeave,
                        onAfterLeave: onTransitionAfterLeave
                      }, {
                        default: withCtx(() => [
                          unref(loading2) ? (openBlock(), createElementBlock("div", {
                            key: 0,
                            class: normalizeClass(unref(styles$10).LoadingPanel)
                          }, [
                            createElementVNode("div", {
                              class: normalizeClass(unref(styles$10).LoadingPanelRow)
                            }, [
                              createVNode(unref(_sfc_main$2H), { size: "small" }),
                              createElementVNode("span", {
                                class: normalizeClass(unref(styles$10).LoadingPanelText)
                              }, toDisplayString(unref(loadingPanelTextContent)), 3)
                            ], 2)
                          ], 2)) : createCommentVNode("", true)
                        ]),
                        _: 1
                      }),
                      renderSlot(_ctx.$slots, "sort"),
                      unref(selectable2) ? (openBlock(), createBlock(unref(_sfc_main$2F), {
                        key: 0,
                        icon: unref(EnableSelectionMinor),
                        onClick: toggleIsSmallScreenSelectable
                      }, {
                        default: withCtx(() => [
                          createTextVNode(toDisplayString(unref(i18n).translate("Polaris.IndexTable.selectButtonText")), 1)
                        ]),
                        _: 1
                      }, 8, ["icon"])) : createCommentVNode("", true)
                    ], 2)) : (openBlock(), createElementBlock("div", {
                      key: 1,
                      class: normalizeClass(unref(stickyHeaderClassNames)),
                      ref_key: "stickyHeaderWrapperElement",
                      ref: stickyHeaderWrapperElement
                    }, [
                      createVNode(Transition, {
                        name: "custom-indextable-loading-transition",
                        appear: "",
                        onBeforeEnter: onTransitionBeforeEnter,
                        onEnter: onTransitionEnter,
                        onAfterEnter: onTransitionAfterEnter,
                        onBeforeLeave: onTransitionBeforeLeave,
                        onLeave: onTransitionLeave,
                        onAfterLeave: onTransitionAfterLeave
                      }, {
                        default: withCtx(() => [
                          unref(loading2) ? (openBlock(), createElementBlock("div", {
                            key: 0,
                            class: normalizeClass(unref(styles$10).LoadingPanel)
                          }, [
                            createElementVNode("div", {
                              class: normalizeClass(unref(styles$10).LoadingPanelRow)
                            }, [
                              createVNode(unref(_sfc_main$2H), { size: "small" }),
                              createElementVNode("span", {
                                class: normalizeClass(unref(styles$10).LoadingPanelText)
                              }, toDisplayString(unref(loadingPanelTextContent)), 3)
                            ], 2)
                          ], 2)) : createCommentVNode("", true)
                        ]),
                        _: 1
                      }),
                      createElementVNode("div", {
                        class: normalizeClass(unref(stickyColumnHeaderClassNames))
                      }, [
                        (openBlock(), createElementBlock("div", {
                          class: normalizeClass(unref(styles$10).TableHeading),
                          key: getHeadingKey(__props.headings[0]),
                          style: normalizeStyle(stickyColumnHeaderStyle.value),
                          "data-index-table-sticky-heading": "true"
                        }, [
                          createVNode(unref(_sfc_main$12), {
                            spacing: "none",
                            wrap: false,
                            alignment: "center",
                            "no-item-wrap": ""
                          }, {
                            default: withCtx(() => [
                              unref(selectable2) ? (openBlock(), createBlock(unref(_sfc_main$13), { key: 0 }, {
                                default: withCtx(() => [
                                  createElementVNode("div", {
                                    class: normalizeClass(unref(styles$10).FirstStickyHeaderElement),
                                    ref_key: "firstStickyHeaderElement",
                                    ref: firstStickyHeaderElement
                                  }, [
                                    createElementVNode("div", {
                                      class: normalizeClass(unref(styles$10).ColumnHeaderCheckboxWrapper)
                                    }, [
                                      createVNode(unref(_sfc_main$2s), {
                                        labelHidden: "",
                                        checked: unref(bulkSelectState),
                                        onChange: handleSelectPage
                                      }, {
                                        label: withCtx(() => [
                                          createTextVNode(toDisplayString(unref(checkboxLabel)), 1)
                                        ]),
                                        _: 1
                                      }, 8, ["checked"])
                                    ], 2)
                                  ], 2)
                                ]),
                                _: 1
                              })) : createCommentVNode("", true),
                              unref(selectable2) ? (openBlock(), createBlock(unref(_sfc_main$13), { key: 1 }, {
                                default: withCtx(() => [
                                  createElementVNode("div", {
                                    class: normalizeClass(unref(styles$10)["StickyTableHeading-second-scrolling"])
                                  }, [
                                    createVNode(unref(_sfc_main$1w), {
                                      heading: __props.headings[0],
                                      index: 0,
                                      sortable: __props.sortable,
                                      defaultSortDirection: __props.defaultSortDirection,
                                      sortDirection: __props.sortDirection,
                                      sortColumnIndex: __props.sortColumnIndex,
                                      onSort: handleSort
                                    }, null, 8, ["heading", "sortable", "defaultSortDirection", "sortDirection", "sortColumnIndex"])
                                  ], 2)
                                ]),
                                _: 1
                              })) : createCommentVNode("", true),
                              !unref(selectable2) ? (openBlock(), createBlock(unref(_sfc_main$13), { key: 2 }, {
                                default: withCtx(() => [
                                  createElementVNode("div", {
                                    class: normalizeClass(unref(styles$10).FirstStickyHeaderElement),
                                    ref_key: "firstStickyHeaderElement",
                                    ref: firstStickyHeaderElement
                                  }, [
                                    createVNode(unref(_sfc_main$1w), {
                                      heading: __props.headings[0],
                                      index: 0,
                                      sortable: __props.sortable,
                                      defaultSortDirection: __props.defaultSortDirection,
                                      sortDirection: __props.sortDirection,
                                      sortColumnIndex: __props.sortColumnIndex,
                                      onSort: handleSort
                                    }, null, 8, ["heading", "sortable", "defaultSortDirection", "sortDirection", "sortColumnIndex"])
                                  ], 2)
                                ]),
                                _: 1
                              })) : createCommentVNode("", true)
                            ]),
                            _: 1
                          })
                        ], 6))
                      ], 2),
                      _cache[0] || (setBlockTracking(-1), _cache[0] = createElementVNode("div", {
                        class: normalizeClass(unref(styles$10).StickyTableHeadings),
                        ref_key: "stickyHeaderElement",
                        ref: stickyHeaderElement
                      }, [
                        (openBlock(true), createElementBlock(Fragment, null, renderList(__props.headings, (heading, index) => {
                          return openBlock(), createElementBlock("div", {
                            key: getHeadingKey(heading),
                            class: normalizeClass(stickyHeadingClassName(index)),
                            style: normalizeStyle(renderStickyHeading(index)),
                            "data-index-table-sticky-heading": "true"
                          }, [
                            createVNode(unref(_sfc_main$1w), {
                              heading,
                              index,
                              sortable: __props.sortable,
                              defaultSortDirection: __props.defaultSortDirection,
                              sortDirection: __props.sortDirection,
                              sortColumnIndex: __props.sortColumnIndex,
                              onSort: handleSort
                            }, null, 8, ["heading", "index", "sortable", "defaultSortDirection", "sortDirection", "sortColumnIndex"])
                          ], 6);
                        }), 128))
                      ], 2), setBlockTracking(1), _cache[0])
                    ], 2))
                  ], 64))
                ]),
                _: 3
              }, 8, ["boundingElement"])
            ], 2)) : createCommentVNode("", true),
            unref(condensed2) ? (openBlock(), createElementBlock("ul", {
              key: 1,
              "data-selectmode": Boolean(unref(selectMode2) || isSmallScreenSelectable.value),
              class: normalizeClass(unref(styles$10).CondensedList),
              ref_key: "condensedListElement",
              ref: condensedListElement
            }, [
              renderSlot(_ctx.$slots, "default")
            ], 10, _hoisted_2$h)) : (openBlock(), createBlock(unref(_sfc_main$1y), {
              key: 2,
              ref_key: "scrollableContainerElement",
              ref: scrollableContainerElement,
              onScroll: handleScrollContainerScroll
            }, {
              default: withCtx(() => [
                createElementVNode("table", {
                  ref_key: "tableElement",
                  ref: tableElement,
                  class: normalizeClass(unref(tableClassNames))
                }, [
                  createElementVNode("thead", null, [
                    createElementVNode("tr", null, [
                      (openBlock(true), createElementBlock(Fragment, null, renderList(__props.headings, (heading, index) => {
                        return openBlock(), createElementBlock(Fragment, {
                          key: getHeadingKey(heading)
                        }, [
                          index === 0 && unref(selectable2) ? (openBlock(), createElementBlock("th", {
                            key: 0,
                            class: normalizeClass(checkboxClassName(index)),
                            "data-index-table-heading": "true"
                          }, [
                            createElementVNode("div", {
                              class: normalizeClass(unref(styles$10).ColumnHeaderCheckboxWrapper)
                            }, [
                              createVNode(unref(_sfc_main$2s), {
                                labelHidden: "",
                                checked: unref(bulkSelectState),
                                onChange: handleSelectPage
                              }, {
                                label: withCtx(() => [
                                  createTextVNode(toDisplayString(unref(checkboxLabel)), 1)
                                ]),
                                _: 1
                              }, 8, ["checked"])
                            ], 2)
                          ], 2)) : createCommentVNode("", true),
                          createElementVNode("th", {
                            class: normalizeClass(headingContentClassName(heading, index)),
                            style: normalizeStyle(stickyPositioningStyle(index)),
                            "data-index-table-heading": "true"
                          }, [
                            createVNode(unref(_sfc_main$1w), {
                              heading,
                              index,
                              sortable: __props.sortable,
                              defaultSortDirection: __props.defaultSortDirection,
                              sortDirection: __props.sortDirection,
                              sortColumnIndex: __props.sortColumnIndex,
                              onSort: handleSort
                            }, null, 8, ["heading", "index", "sortable", "defaultSortDirection", "sortDirection", "sortColumnIndex"])
                          ], 6)
                        ], 64);
                      }), 128))
                    ])
                  ]),
                  createElementVNode("tbody", {
                    ref_key: "tableBodyRef",
                    ref: tableBodyRef
                  }, [
                    renderSlot(_ctx.$slots, "default")
                  ], 512)
                ], 2)
              ]),
              _: 3
            }, 512))
          ], 64)) : (openBlock(), createElementBlock("div", {
            key: 1,
            class: normalizeClass(unref(styles$10).EmptySearchResultWrapper)
          }, [
            unref(hasSlot)(unref(slots).emptyState) ? renderSlot(_ctx.$slots, "emptyState", { key: 0 }) : (openBlock(), createBlock(unref(_sfc_main$21), {
              key: 1,
              title: unref(emptyStateTitle),
              description: unref(i18n).translate("Polaris.IndexTable.emptySearchDescription"),
              withIllustration: ""
            }, null, 8, ["title", "description"]))
          ], 2))
        ], 2),
        isMounted.value && unref(itemCount) > 0 ? (openBlock(), createElementBlock("div", {
          key: 0,
          class: normalizeClass(unref(scrollBarWrapperClassNames)),
          ref_key: "scrollContainerElement",
          ref: scrollContainerElement
        }, [
          createElementVNode("div", {
            onScroll: handleScrollBarScroll,
            class: normalizeClass(unref(styles$10).ScrollBar),
            ref_key: "scrollBarElement",
            ref: scrollBarElement
          }, [
            createElementVNode("div", {
              class: normalizeClass(unref(scrollBarClassNames))
            }, null, 2)
          ], 34)
        ], 2)) : createCommentVNode("", true)
      ], 64);
    };
  }
});
var IndexTable_vue_vue_type_style_index_0_lang = "";
const _sfc_main$1u = /* @__PURE__ */ defineComponent({
  props: {
    selectable: { type: Boolean, default: true },
    itemCount: null,
    selectedItemsCount: { default: 0 },
    resourceName: null,
    loading: { type: Boolean },
    hasMoreItems: { type: Boolean },
    condensed: { type: Boolean },
    headings: null,
    promotedBulkActions: null,
    bulkActions: null,
    paginatedSelectAllActionText: null,
    lastColumnSticky: { type: Boolean, default: false },
    sortable: null,
    defaultSortDirection: null,
    sortDirection: null,
    sortColumnIndex: null,
    sortToggleLabels: null
  },
  emits: ["selection-change", "sort"],
  setup(__props, { emit: emits }) {
    const props = __props;
    const slots = useSlots();
    const onSelectionChange = (selectionType, toggleType, selection) => {
      emits("selection-change", selectionType, toggleType, selection);
    };
    const onSort = (index, direction) => {
      emits("sort", index, direction);
    };
    const indexTableBaseProps = computed(() => {
      return {
        headings: props.headings,
        promotedBulkActions: props.promotedBulkActions,
        bulkActions: props.bulkActions,
        paginatedSelectAllActionText: props.paginatedSelectAllActionText,
        lastColumnSticky: props.lastColumnSticky,
        sortable: props.sortable,
        defaultSortDirection: props.defaultSortDirection,
        sortDirection: props.sortDirection,
        sortColumnIndex: props.sortColumnIndex,
        sortToggleLabels: props.sortToggleLabels
      };
    });
    return (_ctx, _cache) => {
      return openBlock(), createBlock(unref(_sfc_main$1C), {
        selectable: __props.selectable,
        itemCount: __props.itemCount,
        selectedItemsCount: __props.selectedItemsCount,
        resourceName: __props.resourceName,
        loading: __props.loading,
        hasMoreItems: __props.hasMoreItems,
        condensed: __props.condensed,
        onSelectionChange
      }, {
        default: withCtx(() => [
          createVNode(_sfc_main$1v, mergeProps(unref(indexTableBaseProps), { onSort }), createSlots({
            default: withCtx(() => [
              renderSlot(_ctx.$slots, "default")
            ]),
            _: 2
          }, [
            unref(hasSlot)(unref(slots).sort) ? {
              name: "sort",
              fn: withCtx(() => [
                renderSlot(_ctx.$slots, "sort")
              ])
            } : void 0,
            unref(hasSlot)(unref(slots).emptyState) ? {
              name: "emptyState",
              fn: withCtx(() => [
                renderSlot(_ctx.$slots, "emptyState")
              ])
            } : void 0
          ]), 1040)
        ]),
        _: 3
      }, 8, ["selectable", "itemCount", "selectedItemsCount", "resourceName", "loading", "hasMoreItems", "condensed"]);
    };
  }
});
const Code = "Polaris-InlineCode__Code";
var styles$Z = {
  Code
};
var InlineCode_vue_vue_type_style_index_0_lang = "";
const _sfc_main$1t = /* @__PURE__ */ defineComponent({
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("code", {
        class: normalizeClass(unref(styles$Z).Code)
      }, [
        renderSlot(_ctx.$slots, "default")
      ], 2);
    };
  }
});
const Indicator$3 = "Polaris-Indicator";
const pulseIndicator = "Polaris-Indicator--pulseIndicator";
var styles$Y = {
  Indicator: Indicator$3,
  pulseIndicator
};
var Indicator_vue_vue_type_style_index_0_lang = "";
const _sfc_main$1s = /* @__PURE__ */ defineComponent({
  props: {
    pulse: { type: Boolean, default: false }
  },
  setup(__props) {
    const props = __props;
    const className = computed(() => {
      return classNames(styles$Y.Indicator, props.pulse && styles$Y.pulseIndicator);
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("span", {
        class: normalizeClass(unref(className))
      }, null, 2);
    };
  }
});
const Inline = "Polaris-Inline";
var styles$X = {
  Inline
};
var Inline_vue_vue_type_style_index_0_lang = "";
const _sfc_main$1r = /* @__PURE__ */ defineComponent({
  props: {
    align: { default: "start" },
    blockAlign: { default: "center" },
    spacing: { default: "4" },
    wrap: { type: Boolean, default: true }
  },
  setup(__props) {
    const props = __props;
    const style2 = computed(() => {
      const fullStyles = {
        "--pc-inline-align": props.align,
        "--pc-inline-block-align": props.blockAlign,
        "--pc-inline-wrap": props.wrap ? "wrap" : "nowrap",
        "--pc-inline-spacing": `var(--p-space-${props.spacing})`
      };
      return Object.fromEntries(Object.entries(fullStyles).filter(([, value2]) => value2));
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(unref(styles$X).Inline),
        style: normalizeStyle(unref(style2))
      }, [
        renderSlot(_ctx.$slots, "default")
      ], 6);
    };
  }
});
const KeyboardKey = "Polaris-KeyboardKey";
var styles$W = {
  KeyboardKey
};
var KeyboardKey_vue_vue_type_style_index_0_lang = "";
const _sfc_main$1q = /* @__PURE__ */ defineComponent({
  setup(__props) {
    const slots = useSlots();
    const keyString = computed(() => {
      const slotText = slots.default && slots.default()[0].children ? slots.default()[0].children : "";
      if (typeof slotText === "string") {
        return slotText.length > 1 ? slotText.toLowerCase() : slotText.toUpperCase();
      }
      return slotText;
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("kbd", {
        class: normalizeClass(unref(styles$W).KeyboardKey)
      }, toDisplayString(unref(keyString)), 3);
    };
  }
});
const Label$3 = "Polaris-Label";
const hidden$1 = "Polaris-Label--hidden";
const Text$2 = "Polaris-Label__Text";
const RequiredIndicator = "Polaris-Label__RequiredIndicator";
var styles$V = {
  Label: Label$3,
  hidden: hidden$1,
  Text: Text$2,
  RequiredIndicator
};
var Label_vue_vue_type_style_index_0_lang = "";
const _hoisted_1$B = ["id", "for"];
const _sfc_main$1p = /* @__PURE__ */ defineComponent({
  props: {
    id: null,
    hidden: { type: Boolean },
    requiredIndicator: { type: Boolean }
  },
  setup(__props) {
    const props = __props;
    const className = computed(() => classNames(styles$V.Label, props.hidden && styles$V.hidden));
    const labelClassName = computed(() => classNames(styles$V.Text, props.requiredIndicator && styles$V.RequiredIndicator));
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(unref(className))
      }, [
        createElementVNode("label", {
          id: unref(labelID)(__props.id),
          for: __props.id,
          class: normalizeClass(unref(labelClassName))
        }, [
          createVNode(unref(Text), {
            as: "span",
            variant: "bodyMd"
          }, {
            default: withCtx(() => [
              renderSlot(_ctx.$slots, "default")
            ]),
            _: 3
          })
        ], 10, _hoisted_1$B)
      ], 2);
    };
  }
});
const hidden = "Polaris-Labelled--hidden";
const LabelWrapper = "Polaris-Labelled__LabelWrapper";
const HelpText = "Polaris-Labelled__HelpText";
const Action$4 = "Polaris-Labelled__Action";
var styles$U = {
  hidden,
  LabelWrapper,
  HelpText,
  "Error": "Polaris-Labelled__Error",
  Action: Action$4
};
var Labelled_vue_vue_type_style_index_0_lang = "";
const _hoisted_1$A = ["id"];
const _sfc_main$1o = /* @__PURE__ */ defineComponent({
  props: {
    id: null,
    error: null,
    action: null,
    labelHidden: { type: Boolean },
    requiredIndicator: { type: Boolean },
    label: null,
    helpText: null
  },
  setup(__props) {
    const props = __props;
    const isError = computed(() => props.error && typeof props.error !== "boolean");
    const className = computed(() => classNames(props.labelHidden && styles$U.hidden));
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(unref(className))
      }, [
        _ctx.$slots.label || __props.label ? (openBlock(), createElementBlock("div", {
          key: 0,
          class: normalizeClass(unref(styles$U).LabelWrapper)
        }, [
          createVNode(unref(_sfc_main$1p), {
            id: __props.id,
            requiredIndicator: __props.requiredIndicator,
            hidden: false
          }, {
            default: withCtx(() => [
              _ctx.$slots.label ? renderSlot(_ctx.$slots, "label", { key: 0 }) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
                createTextVNode(toDisplayString(__props.label), 1)
              ], 64))
            ]),
            _: 3
          }, 8, ["id", "requiredIndicator"]),
          __props.action ? (openBlock(), createElementBlock("div", {
            key: 0,
            class: normalizeClass(unref(styles$U).Action)
          }, [
            createVNode(unref(_sfc_main$2E), {
              action: __props.action,
              overrides: { plain: true }
            }, null, 8, ["action"])
          ], 2)) : createCommentVNode("", true)
        ], 2)) : createCommentVNode("", true),
        renderSlot(_ctx.$slots, "default"),
        unref(isError) ? (openBlock(), createElementBlock("div", {
          key: 1,
          class: normalizeClass(unref(styles$U).Error)
        }, [
          typeof __props.error === "string" ? (openBlock(), createBlock(unref(_sfc_main$2u), {
            key: 0,
            message: __props.error,
            fieldID: unref(errorID)(__props.id)
          }, null, 8, ["message", "fieldID"])) : (openBlock(), createBlock(resolveDynamicComponent(__props.error), { key: 1 }))
        ], 2)) : createCommentVNode("", true),
        _ctx.$slots["help-text"] || __props.helpText ? (openBlock(), createElementBlock("div", {
          key: 2,
          class: normalizeClass(unref(styles$U).HelpText),
          id: unref(helpTextID$1)(__props.id)
        }, [
          createVNode(unref(Text), {
            as: "span",
            variant: "bodyMd",
            color: "subdued",
            "break-word": ""
          }, {
            default: withCtx(() => [
              _ctx.$slots["help-text"] ? renderSlot(_ctx.$slots, "help-text", { key: 0 }) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
                createTextVNode(toDisplayString(__props.helpText), 1)
              ], 64))
            ]),
            _: 3
          })
        ], 10, _hoisted_1$A)) : createCommentVNode("", true)
      ], 2);
    };
  }
});
const Layout = "Polaris-Layout";
const Section$4 = "Polaris-Layout__Section";
const AnnotatedSection = "Polaris-Layout__AnnotatedSection";
const AnnotationWrapper = "Polaris-Layout__AnnotationWrapper";
const AnnotationContent = "Polaris-Layout__AnnotationContent";
const Annotation = "Polaris-Layout__Annotation";
var styles$T = {
  Layout,
  Section: Section$4,
  "Section-secondary": "Polaris-Layout__Section--secondary",
  "Section-fullWidth": "Polaris-Layout__Section--fullWidth",
  "Section-oneHalf": "Polaris-Layout__Section--oneHalf",
  "Section-oneThird": "Polaris-Layout__Section--oneThird",
  AnnotatedSection,
  AnnotationWrapper,
  AnnotationContent,
  Annotation
};
const _sfc_main$1n = /* @__PURE__ */ defineComponent({
  props: {
    secondary: { type: Boolean },
    fullWidth: { type: Boolean },
    oneHalf: { type: Boolean },
    oneThird: { type: Boolean }
  },
  setup(__props) {
    const props = __props;
    const className = computed(() => classNames(styles$T.Section, props.secondary && styles$T["Section-secondary"], props.fullWidth && styles$T["Section-fullWidth"], props.oneHalf && styles$T["Section-oneHalf"], props.oneThird && styles$T["Section-oneThird"]));
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(unref(className))
      }, [
        renderSlot(_ctx.$slots, "default")
      ], 2);
    };
  }
});
const _sfc_main$1m = /* @__PURE__ */ defineComponent({
  props: {
    id: null
  },
  setup(__props) {
    const slots = useSlots();
    const descriptionSlot = computed(() => {
      var _a;
      return (_a = slots.description) == null ? void 0 : _a.call(slots);
    });
    const isDescriptionSlotContainHTMLTag = computed(() => Boolean(descriptionSlot.value && (descriptionSlot.value.length >= 2 || descriptionSlot.value[0] && (descriptionSlot.value[0].type.toString() !== "Symbol(Text)" || descriptionSlot.value[0].type.toString() !== "Symbol()"))));
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(unref(styles$T).AnnotatedSection)
      }, [
        createElementVNode("div", {
          class: normalizeClass(unref(styles$T).AnnotationWrapper)
        }, [
          createElementVNode("div", {
            class: normalizeClass(unref(styles$T).Annotation)
          }, [
            createVNode(unref(_sfc_main$c), null, {
              default: withCtx(() => [
                createVNode(unref(Text), {
                  id: __props.id,
                  variant: "headingMd",
                  as: "h2"
                }, {
                  default: withCtx(() => [
                    renderSlot(_ctx.$slots, "title")
                  ]),
                  _: 3
                }, 8, ["id"]),
                !unref(isDescriptionSlotContainHTMLTag) ? (openBlock(), createBlock(unref(_sfc_main$2V), {
                  key: 0,
                  color: "text-subdued"
                }, {
                  default: withCtx(() => [
                    renderSlot(_ctx.$slots, "description")
                  ]),
                  _: 3
                })) : renderSlot(_ctx.$slots, "description", { key: 1 })
              ]),
              _: 3
            })
          ], 2),
          createElementVNode("div", {
            class: normalizeClass(unref(styles$T).AnnotationContent)
          }, [
            renderSlot(_ctx.$slots, "default")
          ], 2)
        ], 2)
      ], 2);
    };
  }
});
var Layout_vue_vue_type_style_index_0_lang = "";
const _sfc_main$1l = /* @__PURE__ */ defineComponent({
  props: {
    sectioned: { type: Boolean }
  },
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(unref(styles$T).Layout)
      }, [
        __props.sectioned ? (openBlock(), createBlock(unref(_sfc_main$1n), { key: 0 }, {
          default: withCtx(() => [
            renderSlot(_ctx.$slots, "default")
          ]),
          _: 3
        })) : renderSlot(_ctx.$slots, "default", { key: 1 })
      ], 2);
    };
  }
});
const Link$2 = "Polaris-Link";
const monochrome = "Polaris-Link--monochrome";
const removeUnderline = "Polaris-Link--removeUnderline";
var styles$S = {
  Link: Link$2,
  monochrome,
  removeUnderline
};
var Link_vue_vue_type_style_index_0_lang = "";
const _hoisted_1$z = ["id", "aria-label", "data-primary-link"];
const __default__$3 = {
  inheritAttrs: false
};
const _sfc_main$1k = /* @__PURE__ */ defineComponent(__spreadProps(__spreadValues({}, __default__$3), {
  props: {
    id: null,
    url: null,
    to: null,
    external: { type: Boolean },
    monochrome: { type: Boolean },
    removeUnderline: { type: Boolean },
    accessibilityLabel: null,
    dataPrimaryLink: { type: Boolean }
  },
  setup(__props) {
    const props = __props;
    const BannerContext = inject("BannerContext", false);
    const shouldBeMonochrome = computed(() => props.monochrome || BannerContext);
    const className = computed(() => classNames(styles$S.Link, shouldBeMonochrome.value && styles$S.monochrome, props.removeUnderline && styles$S.removeUnderline));
    return (_ctx, _cache) => {
      return __props.url || __props.to ? (openBlock(), createBlock(unref(_sfc_main$3m), {
        key: 0,
        id: __props.id,
        to: __props.to,
        url: __props.url,
        class: normalizeClass(unref(className)),
        external: __props.external,
        "aria-label": __props.accessibilityLabel,
        "data-primary-link": __props.dataPrimaryLink,
        onClick: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("click"))
      }, {
        default: withCtx(() => [
          renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }, 8, ["id", "to", "url", "class", "external", "aria-label", "data-primary-link"])) : (openBlock(), createElementBlock("button", {
        key: 1,
        id: __props.id,
        type: "button",
        class: normalizeClass(unref(className)),
        "aria-label": __props.accessibilityLabel,
        "data-primary-link": __props.dataPrimaryLink,
        onClick: _cache[1] || (_cache[1] = ($event) => _ctx.$emit("click"))
      }, [
        renderSlot(_ctx.$slots, "default")
      ], 10, _hoisted_1$z));
    };
  }
}));
const List$2 = "Polaris-List";
const typeNumber = "Polaris-List--typeNumber";
const Item$3 = "Polaris-List__Item";
var styles$R = {
  List: List$2,
  typeNumber,
  Item: Item$3
};
var List_vue_vue_type_style_index_0_lang = "";
const _sfc_main$1j = /* @__PURE__ */ defineComponent({
  props: {
    type: { default: "bullet" }
  },
  setup(__props) {
    const props = __props;
    const className = computed(() => {
      const variation = variationName("type", props.type);
      return classNames(styles$R.List, props.type && styles$R[variation]);
    });
    const element = props.type === "bullet" ? "ul" : "ol";
    return (_ctx, _cache) => {
      return openBlock(), createBlock(resolveDynamicComponent(unref(element)), {
        class: normalizeClass(unref(className))
      }, {
        default: withCtx(() => [
          renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }, 8, ["class"]);
    };
  }
});
const _sfc_main$1i = /* @__PURE__ */ defineComponent({
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("li", {
        class: normalizeClass(unref(styles$R).Item)
      }, [
        renderSlot(_ctx.$slots, "default")
      ], 2);
    };
  }
});
function scrollOptionIntoView(option, scrollable2) {
  const listTop = scrollable2.scrollTop;
  const listBottom = listTop + scrollable2.clientHeight;
  const { offsetHeight: optionHeight } = option;
  const { offsetTop: optionTop } = option;
  const optionBottom = optionTop + optionHeight;
  const isVisible = optionTop > listTop && optionBottom < listBottom;
  if (!isVisible) {
    let top = 0;
    if (optionBottom > listBottom) {
      top = optionBottom + optionHeight * 0.85 - listBottom;
    } else if (optionTop < listTop) {
      top = optionTop - optionHeight * 0.15 - listTop;
    }
    requestAnimationFrame(() => {
      scrollable2.scrollBy({ top, behavior: "auto" });
    });
  }
}
const Listbox = "Polaris-Listbox";
var styles$Q = {
  Listbox
};
var Listbox_vue_vue_type_style_index_0_lang = "";
const _hoisted_1$y = { "aria-live": "polite" };
const _hoisted_2$g = ["aria-label", "aria-labelledby", "aria-busy", "asia-activedescendant", "id"];
const _sfc_main$1h = /* @__PURE__ */ defineComponent({
  props: {
    autoSelection: { default: AutoSelection.FirstSelected },
    enableKeyboardControl: { type: Boolean },
    accessibilityLabel: null,
    customListId: null
  },
  emits: ["select", "on-active-option-change"],
  setup(__props, { emit: emits }) {
    const props = __props;
    const OPTION_SELECTOR = "[data-listbox-option]";
    const OPTION_VALUE_ATTRIBUTE = "data-listbox-option-value";
    const OPTION_ACTION_ATTRIBUTE = "data-listbox-option-action";
    const OPTION_FOCUS_ATTRIBUTE = "data-focused";
    const comboboxListboxContext = inject("comboboxListboxContext", {});
    const {
      listboxId,
      textFieldLabelId,
      textFieldFocused,
      willLoadMoreOptions,
      setActiveOptionId,
      setListboxId,
      onOptionSelected,
      onKeyToBottom
    } = comboboxListboxContext;
    const slots = useSlots();
    const { useUniqueId } = UseUniqueId();
    const listId = computed(() => props.customListId || useUniqueId("Listbox"));
    const inCombobox = computed(() => Boolean(setActiveOptionId));
    const listboxRef = ref(null);
    const scrollableRef = ref(null);
    const loading2 = ref("");
    const lazyLoading = ref(false);
    const currentOptions = ref([]);
    const keyboardEventsEnabled = ref(Boolean(props.enableKeyboardControl));
    const activeOption = ref();
    const getNavigableOptions = () => {
      if (!listboxRef.value) {
        return [];
      }
      return [
        ...new Set(listboxRef.value.querySelectorAll(OPTION_SELECTOR))
      ];
    };
    const getFirstNavigableOption = (currentOpts) => {
      const hasSelectedOptions = currentOpts.some((option) => option.getAttribute("aria-selected") === "true");
      let elementIndex = 0;
      const element = currentOpts.find((option, index) => {
        const isInteractable = option.getAttribute("aria-disabled") !== "true";
        let isFirstNavigableOption;
        if (hasSelectedOptions && props.autoSelection === AutoSelection.FirstSelected) {
          const isSelected = option.getAttribute("aria-selected") === "true";
          isFirstNavigableOption = isSelected && isInteractable;
        } else {
          isFirstNavigableOption = isInteractable;
        }
        if (isFirstNavigableOption) {
          elementIndex = index;
        }
        return isFirstNavigableOption;
      });
      if (!element) {
        return;
      }
      return { element, index: elementIndex };
    };
    const handleScrollIntoView = (option) => {
      if (scrollableRef.value) {
        scrollOptionIntoView(option.element, scrollableRef.value);
      }
    };
    const handleScrollIntoViewDebounced = debounce(handleScrollIntoView, 50);
    const handleKeyToBottom = () => {
      if (onKeyToBottom) {
        lazyLoading.value = true;
        return Promise.resolve(onKeyToBottom());
      }
    };
    const handleChangeActiveOption = (nextOption) => {
      var _a;
      if (!nextOption) {
        activeOption.value = void 0;
      } else {
        (_a = activeOption.value) == null ? void 0 : _a.element.removeAttribute(OPTION_FOCUS_ATTRIBUTE);
        nextOption == null ? void 0 : nextOption.element.setAttribute(OPTION_FOCUS_ATTRIBUTE, "true");
        handleScrollIntoViewDebounced(nextOption);
        activeOption.value = nextOption;
        setActiveOptionId == null ? void 0 : setActiveOptionId(nextOption.domId);
        emits("on-active-option-change", nextOption.value);
      }
    };
    const getFormattedOption = (element, index) => {
      return {
        element,
        index,
        domId: element.id,
        value: element.getAttribute(OPTION_VALUE_ATTRIBUTE) || "",
        disabled: element.getAttribute("aria-disabled") === "true",
        isAction: element.getAttribute(OPTION_ACTION_ATTRIBUTE) === "true"
      };
    };
    const resetActiveOption = () => {
      var _a, _b;
      let nextOption;
      const nextOptions = getNavigableOptions();
      const nextActiveOption = getFirstNavigableOption(nextOptions);
      if (nextOptions.length === 0 && currentOptions.value.length > 0) {
        currentOptions.value = nextOptions;
        handleChangeActiveOption();
        return;
      }
      if (nextActiveOption) {
        const { element, index } = nextActiveOption;
        nextOption = getFormattedOption(element, index);
      }
      const optionIsAlreadyActive = activeOption.value !== void 0 && (nextOption == null ? void 0 : nextOption.domId) === ((_a = activeOption.value) == null ? void 0 : _a.domId);
      const actionContentHasUpdated = ((_b = activeOption.value) == null ? void 0 : _b.isAction) && (nextOption == null ? void 0 : nextOption.isAction) && (nextOption == null ? void 0 : nextOption.value) !== (activeOption == null ? void 0 : activeOption.value);
      const currentValues = currentOptions.value.map((option) => option.getAttribute(OPTION_VALUE_ATTRIBUTE));
      const nextValues = nextOptions.map((option) => option.getAttribute(OPTION_VALUE_ATTRIBUTE));
      const listIsUnchanged = nextValues.length === currentValues.length && nextValues.every((value2, index) => {
        return currentValues[index] === value2;
      });
      if (listIsUnchanged) {
        if (optionIsAlreadyActive && actionContentHasUpdated) {
          currentOptions.value = nextOptions;
          handleChangeActiveOption(nextOption);
        }
        return;
      }
      const listIsAppended = currentValues.length !== 0 && nextValues.length > currentValues.length && currentValues.every((value2, index) => {
        return nextValues[index] === value2;
      });
      if (listIsAppended) {
        currentOptions.value = nextOptions;
        return;
      }
      currentOptions.value = nextOptions;
      if (lazyLoading.value) {
        lazyLoading.value = false;
        return;
      }
      handleChangeActiveOption(nextOption);
    };
    const getNextValidOption = async (key) => {
      var _a, _b;
      const lastIndex = currentOptions.value.length - 1;
      let currentIndex = ((_a = activeOption.value) == null ? void 0 : _a.index) || 0;
      let nextIndex = 0;
      let element = (_b = activeOption.value) == null ? void 0 : _b.element;
      let totalOptions = -1;
      if (!activeOption.value && props.autoSelection === AutoSelection.None) {
        const nextOptions = getNavigableOptions();
        const nextActiveOption = getFirstNavigableOption(nextOptions);
        currentOptions.value = nextOptions;
        const {
          tmpElement,
          index
        } = nextActiveOption;
        return {
          element: tmpElement,
          nextIndex: index || 0
        };
      }
      while (totalOptions++ < lastIndex) {
        nextIndex = getNextIndex(currentIndex, lastIndex, key);
        element = currentOptions.value[nextIndex];
        const triggerLazyLoad = nextIndex >= lastIndex;
        const isDisabled2 = (element == null ? void 0 : element.getAttribute("aria-disabled")) === "true";
        if (triggerLazyLoad && (willLoadMoreOptions == null ? void 0 : willLoadMoreOptions.value)) {
          await handleKeyToBottom();
        }
        if (isDisabled2) {
          currentIndex = nextIndex;
          element = void 0;
          continue;
        }
        break;
      }
      return { element, nextIndex };
    };
    const handleArrow = async (type, event) => {
      event.preventDefault();
      const { element, nextIndex } = await getNextValidOption(type);
      if (!element) {
        return;
      }
      const nextOption = getFormattedOption(element, nextIndex);
      handleChangeActiveOption(nextOption);
    };
    const handleDownArrow = (event) => {
      handleArrow("down", event);
    };
    const handleUpArrow = (event) => {
      handleArrow("up", event);
    };
    const handleEnter = (event) => {
      event.preventDefault();
      event.stopPropagation();
      if (activeOption.value) {
        onOptionSelect(activeOption.value);
      }
    };
    const handleFocus = () => {
      if (props.enableKeyboardControl) {
        return;
      }
      keyboardEventsEnabled.value = true;
    };
    const handleBlur = (event) => {
      event.stopPropagation();
      if (keyboardEventsEnabled.value) {
        const nextActiveOption = getFirstNavigableOption(currentOptions.value);
        if (nextActiveOption) {
          const { element, index } = nextActiveOption;
          const nextOption = getFormattedOption(element, index);
          handleChangeActiveOption(nextOption);
        }
      }
      if (props.enableKeyboardControl) {
        return;
      }
      keyboardEventsEnabled.value = false;
    };
    const setLoading = (value2) => {
      loading2.value = value2;
    };
    const getNextIndex = (currentIndex, lastIndex, direction) => {
      let nextIndex;
      if (direction === "down") {
        if (currentIndex === lastIndex) {
          nextIndex = (willLoadMoreOptions == null ? void 0 : willLoadMoreOptions.value) ? currentIndex + 1 : 0;
        } else {
          nextIndex = currentIndex + 1;
        }
      } else {
        nextIndex = currentIndex === 0 ? lastIndex : currentIndex - 1;
      }
      return nextIndex;
    };
    const onOptionSelect = (option) => {
      handleChangeActiveOption(option);
      if (onOptionSelected) {
        onOptionSelected();
      }
      emits("select", option.value);
    };
    provide("listboxContext", { onOptionSelect, setLoading });
    provide("withinListboxContext", true);
    onUpdated(() => {
      if (listboxRef.value) {
        scrollableRef.value = listboxRef.value.closest(scrollable.selector);
      }
    });
    onMounted(() => {
      if (props.autoSelection !== AutoSelection.None && !loading2.value && slots.default && slots.default().length > 0) {
        resetActiveOption();
      }
      if (props.enableKeyboardControl && !keyboardEventsEnabled.value) {
        keyboardEventsEnabled.value = true;
      }
      if (setListboxId && !(listboxId == null ? void 0 : listboxId.value)) {
        setListboxId(listId.value);
      }
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock(Fragment, null, [
        keyboardEventsEnabled.value || unref(textFieldFocused) ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
          createVNode(unref(_sfc_main$3p), {
            keyEvent: "keydown",
            keyCode: unref(Key).ArrowDown,
            handler: handleDownArrow
          }, null, 8, ["keyCode"]),
          createVNode(unref(_sfc_main$3p), {
            keyEvent: "keydown",
            keyCode: unref(Key).ArrowUp,
            handler: handleUpArrow
          }, null, 8, ["keyCode"]),
          createVNode(unref(_sfc_main$3p), {
            keyEvent: "keydown",
            keyCode: unref(Key).Enter,
            handler: handleEnter
          }, null, 8, ["keyCode"])
        ], 64)) : createCommentVNode("", true),
        createVNode(unref(Text), {
          variant: "bodySm",
          as: "span",
          "visually-hidden": ""
        }, {
          default: withCtx(() => [
            createElementVNode("div", _hoisted_1$y, toDisplayString(loading2.value ? loading2.value : null), 1)
          ]),
          _: 1
        }),
        _ctx.$slots.default ? (openBlock(), createElementBlock("ul", {
          key: 1,
          tabindex: "0",
          role: "listbox",
          class: normalizeClass(unref(classNames)(unref(styles$Q).Listbox)),
          "aria-label": unref(inCombobox) ? void 0 : __props.accessibilityLabel,
          "aria-labelledby": unref(textFieldLabelId) || void 0,
          "aria-busy": Boolean(loading2.value),
          "asia-activedescendant": activeOption.value && activeOption.value.domId,
          id: unref(listId),
          onFocus: handleFocus,
          onBlur: handleBlur,
          ref_key: "listboxRef",
          ref: listboxRef
        }, [
          renderSlot(_ctx.$slots, "default")
        ], 42, _hoisted_2$g)) : createCommentVNode("", true)
      ], 64);
    };
  }
});
const Action$3 = "Polaris-Listbox-Action";
const ActionDivider = "Polaris-Listbox-Action__ActionDivider";
const Icon$4 = "Polaris-Listbox-Action__Icon";
var styles$P = {
  Action: Action$3,
  ActionDivider,
  Icon: Icon$4
};
const listboxSectionDataSelector = {
  props: { "data-polaris-listbox-section-item": true },
  selector: "[data-polaris-listbox-section-item]"
};
const listboxWithinSectionDataSelector = {
  attribute: "data-polaris-listbox-within-section-item"
};
const Option$1 = "Polaris-Listbox-Option";
const divider$1 = "Polaris-Listbox-Option--divider";
var styles$O = {
  Option: Option$1,
  divider: divider$1
};
const TextOption = "Polaris-Listbox-TextOption";
const allowMultiple = "Polaris-Listbox-TextOption--allowMultiple";
const isAction = "Polaris-Listbox-TextOption--isAction";
const selected$2 = "Polaris-Listbox-TextOption--selected";
const disabled$5 = "Polaris-Listbox-TextOption--disabled";
const Content$4 = "Polaris-Listbox-TextOption__Content";
const Checkbox$2 = "Polaris-Listbox-TextOption__Checkbox";
var styles$N = {
  TextOption,
  allowMultiple,
  isAction,
  selected: selected$2,
  disabled: disabled$5,
  Content: Content$4,
  Checkbox: Checkbox$2
};
var TextOption_vue_vue_type_style_index_0_lang = "";
const _sfc_main$1g = /* @__PURE__ */ defineComponent({
  props: {
    selected: { type: Boolean },
    disabled: { type: Boolean }
  },
  setup(__props) {
    const props = __props;
    const { allowMultiple: allowMultiple2 } = inject("comboboxListboxOptionContext", {});
    const isAction2 = inject("actionContext", false);
    const textOptionClassName = computed(() => classNames(styles$N.TextOption, props.selected && !allowMultiple2 && styles$N.selected, props.disabled && styles$N.disabled, allowMultiple2 && styles$N.allowMultiple, isAction2 && styles$N.isAction));
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(unref(textOptionClassName))
      }, [
        createElementVNode("div", {
          class: normalizeClass(unref(styles$N).Content)
        }, [
          unref(allowMultiple2) && !unref(isAction2) ? (openBlock(), createElementBlock("div", {
            key: 0,
            class: normalizeClass(unref(styles$N).Checkbox)
          }, [
            createVNode(unref(_sfc_main$2s), {
              disabled: __props.disabled,
              checked: __props.selected
            }, {
              label: withCtx(() => [
                renderSlot(_ctx.$slots, "default")
              ]),
              _: 3
            }, 8, ["disabled", "checked"])
          ], 2)) : renderSlot(_ctx.$slots, "default", { key: 1 })
        ], 2)
      ], 2);
    };
  }
});
var Option_vue_vue_type_style_index_0_lang$1 = "";
const _hoisted_1$x = ["id", "role", "data-within-section", "data-listbox-option-value", "data-listbox-option-action", "data-listbox-option-destructive", "aria-disabled", "aria-label", "aria-selected"];
const _sfc_main$1f = /* @__PURE__ */ defineComponent({
  props: {
    value: null,
    accessibilityLabel: null,
    selected: { type: Boolean },
    disabled: { type: Boolean },
    divider: { type: Boolean }
  },
  setup(__props) {
    const props = __props;
    const mappedActionContext = inject("mappedActionContext", {});
    const sectionContext = inject("sectionContext", "");
    const listboxContext = inject("listboxContext", {
      onOptionSelect(option) {
        return;
      },
      setLoading(label) {
        return;
      }
    });
    const isAction2 = inject("isAction", false);
    const { role, url, external, onAction, destructive: destructive2 } = mappedActionContext;
    const { onOptionSelect } = listboxContext;
    const slots = useSlots();
    const listItemRef = ref(null);
    const { useUniqueId } = UseUniqueId();
    const domId = useUniqueId("ListboxOption");
    const isWithinSection = computed(() => Boolean(sectionContext));
    const sectionAttributes = {
      [listboxWithinSectionDataSelector.attribute]: isWithinSection.value
    };
    const isSlotContainHTMLTag = computed(() => {
      return Boolean(slots.default && (slots.default().length >= 2 || slots.default()[0] && (slots.default()[0].type.toString() !== "Symbol(Text)" && slots.default()[0].type.toString() !== "Symbol()")));
    });
    const legacyRoleSupport = computed(() => role || "option");
    const className = computed(() => classNames(styles$O.Option, props.divider && styles$O.divider));
    const handleOptionSelect = (event) => {
      event.preventDefault();
      event.stopPropagation();
      onAction && onAction();
      if (listItemRef.value && !onAction) {
        onOptionSelect({
          domId,
          value: props.value,
          element: listItemRef.value,
          disabled: props.disabled || false
        });
      }
    };
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("li", mergeProps(sectionAttributes, {
        id: unref(domId),
        class: unref(className),
        ref_key: "listItemRef",
        ref: listItemRef,
        role: unref(legacyRoleSupport),
        "data-within-section": unref(isWithinSection),
        "data-listbox-option-value": __props.value,
        "data-listbox-option-action": unref(isAction2),
        "data-listbox-option-destructive": unref(destructive2),
        "aria-disabled": __props.disabled,
        "aria-label": __props.accessibilityLabel,
        "aria-selected": __props.selected,
        onClick: _cache[0] || (_cache[0] = ($event) => __props.disabled ? void 0 : handleOptionSelect),
        onKeydown: _cache[1] || (_cache[1] = ($event) => __props.disabled ? void 0 : handleOptionSelect),
        onMousedown: handleOptionSelect,
        tabindex: "-1",
        "data-listbox-option": ""
      }), [
        unref(url) ? (openBlock(), createBlock(unref(_sfc_main$3m), {
          key: 0,
          url: unref(url),
          external: unref(external)
        }, {
          default: withCtx(() => [
            !unref(isSlotContainHTMLTag) ? (openBlock(), createBlock(unref(_sfc_main$1g), {
              key: 0,
              selected: __props.selected,
              disabled: __props.disabled
            }, {
              default: withCtx(() => [
                renderSlot(_ctx.$slots, "default")
              ]),
              _: 3
            }, 8, ["selected", "disabled"])) : renderSlot(_ctx.$slots, "default", { key: 1 })
          ]),
          _: 3
        }, 8, ["url", "external"])) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
          !unref(isSlotContainHTMLTag) ? (openBlock(), createBlock(unref(_sfc_main$1g), {
            key: 0,
            selected: __props.selected,
            disabled: __props.disabled
          }, {
            default: withCtx(() => [
              renderSlot(_ctx.$slots, "default")
            ]),
            _: 3
          }, 8, ["selected", "disabled"])) : renderSlot(_ctx.$slots, "default", { key: 1 })
        ], 64))
      ], 16, _hoisted_1$x);
    };
  }
});
var Action_vue_vue_type_style_index_0_lang = "";
const _sfc_main$1e = /* @__PURE__ */ defineComponent({
  props: {
    value: null,
    accessibilityLabel: null,
    selected: { type: Boolean },
    disabled: { type: Boolean },
    divider: { type: Boolean },
    icon: null
  },
  setup(__props) {
    const props = __props;
    provide("actionContext", true);
    const className = computed(() => classNames(styles$P.Action, props.divider && styles$P.ActionDivider));
    return (_ctx, _cache) => {
      return openBlock(), createBlock(unref(_sfc_main$1f), normalizeProps(guardReactiveProps(props)), {
        default: withCtx(() => [
          createElementVNode("div", {
            class: normalizeClass(unref(className))
          }, [
            createVNode(unref(_sfc_main$1g), {
              selected: __props.selected,
              disabled: __props.disabled
            }, {
              default: withCtx(() => [
                __props.icon ? (openBlock(), createElementBlock("div", {
                  key: 0,
                  class: normalizeClass(unref(styles$P).Icon)
                }, [
                  createVNode(unref(_sfc_main$2K), {
                    color: "subdued",
                    source: __props.icon
                  }, null, 8, ["source"])
                ], 2)) : createCommentVNode("", true),
                renderSlot(_ctx.$slots, "default")
              ]),
              _: 3
            }, 8, ["selected", "disabled"])
          ], 2)
        ]),
        _: 3
      }, 16);
    };
  }
});
const _hoisted_1$w = ["id"];
const _sfc_main$1d = /* @__PURE__ */ defineComponent({
  setup(__props) {
    const sectionContext = inject("sectionContext", "");
    const slots = useSlots();
    const defaultSlot = computed(() => {
      var _a;
      return (_a = slots.default) == null ? void 0 : _a.call(slots);
    });
    const isSlotContainHTMLTag = computed(() => {
      if (!defaultSlot.value) {
        return false;
      }
      if (defaultSlot.value.length > 1) {
        return true;
      }
      if (defaultSlot.value[0] && defaultSlot.value[0].type.toString() !== "Symbol(Text)" && defaultSlot.value[0].type.toString() !== "Symbol()") {
        return true;
      }
      return false;
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        id: unref(sectionContext),
        "aria-hidden": ""
      }, [
        !unref(isSlotContainHTMLTag) ? (openBlock(), createBlock(unref(_sfc_main$2V), {
          key: 0,
          "padding-block-start": "2",
          "padding-inline-start": "4",
          "padding-block-end": "2",
          "padding-inline-end": "4"
        }, {
          default: withCtx(() => [
            createVNode(unref(Text), {
              as: "span",
              variant: "headingXs",
              color: "subdued"
            }, {
              default: withCtx(() => [
                renderSlot(_ctx.$slots, "default")
              ]),
              _: 3
            })
          ]),
          _: 3
        })) : renderSlot(_ctx.$slots, "default", { key: 1 })
      ], 8, _hoisted_1$w);
    };
  }
});
const ListItem$2 = "Polaris-Listbox-Loading__ListItem";
const Loading = "Polaris-Listbox-Loading";
var styles$M = {
  ListItem: ListItem$2,
  Loading
};
var Loading_vue_vue_type_style_index_0_lang = "";
const _sfc_main$1c = /* @__PURE__ */ defineComponent({
  props: {
    accessibilityLabel: null
  },
  setup(__props) {
    const props = __props;
    const listboxContext = inject("listboxContext", {
      onOptionSelect(option) {
        return;
      },
      setLoading(label) {
        return;
      }
    });
    const { setLoading } = listboxContext;
    watch(() => props.accessibilityLabel, () => {
      setLoading(props.accessibilityLabel);
      return () => setLoading(void 0);
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("li", {
        class: normalizeClass(unref(styles$M).ListItem),
        role: "presentation"
      }, [
        _ctx.$slots.default ? renderSlot(_ctx.$slots, "default", { key: 0 }) : (openBlock(), createElementBlock("div", {
          key: 1,
          class: normalizeClass(unref(styles$M).Loading)
        }, [
          createVNode(unref(_sfc_main$2H), {
            size: "small",
            accessibilityLabel: __props.accessibilityLabel
          }, null, 8, ["accessibilityLabel"])
        ], 2))
      ], 2);
    };
  }
});
const SectionGroup = "Polaris-Listbox-Section__SectionGroup";
const noDivider = "Polaris-Listbox-Section--noDivider";
var styles$L = {
  SectionGroup,
  noDivider
};
var Section_vue_vue_type_style_index_0_lang$1 = "";
const _hoisted_1$v = ["aria-labelledby"];
const _sfc_main$1b = /* @__PURE__ */ defineComponent({
  props: {
    divider: { type: Boolean }
  },
  setup(__props) {
    const props = __props;
    const { useUniqueId } = UseUniqueId();
    const sectionId = useUniqueId("ListboxSection");
    provide("sectionContext", sectionId);
    const className = computed(() => classNames(styles$L.SectionGroup, !props.divider && styles$L.noDivider));
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("li", mergeProps({ role: "presentation" }, unref(listboxSectionDataSelector)), [
        renderSlot(_ctx.$slots, "title"),
        createElementVNode("ul", {
          role: "group",
          "aria-labelledby": unref(sectionId),
          class: normalizeClass(unref(className))
        }, [
          renderSlot(_ctx.$slots, "default")
        ], 10, _hoisted_1$v)
      ], 16);
    };
  }
});
const _sfc_main$1a = /* @__PURE__ */ defineComponent({
  setup(__props) {
    const { useFrame } = UseFrame();
    const {
      startLoading,
      stopLoading
    } = useFrame();
    onMounted(() => {
      startLoading();
    });
    onBeforeUnmount(() => {
      stopLoading();
    });
    return (_ctx, _cache) => {
      return null;
    };
  }
});
const MediaCard = "Polaris-MediaCard";
const portrait = "Polaris-MediaCard--portrait";
const MediaContainer = "Polaris-MediaCard__MediaContainer";
const sizeSmall$5 = "Polaris-MediaCard--sizeSmall";
const InfoContainer = "Polaris-MediaCard__InfoContainer";
const Popover = "Polaris-MediaCard__Popover";
const Heading = "Polaris-MediaCard__Heading";
const PrimaryAction$1 = "Polaris-MediaCard__PrimaryAction";
const SecondaryAction$1 = "Polaris-MediaCard__SecondaryAction";
const ActionContainer = "Polaris-MediaCard__ActionContainer";
var styles$K = {
  MediaCard,
  portrait,
  MediaContainer,
  sizeSmall: sizeSmall$5,
  InfoContainer,
  Popover,
  Heading,
  PrimaryAction: PrimaryAction$1,
  SecondaryAction: SecondaryAction$1,
  ActionContainer
};
var MediaCard_vue_vue_type_style_index_0_lang = "";
const _sfc_main$19 = /* @__PURE__ */ defineComponent({
  props: {
    title: null,
    description: null,
    primaryAction: null,
    secondaryAction: null,
    popoverActions: { default: () => [] },
    portrait: { type: Boolean, default: false },
    size: { default: "medium" }
  },
  setup(__props) {
    const props = __props;
    const popoverActive = ref(false);
    const i18n = UseI18n();
    const slots = useSlots();
    const actionClassName = computed(() => classNames(styles$K.ActionContainer, props.portrait && styles$K.portrait));
    const mediaCardClassName = computed(() => classNames(styles$K.MediaCard, props.portrait && styles$K.portrait));
    const mediaContainerClassName = computed(() => classNames(styles$K.MediaContainer, props.portrait && styles$K.portrait, props.size === "small" && styles$K.sizeSmall));
    const infoContainerClassName = computed(() => classNames(styles$K.InfoContainer, props.portrait && styles$K.portrait, props.size === "small" && styles$K.sizeSmall));
    const togglePopoverActive = () => {
      popoverActive.value = !popoverActive.value;
    };
    return (_ctx, _cache) => {
      return openBlock(), createBlock(unref(_sfc_main$2w), null, {
        default: withCtx(() => [
          createElementVNode("div", {
            class: normalizeClass(unref(mediaCardClassName))
          }, [
            createElementVNode("div", {
              class: normalizeClass(unref(mediaContainerClassName))
            }, [
              renderSlot(_ctx.$slots, "default")
            ], 2),
            createElementVNode("div", {
              class: normalizeClass(unref(infoContainerClassName))
            }, [
              createVNode(unref(_sfc_main$2y), null, {
                default: withCtx(() => [
                  __props.popoverActions.length > 0 ? (openBlock(), createElementBlock("div", {
                    key: 0,
                    class: normalizeClass(unref(styles$K).Popover)
                  }, [
                    createVNode(unref(_sfc_main$2L), {
                      active: popoverActive.value,
                      preferredAlignment: "left",
                      preferredPosition: "below",
                      onClose: togglePopoverActive
                    }, {
                      content: withCtx(() => [
                        createVNode(unref(_sfc_main$3h), {
                          items: __props.popoverActions,
                          onActionAnyItem: togglePopoverActive
                        }, createSlots({ _: 2 }, [
                          renderList(__props.popoverActions, ({ prefixId }) => {
                            return {
                              name: `prefix-${prefixId}`,
                              fn: withCtx(() => [
                                renderSlot(_ctx.$slots, `prefix-${prefixId}`)
                              ])
                            };
                          }),
                          renderList(__props.popoverActions, ({ suffixId }) => {
                            return {
                              name: `suffix-${suffixId}`,
                              fn: withCtx(() => [
                                renderSlot(_ctx.$slots, `suffix-${suffixId}`)
                              ])
                            };
                          })
                        ]), 1032, ["items"])
                      ]),
                      activator: withCtx(() => [
                        createVNode(unref(_sfc_main$2F), {
                          icon: unref(HorizontalDotsMinor),
                          size: "slim",
                          plain: true,
                          accessibilityLabel: unref(i18n).translate("Polaris.MediaCard.popoverActivatorLabel"),
                          onClick: togglePopoverActive
                        }, null, 8, ["icon", "accessibilityLabel"])
                      ]),
                      _: 3
                    }, 8, ["active"])
                  ], 2)) : createCommentVNode("", true),
                  createVNode(unref(_sfc_main$12), {
                    vertical: true,
                    spacing: "tight"
                  }, {
                    default: withCtx(() => [
                      createElementVNode("div", {
                        class: normalizeClass(unref(styles$K).Heading)
                      }, [
                        unref(hasSlot)(unref(slots).title) ? renderSlot(_ctx.$slots, "title", { key: 0 }) : (openBlock(), createBlock(unref(Text), {
                          key: 1,
                          variant: "headingMd",
                          as: "h2"
                        }, {
                          default: withCtx(() => [
                            createTextVNode(toDisplayString(__props.title), 1)
                          ]),
                          _: 1
                        }))
                      ], 2),
                      createElementVNode("p", null, toDisplayString(__props.description), 1),
                      __props.primaryAction || __props.secondaryAction ? (openBlock(), createElementBlock("div", {
                        key: 0,
                        class: normalizeClass(unref(actionClassName))
                      }, [
                        createVNode(unref(_sfc_main$2C), null, {
                          default: withCtx(() => [
                            __props.primaryAction ? (openBlock(), createElementBlock("div", {
                              key: 0,
                              class: normalizeClass(unref(styles$K).PrimaryAction)
                            }, [
                              createVNode(unref(_sfc_main$2E), { action: __props.primaryAction }, null, 8, ["action"])
                            ], 2)) : createCommentVNode("", true),
                            __props.secondaryAction ? (openBlock(), createElementBlock("div", {
                              key: 1,
                              class: normalizeClass(unref(styles$K).SecondaryAction)
                            }, [
                              createVNode(unref(_sfc_main$2E), { action: __props.secondaryAction }, null, 8, ["action"])
                            ], 2)) : createCommentVNode("", true)
                          ]),
                          _: 1
                        })
                      ], 2)) : createCommentVNode("", true)
                    ]),
                    _: 3
                  })
                ]),
                _: 3
              })
            ], 2)
          ], 2)
        ]),
        _: 3
      });
    };
  }
});
const MessageIndicatorWrapper = "Polaris-MessageIndicator__MessageIndicatorWrapper";
const MessageIndicator = "Polaris-MessageIndicator";
var styles$J = {
  MessageIndicatorWrapper,
  MessageIndicator
};
var MessageIndicator_vue_vue_type_style_index_0_lang = "";
const _sfc_main$18 = /* @__PURE__ */ defineComponent({
  props: {
    active: { type: Boolean }
  },
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(unref(styles$J).MessageIndicatorWrapper)
      }, [
        __props.active ? (openBlock(), createElementBlock("div", {
          key: 0,
          class: normalizeClass(unref(styles$J).MessageIndicator)
        }, null, 2)) : createCommentVNode("", true),
        renderSlot(_ctx.$slots, "default")
      ], 2);
    };
  }
});
const BodyWrapper = "Polaris-Modal__BodyWrapper";
const Body = "Polaris-Modal__Body";
const IFrame = "Polaris-Modal__IFrame";
const Spinner = "Polaris-Modal__Spinner";
var styles$I = {
  BodyWrapper,
  Body,
  IFrame,
  Spinner
};
const Container$2 = "Polaris-Modal-Dialog__Container";
const Dialog = "Polaris-Modal-Dialog";
const Modal = "Polaris-Modal-Dialog__Modal";
const limitHeight = "Polaris-Modal-Dialog--limitHeight";
const sizeSmall$4 = "Polaris-Modal-Dialog--sizeSmall";
const sizeLarge$4 = "Polaris-Modal-Dialog--sizeLarge";
const fullScreen = "Polaris-Modal-Dialog--fullScreen";
const animateFadeUp = "Polaris-Modal-Dialog--animateFadeUp";
const entering = "Polaris-Modal-Dialog--entering";
const exiting = "Polaris-Modal-Dialog--exiting";
const exited = "Polaris-Modal-Dialog--exited";
const entered = "Polaris-Modal-Dialog--entered";
var styles$H = {
  Container: Container$2,
  Dialog,
  Modal,
  limitHeight,
  sizeSmall: sizeSmall$4,
  sizeLarge: sizeLarge$4,
  fullScreen,
  animateFadeUp,
  entering,
  exiting,
  exited,
  entered
};
const _sfc_main$17 = /* @__PURE__ */ defineComponent({
  props: {
    trapping: { type: Boolean, default: true }
  },
  setup(__props) {
    const props = __props;
    const { canSafelyFocus } = UseFocusManager(props);
    const wrapperNode = ref(null);
    const disableFocus = ref(true);
    watch([() => props.trapping], () => {
      disableFocus.value = canSafelyFocus.value && !(wrapperNode.value && wrapperNode.value.contains(document.activeElement)) ? !props.trapping : true;
    });
    const handleFocusIn = (event) => {
      if (!props.trapping || !wrapperNode.value || wrapperNode.value.contains(document.activeElement) || event.target instanceof Element && event.target.matches(`${portal.selector} *`)) {
        return;
      }
      if (canSafelyFocus.value && event.target instanceof HTMLElement && wrapperNode.value !== event.target && wrapperNode.value.contains(event.target)) {
        focusFirstFocusableNode(wrapperNode.value);
      }
    };
    const handleTab = (event) => {
      if (!props.trapping || !wrapperNode.value) {
        return;
      }
      const firstFocusableNode = findFirstKeyboardFocusableNode(wrapperNode.value);
      const lastFocusableNode = findLastKeyboardFocusableNode(wrapperNode.value);
      if (event.target === lastFocusableNode && !event.shiftKey) {
        event.preventDefault();
        focusFirstKeyboardFocusableNode(wrapperNode.value);
      }
      if (event.target === firstFocusableNode && event.shiftKey) {
        event.preventDefault();
        focusLastKeyboardFocusableNode(wrapperNode.value);
      }
    };
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        ref_key: "wrapperNode",
        ref: wrapperNode
      }, [
        createVNode(unref(_sfc_main$1U), {
          disabled: disableFocus.value,
          root: wrapperNode.value
        }, null, 8, ["disabled", "root"]),
        createVNode(unref(_sfc_main$33), {
          event: "focusin",
          handler: handleFocusIn
        }),
        createVNode(unref(_sfc_main$3p), {
          keyCode: unref(Key).Tab,
          keyEvent: "keydown",
          handler: handleTab
        }, null, 8, ["keyCode"]),
        renderSlot(_ctx.$slots, "default")
      ], 512);
    };
  }
});
var Dialog_vue_vue_type_style_index_0_lang = "";
const _hoisted_1$u = ["aria-labelledby"];
const _hoisted_2$f = ["aria-labelledby"];
const _sfc_main$16 = /* @__PURE__ */ defineComponent({
  props: {
    labelledBy: null,
    instant: { type: Boolean },
    limitHeight: { type: Boolean },
    large: { type: Boolean },
    small: { type: Boolean },
    fullScreen: { type: Boolean }
  },
  emits: ["close", "closing", "entered", "exited"],
  setup(__props, { emit }) {
    const props = __props;
    const dialogNode = ref(null);
    const closing = ref(false);
    const classes = computed(() => {
      return classNames(styles$H.Modal, props.small && styles$H.sizeSmall, props.large && styles$H.sizeLarge, props.limitHeight && styles$H.limitHeight, props.fullScreen && styles$H.fullScreen);
    });
    onMounted(() => {
      if (dialogNode.value && dialogNode.value.contains(document.activeElement)) {
        focusFirstFocusableNode(dialogNode.value);
      }
      emit("entered");
    });
    onBeforeUnmount(() => {
      emit("exited");
    });
    const handleKeyDown = () => {
      closing.value = true;
      emit("closing", true);
    };
    const handleKeyUp = () => {
      closing.value = false;
      emit("closing", false);
      emit("close");
    };
    return (_ctx, _cache) => {
      return __props.instant ? (openBlock(), createElementBlock("div", {
        key: 0,
        class: normalizeClass(unref(styles$H).Container),
        "data-polaris-layer": "",
        "data-polaris-overlay": "",
        ref_key: "dialogNode",
        ref: dialogNode
      }, [
        createVNode(unref(_sfc_main$17), null, {
          default: withCtx(() => [
            createElementVNode("div", {
              role: "dialog",
              "aria-modal": "",
              "aria-labelledby": __props.labelledBy,
              tabindex: "-1",
              class: normalizeClass(unref(styles$H).Dialog)
            }, [
              createElementVNode("div", {
                class: normalizeClass(unref(classes))
              }, [
                createVNode(unref(_sfc_main$3p), {
                  "key-code": unref(Key).Escape,
                  "key-event": "keydown",
                  handler: handleKeyDown
                }, null, 8, ["key-code"]),
                createVNode(unref(_sfc_main$3p), {
                  keyCode: unref(Key).Escape,
                  handler: handleKeyUp
                }, null, 8, ["keyCode"]),
                renderSlot(_ctx.$slots, "default")
              ], 2)
            ], 10, _hoisted_1$u)
          ]),
          _: 3
        })
      ], 2)) : (openBlock(), createElementBlock("div", {
        key: 1,
        class: normalizeClass(unref(styles$H).Container),
        "data-polaris-layer": "",
        "data-polaris-overlay": "",
        ref: "dialog"
      }, [
        createVNode(unref(_sfc_main$17), null, {
          default: withCtx(() => [
            createElementVNode("div", {
              role: "dialog",
              "aria-modal": "",
              "aria-labelledby": __props.labelledBy,
              tabindex: "-1",
              class: normalizeClass(unref(styles$H).Dialog)
            }, [
              createElementVNode("div", {
                class: normalizeClass(unref(classes))
              }, [
                createVNode(unref(_sfc_main$3p), {
                  keyCode: unref(Key).Escape,
                  handler: () => _ctx.$emit("close")
                }, null, 8, ["keyCode", "handler"]),
                renderSlot(_ctx.$slots, "default")
              ], 2)
            ], 10, _hoisted_2$f)
          ]),
          _: 3
        })
      ], 2));
    };
  }
});
const Header$2 = "Polaris-Modal-Header";
const titleHidden$3 = "Polaris-Modal-Header--titleHidden";
const Title$3 = "Polaris-Modal-Header__Title";
var styles$G = {
  Header: Header$2,
  titleHidden: titleHidden$3,
  Title: Title$3
};
const CloseButton = "Polaris-Modal-CloseButton";
const titleHidden$2 = "Polaris-Modal-CloseButton--titleHidden";
var styles$F = {
  CloseButton,
  titleHidden: titleHidden$2
};
var CloseButton_vue_vue_type_style_index_0_lang = "";
const _sfc_main$15 = /* @__PURE__ */ defineComponent({
  props: {
    pressed: { type: Boolean },
    titleHidden: { type: Boolean, default: false }
  },
  emits: ["click"],
  setup(__props, { emit }) {
    const props = __props;
    const className = computed(() => classNames(styles$F.CloseButton, props.titleHidden && styles$F.titleHidden));
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("button", {
        class: normalizeClass(unref(className)),
        "aria-label": "Close",
        onClick: _cache[0] || (_cache[0] = ($event) => emit("click"))
      }, [
        createVNode(unref(_sfc_main$2K), {
          source: unref(MobileCancelMajor),
          color: "base"
        }, null, 8, ["source"])
      ], 2);
    };
  }
});
var Header_vue_vue_type_style_index_0_lang$1 = "";
const _hoisted_1$t = ["id"];
const _sfc_main$14 = /* @__PURE__ */ defineComponent({
  props: {
    id: null,
    titleHidden: { type: Boolean },
    closing: { type: Boolean }
  },
  emits: ["close"],
  setup(__props, { emit }) {
    const props = __props;
    const slots = useSlots();
    const className = computed(() => {
      return props.titleHidden || !slots.default ? styles$G.titleHidden : styles$G.Header;
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(unref(className))
      }, [
        createElementVNode("div", {
          id: __props.id,
          class: normalizeClass(unref(styles$G).Title)
        }, [
          createVNode(unref(Text), {
            as: "h2",
            variant: "headingLg"
          }, {
            default: withCtx(() => [
              renderSlot(_ctx.$slots, "default")
            ]),
            _: 3
          })
        ], 10, _hoisted_1$t),
        createVNode(unref(_sfc_main$15), {
          pressed: __props.closing,
          "title-hidden": __props.titleHidden,
          onClick: _cache[0] || (_cache[0] = ($event) => emit("close"))
        }, null, 8, ["pressed", "title-hidden"])
      ], 2);
    };
  }
});
const Footer = "Polaris-Modal-Footer";
const FooterContent = "Polaris-Modal-Footer__FooterContent";
var styles$E = {
  Footer,
  FooterContent
};
const Stack = "Polaris-Stack";
const Item$2 = "Polaris-Stack__Item";
const noWrap = "Polaris-Stack--noWrap";
const spacingNone = "Polaris-Stack--spacingNone";
const spacingExtraTight = "Polaris-Stack--spacingExtraTight";
const spacingTight$1 = "Polaris-Stack--spacingTight";
const spacingBaseTight = "Polaris-Stack--spacingBaseTight";
const spacingLoose$1 = "Polaris-Stack--spacingLoose";
const spacingExtraLoose = "Polaris-Stack--spacingExtraLoose";
const distributionLeading = "Polaris-Stack--distributionLeading";
const distributionTrailing = "Polaris-Stack--distributionTrailing";
const distributionCenter = "Polaris-Stack--distributionCenter";
const distributionEqualSpacing = "Polaris-Stack--distributionEqualSpacing";
const distributionFill = "Polaris-Stack--distributionFill";
const distributionFillEvenly = "Polaris-Stack--distributionFillEvenly";
const alignmentLeading$1 = "Polaris-Stack--alignmentLeading";
const alignmentTrailing$1 = "Polaris-Stack--alignmentTrailing";
const alignmentCenter$1 = "Polaris-Stack--alignmentCenter";
const alignmentFill$1 = "Polaris-Stack--alignmentFill";
const alignmentBaseline$1 = "Polaris-Stack--alignmentBaseline";
const vertical = "Polaris-Stack--vertical";
var styles$D = {
  Stack,
  Item: Item$2,
  noWrap,
  spacingNone,
  spacingExtraTight,
  spacingTight: spacingTight$1,
  spacingBaseTight,
  spacingLoose: spacingLoose$1,
  spacingExtraLoose,
  distributionLeading,
  distributionTrailing,
  distributionCenter,
  distributionEqualSpacing,
  distributionFill,
  distributionFillEvenly,
  alignmentLeading: alignmentLeading$1,
  alignmentTrailing: alignmentTrailing$1,
  alignmentCenter: alignmentCenter$1,
  alignmentFill: alignmentFill$1,
  alignmentBaseline: alignmentBaseline$1,
  vertical,
  "Item-fill": "Polaris-Stack__Item--fill"
};
const _sfc_main$13 = /* @__PURE__ */ defineComponent({
  props: {
    fill: { type: Boolean, default: false }
  },
  setup(__props) {
    const props = __props;
    const className = computed(() => classNames(styles$D.Item, props.fill && styles$D["Item-fill"]));
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(unref(className))
      }, [
        renderSlot(_ctx.$slots, "default")
      ], 2);
    };
  }
});
var Stack_vue_vue_type_style_index_0_lang = "";
const _sfc_main$12 = /* @__PURE__ */ defineComponent({
  props: {
    wrap: { type: Boolean, default: true },
    vertical: { type: Boolean },
    spacing: null,
    alignment: null,
    distribution: null,
    noItemWrap: { type: Boolean, default: false }
  },
  setup(__props) {
    const props = __props;
    const slots = useSlots();
    const className = computed(() => {
      const spacing2 = props.spacing && variationName("spacing", props.spacing);
      const distribution = props.distribution && variationName("distribution", props.distribution);
      const alignment = props.alignment && variationName("alignment", props.alignment);
      return classNames(styles$D.Stack, props.vertical && styles$D.vertical, spacing2 && styles$D[spacing2], distribution && styles$D[distribution], alignment && styles$D[alignment], props.wrap === false && styles$D.noWrap);
    });
    const slotsElms = computed(() => {
      let elms = [];
      if (slots.default) {
        const groups = slots.default().map((group) => {
          return extractElement(group);
        });
        elms = groups.flat();
      }
      return elms;
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(unref(className))
      }, [
        !__props.noItemWrap && unref(slots).default && unref(hasSlot)(unref(slots).default) ? (openBlock(true), createElementBlock(Fragment, { key: 0 }, renderList(unref(slotsElms), (item, index) => {
          return openBlock(), createBlock(unref(_sfc_main$13), { key: index }, {
            default: withCtx(() => [
              (openBlock(), createBlock(resolveDynamicComponent(item)))
            ]),
            _: 2
          }, 1024);
        }), 128)) : renderSlot(_ctx.$slots, "default", { key: 1 })
      ], 2);
    };
  }
});
var Footer_vue_vue_type_style_index_0_lang = "";
const _sfc_main$11 = /* @__PURE__ */ defineComponent({
  props: {
    primaryAction: null,
    secondaryActions: null
  },
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(unref(styles$E).Footer)
      }, [
        createElementVNode("div", {
          class: normalizeClass(unref(styles$E).FooterContent)
        }, [
          createVNode(unref(_sfc_main$12), {
            alignment: "center",
            "no-item-wrap": ""
          }, {
            default: withCtx(() => [
              createVNode(unref(_sfc_main$13), { fill: true }, {
                default: withCtx(() => [
                  renderSlot(_ctx.$slots, "default")
                ]),
                _: 3
              }),
              __props.primaryAction || __props.secondaryActions ? (openBlock(), createBlock(unref(_sfc_main$13), { key: 0 }, {
                default: withCtx(() => [
                  createVNode(unref(_sfc_main$2C), null, {
                    default: withCtx(() => [
                      __props.secondaryActions ? (openBlock(true), createElementBlock(Fragment, { key: 0 }, renderList(__props.secondaryActions, (action, index) => {
                        return openBlock(), createBlock(unref(_sfc_main$2E), {
                          key: index,
                          action
                        }, null, 8, ["action"]);
                      }), 128)) : createCommentVNode("", true),
                      createVNode(unref(_sfc_main$2E), {
                        action: __props.primaryAction,
                        overrides: { primary: true }
                      }, null, 8, ["action"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })) : createCommentVNode("", true)
            ]),
            _: 3
          })
        ], 2)
      ], 2);
    };
  }
});
const Section$3 = "Polaris-Modal-Section";
const subdued$1 = "Polaris-Modal-Section--subdued";
const flush = "Polaris-Modal-Section--flush";
const titleHidden$1 = "Polaris-Modal-Section--titleHidden";
var styles$C = {
  Section: Section$3,
  subdued: subdued$1,
  flush,
  titleHidden: titleHidden$1
};
var Section_vue_vue_type_style_index_0_lang = "";
const _sfc_main$10 = /* @__PURE__ */ defineComponent({
  props: {
    flush: { type: Boolean },
    subdued: { type: Boolean },
    titleHidden: { type: Boolean, default: false }
  },
  setup(__props) {
    const props = __props;
    const className = computed(() => {
      return classNames(styles$C.Section, props.flush && styles$C.flush, props.subdued && styles$C.subdued, props.titleHidden && styles$C.titleHidden);
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("section", {
        class: normalizeClass(unref(className))
      }, [
        renderSlot(_ctx.$slots, "default")
      ], 2);
    };
  }
});
var Modal_vue_vue_type_style_index_0_lang = "";
const _hoisted_1$s = ["name", "src"];
const _sfc_main$$ = /* @__PURE__ */ defineComponent({
  props: {
    open: { type: Boolean },
    src: null,
    iFrameName: null,
    titleHidden: { type: Boolean, default: false },
    instant: { type: Boolean },
    sectioned: { type: Boolean },
    large: { type: Boolean },
    small: { type: Boolean },
    limitHeight: { type: Boolean },
    loading: { type: Boolean },
    noScroll: { type: Boolean },
    fullScreen: { type: Boolean },
    primaryAction: null,
    secondaryActions: null,
    clickOutsideToClose: { type: Boolean }
  },
  emits: ["iframe-load", "transition-end", "scrolled-to-bottom", "close"],
  setup(__props, { emit }) {
    const IFRAME_LOADING_HEIGHT = 200;
    const DEFAULT_IFRAME_CONTENT_HEIGHT = 400;
    const slots = useSlots();
    const activatorNode = ref(null);
    const { useUniqueId } = UseUniqueId();
    const headerId = useUniqueId("modal-header");
    const iframeHeight = ref(IFRAME_LOADING_HEIGHT);
    const domReady = ref(false);
    const closing = ref(false);
    const handleIframeLoad = (evt) => {
      const iframe = evt.target;
      if (iframe && iframe.contentWindow) {
        try {
          iframeHeight.value = iframe.contentWindow.document.body.scrollHeight;
        } catch (_error) {
          iframeHeight.value = DEFAULT_IFRAME_CONTENT_HEIGHT;
        }
      }
      emit("iframe-load", evt);
    };
    const handleEntered = () => {
      emit("transition-end");
    };
    const handleExited = () => {
      iframeHeight.value = IFRAME_LOADING_HEIGHT;
      const node = activatorNode.value;
      if (node) {
        requestAnimationFrame(() => focusFirstFocusableNode(node));
      }
    };
    const setClosing = (v) => {
      closing.value = v;
    };
    onMounted(() => {
      domReady.value = true;
    });
    provide("WithinContentContext", true);
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", null, [
        unref(slots).activator ? (openBlock(), createElementBlock("div", {
          key: 0,
          ref_key: "activatorNode",
          ref: activatorNode
        }, [
          renderSlot(_ctx.$slots, "activator")
        ], 512)) : createCommentVNode("", true),
        domReady.value && __props.open ? (openBlock(), createBlock(unref(_sfc_main$2M), {
          key: 1,
          idPrefix: "modal"
        }, {
          default: withCtx(() => [
            createVNode(unref(_sfc_main$16), {
              instant: __props.instant,
              "labelled-by": unref(headerId),
              large: __props.large,
              small: __props.small,
              "limit-height": __props.limitHeight,
              "full-screen": __props.fullScreen,
              onClose: _cache[2] || (_cache[2] = ($event) => emit("close")),
              onEntered: handleEntered,
              onExited: handleExited,
              onClosing: setClosing
            }, {
              default: withCtx(() => [
                createVNode(unref(_sfc_main$14), {
                  "title-hidden": __props.titleHidden,
                  id: unref(headerId),
                  key: "header",
                  closing: closing.value,
                  onClose: _cache[0] || (_cache[0] = ($event) => emit("close"))
                }, {
                  default: withCtx(() => [
                    renderSlot(_ctx.$slots, "title")
                  ]),
                  _: 3
                }, 8, ["title-hidden", "id", "closing"]),
                createElementVNode("div", {
                  class: normalizeClass(unref(styles$I).BodyWrapper),
                  key: "body"
                }, [
                  __props.src ? (openBlock(), createElementBlock("iframe", {
                    key: 0,
                    name: __props.iFrameName,
                    title: "body markup",
                    src: __props.src,
                    class: normalizeClass(unref(styles$I).IFrame),
                    onLoad: handleIframeLoad,
                    style: normalizeStyle({ height: `${iframeHeight.value}px` })
                  }, null, 46, _hoisted_1$s)) : __props.noScroll ? (openBlock(), createElementBlock("div", {
                    key: 1,
                    class: normalizeClass(unref(styles$I).Body)
                  }, [
                    __props.loading ? (openBlock(), createElementBlock("div", {
                      key: 0,
                      class: normalizeClass(unref(styles$I).Spinner)
                    }, [
                      createVNode(unref(_sfc_main$2H))
                    ], 2)) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
                      __props.sectioned ? (openBlock(), createBlock(unref(_sfc_main$10), { key: 0 }, {
                        default: withCtx(() => [
                          renderSlot(_ctx.$slots, "content")
                        ]),
                        _: 3
                      })) : renderSlot(_ctx.$slots, "content", { key: 1 })
                    ], 64))
                  ], 2)) : (openBlock(), createBlock(unref(_sfc_main$3o), {
                    key: 2,
                    shadow: true,
                    class: normalizeClass(unref(styles$I).Body),
                    onScrolledToBottom: _cache[1] || (_cache[1] = ($event) => emit("scrolled-to-bottom"))
                  }, {
                    default: withCtx(() => [
                      __props.loading ? (openBlock(), createElementBlock("div", {
                        key: 0,
                        class: normalizeClass(unref(styles$I).Spinner)
                      }, [
                        createVNode(unref(_sfc_main$2H))
                      ], 2)) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
                        __props.sectioned ? (openBlock(), createBlock(unref(_sfc_main$10), { key: 0 }, {
                          default: withCtx(() => [
                            renderSlot(_ctx.$slots, "content", { titleHidden: __props.titleHidden })
                          ]),
                          _: 3
                        })) : renderSlot(_ctx.$slots, "content", { key: 1 })
                      ], 64))
                    ]),
                    _: 3
                  }, 8, ["class"]))
                ], 2),
                unref(slots).footer || __props.primaryAction || __props.secondaryActions ? (openBlock(), createBlock(unref(_sfc_main$11), {
                  primaryAction: __props.primaryAction,
                  secondaryActions: __props.secondaryActions,
                  key: "footer"
                }, {
                  default: withCtx(() => [
                    renderSlot(_ctx.$slots, "footer")
                  ]),
                  _: 3
                }, 8, ["primaryAction", "secondaryActions"])) : createCommentVNode("", true)
              ]),
              _: 3
            }, 8, ["instant", "labelled-by", "large", "small", "limit-height", "full-screen"]),
            createVNode(unref(_sfc_main$2_), {
              onClosing: setClosing,
              onClick: _cache[3] || (_cache[3] = ($event) => __props.clickOutsideToClose ? emit("close") : null)
            })
          ]),
          _: 3
        })) : createCommentVNode("", true)
      ]);
    };
  }
});
const Navigation$1 = "Polaris-Navigation";
const UserMenu = "Polaris-Navigation__UserMenu";
const ContextControl$1 = "Polaris-Navigation__ContextControl";
const PrimaryNavigation = "Polaris-Navigation__PrimaryNavigation";
const LogoContainer$1 = "Polaris-Navigation__LogoContainer";
const hasLogoSuffix$1 = "Polaris-Navigation--hasLogoSuffix";
const Logo$1 = "Polaris-Navigation__Logo";
const LogoLink$1 = "Polaris-Navigation__LogoLink";
const Item$1 = "Polaris-Navigation__Item";
const keyFocused$2 = "Polaris-Navigation--keyFocused";
const Icon$3 = "Polaris-Navigation__Icon";
const Badge = "Polaris-Navigation__Badge";
const subNavigationActive = "Polaris-Navigation--subNavigationActive";
const ExternalIcon = "Polaris-Navigation__ExternalIcon";
const ListItem$1 = "Polaris-Navigation__ListItem";
const RollupSection = "Polaris-Navigation__RollupSection";
const SecondaryNavigation = "Polaris-Navigation__SecondaryNavigation";
const ItemWrapper$2 = "Polaris-Navigation__ItemWrapper";
const Text$1 = "Polaris-Navigation__Text";
const SecondaryAction = "Polaris-Navigation__SecondaryAction";
const isExpanded = "Polaris-Navigation--isExpanded";
const List$1 = "Polaris-Navigation__List";
const Section$2 = "Polaris-Navigation__Section";
const SectionHeading = "Polaris-Navigation__SectionHeading";
const Action$2 = "Polaris-Navigation__Action";
const RollupToggle = "Polaris-Navigation__RollupToggle";
const Indicator$2 = "Polaris-Navigation__Indicator";
var styles$B = {
  Navigation: Navigation$1,
  UserMenu,
  ContextControl: ContextControl$1,
  PrimaryNavigation,
  LogoContainer: LogoContainer$1,
  hasLogoSuffix: hasLogoSuffix$1,
  Logo: Logo$1,
  LogoLink: LogoLink$1,
  Item: Item$1,
  keyFocused: keyFocused$2,
  "Icon-resized": "Polaris-Navigation__Icon--resized",
  "Item-selected": "Polaris-Navigation__Item--selected",
  "Item-disabled": "Polaris-Navigation__Item--disabled",
  Icon: Icon$3,
  Badge,
  subNavigationActive,
  "Item-child-active": "Polaris-Navigation--itemChildActive",
  ExternalIcon,
  ListItem: ListItem$1,
  RollupSection,
  SecondaryNavigation,
  "ListItem-hasAction": "Polaris-Navigation__ListItem--hasAction",
  ItemWrapper: ItemWrapper$2,
  Text: Text$1,
  SecondaryAction,
  isExpanded,
  List: List$1,
  "SecondaryNavigation-noIcon": "Polaris-Navigation__SecondaryNavigation--noIcon",
  Section: Section$2,
  "Section-fill": "Polaris-Navigation__Section--fill",
  "Section-withSeparator": "Polaris-Navigation__Section--withSeparator",
  SectionHeading,
  Action: Action$2,
  RollupToggle,
  Indicator: Indicator$2
};
var Navigation_vue_vue_type_style_index_0_lang = "";
const _hoisted_1$r = ["aria-labelledby"];
const _sfc_main$_ = /* @__PURE__ */ defineComponent({
  props: {
    location: null,
    onDismiss: null,
    ariaLabelledBy: null
  },
  setup(__props) {
    const props = __props;
    const { useFrame } = UseFrame();
    const { logo } = useFrame();
    const width = getWidth(logo, 104);
    const slots = useSlots();
    const className = computed(() => classNames(styles$B.LogoContainer, hasSlot(slots["logo-suffix"]) && styles$B.hasLogoSuffix));
    provide("NavigationContext", {
      location: props.location,
      onNavigationDismiss: props.onDismiss,
      withinContentContainer: false
    });
    provide("WithinContentContext", true);
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("nav", {
        class: normalizeClass(unref(styles$B).Navigation),
        "aria-labelledby": __props.ariaLabelledBy
      }, [
        unref(slots).contextControl ? (openBlock(), createElementBlock("div", {
          key: 0,
          class: normalizeClass(unref(styles$B).ContextControl)
        }, [
          renderSlot(_ctx.$slots, "contextControl")
        ], 2)) : unref(logo) ? (openBlock(), createElementBlock("div", {
          key: 1,
          class: normalizeClass(unref(className))
        }, [
          createVNode(unref(_sfc_main$3m), {
            url: unref(logo).url || "",
            class: normalizeClass(unref(styles$B).LogoLink),
            style: normalizeStyle({ width: unref(width) })
          }, {
            default: withCtx(() => [
              createVNode(unref(_sfc_main$1D), {
                source: unref(logo).topBarSource || "",
                alt: unref(logo).accessibilityLabel || "",
                class: normalizeClass(unref(styles$B).Logo),
                style: normalizeStyle({ width: unref(width) })
              }, null, 8, ["source", "alt", "class", "style"])
            ]),
            _: 1
          }, 8, ["url", "class", "style"]),
          renderSlot(_ctx.$slots, "logo-suffix")
        ], 2)) : createCommentVNode("", true),
        createVNode(unref(_sfc_main$3o), {
          class: normalizeClass(unref(styles$B).PrimaryNavigation)
        }, {
          default: withCtx(() => [
            renderSlot(_ctx.$slots, "default")
          ]),
          _: 3
        }, 8, ["class"])
      ], 10, _hoisted_1$r);
    };
  }
});
function UseNavigationContext() {
  const NavigationContext = inject("NavigationContext", { location: "" });
  function useNavigationContext() {
    return NavigationContext;
  }
  return { useNavigationContext };
}
const _sfc_main$Z = /* @__PURE__ */ defineComponent({
  props: {
    expanded: { type: Boolean },
    id: null
  },
  setup(__props) {
    const { useUniqueId } = UseUniqueId();
    const uid = useUniqueId("SecondaryNavigation");
    return (_ctx, _cache) => {
      return openBlock(), createBlock(unref(_sfc_main$2q), {
        id: __props.id || unref(uid),
        open: __props.expanded,
        transition: false
      }, {
        default: withCtx(() => [
          createElementVNode("ul", {
            class: normalizeClass(unref(styles$B).List)
          }, [
            renderSlot(_ctx.$slots, "default")
          ], 2)
        ]),
        _: 3
      }, 8, ["id", "open"]);
    };
  }
});
const _hoisted_1$q = ["disabled", "aria-disabled", "aria-label", "onKeyup"];
const _sfc_main$Y = /* @__PURE__ */ defineComponent({
  props: {
    url: null,
    matches: { type: Boolean },
    matchPaths: null,
    excludePaths: null,
    external: { type: Boolean },
    icon: null,
    badge: null,
    label: null,
    disabled: { type: Boolean },
    accessibilityLabel: null,
    selected: { type: Boolean },
    exactMatch: { type: Boolean },
    new: { type: Boolean },
    subNavigationItems: null,
    secondaryAction: null,
    expanded: { type: Boolean },
    shouldResizeIcon: { type: Boolean }
  },
  emits: ["toggle-expanded-state", "click"],
  setup(__props, { emit: emits }) {
    const props = __props;
    const { useMediaQuery } = UseMediaQuery();
    const { isNavigationCollapsed } = useMediaQuery();
    const { useUniqueId } = UseUniqueId();
    const secondaryNavigationId = useUniqueId("SecondaryNavigation");
    const { useNavigationContext } = UseNavigationContext();
    const { location, onNavigationDismiss } = useNavigationContext();
    const i18n = UseI18n();
    const keyFocused2 = ref(false);
    onUpdated(() => {
      if (!isNavigationCollapsed && props.expanded) {
        onToggleExpandedState();
      }
    });
    const onToggleExpandedState = () => {
      emits("toggle-expanded-state");
    };
    const handleKeyUp = (event) => {
      if (!keyFocused2.value) {
        keyFocused2.value = true;
      }
    };
    const handleBlur = () => {
      keyFocused2.value && (keyFocused2.value = false);
    };
    const tabIndex = computed(() => props.disabled ? -1 : 0);
    const hasNewChild = computed(() => {
      if (props.subNavigationItems) {
        return props.subNavigationItems.filter((subNavigationItem) => subNavigationItem.new).length > 0;
      }
      return false;
    });
    const classNameOrigin = computed(() => {
      return classNames(styles$B.Item, props.disabled && styles$B["Item-disabled"], keyFocused2.value && styles$B.keyFocused, props.selected && styles$B["Item-selected"]);
    });
    const className = computed(() => {
      return classNames(styles$B.ListItem, props.secondaryAction && styles$B["ListItem-hasAction"]);
    });
    const iconClassName = computed(() => {
      return classNames(styles$B.Icon, props.shouldResizeIcon && styles$B["Icon-resized"]);
    });
    const matchState = matchStateForItem({
      url: props.url,
      matches: props.matches,
      exactMatch: props.exactMatch,
      matchPaths: props.matchPaths,
      excludePaths: props.excludePaths
    }, location);
    const matchingSubNavigationItems = computed(() => {
      return props.subNavigationItems && props.subNavigationItems.filter((item) => {
        const subMatchState = matchStateForItem(item, location);
        return subMatchState === "forced" || subMatchState === "url" || subMatchState === "paths";
      });
    });
    const childIsActive = computed(() => {
      return matchingSubNavigationItems.value && matchingSubNavigationItems.value.length > 0;
    });
    const selected2 = computed(() => {
      return props.selected == null ? matchState === "forced" || matchState === "url" || matchState === "paths" : props.selected;
    });
    const showExpanded = computed(() => selected2.value || props.expanded || childIsActive.value);
    const canBeActive = !props.subNavigationItems || props.subNavigationItems.length === 0 || !childIsActive.value;
    const itemClassName = computed(() => {
      return classNames(styles$B.Item, props.disabled && styles$B["Item-disabled"], selected2.value && canBeActive && styles$B["Item-selected"], showExpanded.value && styles$B.subNavigationActive, childIsActive.value && styles$B["Item-child-active"], keyFocused2.value && styles$B.keyFocused);
    });
    const longestMatch = computed(() => {
      if (matchingSubNavigationItems.value) {
        return matchingSubNavigationItems.value.sort(({ url: firstUrl }, { url: secondUrl }) => secondUrl.length - firstUrl.length)[0];
      }
      return null;
    });
    const SecondaryNavigationClassName = computed(() => {
      return classNames(styles$B.SecondaryNavigation, showExpanded.value && styles$B.isExpanded, !props.icon && styles$B["SecondaryNavigation-noIcon"]);
    });
    const getClickHandler = (event) => {
      const currentTarget = event.currentTarget;
      if (currentTarget.getAttribute("href") === location) {
        event.preventDefault();
      }
      if (props.subNavigationItems && props.subNavigationItems.length > 0 && isNavigationCollapsed) {
        event.preventDefault();
        onToggleExpandedState();
      } else if (onNavigationDismiss) {
        onNavigationDismiss();
        emits("click");
        return;
      }
      emits("click");
    };
    function normalizePathname(pathname) {
      const barePathname = pathname.split("?")[0].split("#")[0];
      return barePathname.endsWith("/") ? barePathname : `${barePathname}/`;
    }
    function safeEqual(locationPath, path) {
      return normalizePathname(locationPath) === normalizePathname(path);
    }
    function safeStartsWith(locationPath, path) {
      return normalizePathname(locationPath).startsWith(normalizePathname(path));
    }
    function matchStateForItem({ url, matches: matches2, exactMatch, matchPaths, excludePaths }, itemLocation) {
      if (url == null) {
        return "no-match";
      }
      if (matches2) {
        return "forced";
      }
      if (matches2 === false || excludePaths && excludePaths.some((path) => safeStartsWith(itemLocation, path))) {
        return "excluded";
      }
      if (matchPaths && matchPaths.some((path) => safeStartsWith(itemLocation, path))) {
        return "paths";
      }
      const matchesUrl = exactMatch ? safeEqual(itemLocation, url) : safeStartsWith(itemLocation, url);
      return matchesUrl ? "url" : "no-match";
    }
    function normalizeAriaAttributes(controlId, hasSubMenu, expanded2) {
      return hasSubMenu ? {
        "aria-expanded": expanded2,
        "aria-controls": controlId
      } : void 0;
    }
    return (_ctx, _cache) => {
      const _component_Item = resolveComponent("Item", true);
      return !__props.url ? (openBlock(), createElementBlock("li", {
        key: 0,
        class: normalizeClass(unref(styles$B).ListItem)
      }, [
        createElementVNode("button", {
          type: "button",
          class: normalizeClass(unref(classNameOrigin)),
          disabled: __props.disabled,
          "aria-disabled": __props.disabled,
          "aria-label": __props.accessibilityLabel,
          onClick: getClickHandler,
          onKeyup: withKeys(handleKeyUp, ["tab"]),
          onBlur: handleBlur
        }, [
          __props.icon ? (openBlock(), createElementBlock("div", {
            key: 0,
            class: normalizeClass(unref(iconClassName))
          }, [
            createVNode(unref(_sfc_main$2K), { source: __props.icon }, null, 8, ["source"])
          ], 2)) : createCommentVNode("", true),
          createElementVNode("span", {
            class: normalizeClass(unref(styles$B).Text)
          }, [
            createTextVNode(toDisplayString(__props.label), 1),
            unref(hasNewChild) ? (openBlock(), createElementBlock("span", {
              key: 0,
              class: normalizeClass(unref(styles$B).Indicator)
            }, [
              createVNode(unref(_sfc_main$1s), { pulse: "" })
            ], 2)) : createCommentVNode("", true)
          ], 2),
          props.new || __props.badge ? (openBlock(), createElementBlock("div", {
            key: 1,
            class: normalizeClass(unref(styles$B).Badge)
          }, [
            props.new ? (openBlock(), createBlock(unref(_sfc_main$2Y), {
              key: 0,
              status: "new"
            }, {
              default: withCtx(() => [
                createTextVNode(toDisplayString(unref(i18n).translate("Polaris.Badge.STATUS_LABELS.new")), 1)
              ]),
              _: 1
            })) : typeof __props.badge === "string" ? (openBlock(), createBlock(unref(_sfc_main$2Y), {
              key: 1,
              status: "new"
            }, {
              default: withCtx(() => [
                createTextVNode(toDisplayString(__props.badge), 1)
              ]),
              _: 1
            })) : typeof __props.badge === "object" ? (openBlock(), createBlock(unref(_sfc_main$2Y), normalizeProps(mergeProps({ key: 2 }, __props.badge)), {
              default: withCtx(() => [
                createTextVNode(toDisplayString(__props.badge.content), 1)
              ]),
              _: 1
            }, 16)) : createCommentVNode("", true)
          ], 2)) : createCommentVNode("", true)
        ], 42, _hoisted_1$q)
      ], 2)) : (openBlock(), createElementBlock("li", {
        key: 1,
        class: normalizeClass(unref(className))
      }, [
        createElementVNode("div", {
          class: normalizeClass(unref(styles$B).ItemWrapper)
        }, [
          createVNode(unref(_sfc_main$3m), mergeProps({
            url: __props.url,
            class: unref(itemClassName),
            external: __props.external,
            tabIndex: unref(tabIndex),
            "aria-disabled": __props.disabled,
            "aria-label": __props.accessibilityLabel,
            onClick: getClickHandler,
            onKeyup: withKeys(handleKeyUp, ["tab"]),
            onBlur: handleBlur
          }, __spreadValues({}, normalizeAriaAttributes(unref(secondaryNavigationId), !!__props.subNavigationItems && __props.subNavigationItems.length > 0, !!unref(showExpanded)))), {
            default: withCtx(() => [
              __props.icon ? (openBlock(), createElementBlock("div", {
                key: 0,
                class: normalizeClass(unref(iconClassName))
              }, [
                createVNode(unref(_sfc_main$2K), { source: __props.icon }, null, 8, ["source"])
              ], 2)) : createCommentVNode("", true),
              createElementVNode("span", {
                class: normalizeClass(unref(styles$B).Text)
              }, [
                createTextVNode(toDisplayString(__props.label), 1),
                unref(hasNewChild) ? (openBlock(), createElementBlock("span", {
                  key: 0,
                  class: normalizeClass(unref(styles$B).Indicator)
                }, [
                  createVNode(unref(_sfc_main$1s), { pulse: "" })
                ], 2)) : createCommentVNode("", true)
              ], 2),
              props.new || __props.badge ? (openBlock(), createElementBlock("div", {
                key: 1,
                class: normalizeClass(unref(styles$B).Badge)
              }, [
                props.new ? (openBlock(), createBlock(unref(_sfc_main$2Y), {
                  key: 0,
                  status: "new"
                }, {
                  default: withCtx(() => [
                    createTextVNode(toDisplayString(unref(i18n).translate("Polaris.Badge.STATUS_LABELS.new")), 1)
                  ]),
                  _: 1
                })) : typeof __props.badge === "string" ? (openBlock(), createBlock(unref(_sfc_main$2Y), {
                  key: 1,
                  status: "new"
                }, {
                  default: withCtx(() => [
                    createTextVNode(toDisplayString(__props.badge), 1)
                  ]),
                  _: 1
                })) : typeof __props.badge === "object" ? (openBlock(), createBlock(unref(_sfc_main$2Y), normalizeProps(mergeProps({ key: 2 }, __props.badge)), {
                  default: withCtx(() => [
                    createTextVNode(toDisplayString(__props.badge.content), 1)
                  ]),
                  _: 1
                }, 16)) : createCommentVNode("", true)
              ], 2)) : createCommentVNode("", true)
            ]),
            _: 1
          }, 16, ["url", "class", "external", "tabIndex", "aria-disabled", "aria-label", "onKeyup"]),
          __props.secondaryAction ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
            __props.secondaryAction.tooltip ? (openBlock(), createBlock(unref(_sfc_main$f), normalizeProps(mergeProps({ key: 0 }, __props.secondaryAction.tooltip)), {
              default: withCtx(() => [
                __props.secondaryAction ? (openBlock(), createBlock(unref(_sfc_main$3m), {
                  key: 0,
                  external: "",
                  url: __props.secondaryAction.url,
                  class: normalizeClass(unref(styles$B).SecondaryAction),
                  tabIndex: unref(tabIndex),
                  "aria-disabled": __props.disabled,
                  "aria-label": __props.secondaryAction.accessibilityLabel,
                  onClick: _cache[0] || (_cache[0] = ($event) => __props.secondaryAction && __props.secondaryAction.onClick)
                }, {
                  default: withCtx(() => [
                    createVNode(unref(_sfc_main$2K), {
                      source: __props.secondaryAction.icon
                    }, null, 8, ["source"])
                  ]),
                  _: 1
                }, 8, ["url", "class", "tabIndex", "aria-disabled", "aria-label"])) : createCommentVNode("", true)
              ]),
              _: 1
            }, 16)) : (openBlock(), createBlock(unref(_sfc_main$3m), {
              key: 1,
              external: "",
              url: __props.secondaryAction.url,
              class: normalizeClass(unref(styles$B).SecondaryAction),
              tabIndex: unref(tabIndex),
              "aria-disabled": __props.disabled,
              "aria-label": __props.secondaryAction.accessibilityLabel,
              onClick: _cache[1] || (_cache[1] = ($event) => __props.secondaryAction && __props.secondaryAction.onClick)
            }, {
              default: withCtx(() => [
                createVNode(unref(_sfc_main$2K), {
                  source: __props.secondaryAction.icon
                }, null, 8, ["source"])
              ]),
              _: 1
            }, 8, ["url", "class", "tabIndex", "aria-disabled", "aria-label"]))
          ], 64)) : createCommentVNode("", true)
        ], 2),
        __props.subNavigationItems && __props.subNavigationItems.length > 0 ? (openBlock(), createElementBlock("div", {
          key: 0,
          class: normalizeClass(unref(SecondaryNavigationClassName))
        }, [
          createVNode(unref(_sfc_main$Z), {
            expanded: !!unref(showExpanded),
            id: unref(secondaryNavigationId)
          }, {
            default: withCtx(() => [
              (openBlock(true), createElementBlock(Fragment, null, renderList(__props.subNavigationItems, (item) => {
                return openBlock(), createBlock(_component_Item, mergeProps({
                  key: item.label
                }, item, {
                  matches: item === unref(longestMatch),
                  onClick: () => {
                    unref(onNavigationDismiss) && unref(onNavigationDismiss)();
                    item.onClick && item.onClick();
                  }
                }), null, 16, ["matches", "onClick"]);
              }), 128))
            ]),
            _: 1
          }, 8, ["expanded", "id"])
        ], 2)) : createCommentVNode("", true)
      ], 2));
    };
  }
});
const _hoisted_1$p = ["aria-label"];
const _hoisted_2$e = ["aria-label"];
const _hoisted_3$8 = ["aria-label"];
const _sfc_main$X = /* @__PURE__ */ defineComponent({
  props: {
    items: null,
    icon: null,
    title: null,
    fill: { type: Boolean },
    rollup: null,
    action: null,
    separator: { type: Boolean }
  },
  emits: ["click"],
  setup(__props, { emit: emits }) {
    const props = __props;
    const expanded2 = ref(false);
    const toggleExpanded = () => {
      expanded2.value = !expanded2.value;
    };
    const setExpandedFalse = () => {
      expanded2.value = false;
    };
    const animationFrame = ref(null);
    const expandedIndex = ref();
    const { useMediaQuery } = UseMediaQuery();
    const { isNavigationCollapsed } = useMediaQuery();
    const { useUniqueId } = UseUniqueId();
    const additionalItemsId = useUniqueId("AdditionalItems");
    const handleClick = (hasSubNavItems) => {
      emits("click");
      if (animationFrame.value) {
        cancelAnimationFrame(animationFrame.value);
      }
      if (!hasSubNavItems || !isNavigationCollapsed) {
        animationFrame.value = requestAnimationFrame(setExpandedFalse);
      }
    };
    onMounted(() => {
      animationFrame.value && cancelAnimationFrame(animationFrame.value);
    });
    const className = computed(() => {
      return classNames(styles$B.Section, props.separator && styles$B["Section-withSeparator"], props.fill && styles$B["Section-fill"]);
    });
    const toggleClassName = classNames(styles$B.Item, styles$B.RollupToggle);
    const ariaLabel = computed(() => {
      return props.rollup && (expanded2.value ? props.rollup.hide : props.rollup.view);
    });
    const activeItemIndex = computed(() => {
      return props.items.findIndex((item) => {
        if (!props.rollup) {
          return false;
        }
        return props.rollup.activePath === item.url || item.url && props.rollup.activePath.startsWith(item.url) || (item.subNavigationItems ? item.subNavigationItems.some(({ url: itemUrl }) => props.rollup && props.rollup.activePath.startsWith(itemUrl)) : false);
      });
    });
    const handleToggleExpandedState = (index) => {
      if (expandedIndex.value === index) {
        expandedIndex.value = -1;
      } else {
        expandedIndex.value = index;
      }
    };
    const sectionItems = computed(() => {
      let sectionListItems = [];
      sectionListItems = props.rollup ? props.items.slice(0, props.rollup.after) : props.items;
      if (props.rollup && activeItemIndex.value !== -1 && activeItemIndex.value > props.rollup.after - 1) {
        const additionalItems = props.items.slice(props.rollup.after);
        sectionListItems.push(...additionalItems.splice(activeItemIndex.value - props.rollup.after, 1));
      }
      return sectionListItems;
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("ul", {
        class: normalizeClass(unref(className))
      }, [
        __props.title ? (openBlock(), createElementBlock("li", {
          key: 0,
          class: normalizeClass(unref(styles$B).SectionHeading)
        }, [
          createVNode(unref(Text), {
            as: "span",
            variant: "headingXs",
            color: "subdued"
          }, {
            default: withCtx(() => [
              createTextVNode(toDisplayString(__props.title), 1)
            ]),
            _: 1
          }),
          __props.action ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
            __props.action.tooltip ? (openBlock(), createBlock(unref(_sfc_main$f), normalizeProps(mergeProps({ key: 0 }, __props.action.tooltip)), {
              default: withCtx(() => [
                createElementVNode("button", {
                  type: "button",
                  class: normalizeClass(unref(styles$B).Action),
                  "aria-label": __props.action.accessibilityLabel,
                  onClick: _cache[0] || (_cache[0] = (...args) => {
                    var _a, _b;
                    return ((_a = __props.action) == null ? void 0 : _a.onClick) && ((_b = __props.action) == null ? void 0 : _b.onClick(...args));
                  })
                }, [
                  createVNode(unref(_sfc_main$2K), {
                    source: __props.action.icon
                  }, null, 8, ["source"])
                ], 10, _hoisted_1$p)
              ]),
              _: 1
            }, 16)) : (openBlock(), createElementBlock("button", {
              key: 1,
              type: "button",
              class: normalizeClass(unref(styles$B).Action),
              "aria-label": __props.action.accessibilityLabel,
              onClick: _cache[1] || (_cache[1] = (...args) => {
                var _a, _b;
                return ((_a = __props.action) == null ? void 0 : _a.onClick) && ((_b = __props.action) == null ? void 0 : _b.onClick(...args));
              })
            }, [
              createVNode(unref(_sfc_main$2K), {
                source: __props.action.icon
              }, null, 8, ["source"])
            ], 10, _hoisted_2$e))
          ], 64)) : createCommentVNode("", true)
        ], 2)) : createCommentVNode("", true),
        unref(sectionItems).length > 0 ? (openBlock(true), createElementBlock(Fragment, { key: 1 }, renderList(unref(sectionItems), (item, index) => {
          return openBlock(), createBlock(unref(_sfc_main$Y), mergeProps({
            key: item.label
          }, __spreadValues({}, item), {
            label: item.label,
            subNavigationItems: item.subNavigationItems,
            expanded: expandedIndex.value === index,
            onClick: ($event) => handleClick(item.subNavigationItems != null && item.subNavigationItems.length > 0),
            onToggleExpandedState: ($event) => handleToggleExpandedState(index)
          }), null, 16, ["label", "subNavigationItems", "expanded", "onClick", "onToggleExpandedState"]);
        }), 128)) : createCommentVNode("", true),
        __props.rollup && __props.items.slice(__props.rollup.after).length > 0 ? (openBlock(), createElementBlock("li", {
          key: 2,
          class: normalizeClass(unref(styles$B).RollupSection)
        }, [
          createVNode(unref(_sfc_main$2q), {
            id: unref(additionalItemsId),
            open: expanded2.value
          }, {
            default: withCtx(() => [
              createElementVNode("ul", {
                class: normalizeClass(unref(styles$B).List)
              }, [
                (openBlock(true), createElementBlock(Fragment, null, renderList(__props.items.slice(__props.rollup.after), (item, index) => {
                  return openBlock(), createBlock(unref(_sfc_main$Y), mergeProps({
                    key: item.label
                  }, item, {
                    label: item.label,
                    subNavigationItems: item.subNavigationItems,
                    expanded: expandedIndex.value === index,
                    onClick: ($event) => handleClick(item.subNavigationItems != null && item.subNavigationItems.length > 0),
                    onToggleExpandedState: ($event) => handleToggleExpandedState(index)
                  }), null, 16, ["label", "subNavigationItems", "expanded", "onClick", "onToggleExpandedState"]);
                }), 128))
              ], 2)
            ]),
            _: 1
          }, 8, ["id", "open"]),
          __props.rollup && __props.items.length > __props.rollup.after ? (openBlock(), createElementBlock("div", {
            class: normalizeClass(unref(styles$B).ListItem),
            key: "List Item"
          }, [
            createElementVNode("button", {
              type: "button",
              class: normalizeClass(unref(toggleClassName)),
              "aria-label": unref(ariaLabel),
              onClick: toggleExpanded
            }, [
              createElementVNode("span", {
                class: normalizeClass(unref(styles$B).Icon)
              }, [
                createVNode(unref(_sfc_main$2K), { source: unref(HorizontalDotsMinor) }, null, 8, ["source"])
              ], 2)
            ], 10, _hoisted_3$8)
          ], 2)) : createCommentVNode("", true)
        ], 2)) : createCommentVNode("", true)
      ], 2);
    };
  }
});
const OptionList = "Polaris-OptionList";
const Options = "Polaris-OptionList__Options";
var styles$A = {
  OptionList,
  Options
};
const Option = "Polaris-OptionList-Option";
const SingleSelectOption = "Polaris-OptionList-Option__SingleSelectOption";
const focused$3 = "Polaris-OptionList-Option--focused";
const active$1 = "Polaris-OptionList-Option--active";
const select = "Polaris-OptionList-Option--select";
const disabled$4 = "Polaris-OptionList-Option--disabled";
const Media$1 = "Polaris-OptionList-Option__Media";
const Label$2 = "Polaris-OptionList-Option__Label";
const Checkbox$1 = "Polaris-OptionList-Option__Checkbox";
const verticalAlignTop = "Polaris-OptionList-Option--verticalAlignTop";
const verticalAlignCenter = "Polaris-OptionList-Option--verticalAlignCenter";
const verticalAlignBottom = "Polaris-OptionList-Option--verticalAlignBottom";
var styles$z = {
  Option,
  SingleSelectOption,
  focused: focused$3,
  active: active$1,
  select,
  disabled: disabled$4,
  Media: Media$1,
  Label: Label$2,
  Checkbox: Checkbox$1,
  verticalAlignTop,
  verticalAlignCenter,
  verticalAlignBottom
};
const Checkbox = "Polaris-OptionList-Checkbox";
const active = "Polaris-OptionList-Checkbox--active";
const Backdrop$3 = "Polaris-OptionList-Checkbox__Backdrop";
const Input$4 = "Polaris-OptionList-Checkbox__Input";
const keyFocused$1 = "Polaris-OptionList-Checkbox--keyFocused";
const Icon$2 = "Polaris-OptionList-Checkbox__Icon";
const hover$2 = "Polaris-OptionList-Checkbox--hover";
var styles$y = {
  Checkbox,
  active,
  Backdrop: Backdrop$3,
  Input: Input$4,
  keyFocused: keyFocused$1,
  "Input-indeterminate": "Polaris-OptionList-Checkbox__Input--indeterminate",
  Icon: Icon$2,
  hover: hover$2
};
var Checkbox_vue_vue_type_style_index_0_lang = "";
const _hoisted_1$o = ["id", "name", "value", "checked", "disabled", "aria-checked", "role"];
const _sfc_main$W = /* @__PURE__ */ defineComponent({
  props: {
    checked: { type: Boolean, default: false },
    disabled: { type: Boolean },
    active: { type: Boolean },
    id: null,
    name: null,
    modelValue: null,
    role: null
  },
  emits: ["change", "update:modelValue"],
  setup(__props, { emit: emits }) {
    const props = __props;
    const { useUniqueId } = UseUniqueId();
    const uniqueId = useUniqueId("Checkbox", props.id);
    const keyFocused2 = ref(false);
    const className = computed(() => classNames(styles$y.Checkbox, props.active && styles$y.active));
    const inputClassName = computed(() => {
      return classNames(styles$y.Input, keyFocused2.value && styles$y.keyFocused);
    });
    const handleBlur = () => {
      keyFocused2.value = false;
    };
    const handleKeyUp = () => {
      if (!keyFocused2.value) {
        keyFocused2.value = true;
      }
    };
    const handleChange = (event) => {
      const target = event.target;
      emits("update:modelValue", target.value);
      emits("change", target.value);
    };
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(unref(className))
      }, [
        createElementVNode("input", {
          type: "checkbox",
          id: unref(uniqueId),
          name: __props.name,
          value: __props.modelValue,
          checked: __props.checked,
          disabled: __props.disabled,
          class: normalizeClass(unref(inputClassName)),
          "aria-checked": __props.checked,
          onChange: handleChange,
          onBlur: handleBlur,
          onKeyup: handleKeyUp,
          role: __props.role
        }, null, 42, _hoisted_1$o),
        createElementVNode("div", {
          class: normalizeClass(unref(styles$y).Backdrop)
        }, null, 2),
        createElementVNode("div", {
          class: normalizeClass(unref(styles$y).Icon)
        }, [
          createVNode(unref(_sfc_main$2K), { source: unref(TickSmallMinor) }, null, 8, ["source"])
        ], 2)
      ], 2);
    };
  }
});
var Option_vue_vue_type_style_index_0_lang = "";
const _hoisted_1$n = ["for"];
const _hoisted_2$d = ["id", "disabled", "aria-pressed"];
const _sfc_main$V = /* @__PURE__ */ defineComponent({
  props: {
    id: null,
    value: null,
    section: null,
    index: null,
    disabled: { type: Boolean },
    active: { type: Boolean },
    select: { type: Boolean },
    allowMultiple: { type: Boolean },
    verticalAlign: null,
    role: null
  },
  emits: ["click"],
  setup(__props, { emit: emits }) {
    const props = __props;
    const slots = useSlots();
    const focused2 = ref(false);
    const toggleFocused = () => {
      focused2.value = !focused2.value;
    };
    const singleSelectClassName = computed(() => {
      return classNames(styles$z.SingleSelectOption, focused2.value && styles$z.focused, props.disabled && styles$z.disabled, props.select && styles$z.select, props.active && styles$z.active, props.verticalAlign && styles$z[variationName("verticalAlign", props.verticalAlign)]);
    });
    const multiSelectClassName = computed(() => {
      return classNames(styles$z.Label, props.disabled && styles$z.disabled, props.active && styles$z.active, props.select && styles$z.select, props.verticalAlign && styles$z[variationName("verticalAlign", props.verticalAlign)]);
    });
    const checkBoxRole = computed(() => props.role === "option" ? "presentation" : void 0);
    const handleClick = () => {
      if (props.disabled) {
        return;
      }
      emits("click", props.section, props.index);
    };
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("li", {
        key: __props.id,
        class: normalizeClass(unref(styles$z).Option),
        tabIndex: "-1"
      }, [
        __props.active ? (openBlock(), createBlock(unref(_sfc_main$3n), { key: 0 })) : createCommentVNode("", true),
        __props.allowMultiple ? (openBlock(), createElementBlock("label", {
          key: 1,
          for: __props.id,
          class: normalizeClass(unref(multiSelectClassName))
        }, [
          createElementVNode("div", {
            class: normalizeClass(unref(styles$z).Checkbox)
          }, [
            createVNode(unref(_sfc_main$W), {
              id: __props.id,
              modelValue: __props.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => isRef(value) ? value.value = $event : null),
              checked: __props.select,
              active: __props.active,
              disabled: __props.disabled,
              role: unref(checkBoxRole),
              onChange: handleClick
            }, null, 8, ["id", "modelValue", "checked", "active", "disabled", "role"])
          ], 2),
          unref(slots).media ? (openBlock(), createElementBlock("div", {
            key: 0,
            class: normalizeClass(unref(styles$z).Media)
          }, [
            renderSlot(_ctx.$slots, "media")
          ], 2)) : createCommentVNode("", true),
          renderSlot(_ctx.$slots, "label")
        ], 10, _hoisted_1$n)) : (openBlock(), createElementBlock("button", {
          key: 2,
          type: "button",
          id: __props.id,
          class: normalizeClass(unref(singleSelectClassName)),
          disabled: __props.disabled,
          "aria-pressed": __props.active,
          onClick: handleClick,
          onFocus: toggleFocused,
          onBlur: toggleFocused
        }, [
          unref(slots).media ? (openBlock(), createElementBlock("div", {
            key: 0,
            class: normalizeClass(unref(styles$z).Media)
          }, [
            renderSlot(_ctx.$slots, "media")
          ], 2)) : createCommentVNode("", true),
          renderSlot(_ctx.$slots, "label")
        ], 42, _hoisted_2$d))
      ], 2);
    };
  }
});
var OptionList_vue_vue_type_style_index_0_lang = "";
const _hoisted_1$m = ["role"];
const _hoisted_2$c = ["id", "role"];
const _sfc_main$U = /* @__PURE__ */ defineComponent({
  props: {
    id: null,
    title: null,
    options: null,
    role: null,
    optionRole: null,
    sections: null,
    modelValue: null,
    allowMultiple: { type: Boolean },
    verticalAlign: null
  },
  emits: ["update:modelValue", "change"],
  setup(__props, { emit: emits }) {
    const props = __props;
    const slots = useSlots();
    const normalizedOptions = ref(createNormalizedOptions(props.options, props.sections, props.title));
    const { useUniqueId } = UseUniqueId();
    const uniqueId = useUniqueId("OptionList", props.id);
    const handleClick = (sectionIndex, optionIndex) => {
      const selectedValue = normalizedOptions.value[sectionIndex].options[optionIndex].value;
      const foundIndex = props.modelValue.indexOf(selectedValue);
      if (props.allowMultiple) {
        const newSelection = foundIndex === -1 ? [selectedValue, ...props.modelValue] : [
          ...props.modelValue.slice(0, foundIndex),
          ...props.modelValue.slice(foundIndex + 1, props.modelValue.length)
        ];
        emits("update:modelValue", newSelection);
        emits("change", newSelection);
        return;
      }
      emits("update:modelValue", [selectedValue]);
      emits("change", [selectedValue]);
    };
    const optionsExist = computed(() => normalizedOptions.value.length > 0);
    watch(() => [props.options, props.sections, props.title], (newVal, oldVal) => {
      if (newVal !== oldVal) {
        normalizedOptions.value = createNormalizedOptions(props.options || [], props.sections || [], props.title);
      }
    });
    function createNormalizedOptions(options, sections, title) {
      if (!options || !options.length) {
        const section = title ? [{ options: [], title }] : [];
        return !sections || !sections.length ? [] : [...section, ...sections];
      }
      if (!sections || !sections.length) {
        return [
          {
            title,
            options
          }
        ];
      }
      return [
        {
          title,
          options
        },
        ...sections
      ];
    }
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("ul", {
        class: normalizeClass(unref(styles$A).OptionList),
        role: __props.role
      }, [
        unref(optionsExist) ? (openBlock(true), createElementBlock(Fragment, { key: 0 }, renderList(normalizedOptions.value, (optionItem, sectionIndex) => {
          return openBlock(), createElementBlock("li", {
            key: optionItem.title || `noTitle-${sectionIndex}`
          }, [
            optionItem.title ? (openBlock(), createBlock(unref(_sfc_main$2V), {
              key: 0,
              "padding-block-start": sectionIndex === 0 ? "2" : "4",
              "padding-inline-start": "2",
              "padding-block-end": "2",
              "padding-inline-end": "2",
              "border-block-start": !(sectionIndex === 0) ? "divider" : void 0
            }, {
              default: withCtx(() => [
                createVNode(unref(Text), {
                  as: "p",
                  variant: "headingXs"
                }, {
                  default: withCtx(() => [
                    createTextVNode(toDisplayString(optionItem.title), 1)
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1032, ["padding-block-start", "border-block-start"])) : createCommentVNode("", true),
            createElementVNode("ul", {
              class: normalizeClass(unref(styles$A).Options),
              id: `${unref(uniqueId)}-${sectionIndex}`,
              role: __props.role
            }, [
              optionItem.options ? (openBlock(true), createElementBlock(Fragment, { key: 0 }, renderList(optionItem.options, (option, optionIndex) => {
                return openBlock(), createBlock(unref(_sfc_main$V), mergeProps({
                  key: option.id || `${unref(uniqueId)}-${sectionIndex}-${optionIndex}`,
                  id: option.id || `${unref(uniqueId)}-${sectionIndex}-${optionIndex}`,
                  section: sectionIndex,
                  index: optionIndex
                }, option, {
                  select: __props.modelValue.includes(option.value),
                  allowMultiple: __props.allowMultiple,
                  verticalAlign: __props.verticalAlign,
                  role: __props.optionRole,
                  onClick: handleClick
                }), createSlots({
                  label: withCtx(() => [
                    unref(slots)[`option-label-${option.id}`] ? renderSlot(_ctx.$slots, `option-label-${option.id}`, { key: 0 }) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
                      createTextVNode(toDisplayString(option.label), 1)
                    ], 64))
                  ]),
                  _: 2
                }, [
                  unref(slots)[`option-media-${option.id}`] ? {
                    name: "media",
                    fn: withCtx(() => [
                      renderSlot(_ctx.$slots, `option-media-${option.id}`)
                    ])
                  } : void 0
                ]), 1040, ["id", "section", "index", "select", "allowMultiple", "verticalAlign", "role"]);
              }), 128)) : createCommentVNode("", true)
            ], 10, _hoisted_2$c)
          ]);
        }), 128)) : createCommentVNode("", true)
      ], 10, _hoisted_1$m);
    };
  }
});
const Page$1 = "Polaris-Page";
const fullWidth$1 = "Polaris-Page--fullWidth";
const narrowWidth$1 = "Polaris-Page--narrowWidth";
const Content$3 = "Polaris-Page__Content";
const divider = "Polaris-Page--divider";
var styles$x = {
  Page: Page$1,
  fullWidth: fullWidth$1,
  narrowWidth: narrowWidth$1,
  Content: Content$3,
  divider
};
const _sfc_main$T = /* @__PURE__ */ defineComponent({
  props: {
    title: null,
    secondaryActions: null,
    actionGroups: null
  },
  emits: ["action-rollup"],
  setup(__props, { emit: emits }) {
    const slots = useSlots();
    const { useMediaQuery } = UseMediaQuery();
    const { isNavigationCollapsed } = useMediaQuery();
    const onActionRollup = (hasRolledUp) => {
      emits("action-rollup", hasRolledUp);
    };
    function hasGroupsWithActions(groups = []) {
      return groups.length === 0 ? false : groups.some((group) => group.actions.length > 0);
    }
    return (_ctx, _cache) => {
      return unref(hasSlot)(unref(slots).default) ? renderSlot(_ctx.$slots, "default", { key: 0 }) : __props.secondaryActions && __props.secondaryActions.length > 0 || hasGroupsWithActions(__props.actionGroups) ? (openBlock(), createBlock(unref(_sfc_main$3c), {
        key: 1,
        actions: __props.secondaryActions,
        groups: __props.actionGroups,
        rollup: unref(isNavigationCollapsed),
        rollupActionsLabel: __props.title ? `View actions for ${__props.title}` : void 0,
        onActionRollup
      }, null, 8, ["actions", "groups", "rollup", "rollupActionsLabel"])) : createCommentVNode("", true);
    };
  }
});
const Header$1 = "Polaris-Page-Header";
const titleHidden = "Polaris-Page-Header--titleHidden";
const TitleWrapper$1 = "Polaris-Page-Header__TitleWrapper";
const Navigation = "Polaris-Page-Header__Navigation";
const hasActionMenu = "Polaris-Page-Header--hasActionMenu";
const mobileView = "Polaris-Page-Header--mobileView";
const BreadcrumbWrapper = "Polaris-Page-Header__BreadcrumbWrapper";
const PaginationWrapper = "Polaris-Page-Header__PaginationWrapper";
const AdditionalNavigationWrapper = "Polaris-Page-Header__AdditionalNavigationWrapper";
const MainContent = "Polaris-Page-Header__MainContent";
const TitleActionMenuWrapper = "Polaris-Page-Header__TitleActionMenuWrapper";
const hasNavigation = "Polaris-Page-Header--hasNavigation";
const PrimaryActionWrapper = "Polaris-Page-Header__PrimaryActionWrapper";
const Row = "Polaris-Page-Header__Row";
const RightAlign = "Polaris-Page-Header__RightAlign";
const LeftAlign = "Polaris-Page-Header__LeftAlign";
const noBreadcrumbs = "Polaris-Page-Header--noBreadcrumbs";
const AdditionalMetaData = "Polaris-Page-Header__AdditionalMetaData";
const Actions$2 = "Polaris-Page-Header__Actions";
const longTitle = "Polaris-Page-Header--longTitle";
const mediumTitle = "Polaris-Page-Header--mediumTitle";
const isSingleRow = "Polaris-Page-Header--isSingleRow";
var styles$w = {
  Header: Header$1,
  titleHidden,
  TitleWrapper: TitleWrapper$1,
  Navigation,
  hasActionMenu,
  mobileView,
  BreadcrumbWrapper,
  PaginationWrapper,
  AdditionalNavigationWrapper,
  MainContent,
  TitleActionMenuWrapper,
  hasNavigation,
  PrimaryActionWrapper,
  Row,
  RightAlign,
  LeftAlign,
  noBreadcrumbs,
  AdditionalMetaData,
  Actions: Actions$2,
  longTitle,
  mediumTitle,
  isSingleRow
};
const _sfc_main$S = /* @__PURE__ */ defineComponent({
  props: {
    additionalMetadata: null
  },
  setup(__props) {
    const slots = useSlots();
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(unref(styles$w).AdditionalMetaData)
      }, [
        createVNode(unref(Text), {
          variant: "bodyMd",
          color: "subdued",
          as: "span"
        }, {
          default: withCtx(() => [
            unref(slots).default ? renderSlot(_ctx.$slots, "default", { key: 0 }) : __props.additionalMetadata ? (openBlock(), createElementBlock(Fragment, { key: 1 }, [
              createTextVNode(toDisplayString(__props.additionalMetadata), 1)
            ], 64)) : createCommentVNode("", true)
          ]),
          _: 3
        })
      ], 2);
    };
  }
});
const _sfc_main$R = /* @__PURE__ */ defineComponent({
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(unref(styles$w).AdditionalNavigationWrapper)
      }, [
        renderSlot(_ctx.$slots, "default")
      ], 2);
    };
  }
});
const _sfc_main$Q = /* @__PURE__ */ defineComponent({
  props: {
    breadcrumbs: null
  },
  setup(__props) {
    return (_ctx, _cache) => {
      return __props.breadcrumbs.length > 0 ? (openBlock(), createElementBlock("div", {
        key: 0,
        class: normalizeClass(unref(styles$w).BreadcrumbWrapper)
      }, [
        createVNode(unref(_sfc_main$2U), { breadcrumbs: __props.breadcrumbs }, null, 8, ["breadcrumbs"])
      ], 2)) : createCommentVNode("", true);
    };
  }
});
const _sfc_main$P = /* @__PURE__ */ defineComponent({
  props: {
    pagination: null
  },
  setup(__props) {
    const slots = useSlots();
    const { useMediaQuery } = UseMediaQuery();
    const { isNavigationCollapsed } = useMediaQuery();
    return (_ctx, _cache) => {
      return __props.pagination && !unref(isNavigationCollapsed) ? (openBlock(), createElementBlock("div", {
        key: 0,
        class: normalizeClass(unref(styles$w).PaginationWrapper)
      }, [
        createVNode(unref(_sfc_main$H), normalizeProps(guardReactiveProps(__props.pagination)), {
          default: withCtx(() => [
            unref(hasSlot)(unref(slots).default) ? renderSlot(_ctx.$slots, "default", { key: 0 }) : createCommentVNode("", true)
          ]),
          _: 3
        }, 16)
      ], 2)) : createCommentVNode("", true);
    };
  }
});
const Title$2 = "Polaris-Header-Title";
const TitleWithSubtitle = "Polaris-Header-Title__TitleWithSubtitle";
const SubTitle = "Polaris-Header-Title__SubTitle";
const SubtitleCompact = "Polaris-Header-Title__SubtitleCompact";
const TitleWithMetadataWrapper = "Polaris-Header-Title__TitleWithMetadataWrapper";
const TitleMetadata = "Polaris-Header-Title__TitleMetadata";
var styles$v = {
  Title: Title$2,
  TitleWithSubtitle,
  SubTitle,
  SubtitleCompact,
  TitleWithMetadataWrapper,
  TitleMetadata
};
var Title_vue_vue_type_style_index_0_lang = "";
const _sfc_main$O = /* @__PURE__ */ defineComponent({
  props: {
    title: null,
    subtitle: null,
    compactTitle: { type: Boolean }
  },
  setup(__props) {
    const props = __props;
    const className = computed(() => {
      return classNames(styles$v.Title, props.subtitle && styles$v.TitleWithSubtitle);
    });
    const subtitleClassName = computed(() => {
      return classNames(styles$v.SubTitle, props.compactTitle && styles$v.SubtitleCompact);
    });
    const slots = useSlots();
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock(Fragment, null, [
        unref(hasSlot)(unref(slots).default) ? (openBlock(), createElementBlock("div", {
          key: 0,
          class: normalizeClass(unref(styles$v).TitleWithMetadataWrapper)
        }, [
          __props.title ? (openBlock(), createElementBlock("h1", {
            key: 0,
            class: normalizeClass(unref(className))
          }, toDisplayString(__props.title), 3)) : createCommentVNode("", true),
          createElementVNode("div", {
            class: normalizeClass(unref(styles$v).TitleMetadata)
          }, [
            renderSlot(_ctx.$slots, "default")
          ], 2)
        ], 2)) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
          __props.title ? (openBlock(), createElementBlock("h1", {
            key: 0,
            class: normalizeClass(unref(className))
          }, toDisplayString(__props.title), 3)) : createCommentVNode("", true)
        ], 64)),
        __props.subtitle ? (openBlock(), createElementBlock("div", {
          key: 2,
          class: normalizeClass(unref(subtitleClassName))
        }, [
          createElementVNode("p", null, toDisplayString(__props.subtitle), 1)
        ], 2)) : createCommentVNode("", true)
      ], 64);
    };
  }
});
const _sfc_main$N = /* @__PURE__ */ defineComponent({
  props: {
    title: null,
    subtitle: null,
    compactTitle: { type: Boolean }
  },
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(unref(styles$w).TitleWrapper)
      }, [
        createVNode(unref(_sfc_main$O), {
          title: __props.title,
          subtitle: __props.subtitle,
          compactTitle: __props.compactTitle
        }, {
          default: withCtx(() => [
            renderSlot(_ctx.$slots, "default")
          ]),
          _: 3
        }, 8, ["title", "subtitle", "compactTitle"])
      ], 2);
    };
  }
});
const _sfc_main$M = /* @__PURE__ */ defineComponent({
  props: {
    id: null,
    content: null,
    accessibilityLabel: null,
    url: null,
    external: { type: Boolean },
    destructive: { type: Boolean },
    helpText: null,
    disabled: { type: Boolean },
    loading: { type: Boolean },
    icon: null,
    primary: { type: Boolean },
    onAction: null,
    onMouseEnter: null,
    onTouchStart: null
  },
  setup(__props) {
    const props = __props;
    const slots = useSlots();
    const { useMediaQuery } = UseMediaQuery();
    const { isNavigationCollapsed } = useMediaQuery();
    const primary2 = computed(() => !props.primary ? true : props.primary);
    const iconOnly2 = computed(() => {
      return shouldShowIconOnly(isNavigationCollapsed, props);
    });
    function shouldShowIconOnly(isMobile, action) {
      let { content, accessibilityLabel, icon } = action;
      if (icon == null) {
        return __spreadProps(__spreadValues({}, action), { icon: void 0 });
      }
      if (isMobile) {
        accessibilityLabel = accessibilityLabel || content;
        content = void 0;
      } else {
        icon = void 0;
      }
      return __spreadProps(__spreadValues({}, action), {
        content,
        accessibilityLabel,
        icon
      });
    }
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(unref(styles$w).PrimaryActionWrapper)
      }, [
        unref(hasSlot)(unref(slots).default) && __props.helpText ? (openBlock(), createBlock(unref(_sfc_main$f), {
          key: 0,
          content: __props.helpText
        }, {
          default: withCtx(() => [
            createVNode(unref(_sfc_main$2E), {
              action: unref(iconOnly2),
              overrides: { primary: unref(primary2) },
              onAction: _cache[0] || (_cache[0] = () => {
                __props.onAction && __props.onAction();
              }),
              onMouseenter: _cache[1] || (_cache[1] = () => {
                __props.onMouseEnter && __props.onMouseEnter();
              }),
              onTouchstart: _cache[2] || (_cache[2] = () => {
                __props.onTouchStart && __props.onTouchStart();
              })
            }, null, 8, ["action", "overrides"])
          ]),
          _: 1
        }, 8, ["content"])) : (openBlock(), createBlock(unref(_sfc_main$2E), {
          key: 1,
          action: unref(iconOnly2),
          overrides: { primary: unref(primary2) },
          onAction: _cache[3] || (_cache[3] = () => {
            __props.onAction && __props.onAction();
          }),
          onMouseenter: _cache[4] || (_cache[4] = () => {
            __props.onMouseEnter && __props.onMouseEnter();
          }),
          onTouchstart: _cache[5] || (_cache[5] = () => {
            __props.onTouchStart && __props.onTouchStart();
          })
        }, null, 8, ["action", "overrides"]))
      ], 2);
    };
  }
});
var Header_vue_vue_type_style_index_0_lang = "";
const _sfc_main$L = /* @__PURE__ */ defineComponent({
  props: {
    title: null,
    subtitle: null,
    compactTitle: { type: Boolean },
    titleHidden: { type: Boolean },
    primaryAction: null,
    pagination: null,
    breadcrumbs: null,
    secondaryActions: null,
    actionGroups: null,
    additionalMetadata: null
  },
  setup(__props) {
    const props = __props;
    const slots = useSlots();
    const { useMediaQuery } = UseMediaQuery();
    const { isNavigationCollapsed } = useMediaQuery();
    const SHORT_TITLE = 20;
    const REALLY_SHORT_TITLE = 8;
    const breadcrumbProps = computed(() => {
      return { breadcrumbs: props.breadcrumbs || [] };
    });
    const pageTitleProps = computed(() => {
      return { title: props.title, subtitle: props.subtitle, compactTitle: props.compactTitle };
    });
    const actionMenuProps = computed(() => {
      return {
        title: props.title,
        secondaryActions: props.secondaryActions,
        actionGroups: props.actionGroups
      };
    });
    const primaryActionProps = computed(() => {
      return __spreadValues({}, props.primaryAction);
    });
    const additionalMetadataProps = computed(() => {
      return { additionalMetadata: props.additionalMetadata };
    });
    const conditionMobileCompact = computed(() => {
      return isNavigationCollapsed && (!props.breadcrumbs || !props.breadcrumbs.length) && props.title && props.title.length <= REALLY_SHORT_TITLE;
    });
    const conditionDesktopCompact = computed(() => {
      return !isNavigationCollapsed && !props.pagination && !props.secondaryActions && !slots.secondaryActions && props.title != null && props.title.length <= SHORT_TITLE;
    });
    const conditionSlot4 = computed(() => {
      return (isNavigationCollapsed || conditionDesktopCompact.value) && primaryActionProps.value || !isNavigationCollapsed && !conditionDesktopCompact.value && props.pagination;
    });
    return (_ctx, _cache) => {
      return openBlock(), createBlock(unref(_sfc_main$K), normalizeProps(guardReactiveProps(props)), createSlots({
        slot2: withCtx(() => [
          createVNode(unref(_sfc_main$N), normalizeProps(guardReactiveProps(unref(pageTitleProps))), {
            default: withCtx(() => [
              renderSlot(_ctx.$slots, "pageTitle")
            ]),
            _: 3
          }, 16)
        ]),
        slot3: withCtx(() => [
          createVNode(unref(_sfc_main$T), normalizeProps(guardReactiveProps(unref(actionMenuProps))), {
            default: withCtx(() => [
              renderSlot(_ctx.$slots, "secondaryActions")
            ]),
            _: 3
          }, 16),
          (unref(slots).primaryAction || props.primaryAction) && !unref(isNavigationCollapsed) && !unref(conditionDesktopCompact) ? (openBlock(), createBlock(unref(_sfc_main$M), normalizeProps(mergeProps({ key: 0 }, unref(primaryActionProps))), {
            default: withCtx(() => [
              renderSlot(_ctx.$slots, "primaryAction")
            ]),
            _: 3
          }, 16)) : createCommentVNode("", true)
        ]),
        slot5: withCtx(() => [
          createVNode(unref(_sfc_main$S), normalizeProps(guardReactiveProps(unref(additionalMetadataProps))), {
            default: withCtx(() => [
              renderSlot(_ctx.$slots, "additionalMetadata")
            ]),
            _: 3
          }, 16)
        ]),
        slot6: withCtx(() => [
          createVNode(unref(_sfc_main$R), null, {
            default: withCtx(() => [
              renderSlot(_ctx.$slots, "additionalNavigation")
            ]),
            _: 3
          })
        ]),
        _: 2
      }, [
        !unref(conditionMobileCompact) ? {
          name: "slot1",
          fn: withCtx(() => [
            createVNode(unref(_sfc_main$Q), normalizeProps(guardReactiveProps(unref(breadcrumbProps))), null, 16)
          ])
        } : void 0,
        unref(conditionSlot4) ? {
          name: "slot4",
          fn: withCtx(() => [
            (unref(slots).primaryAction || props.primaryAction) && (unref(isNavigationCollapsed) || unref(conditionDesktopCompact)) ? (openBlock(), createBlock(unref(_sfc_main$M), normalizeProps(mergeProps({ key: 0 }, unref(primaryActionProps))), {
              default: withCtx(() => [
                renderSlot(_ctx.$slots, "primaryAction")
              ]),
              _: 3
            }, 16)) : createCommentVNode("", true),
            !unref(isNavigationCollapsed) && !unref(conditionDesktopCompact) ? (openBlock(), createBlock(unref(_sfc_main$P), {
              key: 1,
              pagination: __props.pagination
            }, {
              default: withCtx(() => [
                unref(hasSlot)(unref(slots).pagination) ? renderSlot(_ctx.$slots, "pagination", { key: 0 }) : createCommentVNode("", true)
              ]),
              _: 3
            }, 8, ["pagination"])) : createCommentVNode("", true)
          ])
        } : void 0
      ]), 1040);
    };
  }
});
const _sfc_main$K = /* @__PURE__ */ defineComponent({
  props: {
    title: null,
    subtitle: null,
    compactTitle: { type: Boolean },
    titleHidden: { type: Boolean },
    primaryAction: null,
    pagination: null,
    breadcrumbs: null,
    secondaryActions: null,
    actionGroups: null,
    additionalMetadata: null
  },
  setup(__props) {
    const props = __props;
    const LONG_TITLE = 34;
    const slots = useSlots();
    const { useMediaQuery } = UseMediaQuery();
    const { isNavigationCollapsed } = useMediaQuery();
    const isSingleRow2 = computed(() => {
      return !props.primaryAction && slots.primaryAction && !props.pagination && (props.secondaryActions && !slots.secondaryActions && !props.secondaryActions.length || slots.secondaryActions) && (!props.actionGroups || !props.actionGroups.length);
    });
    const hasNavigationMarkup = computed(() => {
      return props.breadcrumbs && props.breadcrumbs.length > 0 || props.pagination && !isNavigationCollapsed || slots.additionalNavigation;
    });
    const hasActionMenuMarkup = computed(() => {
      return !slots.default || (props.secondaryActions && props.secondaryActions.length > 0 || hasGroupsWithActions(props.actionGroups));
    });
    const headerClassNames = computed(() => {
      return classNames(styles$w.Header, isSingleRow2.value && styles$w.isSingleRow, props.titleHidden && styles$w.titleHidden, hasNavigationMarkup.value && styles$w.hasNavigation, hasActionMenuMarkup.value && styles$w.hasActionMenu, isNavigationCollapsed && styles$w.mobileView, (!props.breadcrumbs || !props.breadcrumbs.length) && styles$w.noBreadcrumbs, props.title && props.title.length < LONG_TITLE && styles$w.mediumTitle, props.title && props.title.length > LONG_TITLE && styles$w.longTitle);
    });
    const hasSlot1 = computed(() => {
      return hasSlot(slots.slot1);
    });
    const hasSlot2 = computed(() => {
      return hasSlot(slots.slot2);
    });
    const hasSlot3 = computed(() => {
      return hasSlot(slots.slot3);
    });
    const hasSlot4 = computed(() => {
      return hasSlot(slots.slot4);
    });
    const hasSlot5 = computed(() => {
      return hasSlot(slots.slot5);
    });
    const hasSlot6 = computed(() => {
      return hasSlot(slots.slot6);
    });
    function hasGroupsWithActions(groups = []) {
      return groups.length === 0 ? false : groups.some((group) => group.actions.length > 0);
    }
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(unref(headerClassNames))
      }, [
        unref(hasSlot1) || unref(hasSlot2) || unref(hasSlot3) || unref(hasSlot4) ? (openBlock(), createElementBlock("div", {
          key: 0,
          class: normalizeClass(unref(styles$w).Row)
        }, [
          renderSlot(_ctx.$slots, "slot1"),
          renderSlot(_ctx.$slots, "slot2"),
          unref(hasSlot3) || unref(hasSlot4) ? (openBlock(), createElementBlock("div", {
            key: 0,
            class: normalizeClass(unref(styles$w).RightAlign)
          }, [
            unref(hasSlot3) && unref(hasSlot4) ? (openBlock(), createElementBlock("div", {
              key: 0,
              class: normalizeClass(unref(styles$w).Actions)
            }, [
              renderSlot(_ctx.$slots, "slot3"),
              renderSlot(_ctx.$slots, "slot4")
            ], 2)) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
              renderSlot(_ctx.$slots, "slot3"),
              renderSlot(_ctx.$slots, "slot4")
            ], 64))
          ], 2)) : createCommentVNode("", true)
        ], 2)) : createCommentVNode("", true),
        unref(hasSlot5) || unref(hasSlot6) ? (openBlock(), createElementBlock("div", {
          key: 1,
          class: normalizeClass(unref(styles$w).Row)
        }, [
          createElementVNode("div", {
            class: normalizeClass(unref(styles$w).LeftAlign)
          }, [
            renderSlot(_ctx.$slots, "slot5")
          ], 2),
          unref(hasSlot6) ? (openBlock(), createElementBlock("div", {
            key: 0,
            class: normalizeClass(unref(styles$w).RightAlign)
          }, [
            renderSlot(_ctx.$slots, "slot6")
          ], 2)) : createCommentVNode("", true)
        ], 2)) : createCommentVNode("", true)
      ], 2);
    };
  }
});
var Page_vue_vue_type_style_index_0_lang = "";
const _sfc_main$J = /* @__PURE__ */ defineComponent({
  props: {
    title: null,
    subtitle: null,
    compactTitle: { type: Boolean },
    titleHidden: { type: Boolean },
    primaryAction: null,
    pagination: null,
    breadcrumbs: null,
    secondaryActions: null,
    actionGroups: null,
    additionalMetadata: null,
    fullWidth: { type: Boolean },
    narrowWidth: { type: Boolean },
    divider: { type: Boolean }
  },
  setup(__props) {
    const props = __props;
    const slots = useSlots();
    const hasHeaderContent = computed(() => {
      return props.title || props.subtitle || (props.primaryAction || slots.primaryAction) || (props.secondaryActions || slots.secondaryActions) && (props.secondaryActions && !slots.secondaryActions && props.secondaryActions.length > 0 || slots.secondaryActions && (!props.secondaryActions && !slots.secondaryActions.length)) || (props.actionGroups && props.actionGroups.length > 0 || slots.actionGroups) || (props.breadcrumbs && props.breadcrumbs.length > 0 || slots.breadcrumbs);
    });
    const headerProps = computed(() => {
      const _a = props, { fullWidth: fullWidth2, narrowWidth: narrowWidth2, divider: divider2 } = _a, rest = __objRest(_a, ["fullWidth", "narrowWidth", "divider"]);
      return __spreadValues({}, rest);
    });
    const pageClassName = computed(() => {
      return classNames(styles$x.Page, props.fullWidth && styles$x.fullWidth, props.narrowWidth && styles$x.narrowWidth);
    });
    const contentClassName = computed(() => {
      return classNames(!hasHeaderContent.value && styles$x.Content, props.divider && hasHeaderContent && styles$x.divider);
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(unref(pageClassName))
      }, [
        unref(hasHeaderContent) ? (openBlock(), createBlock(unref(_sfc_main$L), normalizeProps(mergeProps({ key: 0 }, unref(headerProps))), createSlots({ _: 2 }, [
          unref(hasSlot)(unref(slots).pageTitle) ? {
            name: "pageTitle",
            fn: withCtx(() => [
              renderSlot(_ctx.$slots, "pageTitle")
            ])
          } : void 0,
          unref(slots).secondaryActions ? {
            name: "secondaryActions",
            fn: withCtx(() => [
              renderSlot(_ctx.$slots, "secondaryActions")
            ])
          } : void 0,
          unref(slots).primaryAction ? {
            name: "primaryAction",
            fn: withCtx(() => [
              renderSlot(_ctx.$slots, "primaryAction")
            ])
          } : void 0,
          unref(slots).additionalMetadata ? {
            name: "additionalMetadata",
            fn: withCtx(() => [
              renderSlot(_ctx.$slots, "additionalMetadata")
            ])
          } : void 0,
          unref(slots).additionalNavigation ? {
            name: "additionalNavigation",
            fn: withCtx(() => [
              renderSlot(_ctx.$slots, "additionalNavigation")
            ])
          } : void 0,
          unref(hasSlot)(unref(slots).pagination) ? {
            name: "pagination",
            fn: withCtx(() => [
              renderSlot(_ctx.$slots, "pagination")
            ])
          } : void 0
        ]), 1040)) : createCommentVNode("", true),
        createElementVNode("div", {
          class: normalizeClass(unref(contentClassName))
        }, [
          renderSlot(_ctx.$slots, "default")
        ], 2)
      ], 2);
    };
  }
});
const PageActions = "Polaris-PageActions";
var styles$u = {
  PageActions
};
var PageActions_vue_vue_type_style_index_0_lang = "";
const _sfc_main$I = /* @__PURE__ */ defineComponent({
  props: {
    primaryAction: null,
    secondaryActions: null
  },
  setup(__props) {
    const props = __props;
    const slots = useSlots();
    const distribution = computed(() => {
      return props.secondaryActions && props.secondaryActions.length > 0 ? "equalSpacing" : "trailing";
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(unref(styles$u).PageActions)
      }, [
        createVNode(unref(_sfc_main$12), {
          distribution: unref(distribution),
          spacing: "tight"
        }, {
          default: withCtx(() => [
            __props.secondaryActions && __props.secondaryActions.length > 0 ? (openBlock(), createBlock(unref(_sfc_main$2C), { key: 0 }, {
              default: withCtx(() => [
                (openBlock(true), createElementBlock(Fragment, null, renderList(__props.secondaryActions, (action) => {
                  return openBlock(), createBlock(unref(_sfc_main$2E), {
                    key: action.id,
                    action
                  }, null, 8, ["action"]);
                }), 128))
              ]),
              _: 1
            })) : createCommentVNode("", true),
            unref(hasSlot)(unref(slots).primaryAction) ? renderSlot(_ctx.$slots, "primaryAction", { key: 1 }) : __props.primaryAction ? (openBlock(), createBlock(unref(_sfc_main$2E), {
              key: 2,
              action: __props.primaryAction,
              overrides: { primary: true }
            }, null, 8, ["action"])) : createCommentVNode("", true)
          ]),
          _: 3
        }, 8, ["distribution"])
      ], 2);
    };
  }
});
function isInputFocused() {
  if (document == null || document.activeElement == null) {
    return false;
  }
  const { tagName } = document.activeElement;
  return tagName === "INPUT" || tagName === "TEXTAREA" || tagName === "SELECT" || document.activeElement.hasAttribute("contenteditable");
}
const _hoisted_1$l = ["aria-label"];
const _hoisted_2$b = {
  key: 2,
  "aria-live": "polite"
};
const _sfc_main$H = /* @__PURE__ */ defineComponent({
  props: {
    nextKeys: null,
    previousKeys: null,
    nextTooltip: null,
    previousTooltip: null,
    nextURL: null,
    previousURL: null,
    hasNext: { type: Boolean },
    hasPrevious: { type: Boolean },
    accessibilityLabel: null,
    accessibilityLabels: null
  },
  setup(__props) {
    const props = __props;
    const i18n = UseI18n();
    const paginationRef = ref(null);
    const slots = useSlots();
    const attrs = useAttrs();
    const navLabel = props.accessibilityLabel || i18n.translate("Polaris.Pagination.pagination");
    const previousLabel = props.accessibilityLabels && props.accessibilityLabels.previous || i18n.translate("Polaris.Pagination.previous");
    const nextLabel = props.accessibilityLabels && props.accessibilityLabels.next || i18n.translate("Polaris.Pagination.next");
    const prevKeyCondition = computed(() => {
      return props.previousKeys && (props.previousURL || attrs["onPrevious"]) && props.hasPrevious;
    });
    const nextKeyCondition = computed(() => {
      return props.nextKeys && (props.nextURL || attrs["onNext"]) && props.hasNext;
    });
    const callbackPrevUrl = () => {
      if (props.previousURL)
        ;
      const prevEmit = attrs["onPrevious"];
      handleCallback(prevEmit());
    };
    const callbackNextUrl = () => {
      if (props.nextURL)
        ;
      const nextEmit = attrs["onNext"];
      handleCallback(nextEmit());
    };
    const handleCallback = (fn) => {
      return () => {
        if (isInputFocused()) {
          return;
        }
        fn();
      };
    };
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("nav", {
        ref_key: "paginationRef",
        ref: paginationRef,
        "aria-label": unref(navLabel)
      }, [
        unref(prevKeyCondition) ? (openBlock(true), createElementBlock(Fragment, { key: 0 }, renderList(__props.previousKeys, (key) => {
          return openBlock(), createBlock(unref(_sfc_main$3p), {
            key,
            "key-code": key,
            handler: callbackPrevUrl
          }, null, 8, ["key-code"]);
        }), 128)) : createCommentVNode("", true),
        unref(nextKeyCondition) ? (openBlock(true), createElementBlock(Fragment, { key: 1 }, renderList(__props.nextKeys, (key) => {
          return openBlock(), createBlock(unref(_sfc_main$3p), {
            key,
            "key-code": key,
            handler: callbackNextUrl
          }, null, 8, ["key-code"]);
        }), 128)) : createCommentVNode("", true),
        createVNode(unref(_sfc_main$2C), {
          segmented: !unref(hasSlot)(unref(slots).default)
        }, {
          default: withCtx(() => [
            __props.previousTooltip && __props.hasPrevious ? (openBlock(), createBlock(unref(_sfc_main$f), {
              key: 0,
              "activator-wrapper": "span",
              content: __props.previousTooltip
            }, {
              default: withCtx(() => [
                createVNode(unref(_sfc_main$2F), {
                  id: "previousURL",
                  outline: "",
                  icon: unref(ChevronLeftMinor),
                  accessibilityLabel: unref(previousLabel),
                  url: __props.previousURL,
                  disabled: !__props.hasPrevious,
                  onClick: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("previous"))
                }, null, 8, ["icon", "accessibilityLabel", "url", "disabled"])
              ]),
              _: 1
            }, 8, ["content"])) : (openBlock(), createBlock(unref(_sfc_main$2F), {
              key: 1,
              id: "previousURL",
              outline: "",
              icon: unref(ChevronLeftMinor),
              accessibilityLabel: unref(previousLabel),
              url: __props.previousURL,
              disabled: !__props.hasPrevious,
              onClick: _cache[1] || (_cache[1] = ($event) => _ctx.$emit("previous"))
            }, null, 8, ["icon", "accessibilityLabel", "url", "disabled"])),
            unref(hasSlot)(unref(slots).default) ? (openBlock(), createElementBlock("div", _hoisted_2$b, [
              __props.hasNext && __props.hasPrevious ? (openBlock(), createBlock(unref(Text), {
                key: 0,
                variant: "bodyMd",
                as: "span"
              }, {
                default: withCtx(() => [
                  renderSlot(_ctx.$slots, "default")
                ]),
                _: 3
              })) : (openBlock(), createBlock(unref(Text), {
                key: 1,
                variant: "bodyMd",
                color: "subdued",
                as: "span"
              }, {
                default: withCtx(() => [
                  renderSlot(_ctx.$slots, "default")
                ]),
                _: 3
              }))
            ])) : createCommentVNode("", true),
            __props.nextTooltip && __props.hasNext ? (openBlock(), createBlock(unref(_sfc_main$f), {
              key: 3,
              "activator-wrapper": "span",
              content: __props.nextTooltip
            }, {
              default: withCtx(() => [
                createVNode(unref(_sfc_main$2F), {
                  id: "nextURL",
                  outline: "",
                  icon: unref(ChevronRightMinor),
                  accessibilityLabel: unref(nextLabel),
                  url: __props.nextURL,
                  onClick: _cache[2] || (_cache[2] = ($event) => _ctx.$emit("next")),
                  disabled: !__props.hasNext
                }, null, 8, ["icon", "accessibilityLabel", "url", "disabled"])
              ]),
              _: 1
            }, 8, ["content"])) : (openBlock(), createBlock(unref(_sfc_main$2F), {
              key: 4,
              id: "nextURL",
              outline: "",
              icon: unref(ChevronRightMinor),
              accessibilityLabel: unref(nextLabel),
              url: __props.nextURL,
              onClick: _cache[3] || (_cache[3] = ($event) => _ctx.$emit("next")),
              disabled: !__props.hasNext
            }, null, 8, ["icon", "accessibilityLabel", "url", "disabled"]))
          ]),
          _: 3
        }, 8, ["segmented"])
      ], 8, _hoisted_1$l);
    };
  }
});
const ProgressBar$1 = "Polaris-ProgressBar";
const sizeSmall$3 = "Polaris-ProgressBar--sizeSmall";
const sizeMedium$3 = "Polaris-ProgressBar--sizeMedium";
const sizeLarge$3 = "Polaris-ProgressBar--sizeLarge";
const colorHighlight = "Polaris-ProgressBar--colorHighlight";
const colorPrimary = "Polaris-ProgressBar--colorPrimary";
const colorSuccess = "Polaris-ProgressBar--colorSuccess";
const colorCritical = "Polaris-ProgressBar--colorCritical";
const Indicator$1 = "Polaris-ProgressBar__Indicator";
const IndicatorAppearActive = "Polaris-ProgressBar__IndicatorAppearActive";
const IndicatorAppearDone = "Polaris-ProgressBar__IndicatorAppearDone";
const Progress$1 = "Polaris-ProgressBar__Progress";
const Label$1 = "Polaris-ProgressBar__Label";
var styles$t = {
  ProgressBar: ProgressBar$1,
  sizeSmall: sizeSmall$3,
  sizeMedium: sizeMedium$3,
  sizeLarge: sizeLarge$3,
  colorHighlight,
  colorPrimary,
  colorSuccess,
  colorCritical,
  Indicator: Indicator$1,
  IndicatorAppearActive,
  IndicatorAppearDone,
  Progress: Progress$1,
  Label: Label$1
};
var ProgressBar_vue_vue_type_style_index_0_lang = "";
const _hoisted_1$k = ["aria-labelledby", "value"];
const _sfc_main$G = /* @__PURE__ */ defineComponent({
  props: {
    progress: { default: 0 },
    size: { default: "medium" },
    color: { default: "highlight" },
    animated: { type: Boolean, default: true },
    ariaLabelledBy: null
  },
  setup(__props) {
    const props = __props;
    const i18n = UseI18n();
    const className = computed(() => classNames(styles$t.ProgressBar, props.size && styles$t[variationName("size", props.size)], props.color && styles$t[variationName("color", props.color)]));
    const warningMessage = computed(() => {
      return props.progress < 0 ? i18n.translate("Polaris.ProgressBar.negativeWarningMessage", { progress: props.progress }) : i18n.translate("Polaris.ProgressBar.exceedWarningMessage", { progress: props.progress });
    });
    const parseProgress = (progress, message) => {
      let progressWidth;
      if (progress < 0) {
        progressWidth = 0;
      } else if (progress > 100) {
        progressWidth = 100;
      } else {
        progressWidth = progress;
      }
      return progressWidth;
    };
    const progressBarDuration = computed(() => props.animated ? motion["duration-500"] : motion["duration-0"]);
    const indicatorStyles = computed(() => {
      return {
        "--pc-progress-bar-duration": progressBarDuration.value,
        "--pc-progress-bar-percent": parsedProgress.value / 100
      };
    });
    const parsedProgress = computed(() => parseProgress(props.progress, warningMessage.value));
    const onTransitionEnter = (el, done) => {
      setTimeout(() => {
        el.classList.add(styles$t.IndicatorAppearDone);
        done();
      }, 1);
    };
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(unref(className))
      }, [
        createElementVNode("progress", {
          "aria-labelledby": __props.ariaLabelledBy,
          class: normalizeClass(unref(styles$t).Progress),
          value: unref(parsedProgress),
          max: "100"
        }, null, 10, _hoisted_1$k),
        createVNode(Transition, {
          appear: "",
          duration: parseInt(unref(progressBarDuration), 10),
          onEnter: onTransitionEnter
        }, {
          default: withCtx(() => [
            createElementVNode("div", {
              class: normalizeClass(unref(classNames)(unref(styles$t).Indicator)),
              style: normalizeStyle(unref(indicatorStyles))
            }, [
              createElementVNode("span", {
                class: normalizeClass(unref(styles$t).Label)
              }, toDisplayString(unref(parsedProgress)) + "%", 3)
            ], 6)
          ]),
          _: 1
        }, 8, ["duration"])
      ], 2);
    };
  }
});
const RadioButton = "Polaris-RadioButton";
const Input$3 = "Polaris-RadioButton__Input";
const keyFocused = "Polaris-RadioButton--keyFocused";
const Backdrop$2 = "Polaris-RadioButton__Backdrop";
const hover$1 = "Polaris-RadioButton--hover";
var styles$s = {
  RadioButton,
  Input: Input$3,
  keyFocused,
  Backdrop: Backdrop$2,
  hover: hover$1
};
var RadioButton_vue_vue_type_style_index_0_lang = "";
const _hoisted_1$j = ["id", "name", "value", "checked", "disabled", "aria-describedby"];
const _sfc_main$F = /* @__PURE__ */ defineComponent({
  props: {
    ariaDescribedBy: null,
    label: null,
    labelHidden: { type: Boolean },
    checked: { type: Boolean },
    helpText: null,
    disabled: { type: Boolean },
    id: null,
    name: null,
    value: null,
    modelValue: null
  },
  emits: ["focus", "change", "update:modelValue", "blur"],
  setup(__props, { emit: emits }) {
    const props = __props;
    const keyFocused2 = ref(false);
    const mouseOver = ref(false);
    const slots = useSlots();
    const helpTextSlot = computed(() => {
      var _a;
      return (_a = slots["help-text"]) == null ? void 0 : _a.call(slots);
    });
    const { useUniqueId } = UseUniqueId();
    const uniqueId = computed(() => useUniqueId("RadioButton", props.id));
    const isChecked = computed(() => props.checked || props.modelValue === props.value);
    const backdropClassName = computed(() => classNames(styles$s.Backdrop, mouseOver.value && styles$s.hover));
    const inputClassName = computed(() => classNames(styles$s.Input, keyFocused2.value && styles$s.keyFocused));
    const formattedAriaDescribedBy = computed(() => {
      const describedBy = [];
      if (props.ariaDescribedBy) {
        describedBy.push(props.ariaDescribedBy);
      }
      if (helpTextSlot.value) {
        describedBy.push(helpTextID(uniqueId.value));
      }
      return describedBy.length ? describedBy.join(" ") : void 0;
    });
    const handleChange = (event) => {
      const target = event.target;
      emits("change", event);
      emits("update:modelValue", target.value);
    };
    const handleBlur = () => {
      emits("blur");
      keyFocused2.value = false;
    };
    const handleKeyup = () => {
      if (!keyFocused2.value) {
        keyFocused2.value = true;
      }
    };
    return (_ctx, _cache) => {
      return openBlock(), createBlock(unref(_sfc_main$2t), {
        id: unref(uniqueId),
        disabled: __props.disabled,
        labelHidden: __props.labelHidden,
        onMouseover: _cache[1] || (_cache[1] = ($event) => mouseOver.value = true),
        onMouseout: _cache[2] || (_cache[2] = ($event) => mouseOver.value = false)
      }, createSlots({
        default: withCtx(() => [
          createElementVNode("span", {
            class: normalizeClass(unref(styles$s).RadioButton)
          }, [
            createElementVNode("input", {
              id: unref(uniqueId),
              name: __props.name || unref(uniqueId),
              value: __props.value,
              type: "radio",
              checked: unref(isChecked),
              disabled: __props.disabled,
              class: normalizeClass(unref(inputClassName)),
              "aria-describedby": unref(formattedAriaDescribedBy),
              onFocus: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("focus")),
              onChange: handleChange,
              onBlur: handleBlur,
              onKeyup: handleKeyup
            }, null, 42, _hoisted_1$j),
            createElementVNode("span", {
              class: normalizeClass(unref(backdropClassName))
            }, null, 2)
          ], 2)
        ]),
        _: 2
      }, [
        unref(hasSlot)(unref(slots).label) || __props.label ? {
          name: "label",
          fn: withCtx(() => [
            unref(hasSlot)(unref(slots).label) ? renderSlot(_ctx.$slots, "label", { key: 0 }) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
              createTextVNode(toDisplayString(__props.label), 1)
            ], 64))
          ])
        } : void 0,
        unref(hasSlot)(unref(slots)["help-text"]) || __props.helpText ? {
          name: "help-text",
          fn: withCtx(() => [
            unref(hasSlot)(unref(slots)["help-text"]) ? renderSlot(_ctx.$slots, "help-text", { key: 0 }) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
              createTextVNode(toDisplayString(__props.helpText), 1)
            ], 64))
          ])
        } : void 0
      ]), 1032, ["id", "disabled", "labelHidden"]);
    };
  }
});
function invertNumber(number) {
  if (Math.sign(number) === 1) {
    return -Math.abs(number);
  } else if (Math.sign(number) === -1) {
    return Math.abs(number);
  } else {
    return 0;
  }
}
const RangeSlider$2 = "Polaris-RangeSlider-SingleThumb__RangeSlider";
const SingleThumb = "Polaris-RangeSlider-SingleThumb";
const disabled$3 = "Polaris-RangeSlider-SingleThumb--disabled";
const InputWrapper = "Polaris-RangeSlider-SingleThumb__InputWrapper";
const Prefix$2 = "Polaris-RangeSlider-SingleThumb__Prefix";
const Suffix$1 = "Polaris-RangeSlider-SingleThumb__Suffix";
const Input$2 = "Polaris-RangeSlider-SingleThumb__Input";
const error$2 = "Polaris-RangeSlider-SingleThumb--error";
const Output$1 = "Polaris-RangeSlider-SingleThumb__Output";
const OutputBubble$1 = "Polaris-RangeSlider-SingleThumb__OutputBubble";
var styles$r = {
  RangeSlider: RangeSlider$2,
  SingleThumb,
  disabled: disabled$3,
  InputWrapper,
  Prefix: Prefix$2,
  Suffix: Suffix$1,
  Input: Input$2,
  error: error$2,
  Output: Output$1,
  OutputBubble: OutputBubble$1
};
const RangeSlider$1 = "Polaris-RangeSlider";
var sharedStyles = {
  RangeSlider: RangeSlider$1
};
var SingleThumb_vue_vue_type_style_index_0_lang = "";
const _hoisted_1$i = ["id", "name", "min", "max", "step", "value", "disabled", "aria-valuemin", "aria-valuemax", "aria-valuenow", "aria-invalid", "aria-describedby"];
const _hoisted_2$a = ["for"];
const _sfc_main$E = /* @__PURE__ */ defineComponent({
  props: {
    labelAction: null,
    labelHidden: { type: Boolean },
    id: null,
    modelValue: null,
    min: null,
    max: null,
    step: null,
    output: { type: Boolean },
    error: null,
    disabled: { type: Boolean },
    prefix: null,
    suffix: null
  },
  emits: ["input", "focus", "blur"],
  setup(__props, { emit: emits }) {
    const props = __props;
    const slots = useSlots();
    const clampedValue = computed(() => clamp(props.modelValue, props.min, props.max));
    const describedBy = ref([]);
    if (props.error) {
      describedBy.value.push(`${props.id}Error`);
    }
    if (slots["help-text"]) {
      describedBy.value.push(helpTextID$1(props.id));
    }
    const ariaDescribedBy = computed(() => describedBy.value.length ? describedBy.value.join(" ") : void 0);
    const sliderProgress = computed(() => (clampedValue.value - props.min) * 100 / (props.max - props.min));
    const outputFactor = computed(() => invertNumber((sliderProgress.value - 50) / 100));
    const cssVars = computed(() => {
      return {
        "--pc-range-slider-min": props.min,
        "--pc-range-slider-max": props.max,
        "--pc-range-slider-current": clampedValue.value,
        "--pc-range-slider-progress": `${sliderProgress.value}%`,
        "--pc-range-slider-output-factor": `${outputFactor.value}`
      };
    });
    const className = computed(() => classNames(styles$r.SingleThumb, sharedStyles.RangeSlider, props.error && styles$r.error, props.disabled && styles$r.disabled));
    const handleChange = (event) => {
      emits("input", parseFloat(event.target.value), props.id);
    };
    return (_ctx, _cache) => {
      return openBlock(), createBlock(unref(_sfc_main$1o), {
        id: __props.id,
        action: __props.labelAction,
        labelHidden: __props.labelHidden
      }, createSlots({
        default: withCtx(() => [
          createElementVNode("div", {
            class: normalizeClass(unref(className)),
            style: normalizeStyle(unref(cssVars))
          }, [
            unref(hasSlot)(unref(slots).prefix) || __props.prefix ? (openBlock(), createElementBlock("div", {
              key: 0,
              class: normalizeClass(unref(styles$r).Prefix)
            }, [
              unref(hasSlot)(unref(slots).prefix) ? renderSlot(_ctx.$slots, "prefix", { key: 0 }) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
                createTextVNode(toDisplayString(__props.prefix), 1)
              ], 64))
            ], 2)) : createCommentVNode("", true),
            createElementVNode("div", {
              class: normalizeClass(unref(styles$r).InputWrapper)
            }, [
              createElementVNode("input", {
                type: "range",
                class: normalizeClass(unref(styles$r).Input),
                id: __props.id,
                name: __props.id,
                min: __props.min,
                max: __props.max,
                step: __props.step,
                value: unref(clampedValue),
                disabled: __props.disabled,
                "aria-valuemin": __props.min,
                "aria-valuemax": __props.max,
                "aria-valuenow": unref(clampedValue),
                "aria-invalid": Boolean(__props.error),
                "aria-describedby": unref(ariaDescribedBy),
                onInput: handleChange,
                onFocus: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("focus")),
                onBlur: _cache[1] || (_cache[1] = ($event) => _ctx.$emit("blur"))
              }, null, 42, _hoisted_1$i),
              !__props.disabled && __props.output ? (openBlock(), createElementBlock("output", {
                key: 0,
                for: __props.id,
                class: normalizeClass(unref(styles$r).Output)
              }, [
                createElementVNode("div", {
                  class: normalizeClass(unref(styles$r).OutputBubble)
                }, [
                  createVNode(unref(Text), {
                    as: "span",
                    variant: "headingXs",
                    alignment: "center"
                  }, {
                    default: withCtx(() => [
                      createTextVNode(toDisplayString(unref(clampedValue)), 1)
                    ]),
                    _: 1
                  })
                ], 2)
              ], 10, _hoisted_2$a)) : createCommentVNode("", true)
            ], 2),
            unref(hasSlot)(unref(slots).suffix) || __props.suffix ? (openBlock(), createElementBlock("div", {
              key: 1,
              class: normalizeClass(unref(styles$r).Suffix)
            }, [
              unref(hasSlot)(unref(slots).suffix) ? renderSlot(_ctx.$slots, "suffix", { key: 0 }) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
                createTextVNode(toDisplayString(__props.suffix), 1)
              ], 64))
            ], 2)) : createCommentVNode("", true)
          ], 6)
        ]),
        _: 2
      }, [
        unref(hasSlot)(unref(slots).label) ? {
          name: "label",
          fn: withCtx(() => [
            renderSlot(_ctx.$slots, "label")
          ])
        } : void 0,
        unref(hasSlot)(unref(slots)["help-text"]) ? {
          name: "help-text",
          fn: withCtx(() => [
            renderSlot(_ctx.$slots, "help-text")
          ])
        } : void 0
      ]), 1032, ["id", "action", "labelHidden"]);
    };
  }
});
const RangeSlider = "Polaris-RangeSlider-DualThumb__RangeSlider";
const DualThumb = "Polaris-RangeSlider-DualThumb";
const TrackWrapper = "Polaris-RangeSlider-DualThumb__TrackWrapper";
const disabled$2 = "Polaris-RangeSlider-DualThumb--disabled";
const Track = "Polaris-RangeSlider-DualThumb__Track";
const error$1 = "Polaris-RangeSlider-DualThumb--error";
const Thumbs = "Polaris-RangeSlider-DualThumb__Thumbs";
const Prefix$1 = "Polaris-RangeSlider-DualThumb__Prefix";
const Suffix = "Polaris-RangeSlider-DualThumb__Suffix";
const Output = "Polaris-RangeSlider-DualThumb__Output";
const OutputBubble = "Polaris-RangeSlider-DualThumb__OutputBubble";
var styles$q = {
  RangeSlider,
  DualThumb,
  TrackWrapper,
  disabled: disabled$2,
  Track,
  error: error$1,
  "Track--dashed": "Polaris-RangeSlider-DualThumb--trackDashed",
  Thumbs,
  Prefix: Prefix$1,
  Suffix,
  Output,
  OutputBubble
};
var DualThumb_vue_vue_type_style_index_0_lang = "";
const _hoisted_1$h = ["id", "aria-disabled", "aria-valuemin", "aria-valuemax", "aria-valuenow", "aria-invalid", "aria-describedby", "aria-labelledby"];
const _hoisted_2$9 = ["for"];
const _hoisted_3$7 = ["id", "aria-disabled", "aria-valuemin", "aria-valuemax", "aria-valuenow", "aria-invalid", "aria-describedby", "aria-labelledby"];
const _hoisted_4$4 = ["for"];
const _sfc_main$D = /* @__PURE__ */ defineComponent({
  props: {
    modelValue: null,
    labelAction: null,
    labelHidden: { type: Boolean },
    id: null,
    min: null,
    max: null,
    step: null,
    output: { type: Boolean },
    error: null,
    disabled: { type: Boolean },
    prefix: null,
    suffix: null
  },
  emits: ["input", "update:modelValue", "focus", "blur"],
  setup(__props, { emit: emits }) {
    const props = __props;
    const slots = useSlots();
    const value2 = ref(sanitizeValue(props.modelValue, props.min, props.max, props.step));
    const trackWidth = ref(0);
    const trackLeft = ref(0);
    const track = ref(null);
    const trackWrapper = ref(null);
    const thumbLower = ref(null);
    const thumbUpper = ref(null);
    const setTrackPosition = debounce(() => {
      if (track.value) {
        const thumbSize = 16;
        const { width, left } = track.value.getBoundingClientRect();
        const adjustedTrackWidth = width - thumbSize;
        const adjustedTrackLeft = left + thumbSize / 2;
        const range2 = props.max - props.min;
        const minValuePosition2 = props.min / range2 * adjustedTrackWidth;
        trackWidth.value = adjustedTrackWidth;
        trackLeft.value = adjustedTrackLeft - minValuePosition2;
      }
    }, 40, { leading: true, trailing: true, maxWait: 40 });
    const idLower = computed(() => props.id);
    const idUpper = computed(() => `${props.id}Upper`);
    const describedBy = ref([]);
    if (props.error) {
      describedBy.value.push(`${props.id}Error`);
    }
    const ariaDescribedBy = computed(() => describedBy.value.length ? describedBy.value.join(" ") : void 0);
    const trackWrapperClassName = computed(() => classNames(styles$q.TrackWrapper, props.error && styles$q.error, props.disabled && styles$q.disabled));
    const thumbLowerClassName = computed(() => classNames(styles$q.Thumbs, props.disabled && styles$q.disabled));
    const thumbUpperClassName = computed(() => classNames(styles$q.Thumbs, props.disabled && styles$q.disabled));
    const range = computed(() => props.max - props.min);
    const minValuePosition = computed(() => props.min / range.value * trackWidth.value);
    const leftPositionThumbLower = computed(() => value2.value[0] / range.value * trackWidth.value - minValuePosition.value);
    const leftPositionThumbUpper = computed(() => value2.value[1] / range.value * trackWidth.value - minValuePosition.value);
    const outputLowerClassName = computed(() => classNames(styles$q.Output));
    const outputUpperClassName = computed(() => classNames(styles$q.Output));
    const cssVars = computed(() => {
      return {
        "--pc-range-slider-progress-lower": `${leftPositionThumbLower.value}px`,
        "--pc-range-slider-progress-upper": `${leftPositionThumbUpper.value}px`
      };
    });
    onMounted(() => {
      setTrackPosition();
      if (trackWrapper.value) {
        trackWrapper.value.addEventListener("touchstart", handleTouchStartTrack, { passive: false });
      }
    });
    onBeforeUnmount(() => {
      if (trackWrapper.value) {
        trackWrapper.value.removeEventListener("touchstart", handleTouchStartTrack);
      }
    });
    const handleMouseDownThumbLower = (event) => {
      if (event.button !== 0 || props.disabled) {
        return;
      }
      registerMouseMoveHandler(handleMouseMoveThumbLower);
      event.stopPropagation();
    };
    const handleMouseMoveThumbLower = (event) => {
      const valueUpper = value2.value[1];
      setValue([actualXPosition(event.clientX), valueUpper], "Upper");
    };
    const handleTouchStartThumbLower = (event) => {
      if (props.disabled) {
        return;
      }
      registerTouchMoveHandler(handleTouchMoveThumbLower);
      event.stopPropagation();
    };
    const handleTouchMoveThumbLower = (event) => {
      event.preventDefault();
      const valueUpper = value2.value[1];
      setValue([actualXPosition(event.touches[0].clientX), valueUpper], "Upper");
    };
    const handleMouseDownThumbUpper = (event) => {
      if (event.button !== 0 || props.disabled) {
        return;
      }
      registerMouseMoveHandler(handleMouseMoveThumbUpper);
      event.stopPropagation();
    };
    const handleMouseMoveThumbUpper = (event) => {
      const valueLower = value2.value[0];
      setValue([valueLower, actualXPosition(event.clientX)], "Lower");
    };
    const handleTouchStartThumbUpper = (event) => {
      if (props.disabled) {
        return;
      }
      registerTouchMoveHandler(handleTouchMoveThumbUpper);
      event.stopPropagation();
    };
    const handleTouchMoveThumbUpper = (event) => {
      event.preventDefault();
      const valueLower = value2.value[0];
      setValue([valueLower, actualXPosition(event.touches[0].clientX)], "Lower");
    };
    const handleKeypressLower = (event) => {
      if (props.disabled) {
        return;
      }
      const handlerMap = {
        [Key.ArrowUp]: incrementValueLower,
        [Key.ArrowRight]: incrementValueLower,
        [Key.ArrowDown]: decrementValueLower,
        [Key.ArrowLeft]: decrementValueLower
      };
      const handler = handlerMap[event.key];
      if (handler != null) {
        event.preventDefault();
        event.stopPropagation();
        handler();
      }
    };
    const handleKeypressUpper = (event) => {
      if (props.disabled) {
        return;
      }
      const handlerMap = {
        [Key.ArrowUp]: incrementValueUpper,
        [Key.ArrowRight]: incrementValueUpper,
        [Key.ArrowDown]: decrementValueUpper,
        [Key.ArrowLeft]: decrementValueUpper
      };
      const handler = handlerMap[event.key];
      if (handler != null) {
        event.preventDefault();
        event.stopPropagation();
        handler();
      }
    };
    const incrementValueLower = () => {
      setValue([value2.value[0] + props.step, value2.value[1]], "Upper");
    };
    const decrementValueLower = () => {
      setValue([value2.value[0] - props.step, value2.value[1]], "Upper");
    };
    const incrementValueUpper = () => {
      setValue([value2.value[0], value2.value[1] + props.step], "Lower");
    };
    const decrementValueUpper = () => {
      setValue([value2.value[0], value2.value[1] - props.step], "Lower");
    };
    const dispatchValue = () => {
      emits("input", value2.value, props.id);
      emits("update:modelValue", value2.value, props.id);
    };
    const setValue = (dirtyValue, control) => {
      const sanitizedValue = sanitizeValue(dirtyValue, props.min, props.max, props.step, control);
      if (!isTupleEqual(sanitizedValue, value2.value)) {
        value2.value = sanitizedValue;
        dispatchValue();
      }
    };
    const handleMouseDownTrack = (event) => {
      if (event.button !== 0 || props.disabled) {
        return;
      }
      event.preventDefault();
      const clickXPosition = actualXPosition(event.clientX);
      const distanceFromLowerThumb = Math.abs(value2.value[0] - clickXPosition);
      const distanceFromUpperThumb = Math.abs(value2.value[1] - clickXPosition);
      if (distanceFromLowerThumb <= distanceFromUpperThumb) {
        setValue([clickXPosition, value2.value[1]], "Upper");
        registerMouseMoveHandler(handleMouseMoveThumbLower);
        if (thumbLower.value) {
          thumbLower.value.focus();
        }
      } else {
        setValue([value2.value[0], clickXPosition], "Lower");
        registerMouseMoveHandler(handleMouseMoveThumbUpper);
        if (thumbUpper.value) {
          thumbUpper.value.focus();
        }
      }
    };
    const handleTouchStartTrack = (event) => {
      if (props.disabled) {
        return;
      }
      event.preventDefault();
      const clickXPosition = actualXPosition(event.touches[0].clientX);
      const distanceFromLowerThumb = Math.abs(value2.value[0] - clickXPosition);
      const distanceFromUpperThumb = Math.abs(value2.value[1] - clickXPosition);
      if (distanceFromLowerThumb <= distanceFromUpperThumb) {
        setValue([clickXPosition, value2.value[1]], "Upper");
        registerTouchMoveHandler(handleTouchMoveThumbLower);
        if (thumbLower.value) {
          thumbLower.value.focus();
        }
      } else {
        setValue([value2.value[0], clickXPosition], "Lower");
        registerTouchMoveHandler(handleTouchMoveThumbUpper);
        if (thumbUpper.value) {
          thumbUpper.value.focus();
        }
      }
    };
    const actualXPosition = (dirtyXPosition) => {
      if (track.value) {
        const { min, max } = props;
        const relativeX = dirtyXPosition - trackLeft.value;
        const percentageOfTrack = relativeX / trackWidth.value;
        return percentageOfTrack * (max - min);
      } else {
        return 0;
      }
    };
    function registerMouseMoveHandler(handler) {
      document.addEventListener("mousemove", handler);
      document.addEventListener("mouseup", () => {
        document.removeEventListener("mousemove", handler);
      }, { once: true });
    }
    function registerTouchMoveHandler(handler) {
      const removeHandler = () => {
        document.removeEventListener("touchmove", handler);
        document.removeEventListener("touchend", removeHandler);
        document.removeEventListener("touchcancel", removeHandler);
      };
      document.addEventListener("touchmove", handler, { passive: false });
      document.addEventListener("touchend", removeHandler, { once: true });
      document.addEventListener("touchcancel", removeHandler, { once: true });
    }
    function sanitizeValue(mainValue, min, max, step, control = "Upper") {
      let upperValue = inBoundsUpper(roundedToStep(mainValue[1]));
      let lowerValue = inBoundsLower(roundedToStep(mainValue[0]));
      const maxLowerValue = upperValue - step;
      const minUpperValue = lowerValue + step;
      if (control === "Upper" && lowerValue > maxLowerValue) {
        lowerValue = maxLowerValue;
      } else if (control === "Lower" && upperValue < minUpperValue) {
        upperValue = minUpperValue;
      }
      return [lowerValue, upperValue];
      function inBoundsUpper(tmpValue) {
        const lowerMin = min + step;
        if (tmpValue < lowerMin) {
          return lowerMin;
        } else if (tmpValue > max) {
          return max;
        } else {
          return tmpValue;
        }
      }
      function inBoundsLower(tmpValue) {
        const upperMax = max - step;
        if (tmpValue < min) {
          return min;
        } else if (tmpValue > upperMax) {
          return upperMax;
        } else {
          return tmpValue;
        }
      }
      function roundedToStep(tmpValue) {
        return Math.round(tmpValue / step) * step;
      }
    }
    function isTupleEqual(a, b) {
      if (a == null || b == null) {
        return false;
      }
      return a[0] === b[0] && a[1] === b[1];
    }
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock(Fragment, null, [
        createVNode(unref(_sfc_main$1o), {
          id: __props.id,
          error: __props.error,
          action: __props.labelAction,
          labelHidden: __props.labelHidden
        }, createSlots({
          default: withCtx(() => [
            createElementVNode("div", {
              class: normalizeClass(unref(classNames)(unref(styles$q).DualThumb, unref(sharedStyles).RangeSlider))
            }, [
              unref(hasSlot)(unref(slots).prefix) || __props.prefix ? (openBlock(), createElementBlock("div", {
                key: 0,
                class: normalizeClass(unref(styles$q).Prefix)
              }, [
                unref(hasSlot)(unref(slots).prefix) ? renderSlot(_ctx.$slots, "prefix", { key: 0 }) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
                  createTextVNode(toDisplayString(__props.prefix), 1)
                ], 64))
              ], 2)) : createCommentVNode("", true),
              createElementVNode("div", {
                class: normalizeClass(unref(trackWrapperClassName)),
                ref_key: "trackWrapper",
                ref: trackWrapper,
                onMousedown: handleMouseDownTrack
              }, [
                createElementVNode("div", {
                  class: normalizeClass(unref(styles$q).Track),
                  style: normalizeStyle(unref(cssVars)),
                  ref_key: "track",
                  ref: track
                }, null, 6),
                createElementVNode("div", {
                  class: normalizeClass(unref(styles$q)["Track--dashed"])
                }, null, 2),
                createElementVNode("div", {
                  id: unref(idLower),
                  class: normalizeClass(unref(thumbLowerClassName)),
                  style: normalizeStyle({ left: `${unref(leftPositionThumbLower)}px` }),
                  ref_key: "thumbLower",
                  ref: thumbLower,
                  role: "slider",
                  "aria-disabled": __props.disabled,
                  "aria-valuemin": __props.min,
                  "aria-valuemax": __props.max,
                  "aria-valuenow": value2.value[0],
                  "aria-invalid": Boolean(__props.error),
                  "aria-describedby": unref(ariaDescribedBy),
                  "aria-labelledby": unref(labelID)(__props.id),
                  tabIndex: "0",
                  onFocus: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("focus")),
                  onBlur: _cache[1] || (_cache[1] = ($event) => _ctx.$emit("blur")),
                  onKeydown: handleKeypressLower,
                  onMousedown: handleMouseDownThumbLower,
                  onTouchstart: handleTouchStartThumbLower
                }, null, 46, _hoisted_1$h),
                !__props.disabled && __props.output ? (openBlock(), createElementBlock("output", {
                  key: 0,
                  for: unref(idUpper),
                  class: normalizeClass(unref(outputLowerClassName)),
                  style: normalizeStyle({ left: `${unref(leftPositionThumbLower)}px` })
                }, [
                  createElementVNode("div", {
                    class: normalizeClass(unref(styles$q).OutputBubble)
                  }, [
                    createVNode(unref(Text), {
                      as: "span",
                      variant: "headingXs",
                      alignment: "center"
                    }, {
                      default: withCtx(() => [
                        createTextVNode(toDisplayString(value2.value[0]), 1)
                      ]),
                      _: 1
                    })
                  ], 2)
                ], 14, _hoisted_2$9)) : createCommentVNode("", true),
                createElementVNode("div", {
                  id: unref(idUpper),
                  class: normalizeClass(unref(thumbUpperClassName)),
                  style: normalizeStyle({ left: `${unref(leftPositionThumbUpper)}px` }),
                  role: "slider",
                  tabIndex: "0",
                  ref_key: "thumbUpper",
                  ref: thumbUpper,
                  "aria-disabled": __props.disabled,
                  "aria-valuemin": __props.min,
                  "aria-valuemax": __props.max,
                  "aria-valuenow": value2.value[1],
                  "aria-invalid": Boolean(__props.error),
                  "aria-describedby": unref(ariaDescribedBy),
                  "aria-labelledby": unref(labelID)(__props.id),
                  onFocus: _cache[2] || (_cache[2] = ($event) => _ctx.$emit("focus")),
                  onBlur: _cache[3] || (_cache[3] = ($event) => _ctx.$emit("blur")),
                  onKeydown: handleKeypressUpper,
                  onMousedown: handleMouseDownThumbUpper,
                  onTouchstart: handleTouchStartThumbUpper
                }, null, 46, _hoisted_3$7),
                !__props.disabled && __props.output ? (openBlock(), createElementBlock("output", {
                  key: 1,
                  for: unref(idUpper),
                  class: normalizeClass(unref(outputUpperClassName)),
                  style: normalizeStyle({ left: `${unref(leftPositionThumbUpper)}px` })
                }, [
                  createElementVNode("div", {
                    class: normalizeClass(unref(styles$q).OutputBubble)
                  }, [
                    createVNode(unref(Text), {
                      as: "span",
                      variant: "headingXs",
                      alignment: "center"
                    }, {
                      default: withCtx(() => [
                        createTextVNode(toDisplayString(value2.value[1]), 1)
                      ]),
                      _: 1
                    })
                  ], 2)
                ], 14, _hoisted_4$4)) : createCommentVNode("", true)
              ], 34),
              unref(hasSlot)(unref(slots).suffix) || __props.suffix ? (openBlock(), createElementBlock("div", {
                key: 1,
                class: normalizeClass(unref(styles$q).Suffix)
              }, [
                unref(hasSlot)(unref(slots).suffix) ? renderSlot(_ctx.$slots, "suffix", { key: 0 }) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
                  createTextVNode(toDisplayString(__props.suffix), 1)
                ], 64))
              ], 2)) : createCommentVNode("", true)
            ], 2)
          ]),
          _: 2
        }, [
          unref(hasSlot)(unref(slots).label) ? {
            name: "label",
            fn: withCtx(() => [
              renderSlot(_ctx.$slots, "label")
            ])
          } : void 0,
          unref(hasSlot)(unref(slots)["help-text"]) ? {
            name: "help-text",
            fn: withCtx(() => [
              renderSlot(_ctx.$slots, "help-text")
            ])
          } : void 0
        ]), 1032, ["id", "error", "action", "labelHidden"]),
        createVNode(unref(_sfc_main$33), {
          event: "resize",
          handler: unref(setTrackPosition)
        }, null, 8, ["handler"])
      ], 64);
    };
  }
});
var RangeSlider_vue_vue_type_style_index_0_lang = "";
const _sfc_main$C = /* @__PURE__ */ defineComponent({
  props: {
    label: null,
    labelAction: null,
    labelHidden: { type: Boolean },
    modelValue: null,
    helpText: null,
    min: { default: 0 },
    max: { default: 100 },
    step: { default: 1 },
    output: { type: Boolean },
    error: null,
    disabled: { type: Boolean },
    prefix: null,
    suffix: null
  },
  emits: ["change", "update:modelValue", "focus", "blur"],
  setup(__props, { emit: emits }) {
    const props = __props;
    const slots = useSlots();
    const { useUniqueId } = UseUniqueId();
    const id = useUniqueId("RangeSlider");
    const isDualThumb = computed(() => Array.isArray(props.modelValue));
    const singleValue = computed(() => isDualThumb.value ? props.modelValue[0] : props.modelValue);
    const dualValue = computed(() => {
      return isDualThumb.value ? props.modelValue : [props.modelValue, props.modelValue + 1];
    });
    const sharedProps = computed(() => {
      const _a = props, { label, modelValue: modelValue2 } = _a, rest = __objRest(_a, ["label", "modelValue"]);
      return __spreadValues({
        id
      }, rest);
    });
    const handleChange = (value2, thumbId) => {
      emits("change", value2, thumbId);
      emits("update:modelValue", value2, thumbId);
    };
    return (_ctx, _cache) => {
      return unref(isDualThumb) ? (openBlock(), createBlock(unref(_sfc_main$D), mergeProps({
        key: 0,
        modelValue: unref(dualValue),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => isRef(dualValue) ? dualValue.value = $event : null)
      }, unref(sharedProps), {
        onInput: handleChange,
        onFocus: _cache[1] || (_cache[1] = ($event) => emits("focus")),
        onBlur: _cache[2] || (_cache[2] = ($event) => emits("blur"))
      }), createSlots({ _: 2 }, [
        unref(hasSlot)(unref(slots).label) || __props.label ? {
          name: "label",
          fn: withCtx(() => [
            unref(hasSlot)(unref(slots).label) ? renderSlot(_ctx.$slots, "label", { key: 0 }) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
              createTextVNode(toDisplayString(__props.label), 1)
            ], 64))
          ])
        } : void 0,
        unref(hasSlot)(unref(slots)["help-text"]) || __props.helpText ? {
          name: "help-text",
          fn: withCtx(() => [
            unref(hasSlot)(unref(slots)["help-text"]) ? renderSlot(_ctx.$slots, "help-text", { key: 0 }) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
              createTextVNode(toDisplayString(__props.helpText), 1)
            ], 64))
          ])
        } : void 0,
        unref(hasSlot)(unref(slots).prefix) || __props.prefix ? {
          name: "prefix",
          fn: withCtx(() => [
            unref(hasSlot)(unref(slots).prefix) ? renderSlot(_ctx.$slots, "prefix", { key: 0 }) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
              createTextVNode(toDisplayString(__props.prefix), 1)
            ], 64))
          ])
        } : void 0,
        unref(hasSlot)(unref(slots).suffix) || __props.suffix ? {
          name: "suffix",
          fn: withCtx(() => [
            unref(hasSlot)(unref(slots).suffix) ? renderSlot(_ctx.$slots, "suffix", { key: 0 }) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
              createTextVNode(toDisplayString(__props.suffix), 1)
            ], 64))
          ])
        } : void 0
      ]), 1040, ["modelValue"])) : (openBlock(), createBlock(unref(_sfc_main$E), mergeProps({
        key: 1,
        modelValue: unref(singleValue),
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => isRef(singleValue) ? singleValue.value = $event : null)
      }, unref(sharedProps), {
        onInput: handleChange,
        onFocus: _cache[4] || (_cache[4] = ($event) => emits("focus")),
        onBlur: _cache[5] || (_cache[5] = ($event) => emits("blur"))
      }), createSlots({ _: 2 }, [
        unref(hasSlot)(unref(slots).label) || __props.label ? {
          name: "label",
          fn: withCtx(() => [
            unref(hasSlot)(unref(slots).label) ? renderSlot(_ctx.$slots, "label", { key: 0 }) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
              createTextVNode(toDisplayString(__props.label), 1)
            ], 64))
          ])
        } : void 0,
        unref(hasSlot)(unref(slots)["help-text"]) || __props.helpText ? {
          name: "help-text",
          fn: withCtx(() => [
            unref(hasSlot)(unref(slots)["help-text"]) ? renderSlot(_ctx.$slots, "help-text", { key: 0 }) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
              createTextVNode(toDisplayString(__props.helpText), 1)
            ], 64))
          ])
        } : void 0,
        unref(hasSlot)(unref(slots).prefix) || __props.prefix ? {
          name: "prefix",
          fn: withCtx(() => [
            unref(hasSlot)(unref(slots).prefix) ? renderSlot(_ctx.$slots, "prefix", { key: 0 }) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
              createTextVNode(toDisplayString(__props.prefix), 1)
            ], 64))
          ])
        } : void 0,
        unref(hasSlot)(unref(slots).suffix) || __props.suffix ? {
          name: "suffix",
          fn: withCtx(() => [
            unref(hasSlot)(unref(slots).suffix) ? renderSlot(_ctx.$slots, "suffix", { key: 0 }) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
              createTextVNode(toDisplayString(__props.suffix), 1)
            ], 64))
          ])
        } : void 0
      ]), 1040, ["modelValue"]));
    };
  }
});
const SELECT_ALL_ITEMS = "All";
const CheckboxWrapper = "Polaris-ResourceItem__CheckboxWrapper";
const ResourceItem = "Polaris-ResourceItem";
const persistActions = "Polaris-ResourceItem--persistActions";
const Actions$1 = "Polaris-ResourceItem__Actions";
const ItemWrapper$1 = "Polaris-ResourceItem__ItemWrapper";
const focusedInner = "Polaris-ResourceItem--focusedInner";
const focused$2 = "Polaris-ResourceItem--focused";
const selected$1 = "Polaris-ResourceItem--selected";
const Link$1 = "Polaris-ResourceItem__Link";
const Button$1 = "Polaris-ResourceItem__Button";
const Container$1 = "Polaris-ResourceItem__Container";
const alignmentLeading = "Polaris-ResourceItem--alignmentLeading";
const alignmentTrailing = "Polaris-ResourceItem--alignmentTrailing";
const alignmentCenter = "Polaris-ResourceItem--alignmentCenter";
const alignmentFill = "Polaris-ResourceItem--alignmentFill";
const alignmentBaseline = "Polaris-ResourceItem--alignmentBaseline";
const Owned = "Polaris-ResourceItem__Owned";
const OwnedNoMedia = "Polaris-ResourceItem__OwnedNoMedia";
const Handle = "Polaris-ResourceItem__Handle";
const selectMode = "Polaris-ResourceItem--selectMode";
const selectable = "Polaris-ResourceItem--selectable";
const Media = "Polaris-ResourceItem__Media";
const Content$2 = "Polaris-ResourceItem__Content";
const Disclosure = "Polaris-ResourceItem__Disclosure";
const ListItem = "Polaris-ResourceItem__ListItem";
var styles$p = {
  CheckboxWrapper,
  ResourceItem,
  persistActions,
  Actions: Actions$1,
  ItemWrapper: ItemWrapper$1,
  focusedInner,
  focused: focused$2,
  selected: selected$1,
  Link: Link$1,
  Button: Button$1,
  Container: Container$1,
  alignmentLeading,
  alignmentTrailing,
  alignmentCenter,
  alignmentFill,
  alignmentBaseline,
  Owned,
  OwnedNoMedia,
  Handle,
  selectMode,
  selectable,
  Media,
  Content: Content$2,
  Disclosure,
  ListItem
};
var ResourceItem_vue_vue_type_style_index_0_lang = "";
const _hoisted_1$g = ["dataHref"];
const _hoisted_2$8 = ["data-href"];
const _hoisted_3$6 = ["aria-label", "aria-controls", "aria-expanded", "tabIndex"];
const _hoisted_4$3 = ["id"];
const _sfc_main$B = /* @__PURE__ */ defineComponent({
  props: {
    accessibilityLabel: null,
    name: null,
    ariaControls: null,
    ariaExpanded: { type: Boolean },
    id: null,
    persistActions: { type: Boolean, default: false },
    shortcutActions: null,
    sortOrder: null,
    url: null,
    external: { type: Boolean },
    verticalAlignment: null,
    dataHref: null
  },
  emits: ["click"],
  setup(__props, { emit: emits }) {
    const props = __props;
    const slots = useSlots();
    const i18n = UseI18n();
    const getUniqueCheckboxID = globalIdGeneratorFactory("ResourceListItemCheckbox");
    const getUniqueOverlayID = globalIdGeneratorFactory("ResourceListItemOverlay");
    const {
      selectedItems,
      selectable: selectable2,
      selectMode: selectMode2,
      loading: loading2,
      resourceName,
      onSelectionChange
    } = inject("ResourceListContext", {});
    const actionsMenuVisible = ref(false);
    const focused2 = ref(false);
    const focusedInner2 = ref(false);
    const selected2 = ref(isSelected(props.id, selectedItems == null ? void 0 : selectedItems.value));
    const checkboxId = getUniqueCheckboxID();
    const overlayId = getUniqueOverlayID();
    const node = ref(null);
    const buttonOverlay = ref(null);
    const isSelectable = computed(() => selectable2 == null ? void 0 : selectable2.value);
    const className = computed(() => classNames(styles$p.ResourceItem, focused2.value && styles$p.focused, isSelectable.value && styles$p.selectable, selected2.value && styles$p.selected, (selectMode2 == null ? void 0 : selectMode2.value) && styles$p.selectMode, props.persistActions && styles$p.persistActions, focusedInner2.value && styles$p.focusedInner));
    const listItemClassName = computed(() => classNames(styles$p.ListItem, focused2.value && !focusedInner2.value && styles$p.focused));
    const ownedClassName = computed(() => classNames(styles$p.Owned, !hasSlot(slots.media) && styles$p.OwnedNoMedia));
    const disclosureAccessibilityLabel = computed(() => props.name ? i18n.translate("Polaris.ResourceList.Item.actionsDropdownLabel", {
      accessibilityLabel: props.name
    }) : i18n.translate("Polaris.ResourceList.Item.actionsDropdown"));
    const checkboxAccessibilityLabel = computed(() => {
      return props.name || props.accessibilityLabel || i18n.translate("Polaris.Common.checkbox");
    });
    const containerClassName = computed(() => classNames(styles$p.Container, props.verticalAlignment && styles$p[variationName("alignment", props.verticalAlignment)]));
    const tabIndex = computed(() => loading2 ? -1 : 0);
    const ariaLabel = computed(() => {
      return props.accessibilityLabel || i18n.translate("Polaris.ResourceList.Item.viewItem", {
        itemName: props.name || resourceName && resourceName.singular || ""
      });
    });
    watch(() => selectedItems == null ? void 0 : selectedItems.value, (newVal, oldVal) => {
      if (newVal !== oldVal) {
        selected2.value = isSelected(props.id, newVal);
      }
    });
    const handleFocus = (event) => {
      if (event.target === buttonOverlay.value || node.value && event.target === node.value.querySelector(`#${overlayId}`)) {
        focused2.value = true;
        focusedInner2.value = false;
      } else if (node.value && node.value.contains(event.target)) {
        focused2.value = true;
        focusedInner2.value = true;
      }
    };
    const handleBlur = (event) => {
      const { relatedTarget } = event;
      if (node.value && relatedTarget instanceof Element && node.value.contains(relatedTarget)) {
        return;
      }
      focused2.value = false;
      focusedInner2.value = false;
    };
    const handleMouseOut = () => {
      if (focused2.value) {
        focused2.value = false;
        focusedInner2.value = false;
      }
    };
    const handleLargerSelectionArea = (event) => {
      event.stopPropagation();
      const e = event;
      handleSelection(!selected2.value, e.shiftKey);
    };
    const handleSelection = (value2, shiftKey) => {
      const {
        id,
        sortOrder
      } = props;
      if (!id || !onSelectionChange) {
        return;
      }
      focused2.value = value2;
      focusedInner2.value = value2;
      onSelectionChange(value2, id, sortOrder, shiftKey);
    };
    const handleClick = (event) => {
      event.stopPropagation();
      const { id, url } = props;
      const { ctrlKey, metaKey } = event;
      const anchor = node.value && node.value.querySelector("a");
      if (selectMode2 == null ? void 0 : selectMode2.value) {
        handleLargerSelectionArea(event);
        return;
      }
      if (anchor === event.target) {
        return;
      }
      emits("click", id);
      if (url && (ctrlKey || metaKey)) {
        window.open(url, "_blank");
        return;
      }
      if (url && anchor) {
        anchor.click();
      }
    };
    const handleKeyUp = (event) => {
      const { key } = event;
      if (key === "Enter" && props.url && !(selectMode2 == null ? void 0 : selectMode2.value)) {
        emits("click", props.id);
      }
    };
    const handleActionsClick = () => {
      actionsMenuVisible.value = !actionsMenuVisible.value;
    };
    const handleCloseRequest = () => {
      actionsMenuVisible.value = false;
    };
    const stopPropagation = (e) => {
      e.stopPropagation();
    };
    function isSelected(id, tmpSelectedItems) {
      return Boolean(tmpSelectedItems && (Array.isArray(tmpSelectedItems) && tmpSelectedItems.includes(id) || tmpSelectedItems === SELECT_ALL_ITEMS));
    }
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("li", {
        class: normalizeClass(unref(listItemClassName)),
        dataHref: __props.dataHref
      }, [
        createElementVNode("div", {
          class: normalizeClass(unref(styles$p).ItemWrapper)
        }, [
          createElementVNode("div", {
            ref_key: "node",
            ref: node,
            class: normalizeClass(unref(className)),
            onClick: handleClick,
            onFocus: handleFocus,
            onBlur: handleBlur,
            onKeyup: handleKeyUp,
            onMouseout: handleMouseOut,
            "data-href": __props.url
          }, [
            __props.url ? (openBlock(), createBlock(unref(_sfc_main$3m), {
              key: 0,
              "aria-describedby": __props.id,
              "aria-label": unref(ariaLabel),
              class: normalizeClass(unref(styles$p).Link),
              url: __props.url,
              external: __props.external,
              tabIndex: unref(tabIndex),
              id: unref(overlayId)
            }, null, 8, ["aria-describedby", "aria-label", "class", "url", "external", "tabIndex", "id"])) : (openBlock(), createElementBlock("button", {
              key: 1,
              class: normalizeClass(unref(styles$p).Button),
              "aria-label": unref(ariaLabel),
              "aria-controls": __props.ariaControls,
              "aria-expanded": __props.ariaExpanded,
              onClick: handleClick,
              tabIndex: unref(tabIndex),
              ref_key: "buttonOverlay",
              ref: buttonOverlay
            }, null, 10, _hoisted_3$6)),
            createElementVNode("div", {
              class: normalizeClass(unref(containerClassName)),
              id: __props.id
            }, [
              unref(hasSlot)(unref(slots).media) || unref(isSelectable) ? (openBlock(), createElementBlock("div", {
                key: 0,
                class: normalizeClass(unref(ownedClassName))
              }, [
                unref(isSelectable) ? (openBlock(), createElementBlock("div", {
                  key: 0,
                  class: normalizeClass(unref(styles$p).Handle),
                  onClick: handleLargerSelectionArea
                }, [
                  createElementVNode("div", {
                    class: normalizeClass(unref(styles$p).CheckboxWrapper),
                    onClick: stopPropagation
                  }, [
                    createElementVNode("div", { onChange: handleLargerSelectionArea }, [
                      createVNode(unref(_sfc_main$2s), {
                        id: unref(checkboxId),
                        label: unref(checkboxAccessibilityLabel),
                        labelHidden: "",
                        checked: selected2.value,
                        disabled: unref(loading2)
                      }, null, 8, ["id", "label", "checked", "disabled"])
                    ], 32)
                  ], 2)
                ], 2)) : createCommentVNode("", true),
                unref(hasSlot)(unref(slots).media) ? (openBlock(), createElementBlock("div", {
                  key: 1,
                  class: normalizeClass(unref(styles$p).Media)
                }, [
                  renderSlot(_ctx.$slots, "media")
                ], 2)) : createCommentVNode("", true)
              ], 2)) : createCommentVNode("", true),
              unref(hasSlot)(unref(slots).default) ? (openBlock(), createElementBlock("div", {
                key: 1,
                class: normalizeClass(unref(styles$p).Content)
              }, [
                renderSlot(_ctx.$slots, "default")
              ], 2)) : createCommentVNode("", true),
              __props.shortcutActions && !unref(loading2) ? (openBlock(), createElementBlock(Fragment, { key: 2 }, [
                __props.persistActions ? (openBlock(), createElementBlock("div", {
                  key: 0,
                  class: normalizeClass(unref(styles$p).Actions),
                  onClick: stopPropagation
                }, [
                  createVNode(unref(_sfc_main$2C), null, {
                    default: withCtx(() => [
                      (openBlock(true), createElementBlock(Fragment, null, renderList(__props.shortcutActions, (action, index) => {
                        return openBlock(), createBlock(unref(_sfc_main$2E), {
                          key: index,
                          action,
                          overrides: { plain: true }
                        }, null, 8, ["action"]);
                      }), 128))
                    ]),
                    _: 1
                  })
                ], 2)) : (openBlock(), createElementBlock("div", {
                  key: 1,
                  class: normalizeClass(unref(styles$p).Actions),
                  onClick: stopPropagation
                }, [
                  createVNode(unref(_sfc_main$2C), { segmented: "" }, {
                    default: withCtx(() => [
                      (openBlock(true), createElementBlock(Fragment, null, renderList(__props.shortcutActions, (action, index) => {
                        return openBlock(), createBlock(unref(_sfc_main$2E), {
                          key: index,
                          action,
                          overrides: { size: "slim" }
                        }, null, 8, ["action"]);
                      }), 128))
                    ]),
                    _: 1
                  })
                ], 2))
              ], 64)) : createCommentVNode("", true),
              __props.persistActions ? (openBlock(), createElementBlock("div", {
                key: 3,
                class: normalizeClass(unref(styles$p).Disclosure),
                onClick: stopPropagation
              }, [
                createVNode(unref(_sfc_main$2L), {
                  active: actionsMenuVisible.value,
                  onClose: handleCloseRequest
                }, {
                  activator: withCtx(() => [
                    createVNode(unref(_sfc_main$2F), {
                      accessibilityLabel: unref(disclosureAccessibilityLabel),
                      plain: "",
                      icon: unref(HorizontalDotsMinor),
                      onClick: handleActionsClick
                    }, null, 8, ["accessibilityLabel", "icon"])
                  ]),
                  content: withCtx(() => [
                    createVNode(unref(_sfc_main$3h), { items: __props.shortcutActions }, null, 8, ["items"])
                  ]),
                  _: 1
                }, 8, ["active"])
              ], 2)) : createCommentVNode("", true)
            ], 10, _hoisted_4$3)
          ], 42, _hoisted_2$8)
        ], 2)
      ], 10, _hoisted_1$g);
    };
  }
});
const FiltersWrapper = "Polaris-ResourceList__FiltersWrapper";
const ResourceList = "Polaris-ResourceList";
const HeaderOuterWrapper = "Polaris-ResourceList__HeaderOuterWrapper";
const HeaderWrapper = "Polaris-ResourceList__HeaderWrapper";
const HeaderContentWrapper = "Polaris-ResourceList__HeaderContentWrapper";
const SortWrapper = "Polaris-ResourceList__SortWrapper";
const AlternateToolWrapper = "Polaris-ResourceList__AlternateToolWrapper";
const HeaderTitleWrapper = "Polaris-ResourceList__HeaderTitleWrapper";
const BulkActionsWrapper = "Polaris-ResourceList__BulkActionsWrapper";
const CheckableButtonWrapper = "Polaris-ResourceList__CheckableButtonWrapper";
const SelectButtonWrapper = "Polaris-ResourceList__SelectButtonWrapper";
const EmptySearchResultWrapper = "Polaris-ResourceList__EmptySearchResultWrapper";
const ResourceListWrapper = "Polaris-ResourceList__ResourceListWrapper";
const ItemWrapper = "Polaris-ResourceList__ItemWrapper";
const SpinnerContainer = "Polaris-ResourceList__SpinnerContainer";
const LoadingOverlay = "Polaris-ResourceList__LoadingOverlay";
const DisabledPointerEvents = "Polaris-ResourceList__DisabledPointerEvents";
const disableTextSelection = "Polaris-ResourceList--disableTextSelection";
var styles$o = {
  FiltersWrapper,
  ResourceList,
  HeaderOuterWrapper,
  "HeaderWrapper-disabled": "Polaris-ResourceList__HeaderWrapper--disabled",
  "HeaderWrapper-overlay": "Polaris-ResourceList__HeaderWrapper--overlay",
  HeaderWrapper,
  "HeaderWrapper-isSticky": "Polaris-ResourceList__HeaderWrapper--isSticky",
  HeaderContentWrapper,
  "HeaderWrapper-inSelectMode": "Polaris-ResourceList__HeaderWrapper--inSelectMode",
  SortWrapper,
  AlternateToolWrapper,
  "HeaderWrapper-hasSelect": "Polaris-ResourceList__HeaderWrapper--hasSelect",
  "HeaderWrapper-hasAlternateTool": "Polaris-ResourceList__HeaderWrapper--hasAlternateTool",
  "HeaderWrapper-hasSort": "Polaris-ResourceList__HeaderWrapper--hasSort",
  HeaderTitleWrapper,
  BulkActionsWrapper,
  CheckableButtonWrapper,
  SelectButtonWrapper,
  EmptySearchResultWrapper,
  ResourceListWrapper,
  ItemWrapper,
  "ItemWrapper-isLoading": "Polaris-ResourceList__ItemWrapper--isLoading",
  SpinnerContainer,
  LoadingOverlay,
  DisabledPointerEvents,
  disableTextSelection
};
var ResourceList_vue_vue_type_style_index_0_lang = "";
const _hoisted_1$f = ["className"];
const _hoisted_2$7 = ["aria-busy"];
const _sfc_main$A = /* @__PURE__ */ defineComponent({
  props: {
    resourceName: null,
    promotedBulkActions: null,
    bulkActions: null,
    selectedItems: { default: [] },
    isFiltered: { type: Boolean },
    selectable: { type: Boolean },
    hasMoreItems: { type: Boolean },
    loading: { type: Boolean },
    showHeader: { type: Boolean, default: true },
    totalItemsCount: null,
    sortValue: null,
    sortOptions: null,
    idForItem: null,
    resolveItemId: null
  },
  emits: ["sort-change", "selection-change"],
  setup(__props, { emit: emits }) {
    const props = __props;
    const SMALL_SPINNER_HEIGHT = 28;
    const LARGE_SPINNER_HEIGHT = 45;
    function getAllItemsOnPage(items2, idForItem) {
      return items2.map((item, index) => {
        return idForItem(item, index);
      });
    }
    const isBreakpointsXS = () => {
      var _a;
      return typeof window === "undefined" ? false : window.innerWidth < parseFloat((_a = toPx(tokens.breakpoints["breakpoints-sm"])) != null ? _a : "");
    };
    const defaultIdForItem = (item, index) => {
      var _a, _b;
      if ((_a = item.props) == null ? void 0 : _a.id) {
        return (_b = item.props) == null ? void 0 : _b.id;
      }
      return Object.prototype.hasOwnProperty.call(item, "id") ? item.id : index.toString();
    };
    const i18n = UseI18n();
    const slots = useSlots();
    const selectMode2 = ref(Boolean(props.selectedItems && props.selectedItems.length > 0));
    const loadingPosition = ref(0);
    const lastSelected = ref();
    const smallScreen = ref(isBreakpointsXS());
    const checkableButtons = ref(/* @__PURE__ */ new Map());
    const isSticky = ref(false);
    const generateItemId = (item, index) => {
      if (props.idForItem) {
        return props.idForItem(item, index);
      }
      return defaultIdForItem(item, index);
    };
    const items = computed(() => {
      let tmpItems = [];
      if (slots.default) {
        const groups = slots.default().map((group) => {
          return extractElement(group);
        });
        tmpItems = groups.flat();
      }
      return tmpItems;
    });
    const defaultResourceName = {
      singular: i18n.translate("Polaris.ResourceList.defaultItemSingular"),
      plural: i18n.translate("Polaris.ResourceList.defaultItemPlural")
    };
    const listRef = ref(null);
    ref(null);
    const isSelectable = computed(() => {
      return Boolean(props.promotedBulkActions && props.promotedBulkActions.length > 0 || props.bulkActions && props.bulkActions.length > 0 || props.selectable);
    });
    const resourceName = computed(() => props.resourceName ? props.resourceName : defaultResourceName);
    const className = computed(() => classNames(styles$o.ItemWrapper, props.loading && styles$o["ItemWrapper-isLoading"]));
    const resourceListClassName = computed(() => classNames(styles$o.ResourceList, selectMode2.value && styles$o.disableTextSelection));
    const itemsExist = computed(() => items.value.length > 0);
    const needsHeader = computed(() => {
      return isSelectable.value || props.sortOptions && props.sortOptions.length > 0 || hasSlot(slots.alternateTool);
    });
    const showEmptyState = computed(() => hasSlot(slots.emptyState) && !itemsExist.value && !props.loading);
    const showEmptySearchState = computed(() => !showEmptyState.value && hasSlot(slots.filterControl) && !itemsExist.value && !props.loading);
    const showSortingSelect = computed(() => props.sortOptions && props.sortOptions.length > 0 && !hasSlot(slots.alternateTool));
    const showHeaderMarkup = computed(() => {
      return !showEmptyState.value && props.showHeader && !showEmptySearchState.value && (props.showHeader || needsHeader.value) && listRef.value;
    });
    const handleStickyChange = (value2) => {
      isSticky.value = value2;
    };
    const headerClassName = computed(() => {
      return classNames(styles$o.HeaderWrapper, props.sortOptions && props.sortOptions.length > 0 && !hasSlot(slots.alternateTool) && styles$o["HeaderWrapper-hasSort"], hasSlot(slots.alternateTool) && styles$o["HeaderWrapper-hasAlternateTool"], isSelectable.value && styles$o["HeaderWrapper-hasSelect"], props.loading && styles$o["HeaderWrapper-disabled"], isSelectable.value && selectMode2.value && styles$o["HeaderWrapper-inSelectMode"], isSticky.value && styles$o["HeaderWrapper-isSticky"]);
    });
    const headerTitle = computed(() => {
      const itemsCount = items.value.length;
      const resource = !props.loading && (!props.totalItemsCount && itemsCount === 1 || props.totalItemsCount === 1) ? resourceName.value.singular : resourceName.value.plural;
      if (props.loading) {
        return i18n.translate("Polaris.ResourceList.loading", { resource });
      } else if (props.totalItemsCount) {
        return i18n.translate("Polaris.ResourceList.showingTotalCount", {
          itemsCount,
          totalItemsCount: props.totalItemsCount,
          resource
        });
      } else {
        return i18n.translate("Polaris.ResourceList.showing", {
          itemsCount,
          resource
        });
      }
    });
    const bulkActionsLabel = computed(() => {
      var _a;
      const selectedItemsCount = props.selectedItems === SELECT_ALL_ITEMS || Array.isArray(props.selectedItems) && props.selectedItems.length === items.value.length ? `${items.value.length}+` : (_a = props.selectedItems) == null ? void 0 : _a.length;
      return i18n.translate("Polaris.ResourceList.selected", {
        selectedItemsCount: `${selectedItemsCount}`
      });
    });
    const bulkActionsAccessibilityLabel = computed(() => {
      var _a;
      const selectedItemsCount = (_a = props.selectedItems) == null ? void 0 : _a.length;
      const totalItemsCount = items.value.length;
      const allSelected = selectedItemsCount === totalItemsCount;
      if (totalItemsCount === 1 && allSelected) {
        return i18n.translate("Polaris.ResourceList.a11yCheckboxDeselectAllSingle", {
          resourceNameSingular: resourceName.value.singular
        });
      } else if (totalItemsCount === 1) {
        return i18n.translate("Polaris.ResourceList.a11yCheckboxSelectAllSingle", {
          resourceNameSingular: resourceName.value.singular
        });
      } else if (allSelected) {
        return i18n.translate("Polaris.ResourceList.a11yCheckboxDeselectAllMultiple", {
          itemsLength: items.value.length,
          resourceNamePlural: resourceName.value.plural
        });
      } else {
        return i18n.translate("Polaris.ResourceList.a11yCheckboxSelectAllMultiple", {
          itemsLength: items.value.length,
          resourceNamePlural: resourceName.value.plural
        });
      }
    });
    const paginatedSelectAllText = computed(() => {
      if (!isSelectable.value || !props.hasMoreItems) {
        return;
      }
      if (props.selectedItems === SELECT_ALL_ITEMS || Array.isArray(props.selectedItems) && props.selectedItems.length === items.value.length) {
        return i18n.translate(props.isFiltered ? "Polaris.ResourceList.allFilteredItemsSelected" : "Polaris.ResourceList.allItemsSelected", {
          itemsLength: items.value.length,
          resourceNamePlural: resourceName.value.plural
        });
      }
      return "";
    });
    const paginatedSelectAllAction = computed(() => {
      if (!isSelectable.value || !props.hasMoreItems) {
        return;
      }
      const actionText = props.selectedItems === SELECT_ALL_ITEMS || Array.isArray(props.selectedItems) && props.selectedItems.length === items.value.length ? i18n.translate("Polaris.Common.undo") : i18n.translate(props.isFiltered ? "Polaris.ResourceList.selectAllFilteredItems" : "Polaris.ResourceList.selectAllItems", {
        itemsLength: items.value.length,
        resourceNamePlural: resourceName.value.plural
      });
      return {
        content: actionText,
        onAction: handleSelectAllItemsInStore
      };
    });
    const emptySearchResultText = computed(() => ({
      title: i18n.translate("Polaris.ResourceList.emptySearchResultTitle", {
        resourceNamePlural: resourceName.value.plural
      }),
      description: i18n.translate("Polaris.ResourceList.emptySearchResultDescription")
    }));
    const defaultTopPadding = 8;
    const topPadding = computed(() => loadingPosition.value > 0 ? loadingPosition.value : defaultTopPadding);
    const spinnerStyle = computed(() => ({ paddingTop: `${topPadding.value}px` }));
    const spinnerSize = computed(() => items.value.length < 2 ? "small" : "large");
    onMounted(() => {
      if (props.loading) {
        setLoadingPosition();
      }
    });
    watch(() => props.loading, (newLoading) => {
      if (newLoading) {
        setLoadingPosition();
      }
    });
    watch(() => [props.selectedItems, selectMode2.value], ([newSelectedItems, newSelectMode], [oldSelectedItems, oldSelectMode]) => {
      if (newSelectedItems !== oldSelectedItems) {
        if (newSelectedItems && newSelectedItems.length > 0 && !newSelectMode) {
          selectMode2.value = true;
        }
        if ((!newSelectedItems || newSelectedItems.length === 0) && !isBreakpointsXS()) {
          selectMode2.value = false;
        }
      }
    });
    const handleSelectAllItemsInStore = () => {
      const newlySelectedItems = props.selectedItems === SELECT_ALL_ITEMS || Array.isArray(props.selectedItems) && props.selectedItems.length === items.value.length ? [] : getAllItemsOnPage(items.value, generateItemId);
      emits("selection-change", newlySelectedItems);
    };
    const bulkSelectState = () => {
      let selectState = "indeterminate";
      if (!props.selectedItems || Array.isArray(props.selectedItems) && props.selectedItems.length === 0) {
        selectState = false;
      } else if (props.selectedItems === SELECT_ALL_ITEMS || Array.isArray(props.selectedItems) && props.selectedItems.length === items.value.length) {
        selectState = true;
      }
      return selectState;
    };
    const handleSelectMode = (tmpSelectMode) => {
      selectMode2.value = tmpSelectMode;
      if (!tmpSelectMode) {
        emits("selection-change", []);
      }
    };
    const handleResize = debounce(() => {
      const newSmallScreen = isBreakpointsXS();
      if (props.selectedItems && props.selectedItems.length === 0 && selectMode2 && !newSmallScreen) {
        handleSelectMode(false);
      }
      if (smallScreen.value !== newSmallScreen) {
        smallScreen.value = newSmallScreen;
      }
    }, 50, { leading: true, trailing: true, maxWait: 50 });
    const setLoadingPosition = () => {
      if (listRef.value != null) {
        if (typeof window === "undefined") {
          return;
        }
        const overlay2 = listRef.value.getBoundingClientRect();
        const viewportHeight = Math.max(document.documentElement ? document.documentElement.clientHeight : 0, window.innerHeight || 0);
        const overflow = viewportHeight - overlay2.height;
        const spinnerHeight = items.value.length === 1 ? SMALL_SPINNER_HEIGHT : LARGE_SPINNER_HEIGHT;
        const spinnerPosition = overflow > 0 ? (overlay2.height - spinnerHeight) / 2 : (viewportHeight - overlay2.top - spinnerHeight) / 2;
        loadingPosition.value = spinnerPosition;
      }
    };
    const handleMultiSelectionChange = (lastSelectedChange, currentSelected, resolveItemId) => {
      const min = Math.min(lastSelectedChange, currentSelected);
      const max = Math.max(lastSelectedChange, currentSelected);
      return items.value.slice(min, max + 1).map(resolveItemId);
    };
    const handleCheckableButtonRegistration = (key, button) => {
      if (!checkableButtons.value.get(key)) {
        checkableButtons.value = new Map(checkableButtons.value).set(key, button);
      }
    };
    const handleSelectionChange = (selected22, id, sortOrder, shiftKey) => {
      if (props.selectedItems === null) {
        return;
      }
      let newlySelectedItems = props.selectedItems === SELECT_ALL_ITEMS || Array.isArray(props.selectedItems) && props.selectedItems.length === items.value.length ? getAllItemsOnPage(items.value, generateItemId) : [...props.selectedItems];
      if (sortOrder !== void 0) {
        lastSelected.value = sortOrder;
      }
      const lastSelectedFromState = lastSelected.value;
      let selectedIds = [id];
      if (shiftKey && lastSelectedFromState != null && sortOrder !== void 0 && props.resolveItemId) {
        selectedIds = handleMultiSelectionChange(lastSelectedFromState, sortOrder, props.resolveItemId);
      }
      newlySelectedItems = [.../* @__PURE__ */ new Set([...newlySelectedItems, ...selectedIds])];
      if (!selected22) {
        for (const selectedId of selectedIds) {
          newlySelectedItems.splice(newlySelectedItems.indexOf(selectedId), 1);
        }
      }
      if (newlySelectedItems.length === 0 && !isBreakpointsXS()) {
        handleSelectMode(false);
      } else if (newlySelectedItems.length > 0) {
        handleSelectMode(true);
      }
      emits("selection-change", newlySelectedItems);
    };
    const onSortChange = (selected22) => {
      emits("sort-change", selected22);
    };
    const handleToggleAll = () => {
      let newlySelectedItems;
      if (Array.isArray(props.selectedItems) && props.selectedItems.length === items.value.length || props.selectedItems === SELECT_ALL_ITEMS) {
        newlySelectedItems = [];
      } else {
        newlySelectedItems = items.value.map((item, index) => {
          const ids = generateItemId && generateItemId(item, index);
          return ids;
        });
      }
      if (newlySelectedItems.length === 0 && !isBreakpointsXS()) {
        handleSelectMode(false);
      } else if (newlySelectedItems.length > 0) {
        handleSelectMode(true);
      }
      let checkbox;
      if (isBreakpointsXS()) {
        checkbox = checkableButtons.value.get("bulkSm");
      } else if (newlySelectedItems.length === 0) {
        checkbox = checkableButtons.value.get("plain");
      } else {
        checkbox = checkableButtons.value.get("bulkLg");
      }
      emits("selection-change", newlySelectedItems);
      setTimeout(() => {
        checkbox && checkbox.focus();
      }, 0);
    };
    const selected2 = computed(() => {
      return Object.keys(props.selectedItems).map((key) => props.selectedItems[key]);
    });
    provide("ResourceListContext", {
      selectable: isSelectable,
      selectedItems: selected2,
      selectMode: selectMode2,
      resourceName: props.resourceName,
      loading: props.loading,
      onSelectionChange: handleSelectionChange,
      registerCheckableButtons: handleCheckableButtonRegistration
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(unref(styles$o).ResourceListWrapper)
      }, [
        unref(hasSlot)(unref(slots).filterControl) ? (openBlock(), createElementBlock("div", {
          key: 0,
          class: normalizeClass(unref(styles$o).FiltersWrapper)
        }, [
          renderSlot(_ctx.$slots, "filterControl")
        ], 2)) : createCommentVNode("", true),
        unref(showHeaderMarkup) ? (openBlock(), createElementBlock("div", {
          key: 1,
          class: normalizeClass(unref(styles$o).HeaderOuterWrapper)
        }, [
          createVNode(unref(_sfc_main$p), {
            "bounding-element": listRef.value,
            onStickyChange: handleStickyChange
          }, {
            default: withCtx(() => [
              createElementVNode("div", {
                class: normalizeClass(unref(headerClassName))
              }, [
                createVNode(unref(_sfc_main$33), {
                  event: "resize",
                  handler: unref(handleResize)
                }, null, 8, ["handler"]),
                __props.loading ? (openBlock(), createElementBlock("div", {
                  key: 0,
                  class: normalizeClass(unref(styles$o)["HeaderWrapper-overlay"])
                }, null, 2)) : createCommentVNode("", true),
                createElementVNode("div", {
                  class: normalizeClass(unref(styles$o).HeaderContentWrapper)
                }, [
                  createElementVNode("div", {
                    class: normalizeClass(unref(styles$o).HeaderTitleWrapper)
                  }, toDisplayString(unref(headerTitle)), 3),
                  unref(isSelectable) ? (openBlock(), createElementBlock("div", {
                    key: 0,
                    class: normalizeClass(unref(styles$o).CheckableButtonWrapper)
                  }, [
                    createVNode(unref(_sfc_main$2v), {
                      plain: "",
                      accessibilityLabel: unref(bulkActionsAccessibilityLabel),
                      label: unref(headerTitle),
                      disabled: __props.loading,
                      onToggleAll: handleToggleAll
                    }, null, 8, ["accessibilityLabel", "label", "disabled"])
                  ], 2)) : createCommentVNode("", true),
                  unref(hasSlot)(unref(slots).alternateTool) && !unref(showSortingSelect) ? (openBlock(), createElementBlock("div", {
                    key: 1,
                    class: normalizeClass(unref(styles$o).AlternateToolWrapper)
                  }, [
                    renderSlot(_ctx.$slots, "alternateTool")
                  ], 2)) : createCommentVNode("", true),
                  unref(showSortingSelect) && __props.sortOptions ? (openBlock(), createElementBlock("div", {
                    key: 2,
                    className: unref(styles$o).SortWrapper
                  }, [
                    createVNode(unref(_sfc_main$y), {
                      modelValue: __props.sortValue,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => isRef(sortValue) ? sortValue.value = $event : null),
                      labelInline: !smallScreen.value,
                      labelHidden: smallScreen.value,
                      options: __props.sortOptions,
                      disabled: selectMode2.value,
                      onChange: onSortChange
                    }, {
                      label: withCtx(() => [
                        createTextVNode(toDisplayString(unref(i18n).translate("Polaris.ResourceList.sortingLabel")), 1)
                      ]),
                      _: 1
                    }, 8, ["modelValue", "labelInline", "labelHidden", "options", "disabled"])
                  ], 8, _hoisted_1$f)) : createCommentVNode("", true),
                  unref(isSelectable) ? (openBlock(), createElementBlock("div", {
                    key: 3,
                    class: normalizeClass(unref(styles$o).SelectButtonWrapper)
                  }, [
                    createVNode(unref(_sfc_main$2F), {
                      disabled: selectMode2.value,
                      icon: unref(EnableSelectionMinor),
                      onClick: _cache[1] || (_cache[1] = () => handleSelectMode(true))
                    }, {
                      default: withCtx(() => [
                        createTextVNode(toDisplayString(unref(i18n).translate("Polaris.ResourceList.selectButtonText")), 1)
                      ]),
                      _: 1
                    }, 8, ["disabled", "icon"])
                  ], 2)) : createCommentVNode("", true)
                ], 2),
                unref(isSelectable) ? (openBlock(), createElementBlock("div", {
                  key: 1,
                  class: normalizeClass(unref(styles$o).BulkActionsWrapper)
                }, [
                  createVNode(unref(_sfc_main$2R), {
                    label: unref(bulkActionsLabel),
                    accessibilityLabel: unref(bulkActionsAccessibilityLabel),
                    selected: bulkSelectState(),
                    "select-mode": selectMode2.value,
                    promotedActions: __props.promotedBulkActions,
                    paginatedSelectAllAction: unref(paginatedSelectAllAction),
                    paginatedSelectAllText: unref(paginatedSelectAllText),
                    actions: __props.bulkActions,
                    disabled: __props.loading,
                    smallScreen: smallScreen.value,
                    onSelectModeToggle: handleSelectMode,
                    onToggleAll: handleToggleAll
                  }, null, 8, ["label", "accessibilityLabel", "selected", "select-mode", "promotedActions", "paginatedSelectAllAction", "paginatedSelectAllText", "actions", "disabled", "smallScreen"])
                ], 2)) : createCommentVNode("", true)
              ], 2)
            ]),
            _: 3
          }, 8, ["bounding-element"])
        ], 2)) : createCommentVNode("", true),
        unref(itemsExist) ? (openBlock(), createElementBlock("ul", {
          key: 2,
          class: normalizeClass(unref(resourceListClassName)),
          ref_key: "listRef",
          ref: listRef,
          "aria-live": "polite",
          "aria-busy": __props.loading
        }, [
          __props.loading ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
            createElementVNode("li", {
              class: normalizeClass(unref(styles$o).SpinnerContainer),
              style: normalizeStyle(unref(spinnerStyle))
            }, [
              createVNode(unref(_sfc_main$2H), {
                size: unref(spinnerSize),
                accessibilityLabel: "Items are loading"
              }, null, 8, ["size"])
            ], 6),
            createElementVNode("li", {
              class: normalizeClass(unref(styles$o).LoadingOverlay)
            }, null, 2)
          ], 64)) : createCommentVNode("", true),
          renderSlot(_ctx.$slots, "default")
        ], 10, _hoisted_2$7)) : createCommentVNode("", true),
        unref(showEmptySearchState) && unref(hasSlot)(unref(slots).emptySearchState) ? renderSlot(_ctx.$slots, "emptySearchState", { key: 3 }) : unref(showEmptySearchState) ? (openBlock(), createElementBlock("div", {
          key: 4,
          class: normalizeClass(unref(styles$o).EmptySearchResultWrapper)
        }, [
          createVNode(unref(_sfc_main$21), mergeProps(unref(emptySearchResultText), { "with-illustration": "" }), null, 16)
        ], 2)) : createCommentVNode("", true),
        unref(showEmptyState) ? renderSlot(_ctx.$slots, "emptyState", { key: 5 }) : createCommentVNode("", true),
        __props.loading && !unref(itemsExist) ? (openBlock(), createElementBlock("div", {
          key: 6,
          class: normalizeClass(unref(className)),
          tabindex: "-1"
        }, [
          __props.loading ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
            createElementVNode("li", {
              class: normalizeClass(unref(styles$o).SpinnerContainer),
              style: normalizeStyle(unref(spinnerStyle))
            }, [
              createVNode(unref(_sfc_main$2H), {
                size: unref(spinnerSize),
                accessibilityLabel: "Items are loading"
              }, null, 8, ["size"])
            ], 6),
            createElementVNode("li", {
              class: normalizeClass(unref(styles$o).LoadingOverlay)
            }, null, 2)
          ], 64)) : createCommentVNode("", true)
        ], 2)) : createCommentVNode("", true)
      ], 2);
    };
  }
});
var ScrollLock_vue_vue_type_style_index_0_lang = "";
const __default__$2 = {
  inheritAttrs: false,
  render() {
    return null;
  }
};
const _sfc_main$z = /* @__PURE__ */ defineComponent(__spreadProps(__spreadValues({}, __default__$2), {
  setup(__props) {
    const scrollLockManager = inject("scrollLockManager");
    onMounted(() => {
      scrollLockManager.registerScrollLock();
    });
    onBeforeUnmount(() => {
      scrollLockManager.unregisterScrollLock();
    });
    return () => {
    };
  }
}));
const Select = "Polaris-Select";
const disabled$1 = "Polaris-Select--disabled";
const Content$1 = "Polaris-Select__Content";
const InlineLabel = "Polaris-Select__InlineLabel";
const Icon$1 = "Polaris-Select__Icon";
const Backdrop$1 = "Polaris-Select__Backdrop";
const SelectedOption = "Polaris-Select__SelectedOption";
const Prefix = "Polaris-Select__Prefix";
const Input$1 = "Polaris-Select__Input";
const error = "Polaris-Select--error";
const hover = "Polaris-Select--hover";
var styles$n = {
  Select,
  disabled: disabled$1,
  Content: Content$1,
  InlineLabel,
  Icon: Icon$1,
  Backdrop: Backdrop$1,
  SelectedOption,
  Prefix,
  Input: Input$1,
  error,
  hover
};
var Select_vue_vue_type_style_index_0_lang = "";
const _hoisted_1$e = ["id", "name", "disabled", "value", "aria-invalid", "aria-describedby", "aria-required"];
const _hoisted_2$6 = ["label"];
const _hoisted_3$5 = ["value", "disabled"];
const _hoisted_4$2 = ["value", "disabled"];
const _hoisted_5$1 = ["aria-disabled"];
const _sfc_main$y = /* @__PURE__ */ defineComponent({
  props: {
    options: null,
    label: null,
    labelAction: null,
    labelHidden: { type: Boolean },
    labelInline: { type: Boolean },
    disabled: { type: Boolean },
    helpText: null,
    placeholder: null,
    id: null,
    name: null,
    value: null,
    error: null,
    requiredIndicator: { type: Boolean },
    modelValue: null
  },
  emits: ["focus", "blur", "change", "update:modelValue"],
  setup(__props, { emit: emits }) {
    const props = __props;
    const slots = useSlots();
    const { useUniqueId } = UseUniqueId();
    const describedBy = [];
    const selectId = computed(() => useUniqueId("Select", props.id));
    const selectLabelHidden = computed(() => props.labelInline ? true : props.labelHidden);
    const className = computed(() => classNames(styles$n.Select, props.error && styles$n.error, props.disabled && styles$n.disabled));
    const flattenOptions = computed(() => {
      let flatOptions = [];
      normalizedOptions.value.forEach((optionOrGroup) => {
        if (isGroup(optionOrGroup)) {
          const optionGroup = optionOrGroup;
          flatOptions = flatOptions.concat(optionGroup.options);
        } else {
          flatOptions.push(optionOrGroup);
        }
      });
      return flatOptions;
    });
    const selectedOption = computed(() => {
      let selected2 = flattenOptions.value.find((option) => props.modelValue === option.value);
      if (selected2 === void 0) {
        selected2 = flattenOptions.value.find((option) => !option.hidden);
      }
      return selected2 || { value: "", label: "" };
    });
    const optionsMarkup = computed(() => {
      return normalizedOptions.value.map((opt) => normalizeOption(opt));
    });
    const normalizedOptions = computed(() => {
      let nOptions = props.options.map(normalizeOption);
      if (props.placeholder) {
        nOptions.unshift({
          label: props.placeholder,
          value: "",
          disabled: true
        });
      }
      return nOptions;
    });
    if (slots["help-text"]) {
      describedBy.push(helpTextID$1(props.id || ""));
    }
    if (props.error) {
      describedBy.push(`${props.id}Error`);
    }
    const isString = (option) => {
      return typeof option === "string";
    };
    const isGroup = (option) => {
      return typeof option === "object" && "options" in option && option.options != null;
    };
    const handleChange = (event) => {
      emits("update:modelValue", event.target.value);
      emits("change", event.target.value);
    };
    const getOptionTitle = (option) => {
      if (isGroup(option)) {
        return option.title;
      }
      return option.label;
    };
    const getHideableStrictOption = (option) => {
      if (isGroup(option)) {
        return {
          label: option.title,
          value: "",
          disabled: true,
          hidden: true
        };
      }
      return option;
    };
    const getGroupOptions = (option) => {
      if (isGroup(option)) {
        return option.options;
      }
      return [];
    };
    function normalizeStringOption(option) {
      return {
        label: option,
        value: option
      };
    }
    function normalizeOption(option) {
      if (isString(option)) {
        return normalizeStringOption(option);
      }
      if (isGroup(option)) {
        const { title, options } = option;
        return {
          title,
          options: options.map((opt) => isString(opt) ? normalizeStringOption(opt) : opt)
        };
      }
      return option;
    }
    return (_ctx, _cache) => {
      return openBlock(), createBlock(unref(_sfc_main$1o), {
        id: unref(selectId),
        error: __props.error,
        action: __props.labelAction,
        "label-hidden": unref(selectLabelHidden),
        "required-indicator": __props.requiredIndicator,
        label: __props.label,
        "help-text": __props.helpText
      }, createSlots({
        default: withCtx(() => [
          createElementVNode("div", {
            class: normalizeClass(unref(className))
          }, [
            createElementVNode("select", {
              id: unref(selectId),
              name: __props.name,
              class: normalizeClass(unref(styles$n).Input),
              disabled: __props.disabled,
              value: __props.modelValue,
              "aria-invalid": !!__props.error,
              "aria-describedby": describedBy.join(" ") || void 0,
              "aria-required": __props.requiredIndicator,
              onFocus: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("focus")),
              onBlur: _cache[1] || (_cache[1] = ($event) => _ctx.$emit("blur")),
              onChange: handleChange
            }, [
              (openBlock(true), createElementBlock(Fragment, null, renderList(unref(optionsMarkup), (option) => {
                return openBlock(), createElementBlock(Fragment, null, [
                  isGroup(option) ? (openBlock(), createElementBlock("optgroup", {
                    label: getOptionTitle(option),
                    key: getOptionTitle(option)
                  }, [
                    (openBlock(true), createElementBlock(Fragment, null, renderList(getGroupOptions(option), (opt) => {
                      return openBlock(), createElementBlock("option", {
                        key: opt.value,
                        value: opt.value,
                        disabled: opt.disabled
                      }, toDisplayString(opt.label), 9, _hoisted_3$5);
                    }), 128))
                  ], 8, _hoisted_2$6)) : (openBlock(), createElementBlock("option", {
                    key: getHideableStrictOption(option).value,
                    value: getHideableStrictOption(option).value,
                    disabled: getHideableStrictOption(option).disabled
                  }, toDisplayString(getHideableStrictOption(option).label), 9, _hoisted_4$2))
                ], 64);
              }), 256))
            ], 42, _hoisted_1$e),
            createElementVNode("div", {
              class: normalizeClass(unref(styles$n).Content),
              "aria-hidden": "",
              "aria-disabled": __props.disabled
            }, [
              __props.labelInline ? (openBlock(), createBlock(unref(_sfc_main$2V), {
                key: 0,
                "padding-inline-end": "1"
              }, {
                default: withCtx(() => [
                  createVNode(unref(Text), {
                    as: "span",
                    variant: "bodyMd",
                    color: "subdued",
                    truncate: ""
                  }, {
                    default: withCtx(() => [
                      unref(slots).label ? renderSlot(_ctx.$slots, "label", { key: 0 }) : __props.label ? (openBlock(), createElementBlock(Fragment, { key: 1 }, [
                        createTextVNode(toDisplayString(__props.label), 1)
                      ], 64)) : createCommentVNode("", true)
                    ]),
                    _: 3
                  })
                ]),
                _: 3
              })) : createCommentVNode("", true),
              _ctx.$slots[`prefix-${unref(selectedOption).id}`] ? (openBlock(), createElementBlock("div", {
                key: 1,
                class: normalizeClass(unref(styles$n).Prefix)
              }, [
                renderSlot(_ctx.$slots, `prefix-${unref(selectedOption).id}`)
              ], 2)) : createCommentVNode("", true),
              createElementVNode("span", {
                class: normalizeClass(unref(styles$n).SelectedOption)
              }, [
                _ctx.$slots[`label-${unref(selectedOption).id}`] ? renderSlot(_ctx.$slots, `label-${unref(selectedOption).id}`, { key: 0 }) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
                  createTextVNode(toDisplayString(unref(selectedOption).label), 1)
                ], 64))
              ], 2),
              createElementVNode("span", {
                class: normalizeClass(unref(styles$n).Icon)
              }, [
                createVNode(unref(_sfc_main$2K), { source: unref(SelectMinor) }, null, 8, ["source"])
              ], 2)
            ], 10, _hoisted_5$1),
            createElementVNode("div", {
              class: normalizeClass(unref(styles$n).Backdrop)
            }, null, 2)
          ], 2)
        ]),
        _: 2
      }, [
        !__props.labelInline && unref(slots).label ? {
          name: "label",
          fn: withCtx(() => [
            renderSlot(_ctx.$slots, "label")
          ])
        } : void 0,
        unref(slots)["help-text"] ? {
          name: "help-text",
          fn: withCtx(() => [
            renderSlot(_ctx.$slots, "help-text")
          ])
        } : void 0
      ]), 1032, ["id", "error", "action", "label-hidden", "required-indicator", "label", "help-text"]);
    };
  }
});
const SettingAction = "Polaris-SettingAction";
const Setting = "Polaris-SettingAction__Setting";
const Action$1 = "Polaris-SettingAction__Action";
var styles$m = {
  SettingAction,
  Setting,
  Action: Action$1
};
var SettingAction_vue_vue_type_style_index_0_lang = "";
const _sfc_main$x = /* @__PURE__ */ defineComponent({
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(unref(styles$m).SettingAction)
      }, [
        createElementVNode("div", {
          class: normalizeClass(unref(styles$m).Setting)
        }, [
          renderSlot(_ctx.$slots, "setting")
        ], 2),
        createElementVNode("div", {
          class: normalizeClass(unref(styles$m).Action)
        }, [
          renderSlot(_ctx.$slots, "action")
        ], 2)
      ], 2);
    };
  }
});
const _hoisted_1$d = ["for"];
const _sfc_main$w = /* @__PURE__ */ defineComponent({
  props: {
    action: null,
    enabled: { type: Boolean }
  },
  setup(__props) {
    const getId = globalIdGeneratorFactory("SettingToggle");
    const id = getId();
    return (_ctx, _cache) => {
      return openBlock(), createBlock(unref(_sfc_main$2w), { sectioned: "" }, {
        default: withCtx(() => [
          createVNode(unref(_sfc_main$x), null, {
            action: withCtx(() => [
              __props.action ? (openBlock(), createBlock(unref(_sfc_main$2E), {
                key: 0,
                action: __props.action,
                overrides: { primary: !__props.enabled, role: "switch", id: unref(id), ariaChecked: __props.enabled ? true : false }
              }, null, 8, ["action", "overrides"])) : createCommentVNode("", true)
            ]),
            setting: withCtx(() => [
              createElementVNode("label", { for: unref(id) }, [
                renderSlot(_ctx.$slots, "default")
              ], 8, _hoisted_1$d)
            ]),
            _: 3
          })
        ]),
        _: 3
      });
    };
  }
});
const Sheet = "Polaris-Sheet";
const Container = "Polaris-Sheet__Container";
const Bottom = "Polaris-Sheet__Bottom";
const enterBottom = "Polaris-Sheet--enterBottom";
const enterBottomActive = "Polaris-Sheet--enterBottomActive";
const exitBottom = "Polaris-Sheet--exitBottom";
const exitBottomActive = "Polaris-Sheet--exitBottomActive";
const Right = "Polaris-Sheet__Right";
const enterRight = "Polaris-Sheet--enterRight";
const enterRightActive = "Polaris-Sheet--enterRightActive";
const exitRight = "Polaris-Sheet--exitRight";
const exitRightActive = "Polaris-Sheet--exitRightActive";
var styles$l = {
  Sheet,
  Container,
  Bottom,
  enterBottom,
  enterBottomActive,
  exitBottom,
  exitBottomActive,
  Right,
  enterRight,
  enterRightActive,
  exitRight,
  exitRightActive
};
var Sheet_vue_vue_type_style_index_0_lang = "";
const _hoisted_1$c = ["aria-label"];
const _sfc_main$v = /* @__PURE__ */ defineComponent({
  props: {
    open: { type: Boolean },
    accessibilityLabel: null
  },
  emits: ["close", "entered", "exit"],
  setup(__props, { emit: emits }) {
    const slots = useSlots();
    const { useMediaQuery } = UseMediaQuery();
    const { isNavigationCollapsed } = useMediaQuery();
    const container = ref(null);
    const activatorRef = ref(null);
    const isMounted = ref(false);
    onMounted(() => {
      isMounted.value = true;
    });
    const handleClose = () => {
      emits("close");
      const activatorElement = slots.activator && hasSlot(slots.activator) ? slots.activator()[0].children : activatorRef.value;
      if (activatorElement) {
        requestAnimationFrame(() => focusFirstFocusableNode(activatorElement));
      }
    };
    const transitionClasses = {
      enter: classNames(isNavigationCollapsed ? styles$l.enterBottom : styles$l.enterRight),
      enterActive: classNames(isNavigationCollapsed ? styles$l.enterBottomActive : styles$l.enterRightActive),
      enterDone: classNames(isNavigationCollapsed ? styles$l.enterBottomActive : styles$l.enterRightActive),
      exit: classNames(isNavigationCollapsed ? styles$l.exitBottom : styles$l.exitBottom),
      exitActive: classNames(isNavigationCollapsed ? styles$l.exitBottomActive : styles$l.exitRightActive)
    };
    const onTransitionBeforeEnter = (el) => {
      el.classList.add(classNames(isNavigationCollapsed ? styles$l.Bottom : styles$l.Right));
      el.classList.add(transitionClasses.enter);
    };
    const onTransitionEnter = (el, done) => {
      el.classList.remove(transitionClasses.enter);
      el.classList.add(transitionClasses.enterDone);
      setTimeout(done, parseInt(motion["duration-300"], 10));
    };
    const onTransitionAfterEnter = (el) => {
      el.classList.remove(transitionClasses.enterDone, classNames(isNavigationCollapsed ? styles$l.Bottom : styles$l.Right));
      emits("entered");
    };
    const onTransitionBeforeLeave = (el) => {
      el.classList.add(classNames(isNavigationCollapsed ? styles$l.Bottom : styles$l.Right));
      el.classList.add(transitionClasses.exitActive);
    };
    const onTransitionLeave = (el, done) => {
      el.classList.add(transitionClasses.exit);
      emits("exit");
      setTimeout(done, parseInt(motion["duration-300"], 10));
    };
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock(Fragment, null, [
        unref(hasSlot)(unref(slots).activator) ? (openBlock(), createElementBlock("div", {
          key: 0,
          ref_key: "activatorRef",
          ref: activatorRef
        }, [
          renderSlot(_ctx.$slots, "activator")
        ], 512)) : createCommentVNode("", true),
        isMounted.value ? (openBlock(), createBlock(unref(_sfc_main$2M), {
          key: 1,
          idPrefix: "sheet"
        }, {
          default: withCtx(() => [
            createVNode(Transition, {
              name: "custom-sheet-transition",
              onAfterEnter: onTransitionAfterEnter,
              onBeforeEnter: onTransitionBeforeEnter,
              onEnter: onTransitionEnter,
              onBeforeLeave: onTransitionBeforeLeave,
              onLeave: onTransitionLeave
            }, {
              default: withCtx(() => [
                __props.open ? (openBlock(), createElementBlock("div", mergeProps({
                  key: 0,
                  class: unref(styles$l).Container
                }, __spreadValues(__spreadValues({}, unref(layer).props), unref(overlay).props), {
                  ref_key: "container",
                  ref: container
                }), [
                  createVNode(unref(_sfc_main$17), { trapping: __props.open }, {
                    default: withCtx(() => [
                      createElementVNode("div", {
                        role: "dialog",
                        "aria-modal": "",
                        tabindex: "-1",
                        class: normalizeClass(unref(styles$l).Sheet),
                        "aria-label": __props.accessibilityLabel
                      }, [
                        renderSlot(_ctx.$slots, "default")
                      ], 10, _hoisted_1$c)
                    ]),
                    _: 3
                  }, 8, ["trapping"])
                ], 16)) : createCommentVNode("", true)
              ]),
              _: 3
            }),
            createVNode(unref(_sfc_main$3p), {
              keyCode: unref(Key).Escape,
              handler: handleClose
            }, null, 8, ["keyCode"]),
            __props.open ? (openBlock(), createBlock(unref(_sfc_main$2_), {
              key: 0,
              transparent: "",
              onClick: handleClose
            })) : createCommentVNode("", true)
          ]),
          _: 3
        })) : createCommentVNode("", true)
      ], 64);
    };
  }
});
const SkeletonBodyText = "Polaris-SkeletonBodyText";
var styles$k = {
  SkeletonBodyText
};
var SkeletonBodyText_vue_vue_type_style_index_0_lang = "";
const _sfc_main$u = /* @__PURE__ */ defineComponent({
  props: {
    lines: { default: 3 }
  },
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(true), createElementBlock(Fragment, null, renderList(__props.lines, (index) => {
        return openBlock(), createElementBlock("div", {
          key: index,
          class: normalizeClass(unref(styles$k).SkeletonBodyText)
        }, null, 2);
      }), 128);
    };
  }
});
const DisplayText = "Polaris-SkeletonDisplayText__DisplayText";
const sizeSmall$2 = "Polaris-SkeletonDisplayText--sizeSmall";
const sizeMedium$2 = "Polaris-SkeletonDisplayText--sizeMedium";
const sizeLarge$2 = "Polaris-SkeletonDisplayText--sizeLarge";
const sizeExtraLarge = "Polaris-SkeletonDisplayText--sizeExtraLarge";
var styles$j = {
  DisplayText,
  sizeSmall: sizeSmall$2,
  sizeMedium: sizeMedium$2,
  sizeLarge: sizeLarge$2,
  sizeExtraLarge
};
var SkeletonDisplayText_vue_vue_type_style_index_0_lang = "";
const _sfc_main$t = /* @__PURE__ */ defineComponent({
  props: {
    size: { default: "medium" }
  },
  setup(__props) {
    const props = __props;
    const className = classNames(styles$j.DisplayText, props.size && styles$j[variationName("size", props.size)]);
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(unref(className))
      }, null, 2);
    };
  }
});
const Page = "Polaris-SkeletonPage__Page";
const fullWidth = "Polaris-SkeletonPage--fullWidth";
const narrowWidth = "Polaris-SkeletonPage--narrowWidth";
const Content = "Polaris-SkeletonPage__Content";
const Header = "Polaris-SkeletonPage__Header";
const BreadcrumbAction = "Polaris-SkeletonPage__BreadcrumbAction";
const TitleAndPrimaryAction = "Polaris-SkeletonPage__TitleAndPrimaryAction";
const TitleWrapper = "Polaris-SkeletonPage__TitleWrapper";
const Title$1 = "Polaris-SkeletonPage__Title";
const SkeletonTitle = "Polaris-SkeletonPage__SkeletonTitle";
const PrimaryAction = "Polaris-SkeletonPage__PrimaryAction";
const Actions = "Polaris-SkeletonPage__Actions";
const Action = "Polaris-SkeletonPage__Action";
var styles$i = {
  Page,
  fullWidth,
  narrowWidth,
  Content,
  Header,
  BreadcrumbAction,
  TitleAndPrimaryAction,
  TitleWrapper,
  Title: Title$1,
  SkeletonTitle,
  PrimaryAction,
  Actions,
  Action
};
var SkeletonPage_vue_vue_type_style_index_0_lang = "";
const _hoisted_1$b = ["aria-label"];
const _sfc_main$s = /* @__PURE__ */ defineComponent({
  props: {
    title: { default: "" },
    fullWidth: { type: Boolean },
    narrowWidth: { type: Boolean },
    primaryAction: { type: Boolean },
    breadcrumbs: { type: Boolean }
  },
  setup(__props) {
    const props = __props;
    const i18n = UseI18n();
    const className = computed(() => classNames(styles$i.Page, props.fullWidth && styles$i.fullWidth, props.narrowWidth && styles$i.narrowWidth));
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(unref(className)),
        role: "status",
        "aria-label": unref(i18n).translate("Polaris.SkeletonPage.loadingLabel")
      }, [
        createElementVNode("div", {
          class: normalizeClass(unref(styles$i).Header)
        }, [
          __props.breadcrumbs ? (openBlock(), createElementBlock("div", {
            key: 0,
            class: normalizeClass(unref(styles$i).BreadcrumbAction),
            style: { width: "60px" }
          }, [
            createVNode(unref(_sfc_main$u), { lines: 1 })
          ], 2)) : createCommentVNode("", true),
          createElementVNode("div", {
            class: normalizeClass(unref(styles$i).TitleAndPrimaryAction)
          }, [
            createElementVNode("div", {
              class: normalizeClass(unref(styles$i).TitleWrapper)
            }, [
              __props.title ? (openBlock(), createElementBlock("h1", {
                key: 0,
                class: normalizeClass(unref(styles$i).Title)
              }, toDisplayString(__props.title), 3)) : (openBlock(), createElementBlock("div", {
                key: 1,
                class: normalizeClass(unref(styles$i).SkeletonTitle)
              }, null, 2))
            ], 2),
            __props.primaryAction ? (openBlock(), createElementBlock("div", {
              key: 0,
              class: normalizeClass(unref(styles$i).PrimaryAction)
            }, [
              createVNode(unref(_sfc_main$t), { size: "large" })
            ], 2)) : createCommentVNode("", true)
          ], 2)
        ], 2),
        createElementVNode("div", {
          class: normalizeClass(unref(styles$i).Content)
        }, [
          renderSlot(_ctx.$slots, "default")
        ], 2)
      ], 10, _hoisted_1$b);
    };
  }
});
const Tabs$1 = "Polaris-SkeletonTabs__Tabs";
const Tab$1 = "Polaris-SkeletonTabs__Tab";
var styles$h = {
  Tabs: Tabs$1,
  Tab: Tab$1,
  "Tab-short": "Polaris-SkeletonTabs__Tab--short",
  "Tab-long": "Polaris-SkeletonTabs__Tab--long"
};
var SkeletonTabs_vue_vue_type_style_index_0_lang = "";
const _sfc_main$r = /* @__PURE__ */ defineComponent({
  props: {
    count: { default: 2 }
  },
  setup(__props) {
    const className = (index) => {
      return classNames(styles$h.Tab, index % 2 === 0 ? styles$h["Tab-short"] : styles$h["Tab-long"]);
    };
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(unref(styles$h).Tabs)
      }, [
        (openBlock(true), createElementBlock(Fragment, null, renderList(__props.count, (key) => {
          return openBlock(), createElementBlock("div", {
            key,
            class: normalizeClass(className(key))
          }, [
            createVNode(unref(_sfc_main$u), { lines: 1 })
          ], 2);
        }), 128))
      ], 2);
    };
  }
});
const SkeletonThumbnail = "Polaris-SkeletonThumbnail";
const sizeExtraSmall$1 = "Polaris-SkeletonThumbnail--sizeExtraSmall";
const sizeSmall$1 = "Polaris-SkeletonThumbnail--sizeSmall";
const sizeMedium$1 = "Polaris-SkeletonThumbnail--sizeMedium";
const sizeLarge$1 = "Polaris-SkeletonThumbnail--sizeLarge";
var styles$g = {
  SkeletonThumbnail,
  sizeExtraSmall: sizeExtraSmall$1,
  sizeSmall: sizeSmall$1,
  sizeMedium: sizeMedium$1,
  sizeLarge: sizeLarge$1
};
var SkeletonThumbnail_vue_vue_type_style_index_0_lang = "";
const _sfc_main$q = /* @__PURE__ */ defineComponent({
  props: {
    size: { default: "medium" }
  },
  setup(__props) {
    const props = __props;
    const className = classNames(styles$g.SkeletonThumbnail, props.size && styles$g[variationName("size", props.size)]);
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(unref(className))
      }, null, 2);
    };
  }
});
const _sfc_main$p = /* @__PURE__ */ defineComponent({
  props: {
    boundingElement: null,
    offset: { type: Boolean, default: false },
    disableWhenStacked: { type: Boolean, default: false }
  },
  emits: ["sticky-change"],
  setup(__props, { emit: emits }) {
    const props = __props;
    const stickyManager = inject("stickyManagerContext", {});
    const isSticky = ref(false);
    const style2 = ref({});
    const placeHolderNode = ref(null);
    const stickyNode = ref(null);
    onMounted(() => {
      if (!stickyNode.value || !placeHolderNode.value) {
        return;
      }
      stickyManager.registerStickyItem({
        stickyNode: stickyNode.value,
        placeHolderNode: placeHolderNode.value,
        handlePositioning,
        offset: props.offset,
        boundingElement: props.boundingElement,
        disableWhenStacked: props.disableWhenStacked
      });
    });
    onBeforeUnmount(() => {
      if (!stickyNode.value) {
        return;
      }
      stickyManager.unregisterStickyItem(stickyNode.value);
    });
    const handlePositioning = (stick, top = 0, left = 0, width = 0) => {
      if (stick && !isSticky.value || !stick && isSticky.value) {
        adjustPlaceHolderNode(stick);
        isSticky.value = !isSticky.value;
        emits("sticky-change", isSticky.value);
        if (!props.boundingElement) {
          return;
        }
        props.boundingElement.toggleAttribute("data-sticky-active");
      }
      style2.value = stick ? {
        position: "fixed",
        top: `${top}px`,
        left: `${left}px`,
        width: `${width}px`
      } : {};
    };
    const adjustPlaceHolderNode = (add) => {
      if (placeHolderNode.value && stickyNode.value) {
        placeHolderNode.value.style.paddingBottom = add ? `${getRectForNode(stickyNode.value).height}px` : "0px";
      }
    };
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", null, [
        createElementVNode("div", {
          ref_key: "placeHolderNode",
          ref: placeHolderNode
        }, null, 512),
        createElementVNode("div", {
          ref_key: "stickyNode",
          ref: stickyNode,
          style: normalizeStyle(style2.value)
        }, [
          renderSlot(_ctx.$slots, "default")
        ], 4)
      ]);
    };
  }
});
const Subheading = "Polaris-Subheading";
var styles$f = {
  Subheading
};
var Subheading_vue_vue_type_style_index_0_lang = "";
const _sfc_main$o = /* @__PURE__ */ defineComponent({
  props: {
    element: { default: "h3" }
  },
  setup(__props) {
    const slots = useSlots();
    const isTextOnlySlot = computed(() => {
      var _a, _b;
      return slots.default && (((_a = slots.default()[0]) == null ? void 0 : _a.type.toString()) === "Symbol(Text)" || ((_b = slots.default()[0]) == null ? void 0 : _b.type.toString()) === "Symbol()");
    });
    const ariaLabel = isTextOnlySlot.value ? slots.default && slots.default()[0].children : void 0;
    return (_ctx, _cache) => {
      return openBlock(), createBlock(resolveDynamicComponent(__props.element), {
        "aria-label": unref(ariaLabel),
        class: normalizeClass(unref(styles$f).Subheading)
      }, {
        default: withCtx(() => [
          renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }, 8, ["aria-label", "class"]);
    };
  }
});
function getVisibleAndHiddenTabIndices(tabs, selected2, disclosureWidth, tabWidths, containerWidth) {
  const sumTabWidths = tabWidths.reduce((sum, width) => sum + width, 0);
  const arrayOfTabIndices = tabs.map((_, index) => {
    return index;
  });
  const visibleTabs = [];
  const hiddenTabs = [];
  if (containerWidth > sumTabWidths) {
    visibleTabs.push(...arrayOfTabIndices);
  } else {
    visibleTabs.push(selected2);
    let tabListWidth = tabWidths[selected2];
    arrayOfTabIndices.forEach((currentTabIndex) => {
      if (currentTabIndex !== selected2) {
        const currentTabWidth = tabWidths[currentTabIndex];
        if (tabListWidth + currentTabWidth >= containerWidth - disclosureWidth) {
          hiddenTabs.push(currentTabIndex);
          return;
        }
        visibleTabs.push(currentTabIndex);
        tabListWidth += currentTabWidth;
      }
    });
  }
  return {
    visibleTabs,
    hiddenTabs
  };
}
const Tabs = "Polaris-Tabs";
const Wrapper = "Polaris-Tabs__Wrapper";
const fitted = "Polaris-Tabs--fitted";
const TabContainer = "Polaris-Tabs__TabContainer";
const Title = "Polaris-Tabs__Title";
const fillSpace = "Polaris-Tabs--fillSpace";
const Tab = "Polaris-Tabs__Tab";
const titleWithIcon = "Polaris-Tabs--titleWithIcon";
const Panel = "Polaris-Tabs__Panel";
const List = "Polaris-Tabs__List";
const Item = "Polaris-Tabs__Item";
const DisclosureTab = "Polaris-Tabs__DisclosureTab";
const DisclosureActivator = "Polaris-Tabs__DisclosureActivator";
const TabMeasurer = "Polaris-Tabs__TabMeasurer";
var styles$e = {
  Tabs,
  Wrapper,
  fitted,
  TabContainer,
  Title,
  fillSpace,
  Tab,
  "Tab-selected": "Polaris-Tabs__Tab--selected",
  titleWithIcon,
  Panel,
  "Panel-hidden": "Polaris-Tabs__Panel--hidden",
  List,
  Item,
  DisclosureTab,
  "DisclosureTab-visible": "Polaris-Tabs__DisclosureTab--visible",
  DisclosureActivator,
  TabMeasurer
};
const _sfc_main$n = /* @__PURE__ */ defineComponent({
  props: {
    id: null,
    focused: { type: Boolean },
    panelID: null,
    url: null,
    accessibilityLabel: null
  },
  setup(__props) {
    const props = __props;
    const focusedNode = ref(null);
    const classItem = classNames(styles$e.Item);
    const sharedProps = computed(() => {
      return {
        id: props.id,
        class: classItem,
        "aria-controls": props.panelID,
        "aria-selected": false,
        "aria-label": props.accessibilityLabel
      };
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("li", null, [
        __props.url ? (openBlock(), createBlock(unref(_sfc_main$3m), mergeProps({
          key: 0,
          ref_key: "focusedNode",
          ref: focusedNode
        }, unref(sharedProps), {
          onClick: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("click"))
        }), {
          default: withCtx(() => [
            renderSlot(_ctx.$slots, "default")
          ]),
          _: 3
        }, 16)) : (openBlock(), createElementBlock("button", mergeProps({
          key: 1,
          type: "button",
          ref_key: "focusedNode",
          ref: focusedNode
        }, unref(sharedProps), {
          onClick: _cache[1] || (_cache[1] = ($event) => _ctx.$emit("click"))
        }), [
          renderSlot(_ctx.$slots, "default")
        ], 16))
      ]);
    };
  }
});
const _sfc_main$m = /* @__PURE__ */ defineComponent({
  props: {
    focusIndex: null,
    disclosureTabs: null
  },
  emits: ["click", "keypress"],
  setup(__props, { emit: emits }) {
    const slots = useSlots();
    const handleKeyDown = (event) => {
      const { key } = event;
      if (key === "ArrowLeft" || key === "ArrowRight") {
        event.preventDefault();
        event.stopPropagation();
      }
    };
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("ul", {
        class: normalizeClass(unref(styles$e).List),
        onKeydown: handleKeyDown,
        onKeyup: _cache[0] || (_cache[0] = ($event) => emits("keypress", $event))
      }, [
        (openBlock(true), createElementBlock(Fragment, null, renderList(__props.disclosureTabs, (item, index) => {
          return openBlock(), createBlock(unref(_sfc_main$n), {
            key: item.id,
            id: item.id,
            url: item.url,
            panelID: item.panelID,
            accessibilityLabel: item.accessibilityLabel,
            focused: index === __props.focusIndex,
            onClick: ($event) => emits("click", item.id)
          }, {
            default: withCtx(() => [
              unref(hasSlot)(unref(slots)[item.id]) ? renderSlot(_ctx.$slots, item.id, { key: 0 }) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
                createTextVNode(toDisplayString(item.content), 1)
              ], 64))
            ]),
            _: 2
          }, 1032, ["id", "url", "panelID", "accessibilityLabel", "focused", "onClick"]);
        }), 128))
      ], 34);
    };
  }
});
const _hoisted_1$a = ["id", "aria-labelledby"];
const _sfc_main$l = /* @__PURE__ */ defineComponent({
  props: {
    hidden: { type: Boolean },
    id: null,
    tabID: null
  },
  setup(__props) {
    const props = __props;
    const className = computed(() => {
      return classNames(styles$e.Panel, props.hidden && styles$e["Panel--hidden"]);
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(unref(className)),
        id: __props.id,
        role: "tabpanel",
        "aria-labelledby": __props.tabID,
        tabIndex: "-1"
      }, [
        renderSlot(_ctx.$slots, "default")
      ], 10, _hoisted_1$a);
    };
  }
});
const _hoisted_1$9 = ["id", "tabIndex", "aria-selected", "aria-controls", "aria-label"];
const _sfc_main$k = /* @__PURE__ */ defineComponent({
  props: {
    id: null,
    focused: { type: Boolean },
    siblingTabHasFocus: { type: Boolean },
    selected: { type: Boolean },
    panelID: null,
    url: null,
    measuring: { type: Boolean },
    accessibilityLabel: null
  },
  emits: ["click"],
  setup(__props, { emit: emits }) {
    const props = __props;
    useSlots();
    const wasSelected = ref(props.selected);
    const panelFocused = ref(false);
    const tabNode = ref(null);
    const tabIndex = computed(() => {
      if (props.selected && !props.siblingTabHasFocus && !props.measuring) {
        return 0;
      } else if (props.focused && !props.measuring) {
        return 0;
      }
      return -1;
    });
    const handleClick = () => {
      emits("click", props.id);
    };
    onMounted(() => {
      initialize();
    });
    watch(() => [props.focused, props.id, props.measuring, props.panelID, props.selected], () => {
      initialize();
    });
    const initialize = () => {
      if (props.measuring) {
        return;
      }
      const itemHadFocus = props.focused || document.activeElement && document.activeElement.id === props.id;
      if (itemHadFocus && props.selected && props.panelID && !panelFocused.value) {
        focusPanelID(props.panelID);
        panelFocused.value = true;
      }
      if (props.selected && !wasSelected.value && props.panelID) {
        focusPanelID(props.panelID);
      } else if (props.focused && tabNode.value) {
        focusFirstFocusableNode(tabNode.value);
      }
      wasSelected.value = props.selected;
    };
    const className = computed(() => {
      return classNames(styles$e.Tab, props.selected && styles$e["Tab-selected"]);
    });
    const tabContainerClassName = computed(() => {
      return classNames(styles$e.TabContainer);
    });
    const focusPanelID = (panelID) => {
      const panel = document.getElementById(panelID);
      if (panel) {
        panel.focus({ preventScroll: true });
      }
    };
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("li", {
        class: normalizeClass(unref(tabContainerClassName)),
        ref_key: "tabNode",
        ref: tabNode,
        role: "presentation"
      }, [
        __props.url ? (openBlock(), createBlock(unref(_sfc_main$3m), {
          key: 0,
          id: __props.id,
          url: __props.url,
          role: "tab",
          tabIndex: unref(tabIndex),
          class: normalizeClass(unref(className)),
          "aria-selected": __props.selected,
          "aria-controls": __props.panelID,
          "aria-label": __props.accessibilityLabel,
          onClick: handleClick,
          onMouseup: unref(handleMouseUpByBlurring)
        }, {
          default: withCtx(() => [
            createElementVNode("span", {
              class: normalizeClass(unref(styles$e).Title)
            }, [
              renderSlot(_ctx.$slots, "default")
            ], 2)
          ]),
          _: 3
        }, 8, ["id", "url", "tabIndex", "class", "aria-selected", "aria-controls", "aria-label", "onMouseup"])) : (openBlock(), createElementBlock("button", {
          key: 1,
          id: __props.id,
          role: "tab",
          type: "button",
          tabIndex: unref(tabIndex),
          class: normalizeClass(unref(className)),
          "aria-selected": __props.selected,
          "aria-controls": __props.panelID,
          "aria-label": __props.accessibilityLabel,
          onClick: handleClick,
          onMouseup: _cache[0] || (_cache[0] = (...args) => unref(handleMouseUpByBlurring) && unref(handleMouseUpByBlurring)(...args))
        }, [
          createElementVNode("span", {
            class: normalizeClass(unref(styles$e).Title)
          }, [
            renderSlot(_ctx.$slots, "default")
          ], 2)
        ], 42, _hoisted_1$9))
      ], 2);
    };
  }
});
const _sfc_main$j = /* @__PURE__ */ defineComponent({
  props: {
    tabToFocus: null,
    siblingTabHasFocus: { type: Boolean },
    selected: null,
    tabs: null
  },
  emits: ["measurement"],
  setup(__props, { emit: emits }) {
    const props = __props;
    const slots = useSlots();
    const containerNode = ref(null);
    const animationFrame = ref(null);
    const handleMeasurement = () => {
      if (animationFrame.value) {
        cancelAnimationFrame(animationFrame.value);
      }
      animationFrame.value = requestAnimationFrame(() => {
        if (!containerNode.value) {
          return;
        }
        const containerWidth = containerNode.value.offsetWidth;
        const hiddenTabNodes = containerNode.value.children;
        const hiddenTabNodesArray = Array.from(hiddenTabNodes);
        const hiddenTabWidths = hiddenTabNodesArray.map((node) => {
          return Math.ceil(node.getBoundingClientRect().width);
        });
        const disclosureWidth = hiddenTabWidths.pop() || 0;
        emits("measurement", {
          containerWidth,
          disclosureWidth,
          hiddenTabWidths
        });
      });
    };
    watch(() => props.tabs, () => {
      handleMeasurement();
    });
    const className = classNames(styles$e.Tabs, styles$e.TabMeasurer);
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(unref(className)),
        ref_key: "containerNode",
        ref: containerNode
      }, [
        createVNode(unref(_sfc_main$33), {
          event: "resize",
          handler: handleMeasurement
        }),
        (openBlock(true), createElementBlock(Fragment, null, renderList(__props.tabs, (tab, index) => {
          return openBlock(), createBlock(unref(_sfc_main$k), {
            measuring: "",
            key: `${index}${tab.id}Hidden`,
            id: `${tab.id}Measurer`,
            siblingTabHasFocus: __props.siblingTabHasFocus,
            focused: index === __props.tabToFocus,
            selected: index === __props.selected,
            url: tab.url
          }, {
            default: withCtx(() => [
              unref(hasSlot)(unref(slots)[tab.id]) ? renderSlot(_ctx.$slots, tab.id, { key: 0 }) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
                createTextVNode(toDisplayString(tab.content), 1)
              ], 64))
            ]),
            _: 2
          }, 1032, ["id", "siblingTabHasFocus", "focused", "selected", "url"]);
        }), 128)),
        renderSlot(_ctx.$slots, "activator")
      ], 2);
    };
  }
});
var Tabs_vue_vue_type_style_index_0_lang = "";
const _hoisted_1$8 = ["aria-label"];
const _hoisted_2$5 = ["aria-label"];
const _hoisted_3$4 = ["aria-label"];
const _hoisted_4$1 = ["aria-label"];
const _sfc_main$i = /* @__PURE__ */ defineComponent({
  props: {
    selected: null,
    tabs: null,
    fitted: { type: Boolean },
    disclosureText: null
  },
  emits: ["select"],
  setup(__props, { emit: emits }) {
    const props = __props;
    const i18n = UseI18n();
    const slots = useSlots();
    const getDerivedStateFromProps = (nextProps, prevState) => {
      const { disclosureWidth: disclosureWidth2, tabWidths: tabWidths2, containerWidth: containerWidth2 } = prevState;
      const { visibleTabs: tmpVisibleTabs, hiddenTabs: tmpHiddenTabs } = getVisibleAndHiddenTabIndices(nextProps.tabs, nextProps.selected, disclosureWidth2, tabWidths2, containerWidth2);
      visibleTabs.value = tmpVisibleTabs;
      hiddenTabs.value = tmpHiddenTabs;
    };
    onMounted(() => {
      getDerivedStateFromProps({ tabs: props.tabs, selected: props.selected }, {
        disclosureWidth: disclosureWidth.value,
        tabWidths: tabWidths.value,
        containerWidth: containerWidth.value
      });
    });
    const disclosureWidth = ref(0);
    const containerWidth = ref(Infinity);
    const tabWidths = ref([]);
    const visibleTabs = ref([]);
    const hiddenTabs = ref([]);
    const showDisclosure = ref(false);
    const tabToFocus = ref(-1);
    const disclosureActivatorVisible = computed(() => visibleTabs.value.length < props.tabs.length);
    const hasCustomDisclosure = computed(() => !!props.disclosureText);
    const className = computed(() => classNames(styles$e.Tabs, props.fitted && styles$e.fitted, disclosureActivatorVisible.value && styles$e.fillSpace));
    const disclosureTabClassName = computed(() => classNames(styles$e.DisclosureTab, disclosureActivatorVisible.value && styles$e["DisclosureTab-visible"]));
    const disclosureButtonClassName = computed(() => classNames(styles$e.DisclosureActivator, hasCustomDisclosure.value && styles$e.Tab));
    const disclosureButtonContentWrapperClassName = computed(() => classNames(styles$e.Title, hasCustomDisclosure.value && styles$e.titleWithIcon));
    const sortedTab = computed(() => {
      const tmpVisibleTabs = [...visibleTabs.value];
      return tmpVisibleTabs.sort((a, b) => a - b);
    });
    const disclosureTabs = computed(() => {
      return hiddenTabs.value.map((tabIndex) => props.tabs[tabIndex]);
    });
    const handleKeyPress = (event) => {
      const key = event.key;
      const tabsArrayInOrder = showDisclosure.value ? visibleTabs.value.concat(hiddenTabs.value) : [...visibleTabs.value];
      let newFocus = tabsArrayInOrder.indexOf(tabToFocus.value);
      if (key === "ArrowRight") {
        newFocus += 1;
        if (newFocus === tabsArrayInOrder.length) {
          newFocus = 0;
        }
      }
      if (key === "ArrowLeft") {
        if (newFocus === -1 || newFocus === 0) {
          newFocus = tabsArrayInOrder.length - 1;
        } else {
          newFocus -= 1;
        }
      }
      tabToFocus.value = tabsArrayInOrder[newFocus];
    };
    const handleFocus = (event) => {
      const target = event.target;
      if (target.classList.contains(styles$e.Tab) || target.classList.contains(styles$e.Item)) {
        let tmpTabToFocus = -1;
        props.tabs.some((tab, index) => {
          if (tab.id === target.id) {
            tmpTabToFocus = index;
            return true;
          }
          return false;
        });
        tabToFocus.value = tmpTabToFocus;
        return;
      }
      if (target.classList.contains(styles$e.DisclosureActivator)) {
        return;
      }
      if (!event.relatedTarget) {
        tabToFocus.value = props.selected;
        return;
      }
      const relatedTarget = event.relatedTarget;
      if (relatedTarget instanceof HTMLElement && !relatedTarget.classList.contains(styles$e.Tab) && !relatedTarget.classList.contains(styles$e.Item) && !relatedTarget.classList.contains(styles$e.DisclosureActivator)) {
        tabToFocus.value = props.selected;
      }
    };
    const handleBlur = (event) => {
      if (event.relatedTarget == null) {
        tabToFocus.value = -1;
        return;
      }
      const target = event.relatedTarget;
      if (target instanceof HTMLElement && !target.classList.contains(styles$e.Tab) && !target.classList.contains(styles$e.Item)) {
        tabToFocus.value = -1;
      }
    };
    const handleDisclosureActivatorClick = () => {
      showDisclosure.value = !showDisclosure.value;
    };
    const handleClose = () => {
      showDisclosure.value = false;
    };
    const handleMeasurement = (measurements) => {
      const tabIndices = getVisibleAndHiddenTabIndices(props.tabs, props.selected, measurements.disclosureWidth, measurements.hiddenTabWidths, measurements.containerWidth);
      tabToFocus.value = tabToFocus.value === -1 ? -1 : props.selected;
      visibleTabs.value = tabIndices.visibleTabs;
      hiddenTabs.value = tabIndices.hiddenTabs;
      disclosureWidth.value = measurements.disclosureWidth;
      containerWidth.value = measurements.containerWidth;
      tabWidths.value = measurements.hiddenTabWidths;
    };
    const handleTabClick = (id) => {
      const tab = props.tabs.findIndex((aTab) => aTab.id === id);
      if (tab === -1) {
        return;
      }
      emits("select", tab);
    };
    function handleKeyDown(event) {
      const { key } = event;
      if (key === "ArrowLeft" || key === "ArrowRight") {
        event.preventDefault();
        event.stopPropagation();
      }
    }
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", null, [
        createElementVNode("div", {
          class: normalizeClass(unref(styles$e).Wrapper)
        }, [
          createVNode(unref(_sfc_main$j), {
            tabToFocus: tabToFocus.value,
            selected: __props.selected,
            tabs: __props.tabs,
            siblingTabHasFocus: tabToFocus.value > -1,
            onMeasurement: handleMeasurement
          }, createSlots({
            activator: withCtx(() => [
              __props.disclosureText ? (openBlock(), createElementBlock("div", {
                key: 0,
                class: normalizeClass(unref(styles$e).TabContainer)
              }, [
                createElementVNode("button", {
                  type: "button",
                  class: normalizeClass(unref(disclosureButtonClassName)),
                  "aria-label": unref(i18n).translate("Polaris.Tabs.toggleTabsLabel"),
                  onClick: handleDisclosureActivatorClick
                }, [
                  createElementVNode("span", {
                    class: normalizeClass(unref(disclosureButtonContentWrapperClassName))
                  }, [
                    unref(hasCustomDisclosure) ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
                      createTextVNode(toDisplayString(__props.disclosureText), 1),
                      createVNode(unref(_sfc_main$2K), {
                        source: unref(CaretDownMinor),
                        color: "subdued"
                      }, null, 8, ["source"])
                    ], 64)) : (openBlock(), createBlock(unref(_sfc_main$2K), {
                      key: 1,
                      source: unref(HorizontalDotsMinor),
                      color: "subdued"
                    }, null, 8, ["source"]))
                  ], 2)
                ], 10, _hoisted_1$8)
              ], 2)) : (openBlock(), createElementBlock("button", {
                key: 1,
                type: "button",
                class: normalizeClass(unref(disclosureButtonClassName)),
                "aria-label": unref(i18n).translate("Polaris.Tabs.toggleTabsLabel"),
                onClick: handleDisclosureActivatorClick
              }, [
                createElementVNode("span", {
                  class: normalizeClass(unref(disclosureButtonContentWrapperClassName))
                }, [
                  unref(hasCustomDisclosure) ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
                    createTextVNode(toDisplayString(__props.disclosureText), 1),
                    createVNode(unref(_sfc_main$2K), {
                      source: unref(CaretDownMinor),
                      color: "subdued"
                    }, null, 8, ["source"])
                  ], 64)) : (openBlock(), createBlock(unref(_sfc_main$2K), {
                    key: 1,
                    source: unref(HorizontalDotsMinor),
                    color: "subdued"
                  }, null, 8, ["source"]))
                ], 2)
              ], 10, _hoisted_2$5))
            ]),
            _: 2
          }, [
            renderList(__props.tabs, (tab, index) => {
              return {
                name: "{#[tab.id]}",
                fn: withCtx(() => [
                  unref(hasSlot)(unref(slots)[tab.id]) ? renderSlot(_ctx.$slots, tab.id, { key: 0 }) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
                    createTextVNode(toDisplayString(tab.content), 1)
                  ], 64))
                ])
              };
            })
          ]), 1032, ["tabToFocus", "selected", "tabs", "siblingTabHasFocus"]),
          createElementVNode("ul", {
            role: "tablist",
            class: normalizeClass(unref(className)),
            onFocus: handleFocus,
            onBlur: handleBlur,
            onKeydown: handleKeyDown,
            onKeyup: handleKeyPress
          }, [
            (openBlock(true), createElementBlock(Fragment, null, renderList(unref(sortedTab), (tab, index) => {
              return openBlock(), createBlock(unref(_sfc_main$k), {
                key: `${index}-${__props.tabs[tab].id}`,
                id: __props.tabs[tab].id,
                siblingTabHasFocus: tabToFocus.value > -1,
                focused: index === tabToFocus.value,
                selected: index === __props.selected,
                panelID: unref(hasSlot)(unref(slots).default) ? __props.tabs[tab].panelID || `${__props.tabs[tab].id}-panel` : void 0,
                accessibilityLabel: __props.tabs[tab].accessibilityLabel,
                url: __props.tabs[tab].url,
                onClick: handleTabClick
              }, {
                default: withCtx(() => [
                  createVNode(unref(Text), {
                    as: "span",
                    variant: "bodyMd"
                  }, {
                    default: withCtx(() => [
                      unref(hasSlot)(unref(slots)[__props.tabs[tab].id]) ? renderSlot(_ctx.$slots, __props.tabs[tab].id, { key: 0 }) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
                        createTextVNode(toDisplayString(__props.tabs[tab].content), 1)
                      ], 64))
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1032, ["id", "siblingTabHasFocus", "focused", "selected", "panelID", "accessibilityLabel", "url"]);
            }), 128)),
            createElementVNode("li", {
              class: normalizeClass(unref(disclosureTabClassName)),
              role: "presentation"
            }, [
              createVNode(unref(_sfc_main$2L), {
                preferredPosition: "below",
                active: unref(disclosureActivatorVisible) && showDisclosure.value,
                onClose: handleClose,
                autofocusTarget: "first-node"
              }, {
                activator: withCtx(() => [
                  __props.disclosureText ? (openBlock(), createElementBlock("div", {
                    key: 0,
                    class: normalizeClass(unref(styles$e).TabContainer)
                  }, [
                    createElementVNode("button", {
                      type: "button",
                      class: normalizeClass(unref(disclosureButtonClassName)),
                      "aria-label": unref(i18n).translate("Polaris.Tabs.toggleTabsLabel"),
                      onClick: handleDisclosureActivatorClick
                    }, [
                      createElementVNode("span", {
                        class: normalizeClass(unref(disclosureButtonContentWrapperClassName))
                      }, [
                        unref(hasCustomDisclosure) ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
                          createTextVNode(toDisplayString(__props.disclosureText), 1),
                          createVNode(unref(_sfc_main$2K), {
                            source: unref(CaretDownMinor),
                            color: "subdued"
                          }, null, 8, ["source"])
                        ], 64)) : (openBlock(), createBlock(unref(_sfc_main$2K), {
                          key: 1,
                          source: unref(HorizontalDotsMinor),
                          color: "subdued"
                        }, null, 8, ["source"]))
                      ], 2)
                    ], 10, _hoisted_3$4)
                  ], 2)) : (openBlock(), createElementBlock("button", {
                    key: 1,
                    type: "button",
                    class: normalizeClass(unref(disclosureButtonClassName)),
                    "aria-label": unref(i18n).translate("Polaris.Tabs.toggleTabsLabel"),
                    onClick: handleDisclosureActivatorClick
                  }, [
                    createElementVNode("span", {
                      class: normalizeClass(unref(disclosureButtonContentWrapperClassName))
                    }, [
                      unref(hasCustomDisclosure) ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
                        createTextVNode(toDisplayString(__props.disclosureText), 1),
                        createVNode(unref(_sfc_main$2K), {
                          source: unref(CaretDownMinor),
                          color: "subdued"
                        }, null, 8, ["source"])
                      ], 64)) : (openBlock(), createBlock(unref(_sfc_main$2K), {
                        key: 1,
                        source: unref(HorizontalDotsMinor),
                        color: "subdued"
                      }, null, 8, ["source"]))
                    ], 2)
                  ], 10, _hoisted_4$1))
                ]),
                content: withCtx(() => [
                  createVNode(unref(_sfc_main$m), {
                    focusIndex: hiddenTabs.value.indexOf(tabToFocus.value),
                    disclosureTabs: unref(disclosureTabs),
                    onClick: handleTabClick,
                    onKeypress: handleKeyPress
                  }, null, 8, ["focusIndex", "disclosureTabs"])
                ]),
                _: 1
              }, 8, ["active"])
            ], 2)
          ], 34)
        ], 2),
        unref(hasSlot)(unref(slots).default) ? (openBlock(true), createElementBlock(Fragment, { key: 0 }, renderList(__props.tabs, (tab, index) => {
          return openBlock(), createElementBlock(Fragment, {
            key: tab.id
          }, [
            __props.selected === index ? (openBlock(), createBlock(unref(_sfc_main$l), {
              key: 0,
              id: tab.panelID || `${tab.id}-panel`,
              tabID: tab.id
            }, {
              default: withCtx(() => [
                renderSlot(_ctx.$slots, "default")
              ]),
              _: 2
            }, 1032, ["id", "tabID"])) : createCommentVNode("", true),
            createVNode(unref(_sfc_main$l), {
              id: tab.panelID || `${tab.id}-panel`,
              tabID: tab.id,
              hidden: ""
            }, null, 8, ["id", "tabID"])
          ], 64);
        }), 128)) : createCommentVNode("", true)
      ]);
    };
  }
});
const _sfc_main$h = /* @__PURE__ */ defineComponent({
  props: {
    content: null,
    duration: null,
    error: { type: Boolean },
    action: null
  },
  setup(__props) {
    const props = __props;
    const attrs = useAttrs();
    const { useUniqueId } = UseUniqueId();
    const { useFrame } = UseFrame();
    const {
      showToast,
      hideToast
    } = useFrame();
    const id = useUniqueId("Toast");
    onMounted(() => {
      showToast(__spreadValues(__spreadValues({ id }, props), attrs));
    });
    onBeforeUnmount(() => {
      hideToast({ id });
    });
    return (_ctx, _cache) => {
      return null;
    };
  }
});
var TooltipOverlay_vue_vue_type_style_index_0_lang = "";
const _hoisted_1$7 = ["id", "aria-label"];
const _sfc_main$g = /* @__PURE__ */ defineComponent({
  props: {
    id: null,
    active: { type: Boolean },
    preventInteraction: null,
    preferredPosition: { default: "below" },
    activator: null,
    accessibilityLabel: null
  },
  setup(__props) {
    const props = __props;
    const i18n = UseI18n();
    const contentStyles = ref({});
    const ariaLabel = computed(() => {
      return props.accessibilityLabel ? i18n.translate("Polaris.TooltipOverlay.accessibilityLabel", {
        label: props.accessibilityLabel
      }) : void 0;
    });
    const changeContentStyles = (value2) => {
      contentStyles.value = { minHeight: `${value2.desiredHeight}px` };
    };
    return (_ctx, _cache) => {
      return __props.active ? (openBlock(), createBlock(unref(_sfc_main$2Q), {
        key: 0,
        layout: "tooltip",
        active: __props.active,
        activator: __props.activator,
        preferredPosition: __props.preferredPosition,
        preventInteraction: __props.preventInteraction,
        onChangeContentStyles: changeContentStyles
      }, {
        default: withCtx(() => [
          createElementVNode("div", {
            id: __props.id,
            role: "tooltip",
            class: normalizeClass(unref(styles$1E).Content),
            style: normalizeStyle(contentStyles.value),
            "aria-label": unref(ariaLabel)
          }, [
            renderSlot(_ctx.$slots, "default")
          ], 14, _hoisted_1$7)
        ]),
        _: 3
      }, 8, ["active", "activator", "preferredPosition", "preventInteraction"])) : createCommentVNode("", true);
    };
  }
});
const __default__$1 = {
  inheritAttrs: false
};
const _sfc_main$f = /* @__PURE__ */ defineComponent(__spreadProps(__spreadValues({}, __default__$1), {
  props: {
    active: { type: Boolean, default: false },
    content: null,
    dismissOnMouseOut: null,
    preferredPosition: { default: "below" },
    activatorWrapper: { default: "span" },
    accessibilityLabel: null
  },
  emits: ["close", "open"],
  setup(__props, { emit: emits }) {
    const props = __props;
    const slots = useSlots();
    const active2 = ref(props.active);
    const mouseEntered = ref(false);
    const activatorNode = ref(null);
    const activatorContainer = ref(null);
    const { useUniqueId, uniqueIdRef } = UseUniqueId();
    const id = useUniqueId("TooltipContent");
    watch(() => uniqueIdRef.value, () => {
      const firstFocusable = activatorContainer.value ? findFirstFocusableNode(activatorContainer.value) : null;
      const accessibilityNode = firstFocusable || activatorContainer.value;
      if (!accessibilityNode) {
        return;
      }
      accessibilityNode.tabIndex = 0;
      accessibilityNode.setAttribute("aria-describedby", id);
      accessibilityNode.setAttribute("data-polaris-tooltip-activator", "true");
    });
    watch(() => activatorContainer.value, () => {
      const node = activatorContainer.value;
      if (node == null) {
        activatorNode.value = null;
      } else {
        if (node.firstElementChild instanceof HTMLElement) {
          activatorNode.value = node.firstElementChild;
        }
      }
    });
    const handleBlur = () => {
      active2.value = false;
      emits("close");
    };
    const handleFocus = () => {
      active2.value = true;
      emits("open");
    };
    const handleKeyUp = (event) => {
      if (event.key !== Key.Escape) {
        return;
      }
      emits("close");
      handleBlur();
    };
    function handleMouseEnter() {
      mouseEntered.value = true;
      handleFocus();
    }
    function handleMouseLeave() {
      mouseEntered.value = false;
      handleBlur();
    }
    function handleMouseEnterFix() {
      !mouseEntered.value && handleMouseEnter();
    }
    return (_ctx, _cache) => {
      return openBlock(), createBlock(resolveDynamicComponent(__props.activatorWrapper), {
        ref_key: "activatorContainer",
        ref: activatorContainer,
        onFocus: handleFocus,
        onBlur: handleBlur,
        onMouseleave: handleMouseLeave,
        onMouseover: handleMouseEnterFix,
        onKeyup: handleKeyUp
      }, {
        default: withCtx(() => [
          renderSlot(_ctx.$slots, "default"),
          activatorNode.value ? (openBlock(), createBlock(unref(_sfc_main$2M), {
            key: 0,
            idPrefix: "tooltip"
          }, {
            default: withCtx(() => [
              createVNode(unref(_sfc_main$g), {
                id: unref(id),
                preferredPosition: __props.preferredPosition,
                preventInteraction: __props.dismissOnMouseOut,
                activator: activatorNode.value,
                active: active2.value,
                accessibilityLabel: __props.accessibilityLabel
              }, {
                default: withCtx(() => [
                  unref(slots).content ? renderSlot(_ctx.$slots, "content", { key: 0 }) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
                    createTextVNode(toDisplayString(__props.content), 1)
                  ], 64))
                ]),
                _: 3
              }, 8, ["id", "preferredPosition", "preventInteraction", "activator", "active", "accessibilityLabel"])
            ]),
            _: 3
          })) : createCommentVNode("", true)
        ]),
        _: 3
      }, 512);
    };
  }
}));
const Tag = "Polaris-Tag";
const disabled = "Polaris-Tag--disabled";
const clickable = "Polaris-Tag--clickable";
const removable = "Polaris-Tag--removable";
const linkable = "Polaris-Tag--linkable";
const TagText = "Polaris-Tag__TagText";
const Button = "Polaris-Tag__Button";
const segmented = "Polaris-Tag--segmented";
const Link = "Polaris-Tag__Link";
const LinkText = "Polaris-Tag__LinkText";
var styles$d = {
  Tag,
  disabled,
  clickable,
  removable,
  linkable,
  TagText,
  Button,
  segmented,
  Link,
  LinkText
};
var Tag_vue_vue_type_style_index_0_lang = "";
const _hoisted_1$6 = ["disabled"];
const _hoisted_2$4 = ["href"];
const _hoisted_3$3 = ["title"];
const _hoisted_4 = ["title"];
const _hoisted_5 = ["aria-label", "disabled"];
const _sfc_main$e = /* @__PURE__ */ defineComponent({
  props: {
    disabled: { type: Boolean },
    accessibilityLabel: null,
    url: null
  },
  setup(__props) {
    const props = __props;
    const attrs = useAttrs();
    const slots = useSlots();
    const hasEventClick = computed(() => Boolean(attrs["onClick"]));
    const hasEventRemove = computed(() => Boolean(attrs["onRemove"]));
    const segmented2 = computed(() => hasEventClick.value && props.url);
    const className = computed(() => {
      return classNames(styles$d.Tag, props.disabled && styles$d.disabled, hasEventClick.value && styles$d.clickable, hasEventRemove.value && styles$d.removable, props.url && !props.disabled && styles$d.linkable, segmented2.value && styles$d.segmented);
    });
    const classLink = computed(() => classNames(styles$d.Link, segmented2.value && styles$d.segmented));
    const classRemove = computed(() => classNames(styles$d.Button, segmented2.value && styles$d.segmented));
    const tagTitle = computed(() => {
      if (props.accessibilityLabel) {
        return props.accessibilityLabel;
      }
      if (slots.default && slots.default()[0].children) {
        return slots.default()[0].children;
      }
      return "";
    });
    const ariaLabel = computed(() => {
      return `Remove ${tagTitle.value || ""}`;
    });
    const onMouseUp = handleMouseUpByBlurring;
    return (_ctx, _cache) => {
      return unref(hasEventClick) ? (openBlock(), createElementBlock("button", {
        key: 0,
        type: "button",
        disabled: __props.disabled,
        class: normalizeClass(unref(className))
      }, [
        renderSlot(_ctx.$slots, "default")
      ], 10, _hoisted_1$6)) : (openBlock(), createElementBlock("span", {
        key: 1,
        class: normalizeClass(unref(className))
      }, [
        __props.url && !__props.disabled ? (openBlock(), createElementBlock("a", {
          key: 0,
          class: normalizeClass(unref(classLink)),
          href: __props.url
        }, [
          createElementVNode("span", {
            title: unref(tagTitle),
            class: normalizeClass(unref(styles$d).LinkText)
          }, [
            renderSlot(_ctx.$slots, "default")
          ], 10, _hoisted_3$3)
        ], 10, _hoisted_2$4)) : (openBlock(), createElementBlock("span", {
          key: 1,
          title: unref(tagTitle),
          class: normalizeClass(unref(styles$d).TagText)
        }, [
          renderSlot(_ctx.$slots, "default")
        ], 10, _hoisted_4)),
        unref(hasEventRemove) ? (openBlock(), createElementBlock("button", {
          key: 2,
          type: "button",
          "aria-label": unref(ariaLabel),
          class: normalizeClass(unref(classRemove)),
          disabled: __props.disabled,
          onClick: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("remove")),
          onMouseup: _cache[1] || (_cache[1] = (...args) => unref(onMouseUp) && unref(onMouseUp)(...args))
        }, [
          createVNode(unref(_sfc_main$2K), { source: unref(CancelSmallMinor) }, null, 8, ["source"])
        ], 42, _hoisted_5)) : createCommentVNode("", true)
      ], 2));
    };
  }
});
const root = "Polaris-Text--root";
const block = "Polaris-Text--block";
const truncate = "Polaris-Text--truncate";
const visuallyHidden = "Polaris-Text--visuallyHidden";
const start = "Polaris-Text--start";
const center = "Polaris-Text--center";
const end = "Polaris-Text--end";
const justify = "Polaris-Text--justify";
const success = "Polaris-Text--success";
const critical = "Polaris-Text--critical";
const warning = "Polaris-Text--warning";
const subdued = "Polaris-Text--subdued";
const regular = "Polaris-Text--regular";
const medium = "Polaris-Text--medium";
const semibold = "Polaris-Text--semibold";
const bold = "Polaris-Text--bold";
const headingXs = "Polaris-Text--headingXs";
const headingSm = "Polaris-Text--headingSm";
const headingMd = "Polaris-Text--headingMd";
const headingLg = "Polaris-Text--headingLg";
const headingXl = "Polaris-Text--headingXl";
const heading2xl = "Polaris-Text--heading2xl";
const heading3xl = "Polaris-Text--heading3xl";
const heading4xl = "Polaris-Text--heading4xl";
const bodySm = "Polaris-Text--bodySm";
const bodyMd = "Polaris-Text--bodyMd";
const bodyLg = "Polaris-Text--bodyLg";
var styles$c = {
  root,
  block,
  truncate,
  visuallyHidden,
  start,
  center,
  end,
  justify,
  success,
  critical,
  warning,
  subdued,
  "text-inverse": "Polaris-Text__text--inverse",
  regular,
  medium,
  semibold,
  bold,
  headingXs,
  headingSm,
  headingMd,
  headingLg,
  headingXl,
  heading2xl,
  heading3xl,
  heading4xl,
  bodySm,
  bodyMd,
  bodyLg,
  "break": "Polaris-Text--break"
};
var Text_vue_vue_type_style_index_0_lang = "";
const _sfc_main$d = /* @__PURE__ */ defineComponent({
  props: {
    alignment: null,
    as: null,
    breakWord: { type: Boolean },
    color: null,
    fontWeight: null,
    id: null,
    truncate: { type: Boolean, default: false },
    variant: null,
    visuallyHidden: { type: Boolean, default: false }
  },
  setup(__props) {
    const props = __props;
    const VariantFontWeightMapping = {
      headingXs: "semibold",
      headingSm: "semibold",
      headingMd: "semibold",
      headingLg: "semibold",
      headingXl: "semibold",
      heading2xl: "semibold",
      heading3xl: "semibold",
      heading4xl: "bold",
      bodySm: "regular",
      bodyMd: "regular",
      bodyLg: "regular"
    };
    const componentName = computed(() => props.as || (props.visuallyHidden ? "span" : "p"));
    const className = computed(() => classNames(styles$c.root, styles$c[props.variant], props.fontWeight ? styles$c[props.fontWeight] : styles$c[VariantFontWeightMapping[props.variant]], (props.alignment || props.truncate) && styles$c.block, props.alignment && styles$c[props.alignment], props.breakWord && styles$c.break, props.color && styles$c[props.color], props.truncate && styles$c.truncate, props.visuallyHidden && styles$c.visuallyHidden));
    return (_ctx, _cache) => {
      return openBlock(), createBlock(resolveDynamicComponent(unref(componentName)), {
        class: normalizeClass(unref(className)),
        id: __props.id
      }, {
        default: withCtx(() => [
          renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }, 8, ["class", "id"]);
    };
  }
});
var Text = _sfc_main$d;
const TextContainer = "Polaris-TextContainer";
const spacingTight = "Polaris-TextContainer--spacingTight";
const spacingLoose = "Polaris-TextContainer--spacingLoose";
var styles$b = {
  TextContainer,
  spacingTight,
  spacingLoose
};
var TextContainer_vue_vue_type_style_index_0_lang = "";
const _sfc_main$c = /* @__PURE__ */ defineComponent({
  props: {
    spacing: null
  },
  setup(__props) {
    const props = __props;
    const spacingClassName = computed(() => props.spacing && styles$b[variationName("spacing", props.spacing)]);
    const className = computed(() => classNames(styles$b.TextContainer, spacingClassName.value));
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(unref(className))
      }, [
        renderSlot(_ctx.$slots, "default")
      ], 2);
    };
  }
});
const variationPositive = "Polaris-TextStyle--variationPositive";
const variationNegative = "Polaris-TextStyle--variationNegative";
const variationWarning = "Polaris-TextStyle--variationWarning";
const variationCode = "Polaris-TextStyle--variationCode";
const variationStrong = "Polaris-TextStyle--variationStrong";
const variationSubdued = "Polaris-TextStyle--variationSubdued";
var styles$a = {
  variationPositive,
  variationNegative,
  variationWarning,
  variationCode,
  variationStrong,
  variationSubdued
};
var TextStyle_vue_vue_type_style_index_0_lang = "";
const _sfc_main$b = /* @__PURE__ */ defineComponent({
  props: {
    variation: {
      type: String,
      default: null
    }
  },
  setup(__props) {
    const props = __props;
    const VariationValue = {
      positive: "positive",
      negative: "negative",
      warning: "warning",
      strong: "strong",
      subdued: "subdued",
      code: "code"
    };
    function variationElement(variation) {
      return variation === VariationValue.code ? "code" : "span";
    }
    const element = ref(variationElement(props.variation));
    const className = computed(() => {
      const variation = props.variation && variationName("variation", props.variation);
      return classNames(variation && styles$a[variation]);
    });
    return (_ctx, _cache) => {
      return openBlock(), createBlock(resolveDynamicComponent(element.value), {
        class: normalizeClass(unref(className))
      }, {
        default: withCtx(() => [
          renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }, 8, ["class"]);
    };
  }
});
const Thumbnail$1 = "Polaris-Thumbnail";
const sizeExtraSmall = "Polaris-Thumbnail--sizeExtraSmall";
const sizeSmall = "Polaris-Thumbnail--sizeSmall";
const sizeMedium = "Polaris-Thumbnail--sizeMedium";
const sizeLarge = "Polaris-Thumbnail--sizeLarge";
const transparent = "Polaris-Thumbnail--transparent";
var styles$9 = {
  Thumbnail: Thumbnail$1,
  sizeExtraSmall,
  sizeSmall,
  sizeMedium,
  sizeLarge,
  transparent
};
var Thumbnail_vue_vue_type_style_index_0_lang = "";
const _sfc_main$a = /* @__PURE__ */ defineComponent({
  props: {
    size: { default: "medium" },
    source: null,
    alt: null,
    transparent: { type: Boolean }
  },
  setup(__props) {
    const props = __props;
    const className = computed(() => {
      const size = variationName("size", props.size);
      return classNames(styles$9.Thumbnail, size && styles$9[size], props.transparent && styles$9.transparent);
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("span", {
        class: normalizeClass(unref(className))
      }, [
        typeof __props.source === "string" ? (openBlock(), createBlock(unref(_sfc_main$1D), {
          key: 0,
          alt: __props.alt,
          source: __props.source
        }, null, 8, ["alt", "source"])) : (openBlock(), createBlock(unref(_sfc_main$2K), {
          key: 1,
          accessibilityLabel: __props.alt,
          source: __props.source
        }, null, 8, ["accessibilityLabel", "source"]))
      ], 2);
    };
  }
});
const Tiles = "Polaris-Tiles";
var styles$8 = {
  Tiles
};
var Tiles_vue_vue_type_style_index_0_lang = "";
const _sfc_main$9 = /* @__PURE__ */ defineComponent({
  props: {
    gap: null,
    columns: null
  },
  setup(__props) {
    const props = __props;
    const style2 = computed(() => {
      var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o;
      const fullStyles = {
        "--pc-tile-gap-xs": ((_a = props.gap) == null ? void 0 : _a.xs) ? `var(--p-space-${(_b = props.gap) == null ? void 0 : _b.xs})` : void 0,
        "--pc-tile-gap-sm": ((_c = props.gap) == null ? void 0 : _c.sm) ? `var(--p-space-${(_d = props.gap) == null ? void 0 : _d.sm})` : void 0,
        "--pc-tile-gap-md": ((_e = props.gap) == null ? void 0 : _e.md) ? `var(--p-space-${(_f = props.gap) == null ? void 0 : _f.md})` : void 0,
        "--pc-tile-gap-lg": ((_g = props.gap) == null ? void 0 : _g.lg) ? `var(--p-space-${(_h = props.gap) == null ? void 0 : _h.lg})` : void 0,
        "--pc-tile-gap-xl": ((_i = props.gap) == null ? void 0 : _i.xl) ? `var(--p-space-${(_j = props.gap) == null ? void 0 : _j.xl})` : void 0,
        "--pc-tile-xs": formatColumns((_k = props.columns) == null ? void 0 : _k.xs),
        "--pc-tile-sm": formatColumns((_l = props.columns) == null ? void 0 : _l.sm),
        "--pc-tile-md": formatColumns((_m = props.columns) == null ? void 0 : _m.md),
        "--pc-tile-lg": formatColumns((_n = props.columns) == null ? void 0 : _n.lg),
        "--pc-tile-xl": formatColumns((_o = props.columns) == null ? void 0 : _o.xl)
      };
      return Object.fromEntries(Object.entries(fullStyles).filter(([, value2]) => value2));
    });
    function formatColumns(columns) {
      if (!columns) {
        return void 0;
      }
      return typeof columns === "number" ? `repeat(${columns}, 1fr)` : columns;
    }
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(unref(styles$8).Tiles),
        style: normalizeStyle(unref(style2))
      }, [
        renderSlot(_ctx.$slots, "default")
      ], 6);
    };
  }
});
const _hoisted_1$5 = {
  viewBox: "0 0 20 20",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$3 = /* @__PURE__ */ createElementVNode("path", { d: "M19 11H1a1 1 0 0 1 0-2h18a1 1 0 1 1 0 2zm0-7H1a1 1 0 0 1 0-2h18a1 1 0 1 1 0 2zm0 14H1a1 1 0 0 1 0-2h18a1 1 0 0 1 0 2z" }, null, -1);
const _hoisted_3$2 = [
  _hoisted_2$3
];
function render$1(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1$5, _hoisted_3$2);
}
var MobileHamburgerMajor = { render: render$1 };
const TopBar = "Polaris-TopBar";
const LogoDisplayControl = "Polaris-TopBar__LogoDisplayControl";
const LogoDisplayContainer = "Polaris-TopBar__LogoDisplayContainer";
const LogoContainer = "Polaris-TopBar__LogoContainer";
const hasLogoSuffix = "Polaris-TopBar--hasLogoSuffix";
const Logo = "Polaris-TopBar__Logo";
const LogoLink = "Polaris-TopBar__LogoLink";
const ContextControl = "Polaris-TopBar__ContextControl";
const NavigationIcon = "Polaris-TopBar__NavigationIcon";
const focused$1 = "Polaris-TopBar--focused";
const IconWrapper = "Polaris-TopBar__IconWrapper";
const Contents = "Polaris-TopBar__Contents";
const SearchField$1 = "Polaris-TopBar__SearchField";
const SecondaryMenu = "Polaris-TopBar__SecondaryMenu";
var styles$7 = {
  TopBar,
  LogoDisplayControl,
  LogoDisplayContainer,
  LogoContainer,
  hasLogoSuffix,
  Logo,
  LogoLink,
  ContextControl,
  NavigationIcon,
  focused: focused$1,
  IconWrapper,
  Contents,
  SearchField: SearchField$1,
  SecondaryMenu
};
const ActivatorWrapper = "Polaris-TopBar-Menu__ActivatorWrapper";
const Activator = "Polaris-TopBar-Menu__Activator";
const Section$1 = "Polaris-TopBar-Menu__Section";
var styles$6 = {
  ActivatorWrapper,
  Activator,
  Section: Section$1
};
const Section = "Polaris-Menu-Message__Section";
var styles$5 = {
  Section
};
var Message_vue_vue_type_style_index_0_lang = "";
const _sfc_main$8 = /* @__PURE__ */ defineComponent({
  props: {
    title: null,
    description: null,
    action: null,
    link: null,
    badge: null
  },
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(unref(styles$5).Section)
      }, [
        createVNode(unref(_sfc_main$2P), null, {
          default: withCtx(() => [
            createVNode(unref(_sfc_main$12), {
              vertical: "",
              spacing: "tight"
            }, {
              default: withCtx(() => [
                createVNode(unref(_sfc_main$c), null, {
                  default: withCtx(() => [
                    createVNode(unref(Text), {
                      as: "h2",
                      variant: "headingMd"
                    }, {
                      default: withCtx(() => [
                        createTextVNode(toDisplayString(__props.title), 1),
                        __props.badge ? (openBlock(), createBlock(unref(_sfc_main$2Y), {
                          key: 0,
                          status: __props.badge.status
                        }, {
                          default: withCtx(() => [
                            createTextVNode(toDisplayString(__props.badge.content), 1)
                          ]),
                          _: 1
                        }, 8, ["status"])) : createCommentVNode("", true)
                      ]),
                      _: 1
                    }),
                    createElementVNode("p", null, toDisplayString(__props.description), 1)
                  ]),
                  _: 1
                }),
                createVNode(unref(_sfc_main$1k), {
                  url: __props.link.to
                }, {
                  default: withCtx(() => [
                    createTextVNode(toDisplayString(__props.link.content), 1)
                  ]),
                  _: 1
                }, 8, ["url"]),
                createVNode(unref(_sfc_main$2F), {
                  plain: "",
                  onClick: __props.action.onClick
                }, {
                  default: withCtx(() => [
                    createTextVNode(toDisplayString(__props.action.content), 1)
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ], 2);
    };
  }
});
var Menu_vue_vue_type_style_index_0_lang = "";
const _hoisted_1$4 = ["aria-label"];
const __default__ = {
  inheritAttrs: false
};
const _sfc_main$7 = /* @__PURE__ */ defineComponent(__spreadProps(__spreadValues({}, __default__), {
  props: {
    actions: null,
    message: null,
    open: { type: Boolean },
    accessibilityLabel: null
  },
  setup(__props) {
    const props = __props;
    const isFullHeight = computed(() => !!props.message);
    const badgeProps = props.message && props.message.badge && {
      content: props.message.badge.content,
      status: props.message.badge.status
    };
    return (_ctx, _cache) => {
      return openBlock(), createBlock(unref(_sfc_main$2L), {
        fixed: "",
        active: __props.open,
        "full-height": unref(isFullHeight),
        "preferred-alignment": "right",
        onClose: _cache[2] || (_cache[2] = ($event) => _ctx.$emit("close"))
      }, {
        activator: withCtx(() => [
          createElementVNode("div", {
            class: normalizeClass(unref(styles$6).ActivatorWrapper)
          }, [
            createElementVNode("button", {
              type: "button",
              class: normalizeClass(unref(styles$6).Activator),
              "aria-label": __props.accessibilityLabel,
              onClick: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("open"))
            }, [
              renderSlot(_ctx.$slots, "activatorContent")
            ], 10, _hoisted_1$4)
          ], 2)
        ]),
        content: withCtx(() => [
          createVNode(unref(_sfc_main$3h), {
            sections: __props.actions,
            onActionAnyItem: _cache[1] || (_cache[1] = ($event) => _ctx.$emit("close"))
          }, null, 8, ["sections"]),
          __props.message && __props.message.action && __props.message.link ? (openBlock(), createBlock(unref(_sfc_main$8), {
            key: 0,
            title: __props.message.title,
            description: __props.message.description,
            action: { onClick: __props.message.action.onClick, content: __props.message.action.content },
            link: { to: __props.message.link.to, content: __props.message.link.content },
            badge: unref(badgeProps)
          }, null, 8, ["title", "description", "action", "link", "badge"])) : createCommentVNode("", true)
        ]),
        _: 3
      }, 8, ["active", "full-height"]);
    };
  }
}));
const Search = "Polaris-TopBar-Search";
const SearchContent = "Polaris-TopBar-Search__SearchContent";
const visible$1 = "Polaris-TopBar-Search--visible";
const Results = "Polaris-TopBar-Search__Results";
var styles$4 = {
  Search,
  SearchContent,
  visible: visible$1,
  Results
};
const SearchDismissOverlay = "Polaris-TopBar-SearchDismissOverlay";
const visible = "Polaris-TopBar-SearchDismissOverlay--visible";
var styles$3 = {
  SearchDismissOverlay,
  visible
};
var SearchDismissOverlay_vue_vue_type_style_index_0_lang = "";
const _sfc_main$6 = /* @__PURE__ */ defineComponent({
  props: {
    visible: { type: Boolean }
  },
  emits: ["dismiss"],
  setup(__props, { emit: emits }) {
    const props = __props;
    const nodeRef = ref(null);
    const className = computed(() => classNames(styles$3.SearchDismissOverlay, props.visible && styles$3.visible));
    const handleDismiss = (e) => {
      const target = e.target;
      if (target === nodeRef.value) {
        emits("dismiss");
      }
    };
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock(Fragment, null, [
        __props.visible ? (openBlock(), createBlock(unref(_sfc_main$z), { key: 0 })) : createCommentVNode("", true),
        createElementVNode("div", mergeProps(_ctx.$attrs, {
          ref_key: "nodeRef",
          ref: nodeRef,
          class: unref(className),
          onClick: handleDismiss
        }), null, 16)
      ], 64);
    };
  }
});
var Search_vue_vue_type_style_index_0_lang = "";
const _sfc_main$5 = /* @__PURE__ */ defineComponent({
  props: {
    visible: { type: Boolean },
    overlayVisible: { type: Boolean, default: false }
  },
  emits: ["dismiss"],
  setup(__props, { emit: emits }) {
    const props = __props;
    const slots = useSlots();
    const className = computed(() => classNames(styles$4.Search, props.visible && styles$4.visible));
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock(Fragment, null, [
        __props.visible && unref(slots).default ? (openBlock(), createBlock(unref(_sfc_main$6), {
          key: 0,
          visible: __props.overlayVisible,
          onDismiss: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("dismiss"))
        }, null, 8, ["visible"])) : createCommentVNode("", true),
        unref(slots).default ? (openBlock(), createElementBlock("div", {
          key: 1,
          class: normalizeClass(unref(className))
        }, [
          createElementVNode("div", {
            class: normalizeClass(unref(styles$4).SearchContent)
          }, [
            createElementVNode("div", {
              class: normalizeClass(unref(styles$4).Results)
            }, [
              renderSlot(_ctx.$slots, "default")
            ], 2)
          ], 2)
        ], 2)) : createCommentVNode("", true)
      ], 64);
    };
  }
});
const SearchField = "Polaris-TopBar-SearchField";
const focused = "Polaris-TopBar-SearchField--focused";
const Input = "Polaris-TopBar-SearchField__Input";
const Backdrop = "Polaris-TopBar-SearchField__Backdrop";
const BackdropShowFocusBorder = "Polaris-TopBar-SearchField__BackdropShowFocusBorder";
const Icon = "Polaris-TopBar-SearchField__Icon";
const Clear = "Polaris-TopBar-SearchField__Clear";
var styles$2 = {
  SearchField,
  focused,
  Input,
  Backdrop,
  BackdropShowFocusBorder,
  Icon,
  Clear
};
var SearchField_vue_vue_type_style_index_0_lang = "";
const _hoisted_1$3 = ["for"];
const _hoisted_2$2 = ["id", "placeholder"];
const _hoisted_3$1 = ["aria-label"];
const _sfc_main$4 = /* @__PURE__ */ defineComponent({
  props: {
    modelValue: null,
    placeholder: null,
    focused: { type: Boolean },
    active: { type: Boolean },
    showFocusBorder: { type: Boolean }
  },
  emits: ["change", "focus", "blur", "cancel", "update:modelValue"],
  setup(__props, { emit: emits }) {
    const props = __props;
    const i18n = UseI18n();
    const forceActive = ref(false);
    const inputRef = ref(null);
    const { useUniqueId } = UseUniqueId();
    const searchId = useUniqueId("SearchField");
    const handleChange = (e) => {
      const el = e.target;
      emits("change", el.value);
      emits("update:modelValue", el.value);
    };
    const handleFocus = () => {
      emits("focus");
    };
    const handleBlur = () => {
      emits("blur");
    };
    const handleClear = () => {
      emits("cancel");
      emits("update:modelValue", "");
      emits("change", "");
      if (inputRef.value) {
        inputRef.value.focus();
      }
    };
    const onClearBlur = () => {
      forceActive.value = false;
    };
    const onClearFocus = () => {
      handleFocus();
      forceActive.value = true;
    };
    const className = computed(() => {
      return classNames(styles$2.SearchField, (props.focused || props.active || forceActive.value) && styles$2.focused);
    });
    const backDropClassName = computed(() => {
      return classNames(styles$2.Backdrop, props.showFocusBorder && styles$2.BackdropShowFocusBorder);
    });
    onMounted(() => {
      if (!inputRef.value) {
        return;
      }
      if (props.focused) {
        inputRef.value.focus();
      } else {
        inputRef.value.blur();
      }
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(unref(className)),
        onFocus: handleFocus,
        onBlur: handleBlur
      }, [
        createVNode(unref(Text), {
          as: "span",
          variant: "bodySm",
          "visually-hidden": ""
        }, {
          default: withCtx(() => [
            createElementVNode("label", { for: unref(searchId) }, toDisplayString(unref(i18n).translate("Polaris.TopBar.SearchField.search")), 9, _hoisted_1$3)
          ]),
          _: 1
        }),
        withDirectives(createElementVNode("input", {
          id: unref(searchId),
          class: normalizeClass(unref(styles$2).Input),
          placeholder: __props.placeholder,
          ref_key: "inputRef",
          ref: inputRef,
          type: "search",
          autoCapitalize: "off",
          autoComplete: "off",
          autoCorrect: "off",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => isRef(modelValue) ? modelValue.value = $event : null),
          onInput: handleChange,
          onKeydown: _cache[1] || (_cache[1] = withKeys(withModifiers(() => false, ["prevent"]), ["enter"]))
        }, null, 42, _hoisted_2$2), [
          [vModelText, __props.modelValue]
        ]),
        createElementVNode("span", {
          class: normalizeClass(unref(styles$2).Icon)
        }, [
          createVNode(unref(_sfc_main$2K), { source: unref(SearchMinor) }, null, 8, ["source"])
        ], 2),
        __props.modelValue.length > 0 ? (openBlock(), createElementBlock("button", {
          key: 0,
          type: "button",
          "aria-label": unref(i18n).translate("Polaris.TopBar.SearchField.clearButtonLabel"),
          class: normalizeClass(unref(styles$2).Clear),
          onClick: handleClear,
          onBlur: onClearBlur,
          onFocus: onClearFocus
        }, [
          createVNode(unref(_sfc_main$2K), { source: unref(CircleCancelMinor) }, null, 8, ["source"])
        ], 42, _hoisted_3$1)) : createCommentVNode("", true),
        createElementVNode("div", {
          class: normalizeClass(unref(backDropClassName))
        }, null, 2)
      ], 34);
    };
  }
});
const Details = "Polaris-TopBar-UserMenu__Details";
var styles$1 = {
  Details
};
var UserMenu_vue_vue_type_style_index_0_lang = "";
const _sfc_main$3 = /* @__PURE__ */ defineComponent({
  props: {
    actions: null,
    message: null,
    name: null,
    detail: null,
    accessibilityLabel: null,
    initials: null,
    avatar: null,
    open: { type: Boolean }
  },
  setup(__props) {
    const props = __props;
    const showIndicator = ref(!!props.message);
    return (_ctx, _cache) => {
      return openBlock(), createBlock(unref(_sfc_main$7), {
        open: __props.open,
        actions: __props.actions,
        message: __props.message,
        accessibilityLabel: __props.accessibilityLabel,
        onOpen: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("toggle")),
        onClose: _cache[1] || (_cache[1] = ($event) => _ctx.$emit("toggle"))
      }, {
        activatorContent: withCtx(() => [
          createVNode(unref(_sfc_main$18), { active: showIndicator.value }, {
            default: withCtx(() => [
              createVNode(unref(_sfc_main$2$), {
                size: "small",
                source: __props.avatar,
                initials: __props.initials ? __props.initials.replace(" ", "") : void 0
              }, null, 8, ["source", "initials"])
            ]),
            _: 1
          }, 8, ["active"]),
          createElementVNode("span", {
            class: normalizeClass(unref(styles$1).Details)
          }, [
            createVNode(unref(Text), {
              as: "p",
              variant: "bodyMd",
              alignment: "start",
              "font-weight": "medium",
              truncate: ""
            }, {
              default: withCtx(() => [
                createTextVNode(toDisplayString(__props.name), 1)
              ]),
              _: 1
            }),
            createVNode(unref(Text), {
              as: "p",
              variant: "bodySm",
              alignment: "start",
              color: "subdued",
              truncate: ""
            }, {
              default: withCtx(() => [
                createTextVNode(toDisplayString(__props.detail), 1)
              ]),
              _: 1
            })
          ], 2)
        ]),
        _: 1
      }, 8, ["open", "actions", "message", "accessibilityLabel"]);
    };
  }
});
var TopBar_vue_vue_type_style_index_0_lang = "";
const _hoisted_1$2 = ["aria-label"];
const _sfc_main$2 = /* @__PURE__ */ defineComponent({
  props: {
    showNavigationToggle: { type: Boolean },
    searchResultsVisible: { type: Boolean },
    searchResultsOverlayVisible: { type: Boolean, default: false }
  },
  emits: ["search-result-dismiss", "navigation-toggle"],
  setup(__props, { emit: emits }) {
    const props = __props;
    const i18n = UseI18n();
    const { useFrame } = UseFrame();
    const { logo } = useFrame();
    const slots = useSlots();
    const focused2 = ref(false);
    const forceTrueFocused = () => {
      focused2.value = true;
    };
    const forceFalseFocused = () => {
      focused2.value = false;
    };
    const iconClassName = computed(() => {
      return classNames(styles$7.NavigationIcon, focused2.value && styles$7.focused);
    });
    const className = computed(() => {
      return classNames(styles$7.LogoContainer, props.showNavigationToggle || slots.searchField ? styles$7.LogoDisplayControl : styles$7.LogoDisplayContainer, hasSlot(slots["logo-suffix"]) && styles$7.hasLogoSuffix);
    });
    const width = getWidth(logo, 104);
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(unref(styles$7).TopBar)
      }, [
        __props.showNavigationToggle ? (openBlock(), createElementBlock("button", {
          key: 0,
          type: "button",
          class: normalizeClass(unref(iconClassName)),
          onClick: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("navigation-toggle")),
          onFocus: forceTrueFocused,
          onBlur: forceFalseFocused,
          "aria-label": unref(i18n).translate("Polaris.TopBar.toggleMenuLabel")
        }, [
          createElementVNode("div", {
            class: normalizeClass(unref(styles$7).IconWrapper)
          }, [
            createVNode(unref(_sfc_main$2K), { source: unref(MobileHamburgerMajor) }, null, 8, ["source"])
          ], 2)
        ], 42, _hoisted_1$2)) : createCommentVNode("", true),
        unref(slots).contextControl ? (openBlock(), createElementBlock("div", {
          key: 1,
          class: normalizeClass(unref(styles$7).ContextControl)
        }, [
          renderSlot(_ctx.$slots, "contextControl")
        ], 2)) : unref(logo) ? (openBlock(), createElementBlock("div", {
          key: 2,
          class: normalizeClass(unref(className))
        }, [
          createVNode(unref(_sfc_main$3m), {
            url: unref(logo).url || "",
            class: normalizeClass(unref(styles$7).LogoLink),
            style: normalizeStyle({ width: unref(width) })
          }, {
            default: withCtx(() => [
              createVNode(unref(_sfc_main$1D), {
                source: unref(logo).topBarSource || "",
                alt: unref(logo).accessibilityLabel || "",
                class: normalizeClass(unref(styles$7).Logo),
                style: normalizeStyle({ width: unref(width) })
              }, null, 8, ["source", "alt", "class", "style"])
            ]),
            _: 1
          }, 8, ["url", "class", "style"]),
          renderSlot(_ctx.$slots, "logo-suffix")
        ], 2)) : createCommentVNode("", true),
        createElementVNode("div", {
          class: normalizeClass(unref(styles$7).Contents)
        }, [
          createElementVNode("div", {
            class: normalizeClass(unref(styles$7).SearchField)
          }, [
            unref(slots).searchField ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
              renderSlot(_ctx.$slots, "searchField"),
              createVNode(unref(_sfc_main$5), {
                visible: __props.searchResultsVisible,
                overlayVisible: __props.searchResultsOverlayVisible,
                onDismiss: _cache[1] || (_cache[1] = ($event) => _ctx.$emit("search-result-dismiss"))
              }, {
                default: withCtx(() => [
                  renderSlot(_ctx.$slots, "searchResults")
                ]),
                _: 3
              }, 8, ["visible", "overlayVisible"])
            ], 64)) : createCommentVNode("", true)
          ], 2),
          createElementVNode("div", {
            class: normalizeClass(unref(styles$7).SecondaryMenu)
          }, [
            renderSlot(_ctx.$slots, "secondaryMenu")
          ], 2),
          renderSlot(_ctx.$slots, "userMenu")
        ], 2)
      ], 2);
    };
  }
});
const _sfc_main$1 = /* @__PURE__ */ defineComponent({
  props: {
    className: null
  },
  setup(__props) {
    const textRef = ref(null);
    return (_ctx, _cache) => {
      return openBlock(), createBlock(unref(_sfc_main$f), {
        content: textRef.value && textRef.value.innerText || ""
      }, {
        default: withCtx(() => [
          createElementVNode("span", {
            ref_key: "textRef",
            ref: textRef,
            class: normalizeClass(__props.className)
          }, [
            renderSlot(_ctx.$slots, "default")
          ], 2)
        ]),
        _: 3
      }, 8, ["content"]);
    };
  }
});
const MINUTE = 60;
const HOUR = MINUTE * 60;
function ensureTwoDigits(num) {
  return num > 9 ? String(num) : `0${num}`;
}
function secondsToTimeComponents(seconds) {
  return {
    hours: Math.floor(seconds / HOUR),
    minutes: Math.floor(seconds % HOUR / MINUTE),
    seconds: seconds % MINUTE
  };
}
function secondsToTimestamp(numSeconds) {
  const { hours, minutes, seconds } = secondsToTimeComponents(numSeconds);
  const hasHours = numSeconds > HOUR;
  const hoursText = hasHours ? `${hours}:` : "";
  const minutesText = `${hasHours ? ensureTwoDigits(minutes) : minutes}:`;
  const secondsText = `${ensureTwoDigits(seconds)}`;
  return `${hoursText}${minutesText}${secondsText}`;
}
function secondsToDurationTranslationKey(numSeconds) {
  const { hours, minutes, seconds } = secondsToTimeComponents(numSeconds);
  let durationKey = "Polaris.VideoThumbnail.playButtonA11yLabel.duration";
  if (hours) {
    durationKey += `.hours.${hours > 1 ? "other" : "one"}`;
    if (seconds) {
      if (minutes > 1) {
        durationKey += `${seconds > 1 ? ".minutesAndSeconds" : ".minutesAndSecond"}`;
      } else if (minutes === 1) {
        durationKey += `${seconds > 1 ? ".minuteAndSeconds" : ".minuteAndSecond"}`;
      } else {
        durationKey += `${seconds > 1 ? ".andSeconds" : ".andSecond"}`;
      }
    } else if (minutes) {
      durationKey += `${minutes > 1 ? ".andMinutes" : ".andMinute"}`;
    } else {
      durationKey += ".only";
    }
  } else if (minutes) {
    durationKey += `.minutes.${minutes > 1 ? "other" : "one"}`;
    if (seconds) {
      durationKey += `${seconds > 1 ? ".andSeconds" : ".andSecond"}`;
    } else {
      durationKey += ".only";
    }
  } else if (seconds) {
    durationKey += seconds > 1 ? ".seconds.other" : ".seconds.one";
  }
  return durationKey;
}
const _hoisted_1$1 = {
  viewBox: "0 0 20 20",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$1 = /* @__PURE__ */ createElementVNode("path", { d: "M16 10a.997.997 0 0 1-.485.857l-10 6a1.004 1.004 0 0 1-1.008.013A1.001 1.001 0 0 1 4 16V4a1.001 1.001 0 0 1 1.515-.857l10 6c.301.18.485.505.485.857z" }, null, -1);
const _hoisted_3 = [
  _hoisted_2$1
];
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1$1, _hoisted_3);
}
var PlayMinor = { render };
const Thumbnail = "Polaris-VideoThumbnail__Thumbnail";
const ThumbnailContainer = "Polaris-VideoThumbnail__ThumbnailContainer";
const PlayButton = "Polaris-VideoThumbnail__PlayButton";
const Timestamp = "Polaris-VideoThumbnail__Timestamp";
const PlayIcon = "Polaris-VideoThumbnail__PlayIcon";
const Progress = "Polaris-VideoThumbnail__Progress";
const Indicator = "Polaris-VideoThumbnail__Indicator";
const ProgressBar = "Polaris-VideoThumbnail__ProgressBar";
const Label = "Polaris-VideoThumbnail__Label";
var styles = {
  Thumbnail,
  ThumbnailContainer,
  PlayButton,
  Timestamp,
  PlayIcon,
  Progress,
  Indicator,
  ProgressBar,
  Label
};
var VideoThumbnail_vue_vue_type_style_index_0_lang = "";
const _hoisted_1 = ["aria-label"];
const _hoisted_2 = ["value"];
const _sfc_main = /* @__PURE__ */ defineComponent({
  props: {
    thumbnailUrl: null,
    videoLength: { default: 0 },
    videoProgress: { default: 0 },
    showVideoProgress: { type: Boolean, default: false },
    accessibilityLabel: null
  },
  setup(__props) {
    const props = __props;
    const i18n = UseI18n();
    const { useMediaQuery } = UseMediaQuery();
    const { isNavigationCollapsed } = useMediaQuery();
    const buttonLabel = computed(() => {
      if (props.accessibilityLabel) {
        return props.accessibilityLabel;
      }
      if (props.videoLength) {
        const { hours, minutes, seconds } = secondsToTimeComponents(props.videoLength);
        const translationKey = i18n.translate(secondsToDurationTranslationKey(props.videoLength), {
          hourCount: hours,
          minuteCount: minutes,
          secondCount: seconds
        });
        return i18n.translate("Polaris.VideoThumbnail.playButtonA11yLabel.defaultWithDuration", { duration: translationKey });
      }
      return i18n.translate("Polaris.VideoThumbnail.playButtonA11yLabel.default");
    });
    const progressValue = computed(() => calculateProgress(props.videoLength, props.videoProgress));
    const progressValuePercents = computed(() => Math.round(progressValue.value * 100));
    function calculateProgress(videoLength, videoProgress) {
      if (videoProgress > 0 && videoLength > 0) {
        const progress = parseFloat((videoProgress / videoLength).toFixed(2));
        return progress > 1 ? 1 : progress;
      }
      return 0;
    }
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(unref(styles).ThumbnailContainer)
      }, [
        createElementVNode("div", {
          class: normalizeClass(unref(styles).Thumbnail),
          style: normalizeStyle({ backgroundImage: `url(${__props.thumbnailUrl})` })
        }, null, 6),
        createElementVNode("button", {
          type: "button",
          class: normalizeClass(unref(styles).PlayButton),
          "aria-label": unref(buttonLabel),
          onClick: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("click")),
          onMouseenter: _cache[1] || (_cache[1] = ($event) => _ctx.$emit("before-start-playing")),
          onFocus: _cache[2] || (_cache[2] = ($event) => _ctx.$emit("before-start-playing")),
          onTouchstart: _cache[3] || (_cache[3] = ($event) => _ctx.$emit("before-start-playing"))
        }, [
          __props.videoLength ? (openBlock(), createElementBlock("p", {
            key: 0,
            class: normalizeClass(unref(styles).Timestamp)
          }, [
            createVNode(unref(_sfc_main$12), {
              alignment: "center",
              spacing: "extraTight"
            }, {
              default: withCtx(() => [
                createElementVNode("span", {
                  class: normalizeClass(unref(styles).PlayIcon)
                }, [
                  createVNode(unref(_sfc_main$2K), { source: unref(PlayMinor) }, null, 8, ["source"])
                ], 2),
                createVNode(unref(Text), {
                  variant: unref(isNavigationCollapsed) ? "bodyLg" : "bodyMd",
                  as: "p",
                  "font-weight": "semibold"
                }, {
                  default: withCtx(() => [
                    createTextVNode(toDisplayString(unref(secondsToTimestamp)(__props.videoLength)), 1)
                  ]),
                  _: 1
                }, 8, ["variant"])
              ]),
              _: 1
            })
          ], 2)) : createCommentVNode("", true)
        ], 42, _hoisted_1),
        __props.showVideoProgress ? (openBlock(), createElementBlock("div", {
          key: 0,
          class: normalizeClass(unref(styles).Progress)
        }, [
          createElementVNode("progress", {
            class: normalizeClass(unref(styles).ProgressBar),
            value: unref(progressValuePercents),
            max: "100"
          }, null, 10, _hoisted_2),
          createElementVNode("div", {
            class: normalizeClass(unref(styles).Indicator),
            style: normalizeStyle({ transform: `scaleX(${unref(progressValue)})` })
          }, [
            createElementVNode("span", {
              class: normalizeClass(unref(styles).Label)
            }, toDisplayString(unref(progressValuePercents)) + "%", 3)
          ], 6)
        ], 2)) : createCommentVNode("", true)
      ], 2);
    };
  }
});
var components = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  [Symbol.toStringTag]: "Module",
  AccountConnection: _sfc_main$3q,
  ActionList: _sfc_main$3h,
  ActionListItem: _sfc_main$3k,
  ActionMenu: _sfc_main$3c,
  AlphaCard: _sfc_main$3b,
  AlphaStack: _sfc_main$3a,
  AppProvider: _sfc_main$39,
  Autocomplete: _sfc_main$36,
  AutocompleteTextField: _sfc_main$30,
  Avatar: _sfc_main$2$,
  Backdrop: _sfc_main$2_,
  Badge: _sfc_main$2Y,
  Banner: _sfc_main$2X,
  Bleed: _sfc_main$2W,
  Box: _sfc_main$2V,
  Breadcrumbs: _sfc_main$2U,
  BulkActions: _sfc_main$2R,
  Button: _sfc_main$2F,
  ButtonFrom: _sfc_main$2E,
  ButtonGroup: _sfc_main$2C,
  ButtonGroupItem: _sfc_main$2D,
  CalloutCard: _sfc_main$2B,
  Caption: _sfc_main$2A,
  Card: _sfc_main$2w,
  CardHeader: _sfc_main$2z,
  CardSection: _sfc_main$2y,
  CardSubsection: _sfc_main$2x,
  CheckableButton: _sfc_main$2v,
  Checkbox: _sfc_main$2s,
  Choice: _sfc_main$2t,
  ChoiceList: _sfc_main$2r,
  Collapsible: _sfc_main$2q,
  ColorPicker: _sfc_main$2m,
  Columns: _sfc_main$2l,
  Combobox: _sfc_main$35,
  ComboboxTextField: _sfc_main$30,
  Connected: _sfc_main$2j,
  ContentBlock: _sfc_main$2i,
  ContextualSaveBar: _sfc_main$2h,
  DataTable: _sfc_main$2d,
  DatePicker: _sfc_main$29,
  DescriptionList: _sfc_main$28,
  Dt: _sfc_main$27,
  Dd: _sfc_main$26,
  DisplayText: _sfc_main$25,
  DropZone: _sfc_main$23,
  DropZoneFileUpload: _sfc_main$22,
  EmptySearchResult: _sfc_main$21,
  EmptyState: _sfc_main$20,
  EventListener: _sfc_main$33,
  ExceptionList: _sfc_main$1$,
  ExceptionListItem: _sfc_main$1Z,
  Filters: _sfc_main$1V,
  Focus: _sfc_main$1U,
  FooterHelp: _sfc_main$1T,
  Form: _sfc_main$1S,
  FormLayout: _sfc_main$1P,
  FormGroup: _sfc_main$1Q,
  FormItem: _sfc_main$1R,
  Frame: _sfc_main$1I,
  FullscreenBar: _sfc_main$1H,
  Grid: _sfc_main$1G,
  GridCell: _sfc_main$1F,
  Heading: _sfc_main$1E,
  Icon: _sfc_main$2K,
  Image: _sfc_main$1D,
  IndexProvider: _sfc_main$1C,
  IndexTable: _sfc_main$1u,
  IndexTableCell: _sfc_main$1B,
  IndexTableRow: _sfc_main$1z,
  InlineCode: _sfc_main$1t,
  Indicator: _sfc_main$1s,
  Inline: _sfc_main$1r,
  InlineError: _sfc_main$2u,
  KeyboardKey: _sfc_main$1q,
  KeypressListener: _sfc_main$3p,
  Key,
  Label: _sfc_main$1p,
  Labelled: _sfc_main$1o,
  Layout: _sfc_main$1l,
  LayoutSection: _sfc_main$1n,
  AnnotatedSection: _sfc_main$1m,
  Link: _sfc_main$1k,
  List: _sfc_main$1j,
  ListItem: _sfc_main$1i,
  Listbox: _sfc_main$1h,
  ListboxAction: _sfc_main$1e,
  ListboxHeader: _sfc_main$1d,
  ListboxLoading: _sfc_main$1c,
  ListboxOption: _sfc_main$1f,
  ListboxSection: _sfc_main$1b,
  ListboxTextOption: _sfc_main$1g,
  Loading: _sfc_main$1a,
  MediaCard: _sfc_main$19,
  MessageIndicator: _sfc_main$18,
  Modal: _sfc_main$$,
  ModalDialog: _sfc_main$16,
  ModalFooter: _sfc_main$11,
  ModalHeader: _sfc_main$14,
  ModalSection: _sfc_main$10,
  ModalCloseButton: _sfc_main$15,
  Navigation: _sfc_main$_,
  NavigationItem: _sfc_main$Y,
  NavigationSection: _sfc_main$X,
  OptionList: _sfc_main$U,
  Page: _sfc_main$J,
  PageActions: _sfc_main$I,
  Pagination: _sfc_main$H,
  Popover: _sfc_main$2L,
  Pane: _sfc_main$2O,
  PopoverOverlay: _sfc_main$2N,
  PopoverSection: _sfc_main$2P,
  Portal: _sfc_main$2M,
  PositionedOverlay: _sfc_main$2Q,
  ProgressBar: _sfc_main$G,
  RadioButton: _sfc_main$F,
  RangeSlider: _sfc_main$C,
  ResourceItem: _sfc_main$B,
  ResourceList: _sfc_main$A,
  Scrollable: _sfc_main$3o,
  ScrollTo: _sfc_main$3n,
  ScrollLock: _sfc_main$z,
  Select: _sfc_main$y,
  SettingAction: _sfc_main$x,
  SettingToggle: _sfc_main$w,
  Sheet: _sfc_main$v,
  SkeletonBodyText: _sfc_main$u,
  SkeletonDisplayText: _sfc_main$t,
  SkeletonPage: _sfc_main$s,
  SkeletonTabs: _sfc_main$r,
  SkeletonThumbnail: _sfc_main$q,
  Spinner: _sfc_main$2H,
  Stack: _sfc_main$12,
  StackItem: _sfc_main$13,
  Sticky: _sfc_main$p,
  Subheading: _sfc_main$o,
  Tabs: _sfc_main$i,
  Toast: _sfc_main$h,
  Tooltip: _sfc_main$f,
  Tag: _sfc_main$e,
  Text,
  TextContainer: _sfc_main$c,
  TextField: _sfc_main$31,
  TextStyle: _sfc_main$b,
  Thumbnail: _sfc_main$a,
  Tiles: _sfc_main$9,
  TopBar: _sfc_main$2,
  TopBarMenu: _sfc_main$7,
  TopBarSearchField: _sfc_main$4,
  TopBarUserMenu: _sfc_main$3,
  TrapFocus: _sfc_main$17,
  Truncate: _sfc_main$1_,
  TruncatedText: _sfc_main$1,
  UnstyledButton: _sfc_main$2J,
  UnstyledButtonFrom: _sfc_main$2I,
  UnstyledLink: _sfc_main$3m,
  VideoThumbnail: _sfc_main
});
function defaultResourceIDResolver(resource) {
  if ("id" in resource) {
    return resource.id;
  }
  throw new Error("Your resource does not directly contain an `id`. Pass a `resourceIDResolver` to `useIndexResourceState`");
}
function useIndexResourceState(resources, {
  selectedResources: initSelectedResources = [],
  allResourcesSelected: initAllResourcesSelected = false,
  resourceIDResolver = defaultResourceIDResolver,
  resourceFilter = void 0
} = {
  selectedResources: [],
  allResourcesSelected: false,
  resourceIDResolver: defaultResourceIDResolver,
  resourceFilter: void 0
}) {
  const selectedResources = ref(initSelectedResources);
  const allResourcesSelected = ref(initAllResourcesSelected);
  const handleSelectionChange = (selectionType, isSelecting, selection) => {
    if (selectionType === "all") {
      allResourcesSelected.value = isSelecting;
    } else if (allResourcesSelected.value) {
      allResourcesSelected.value = false;
    }
    switch (selectionType) {
      case "single":
        selectedResources.value = isSelecting ? [...selectedResources.value, selection] : selectedResources.value.filter((id) => id !== selection);
        break;
      case "all":
      case "page":
        selectedResources.value = isSelecting ? resources.map(resourceIDResolver) : [];
        if (resourceFilter) {
          const filteredResources = resources.filter(resourceFilter);
          selectedResources.value = isSelecting && selectedResources.value.length < filteredResources.length ? filteredResources.map(resourceIDResolver) : [];
        } else {
          selectedResources.value = isSelecting ? resources.map(resourceIDResolver) : [];
        }
        break;
      case "multi":
        if (!selection) {
          break;
        }
        selectedResources.value = (() => {
          const ids = [];
          const filteredResources = resourceFilter ? resources.filter(resourceFilter) : resources;
          for (let i = selection[0]; i <= selection[1]; i++) {
            if (filteredResources.includes(resources[i])) {
              const id = resourceIDResolver(resources[i]);
              if (isSelecting && !selectedResources.value.includes(id) || !isSelecting && selectedResources.value.includes(id)) {
                ids.push(id);
              }
            }
          }
          return isSelecting ? [...selectedResources.value, ...ids] : selectedResources.value.filter((id) => !ids.includes(id));
        })();
        break;
    }
  };
  const clearSelection = () => {
    selectedResources.value = [];
    allResourcesSelected.value = false;
  };
  const removeSelectedResources = (removeResources) => {
    const selectedResourcesCopy = [...selectedResources.value];
    const newSelectedResources = selectedResourcesCopy.filter((resource) => !removeResources.includes(resource));
    selectedResources.value = newSelectedResources;
    if (newSelectedResources.length === 0) {
      allResourcesSelected.value = false;
    }
  };
  return {
    selectedResources,
    allResourcesSelected,
    handleSelectionChange,
    clearSelection,
    removeSelectedResources
  };
}
const PolarisVue = {
  install(Vue) {
    for (const component in components) {
      const componentElement = components[component];
      Vue.component(component, componentElement);
    }
  }
};
export { _sfc_main$3q as AccountConnection, _sfc_main$3h as ActionList, _sfc_main$3k as ActionListItem, _sfc_main$3c as ActionMenu, _sfc_main$3b as AlphaCard, _sfc_main$3a as AlphaStack, _sfc_main$1m as AnnotatedSection, _sfc_main$39 as AppProvider, _sfc_main$36 as Autocomplete, _sfc_main$30 as AutocompleteTextField, _sfc_main$2$ as Avatar, _sfc_main$2_ as Backdrop, _sfc_main$2Y as Badge, _sfc_main$2X as Banner, _sfc_main$2W as Bleed, _sfc_main$2V as Box, _sfc_main$2U as Breadcrumbs, _sfc_main$2R as BulkActions, _sfc_main$2F as Button, _sfc_main$2E as ButtonFrom, _sfc_main$2C as ButtonGroup, _sfc_main$2D as ButtonGroupItem, _sfc_main$2B as CalloutCard, _sfc_main$2A as Caption, _sfc_main$2w as Card, _sfc_main$2z as CardHeader, _sfc_main$2y as CardSection, _sfc_main$2x as CardSubsection, _sfc_main$2v as CheckableButton, _sfc_main$2s as Checkbox, _sfc_main$2t as Choice, _sfc_main$2r as ChoiceList, _sfc_main$2q as Collapsible, _sfc_main$2m as ColorPicker, _sfc_main$2l as Columns, _sfc_main$35 as Combobox, _sfc_main$30 as ComboboxTextField, _sfc_main$2j as Connected, _sfc_main$2i as ContentBlock, _sfc_main$2h as ContextualSaveBar, _sfc_main$2d as DataTable, _sfc_main$29 as DatePicker, _sfc_main$26 as Dd, _sfc_main$28 as DescriptionList, _sfc_main$25 as DisplayText, _sfc_main$23 as DropZone, _sfc_main$22 as DropZoneFileUpload, _sfc_main$27 as Dt, _sfc_main$21 as EmptySearchResult, _sfc_main$20 as EmptyState, _sfc_main$33 as EventListener, _sfc_main$1$ as ExceptionList, _sfc_main$1Z as ExceptionListItem, _sfc_main$1V as Filters, _sfc_main$1U as Focus, _sfc_main$1T as FooterHelp, _sfc_main$1S as Form, _sfc_main$1Q as FormGroup, _sfc_main$1R as FormItem, _sfc_main$1P as FormLayout, _sfc_main$1I as Frame, _sfc_main$1H as FullscreenBar, _sfc_main$1G as Grid, _sfc_main$1F as GridCell, _sfc_main$1E as Heading, _sfc_main$2K as Icon, _sfc_main$1D as Image, _sfc_main$1C as IndexProvider, _sfc_main$1u as IndexTable, _sfc_main$1B as IndexTableCell, _sfc_main$1z as IndexTableRow, _sfc_main$1s as Indicator, _sfc_main$1r as Inline, _sfc_main$1t as InlineCode, _sfc_main$2u as InlineError, Key, _sfc_main$1q as KeyboardKey, _sfc_main$3p as KeypressListener, _sfc_main$1p as Label, _sfc_main$1o as Labelled, _sfc_main$1l as Layout, _sfc_main$1n as LayoutSection, _sfc_main$1k as Link, _sfc_main$1j as List, _sfc_main$1i as ListItem, _sfc_main$1h as Listbox, _sfc_main$1e as ListboxAction, _sfc_main$1d as ListboxHeader, _sfc_main$1c as ListboxLoading, _sfc_main$1f as ListboxOption, _sfc_main$1b as ListboxSection, _sfc_main$1g as ListboxTextOption, _sfc_main$1a as Loading, _sfc_main$19 as MediaCard, _sfc_main$18 as MessageIndicator, _sfc_main$$ as Modal, _sfc_main$15 as ModalCloseButton, _sfc_main$16 as ModalDialog, _sfc_main$11 as ModalFooter, _sfc_main$14 as ModalHeader, _sfc_main$10 as ModalSection, _sfc_main$_ as Navigation, _sfc_main$Y as NavigationItem, _sfc_main$X as NavigationSection, _sfc_main$U as OptionList, _sfc_main$J as Page, _sfc_main$I as PageActions, _sfc_main$H as Pagination, _sfc_main$2O as Pane, _sfc_main$2L as Popover, _sfc_main$2N as PopoverOverlay, _sfc_main$2P as PopoverSection, _sfc_main$2M as Portal, _sfc_main$2Q as PositionedOverlay, _sfc_main$G as ProgressBar, _sfc_main$F as RadioButton, _sfc_main$C as RangeSlider, _sfc_main$B as ResourceItem, _sfc_main$A as ResourceList, _sfc_main$z as ScrollLock, _sfc_main$3n as ScrollTo, _sfc_main$3o as Scrollable, _sfc_main$y as Select, _sfc_main$x as SettingAction, _sfc_main$w as SettingToggle, _sfc_main$v as Sheet, _sfc_main$u as SkeletonBodyText, _sfc_main$t as SkeletonDisplayText, _sfc_main$s as SkeletonPage, _sfc_main$r as SkeletonTabs, _sfc_main$q as SkeletonThumbnail, _sfc_main$2H as Spinner, _sfc_main$12 as Stack, _sfc_main$13 as StackItem, _sfc_main$p as Sticky, _sfc_main$o as Subheading, _sfc_main$i as Tabs, _sfc_main$e as Tag, Text, _sfc_main$c as TextContainer, _sfc_main$31 as TextField, _sfc_main$b as TextStyle, _sfc_main$a as Thumbnail, _sfc_main$9 as Tiles, _sfc_main$h as Toast, _sfc_main$f as Tooltip, _sfc_main$2 as TopBar, _sfc_main$7 as TopBarMenu, _sfc_main$4 as TopBarSearchField, _sfc_main$3 as TopBarUserMenu, _sfc_main$17 as TrapFocus, _sfc_main$1_ as Truncate, _sfc_main$1 as TruncatedText, _sfc_main$2J as UnstyledButton, _sfc_main$2I as UnstyledButtonFrom, _sfc_main$3m as UnstyledLink, _sfc_main as VideoThumbnail, PolarisVue as default, useContainerScroll, useIndexResourceState };
